webpackJsonp([3],{

/***/ "+JEf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_HSNDIR_Events_js__ = __webpack_require__("vued");


HSN.ConfigLoader = function (config) {
    this.application = config.application;
    var scope = this;

    $.ajax({
        url: '/api/configuration',
        beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader('X-Requested-With', { toString: function toString() {
                    return '';
                } });
        }
    }).done(function (data) {
        HSN.Config = data;
        scope.application.Events.Trigger(__WEBPACK_IMPORTED_MODULE_0_HSNDIR_Events_js__["a" /* default */].Config.LOADED, data);
    });
};

/***/ }),

/***/ "+PcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* new HSN.QuantitySelector(config)
* A widget for selecting quantity with - and + buttons to interact with it
* - config (Object): A configuration object for the [[HSN.QuantitySelector]]
*   consisting of the following keys:
*   - application (HSN.Application): An instance of the [[HSN.Application]] that the QuantitySelector should interact with.
*   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the QuantitySelector.
**/
HSN.QuantitySelector = function (config) {
    var scope = this;

    scope.application = config.application;
    scope.container = $(config.container);
    scope.minusButton = scope.container.find('.minus');
    scope.plusButton = scope.container.find('.plus');
    scope.input = scope.container.find('.qs-quantity');

    var data = scope.container.data();

    scope.minQty = data.minQty;
    scope.maxQty = data.maxQty;
    scope.currentQty = data.currentQty;

    scope.minusButton.on('click', scope.Decrement.bind(scope));
    scope.plusButton.on('click', scope.Increment.bind(scope));

    scope.input.on('keydown', function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    });

    scope.RefreshUI();
};

HSN.QuantitySelector.prototype = {
    Increment: function Increment() {
        var scope = this;
        scope.currentQty += 1;
        if (scope.currentQty > scope.maxQty) {
            scope.currentQty = scope.maxQty;
        }
        scope.RefreshUI();
        scope.Changed();
    },
    Decrement: function Decrement() {
        var scope = this;
        scope.currentQty -= 1;
        if (scope.currentQty < scope.minQty) {
            scope.currentQty = scope.minQty;
        }
        scope.RefreshUI();
        scope.Changed();
    },
    RefreshUI: function RefreshUI() {
        var scope = this;
        scope.minusButton.prop('disabled', scope.currentQty <= scope.minQty);
        scope.plusButton.prop('disabled', scope.currentQty >= scope.maxQty);
        scope.input.val(scope.currentQty);
    },
    Changed: function Changed() {
        var scope = this;
        scope.container.trigger('qtyChanged', scope.currentQty);
    },
    GetQuantity: function GetQuantity() {
        return this.currentQty;
    }
};

/***/ }),

/***/ "/DXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.KashReminderModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.KashReminderModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(KashReminderModal, parent);

    function KashReminderModal(config) {
        var modal = KashReminderModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.KashReminderModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    KashReminderModal.prototype._show = function (kashAmount) {
        $.ajax('/account/kashreminder/modal' + "?amt=" + kashAmount + "&t=" + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                    }
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                //Dont think we want to display the loading error if this modal doesnt display?
                //alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return KashReminderModal;
}(HSN.Modal);

/***/ }),

/***/ "03Jy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Widget.FlexPayProcessPayments
    *
    * Encapsulates the common functionality of the FlexPayProcessPayments Widget.
    **/
HSN.Widget.FlexPayProcessPayments = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var paymentNumbers;
    /**
        * new HSN.Widget.FlexPayProcessPayments.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayProcessPayments]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        paymentNumbers = config.paymentNumbers;

        bindEvents();
    }

    function startProcessing() {
        processPayment(0);
    }

    function bindEvents() {
        container.on('click', '.return-to-flexpay', function () {
            application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.RETURN_TO_MANAGER);
            return false;
        });
    }

    function processPayment(index) {
        if (index < paymentNumbers.length) {
            updateStatus(paymentNumbers[index], 'processing');
            accountService.SubmitFlexPayment({ orderIdentity: orderIdentity, flexPaymentNumber: paymentNumbers[index] }, {
                callback: function callback(data) {
                    if (data.success) {
                        updateStatus(paymentNumbers[index], 'charged');
                        //Only recurse if everything was successful 
                        processPayment(index + 1);
                    } else {
                        //Insert error before line that caused it
                        HSN.AddErrorTreatment($('.payment-line-' + paymentNumbers[index], container), data);
                        updateStatus(paymentNumbers[index], 'error');
                        application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR);
                        showErrorMessage();
                    }
                },
                errorCallback: function errorCallback() {
                    updateStatus(paymentNumbers[index], 'error');
                    application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR);
                    showErrorMessage();
                }
            });
        } else {
            application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.FINISHED);
            showSuccessMessage();
        }
    }

    function updateStatus(paymentNumber, status) {
        var payment = $('.payment-line-' + paymentNumber, container);
        $('.processing-status', payment).html(status);
        switch (status) {
            case 'processing':
                $('.processing-container', payment).toggle(true);
                $('.success-container', payment).toggle(false);
                $('.error-icon-container', payment).toggle(false);
                break;
            case 'charged':
                $('.processing-container', payment).toggle(false);
                $('.success-container', payment).toggle(true);
                $('.error-icon-container', payment).toggle(false);
                break;
            case 'error':
                $('.processing-container', payment).toggle(false);
                $('.success-container', payment).toggle(false);
                $('.error-icon-container', payment).toggle(true);
                break;
        }
    }
    function showSuccessMessage() {
        $('.success-message').toggle(true);
    }
    function showErrorMessage() {
        $('.error-message').toggle(true);
    }
    function Destroy() {}
    return {
        init: init,
        Destroy: Destroy,
        StartProcessing: startProcessing
    };
};

HSN.Widget.FlexPayProcessPayments.EVENT = {
    FINISHED: 'HSN.Widget.FlexPayProcessPayments:FINISHED',
    ERROR: 'HSN.Widget.FlexPayProcessPayments:ERROR',
    RETURN_TO_MANAGER: 'HSN.Widget.FlexPayProcessPayments:RETURN_TO_MANAGER'
};

/***/ }),

/***/ "0Pp3":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var require;/*** IMPORTS FROM imports-loader ***/
(function() {

!function(e){var r=e.babelHelpers={};r.typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r.jsx=function(){var e="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;return function(r,t,n,o){var i=r&&r.defaultProps,u=arguments.length-3;if(t||0===u||(t={}),t&&i)for(var a in i)void 0===t[a]&&(t[a]=i[a]);else t||(t=i||{});if(1===u)t.children=o;else if(u>1){for(var f=Array(u),l=0;l<u;l++)f[l]=arguments[l+3];t.children=f}return{$$typeof:e,type:r,key:void 0===n?null:""+n,ref:null,props:t,_owner:null}}}(),r.asyncIterator=function(e){if("function"==typeof Symbol){if(Symbol.asyncIterator){var r=e[Symbol.asyncIterator];if(null!=r)return r.call(e)}if(Symbol.iterator)return e[Symbol.iterator]()}throw new TypeError("Object is not async iterable")},r.asyncGenerator=function(){function e(e){this.value=e}function r(r){function t(e,r){return new Promise(function(t,o){var a={key:e,arg:r,resolve:t,reject:o,next:null};u?u=u.next=a:(i=u=a,n(e,r))})}function n(t,i){try{var u=r[t](i),a=u.value;a instanceof e?Promise.resolve(a.value).then(function(e){n("next",e)},function(e){n("throw",e)}):o(u.done?"return":"normal",u.value)}catch(e){o("throw",e)}}function o(e,r){switch(e){case"return":i.resolve({value:r,done:!0});break;case"throw":i.reject(r);break;default:i.resolve({value:r,done:!1})}i=i.next,i?n(i.key,i.arg):u=null}var i,u;this._invoke=t,"function"!=typeof r.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(r.prototype[Symbol.asyncIterator]=function(){return this}),r.prototype.next=function(e){return this._invoke("next",e)},r.prototype.throw=function(e){return this._invoke("throw",e)},r.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new r(e.apply(this,arguments))}},await:function(r){return new e(r)}}}(),r.asyncGeneratorDelegate=function(e,r){function t(t,n){return o=!0,n=new Promise(function(r){r(e[t](n))}),{done:!1,value:r(n)}}var n={},o=!1;return"function"==typeof Symbol&&Symbol.iterator&&(n[Symbol.iterator]=function(){return this}),n.next=function(e){return o?(o=!1,e):t("next",e)},"function"==typeof e.throw&&(n.throw=function(e){if(o)throw o=!1,e;return t("throw",e)}),"function"==typeof e.return&&(n.return=function(e){return t("return",e)}),n},r.asyncToGenerator=function(e){return function(){var r=e.apply(this,arguments);return new Promise(function(e,t){function n(o,i){try{var u=r[o](i),a=u.value}catch(e){return void t(e)}return u.done?void e(a):Promise.resolve(a).then(function(e){n("next",e)},function(e){n("throw",e)})}return n("next")})}},r.classCallCheck=function(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")},r.createClass=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),r.defineEnumerableProperties=function(e,r){for(var t in r){var n=r[t];n.configurable=n.enumerable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,t,n)}return e},r.defaults=function(e,r){for(var t=Object.getOwnPropertyNames(r),n=0;n<t.length;n++){var o=t[n],i=Object.getOwnPropertyDescriptor(r,o);i&&i.configurable&&void 0===e[o]&&Object.defineProperty(e,o,i)}return e},r.defineProperty=function(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e},r.extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},r.get=function e(r,t,n){null===r&&(r=Function.prototype);var o=Object.getOwnPropertyDescriptor(r,t);if(void 0===o){var i=Object.getPrototypeOf(r);return null===i?void 0:e(i,t,n)}if("value"in o)return o.value;var u=o.get;if(void 0!==u)return u.call(n)},r.inherits=function(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Super expression must either be null or a function, not "+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)},r.instanceof=function(e,r){return null!=r&&"undefined"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r},r.interopRequireDefault=function(e){return e&&e.__esModule?e:{default:e}},r.interopRequireWildcard=function(e){if(e&&e.__esModule)return e;var r={};if(null!=e)for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=e[t]);return r.default=e,r},r.newArrowCheck=function(e,r){if(e!==r)throw new TypeError("Cannot instantiate an arrow function")},r.objectDestructuringEmpty=function(e){if(null==e)throw new TypeError("Cannot destructure undefined")},r.objectWithoutProperties=function(e,r){var t={};for(var n in e)r.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t},r.possibleConstructorReturn=function(e,r){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!r||"object"!=typeof r&&"function"!=typeof r?e:r},r.selfGlobal="undefined"==typeof e?self:e,r.set=function e(r,t,n,o){var i=Object.getOwnPropertyDescriptor(r,t);if(void 0===i){var u=Object.getPrototypeOf(r);null!==u&&e(u,t,n,o)}else if("value"in i&&i.writable)i.value=n;else{var a=i.set;void 0!==a&&a.call(o,n)}return n},r.slicedToArray=function(){function e(e,r){var t=[],n=!0,o=!1,i=void 0;try{for(var u,a=e[Symbol.iterator]();!(n=(u=a.next()).done)&&(t.push(u.value),!r||t.length!==r);n=!0);}catch(e){o=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(o)throw i}}return t}return function(r,t){if(Array.isArray(r))return r;if(Symbol.iterator in Object(r))return e(r,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),r.slicedToArrayLoose=function(e,r){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e)){for(var t,n=[],o=e[Symbol.iterator]();!(t=o.next()).done&&(n.push(t.value),!r||n.length!==r););return n}throw new TypeError("Invalid attempt to destructure non-iterable instance")},r.taggedTemplateLiteral=function(e,r){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))},r.taggedTemplateLiteralLoose=function(e,r){return e.raw=r,e},r.temporalRef=function(e,r,t){if(e===t)throw new ReferenceError(r+" is not defined - temporal dead zone");return e},r.temporalUndefined={},r.toArray=function(e){return Array.isArray(e)?e:Array.from(e)},r.toConsumableArray=function(e){if(Array.isArray(e)){for(var r=0,t=Array(e.length);r<e.length;r++)t[r]=e[r];return t}return Array.from(e)}}("undefined"==typeof global?self:global);
try{var ce=new window.CustomEvent("test");ce.preventDefault();if(!0!==ce.defaultPrevented)throw Error("Could not prevent default");}catch(e){var CustomEvent=function(d,a){var b,c;a=a||{bubbles:!1,cancelable:!1,detail:void 0};b=document.createEvent("CustomEvent");b.initCustomEvent(d,a.bubbles,a.cancelable,a.detail);c=b.preventDefault;b.preventDefault=function(){c.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(f){this.defaultPrevented=!0}};return b};CustomEvent.prototype=
window.Event.prototype;window.CustomEvent=CustomEvent};
!function(t,e){if(!t.ES6Promise){t.ES6Promise=e();t.ES6Promise.polyfill()}}(this,function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function e(t){return"function"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=__webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"vertx\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?j(t,it.error):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),P(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(P,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(P,t)}function P(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function T(){this.error=null}function M(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=M(r,o),s===st?(a=!0,u=s.error,s=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error("Array Methods must be provided an Array")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function N(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&("function"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q="undefined"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),Z="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&"function"=="function"?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new T,st=new T,ut=0;return Y.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===nt&&n<t;n++)this._eachEntry(e[n],n)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,"catch":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U});
if (typeof Object.assign != 'function') {

  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

   target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

(function(n){function i(a,d){this.setNotifyMethod(a);this.setNotifyContext(d)}function j(a,d,b){this.name=a;this.body=d;this.type=b}function k(){}function m(){}function l(){this.subCommands=[];this.initializeMacroCommand()}function g(a,d){this.mediatorName=a||this.constructor.NAME;this.viewComponent=d}function h(a,d){this.proxyName=a||this.constructor.NAME;null!=d&&this.setData(d)}function b(a){if(null!=b.instanceMap[a])throw Error(b.MULTITON_MSG);this.initializeNotifier(a);b.instanceMap[a]=this;
this.initializeFacade()}function c(a){if(null!=c.instanceMap[a])throw Error(c.MULTITON_MSG);this.multitonKey=a;c.instanceMap[this.multitonKey]=this;this.mediatorMap=[];this.observerMap=[];this.initializeView()}function e(a){if(e.instanceMap[a])throw Error(e.MULTITON_MSG);this.multitonKey=a;e.instanceMap[a]=this;this.proxyMap=[];this.initializeModel()}function f(a){if(null!=f.instanceMap[a])throw Error(f.MULTITON_MSG);this.multitonKey=a;f.instanceMap[this.multitonKey]=this;this.commandMap=[];this.initializeController()}
function p(a,d,b){for(var a=a.split("."),b=b||o.global,c,e,f=0,g=a.length;f<g;f++)c=b,e=a[f],b=null==b[e]?b[e]={}:b[e];return null==d?b:c[e]=d}null==n&&(n=window);if(!n.puremvc){i.prototype.setNotifyMethod=function(a){this.notify=a};i.prototype.setNotifyContext=function(a){this.context=a};i.prototype.getNotifyMethod=function(){return this.notify};i.prototype.getNotifyContext=function(){return this.context};i.prototype.notifyObserver=function(a){this.getNotifyMethod().call(this.getNotifyContext(),
a)};i.prototype.compareNotifyContext=function(a){return a===this.context};i.prototype.notify=null;i.prototype.context=null;j.prototype.getName=function(){return this.name};j.prototype.setBody=function(a){this.body=a};j.prototype.getBody=function(){return this.body};j.prototype.setType=function(a){this.type=a};j.prototype.getType=function(){return this.type};j.prototype.toString=function(){var a="Notification Name: "+this.getName(),a=a+("\nBody:"+(null==this.body?"null":this.body.toString()));return a+=
"\nType:"+(null==this.type?"null":this.type)};j.prototype.name=null;j.prototype.type=null;j.prototype.body=null;k.prototype.sendNotification=function(a,d,b){var c=this.getFacade();c&&c.sendNotification(a,d,b)};k.prototype.initializeNotifier=function(a){this.multitonKey=""+a;this.facade=this.getFacade()};k.prototype.getFacade=function(){if(null==this.multitonKey)throw Error(k.MULTITON_MSG);return b.getInstance(this.multitonKey)};k.prototype.multitonKey=null;k.MULTITON_MSG="multitonKey for this Notifier not yet initialized!";
m.prototype=new k;m.prototype.constructor=m;m.prototype.execute=function(){};l.prototype=new k;l.prototype.constructor=l;l.prototype.subCommands=null;l.prototype.initializeMacroCommand=function(){};l.prototype.addSubCommand=function(a){this.subCommands.push(a)};l.prototype.execute=function(a){for(;0<this.subCommands.length;){var d=new (this.subCommands.shift());d.initializeNotifier(this.multitonKey);d.execute(a)}};g.NAME="Mediator";g.prototype=new k;g.prototype.constructor=g;g.prototype.getMediatorName=
function(){return this.mediatorName};g.prototype.setViewComponent=function(a){this.viewComponent=a};g.prototype.getViewComponent=function(){return this.viewComponent};g.prototype.listNotificationInterests=function(){return[]};g.prototype.handleNotification=function(){};g.prototype.onRegister=function(){};g.prototype.onRemove=function(){};g.prototype.mediatorName=null;g.prototype.viewComponent=null;h.NAME="Proxy";h.prototype=new k;h.prototype.constructor=h;h.prototype.getProxyName=function(){return this.proxyName};
h.prototype.setData=function(a){this.data=a};h.prototype.getData=function(){return this.data};h.prototype.onRegister=function(){};h.prototype.onRemove=function(){};h.prototype.proxyName=null;h.prototype.data=null;b.prototype.initializeFacade=function(){this.initializeModel();this.initializeController();this.initializeView()};b.getInstance=function(a){if(null==a)return null;null==b.instanceMap[a]&&(b.instanceMap[a]=new b(a));return b.instanceMap[a]};b.prototype.initializeController=function(){if(null==
this.controller)this.controller=f.getInstance(this.multitonKey)};b.prototype.initializeModel=function(){if(null==this.model)this.model=e.getInstance(this.multitonKey)};b.prototype.initializeView=function(){if(null==this.view)this.view=c.getInstance(this.multitonKey)};b.prototype.registerCommand=function(a,d){this.controller.registerCommand(a,d)};b.prototype.removeCommand=function(a){this.controller.removeCommand(a)};b.prototype.hasCommand=function(a){return this.controller.hasCommand(a)};b.prototype.registerProxy=
function(a){this.model.registerProxy(a)};b.prototype.retrieveProxy=function(a){return this.model.retrieveProxy(a)};b.prototype.removeProxy=function(a){var d=null;null!=this.model&&(d=this.model.removeProxy(a));return d};b.prototype.hasProxy=function(a){return this.model.hasProxy(a)};b.prototype.registerMediator=function(a){null!=this.view&&this.view.registerMediator(a)};b.prototype.retrieveMediator=function(a){return this.view.retrieveMediator(a)};b.prototype.removeMediator=function(a){var d=null;
null!=this.view&&(d=this.view.removeMediator(a));return d};b.prototype.hasMediator=function(a){return this.view.hasMediator(a)};b.prototype.sendNotification=function(a,d,b){this.notifyObservers(new j(a,d,b))};b.prototype.notifyObservers=function(a){null!=this.view&&this.view.notifyObservers(a)};b.prototype.initializeNotifier=function(a){this.multitonKey=a};b.hasCore=function(a){return null!=b.instanceMap[a]};b.removeCore=function(a){null!=b.instanceMap[a]&&(e.removeModel(a),c.removeView(a),f.removeController(a),
delete b.instanceMap[a])};b.prototype.controller=null;b.prototype.model=null;b.prototype.view=null;b.prototype.multitonKey=null;b.instanceMap=[];b.MULTITON_MSG="Facade instance for this Multiton key already constructed!";c.prototype.initializeView=function(){};c.getInstance=function(a){if(null==a)return null;null==c.instanceMap[a]&&(c.instanceMap[a]=new c(a));return c.instanceMap[a]};c.prototype.registerObserver=function(a,d){null!=this.observerMap[a]?this.observerMap[a].push(d):this.observerMap[a]=
[d]};c.prototype.notifyObservers=function(a){if(null!=this.observerMap[a.getName()]){for(var d=this.observerMap[a.getName()],b=[],c,e=0;e<d.length;e++)c=d[e],b.push(c);for(e=0;e<b.length;e++)c=b[e],c.notifyObserver(a)}};c.prototype.removeObserver=function(a,d){for(var b=this.observerMap[a],c=0;c<b.length;c++)if(!0==b[c].compareNotifyContext(d)){b.splice(c,1);break}0==b.length&&delete this.observerMap[a]};c.prototype.registerMediator=function(a){if(null==this.mediatorMap[a.getMediatorName()]){a.initializeNotifier(this.multitonKey);
this.mediatorMap[a.getMediatorName()]=a;var d=a.listNotificationInterests();if(0<d.length)for(var b=new i(a.handleNotification,a),c=0;c<d.length;c++)this.registerObserver(d[c],b);a.onRegister()}};c.prototype.retrieveMediator=function(a){return this.mediatorMap[a]};c.prototype.removeMediator=function(a){var d=this.mediatorMap[a];if(d){for(var b=d.listNotificationInterests(),c=0;c<b.length;c++)this.removeObserver(b[c],d);delete this.mediatorMap[a];d.onRemove()}return d};c.prototype.hasMediator=function(a){return null!=
this.mediatorMap[a]};c.removeView=function(a){delete c.instanceMap[a]};c.prototype.mediatorMap=null;c.prototype.observerMap=null;c.instanceMap=[];c.prototype.multitonKey=null;c.MULTITON_MSG="View instance for this Multiton key already constructed!";e.prototype.initializeModel=function(){};e.getInstance=function(a){if(null==a)return null;null==e.instanceMap[a]&&(e.instanceMap[a]=new e(a));return e.instanceMap[a]};e.prototype.registerProxy=function(a){a.initializeNotifier(this.multitonKey);this.proxyMap[a.getProxyName()]=
a;a.onRegister()};e.prototype.retrieveProxy=function(a){return this.proxyMap[a]};e.prototype.hasProxy=function(a){return null!=this.proxyMap[a]};e.prototype.removeProxy=function(a){var b=this.proxyMap[a];b&&(this.proxyMap[a]=null,b.onRemove());return b};e.removeModel=function(a){delete e.instanceMap[a]};e.prototype.proxyMap=null;e.instanceMap=[];e.MULTITON_MSG="Model instance for this Multiton key already constructed!";f.prototype.initializeController=function(){this.view=c.getInstance(this.multitonKey)};
f.getInstance=function(a){if(null==a)return null;null==this.instanceMap[a]&&(this.instanceMap[a]=new this(a));return this.instanceMap[a]};f.prototype.executeCommand=function(a){var b=this.commandMap[a.getName()];null!=b&&(b=new b,b.initializeNotifier(this.multitonKey),b.execute(a))};f.prototype.registerCommand=function(a,b){null==this.commandMap[a]&&this.view.registerObserver(a,new i(this.executeCommand,this));this.commandMap[a]=b};f.prototype.hasCommand=function(a){return null!=this.commandMap[a]};
f.prototype.removeCommand=function(a){this.hasCommand(a)&&(this.view.removeObserver(a,this),this.commandMap[a]=null)};f.removeController=function(a){delete this.instanceMap[a]};f.prototype.view=null;f.prototype.commandMap=null;f.prototype.multitonKey=null;f.instanceMap=[];f.MULTITON_MSG="controller key for this Multiton key already constructed";var o={global:function(){return this}(),extend:function(a,b){if("function"!==typeof a)throw new TypeError("#extend- child should be Function");if("function"!==
typeof b)throw new TypeError("#extend- parent should be Function");if(b!==a){var c=new Function;c.prototype=b.prototype;a.prototype=new c;return a.prototype.constructor=a}},decorate:function(a,b){for(var c in b)a[c]=b[c];return a}};n.puremvc={View:c,Model:e,Controller:f,SimpleCommand:m,MacroCommand:l,Facade:b,Mediator:g,Observer:i,Notification:j,Notifier:k,Proxy:h,define:function(a,b,c){a||(a={});var e=a.name,f=a.parent,g="function"===typeof f,h=a.scope||null;if("parent"in a&&!g)throw new TypeError("Class parent must be Function");
if(a.hasOwnProperty("constructor")){if(a=a.constructor,"function"!==typeof a)throw new TypeError("Class constructor must be Function");}else a=g?function(){f.apply(this,arguments)}:new Function;g&&o.extend(a,f);if(b)g=a.prototype,o.decorate(g,b),g.constructor=a;c&&o.decorate(a,c);if(e){if("string"!==typeof e)throw new TypeError("Class name must be primitive string");p(e,a,h)}return a},declare:p}}})(this);
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchStr, position) {
      // This works much better than >= because
      // it compensates for NaN:
      if (!(position < this.length))
        position = this.length;
      else
        position |= 0; // round position
      return this.substr(position - searchStr.length, searchStr.length) === searchStr;
  };
}


(function() {
var  global, version, _ref;


  function AkamaiSDKManager() {
    var legacyCheck, sdk, versions,
      _this = this;
    sdk = null;
    this.getSDK = function() {
      return sdk;
    };
    this.setSDK = function(newSDK) {
      var key, value;
      sdk = newSDK;
      legacyCheck();
      for (key in sdk) {
        value = sdk[key];
        window[key] = value;
      }
      return sdk;
    };
    this.saveSDK = function(version, object) {
      var key, value, _ref;
      if (!(object != null) || !(version != null) || version === "") {
        return;
      }
      if (!(object.main != null)) {
        for (key in object) {
          value = object[key];
          if (!((value != null ? value.VERSION : void 0) === version)) {
            continue;
          }
          object.main = value;
          break;
        }
      }
      if ((_ref = object.version) == null) {
        object.version = version;
      }
      versions.push(object);
      this[version] = object;
      return object;
    };
    versions = [];
    this.getVersions = function() {
      return versions.slice();
    };
    this.getVersion = function(version) {
      return this[version];
    };
    this.setVersion = function(version) {
      sdk = this.getVersion(version);
      if (!(sdk != null)) {
        return null;
      }
      this.setSDK(sdk);
      return sdk;
    };
    this.revert = function() {
      return this.setSDK(versions[0]);
    };
    this.noConflict = function() {
      var current;
      current = this.getSDK();
      this.revert();
      return current;
    };
    this.create = (function() {
      var Creator;
      Creator = function(cls, args) {
        this.prototype = cls.prototype;
        return cls.apply(this, args);
      };
      return function(args) {
        return new Creator(sdk.main, arguments);
      };
    })();
    legacyCheck = function() {
      var key, obj, value, _ref, _ref1;
      if ((_ref = window.com) != null ? (_ref1 = _ref.akamai) != null ? _ref1.amp : void 0 : void 0) {
        for (key in window) {
          value = window[key];
          if ((value === window.AMP || value === window.AMPremier) && ((value != null ? value.VERSION : void 0) != null) && value.VERSION !== "" && value.VERSION !== (sdk != null ? sdk.version : void 0) && (!(_this[value.VERSION] != null))) {
            obj = {};
            obj.main = value;
            obj.com = window.com;
            if (window.AMP) {
              obj.AMP = window.AMP;
            }
            if (window.AMPPremier) {
              obj.AMPremier = window.AMPPremier;
            }
            if (window.Utils) {
              obj.Utils = window.Utils;
            }
            if (window.QueryString) {
              obj.QueryString = window.QueryString;
            }
            if (window.QueryParams) {
              obj.QueryParams = window.QueryParams;
            }
            _this.saveSDK(value.VERSION, obj);
            break;
          }
        }
      }
    };
    legacyCheck();
  }

  
if ((_ref = window.AKAMAI_MEDIA_PLAYER) == null) {
  window.AKAMAI_MEDIA_PLAYER = new AkamaiSDKManager();
}
version = "AMP v4.84.10";
if (!(window.AKAMAI_MEDIA_PLAYER[version] != null)) {
  global = window.AKAMAI_MEDIA_PLAYER[version] = {};
  /* Start JS Lib
  */
  function __hasProp(prop) {
	return {}["hasOwnProperty"](prop);
}

function __extends(child, parent) {
	for (var key in parent) {
		if (__hasProp["call"](parent, key))
			child[key] = parent[key];
	}
	function ctor() {
		this.constructor = child;
	}

	ctor.prototype = parent.prototype;
	child.prototype = new ctor;
	child.__super__ = parent.prototype;
	return child;
}

function __indexOf(item) {
	for (var i = 0, l = this.length; i < l; i++) {
		if ( i in this && this[i] === item)
			return i;
	}
	return -1;
}

function __bind(fn, me) {
	return function() {
		return fn["apply"](me, arguments);
	};
}

function QueryString() {}

QueryString.construct = function() {
  var key, value, vars;
  vars = this.decode(window.location.search);
  QueryString.typed = {};
  for (key in vars) {
    value = vars[key];
    QueryString[key] = value;
    QueryString.typed[key] = this.parse(value);
  }
  return true;
};

QueryString.encode = function(obj, prefix) {
  var k, p, str, v;
  str = [];
  for (p in obj) {
    v = obj[p];
    if (!(v != null)) {
      continue;
    }
    k = (prefix ? prefix + "[" + p + "]" : p);
    str.push((typeof v === "object" ? this.encode(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v)));
  }
  return str.join("&");
};

QueryString.decode = function(uri) {
  var results,
    _this = this;
  if (uri != null) {
    results = {};
    uri = uri.replace(/^[^?]*\?/, "");
    uri.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function($0, $1, $2, $3) {
      results[decodeURIComponent($1)] = decodeURIComponent($3);
    });
  }
  return results;
};

QueryString.parse = function(value) {
  var temp;
  if (value === "undefined") {
    return true;
  }
  temp = value.toLowerCase();
  if (temp === "true" || temp === "false") {
    return temp === "true";
  }
  temp = parseFloat(value);
  if (!isNaN(temp)) {
    return temp;
  }
  try {
    temp = JSON.parse(value);
    return temp;
  } catch (error) {
    return value;
  }
};

QueryString.constructed = QueryString.construct();

/**
 * Creates a new instance of MediaProxy. Used to track player configuration settings.
 * 
 * @param {Object} data The config object.
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
*/
function ModuleProxy(data, name) {
  this.config = data;
  ModuleProxy.__super__.constructor.call(this, name);
}


__extends(ModuleProxy, puremvc.Proxy);


/** @static
*/
ModuleProxy.NAME = "ModuleProxy";

/** @private
*/
ModuleProxy.prototype.defaults = null;

ModuleProxy.prototype.config = null;

/** @override
*/
ModuleProxy.prototype.initializeNotifier = function(key) {
  ModuleProxy.__super__.initializeNotifier.call(this, key);
  this.createData();
};

/**
*/
ModuleProxy.prototype.createData = function() {
  this.setData(this.config);
};

/**
*/
ModuleProxy.prototype.getDefaults = function() {
  return this.defaults || {};
};

/**
 * Sets the data for this proxy.
 * 
 * @param {Object} value 
 *    The new data for this proxy
 * @override
*/
ModuleProxy.prototype.setData = function(data) {
  var dflt, key, obj, value, _ref;
  if (data == null) {
    data = {};
  }
  obj = {};
  _ref = this.getDefaults();
  for (key in _ref) {
    dflt = _ref[key];
    value = key in data ? data[key] : dflt;
    obj[key] = value;
  }
  ModuleProxy.__super__.setData.call(this, obj);
  return data;
};

/**
*/
ModuleProxy.prototype.destroy = function() {};

/**
 * The Module class.
 *
 * @param {Object}  config        The configuration object
 * @param {Object}  viewComponent The player's container element
 * @constructor
 * @private
 * @extends {puremvc.Facade}
*/
function Module(viewComponent) {
  this.viewComponent = viewComponent;
  this.performance = {
    init: Date.now()
  };
  Module.__super__.constructor.call(this, this.getModuleName() + "-" + Utils.createUID());
  this.dispatcher = new EventDispatcher(this);
  this.logger = Logger.instance;
  this.moduleMap = {};
}


__extends(Module, puremvc.Facade);


Module.prototype.logger = null;

Module.prototype.config = null;

Module.prototype.moduleName = null;

Module.prototype.moduleMap = null;

Module.prototype.viewComponent = null;

Module.prototype.dispatcher = null;

Module.prototype.oninitialized = null;

Module.prototype.onerror = null;

Module.prototype.parentModule = null;

Module.prototype.performance = null;

/**
 * Initialization function.
 *
 * @param {Object}  config  The plugin's configuration object.
*/
Module.prototype.initialize = function(config, parentModule) {
  this.config = config;
  this.parentModule = parentModule;
  this.loadModuleResources().then(this.resourcesLoaded.bind(this))["catch"](this.resourcesError.bind(this));
};

/**
*/
Module.prototype.loadModuleResources = function(resources) {
  var resource, _i, _len;
  if (resources == null) {
    resources = this.config.resources;
  }
  if (!(resources != null ? resources.length : void 0) > 0) {
    return Promise.resolve();
  }
  for (_i = 0, _len = resources.length; _i < _len; _i++) {
    resource = resources[_i];
    resource.src = this.evaluatePaths(resource.src);
    if (resource.debug != null) {
      resource.debug = this.evaluatePaths(resource.debug);
    }
  }
  return AMP.addResources(resources);
};

/**
*/
Module.prototype.evaluatePaths = function(path) {
  var paths, _ref, _ref1;
  if (!(path != null)) {
    return;
  }
  paths = this.config.paths || ((_ref = this.parentModule) != null ? (_ref1 = _ref.config) != null ? _ref1.paths : void 0 : void 0);
  if (paths != null) {
    path = path.replace(/[\$#]{paths\.[^}]*}/g, function(match) {
      return DataBinding["eval"](match, null, null, null, paths);
    });
  }
  return path;
};

/**
 * The resources failed to load.
 *
 * @private
*/
Module.prototype.resourcesError = function(error) {
  if (typeof this.onerror === "function") {
    this.onerror(this);
  }
};

/**
 * The resources have finished loaded, load the extensions.
 *
 * @private
*/
Module.prototype.resourcesLoaded = function() {
  this.createFramework();
  if (typeof this.oninitialized === "function") {
    this.oninitialized(this);
  }
};

/**
 * Framework based initialization function for defining default
 * mvc classes. Meant to be overwritten by base classes.
*/
Module.prototype.createFramework = function() {
  this.createModel();
  this.createController();
  this.createView();
};

/**
*/
Module.prototype.createModel = function() {
  this.registerProxy(new ModuleProxy(this.config));
};

/**
*/
Module.prototype.createView = function() {};

/**
*/
Module.prototype.createController = function() {
  this.registerCommand(Notifications.DISPATCH_EVENT, DispatchEventCommand);
};

/**
*/
Module.prototype.getModuleName = function() {
  return this.moduleName;
};

/**
 * @return {Object} The configuration object.
 * @expose
*/
Module.prototype.getConfig = function() {
  return this.config;
};

/**
*/
Module.prototype.hasModule = function(moduleName) {
  return this.moduleMap[moduleName] != null;
};

/**
*/
Module.prototype.getModules = function() {
  var key, modules, value, _ref;
  modules = {};
  _ref = this.moduleMap;
  for (key in _ref) {
    value = _ref[key];
    modules[key] = value.module;
  }
  return modules;
};

/**
*/
Module.prototype.registerModule = function(module) {
  var adaptor, moduleName;
  moduleName = module.getModuleName();
  if (!(module != null) || (this.moduleMap[moduleName] != null)) {
    return;
  }
  adaptor = new ModuleAdapter(module);
  this.moduleMap[moduleName] = adaptor;
  this.registerMediator(adaptor);
  module.onRegister();
};

/**
*/
Module.prototype.retrieveModule = function(moduleName) {
  return this.moduleMap[moduleName].module;
};

/**
*/
Module.prototype.removeModule = function(moduleName) {
  var adaptor, module;
  adaptor = this.moduleMap[moduleName];
  if (!(adaptor != null)) {
    return;
  }
  delete this.moduleMap[moduleName];
  this.removeMediator(moduleName);
  module = adaptor.module;
  module.onRemove.call(module);
  return module;
};

/** List INotification interests.
*/
Module.prototype.listNotificationInterests = function() {
  return [];
};

/** List Notification publications
*/
Module.prototype.listNotificationPublications = function() {
  return [];
};

/** Get the IMediator's view component.
*/
Module.prototype.getViewComponent = function() {
  return this.viewComponent;
};

/** Set the IMediator's view component.
*/
Module.prototype.setViewComponent = function(viewComponent) {
  this.viewComponent = viewComponent;
  return viewComponent;
};

/** Called by the parent module when the Module is registered
*/
Module.prototype.onRegister = function() {};

/** Called by the parent module when the Module is removed
*/
Module.prototype.onRemove = function() {};

/** Destroys the module
*/
Module.prototype.destroy = function() {
  var key, value, _ref, _ref1;
  if (this.getModules() != null) {
    _ref = this.getModules();
    for (key in _ref) {
      value = _ref[key];
      this.removeModule(key);
      value.destroy();
    }
  }
  if ((_ref1 = this.retrieveProxy(ModuleProxy.NAME)) != null) {
    if (typeof _ref1.destroy === "function") {
      _ref1.destroy();
    }
  }
  puremvc.Facade.removeCore(this.multitonKey);
  if (this.viewComponent != null) {
    this.viewComponent.innerHTML = "";
    this.viewComponent.className = "";
  }
  for (key in this) {
    try {
      this[key] = null;
    } catch (error) {

    }
    delete this[key];
  }
};

/**
 * Adds a listener for a given event type.
 *
 * @param {!string}  type  A string representing the event's type.
 * @param {!Function} func  A function to call when the event is triggered.
 * @expose
*/
Module.prototype.addEventListener = function(type, func) {
  this.dispatcher.addEventListener(type, func);
};

/**
 * Adds a listener for a given event type and removes it after it has been triggered once.
*/
Module.prototype.once = function(type, func) {
  this.dispatcher.once(type, func);
};

/**
*/
Module.prototype.logEvent = function(event) {
  var prefix;
  if (/(timeupdate|progress|fragmentloaded|fragmentloadstart)/.test(event.type) === true) {
    return;
  }
  prefix = this.getModuleName().toUpperCase();
  if (event.dispatcher) {
    prefix += " " + event.dispatcher;
  }
  this.logger.log("[" + prefix + " EVENT] " + event.type, event);
};

/**
 * Dispathes and event, triggering all event listener of the event's type.
 *
 * @param {!IEvent} event The event to dispatch.
 * @expose
*/
Module.prototype.dispatchEvent = function(event) {
  this.logEvent(event);
  this.dispatcher.dispatchEvent(event);
};

/**
 * Removes a listener for a given event type.
 *
 * @param {!string}  type  A string representing the event's type.
 * @param {!Function} func  A function to call when the event is triggered.
 * @return {?Function} the handler that was removed if any
 * @expose
*/
Module.prototype.removeEventListener = function(type, func) {
  this.dispatcher.removeEventListener(type, func);
};

/**
 * Creates a new EventDispatcher
 *
 * @constructor
 * @private
 * @implements {IEventDispatcher}
*/
function EventDispatcher(_target) {
  this._target = _target != null ? _target : this;
  this._listenerMap = {};
}

/**
 * Adds a listener for a given event type.
 *
 * @param {!string}  type  A string representing the event's type.
 * @param {!Function} func  A function to call when the event is triggered.
 * @param {boolean=} capture
*/
EventDispatcher.prototype.addEventListener = function(type, func, capture) {
  if (!(func != null) || !(type != null)) {
    return;
  }
  if (!(this._listenerMap[type] != null)) {
    this._listenerMap[type] = [];
  }
  if (this._listenerMap[type].indexOf(func) !== -1) {
    return;
  }
  this._listenerMap[type].push(func);
};

/**
 * Adds a listener for a given event type and removes it after it has been triggered once.
*/
EventDispatcher.prototype.once = function(type, func) {
  func.once = true;
  this.addEventListener(type, func);
};

/**
 * Dispathes and event, triggering all event listener of the event's type.
 *
 * @param {!IEvent} event The event to dispatch.
*/
EventDispatcher.prototype.dispatchEvent = function(event) {
  var listener, listeners, remove, _i, _j, _len, _len1, _ref;
  listeners = this._listenerMap[event.type];
  listener = this._target["on" + event.type];
  event.target = this._target;
  remove = [];
  if (listener != null) {
    listener.apply(this._target, [event]);
  }
  if (!(listeners != null)) {
    return;
  }
  _ref = listeners.slice();
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    listener = _ref[_i];
    listener.apply(this._target, [event]);
    if (listener.once === true) {
      remove.push(listener);
    }
  }
  if (remove.length > 0) {
    for (_j = 0, _len1 = remove.length; _j < _len1; _j++) {
      listener = remove[_j];
      listeners.splice(listeners.indexOf(listener), 1);
    }
  }
};

/**
 * Removes a listener for a given event type.
 *
 * @param {!string}  type  A string representing the event's type.
 * @param {!Function} func  A function to call when the event is triggered.
 * @return {?Function} the handler that was removed if any
 * @param {boolean=} capture
*/
EventDispatcher.prototype.removeEventListener = function(type, func, capture) {
  var index, listeners;
  if (!(func != null) || !(type != null)) {
    return;
  }
  listeners = this._listenerMap[type];
  if (!(listeners != null)) {
    return;
  }
  index = listeners != null ? listeners.indexOf(func) : void 0;
  if (index === -1) {
    return;
  }
  return listeners.splice(index, 1);
};

/**
 * @constructor
 * @private
*/
function TrackList(list) {
  this.list = list != null ? list : [];
  TrackList.__super__.constructor.call(this);
  this.dispatcher = new EventDispatcher(this);
  this.handlers = {
    change: this.changeHandler.bind(this)
  };
}


__extends(TrackList, Array);


TrackList.prototype.onchange = null;

/**
*/
TrackList.prototype.changeHandler = function(event) {
  this.dispatchEvent(event);
};

/**
*/
TrackList.prototype.addEventListener = function(type, func, capture) {
  this.dispatcher.addEventListener(type, func, capture);
};

/**
*/
TrackList.prototype.dispatchEvent = function(event) {
  this.dispatcher.dispatchEvent(event);
};

/**
*/
TrackList.prototype.removeEventListener = function(type, func, capture) {
  return this.dispatcher.removeEventListener(type, func, capture);
};

/**
 * @param {string} key
 *     The key
 *
 * @param {Object} value
 *     The value
*/
TrackList.prototype.add = function(track, dispatch) {
  if (dispatch == null) {
    dispatch = true;
  }
  this.push(track);
  track.addEventListener("change", this.handlers.change);
  if (dispatch === true) {
    this.dispatchEvent({
      type: "addtrack"
    });
  }
};

/**
 * @param {string} key
 *     The module's key
 *
 * @return {Object}
 *     The item.
*/
TrackList.prototype.remove = function(track, dispatch) {
  var index;
  if (dispatch == null) {
    dispatch = true;
  }
  index = this.indexOf(track);
  if (index === -1) {
    return;
  }
  this.splice(index, 1);
  track.removeEventListener("change", this.handlers.change);
  if (dispatch === true) {
    this.dispatchEvent({
      type: "removetrack"
    });
  }
  return track;
};

TrackList.prototype.clear = function() {
  var index, track, _i, _len;
  if (this.length === 0) {
    return;
  }
  for (index = _i = 0, _len = this.length; _i < _len; index = ++_i) {
    track = this[index];
    this.remove(track, false);
    this[index] = null;
    delete this[index];
  }
  this.dispatchEvent({
    type: "removetrack"
  });
};

TrackList.prototype.getTrackById = function(id) {
  var track, _i, _len;
  for (_i = 0, _len = this.length; _i < _len; _i++) {
    track = this[_i];
    if (track.id === id) {
      return track;
    }
  }
};

/** 
 * The InstallPlayer class.
 *   
 * @constructor
 * @private 
 * @param {Object} viewComponent
*/
function InstallPlayer(viewComponent) {
  var anchor, div, img, message;
  viewComponent.className = Namespace.PREFIX + "player";
  div = UI.create("install-flash", viewComponent);
  message = UI.create(null, div, "p", "To view this page ensure that Adobe Flash Player version 10.2.0 or greater is installed.");
  anchor = UI.create(null, div, "a");
  anchor.href = 'http://www.adobe.com/go/getflashplayer';
  img = UI.create(null, anchor, "img");
  img.src = "//www.adobe.com/images/shared/download_buttons/get_flash_player.gif";
  img.alt = "Get Adobe Flash player";
}

InstallPlayer.prototype.initialize = function() {};

/**
*/
InstallPlayer.prototype.getModules = function() {
  return [];
};

/**
 * @constructor
 * @private
*/
function Manager() {
  this.map = {};
}

/** 
 * @type {Object.<string, Object>}
 * @private
*/
Manager.prototype.map = null;

/**
 * @param {string} key
 *     The key
 * 
 * @param {Object} value
 *     The value
*/
Manager.prototype.add = function(key, value) {
  this.map[key] = value;
};

/**
 * @param {string} key
 *     The module's key
 * 
 * @return {Object}
 *     The item at the given key.
*/
Manager.prototype.item = function(key) {
  return this.map[key];
};

/**
 * @param {string} key
 *     The module's key
 * 
 * @return {Object}
 *     The item.
*/
Manager.prototype.remove = function(key) {
  var item;
  item = this.map[key];
  if (item != null) {
    this.map[key] = null;
    delete this.map[key];
  }
  return item;
};

function URL() {}

/**
 * The URL to send the request to.
 *
 * @type {String}
*/
URL.prototype.url = null;

/**
 * The HTTP method to use, such as "GET", "POST", "PUT", "DELETE", etc. 
 * Ignored for non-HTTP(S) URLs.
 *
 * @type {String}
*/
URL.prototype.method = null;

/**
 * A Boolean that indicates whether or not cross-site Access-Control 
 * requests should be made using credentials such as cookies or authorization 
 * headers.
 *
 * @type {Boolean}
*/
URL.prototype.withCredentials = null;

/**
 * A key value map of http headers to include in the reques
 * 
 * @type {Object}
*/
URL.prototype.headers = null;

/**
 * Data to send with a POST request  
 * 
 * @type {Object}
*/
URL.prototype.data = null;

function Authorization(key, token, expiration) {
  this.key = key;
  this.token = token;
  this.expiration = expiration;
}

Authorization.prototype.key = null;

Authorization.prototype.token = null;

Authorization.prototype.expiration = null;

/**
 * @constructor
 * @extends {Manager}
*/
function ResourceManager() {
  ResourceManager.__super__.constructor.call(this);
}


__extends(ResourceManager, Manager);


ResourceManager.prototype.js = function(src, resource) {
  return Utils.loadScript(src, document.body);
};

ResourceManager.prototype.css = function(src, resource) {
  var _this = this;
  return new Promise(function(resolve, reject) {
    try {
      Utils.loadStyleSheet(src);
    } catch (error) {
      reject();
    }
    resolve(resource);
  });
};

ResourceManager.prototype.json = function(src, resource) {
  var _this = this;
  return Utils.requestJson(resource.src).then(function(data) {
    resource.data = data;
    return resource;
  });
};

/**
 * @override
*/
ResourceManager.prototype.require = function(id) {
  var item,
    _this = this;
  item = this.item(id);
  if (!(item != null)) {
    if (typeof id === "string") {
      return this.add({
        src: id
      });
    } else if (id.src != null) {
      return this.add(id);
    } else {
      return Promise.resolve(id);
    }
  } else if (typeof item === "function") {
    Manager.prototype.add.call(this, id, null);
    return Promise.resolve().then(function() {
      return item();
    });
  } else if (typeof item.then === "function") {
    return item;
  } else {
    return Promise.resolve(item);
  }
};

/**
 * @override
*/
ResourceManager.prototype.add = function(resource) {
  var id, item, promise, src, type,
    _this = this;
  if (resource.enabled === false) {
    return Promise.resolve();
  }
  src = Logger.instance.enabled && (resource.debug != null) ? resource.debug : resource.src;
  id = resource.id || src;
  if (resource.defer === true) {
    resource.defer = false;
    ResourceManager.__super__.add.call(this, id, this.add.bind(this, resource));
    return Promise.resolve();
  }
  item = this.item(id);
  if (item != null) {
    if (typeof item.then === "function") {
      return item;
    } else {
      return Promise.resolve(item);
    }
  }
  type = resource.type || Utils.getMimeType(src);
  if (type === Utils.mimeTypes.js || /javascript/.test(type)) {
    promise = this.js(src, resource);
  } else if (type === Utils.mimeTypes.css) {
    promise = this.css(src, resource);
  } else if (type === Utils.mimeTypes.json || /json/.test(type)) {
    promise = this.json(src, resource);
  } else if (type !== Utils.mimeTypes.swf) {
    promise = Utils.request(src);
  }
  if (!(promise != null)) {
    return Promise.resolve();
  }
  promise = promise.then(function(resource) {
    Manager.prototype.add.call(_this, id, resource);
    return resource;
  });
  ResourceManager.__super__.add.call(this, id, promise);
  return promise;
};

/**
 * @param {Array.<akamai.amp.Resource>} resource
 *    The resource
 *
 * @param {Function} callback
*/
ResourceManager.prototype.addResources = function(resources) {
  var asyncs, promise, promises, resource, _i, _len,
    _this = this;
  if (!(resources != null ? resources.length : void 0) > 0) {
    return Promise.resolve();
  }
  promises = [];
  asyncs = [];
  for (_i = 0, _len = resources.length; _i < _len; _i++) {
    resource = resources[_i];
    if (resource instanceof Array) {
      promises.push(this.addResources.bind(this, resource));
    } else if (resource.async === true) {
      asyncs.push(this.add(resource));
    } else {
      promises.push(this.add.bind(this, resource));
    }
  }
  if (asyncs.length > 0) {
    promise = Promise.all(asyncs);
  } else {
    promise = Promise.resolve();
  }
  return promise.then(function() {
    return Utils.chain(promises);
  });
};

/**
 * The PluginsInitializedCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function PluginsInitializedCommand() {
  PluginsInitializedCommand.__super__.constructor.call(this);
}


__extends(PluginsInitializedCommand, puremvc.SimpleCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
PluginsInitializedCommand.prototype.execute = function(notification) {
  var media, _ref;
  this.facade.performance.ready = Date.now();
  this.sendNotification(Notifications.READY, this.facade.config);
  media = (_ref = this.facade.config) != null ? _ref.media : void 0;
  if (media != null) {
    setTimeout(this.sendNotification.bind(this, Notifications.SET_MEDIA, media), 0);
  }
};

/** 
 * The PlayerCommand class. Base class for commands that need access 
 * to the application state or the media
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function PlayerCommand() {
  PlayerCommand.__super__.constructor.call(this);
}


__extends(PlayerCommand, puremvc.SimpleCommand);


PlayerCommand.prototype.applicationState = null;

PlayerCommand.prototype.media = null;

PlayerCommand.prototype.player = null;

PlayerCommand.prototype.playback = null;

PlayerCommand.prototype.config = null;

PlayerCommand.prototype.logger = null;

PlayerCommand.prototype.bindings = null;

PlayerCommand.prototype.params = null;

PlayerCommand.prototype.playerCore = null;

PlayerCommand.prototype.security = null;

PlayerCommand.prototype.tracks = null;

/** @override
*/
PlayerCommand.prototype.initializeNotifier = function(key) {
  var _ref;
  PlayerCommand.__super__.initializeNotifier.call(this, key);
  this.player = this.facade.player || this.facade;
  this.applicationState = this.player.appState;
  this.media = this.player.mediaProxy;
  this.config = this.player.configuration;
  this.logger = this.player.logger;
  this.bindings = this.player.bindings;
  this.params = this.player.params;
  this.playerCore = this.player.playerCore;
  this.security = this.player.security;
  this.tracks = this.player.tracks;
  this.playback = ((_ref = this.player.playerCore) != null ? _ref.getActivePlaybackCore() : void 0) || this.player.playback;
};

/**
 * The TogglePlayPauseCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function TogglePlayPauseCommand() {
  TogglePlayPauseCommand.__super__.constructor.call(this);
}


__extends(TogglePlayPauseCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
TogglePlayPauseCommand.prototype.execute = function(notification) {
  var note;
  if (this.applicationState.getSeeking()) {
    return;
  }
  switch (this.applicationState.getPlayState()) {
    case PlayState.ENDED:
      note = Notifications.REPLAY;
      break;
    case PlayState.PAUSED:
    case PlayState.READY:
      note = Notifications.PLAY;
      break;
    case PlayState.PLAYING:
      note = Notifications.PAUSE;
  }
  if (this.applicationState.getWaiting()) {
    if (this.facade.getMediaElement().paused === true) {
      note = Notifications.PLAY;
    }
  }
  this.sendNotification(note, true);
};

/**
 * The ToggleFullScreenCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ToggleFullScreenCommand() {
  ToggleFullScreenCommand.__super__.constructor.call(this);
}


__extends(ToggleFullScreenCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ToggleFullScreenCommand.prototype.execute = function(notification) {
  var state;
  state = this.applicationState.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;
  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, state);
};

/**
 * The PlayerCommand class. Base class for commands that need access
 * to the application state or the media
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function PlayerEventCommand() {
  PlayerEventCommand.__super__.constructor.call(this);
}


__extends(PlayerEventCommand, PlayerCommand);


/**
 *
*/
PlayerEventCommand.prototype.dispatchEvent = function(type, detail) {
  var event;
  if (typeof type !== "string") {
    detail = type.getBody() != null ? type.getBody() : {};
    type = type.getName();
  }
  event = new Event(type.toLowerCase(), detail);
  this.sendNotification(Notifications.DISPATCH_EVENT, event);
};

/**
 *
*/
PlayerEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {
  setTimeout(this.dispatchEvent.bind(this, type, detail), 0);
};

/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
PlayerEventCommand.prototype.execute = function(notification) {
  this.dispatchEvent(notification);
};

/**
 * The PlayCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.MacroCommand}
*/
function PlayingCommand() {
  PlayingCommand.__super__.constructor.call(this);
}


__extends(PlayingCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
PlayingCommand.prototype.execute = function(notification) {
  if (this.applicationState.getIsUserActive() === true) {
    return;
  }
  if (this.facade.getMediaElement().currentTime === 0 && this.media.started === false && this.applicationState.getSeeking() === false) {
    this.media.started = true;
    this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);
  }
  if (this.applicationState.getPlayState() === PlayState.PLAYING) {
    PlayingCommand.__super__.execute.call(this, notification);
  } else {
    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);
  }
};

/**
 * @enum {string}
 * @const
 * @private
*/

var FullscreenMode = {
  /**
   *
  */

  EXTERNAL: "external"
};

/**
 * @enum {string}
 * @const
 * @private
*/

var ControlsMode = {
  /**
   * Constant representing auto controls mode
  */

  AUTO: "auto",
  /**
   * Constant representing the persistent controls mode
  */

  PERSISTENT: "persistent",
  /**
   * Constant representing none controls mode
  */

  NONE: "none"
};

/**
 * The PauseCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function PauseCommand() {
  PauseCommand.__super__.constructor.call(this);
}


__extends(PauseCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
PauseCommand.prototype.execute = function(notification) {
  this.playback.pause();
  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);
  PauseCommand.__super__.execute.call(this, notification);
};

/**
 * The ChangeAutoplayCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeAutoplayCommand() {
  ChangeAutoplayCommand.__super__.constructor.call(this);
}


__extends(ChangeAutoplayCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeAutoplayCommand.prototype.execute = function(notification) {
  this.config.setAutoplay(notification.getBody());
};

/**
 * The ChangeLoopCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeLoopCommand() {
  ChangeLoopCommand.__super__.constructor.call(this);
}


__extends(ChangeLoopCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeLoopCommand.prototype.execute = function(notification) {
  this.config.setLoop(notification.getBody());
};

/**
 * The ChangeVolumeCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeVolumeCommand() {
  ChangeVolumeCommand.__super__.constructor.call(this);
}


__extends(ChangeVolumeCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ChangeVolumeCommand.prototype.execute = function(notification) {
  this.playback.setVolume(Utils.clamp(notification.getBody(), 0, 1));
};

/**
 * The MediaValidatedCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function MediaValidatedCommand() {
  MediaValidatedCommand.__super__.constructor.call(this);
}


__extends(MediaValidatedCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
MediaValidatedCommand.prototype.execute = function(notification) {
  var canAutoPlay, container, media, mediaElement, muted, playsinline, unmute,
    _this = this;
  media = notification.getBody();
  mediaElement = this.facade.getMediaElement();
  this.sendNotification(Notifications.MEDIA_CHANGE, media);
  canAutoPlay = this.applicationState.getLocked() === false && this.facade.getAutoplay() === true;
  playsinline = this.config.getPlaysInline();
  mediaElement.playsInline = playsinline != null ? playsinline : true;
  muted = this.config.getMuted();
  if (muted != null) {
    this.playback.setMuted(muted);
  }
  if (canAutoPlay && muted) {
    container = this.facade.getContainer();
    unmute = function() {
      _this.config.setMuted(false);
      _this.facade.setMuted(false);
      container.removeEventListener("click", unmute);
    };
    container.addEventListener("click", unmute);
  }
  if (canAutoPlay) {
    setTimeout(this.sendNotification.bind(this, Notifications.PLAY, true), 0);
  }
};

/**
 * The SeekCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function SeekCommand() {
  SeekCommand.__super__.constructor.call(this);
}


__extends(SeekCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
SeekCommand.prototype.execute = function(notification) {
  var time, video;
  time = notification.getBody();
  if (time === 0 && this.media.getType() === Utils.mimeTypes.m3u8) {
    time = 0.25;
  }
  if (time === this.playback.getCurrentTime()) {
    return;
  }
  if (this.playback.getStarted() === true) {
    this.sendNotification(Notifications.WAITING);
  }
  this.sendNotification(Notifications.DISPLAY_TIME, {
    currentTime: time,
    duration: this.playback.getDuration()
  });
  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);
  video = this.facade.getMediaElement();
  this.applicationState.pausedBeforeSeek = video.paused;
  this.playback.setCurrentTime(time);
  if (this.playback.getStarted() !== true) {
    this.sendNotification(Notifications.TIME_UPDATE, time);
  }
};

/**
 * The SeekingCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function SeekingCommand() {
  SeekingCommand.__super__.constructor.call(this);
}


__extends(SeekingCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
SeekingCommand.prototype.execute = function(notification) {
  if (this.applicationState.getSeeking() === true) {
    this.applicationState.setSeekRequested(true);
    return;
  }
  if (this.applicationState.getEnded()) {
    this.applicationState.setEnded(false);
  }
  if (this.facade.getMediaElement().currentTime === 0) {
    this.media.started = false;
  }
  this.applicationState.setSeeking(true);
  SeekingCommand.__super__.execute.call(this, notification);
};

/**
 * The SeekedCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function SeekedCommand() {
  SeekedCommand.__super__.constructor.call(this);
}


__extends(SeekedCommand, PlayerEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
SeekedCommand.prototype.execute = function(notification) {
  var _this = this;
  if (this.applicationState.getIsUserActive() === true) {
    setTimeout(this.sendNotification.bind(this, notification.getName(), notification.getBody()), 100);
    return;
  }
  setTimeout(function() {
    var state;
    _this.applicationState.setSeeking(false);
    _this.dispatchEvent(notification);
    _this.applicationState.setSeekRequested(false);
    _this.sendNotification(UserNotifications.SEEKED, notification.getBody());
    if (_this.applicationState.getPlayState() === PlayState.READY) {
      return;
    }
    state = _this.applicationState.pausedBeforeSeek === true || _this.facade.retrieveProxy(PlaybackProxy.NAME).getPaused() === true ? PlayState.PAUSED : PlayState.PLAYING;
    if (_this.applicationState.displayState === "full-screen" && _this.applicationState.device === "ipad" && _this.facade.retrieveProxy(PlaybackProxy.NAME).getPaused() !== _this.facade.getMediaElement().paused) {
      state = _this.facade.getMediaElement().paused === true ? PlayState.PAUSED : PlayState.PLAYING;
    }
    _this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);
  }, 1);
};

/**
 * The ReplayCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ReplayCommand() {
  ReplayCommand.__super__.constructor.call(this);
}


__extends(ReplayCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ReplayCommand.prototype.execute = function(notification) {
  if (typeof this.playback.replay === "function") {
    this.playback.replay();
    return;
  }
  this.sendNotification(Notifications.SET_MEDIA, this.media.getData());
};

/**
 * The EndCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function EndCommand() {
  EndCommand.__super__.constructor.call(this);
}


__extends(EndCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
EndCommand.prototype.execute = function(notification) {
  if (this.applicationState.getEnded()) {
    return;
  }
  this.playback.setEnabled(false);
  this.playback.pause();
  this.playback.seek(this.playback.getDuration()).then(this.sendNotification.bind(this, Notifications.ENDED));
};

/**
 * The EndedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function EndedCommand() {
  EndedCommand.__super__.constructor.call(this);
}


__extends(EndedCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
EndedCommand.prototype.execute = function(notification) {
  if (this.applicationState.getEnded()) {
    return;
  }
  this.applicationState.setEnded(true);
  EndedCommand.__super__.execute.call(this, notification);
  if (this.config.getLoop() === true) {
    this.sendNotification(Notifications.REPLAY);
  } else if (this.applicationState.getHasPostContent() === false) {
    this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);
  }
};

/**
 * The StartCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function StartCommand() {
  StartCommand.__super__.constructor.call(this);
}


__extends(StartCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
StartCommand.prototype.execute = function(notification) {
  this.sendNotification(Notifications.PLAY_REQUEST);
  this.sendNotification(Notifications.DISPLAY_TIME, {
    currentTime: 0,
    duration: this.media.getDuration()
  });
  this.sendNotification(Notifications.STARTED, notification.getBody());
};

/**
 * The IsUserActiveCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function IsUserActiveCommand() {
  IsUserActiveCommand.__super__.constructor.call(this);
}


__extends(IsUserActiveCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
IsUserActiveCommand.prototype.execute = function(notification) {
  this.applicationState.setIsUserActive(notification.getBody());
};

/**
 * The WaitingCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function WaitingCommand() {
  WaitingCommand.__super__.constructor.call(this);
}


__extends(WaitingCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
WaitingCommand.prototype.execute = function(notification) {
  if (this.applicationState.getWaiting()) {
    return;
  }
  this.applicationState.setWaiting(true);
  WaitingCommand.__super__.execute.call(this, notification);
};

/**
 * The ChangeMutedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeMutedCommand() {
  ChangeMutedCommand.__super__.constructor.call(this);
}


__extends(ChangeMutedCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeMutedCommand.prototype.execute = function(notification) {
  this.playback.setMuted(notification.getBody());
};

/**
 * The AuthorizedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function AuthorizedCommand() {
  AuthorizedCommand.__super__.constructor.call(this);
}


__extends(AuthorizedCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
AuthorizedCommand.prototype.execute = function(notification) {
  if (this.security.getSession() != null) {
    return;
  }
  this.security.setSession(UI.createUID());
  this.sendNotification(Notifications.MEDIA_VALIDATED, this.media.getData());
  AuthorizedCommand.__super__.execute.call(this, notification);
};

/**
 * The InitializedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function InitializedCommand() {
  InitializedCommand.__super__.constructor.call(this);
}


__extends(InitializedCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
InitializedCommand.prototype.execute = function(notification) {
  this.playback.initialized = true;
};

/**
 * The RegisterPlaybackCoreCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function RegisterPlaybackCoreCommand() {
  RegisterPlaybackCoreCommand.__super__.constructor.call(this);
}


__extends(RegisterPlaybackCoreCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
RegisterPlaybackCoreCommand.prototype.execute = function(notification) {
  this.playerCore.registerPlaybackCore(notification.getBody());
};

/**
 * The RecordContentChangeCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function RecordContentChangeCommand() {
  RecordContentChangeCommand.__super__.constructor.call(this);
}


__extends(RecordContentChangeCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
RecordContentChangeCommand.prototype.execute = function(notification) {
  var content;
  content = notification.getBody();
  this.sendNotification(Notifications.CHANGE_CONTENT, {
    from: this.media.getData(),
    to: content
  });
  this.media.updateData(content);
  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);
  this.sendNotification(Notifications.CHANGE_CONTENT, this.media.getData());
};

/**
 * The TimeupdateCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function TimeUpdateCommand() {
  TimeUpdateCommand.__super__.constructor.call(this);
}


__extends(TimeUpdateCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
TimeUpdateCommand.prototype.execute = function(notification) {
  this.sendNotification(Notifications.DISPLAY_TIME, {
    currentTime: this.playback.getCurrentTime(),
    duration: this.playback.getDuration()
  });
  TimeUpdateCommand.__super__.execute.call(this, notification);
};

/**
 * The ToggleMutedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ToggleMutedCommand() {
  ToggleMutedCommand.__super__.constructor.call(this);
}


__extends(ToggleMutedCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ToggleMutedCommand.prototype.execute = function(notification) {
  this.playback.setMuted(!this.playback.getMuted());
};

/**
 * The PlayRequestCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function PlayRequestCommand() {
  PlayRequestCommand.__super__.constructor.call(this);
}


__extends(PlayRequestCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
PlayRequestCommand.prototype.execute = function(notification) {
  if (this.media.started === true) {
    return;
  }
  this.media.started = true;
  PlayRequestCommand.__super__.execute.call(this, notification);
  this.sendNotification(Notifications.WAITING);
  this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);
};

/**
 * The EnableVideoEventsCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function EnableVideoEventsCommand() {
  EnableVideoEventsCommand.__super__.constructor.call(this);
}


__extends(EnableVideoEventsCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
EnableVideoEventsCommand.prototype.execute = function(notification) {
  var event, events, video, _i, _len;
  video = this.player.getMediaElement();
  events = notification.getBody();
  for (_i = 0, _len = events.length; _i < _len; _i++) {
    event = events[_i];
    video.addEventListener(event, this.playback.handlers[event]);
  }
};

/**
 * The DisableVideoEventsCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function DisableVideoEventsCommand() {
  DisableVideoEventsCommand.__super__.constructor.call(this);
}


__extends(DisableVideoEventsCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
DisableVideoEventsCommand.prototype.execute = function(notification) {
  var event, events, video, _i, _len;
  video = this.player.getMediaElement();
  events = notification.getBody();
  for (_i = 0, _len = events.length; _i < _len; _i++) {
    event = events[_i];
    video.removeEventListener(event, this.playback.handlers[event]);
  }
};

/**
 * The PauseCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function VolumeChangeCommand() {
  VolumeChangeCommand.__super__.constructor.call(this);
}


__extends(VolumeChangeCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
VolumeChangeCommand.prototype.execute = function(notification) {
  this.applicationState.setVolume(notification.getBody());
  VolumeChangeCommand.__super__.execute.call(this, notification);
};

/**
 * The HasPostContentCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function HasPostContentCommand() {
  HasPostContentCommand.__super__.constructor.call(this);
}


__extends(HasPostContentCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
HasPostContentCommand.prototype.execute = function(notification) {
  this.applicationState.setHasPostContent(notification.getBody());
};

/**
 * The EndedCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function MediaSequenceEndedCommand() {
  MediaSequenceEndedCommand.__super__.constructor.call(this);
}


__extends(MediaSequenceEndedCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
MediaSequenceEndedCommand.prototype.execute = function(notification) {
  if (this.config.getLoop() === true) {
    MediaSequenceEndedCommand.__super__.execute.call(this, notification);
    this.sendNotification(Notifications.REPLAY);
  } else {
    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ENDED);
    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);
    MediaSequenceEndedCommand.__super__.execute.call(this, notification);
  }
};

/**
 * The LockCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function LockCommand() {
  LockCommand.__super__.constructor.call(this);
}


__extends(LockCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
LockCommand.prototype.execute = function(notification) {
  var locked, note;
  locked = notification.getBody();
  note = locked ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
  this.sendNotification(note, "locked");
  this.applicationState.setLocked(locked);
};

/**
 * The SeekCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function GoLiveCommand() {
  GoLiveCommand.__super__.constructor.call(this);
}


__extends(GoLiveCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
GoLiveCommand.prototype.execute = function(notification) {
  var _base;
  if (typeof (_base = this.playback).goLive === "function") {
    _base.goLive();
  }
};

/**
 * The ChangeActiveStateCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeActiveStateCommand() {
  ChangeActiveStateCommand.__super__.constructor.call(this);
}


__extends(ChangeActiveStateCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeActiveStateCommand.prototype.execute = function(notification) {
  var state;
  state = this.config.getControls().mode !== ControlsMode.PERSISTENT ? notification.getBody() : ActiveState.ACTIVE;
  this.applicationState.setActiveState(state);
};

/**
 * The ChangeDisplayStateCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function ChangeDisplayStateCommand() {
  ChangeDisplayStateCommand.__super__.constructor.call(this);
}


__extends(ChangeDisplayStateCommand, PlayerEventCommand);


ChangeDisplayStateCommand.interval = null;

/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ChangeDisplayStateCommand.prototype.execute = function(notification) {
  var core, fullscreen, state, view,
    _this = this;
  state = notification.getBody();
  if (state === this.applicationState.getDisplayState()) {
    return;
  }
  this.applicationState.setDisplayState(state);
  if (this.config.getFullscreen().mode === FullscreenMode.EXTERNAL) {
    this.sendNotifications(state);
    return;
  }
  core = this.facade.getMediaElement();
  view = this.facade.getViewComponent();
  fullscreen = Utils.getFullScreenApi(view, core);
  if (state === DisplayState.FULL_SCREEN) {
    if (fullscreen.event != null) {
      if (view.mozRequestFullScreen != null) {
        document[fullscreen.event] = function(event) {
          if (!document.mozFullScreen) {
            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
          }
        };
      } else {
        view[fullscreen.event] = function(event) {
          if (!(document[fullscreen.element] != null)) {
            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
          }
        };
      }
    } else {
      clearInterval(ChangeDisplayStateCommand.interval);
      ChangeDisplayStateCommand.interval = setInterval(function() {
        if (core.webkitDisplayingFullscreen !== true) {
          _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
          clearInterval(ChangeDisplayStateCommand.interval);
        }
      }, 100);
    }
    if (fullscreen.error != null) {
      document.addEventListener(fullscreen.error, this.facade.logger.error.bind(this.facade.logger));
    }
    fullscreen.enter();
  } else if (state === DisplayState.NORMAL) {
    if (fullscreen != null) {
      if (typeof fullscreen.exit === "function") {
        fullscreen.exit();
      }
    }
    core[fullscreen.event] = null;
    clearInterval(ChangeDisplayStateCommand.interval);
  }
  this.sendNotifications(state);
};

ChangeDisplayStateCommand.prototype.sendNotifications = function(state) {
  setTimeout(this.sendNotification.bind(this, Notifications.FULL_SCREEN_CHANGE, state), 100);
  this.dispatchEvent("fullscreenchange", state === DisplayState.FULL_SCREEN);
};

/**
 * The PlayCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function PlayCommand() {
  PlayCommand.__super__.constructor.call(this);
}


__extends(PlayCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
PlayCommand.prototype.execute = function(notification) {
  var userInitiated;
  if (this.applicationState.getLocked() === true) {
    return;
  }
  userInitiated = notification.getBody();
  if (userInitiated && this.playback.initialized !== true) {
    this.sendNotification(Notifications.INITIALIZED);
  }
  if (this.playback.initialized !== true || (!this.media.getSrc() && !this.media.getSource())) {
    return;
  }
  if (!this.playback.getStarted()) {
    this.sendNotification(Notifications.START);
  }
  this.playback.play();
  PlayCommand.__super__.execute.call(this, notification);
};

/**
 * The ToggleActiveCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ToggleActiveCommand() {
  ToggleActiveCommand.__super__.constructor.call(this);
}


__extends(ToggleActiveCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ToggleActiveCommand.prototype.execute = function(notification) {
  var state;
  state = this.applicationState.getActiveState() === ActiveState.ACTIVE ? ActiveState.INACTIVE : ActiveState.ACTIVE;
  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);
};

function Track(data) {
  this.data = data != null ? data : {};
  Track.__super__.constructor.call(this);
  Object.defineProperties(this, {
    kind: {
      get: this.getKind,
      enumerable: true,
      configurable: false
    },
    label: {
      get: this.getLabel,
      enumerable: true,
      configurable: false
    },
    language: {
      get: this.getLanguage,
      enumerable: true,
      configurable: false
    },
    id: {
      get: this.getId,
      enumerable: true,
      configurable: false
    },
    enabled: {
      get: this.getEnabled,
      set: this.setEnabled,
      enumerable: true,
      configurable: false
    }
  });
}


__extends(Track, EventDispatcher);


Track.prototype.getKind = function() {
  return this.data.kind;
};

Track.prototype.getLabel = function() {
  return this.data.label;
};

Track.prototype.getLanguage = function() {
  return this.data.language;
};

Track.prototype.getId = function() {
  return this.data.id;
};

Track.prototype.setEnabled = function(value) {
  if (value === this.data.enabled) {
    return;
  }
  this.data.enabled = value;
  this.changeEnabled(value);
  this.dispatchEvent("change");
};

Track.prototype.changeEnabled = function(value) {};

Track.prototype.getEnabled = function() {
  return this.data.enabled;
};

function XMLUtils() {}

XMLUtils.createTextContent = function(xml, text) {
  var node;
  node = /[\&<>]/.test(text) ? xml.createCDATASection(text) : xml.createTextNode(text);
  return node;
};

XMLUtils.updateTextContent = function(node, str) {
  var text;
  text = XMLUtils.createTextContent(node.ownerDocument, str);
  node.removeChild(node.childNodes[0]);
  node.appendChild(text);
  return node;
};

XMLUtils.serialize = function(xml) {
  var serializer;
  if (!(xml != null)) {
    return;
  }
  if (typeof xml === "string") {
    return xml;
  }
  try {
    serializer = new XMLSerializer();
    return serializer.serializeToString(xml);
  } catch (err1) {
    try {
      serializer = document.implementation.createLSSerializer();
      return xmlSerializer.writeToString(xml);
    } catch (err3) {
      try {
        return xml.xml;
      } catch (err2) {

      }
    }
  }
};

XMLUtils.parse = function(text) {
  var parser, xmlDoc;
  if (window.DOMParser) {
    parser = new DOMParser();
    xmlDoc = parser.parseFromString(text, "text/xml");
  } else {
    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
    xmlDoc.async = false;
    xmlDoc.loadXML(text);
  }
  return xmlDoc;
};

/**
 * Creates a new instance of TracksProxy.
 * 
 * @constructor
 * @private
 * @extends {DataBindingContext}
*/
function TracksProxy() {
  TracksProxy.__super__.constructor.call(this, null, {});
  this.data.audioTracks = new TrackList();
  this.data.videoTracks = new TrackList();
  this.data.textTracks = new TrackList();
}


__extends(TracksProxy, puremvc.Proxy);


/** @static
*/
TracksProxy.NAME = "TracksProxy";

TracksProxy.prototype.clear = function() {
  this.data.audioTracks.clear();
  this.data.videoTracks.clear();
  this.data.textTracks.clear();
};

TracksProxy.prototype.getAudioTracks = function() {
  return this.data.audioTracks;
};

TracksProxy.prototype.getVideoTracks = function() {
  return this.data.videoTracks;
};

TracksProxy.prototype.getTextTracks = function() {
  return this.data.textTracks;
};

/**
 * The base player class.
 *
 * @param {Object} config
 * @param {Object} viewComponent
 * @constructor
 * @private
 * @extends {Module}
*/
function Player(viewComponent) {
  Player.__super__.constructor.call(this, viewComponent);
}


__extends(Player, Module);


Player.prototype.moduleName = "amp";

Player.prototype.playerType = null;

Player.prototype.hidden = false;

Player.prototype.l10n = null;

Player.prototype.appState = null;

Player.prototype.mediaProxy = null;

Player.prototype.bindings = null;

Player.prototype.configuration = null;

Player.prototype.params = null;

Player.prototype.security = null;

Player.prototype.createModel = function() {
  this.appState = new ApplicationStateProxy();
  this.registerProxy(this.appState);
  this.bindings = new DataBindingProxy();
  this.registerProxy(this.bindings);
  this.security = new SecurityProxy();
  this.registerProxy(this.security);
  this.mediaProxy = new MediaProxy(this.config);
  this.registerProxy(this.mediaProxy);
  this.params = new ParamsProxy(this.config.params);
  this.registerProxy(this.params);
  this.configuration = new ConfigurationProxy(this.config);
  this.registerProxy(this.configuration);
};

/** @override
*/
Player.prototype.resourcesLoaded = function() {
  Player.__super__.resourcesLoaded.call(this);
  Object.defineProperties(this, {
    src: {
      get: this.getSrc,
      set: this.setSrc,
      enumerable: true,
      configurable: false
    },
    media: {
      get: this.getMedia,
      set: this.setMedia,
      enumerable: true,
      configurable: false
    },
    currentTime: {
      get: this.getCurrentTime,
      set: this.setCurrentTime,
      enumerable: true,
      configurable: false
    },
    autoplay: {
      get: this.getAutoplay,
      set: this.setAutoplay,
      enumerable: true,
      configurable: false
    },
    duration: {
      get: this.getDuration,
      enumerable: true,
      configurable: false
    },
    playState: {
      get: this.getPlayState,
      enumerable: true,
      configurable: false
    },
    seeking: {
      get: this.getSeeking,
      enumerable: true,
      configurable: false
    },
    paused: {
      get: this.getPaused,
      enumerable: true,
      configurable: false
    },
    ended: {
      get: this.getEnded,
      enumerable: true,
      configurable: false
    },
    volume: {
      get: this.getVolume,
      set: this.setVolume,
      enumerable: true,
      configurable: false
    },
    muted: {
      get: this.getMuted,
      set: this.setMuted,
      enumerable: true,
      configurable: false
    },
    mediaElement: {
      get: this.getMediaElement,
      enumerable: true,
      configurable: false
    },
    textTracks: {
      get: (function() {
        return this.getMediaElement().textTracks;
      }),
      enumerable: true,
      configurable: false
    },
    audioTracks: {
      get: this.getAudioTracks,
      enumerable: true,
      configurable: false
    },
    container: {
      get: this.getContainer,
      enumerable: true,
      configurable: false
    },
    loop: {
      get: this.getLoop,
      set: this.setLoop,
      enumerable: true,
      configurable: false
    },
    displayState: {
      get: this.getDisplayState,
      set: this.setDisplayState,
      enumerable: true,
      configurable: false
    },
    playbackRate: {
      get: this.getPlaybackRate,
      set: this.setPlaybackRate,
      enumerable: true,
      configurable: false
    },
    language: {
      get: this.getLanguage,
      set: this.setLanguage,
      enumerable: true,
      configurable: false
    },
    localization: {
      get: (function() {
        return this.retrieveProxy(LocalizationProxy.NAME);
      }),
      enumerable: true,
      configurable: false
    },
    version: {
      get: this.getVersion,
      enumerable: true,
      configurable: false
    },
    error: {
      get: this.getError,
      enumerable: true,
      configurable: false
    },
    hidden: {
      get: this.getHidden,
      set: this.setHidden,
      enumerable: true,
      configurable: false
    },
    mediaTransforms: {
      get: this.getMediaTransforms,
      enumerable: true,
      configurable: false
    },
    waiting: {
      get: this.getWaiting,
      enumerable: true,
      configurable: false
    },
    cues: {
      get: this.getCues,
      set: this.setCues,
      enumerable: true,
      configurable: false
    },
    quality: {
      get: this.getQuality,
      set: this.setQuality,
      enumerable: true,
      configurable: false
    },
    qualityMode: {
      get: this.getQualityMode,
      set: this.setQualityMode,
      enumerable: true,
      configurable: false
    },
    qualityLevels: {
      get: this.getQualityLevels,
      enumerable: true,
      configurable: false
    },
    debug: {
      get: this.getDebug,
      enumerable: true,
      configurable: false
    },
    settings: {
      get: this.getSettings,
      enumerable: true,
      configurable: false
    },
    mode: {
      get: this.getMode,
      enumerable: true,
      configurable: false
    },
    buffering: {
      get: this.getBuffering,
      enumerable: true,
      configurable: false
    }
  });
};

/** @override
*/
Player.prototype.createView = function() {
  if ((this.config.settings != null) && this.config.settings.enabled !== false) {
    this._settings = new SettingsMediator();
    this.registerMediator(this._settings);
  }
};

/** @override
*/
Player.prototype.createController = function() {
  Player.__super__.createController.call(this);
  this.registerCommand(Notifications.SETTINGS_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.CUES_CHANGE, PlayerEventCommand);
};

/** @override
*/
Player.prototype.setViewComponent = function(viewComponent) {
  viewComponent["amp"] = this;
  return Player.__super__.setViewComponent.call(this, viewComponent);
};

/**
*/
Player.prototype.getPlayerType = function() {
  return this.playerType;
};

/**
*/
Player.prototype.getVersion = function() {
  return AMP.getVersion();
};

/**
*/
Player.prototype.getDebug = function() {
  return this.config.debug;
};

/**
*/
Player.prototype.getMode = function() {
  return this.config.mode;
};

/**
*/
Player.prototype.createPlugins = function() {
  this.sendNotification(PluginNotifications.REGISTER_PLUGINS, this.config);
};

/**
*/
Player.prototype.createMediaElement = function() {
  return null;
};

/** @override
*/
Player.prototype.createFramework = function() {
  Player.__super__.createFramework.call(this);
  this.setMediaElement(this.createMediaElement());
  this.createPlugins();
};

/**
*/
Player.prototype.getLanguage = function() {
  return this.retrieveProxy(LocalizationProxy.NAME).getLanguage();
};

/**
*/
Player.prototype.setLanguage = function(value) {
  this.retrieveProxy(LocalizationProxy.NAME).setLanguage(value);
  return value;
};

/**
*/
Player.prototype.getLocalizedString = function(value) {
  try {
    return this.retrieveProxy(LocalizationProxy.NAME).getString(value);
  } catch (error) {
    return value;
  }
};

/**
 * @return {HTMLObject|HTMLMediaElement} The media playback DOM element.
*/
Player.prototype.getMediaElement = function() {
  return this.appState.getMediaElement();
};

/**
*/
Player.prototype.setMediaElement = function(value) {
  this.appState.setMediaElement(value);
  if (!(value.once != null)) {
    value.once = function(type, listener) {
      var handler, id;
      id = Utils.createUID();
      handler = function(id, type, listener, event) {
        this.removeEventListener(type, this[id]);
        delete this[id];
        listener(event);
      };
      this[id] = handler.bind(this, id, type, listener);
      this.addEventListener(type, this[id]);
    };
    value.once = value.once.bind(value);
  }
  value.amp = this;
  return value;
};

/**
 * @return {HTMLElement} The container div.
*/
Player.prototype.getContainer = function() {
  return this.getViewComponent();
};

/**
 * @return {HTMLElement} The container div.
*/
Player.prototype.getAudioTracks = function() {};

/**
 * @param   {string}  binding
 *    A data bound string to evaluate.
 *
 * @return {Object}
 *    The evaluated result
*/
Player.prototype.evaluateBinding = function(binding) {};

/**
 * @param   {Object}  binding
 *    A data bound object to evaluate.
 *
 * @param   {?Object}  params
 *    Optional parameters object to pass to the bindings
 *
 * @return {Object}
 *    The evaluated result
*/
Player.prototype.evaluateBindings = function(binding, context, params) {
  if (!(context != null)) {
    context = this.bindings.data;
  } else {
    context = Utils.override(this.bindings.data, context);
  }
  return AMP.evaluateBindings(binding, context, params);
};

/**
 * Determines if the core can play a given mimeType.
 *
 * @param   {string}  type
 *    The mimetype to check.
 *
 * @return  {string}  ""
 *    if the core can't play the mimeType
*/
Player.prototype.canPlayType = function(type) {};

/**
 * Loads the video.
*/
Player.prototype.load = function() {};

/**
 * Plays the currently loaded video.
*/
Player.prototype.play = function() {};

/**
 * Plays the currently loaded video from its start time.
*/
Player.prototype.replay = function() {};

/**
 * Pauses the currently loaded video.
*/
Player.prototype.pause = function() {};

/**
 * Ends video playback.
*/
Player.prototype.end = function() {};

/**
 * Sets user params.
 *
 * @param {Object} value The user params object.
*/
Player.prototype.setParams = function(value) {};

/**
 * Gets user params.
 *
 * @return {Object} The user params object.
*/
Player.prototype.getParams = function() {};

/**
 * Sets auto play flag.
 *
 * @param {boolean} value The autoplay flash.
*/
Player.prototype.setAutoplay = function(value) {};

/**
 * Gets auto play flag.
 *
 * @return {boolean} The autoplay flash.
*/
Player.prototype.getAutoplay = function() {};

/**
 * Sets player's loop flag.
 *
 * @param {boolean} value The loop flag.
*/
Player.prototype.setLoop = function(value) {};

/**
 * Gets player's loop flag.
 *
 * @return {boolean} The loop flag.
*/
Player.prototype.getLoop = function() {};

/**
 * Sets player's muted value.
 *
 * @param {boolean} value The muted value.
*/
Player.prototype.setMuted = function(value) {};

/**
 * Gets player's muted value.
 *
 * @return {boolean} The muted value.
*/
Player.prototype.getMuted = function() {};

/**
 * Mutes the player.
*/
Player.prototype.mute = function() {
  return this.setMuted(true);
};

/**
 * Unmutes the player.
*/
Player.prototype.unmute = function() {
  return this.setMuted(false);
};

/**
 * Sets the media object.
 *
 * @param {Object} value The media object for the video to play.
*/
Player.prototype.setMedia = function(value) {};

/**
 * Gets the media object.
 *
 * @return {Object} The media object for the video to play.
*/
Player.prototype.getMedia = function() {};

/**
 * Sets the current time of the video.
 *
 * @param {number} value The desired time to seek to.
*/
Player.prototype.setCurrentTime = function(value) {};

/**
 * Gets the current time of the video.
 *
 * @return {number} The current playhead time.
*/
Player.prototype.getCurrentTime = function() {};

/**
 * Gets the current time of the video as a UTC timestamp.
 *
 * @return {number} The current playhead time as a UTC timestamp.
*/
Player.prototype.getCurrentTimeUTC = function() {};

/**
 * Gets the current time of the video.
 *
 * @return {number} The current time of the video.
*/
Player.prototype.getDuration = function() {};

/**
 * Sets the source url of video.
 *
 * @param {string} value The source url of the video to play.
*/
Player.prototype.setSrc = function(value) {};

/**
 * Gets the source url of video.
 *
 * @return {string} The source url of the video to play.
*/
Player.prototype.getSrc = function() {};

/**
 * Sets the source url of video.
 *
 * @param {Array.<Object>} value An array of source objects to choose from.
*/
Player.prototype.setSource = function(value) {};

/**
 * Gets the source url of video.
 *
 * @return {Array.<Object>} An array of source objects to choose from.
*/
Player.prototype.getSource = function() {};

/**
 * Sets the source url of video.
 *
 * @param {number} value The source url of the video to play.
*/
Player.prototype.setVolume = function(value) {};

/**
 * Gets the source url of video.
 *
 * @return {number} The volume a number between 0 and 1.
*/
Player.prototype.getVolume = function() {};

/**
 * The seeking flag.
 *
 * @return {boolean} The seeking flag.
*/
Player.prototype.getSeeking = function() {};

/**
 * The paused flag.
 *
 * @return {boolean} The paused flag.
*/
Player.prototype.getPaused = function() {};

/**
 * The ended flag.
 *
 * @return {boolean} The ended flag.
*/
Player.prototype.getEnded = function() {};

/**
 * The buffering flag.
 *
 * @return {boolean} The buffering flag.
*/
Player.prototype.getBuffering = function() {
  return this.appState.getBuffering();
};

/**
 * Sets the player's display state.
 *
 * @param {DisplayState} value
 *    The display state.
*/
Player.prototype.setDisplayState = function(value) {};

/**
 * Returns the player's display state.
 *
 * @return {DisplayState}
 *    The display state.
*/
Player.prototype.getDisplayState = function() {};

/**
 * Returns the player error.
 *
 * @return {Error}
 *    The Error
*/
Player.prototype.getError = function() {};

/**
 * Enters the player into full screen mode.
*/
Player.prototype.enterFullScreen = function() {};

/**
 * Exits the player out of full screen mode.
*/
Player.prototype.exitFullScreen = function() {};

/**
 * Show the player
*/
Player.prototype.setHidden = function(value) {
  var style;
  if (value === this.appState.getHidden()) {
    return;
  }
  this.appState.setHidden(value);
  style = this.viewComponent.style;
  if (value === true) {
    this.hiddenData = {
      width: style.width,
      height: style.height,
      paused: this.getPaused()
    };
    style.width = style.height = "0px";
    if (this.hiddenData.paused === false) {
      this.pause();
    }
  } else {
    style.width = this.hiddenData.width;
    style.height = this.hiddenData.height;
    if (this.hiddenData.paused === false) {
      this.play();
    }
    this.hiddenData = null;
  }
};

/**
 * Hide the player
*/
Player.prototype.getHidden = function() {
  return this.appState.getHidden();
};

/**
 * Records a content change
 *
 * @param {Object} content
 *    An object representing the new content
*/
Player.prototype.recordContentChange = function(content) {};

/**
 * Sets the rate of playback.
*/
Player.prototype.setPlaybackRate = function() {};

/**
 * Gets the rate of playback.
*/
Player.prototype.getPlaybackRate = function() {};

/**
 * Sets the list of cues.
*/
Player.prototype.setCues = function(value) {
  this.mediaProxy.setCues(value);
  return value;
};

/**
 * Gets the list of cues.
*/
Player.prototype.getCues = function() {
  return this.mediaProxy.getCues();
};

/**
 *
*/
Player.prototype.setQuality = function(value) {};

/**
 *
*/
Player.prototype.getQuality = function() {};

/**
 *
*/
Player.prototype.getQualityLevels = function() {};

/**
 *
*/
Player.prototype.getQualityMode = function() {};

/**
 *
*/
Player.prototype.setQualityMode = function(value) {};

/**
 * Gets the play state.
*/
Player.prototype.getPlaystate = function() {};

/**
 * Gets the list of media transforms
*/
Player.prototype.getMediaTransforms = function() {
  return this.mediaProxy.getTransforms();
};

/**
 * Authorizes a protected stream
*/
Player.prototype.authorize = function(authorization) {
  this.security.authorize(authorization);
};

/**
 * Force the player into live mode during DVR playback
*/
Player.prototype.goLive = function() {};

/**
 *
*/
Player.prototype.appendChild = function(element) {
  this.mediator.addLayer(element);
};

/**
 *
*/
Player.prototype.removeChild = function(element) {
  this.mediator.removeLayer(element);
};

/**
 *
*/
Player.prototype.getSettings = function() {
  var _ref;
  return ((_ref = this._settings) != null ? _ref.getSettings() : void 0) || {
    change: function() {}
  };
};

/**
 * The HTMLPlayer class.
 *
 * @param {Object} viewComponent
 * @constructor
 * @private
 * @extends {Player}
*/
function HTMLPlayer(viewComponent) {
  HTMLPlayer.__super__.constructor.call(this, viewComponent);
  this.fps = FPS;
}


__extends(HTMLPlayer, Player);


HTMLPlayer.prototype.playerType = "html";

HTMLPlayer.prototype.playerCore = null;

HTMLPlayer.prototype.tracks = null;

HTMLPlayer.prototype.mediator = null;

/** @override
*/
HTMLPlayer.prototype.createMediaElement = function() {
  var viewComponent;
  this.mediator = new MediaElementMediator("html5", "video");
  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);
  viewComponent = this.mediator.getViewComponent();
  if (viewComponent.dataset == null) {
    viewComponent.dataset = {};
  }
  return viewComponent;
};

/** @override
*/
HTMLPlayer.prototype.createModel = function() {
  var playbackProxy;
  HTMLPlayer.__super__.createModel.call(this);
  this.registerProxy(new LocalizationProxy(this.config));
  playbackProxy = new PlaybackCoreProxy();
  this.registerProxy(playbackProxy);
  this.playerCore = new PlayerProxy(playbackProxy, this.config.getPlaybackOrder);
  this.registerProxy(this.playerCore);
  this.tracks = new TracksProxy();
  this.registerProxy(this.tracks);
  this.appState.setRenderMode(RenderMode.HTML);
  this.bindings.initialize();
};

/** @override
*/
HTMLPlayer.prototype.createView = function() {
  HTMLPlayer.__super__.createView.call(this);
  this.mediator = new PlayerMediator("html5", this.getViewComponent());
  this.registerMediator(this.mediator);
  this.registerMediator(new PluginAdapter());
  this.registerMediator(new VideoLayerMediator());
  this.registerMediator(new OverlayLayerMediator());
};

/** @override
*/
HTMLPlayer.prototype.createController = function() {
  HTMLPlayer.__super__.createController.call(this);
  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);
  this.registerCommand(Notifications.PLAY, PlayCommand);
  this.registerCommand(Notifications.PLAYING, PlayingCommand);
  this.registerCommand(Notifications.PAUSE, PauseCommand);
  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);
  this.registerCommand(Notifications.TOGGLE_FULL_SCREEN, ToggleFullScreenCommand);
  this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);
  this.registerCommand(Notifications.TOGGLE_ACTIVE, ToggleActiveCommand);
  this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, ChangeActiveStateCommand);
  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);
  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);
  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);
  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);
  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);
  this.registerCommand(Notifications.START, StartCommand);
  this.registerCommand(Notifications.SEEK, SeekCommand);
  this.registerCommand(Notifications.SEEKING, SeekingCommand);
  this.registerCommand(Notifications.SEEKED, SeekedCommand);
  this.registerCommand(Notifications.CHANGE_VOLUME, ChangeVolumeCommand);
  this.registerCommand(Notifications.CHANGE_MUTED, ChangeMutedCommand);
  this.registerCommand(Notifications.CHANGE_AUTOPLAY, ChangeAutoplayCommand);
  this.registerCommand(Notifications.CHANGE_LOOP, ChangeLoopCommand);
  this.registerCommand(Notifications.END, EndCommand);
  this.registerCommand(Notifications.ENDED, EndedCommand);
  this.registerCommand(Notifications.REPLAY, ReplayCommand);
  this.registerCommand(Notifications.ERROR, ErrorCommand);
  this.registerCommand(Notifications.READY, ReadyCommand);
  this.registerCommand(Notifications.WAITING, WaitingCommand);
  this.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);
  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);
  this.registerCommand(Notifications.IS_USER_ACTIVE, IsUserActiveCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZED, AuthorizedCommand);
  this.registerCommand(Notifications.INITIALIZED, InitializedCommand);
  this.registerCommand(Notifications.REGISTER_PLAYBACK_CORE, RegisterPlaybackCoreCommand);
  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);
  this.registerCommand(UserNotifications.SEEK, SeekCommand);
  this.registerCommand(Notifications.CHANGE_PLAYBACK_TARGET, ChangePlaybackTargetCommand);
  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);
  this.registerCommand(Notifications.RECORD_CONTENT_CHANGE, RecordContentChangeCommand);
  this.registerCommand(Notifications.TIME_UPDATE, TimeUpdateCommand);
  this.registerCommand(Notifications.TOGGLE_MUTED, ToggleMutedCommand);
  this.registerCommand(Notifications.VOLUME_CHANGE, VolumeChangeCommand);
  this.registerCommand(Notifications.PLAY_REQUEST, PlayRequestCommand);
  this.registerCommand(Notifications.HAS_POST_CONTENT, HasPostContentCommand);
  this.registerCommand(Notifications.LOCK, LockCommand);
  this.registerCommand(UserNotifications.GO_LIVE, GoLiveCommand);
  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);
  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.PROGRESS, PlayerEventCommand);
  this.registerCommand(Notifications.CAN_PLAY, PlayerEventCommand);
  this.registerCommand(Notifications.CAN_PLAY_THROUGH, PlayerEventCommand);
  this.registerCommand(Notifications.LOAD_START, PlayerEventCommand);
  this.registerCommand(Notifications.STARTED, PlayerEventCommand);
  this.registerCommand(Notifications.LOADED_METADATA, PlayerEventCommand);
  this.registerCommand(Notifications.DURATION_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.MEDIUM_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.TEMPORAL_TYPE_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.LANGUAGE_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.PLAYBACK_TARGET_AVAILABLE, PlayerEventCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PlayerEventCommand);
  this.registerCommand(SecurityNotifications.AUTHENTICATION_FAILED, PlayerEventCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZATION_EXPIRED, PlayerEventCommand);
  this.registerCommand(Notifications.FAIL_OVER_ATTEMPT, PlayerEventCommand);
  this.registerCommand(Notifications.IS_LIVE, PlayerEventCommand);
  this.registerCommand(Notifications.TIMED_METADATA, PlayerEventCommand);
  this.registerCommand(Notifications.PAUSED, PlayerEventCommand);
  this.registerCommand(Notifications.STALLED, PlayerEventCommand);
  this.registerCommand(Notifications.QUALITY_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.QUALITY_CHANGING, PlayerEventCommand);
  this.registerCommand(Notifications.QUALITY_LEVELS_LOADED, PlayerEventCommand);
  this.registerCommand(Notifications.MUTE_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.RESUME, PlayerEventCommand);
  this.registerCommand(Notifications.FRAGMENT_LOAD_START, PlayerEventCommand);
  this.registerCommand(Notifications.FRAGMENT_LOADED, PlayerEventCommand);
  this.registerCommand(Notifications.MEDIA_SEQUENCE_STARTED, PlayerEventCommand);
  this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, MediaSequenceEndedCommand);
  this.registerCommand(Notifications.ENABLE_VIDEO_EVENTS, EnableVideoEventsCommand);
  this.registerCommand(Notifications.DISABLE_VIDEO_EVENTS, DisableVideoEventsCommand);
};

/** @override
*/
HTMLPlayer.prototype.setMediaElement = function(value) {
  var mediaElement;
  mediaElement = this.getMediaElement();
  if (mediaElement != null) {
    mediaElement.removeEventListener("webkitpresentationmodechanged", this.presentationModeChanged);
  }
  value.addEventListener("webkitpresentationmodechanged", this.presentationModeChanged);
  HTMLPlayer.__super__.setMediaElement.call(this, value);
  return value;
};

/**
 * HACK: Fix for iOS 10 manipulating controls property incorrectly after leaving fullscreen
*/
HTMLPlayer.prototype.presentationModeChanged = function(event) {
  if ("inline" === event.target.webkitPresentationMode) {
    event.target.controls = false;
  }
};

HTMLPlayer.prototype.evaluateBinding = function(binding) {
  return this.bindings.evaluateBinding(binding);
};

HTMLPlayer.prototype.recordContentChange = function(content) {
  this.sendNotification(Notifications.RECORD_CONTENT_CHANGE, content);
};

HTMLPlayer.prototype.canPlayType = function(type) {
  return this.retrieveProxy(PlaybackProxy.NAME).canPlayType(type);
};

HTMLPlayer.prototype.getAudioTracks = function() {
  return this.retrieveProxy(TracksProxy.NAME).getAudioTracks();
};

HTMLPlayer.prototype.load = function() {
  this.sendNotification(Notifications.LOAD);
};

HTMLPlayer.prototype.play = function() {
  this.sendNotification(Notifications.PLAY, true);
};

HTMLPlayer.prototype.replay = function() {
  this.sendNotification(Notifications.REPLAY);
};

HTMLPlayer.prototype.pause = function() {
  this.sendNotification(Notifications.PAUSE);
};

HTMLPlayer.prototype.end = function() {
  this.sendNotification(Notifications.END);
};

HTMLPlayer.prototype.setParams = function(value) {
  this.sendNotification(Notifications.CHANGE_PARAMS, value);
  return value;
};

HTMLPlayer.prototype.getParams = function() {
  return this.params.getData();
};

HTMLPlayer.prototype.setAutoplay = function(value) {
  this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);
  return value;
};

HTMLPlayer.prototype.getAutoplay = function() {
  var autoPlay, playbackProxy, _ref;
  playbackProxy = this.retrieveProxy(PlaybackProxy.NAME);
  autoPlay = ((Utils.isAutoplaySupported() && this.configuration.getMuted()) || playbackProxy.initialized) && (this.configuration.getAutoplay() || ((_ref = this.getMedia()) != null ? _ref.autoplay : void 0) === true);
  return autoPlay;
};

HTMLPlayer.prototype.setLoop = function(value) {
  this.sendNotification(Notifications.CHANGE_LOOP, value);
  return value;
};

HTMLPlayer.prototype.getLoop = function() {
  return this.configuration.getLoop();
};

HTMLPlayer.prototype.setMuted = function(value) {
  this.sendNotification(Notifications.CHANGE_MUTED, value);
  return value;
};

HTMLPlayer.prototype.getMuted = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getMuted();
};

HTMLPlayer.prototype.setMedia = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, value);
  return value;
};

HTMLPlayer.prototype.getMedia = function() {
  return this.mediaProxy.getData();
};

HTMLPlayer.prototype.setCurrentTime = function(value) {
  this.sendNotification(Notifications.SEEK, value);
  return value;
};

HTMLPlayer.prototype.getCurrentTime = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getCurrentTime();
};

HTMLPlayer.prototype.getDuration = function() {
  return this.mediaProxy.getDuration();
};

HTMLPlayer.prototype.setSrc = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, {
    src: value
  });
  return value;
};

HTMLPlayer.prototype.getSrc = function() {
  return this.mediaProxy.getSrc();
};

HTMLPlayer.prototype.setSource = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, {
    source: value
  });
  return value;
};

HTMLPlayer.prototype.getSource = function() {
  return this.mediaProxy.getSource();
};

HTMLPlayer.prototype.setVolume = function(value) {
  this.sendNotification(Notifications.CHANGE_VOLUME, value);
  return value;
};

HTMLPlayer.prototype.getVolume = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getVolume();
};

HTMLPlayer.prototype.getSeeking = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getSeeking();
};

HTMLPlayer.prototype.getPaused = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getPaused();
};

HTMLPlayer.prototype.getEnded = function() {
  return this.appState.getEnded();
};

HTMLPlayer.prototype.getWaiting = function() {
  return this.appState.getWaiting();
};

HTMLPlayer.prototype.getError = function() {
  return this.getMediaElement().error;
};

HTMLPlayer.prototype.setDisplayState = function(value) {
  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);
};

HTMLPlayer.prototype.getDisplayState = function(value) {
  return this.appState.getDisplayState();
};

HTMLPlayer.prototype.enterFullScreen = function() {
  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.FULL_SCREEN);
};

HTMLPlayer.prototype.exitFullScreen = function() {
  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
};

HTMLPlayer.prototype.setPlaybackRate = function(value) {
  var _ref;
  if (((_ref = this.ads) != null ? _ref.inProgress : void 0) === true || value === this.getMediaElement().playbackRate) {
    return;
  }
  this.getMediaElement().playbackRate = value;
  this.dispatchEvent(new Event(Events.PLAYBACK_RATE_CHANGE, value));
};

HTMLPlayer.prototype.getPlaybackRate = function() {
  return this.getMediaElement().playbackRate;
};

HTMLPlayer.prototype.getQualityLevels = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getQualityLevels();
};

HTMLPlayer.prototype.setQuality = function(value) {
  return this.retrieveProxy(PlaybackProxy.NAME).setQuality(value);
};

HTMLPlayer.prototype.getQuality = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getQuality();
};

HTMLPlayer.prototype.getQualityMode = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).getQualityMode();
};

HTMLPlayer.prototype.setQualityMode = function(value) {
  return this.retrieveProxy(PlaybackProxy.NAME).setQualityMode(value);
};

/**
 * Gets the play state.
*/
HTMLPlayer.prototype.getPlayState = function() {
  return this.appState.getPlayState();
};

/**
 * Force the player into live mode during DVR playback
*/
HTMLPlayer.prototype.goLive = function() {
  return this.retrieveProxy(PlaybackProxy.NAME).goLive();
};

/**
 * @override
*/
HTMLPlayer.prototype.destroy = function() {
  var _ref, _ref1;
  if ((_ref = this.retrieveProxy(PlayerProxy.NAME)) != null) {
    if ((_ref1 = _ref.activePlaybackCore) != null) {
      if (typeof _ref1.destroy === "function") {
        _ref1.destroy();
      }
    }
  }
  HTMLPlayer.__super__.destroy.call(this);
};

/**
 * @enum {string}
 * @const
 * @private
*/

var FlashNotifications = {
  READY: "jsApiReady",
  RESET: "mediaPlayerReset",
  LOADING: "mediaPlayerLoading",
  PLAYER_ERROR: "mediaPlayerError",
  MEDIA_ERROR: "mediaError",
  ERROR_STREAM_NOT_FOUND: "mediaPlayerErrorStreamNotFound",
  CAPABILITY_CHANGE: "mediaPlayerCapabilityChange",
  PLAYBACK_OPEN: "mediaPlayerPlaybackOpen",
  PLAYBACK_CLOSE: "mediaPlayerPlaybackClose",
  PLAYING: "mediaPlayerPlaying",
  ENDED: "mediaPlayerPlaybackClose",
  MEDIA_SEQUENCE_ENDED: "mediaPlayerPlaybackSequenceComplete",
  PAUSED: "mediaPlayerPaused",
  BUFFERING: "mediaPlayerBuffering",
  DURATION_CHANGE: "mediaPlayerDurationChange",
  TIME_UPDATE: "mediaPlayerPlayheadUpdate",
  SEEKING_CHANGE: "mediaPlayerSeekingChange",
  ERROR: "error",
  VOLUME_CHANGE: "mediaPlayerVolumeChanged",
  PLAY_STATE_CHANGE: "mediaPlayerPlayStateChange",
  STATE_CHANGE: "mediaPlayerStateChange",
  CAPTION_DATA_CHANGE: "mediaPlayerCaptiondataChange",
  FAIL_OVER_ATTEMPT: "mediaPlayerFailoverAttempt",
  ELEMENT_EVENT: "mediaPlayerElementEvent",
  PLAY: "mediaPlayerResumeOrPausePlayback",
  BUFFERING_CHANGE: "mediaPlayerBufferingChanged",
  APPLICATION_STATE_CHANGE: "mediaPlayerApplicationStateChange",
  INITIALIZED: "mediaPlayerInitialized",
  FULLSCREEN_CHANGE: "mediaPlayerFullscreenChange",
  AUTHORIZE: "mediaPlayerAuthenticate",
  CAPTIONING_REQUEST: "mediaPlayerCaptioningRequest",
  CAPTION_LANG_CHANGE: "mediaPlayerCaptionLangChange",
  RECOMMENDATIONS_LOADED: "mediaPlayerRecommendationsLoaded",
  RECOMMENDATION_SELECTED: "mediaPlayerRecommendationSelected",
  SHARE: "mediaPlayerShare",
  SHARE_REQUEST: "mediaPlayerShareRequest",
  AUTO_ADVANCE: "mediaPlayerAutoAdvance",
  CREATE_FLASH_VARS: "createFlashVars",
  CREATE_XML: "createXML",
  FLASH_CREATED: "flashCreated",
  PLAY_REQUEST: "mediaPlayerPlaybackSequenceInitiated",
  LOAD_FEED: "mediaPlayerDataFeedRequested",
  FEED_UPDATED: "mediaPlayerDataFeedUpdated",
  FEED_LOADED: "mediaPlayerFeedLoaded",
  TIMED_METADATA: "mediaPlayerSendCuePoint",
  MEDIA_PLAYER_ID3_UPDATED: "mediaPlayerID3Updated"
};

/**
 * PlaybackProxy constructor.
 *
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
*/
function PlaybackProxy() {
  PlaybackProxy.__super__.constructor.call(this, PlaybackProxy.NAME);
  this.data = {
    core: null,
    muted: false,
    started: false,
    volume: 1,
    currentTime: 0,
    duration: 0,
    src: null,
    ended: false,
    paused: false,
    seeking: false,
    loading: false,
    waiting: false
  };
  if (Utils.getDevice() === "desktop") {
    this.initialized = true;
  }
  this.handlers = {
    "timeupdate": this.ontimeupdate.bind(this),
    "durationchange": this.ondurationchange.bind(this),
    "play": this.onplay.bind(this),
    "playing": this.onplaying.bind(this),
    "pause": this.onpause.bind(this),
    "loadeddata": this.onloadeddata.bind(this),
    "waiting": this.onwaiting.bind(this),
    "seeking": this.onseeking.bind(this),
    "seeked": this.onseeked.bind(this),
    "ended": this.onended.bind(this),
    "progress": this.onprogress.bind(this),
    "error": this.onerror.bind(this),
    "loadstart": this.onloadstart.bind(this),
    "canplay": this.oncanplay.bind(this),
    "canplaythrough": this.oncanplaythrough.bind(this),
    "loadedmetadata": this.onloadedmetadata.bind(this),
    "stalled": this.onstalled.bind(this)
  };
  this.resume = {
    event: Utils.getIEVersion() === -1 || Utils.getIEVersion() === 11 ? "loadedmetadata" : "canplaythrough",
    listener: this.resumestart.bind(this)
  };
  this.textTrackHandlers = {
    "addtrack": this.onaddtrack.bind(this)
  };
  this.fps = FPS;
  this.onneedkey = this.onneedkey.bind(this);
}


__extends(PlaybackProxy, puremvc.Proxy);


/**
 * The name of the this Proxy.
 *
 * @static
 * @type {string}
*/
PlaybackProxy.NAME = "PlaybackProxy";

/** @private
*/
PlaybackProxy.prototype.data = null;

PlaybackProxy.prototype.initialized = false;

PlaybackProxy.prototype.enabled = null;

PlaybackProxy.prototype.handlers = null;

PlaybackProxy.prototype.resume = null;

PlaybackProxy.prototype.playWhenLoaded = false;

PlaybackProxy.prototype.metadataloaded = false;

PlaybackProxy.prototype.activeCuesIndex = 0;

PlaybackProxy.prototype.id3CueType = null;

/**
 * The current time of the video in seconds. Value must be between currentTime and duration.
 *
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number}
 *    The currentTime value in seconds
 * @type {Number}
*/
PlaybackProxy.prototype.getEnabled = function() {
  return this.enabled;
};

PlaybackProxy.prototype.setEnabled = function(value) {
  if (value === this.enabled) {
    return;
  }
  this.enabled = value;
  if (this.enabled === true) {
    this.load();
  } else {
    this.applyHandlers(false);
  }
  return value;
};

/** @private
*/
PlaybackProxy.prototype.applyHandlers = function(enabled) {
  var action, handler, type, video, _ref;
  if (enabled == null) {
    enabled = true;
  }
  video = this.getMediaElement();
  action = enabled ? "addEventListener" : "removeEventListener";
  _ref = this.handlers;
  for (type in _ref) {
    handler = _ref[type];
    video[action](type, handler);
  }
};

/** @private
*/
PlaybackProxy.prototype.resumestart = function(event) {
  var video,
    _this = this;
  video = this.getMediaElement();
  this.handlers.durationchange(event);
  if (this.data.currentTime > 0) {
    setTimeout(function() {
      _this.seek(_this.data.currentTime).then(_this.resumecomplete.bind(_this));
    }, 50);
  } else {
    this.resumecomplete();
  }
};

/** @private
*/
PlaybackProxy.prototype.resumecomplete = function() {
  this.data.loading = false;
  this.applyHandlers(true);
  if (this.playWhenLoaded === true) {
    setTimeout(this.play.bind(this), 1);
  }
};

/** @private
*/
PlaybackProxy.prototype.onaddtrack = function(event) {
  var track,
    _this = this;
  track = event.track;
  if (track.kind !== "metadata") {
    return;
  }
  track.mode = "hidden";
  track.addEventListener("cuechange", function(event) {
    var cue, _i, _len, _ref;
    _ref = event.target.activeCues;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      cue = _ref[_i];
      _this.sendNotification(Notifications.TIMED_METADATA, cue);
    }
  });
};

PlaybackProxy.prototype.ontimeupdate = function(event) {
  var ads, inProgress;
  ads = this.facade.ads || {};
  inProgress = (typeof ads.getInProgress === "function" ? ads.getInProgress() : void 0) || ads.inProgress;
  if (inProgress === true) {
    return;
  }
  this.data.currentTime = event.target.currentTime;
  this.sendNotification(Notifications.TIME_UPDATE, this.data.currentTime);
};

PlaybackProxy.prototype.ondurationchange = function(event) {
  var duration;
  duration = event.target.duration;
  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {
    return;
  }
  this.data.duration = duration;
  if (/Android [4-7]/.test(navigator.userAgent) && this.getMediaElement().src.indexOf(".m3u8") !== -1 && duration === Infinity) {
    return;
  }
  this.sendNotification(Notifications.CHANGE_DURATION, duration);
};

PlaybackProxy.prototype.onplay = function(event) {
  this.data.paused = false;
};

PlaybackProxy.prototype.onplaying = function(event) {
  this.data.paused = false;
  this.data.seeking = false;
  this.data.waiting = false;
  this.sendNotification(Notifications.PLAYING);
};

PlaybackProxy.prototype.onpause = function(event) {
  if (this.getMediaElement().ended === true) {
    return;
  }
  if (this.data.waiting === true && this.playbackCoreName === "hls") {
    return;
  }
  this.data.paused = true;
  if (event.target.readyState > 0) {
    this.sendNotification(Notifications.PAUSED);
    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);
  }
};

PlaybackProxy.prototype.onloadeddata = function(event) {
  this.sendNotification(Notifications.LOADED_DATA);
};

PlaybackProxy.prototype.onwaiting = function(event) {
  var video;
  this.data.waiting = true;
  this.sendNotification(Notifications.WAITING);
  video = this.getMediaElement();
  if (video.seeking === false && video.readyState === 2 && video.networkState === 2) {
    video.once("playing", this.sendNotification.bind(this, Notifications.BUFFERING_CHANGE, false));
    this.sendNotification(Notifications.BUFFERING_CHANGE, true);
  }
};

PlaybackProxy.prototype.onstalled = function(event) {
  this.sendNotification(Notifications.STALLED);
};

PlaybackProxy.prototype.onseeking = function(event) {
  this.getMediaElement().removeEventListener("timeupdate", this.handlers.timeupdate);
  this.data.seeking = true;
  this.sendNotification(Notifications.SEEKING);
};

PlaybackProxy.prototype.onseeked = function(event) {
  this.data.seeking = false;
  this.sendNotification(Notifications.SEEKED, event.target.currentTime);
  this.getMediaElement().addEventListener("timeupdate", this.handlers.timeupdate);
};

PlaybackProxy.prototype.onended = function(event) {
  this.data.ended = true;
  this.sendNotification(Notifications.ENDED);
};

PlaybackProxy.prototype.onprogress = function(event) {
  var buffered, video;
  try {
    video = this.getMediaElement();
    buffered = video.buffered;
    this.sendNotification(Notifications.PROGRESS, buffered.end(buffered.length - 1) / video.duration);
  } catch (error) {

  }
};

PlaybackProxy.prototype.onerror = function(event) {
  this.sendNotification(Notifications.ERROR, this.getMediaElement().error);
};

PlaybackProxy.prototype.onloadstart = function(event) {
  this.sendNotification(Notifications.LOAD_START);
};

PlaybackProxy.prototype.oncanplay = function(event) {
  this.sendNotification(Notifications.CAN_PLAY);
};

PlaybackProxy.prototype.oncanplaythrough = function(event) {
  this.createTracks();
  this.sendNotification(Notifications.CAN_PLAY_THROUGH);
  this.sendNotification(Notifications.PROGRESS, this.getDuration());
};

PlaybackProxy.prototype.onloadedmetadata = function(event) {
  this.metadataloaded = true;
  this.sendNotification(Notifications.ENABLE_FULL_SCREEN);
  this.sendNotification(Notifications.LOADED_METADATA);
};

PlaybackProxy.prototype.applyTextTrackHandlers = function(data) {
  var action, _ref;
  action = data === true ? "addEventListener" : "removeEventListener";
  if ((_ref = this.getMediaElement().textTracks) != null) {
    _ref[action]("addtrack", this.textTrackHandlers.addtrack);
  }
};

/** @override
*/
PlaybackProxy.prototype.createTracks = function() {
  var audio, count, index, track, tracks, _i, _len;
  audio = this.getMediaElement().audioTracks;
  tracks = this.facade.retrieveProxy(TracksProxy.NAME).getAudioTracks();
  if (audio != null) {
    count = audio.length || 0;
    for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {
      track = audio[index];
      tracks.add(new Track(track), index + 1 === count);
    }
  }
};

/** @private
*/
PlaybackProxy.prototype.reset = function() {
  this.data.currentTime = 0;
  this.data.duration = 0;
  this.data.src = null;
  this.data.ended = false;
  this.data.paused = false;
  this.data.seeking = false;
  this.data.started = false;
  this.data.loading = false;
  this.applyTextTrackHandlers(false);
};

/**
 * @return {boolean}
*/
PlaybackProxy.prototype.getStarted = function() {
  return this.data.started;
};

/**
 * The playback core
 *
 * @param {HTMLVideoElement} value
 *    The new playback core
 * @returns {HTMLVideoElement}
 *    The playback core
 * @type {HTMLVideoElement}
 *
 * @private
*/
PlaybackProxy.prototype.getMediaElement = function() {
  return this.facade.getMediaElement();
};

/**
 *
*/
PlaybackProxy.prototype.canPlayMedium = function(medium) {
  return medium === "video";
};

/**
 *
*/
PlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {
  return temporalType !== "dvr";
};

/**
 * Determines if the core can play a given mimeType.
 *
 * @return {String} "" if the core can't play the mimeType
*/
PlaybackProxy.prototype.canPlayType = function(mimeType) {
  var canPlay;
  canPlay = document.createElement("video").canPlayType(mimeType) || "";
  if ((/Android (4\.[1-9]|[5-6])/.test(navigator.userAgent) || /Silk\/3/.test(navigator.userAgent)) && mimeType === Utils.mimeTypes.m3u8) {
    canPlay = "maybe";
  }
  if (canPlay === "probably" && /video\/f4m|x-flv/.test(mimeType) && /UCBrowser/.test(navigator.userAgent)) {
    canPlay = "";
  }
  return canPlay;
};

/**
 * Indicates whether or not the video is playing.
 *
 * @returns {Boolean}
 *    The playing value
 * @type {Boolean}
*/
PlaybackProxy.prototype.getPaused = function() {
  return this.data.paused;
};

/**
 * Indicates whether or not the video is playing.
 *
 * @returns {Boolean}
 *    The playing value
 * @type {Boolean}
*/
PlaybackProxy.prototype.getSeeking = function() {
  return this.data.seeking;
};

/**
 * The current time of the video in seconds. Value must be between currentTime and duration.
 *
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number}
 *    The currentTime value in seconds
 * @type {Number}
*/
PlaybackProxy.prototype.getCurrentTime = function() {
  return this.data.currentTime;
};

PlaybackProxy.prototype.setCurrentTime = function(value) {
  if (value === this.data.currentTime) {
    return;
  }
  this.data.currentTime = value;
  if (this.getStarted()) {
    this.seek(value);
  }
  return value;
};

/** @private
*/
PlaybackProxy.prototype.seek = function(time) {
  var _this = this;
  if (time == null) {
    time = this.data.currentTime;
  }
  return new Promise(function(resolve, reject) {
    var interval, seeked, ua, video;
    try {
      video = _this.getMediaElement();
      seeked = function() {
        setTimeout(resolve, 10, time);
      };
      video.once("seeked", seeked);
      video.currentTime = time;
      ua = navigator.userAgent;
      if (/Android.*Chrome/.test(ua)) {
        interval = setInterval(function() {
          if (Math.round(video.currentTime) === Math.round(time)) {
            clearInterval(interval);
            video.dispatchEvent(new CustomEvent("seeked"));
          }
        }, 10);
      }
    } catch (error) {
      reject(error);
    }
  });
};

/**
*/
PlaybackProxy.prototype.goLive = function() {
  var mediaElement, time;
  mediaElement = this.getMediaElement();
  time = mediaElement.duration === Infinity ? mediaElement.seekable.end(0) : mediaElement.duration;
  mediaElement.currentTime = time;
};

/**
 * The current time of the video in seconds. Value must be between currentTime and duration.
 *
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number}
 *    The currentTime value in seconds
 * @type {Number}
*/
PlaybackProxy.prototype.getVolume = function() {
  var mediaElement;
  mediaElement = this.getMediaElement();
  if (mediaElement.muted === true) {
    return 0;
  } else {
    return mediaElement.volume;
  }
};

PlaybackProxy.prototype.setVolume = function(value) {
  if (this.getMuted() && value > 0) {
    this.setMuted(false);
  } else if (!this.getMuted() && value === 0) {
    this.setMuted(true);
  }
  this.sendNotification(Notifications.VOLUME_CHANGE, this.getMediaElement().volume = value);
  return value;
};

/**
*/
PlaybackProxy.prototype.getMuted = function() {
  return this.data.muted;
};

PlaybackProxy.prototype.setMuted = function(value) {
  var volume;
  if (this.data.muted === value) {
    return;
  }
  this.data.muted = value;
  if (this.data.muted === true) {
    this.data.volume = this.getVolume();
    volume = 0;
  } else {
    volume = this.data.volume;
  }
  this.getMediaElement().muted = value;
  this.sendNotification(Notifications.CHANGE_VOLUME, volume);
  this.sendNotification(Notifications.MUTE_CHANGE, this.data.muted);
  return value;
};

/**
 * The duration of the video in seconds.
 *
 * @returns {Number}
 *    The duration of the video
 * @type {Number}
*/
PlaybackProxy.prototype.getDuration = function() {
  return this.data.duration;
};

/**
 * Instructs the core to play.
*/
PlaybackProxy.prototype.play = function() {
  if (this.data.started !== true) {
    this.data.started = true;
    this.setEnabled(true);
    this.playWhenLoaded = true;
    if (this.metadataloaded === false) {
      return;
    }
  } else if (this.data.loading === true) {
    this.playWhenLoaded = true;
    return;
  }
  if (this.getPaused()) {
    this.sendNotification(Notifications.RESUME);
  }
  this.getMediaElement().play();
};

/**
 * Instructs the core to pause.
*/
PlaybackProxy.prototype.pause = function() {
  this.data.paused = true;
  this.getMediaElement().pause();
};

PlaybackProxy.prototype.getSrc = function() {
  return this.facade.mediaProxy.getSrc();
};

/**
 * Instructs the core to load.
*/
PlaybackProxy.prototype.load = function() {
  var element;
  this.sendNotification(Notifications.WAITING);
  this.data.loading = true;
  this.playWhenLoaded = false;
  this.metadataloaded = false;
  element = this.getMediaElement();
  element.once(this.resume.event, this.resume.listener);
  element.addEventListener("loadedmetadata", this.handlers.loadedmetadata);
  element.addEventListener("durationchange", this.handlers.durationchange);
  element.addEventListener("canplaythrough", this.handlers.canplaythrough);
  element.addEventListener("webkitneedkey", this.onneedkey);
  element.addEventListener("error", this.handlers.error);
  this.applyTextTrackHandlers(true);
  this.applySrc();
};

PlaybackProxy.prototype.applySrc = function() {
  var element, muted, src, _ref;
  src = this.getSrc();
  if (!(src != null) || src === "") {
    this.sendNotification(Notifications.ERROR, "The value of src is not supported: " + value);
  }
  element = this.getMediaElement();
  element.src = src;
  muted = element.muted;
  if (muted === true) {
    this.data.muted = true;
  }
  if (Utils.isIPad() && ((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 8) {
    setTimeout(element.load.bind(element), 100);
  } else {
    element.load();
  }
};

PlaybackProxy.prototype.setQuality = function(value) {};

PlaybackProxy.prototype.getQuality = function() {};

PlaybackProxy.prototype.getQualityLevels = function() {
  return [];
};

PlaybackProxy.prototype.getQualityMode = function() {};

PlaybackProxy.prototype.setQualityMode = function(value) {};

PlaybackProxy.prototype.destroy = function() {
  var element, key, value, _ref;
  element = this.getMediaElement();
  _ref = this.handlers;
  for (key in _ref) {
    value = _ref[key];
    element.removeEventListener(key, value);
  }
  element.removeEventListener(this.resume.event, this.resume.listener);
};

/**
  The EME specification (https://dvcs.w3.org/hg/html-media/raw-file/tip/encrypted-media/encrypted-media.html)
  is supported starting OSX 10.10 and greater.
*/
PlaybackProxy.prototype.onneedkey = function(event) {
  var contentId, initData, keySystem, keys, serverUrl, video,
    _this = this;
  video = event.target;
  keySystem = Utils.getKeySystem();
  keys = this.facade.mediaProxy.getKeys()[keySystem];
  if (!(keys != null) || keySystem !== "com.apple.fps.1_0") {
    return;
  }
  initData = event.initData;
  contentId = this.fps.extractContentId(initData, keys);
  serverUrl = this.fps.extractServerUrl(initData, keys);
  this.fps.requestCertificate(keys).then(function(cert) {
    return _this.fps.concatInitDataIdAndCertificate(initData, contentId, cert);
  }).then(function(initData) {
    var session;
    if (!WebKitMediaKeys.isTypeSupported(keySystem, "video/mp4")) {
      throw "Key System not supported";
    }
    if (!(video.webkitKeys != null)) {
      video.webkitSetMediaKeys(new WebKitMediaKeys(keySystem));
    }
    if (!(video.webkitKeys != null)) {
      throw "Could not create MediaKeys";
    }
    session = video.webkitKeys.createSession("video/mp4", initData);
    if (!(session != null)) {
      throw "Could not create key session";
    }
    session.addEventListener("webkitkeymessage", function(event) {
      _this.fps.requestLicense(event.message, contentId, serverUrl).then(function(key) {
        session.update(key);
      })["catch"](function(error) {
        _this.facade.logger.error("[AMP DRM] A key request error was encountered.", error);
      });
    });
    session.addEventListener("webkitkeyadded", function(event) {
      _this.facade.logger.log("[AMP DRM] Decryption key was added to session.");
    });
    session.addEventListener("webkitkeyerror", function(event) {
      _this.facade.logger.log("[AMP DRM] A decryption key error was encountered.", event);
    });
  })["catch"](function(error) {
    _this.facade.logger.error(error);
  });
};

/**
 * The FlashPluginsInitializedCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function FlashPluginsInitializedCommand() {
  FlashPluginsInitializedCommand.__super__.constructor.call(this);
}


__extends(FlashPluginsInitializedCommand, puremvc.SimpleCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
FlashPluginsInitializedCommand.prototype.execute = function(notification) {
  setTimeout(this.facade.pluginsinitialized.bind(this.facade), 0);
};

/**
 * The FlashStartCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function FlashStartCommand() {
  FlashStartCommand.__super__.constructor.call(this);
}


__extends(FlashStartCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
FlashStartCommand.prototype.execute = function(notification) {
  this.player.started = true;
  this.sendNotification(Notifications.STARTED, notification.getBody());
  this.sendNotification(Notifications.PLAY, notification.getBody());
};

/**
 * The RegisterPlaybackCoreCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function ChangePlaybackTargetCommand() {
  ChangePlaybackTargetCommand.__super__.constructor.call(this);
}


__extends(ChangePlaybackTargetCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangePlaybackTargetCommand.prototype.execute = function(notification) {
  var target;
  target = notification.getBody();
  this.applicationState.setPlaybackTarget(target);
  if (target !== "amp") {
    if (this.applicationState.getPlayState() !== PlayState.PAUSED) {
      this.facade.pause();
    }
  } else {
    if (this.applicationState.getPlayState() === PlayState.PLAYING) {
      this.facade.play();
    }
  }
};

/**
 * The WaitingCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function BufferingChangeCommand() {
  BufferingChangeCommand.__super__.constructor.call(this);
}


__extends(BufferingChangeCommand, PlayerEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
BufferingChangeCommand.prototype.execute = function(notification) {
  var buffering;
  buffering = notification.getBody();
  if (this.applicationState.getBuffering() === buffering) {
    return;
  }
  this.applicationState.setBuffering(buffering);
  BufferingChangeCommand.__super__.execute.call(this, notification);
};

function LocalizationWrapper(player, config) {
  this.player = player;
  this.config = config;
  LocalizationWrapper.__super__.constructor.call(this, this.constructor.NAME);
  this.proxy = new LocalizationProxy(this.config);
  this.player.registerProxy(this.proxy);
}


__extends(LocalizationWrapper, puremvc.Mediator);


LocalizationWrapper.prototype.player = null;

LocalizationWrapper.prototype.config = null;

LocalizationWrapper.prototype.proxy = null;

LocalizationWrapper.NAME = "LocalizationWrapper";

/**
*/
LocalizationWrapper.prototype.getString = function(key) {
  return this.proxy.getString(key);
};

/** @override
*/
LocalizationWrapper.prototype.listNotificationInterests = function() {
  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];
};

/**
*/
LocalizationWrapper.prototype.handleNotification = function(notification) {
  var application, body, config, element, flashvars, key, lang, locale, locales, name, prop, text, value, xml, _ref;
  LocalizationWrapper.__super__.handleNotification.call(this, notification);
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case FlashNotifications.CREATE_FLASH_VARS:
      flashvars = body.flashvars;
      config = body.config;
      flashvars.locale_setting = this.proxy.getLocaleId();
      break;
    case FlashNotifications.CREATE_XML:
      xml = body.xml;
      application = xml.firstChild;
      locales = xml.getElementsByTagName("locales")[0];
      if (!(locales != null)) {
        locales = xml.createElement("locales");
        application.appendChild(locales);
      }
      _ref = this.proxy.getLocales();
      for (lang in _ref) {
        locale = _ref[lang];
        element = xml.createElement("locale");
        element.setAttribute("id", lang);
        locales.appendChild(element);
        for (key in locale) {
          value = locale[key];
          prop = xml.createElement("property");
          prop.setAttribute("key", key);
          text = XMLUtils.createTextContent(xml, value);
          prop.appendChild(text);
          element.appendChild(prop);
        }
      }
  }
};

/** 
 * The ModuleMediator class.
 * 
 * @param {string} name
 * @param {Object} viewComponent
 * @constructor
 * @private 
 * @extends {puremvc.Mediator}
*/
function ModuleMediator(viewComponent) {
  if (this.cssPrefix == null) {
    this.cssPrefix = Namespace.PREFIX;
  }
  ModuleMediator.__super__.constructor.call(this, this.mediatorName, viewComponent);
}


__extends(ModuleMediator, puremvc.Mediator);


ModuleMediator.prototype.config = null;

ModuleMediator.prototype.cssPrefix = null;

ModuleMediator.prototype.classList = null;

/** @override
*/
ModuleMediator.prototype.initializeNotifier = function(key) {
  var base;
  ModuleMediator.__super__.initializeNotifier.call(this, key);
  base = this.facade.player || this.facade;
  this.config = base.retrieveProxy(ModuleProxy.NAME);
  this.classList = this.classList = new ClassList(this.viewComponent);
};

/** 
 * @constructor
 * @private
*/
function LocalizedMediator(viewComponent) {
  LocalizedMediator.__super__.constructor.call(this, viewComponent);
}


__extends(LocalizedMediator, ModuleMediator);


LocalizedMediator.prototype.localizationManager = null;

/** @override
*/
LocalizedMediator.prototype.initializeNotifier = function(key) {
  var target;
  LocalizedMediator.__super__.initializeNotifier.call(this, key);
  target = this.facade.player || this.facade;
  this.localizationManager = target.retrieveProxy(LocalizationProxy.NAME);
};

/** 
 * @constructor
 * @extends {LocalizedMediator}
 * @private
*/
function ComponentMediator(componentName, componentType, parent, element) {
  this.componentName = componentName != null ? componentName : this.componentName;
  this.componentType = componentType != null ? componentType : this.componentType;
  this.parent = parent;
  this.element = element;
  if (this.mediatorName == null) {
    this.mediatorName = this.createMediatorName();
  }
  ComponentMediator.__super__.constructor.call(this, this.viewComponent);
}


__extends(ComponentMediator, LocalizedMediator);


ComponentMediator.prototype.componentName = null;

ComponentMediator.prototype.componentType = null;

ComponentMediator.prototype.parent = null;

ComponentMediator.prototype.element = null;

ComponentMediator.prototype.classList = null;

ComponentMediator.prototype.state = null;

ComponentMediator.prototype.disabled = false;

/**
*/
ComponentMediator.prototype.onRegister = function() {
  this.viewComponent = this.createViewComponent(this.parent, this.element);
  this.classList = this.viewComponent._classList;
  UI.bindEvents(this.viewComponent, this);
};

/**
*/
ComponentMediator.prototype.createViewComponent = function(parent, element) {
  var type;
  type = this.getTypeList();
  return UI.create(type, parent, element);
};

/**
*/
ComponentMediator.prototype.createMediatorName = function() {
  var type;
  type = this.getTypeList();
  type.push("mediator");
  type.push(UI.createUID());
  return type.join("-");
};

/**
*/
ComponentMediator.prototype.getTypeList = function() {
  var type;
  type = [];
  if (this.componentName != null) {
    type.push(this.componentName);
  }
  if (this.componentType != null) {
    type = type.concat(this.componentType);
  }
  return type;
};

/**
*/
ComponentMediator.prototype.create = function(type, parent, element, text) {
  if (parent == null) {
    parent = this;
  }
  if (parent === false) {
    parent = null;
  }
  return UI.create(type, parent, element, text);
};

/**
*/
ComponentMediator.prototype.createText = function(type, text, parent, element) {
  if (parent == null) {
    parent = this;
  }
  return UI.create(type, parent, element, text);
};

/**
*/
ComponentMediator.prototype.setState = function(value) {
  if (value === this.state) {
    return;
  }
  if (this.state != null) {
    this.classList.remove(this.state);
  }
  this.state = value;
  if (this.state != null) {
    this.classList.add(this.state);
  }
  return value;
};

/**
*/
ComponentMediator.prototype.getState = function() {
  return this.state;
};

/**
*/
ComponentMediator.prototype.setDisabled = function(value) {
  if (value === this.disabled) {
    return;
  }
  this.disabled = value;
  if (this.disabled) {
    this.classList.add("disabled");
  } else {
    this.classList.remove("disabled");
  }
  return value;
};

/**
*/
ComponentMediator.prototype.getDisabled = function() {
  return this.disabled;
};

/** 
 * @constructor
 * @private
 * @extends {ComponentMediator}
*/
function MediaElementMediator(componentName, viewComponent) {
  this.mediatorName = "" + this.componentType + "-mediator";
  MediaElementMediator.__super__.constructor.call(this, componentName, null, null, viewComponent);
}


__extends(MediaElementMediator, ComponentMediator);


MediaElementMediator.prototype.componentType = "media-element";

MediaElementMediator.prototype.created = false;

MediaElementMediator.prototype.onRegister = function() {
  if (this.created !== true) {
    this.created = true;
    MediaElementMediator.__super__.onRegister.call(this);
  }
};

/** 
 * @constructor
 * @private
*/
function LayerMediator() {
  LayerMediator.__super__.constructor.call(this);
}


__extends(LayerMediator, ComponentMediator);


LayerMediator.prototype.componentType = "layer";

/**
 * Registers the layer
 * 
 * @override
*/
LayerMediator.prototype.onRegister = function() {
  LayerMediator.__super__.onRegister.call(this);
  this.registerLayer();
};

/**
 * Removes the layer
 * 
 * @override
*/
LayerMediator.prototype.onRemove = function() {
  LayerMediator.__super__.onRemove.call(this);
  this.removeLayer();
};

/**
 *
*/
LayerMediator.prototype.registerLayer = function() {
  this.sendNotification(Notifications.ADD_LAYER, this.viewComponent);
};

/**
 *
*/
LayerMediator.prototype.removeLayer = function() {
  this.sendNotification(Notifications.REMOVE_LAYER, this.viewComponent);
};

/**
 * @constructor
 * @extends {LayerMediator}
 * @private
*/
function VideoLayerMediator() {
  VideoLayerMediator.__super__.constructor.call(this);
}


__extends(VideoLayerMediator, LayerMediator);


VideoLayerMediator.prototype.componentName = "video";

/** @override
*/
VideoLayerMediator.prototype.listNotificationInterests = function() {
  return [Notifications.PLAYBACK_CORE_CHANGE];
};

VideoLayerMediator.prototype.mediator = null;

VideoLayerMediator.prototype.mediaElement = null;

/** @override
*/
VideoLayerMediator.prototype.handleNotification = function(notification) {
  var body, isMediator, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.PLAYBACK_CORE_CHANGE:
      if (this.mediaElement != null) {
        this.viewComponent.removeChild(this.mediaElement);
      }
      if (this.mediator != null) {
        this.facade.removeMediator(this.mediator.getMediatorName());
      }
      isMediator = (body != null ? body.getViewComponent : void 0) != null;
      if (isMediator) {
        this.facade.registerMediator(body);
        this.mediator = body;
        this.mediaElement = this.mediator.getViewComponent();
      } else {
        this.mediator = null;
        this.mediaElement = body;
      }
      if (this.mediaElement != null) {
        this.facade.setMediaElement(this.mediaElement);
        this.viewComponent.appendChild(this.mediaElement);
      }
  }
};

/**
 * @constructor
 * @private
 * @extends {ModuleMediator}
*/
function PlayerMediator(componentName, viewComponent) {
  this.componentName = componentName;
  this.layers = [];
  PlayerMediator.__super__.constructor.call(this, null, null, null, viewComponent);
}


__extends(PlayerMediator, ComponentMediator);


PlayerMediator.prototype.componentType = "player";

PlayerMediator.prototype.core = null;

PlayerMediator.prototype.medium = null;

PlayerMediator.prototype.layers = null;

PlayerMediator.prototype.ready = false;

/** @override
*/
PlayerMediator.prototype.onRegister = function() {
  var device;
  PlayerMediator.__super__.onRegister.call(this);
  device = Utils.getDevice();
  if ((device != null)) {
    this.classList.add(device);
  }
  if (Utils.isTouchDevice()) {
    this.classList.add("touch");
  }
};

/** @override
*/
PlayerMediator.prototype.listNotificationInterests = function() {
  return [Notifications.DISPLAY_STATE_CHANGE, Notifications.ACTIVE_STATE_CHANGE, Notifications.PLAY_STATE_CHANGE, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.MEDIUM_CHANGE, Notifications.DURATION_CHANGE, Notifications.TEMPORAL_TYPE_CHANGE, Notifications.IS_LIVE, Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.READY];
};

/** @override
*/
PlayerMediator.prototype.handleNotification = function(notification) {
  var body, name, previous, state, states, value;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.ACTIVE_STATE_CHANGE:
    case Notifications.PLAY_STATE_CHANGE:
    case Notifications.DISPLAY_STATE_CHANGE:
    case Notifications.MEDIUM_CHANGE:
      states = body;
      value = states.value;
      previous = states.previous;
      if ((previous != null) && this.classList.contains(previous)) {
        this.classList.remove(previous);
      }
      if (value != null) {
        this.classList.add(value);
      }
      break;
    case Notifications.ADD_APPLICATION_STATE:
      state = body;
      this.classList.add(state);
      break;
    case Notifications.REMOVE_APPLICATION_STATE:
      state = body;
      this.classList.remove(state);
      break;
    case Notifications.TEMPORAL_TYPE_CHANGE:
      if (body.previous) {
        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, body.previous);
      }
      if (body.value) {
        this.sendNotification(Notifications.ADD_APPLICATION_STATE, body.value);
      }
      break;
    case Notifications.IS_LIVE:
      if (body === true) {
        this.sendNotification(Notifications.ADD_APPLICATION_STATE, "is-live");
      } else {
        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, "is-live");
      }
      break;
    case Notifications.DURATION_CHANGE:
      if (body > 3600) {
        this.sendNotification(Notifications.ADD_APPLICATION_STATE, "long-form");
      } else {
        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, "long-form");
      }
      break;
    case Notifications.ADD_LAYER:
      this.addLayer(body);
      break;
    case Notifications.REMOVE_LAYER:
      this.removeLayer(body);
      break;
    case Notifications.READY:
      this.initialize();
      this.viewCreated();
  }
};

/**
*/
PlayerMediator.prototype.initialize = function() {
  var layer, _i, _len, _ref;
  this.ready = true;
  _ref = this.layers;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    layer = _ref[_i];
    if (!this.viewComponent.contains(layer)) {
      this.viewComponent.appendChild(layer);
    }
  }
};

PlayerMediator.prototype.viewCreated = function() {
  this.sendNotification(Notifications.VIEW_CREATED);
};

/**
*/
PlayerMediator.prototype.addLayer = function(layer) {
  this.layers.push(layer);
  if (this.ready) {
    this.viewComponent.appendChild(layer);
  }
};

/**
*/
PlayerMediator.prototype.removeLayer = function(layer) {
  var index;
  if (this.viewComponent.contains(layer)) {
    this.viewComponent.removeChild(layer);
  }
  index = this.layers.indexOf(layer);
  if (index >= 0) {
    this.layers.splice(index, 1);
  }
};

/** 
 * @param {Object} viewComponent
 * @constructor
 * @private 
 * @extends {PlayerMeditator}
*/
function FlashPlayerMediator(viewComponent) {
  FlashPlayerMediator.__super__.constructor.call(this, this.type, viewComponent);
}


__extends(FlashPlayerMediator, PlayerMediator);


/**
 * The name of the this Mediator.
 * 
 * @static
 * @type {String}
*/
FlashPlayerMediator.NAME = "FlashPlayerMediator";

FlashPlayerMediator.prototype.type = "flash";

/** @override
*/
FlashPlayerMediator.prototype.listNotificationInterests = function() {
  return FlashPlayerMediator.__super__.listNotificationInterests.call(this).concat([PluginNotifications.PLUGINS_INITIALIZED]);
};

/** @override
*/
FlashPlayerMediator.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.READY:
      this.viewCreated();
      return;
    case PluginNotifications.PLUGINS_INITIALIZED:
      this.initialize();
      return;
  }
  FlashPlayerMediator.__super__.handleNotification.call(this, notification);
};

/**
 * The RegisterPlaybackCoreCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function PlaybackTargetChangeCommand() {
  PlaybackTargetChangeCommand.__super__.constructor.call(this);
}


__extends(PlaybackTargetChangeCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
PlaybackTargetChangeCommand.prototype.execute = function(notification) {
  var note, target;
  target = notification.getBody().value;
  if (target === "amp") {
    note = Notifications.REMOVE_APPLICATION_STATE;
  } else {
    note = Notifications.ADD_APPLICATION_STATE;
  }
  this.sendNotification(note, "remote-playback");
  PlaybackTargetChangeCommand.__super__.execute.call(this, notification);
};

/**
 * The FlashAuthorizedCommand class.
 *
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function FlashAuthorizedCommand() {
  FlashAuthorizedCommand.__super__.constructor.call(this);
}


__extends(FlashAuthorizedCommand, PlayerEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
FlashAuthorizedCommand.prototype.execute = function(notification) {
  var media;
  FlashAuthorizedCommand.__super__.execute.call(this, notification);
  media = Utils.clone(this.media.getData());
  media.src = this.media.getSrc();
  this.facade.getMediaElement().authenticationComplete({
    media: media
  });
};

/**
 * PlaybackCoreProxy constructor.
 *
 * @constructor
 * @private
 * @extends {PlaybackProxy}
*/
function PlaybackCoreProxy(supportedTypes, config) {
  this.supportedTypes = supportedTypes != null ? supportedTypes : this.supportedTypes;
  this.config = config;
  PlaybackCoreProxy.__super__.constructor.call(this);
  this.temporalTypes = ["vod", "live", "ondemand"];
}


__extends(PlaybackCoreProxy, PlaybackProxy);


PlaybackCoreProxy.prototype.temporalTypes = null;

PlaybackCoreProxy.prototype.supportedTypes = null;

PlaybackCoreProxy.prototype.playbackCoreName = "default";

PlaybackCoreProxy.prototype.config = null;

/**
*/
PlaybackCoreProxy.prototype.onRegister = function() {
  this.mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);
};

/**
*/
PlaybackCoreProxy.prototype.getUseMAE = function() {
  var maeConfig;
  maeConfig = this.config.mae;
  return (maeConfig != null) && maeConfig.enabled !== false;
};

/**
*/
PlaybackCoreProxy.prototype.getPlaybackCoreName = function() {
  return this.playbackCoreName;
};

/**
*/
PlaybackCoreProxy.prototype.getSupportedTypes = function() {
  return this.supportedTypes || [];
};

/**
*/
PlaybackCoreProxy.prototype.setSupportedTypes = function(types) {
  this.supportedTypes = types;
  return types;
};

/**
*/
PlaybackCoreProxy.prototype.getTemporalTypes = function() {
  return this.temporalTypes || [];
};

/**
*/
PlaybackCoreProxy.prototype.setTemporalTypes = function(types) {
  this.temporalTypes = types;
  return types;
};

/** @override
*/
PlaybackCoreProxy.prototype.canPlayTemporalType = function(temporalType) {
  return this.getTemporalTypes().indexOf(temporalType) !== -1;
};

/** @override
*/
PlaybackCoreProxy.prototype.canPlayType = function(mimeType) {
  if (this.supportedTypes != null) {
    if (this.getSupportedTypes().indexOf(mimeType) !== -1) {
      return "maybe";
    } else {
      return "";
    }
  } else {
    return PlaybackCoreProxy.__super__.canPlayType.call(this, mimeType);
  }
};

/**
 * ChromeCastPlaybackProxy constructor.
 * 
 * @constructor
 * @extends {PlaybackCoreProxy}
 * @private
*/
function FlashPlaybackProxy(player) {
  this.player = player;
  FlashPlaybackProxy.__super__.constructor.call(this);
}


__extends(FlashPlaybackProxy, PlaybackCoreProxy);


/**
 * The name of the this Proxy.
 * 
 * @static
 * @type {string}
*/
FlashPlaybackProxy.NAME = PlaybackProxy.NAME;

FlashPlaybackProxy.prototype.player = null;

FlashPlaybackProxy.prototype.initialized = true;

FlashPlaybackProxy.prototype.playbackCoreName = "flash";

FlashPlaybackProxy.prototype.supportedTypes = ["video/mp4", "video/x-flv", "video/f4m", "application/smil", "application/smil+xml"];

/**     
 * Indicates whether or not the video is playing.
 * 
 * @returns {Boolean} 
 *    The playing value
 * @type {Boolean}
*/
FlashPlaybackProxy.prototype.getPaused = function() {
  return this.player.getPaused();
};

/**     
 * Indicates whether or not the video is playing.
 * 
 * @returns {Boolean} 
 *    The playing value
 * @type {Boolean}
*/
FlashPlaybackProxy.prototype.getEnded = function() {
  return this.player.getEnded();
};

/**     
 * Indicates whether or not the video is playing.
 * 
 * @returns {Boolean} 
 *    The playing value
 * @type {Boolean}
*/
FlashPlaybackProxy.prototype.getSeeking = function() {
  return this.player.getSeeking();
};

/**     
 * The current time of the video in seconds. Value must be between currentTime and duration.
 * 
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number} 
 *    The currentTime value in seconds
 * @type {Number}
*/
FlashPlaybackProxy.prototype.getCurrentTime = function() {
  return this.player.getCurrentTime();
};

FlashPlaybackProxy.prototype.setCurrentTime = function(value) {
  this.player.setCurrentTime(value);
  return value;
};

/**     
 * The current time of the video in seconds. Value must be between currentTime and duration.
 * 
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number} 
 *    The currentTime value in seconds
 * @type {Number}
*/
FlashPlaybackProxy.prototype.getSrc = function() {
  return this.player.getSrc();
};

FlashPlaybackProxy.prototype.setSrc = function(value) {
  this.player.setSrc(value);
  return value;
};

/**     
 * The current time of the video in seconds. Value must be between currentTime and duration.
 * 
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number} 
 *    The currentTime value in seconds
 * @type {Number}
*/
FlashPlaybackProxy.prototype.getVolume = function() {
  return this.player.getVolume();
};

FlashPlaybackProxy.prototype.setVolume = function(value) {
  this.player.setVolume(value);
  return value;
};

/**
*/
FlashPlaybackProxy.prototype.getMuted = function() {
  return this.player.getMuted();
};

FlashPlaybackProxy.prototype.setMuted = function(value) {
  this.player.setMuted(value);
  return value;
};

/**
 * The duration of the video in seconds.
 *     
 * @returns {Number} 
 *    The duration of the video
 * @type {Number}
*/
FlashPlaybackProxy.prototype.getDuration = function(value) {
  return this.player.getDuration();
};

/**
 * Instructs the core to play.
*/
FlashPlaybackProxy.prototype.play = function() {
  this.player.play();
};

/**
 * Instructs the core to pause.
*/
FlashPlaybackProxy.prototype.pause = function() {
  this.player.pause();
};

/**
 * Instructs the core to load.
*/
FlashPlaybackProxy.prototype.load = function() {
  this.player.load();
};

/**
 * The FlashPlayer class
 *
 * @param {Object} viewComponent
 * @constructor
 * @private
 * @extends {Player}
*/
function FlashPlayer(viewComponent) {
  var _this = this;
  this.flashObjectID += Date.now();
  this.plugins = {};
  this._displayState = DisplayState.NORMAL;
  this.debug = /debug\=true/.test(location.search);
  FlashPlayer.__super__.constructor.call(this, viewComponent);
  this.addEventListener("mediachange", function(event) {
    var item, mediaElement, textTracks, track, tracks, _i, _len;
    tracks = event.detail.track;
    mediaElement = _this.getMediaElement();
    textTracks = mediaElement.textTracks = [];
    if (!(tracks != null)) {
      return;
    }
    for (_i = 0, _len = tracks.length; _i < _len; _i++) {
      track = tracks[_i];
      item = {
        kind: track.kind,
        label: track.label,
        language: track.srclang,
        _mode: track.mode
      };
      Object.defineProperty(item, "mode", {
        get: function() {
          return this._mode;
        },
        set: function(value) {
          var visible;
          this._mode = value;
          visible = value === "showing";
          if (visible) {
            mediaElement.setTrackByLanguage(this.language);
          }
          mediaElement.setPlayerProperty("captionDisplay", {
            visible: visible
          });
        },
        enumerable: true,
        configurable: false
      });
      textTracks.push(item);
    }
  });
}


__extends(FlashPlayer, Player);


/**
 * @override
*/
FlashPlayer.prototype.initialize = function(config, parentModule) {
  var _ref, _ref1;
  this.config = config;
  this.parentModule = parentModule;
  this.createDefaults();
  this.logEvents = ((_ref = this.config.flash) != null ? _ref.logEvents : void 0) === true || ((_ref1 = QueryString["amp-flash-log"]) != null ? _ref1.toLowerCase() : void 0) === "true";
  FlashPlayer.__super__.initialize.call(this, this.config, this.parentModule);
};

/**
*/
FlashPlayer.prototype.loadModuleResources = function(resources) {
  var _this = this;
  return FlashPlayer.__super__.loadModuleResources.call(this, resources).then(function() {
    var key, locales, promises, update, value;
    locales = _this.config.locales;
    promises = [];
    update = function(key, resource) {
      locales[key] = resource.data;
    };
    for (key in locales) {
      value = locales[key];
      if (typeof value === "string") {
        promises.push(AMP.addResource({
          src: _this.evaluatePaths(value),
          type: Utils.mimeTypes.json
        }).then(update.bind(_this, key))["catch"](function(error) {
          return Promise.resolve();
        }));
      }
    }
    return Promise.all(promises);
  });
};

/** @override
*/
FlashPlayer.prototype.pluginsinitialized = function() {
  var attributes, expressInstallSWF, flash, params, swf, swfs, version, xml, _ref;
  flash = this.config.flash || {};
  swfs = ((_ref = flash["static"]) != null ? _ref.enabled : void 0) === true ? flash["static"] : flash;
  swf = this.debug && (swfs.debug != null) ? swfs.debug : swfs.swf || "amp.swf";
  version = flash.version || "10.1";
  expressInstallSWF = this.evaluatePaths(flash.expressInstallSWF) || "playerProductInstall.swf";
  params = this.createParams(flash);
  attributes = this.createAttributes(flash);
  this.flashvars = this.createFlashVars(flash);
  if (!(this.flashvars.settings_url != null)) {
    xml = this.createXML(this.config);
    if (xml != null) {
      this.flashvars.settings_xml = xml;
    }
  }
  attributes.data = this.evaluatePaths(swf);
  this.createdHandler(Utils.createFlashObject({
    params: params,
    attributes: attributes,
    vars: this.flashvars
  }, this.getMediaElement().parentNode));
};

FlashPlayer.prototype.playerType = "flash";

FlashPlayer.prototype.flashObjectID = "flashObject";

FlashPlayer.prototype.loaded = false;

FlashPlayer.prototype.flashvars = null;

FlashPlayer.prototype._paused = false;

FlashPlayer.prototype._ended = false;

FlashPlayer.prototype._muted = false;

FlashPlayer.prototype.plugins = null;

FlashPlayer.prototype.debug = false;

FlashPlayer.prototype.started = false;

FlashPlayer.prototype._displayState = null;

FlashPlayer.prototype.logEvents = false;

FlashPlayer.prototype._loop = false;

FlashPlayer.prototype.playback = null;

FlashPlayer.prototype.flashPlugins = [
  {
    id: "AkamaiAdvancedStreamingPlugin",
    src: "http://players.edgesuite.net/flash/plugins/osmf/advanced-streaming-plugin/v3.10/osmf2.0/AkamaiAdvancedStreamingPlugin.swf",
    absolute: true,
    host: "osmf",
    main: "com.akamai.osmf.AkamaiAdvancedStreamingPluginInfo",
    type: "application/x-shockwave-flash"
  }, {
    id: "ErrorMessagingPlugin",
    src: '#{paths.resources}plugins/ErrorMessagingPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "ErrorMessagingPlugin",
    type: "application/x-shockwave-flash"
  }, {
    id: "VideoMetricsViewPlugin",
    src: '#{paths.resources}plugins/VideoMetricsViewPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "VideoMetricsViewPlugin",
    type: "application/x-shockwave-flash"
  }, {
    id: "VideoStatsInfoOverlayPlugin",
    src: '#{paths.resources}plugins/VideoStatsInfoOverlayPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "VideoStatsInfoOverlayPlugin",
    type: "application/x-shockwave-flash"
  }
];

FlashPlayer.prototype.flashView = null;

/** @override
*/
FlashPlayer.prototype.createModel = function() {
  FlashPlayer.__super__.createModel.call(this);
  this.playback = new FlashPlaybackProxy(this);
  this.registerProxy(this.playback);
  this.appState.setRenderMode(RenderMode.FLASH);
  this.bindings.initialize();
};

/** @override
*/
FlashPlayer.prototype.createView = function() {
  FlashPlayer.__super__.createView.call(this);
  this.mediator = new FlashPlayerMediator(this.getViewComponent());
  this.registerMediator(this.mediator);
  this.registerMediator(new VideoLayerMediator());
  this.registerMediator(new OverlayLayerMediator());
  this.registerMediator(new LocalizationWrapper(this, this.config));
};

/** @override
*/
FlashPlayer.prototype.createController = function() {
  var _ref,
    _this = this;
  FlashPlayer.__super__.createController.call(this);
  if (((_ref = this.config.plugins) != null ? _ref.react : void 0) != null) {
    this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);
    this.getDisplayState = function() {
      return _this.appState.getDisplayState();
    };
    this.setDisplayState = function(value) {
      return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);
    };
  }
  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, FlashPluginsInitializedCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);
  this.registerCommand(SecurityNotifications.AUTHORIZED, FlashAuthorizedCommand);
  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);
  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);
  this.registerCommand(Notifications.START, FlashStartCommand);
  this.registerCommand(Notifications.STARTED, PlayerEventCommand);
  this.registerCommand(Notifications.PLAY, PlayerEventCommand);
  this.registerCommand(Notifications.PLAY_REQUEST, PlayerEventCommand);
  this.registerCommand(FlashNotifications.FLASH_CREATED, PlayerEventCommand);
  this.registerCommand(Notifications.CHANGE_PLAYBACK_TARGET, ChangePlaybackTargetCommand);
  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);
  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);
  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);
  this.registerCommand(FlashNotifications.CREATE_XML, PlayerEventCommand);
  this.registerCommand(FlashNotifications.CREATE_FLASH_VARS, PlayerEventCommand);
};

/** @override
*/
FlashPlayer.prototype.createMediaElement = function() {
  var video, viewComponent;
  video = new MediaElementMediator("flash", "div");
  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, video);
  viewComponent = video.getViewComponent();
  viewComponent.id = viewComponent.name = this.flashObjectID;
  return viewComponent;
};

/**
*/
FlashPlayer.prototype.createDefaults = function() {
  var plugin, resources, swf, _i, _len, _ref, _ref1, _ref2;
  if (!((_ref = this.flashPlugins) != null ? _ref.length : void 0) > 0) {
    return;
  }
  resources = this.config.resources || [];
  if (((_ref1 = this.config.flash) != null ? _ref1.resources : void 0) != null) {
    resources = resources.concat(this.config.flash.resources);
  }
  swf = Utils.mimeTypes.swf;
  _ref2 = this.flashPlugins;
  for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
    plugin = _ref2[_i];
    if ((plugin != null) && resources.filter(function(resource) {
      return resource.id === plugin.id;
    }).length === 0) {
      if (plugin.type == null) {
        plugin.type = swf;
      }
      resources.push(plugin);
    }
  }
  this.config.resources = resources;
};

/**
*/
FlashPlayer.prototype.createParams = function(flash) {
  var params;
  params = {
    allowFullScreen: true,
    allowScriptAccess: "always",
    wmode: "direct",
    bgColor: "#000000"
  };
  if (flash.params != null) {
    if (flash.params.allowFullScreen != null) {
      params.allowFullScreen = flash.params.allowFullScreen;
    }
    if (flash.params.allowScriptAccess != null) {
      params.allowScriptAccess = flash.params.allowScriptAccess;
    }
    if (flash.params.wmode != null) {
      params.wmode = flash.params.wmode;
    }
    if (flash.params.bgColor != null) {
      params.bgColor = flash.params.bgColor;
    }
  }
  if (params.wmode === "direct" && /MSIE/.test(navigator.userAgent)) {
    params.wmode = "transparent";
  }
  return params;
};

/** @override
*/
FlashPlayer.prototype.getModules = function() {
  return this.plugins;
};

/** @override
*/
FlashPlayer.prototype.createPlugins = function() {
  var def, feature, init, key, plugin, plugins, promises, register, type, _ref,
    _this = this;
  type = this.getPlayerType();
  _ref = AMP.plugins;
  for (key in _ref) {
    register = _ref[key];
    if (!((key in this.config) && (this.config[key] != null) && !(this.config[key].enabled === false))) {
      continue;
    }
    def = register[type];
    if (!(def != null)) {
      this.logger.debug("[AMP] Plugin could not be found: " + key);
      continue;
    }
    try {
      plugin = this[key] = this.plugins[key] = new def(this, this.config[key]);
      this.registerMediator(this.plugins[key]);
      feature = typeof plugin.getFeatureName === "function" ? plugin.getFeatureName() : void 0;
      if (feature != null) {
        this[feature] = plugin;
      }
      if (plugin.flashView != null) {
        this.flashView = Utils.override(this.flashView, plugin.flashView);
      }
      this.logger.debug("[AMP] Plugin registered: " + key);
    } catch (error) {
      this.logger.error("[AMP] Plugin could not be created: " + key + ". " + error);
      continue;
    }
  }
  plugins = this.config.plugins || {};
  promises = [];
  for (key in plugins) {
    init = plugins[key];
    if (!((init != null) && init.enabled !== false)) {
      continue;
    }
    plugin = function(player, config, key) {
      return _this.loadResources(config.resources).then(function() {
        def = AMP.plugins[key][type];
        if (!(def != null)) {
          throw new Error("[AMP] Plugin could not be found: " + key);
        }
        return def(player, config, key).then(function(result) {
          _this.logger.debug("[AMP] Plugin registered: " + key);
          return {
            key: key,
            value: result
          };
        });
      })["catch"](function(error) {
        return _this.logger.error("[AMP] Plugin could not be created: " + key + ". " + error);
      });
    };
    promises.push(plugin.bind(null, this, init, key));
  }
  promises = promises.map(function(item) {
    return item();
  });
  Promise.all(promises).then(function(plugins) {
    var plugin, _i, _len;
    if (_this.config.flash.view != null) {
      _this.flashView = Utils.override(_this.flashView, _this.config.flash.view);
    }
    for (_i = 0, _len = plugins.length; _i < _len; _i++) {
      plugin = plugins[_i];
      if (!(plugin != null)) {
        continue;
      }
      _this[plugin.key] = plugin.value;
      _this.plugins[plugin.key] = plugin.value;
    }
    return _this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, _this.plugins);
  })["catch"](function(error) {
    return _this.logger.error(error);
  });
};

/**
*/
FlashPlayer.prototype.createAttributes = function(flash) {
  var attributes;
  attributes = {
    id: this.flashObjectID,
    name: this.flashObjectID
  };
  if (flash.attributes != null) {
    if (flash.attributes.id != null) {
      attributes.id = flash.attributes.id;
    }
    if (flash.attributes.name != null) {
      attributes.name = flash.attributes.name;
    }
  }
  return attributes;
};

/**
*/
FlashPlayer.prototype.createFlashJSON = function(config, spacer) {
  var prepJSON, prepValue;
  if (config == null) {
    config = this.config;
  }
  config = JSON.stringify(config);
  config = this.evaluatePaths(config);
  config = JSON.parse(config);
  prepValue = function(config, key, value) {
    switch (typeof value) {
      case "string":
        config[key] = escape(value);
        break;
      case "object":
        prepJSON(value);
    }
  };
  prepJSON = function(config) {
    var key, value, _i, _len;
    if (config instanceof Array) {
      for (key = _i = 0, _len = config.length; _i < _len; key = ++_i) {
        value = config[key];
        prepValue(config, key, value);
      }
    } else if (typeof config === "object") {
      for (key in config) {
        value = config[key];
        prepValue(config, key, value);
      }
    }
  };
  prepJSON(config);
  return encodeURIComponent(JSON.stringify(config, null, spacer));
};

/**
*/
FlashPlayer.prototype.createFlashVars = function(flash) {
  var flashvars, loadingViewString, prop, settings, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
  flashvars = {};
  settings = JSON.parse(JSON.stringify(this.config));
  settings.flash = null;
  delete settings.flash;
  settings.locales = null;
  delete settings.locales;
  settings.params = null;
  delete settings.params;
  settings.rules = null;
  delete settings.rules;
  flashvars.settings_json = this.createFlashJSON(settings);
  if (this.config.autoplay != null) {
    flashvars.auto_play = this.config.autoplay;
  }
  if ((this.config.rules != null)) {
    Utils.mergeRules(this.config.rules);
  }
  flashvars.hinting_rules = escape(JSON.stringify(Utils.rules));
  if (this.config.volume != null) {
    flashvars.volume = Utils.clamp(this.config.volume, 0, 1);
  }
  if ((this.config.target != null)) {
    flashvars.external_target = this.config.target;
  }
  if ((this.config.name != null)) {
    flashvars.core_player_name = this.config.name;
  }
  if ((this.config.domain != null)) {
    flashvars.embed_domain = flashvars.domain = this.config.domain;
  }
  this._loop = flashvars.auto_replay = this.config.loop === true;
  if (this.config.fullscreen != null) {
    flashvars.fullscreen_enabled = this.config.fullscreen.enabled !== false && this.config.fullscreen.mode !== FullscreenMode.EXTERNAL;
  }
  if (this.config.titlebar != null) {
    flashvars.titlebar_enabled = this.config.titlebar.enabled !== false;
  }
  if (this.config.params != null) {
    flashvars.params = escape(JSON.stringify(this.config.params));
  }
  if (this.config.version != null) {
    flashvars.context_menu_label = this.config.version;
  }
  if (((_ref = this.config.controls) != null ? _ref.displaySceneMarkers : void 0) != null) {
    flashvars.displaySceneMarkers = this.config.controls.displaySceneMarkers;
  }
  if (this.config.media != null) {
    this.mediaProxy.setData(this.config.media);
    if (this.config.media.src != null) {
      this.setSrc(this.config.media.src);
      flashvars.video_url = escape(this.config.media.src);
    }
    if ((this.config.media.source != null) && this.config.media.source.length > 0) {
      this.setSource(this.config.media.source);
      flashvars.video_url = escape(this.mediaProxy.getSrc());
    }
    if (this.config.media.medium != null) {
      this.setMedium(this.config.media.medium);
      flashvars.medium = this.config.media.medium;
    }
    if (this.config.media.title != null) {
      flashvars.title = encodeURIComponent(this.config.media.title);
    }
    if (this.config.media.poster != null) {
      flashvars.poster = escape(this.config.media.poster);
    }
    if (this.config.media.temporalType != null) {
      flashvars.temporalType = this.config.media.temporalType;
    }
  }
  if (this.getMedium() === "audio") {
    flashvars.controls = true;
    flashvars.auto_hide = -1;
  }
  if (((_ref1 = this.config.ima) != null ? (_ref2 = _ref1.overlay) != null ? _ref2.delay : void 0 : void 0) != null) {
    flashvars.overlay_ad_delay = this.config.ima.overlay.delay;
  }
  if ((this.config.ticker != null) && this.config.ticker.enabled !== false) {
    if (this.config.ticker.url != null) {
      flashvars.ticker_text_url = this.config.ticker.url;
    }
    if (this.config.ticker.interval != null) {
      flashvars.ticker_polling_interval = this.config.ticker.interval;
    }
    if (this.config.ticker.speed != null) {
      flashvars.ticker_speed = this.config.ticker.speed;
    }
  }
  flashvars.show_play_button_overlay = false;
  flashvars.auto_play_list = false;
  flashvars.next_video_timer = 0;
  if (flashvars.context_menu_mode == null) {
    flashvars.context_menu_mode = this.debug === true ? "long" : "short";
  }
  if (((_ref3 = this.config.flash) != null ? (_ref4 = _ref3.view) != null ? (_ref5 = _ref4.elements) != null ? (_ref6 = _ref5.loadingView) != null ? _ref6.attributes : void 0 : void 0 : void 0 : void 0) != null) {
    loadingViewString = "";
    for (prop in this.config.flash.view.elements.loadingView.attributes) {
      loadingViewString += prop + ":" + this.config.flash.view.elements.loadingView.attributes[prop] + " ";
    }
    flashvars.loadingView = loadingViewString;
  }
  this.sendNotification(FlashNotifications.CREATE_FLASH_VARS, {
    flashvars: flashvars,
    config: this.config
  });
  flashvars = Utils.override(flashvars, flash.vars);
  return flashvars;
};

/**
*/
FlashPlayer.prototype.createXML = function(config) {
  var app, element, elements, isStatic, key, mode, node, parent, parseResources, parseView, plugin, plugins, str, swf, value, viewXML, xml, _i, _j, _len, _len1, _ref, _ref1, _ref2;
  if (!((config != null ? (_ref = config.flash) != null ? _ref.xml : void 0 : void 0) != null)) {
    if (config.flash == null) {
      config.flash = {};
    }
    config.flash.xml = "<application></application>";
  }
  xml = XMLUtils.parse(config.flash.xml);
  if (xml.childNodes.length > 1) {
    xml.removeChild(xml.firstChild);
  }
  this.sendNotification(FlashNotifications.CREATE_XML, {
    config: config,
    xml: xml
  });
  parseResources = function(config) {
    var key, plugins, resource, resources, value, _i, _len, _ref1;
    resources = config.resources;
    plugins = [];
    if ((resources instanceof Array) && ((resources != null ? resources.length : void 0) > 0)) {
      for (_i = 0, _len = resources.length; _i < _len; _i++) {
        resource = resources[_i];
        if (!(resource.type === swf)) {
          continue;
        }
        resource = Utils.clone(resource);
        if (isStatic === true) {
          if ((resource.main != null) && resource.main !== "") {
            resource.src = resource.main;
            resource.type = "static";
          } else {
            resource.type = "dynamic";
          }
        } else {
          if ((resource.src != null) && resource.src !== "") {
            resource.type = "dynamic";
          } else {
            resource.src = resource.main;
            resource.type = "static";
          }
        }
        delete resource.main;
        plugins.push(resource);
      }
    }
    for (key in config) {
      value = config[key];
      if (key !== "flash" && ((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {
        plugins = plugins.concat(parseResources(value));
      }
    }
    _ref1 = config.plugins;
    for (key in _ref1) {
      value = _ref1[key];
      if (((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {
        plugins = plugins.concat(parseResources(value));
      }
    }
    return plugins;
  };
  swf = Utils.mimeTypes.swf;
  plugins = parseResources(this.config);
  isStatic = ((_ref1 = config.flash["static"]) != null ? _ref1.enabled : void 0) === true;
  if ((plugins != null ? plugins.length : void 0) > 0) {
    parent = xml.getElementsByTagName("plugins");
    if (parent.length < 1) {
      parent = xml.createElement("plugins");
      xml.firstChild.appendChild(parent);
    } else {
      parent = parent[0];
    }
    for (_i = 0, _len = plugins.length; _i < _len; _i++) {
      plugin = plugins[_i];
      if (!(plugin.enabled !== false)) {
        continue;
      }
      node = xml.createElement("plugin");
      for (key in plugin) {
        value = plugin[key];
        if (key !== "loaded") {
          if (key !== "src") {
            node.setAttribute(key, "" + value);
          } else {
            if (key === "id" && value === "AkamaiAdvancedStreamingPlugin" && this.debug === true) {
              value = value.replace("AkamaiAdvancedStreamingPlugin.swf", "AkamaiAdvancedStreamingPlugin-logging.swf");
            }
            node.appendChild(XMLUtils.createTextContent(xml, value));
          }
        }
      }
      parent.appendChild(node);
    }
  }
  parseView = function(view, node) {
    var element, key, value, _ref2, _ref3, _ref4;
    if (view.attributes != null) {
      _ref2 = view.attributes;
      for (key in _ref2) {
        value = _ref2[key];
        node.setAttribute(key, "" + value);
      }
    }
    if (view.elements != null) {
      _ref3 = view.elements;
      for (key in _ref3) {
        value = _ref3[key];
        if (!(value != null)) {
          continue;
        }
        element = xml.createElement("element");
        element.setAttribute("id", key);
        if (element.id === "state") {
          continue;
        }
        parseView(value, element);
        node.appendChild(element);
      }
    }
    if (view.state != null) {
      element = xml.createElement("state");
      if (view.state.attributes) {
        _ref4 = view.state.attributes;
        for (key in _ref4) {
          value = _ref4[key];
          if (value != null) {
            element.setAttribute(key, "" + value);
          }
        }
      }
      node.appendChild(element);
    }
    return node;
  };
  viewXML = xml.getElementsByTagName("view")[0];
  if (!(viewXML != null)) {
    viewXML = xml.createElement("view");
    xml.firstChild.appendChild(viewXML);
  }
  parseView(this.flashView, viewXML);
  mode = (_ref2 = this.config.fullscreen) != null ? _ref2.mode : void 0;
  if (mode != null) {
    elements = xml.getElementsByTagName("element");
    for (_j = 0, _len1 = elements.length; _j < _len1; _j++) {
      element = elements[_j];
      if (element.getAttribute("id") === "fullscreenBtn") {
        element.setAttribute("action", "external");
      }
    }
  }
  str = XMLUtils.serialize(xml);
  app = str.match(/<application>[\w\W\s\S\d\D]*<\/application>/)[0] || str;
  app = app.replace(/[\n\r\t]/g, "");
  app = this.evaluatePaths(app);
  return encodeURIComponent(app);
};

/**
*/
FlashPlayer.prototype.createdHandler = function(obj) {
  var id, mediaElement,
    _this = this;
  id = this.getMediaElement().id;
  mediaElement = document.getElementById(id);
  this.setMediaElement(mediaElement);
  mediaElement.className = Namespace.PREFIX + MediaElementMediator.prototype.componentType;
  mediaElement.eventHandler = function(eventName, body) {
    return _this.eventHandler(eventName, body);
  };
  this.sendNotification(FlashNotifications.FLASH_CREATED);
  if (this.getMedium() != null) {
    this.setMedium(this.getMedium());
  }
};

/**
*/
FlashPlayer.prototype.eventHandler = function(eventName, body) {
  var error, event, helper, media, state, type, update, _ref, _ref1, _ref2, _ref3,
    _this = this;
  if (this.logEvents && !this.excludedFlashEvents.test(eventName)) {
    this.logger.log("[AMP FLASH EVENT] " + eventName, body);
  }
  try {
    switch (eventName) {
      case FlashNotifications.INITIALIZED:
        type = state = "ready";
        break;
      case FlashNotifications.RESET:
        if (!(body != null)) {
          state = "ready";
        }
        this.started = false;
        break;
      case FlashNotifications.LOADING:
        type = "loadstart";
        break;
      case FlashNotifications.PLAYER_ERROR:
        type = state = "error";
        break;
      case FlashNotifications.MEDIA_ERROR:
        type = state = "error";
        break;
      case FlashNotifications.FEED_LOADED:
        body = JSON.parse(body);
        helper = new MRSSHelper();
        media = (_ref = helper.createFeed(body)) != null ? (_ref1 = _ref.item) != null ? _ref1[0] : void 0 : void 0;
        if (media != null) {
          this.mediaProxy.setData(media);
        }
        break;
      case FlashNotifications.FEED_UPDATED:
        type = "mediachange";
        body = this.getMedia();
        update = true;
        break;
      case FlashNotifications.ERROR_STREAM_NOT_FOUND:
        type = state = "error";
        break;
      case FlashNotifications.CAPABILITY_CHANGE:
        event = body.type;
        if (event === "canPlayChange" && body.enabled === true) {
          type = "canplay";
          this.loaded = true;
        } else if (event === "canSeekChange" && body.enabled === true) {
          type = "canplaythrough";
        } else if (event === "temporalChange" && body.enabled === true) {
          type = "loadedmetadata";
          if (!this.started) {
            this.sendNotification(Notifications.START, body);
          }
        }
        break;
      case FlashNotifications.PLAYING:
        if (!this.started) {
          this.sendNotification(Notifications.START, body);
        }
        type = state = "playing";
        this._ended = false;
        this._paused = false;
        if (this.appState.getSeeking() === true) {
          this.appState.setSeeking(false);
          this.sendNotification(Notifications.SEEKED);
          this.sendNotification(Notifications.DISPATCH_EVENT, new Event("seeked"));
        }
        break;
      case FlashNotifications.ELEMENT_EVENT:
        if (body.element === "fullscreenBtn" && body.type === "click" && ((_ref2 = this.config) != null ? (_ref3 = _ref2.fullscreen) != null ? _ref3.mode : void 0 : void 0) === FullscreenMode.EXTERNAL) {
          state = this.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;
          this.setDisplayState(state);
        }
        break;
      case FlashNotifications.PLAY_REQUEST:
        this.sendNotification(Notifications.PLAY_REQUEST);
        this.setPlayState("playing");
        type = Notifications.MEDIA_SEQUENCE_STARTED;
        this.loaded = true;
        this._ended = false;
        break;
      case FlashNotifications.PLAY:
        if (this.getPlayState() !== "paused" && this.started) {
          this.sendNotification(Notifications.PLAY, body);
        }
        break;
      case FlashNotifications.ENDED:
        type = Notifications.ENDED;
        break;
      case FlashNotifications.MEDIA_SEQUENCE_ENDED:
        type = Notifications.MEDIA_SEQUENCE_ENDED;
        state = Notifications.ENDED;
        this._ended = true;
        break;
      case FlashNotifications.PAUSED:
        type = "pause";
        state = "paused";
        this._paused = true;
        break;
      case FlashNotifications.BUFFERING:
        if (this.className !== "ended") {
          type = state = "waiting";
        }
        break;
      case FlashNotifications.BUFFERING_CHANGE:
        this.sendNotification(Notifications.BUFFERING_CHANGE, body);
        return;
      case FlashNotifications.DURATION_CHANGE:
        if (!isNaN(body.time)) {
          if (body.time === 0) {
            this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);
          }
          type = "durationchange";
          body = body.time;
          setTimeout(function() {
            _this.setCues(_this.getCues().slice());
          }, 0);
        }
        break;
      case FlashNotifications.VOLUME_CHANGE:
        type = "volumechange";
        body = body.volume;
        break;
      case FlashNotifications.TIME_UPDATE:
        type = "timeupdate";
        body = body.currentTime;
        break;
      case FlashNotifications.SEEKING_CHANGE:
        if (this.appState.getSeeking() === false && body.seeking === false) {
          return;
        }
        type = body.seeking ? "seeking" : "seeked";
        this.appState.setSeeking(body.seeking);
        if (body.seeking) {
          state = "seeking";
        }
        break;
      case FlashNotifications.FULLSCREEN_CHANGE:
        type = "fullscreenchange";
        body = body.displayState === "fullScreen";
        this.applyDisplayState(body ? DisplayState.FULL_SCREEN : DisplayState.NORMAL);
        break;
      case FlashNotifications.FAIL_OVER_ATTEMPT:
        type = "failoverattempt";
        body = body;
        break;
      case FlashNotifications.ERROR:
        eventName = null;
        break;
      case FlashNotifications.AUTHORIZE:
        type = SecurityNotifications.AUTHORIZE;
        break;
      case FlashNotifications.TIMED_METADATA:
        type = Notifications.TIMED_METADATA;
        body = {
          startTime: body.time,
          endTime: body.time,
          data: body
        };
        break;
      case FlashNotifications.MEDIA_PLAYER_ID3_UPDATED:
        type = Notifications.TIMED_METADATA;
        body = {
          startTime: body.time,
          endTime: body.time,
          data: window.atob(body)
        };
    }
    if ((eventName != null) && eventName !== type) {
      event = new Event(eventName, body);
      event.dispatcher = "FLASH";
      this.sendNotification(Notifications.DISPATCH_EVENT, event);
      this.sendNotification(eventName, body);
    }
    if (type != null) {
      if (type === "error") {
        error = body.error || body;
        this.logError("Flash Error", error);
      }
      this.sendNotification(type, body);
      this.sendNotification(Notifications.DISPATCH_EVENT, new Event(type, body));
    }
    if (update != null) {
      this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);
    }
    if (state != null) {
      this.setPlayState(state);
    }
  } catch (error) {
    this.logError("Event Error: " + eventName, error);
  }
};

FlashPlayer.prototype.logError = function(msg, error) {
  this.logger.error("[AMP FLASH ERROR]", msg, error);
};

/**
*/
FlashPlayer.prototype.excludedFlashEvents = /(mediaPlayerPlayheadUpdate|mediaPlayerElementEvent|adComponentPlaybackProgress)/;

FlashPlayer.prototype.logFlashEvents = false;

FlashPlayer.prototype.logEvent = function(event) {
  if ((event.dispatcher === "FLASH" && this.logFlashEvents === false) || this.excludedFlashEvents.test(event.type) === true) {
    return;
  }
  FlashPlayer.__super__.logEvent.call(this, event);
};

/**
 * Sets the player's play state and adds CSS class to player div
*/
FlashPlayer.prototype.setPlayState = function(state) {
  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);
  return state;
};

FlashPlayer.prototype.getPlayState = function() {
  return this.appState.getPlayState();
};

/**
 * Initializes the player to a given set of parameters
*/
FlashPlayer.prototype.setMedia = function(value) {
  var _this = this;
  if (this.getPlayState() != null) {
    this.setPlayState("ready");
  }
  this.mediaProxy.transform(value).then(function(result) {
    value = result;
    _this.mediaProxy.setData(value);
    if (value.src != null) {
      _this.setSrc(value.src);
    }
    if ((value.source != null) && value.source.length > 0) {
      _this.setSource(value.source);
    }
    _this.sendNotification(Notifications.MEDIA_CHANGE, value);
    return _this.load(_this.mediaProxy.getData());
  })["catch"](function(error) {
    return _this.sendNotification(Notifications.ERROR, error);
  });
  return value;
};

/**
*/
FlashPlayer.prototype.getMedia = function() {
  return this.mediaProxy.getData();
};

/**
 * Loads the video.
 *
*/
FlashPlayer.prototype.load = function() {
  var data, key, media, value;
  media = this.mediaProxy.getData();
  this.security.setMedia(media);
  if (this.security.getAuthorized()) {
    this.loaded = true;
    data = Utils.clone(media);
    if (data.autoplay == null) {
      data.autoplay = this.config.autoplay;
    }
    for (key in data) {
      value = data[key];
      if (value === void 0) {
        delete data[key];
      }
    }
    this.getMediaElement().loadURL(this.mediaProxy.getSrc(), data);
  } else {
    this.sendNotification(SecurityNotifications.AUTHORIZE, {
      media: media
    });
  }
};

/**
 * Plays the currently loaded video.
 *
*/
FlashPlayer.prototype.play = function() {
  if (!this.loaded) {
    this.load();
  }
  this.getMediaElement().unpause();
};

/**
*/
FlashPlayer.prototype.setMuted = function(value) {
  this._muted = value;
  try {
    if (value === true) {
      this.getMediaElement().mute();
    } else {
      this.getMediaElement().unmute();
    }
  } catch (error) {
    this.logError("Flash muted error", error);
  }
  return value;
};

/**
*/
FlashPlayer.prototype.getMuted = function() {
  return this._muted;
};

/**
*/
FlashPlayer.prototype.getLoop = function() {
  return this._loop;
};

/**
 * The source url of video.
 *
 * @param {String} value The source url of the video to play.
*/
FlashPlayer.prototype.getSrc = function(value) {
  return this.getMediaElement().getURL();
};

FlashPlayer.prototype.setSrc = function(value) {
  this.mediaProxy.setSrc(value);
  this.loaded = false;
  this.setMedium(Utils.getMimeType(value));
  return value;
};

/**
*/
FlashPlayer.prototype.setAutoplay = function(value) {
  this.getMediaElement().setPlayerProperty("autoplay", value);
  return value;
};

FlashPlayer.prototype.getAutoplay = function() {
  return this.getMediaElement().getPlayerProperty("autoplay");
};

/**
 * The url to the video.
 *
 * @param {String} value
 *    The new title of the video
 * @returns {Boolean}
 *    The title of the video
 * @type {String}
*/
FlashPlayer.prototype.getMedium = function() {
  return this.mediaProxy.getData().medium;
};

FlashPlayer.prototype.setMedium = function(value) {
  var media, previous;
  media = this.mediaProxy.getData();
  if (value === media.medium) {
    return;
  }
  if (media.medium != null) {
    previous = "medium-" + media.medium;
  }
  media.medium = /audio/.test(value) ? "audio" : "video";
  this.sendNotification(Notifications.MEDIUM_CHANGE, {
    value: "medium-" + media.medium,
    previous: previous
  });
  return value;
};

/**
 * Sets the source url of video.
 *
 * @param {String} value The source url of the video to play.
*/
FlashPlayer.prototype.setSource = function(value) {
  var item, media,
    _this = this;
  if (!(value != null) || value.length < 1) {
    return;
  }
  media = this.mediaProxy.getData();
  media.source = value;
  this.loaded = false;
  item = Utils.selectSource(value, function(type) {
    return _this.canPlayType(type);
  });
  if (((item != null ? item.src : void 0) != null) && item.src !== "") {
    this.setSrc(item.src);
    if (typeof type !== "undefined" && type !== null) {
      this.setMedium(type);
    }
  } else {
    throw new Error("No valid source could be found");
  }
  return value;
};

/**
 * Gets the source url of video.
 *
 * @return {Number} The source url of the video.
*/
FlashPlayer.prototype.getSource = function() {
  return this.mediaProxy.getData().source;
};

/**
 * Gets the source url of video.
 *
 * @return {Number} The source url of the video.
*/
FlashPlayer.prototype.getSeeking = function() {
  return this.appState.getSeeking();
};

/**
 * Gets the source url of video.
 *
 * @return {Number} The source url of the video.
*/
FlashPlayer.prototype.getPaused = function() {
  return this._paused;
};

/**
 * Gets the source url of video.
 *
 * @return {Number} The source url of the video.
*/
FlashPlayer.prototype.getEnded = function() {
  return this._ended;
};

/**
*/
FlashPlayer.prototype.getFlashXML = function() {
  var doc, xml;
  xml = decodeURIComponent(this.flashvars.settings_xml);
  doc = XMLUtils.parse(xml);
  try {
    doc.toString = function() {
      return xml;
    };
  } catch (error) {

  }
  return doc;
};

/**
*/
FlashPlayer.prototype.getFlashVars = function() {
  return this.flashvars;
};

/**
*/
FlashPlayer.prototype.getFlashJSON = function() {
  return JSON.parse(decodeURIComponent(this.flashvars.settings_json));
};

FlashPlayer.prototype.evaluateBinding = function(str) {
  var value;
  try {
    value = this.getMediaElement().evaluateBinding(str);
    if (value != null) {
      value = JSON.parse(value);
    }
  } catch (error) {

  }
  return value;
};

FlashPlayer.prototype.canPlayType = function(mimeType) {
  if (__indexOf.call(Utils.flashTypes, mimeType) >= 0) {
    return "maybe";
  } else {
    return "";
  }
};

FlashPlayer.prototype.replay = function() {
  this.getMediaElement().replay();
};

FlashPlayer.prototype.pause = function() {
  this.getMediaElement().pause();
};

FlashPlayer.prototype.end = function() {
  this.getMediaElement().stopPlayer();
};

FlashPlayer.prototype.getCurrentTime = function() {
  var _base;
  return typeof (_base = this.getMediaElement()).getCurrentTime === "function" ? _base.getCurrentTime() : void 0;
};

FlashPlayer.prototype.setCurrentTime = function(value) {
  this.getMediaElement().jumpToTime(value);
  return value;
};

FlashPlayer.prototype.getParams = function() {
  return this.getMediaElement().getParams();
};

FlashPlayer.prototype.setParams = function(value) {
  this.getMediaElement().setParams(value);
  return value;
};

FlashPlayer.prototype.getVolume = function() {
  var _ref;
  return ((_ref = this.getMediaElement()) != null ? typeof _ref.getVolume === "function" ? _ref.getVolume() : void 0 : void 0) || 0;
};

FlashPlayer.prototype.setVolume = function(value, scope) {
  this.getMediaElement().setVolume(value, scope || "");
  return value;
};

FlashPlayer.prototype.getDuration = function() {
  var _base;
  return typeof (_base = this.getMediaElement()).getDuration === "function" ? _base.getDuration() : void 0;
};

FlashPlayer.prototype.getDisplayState = function() {
  return this._displayState;
};

FlashPlayer.prototype.setDisplayState = function(value) {
  var _ref;
  if (value === this._displayState) {
    return;
  }
  this.applyDisplayState(value);
  if (((_ref = this.config.fullscreen) != null ? _ref.mode : void 0) === FullscreenMode.EXTERNAL) {
    return;
  }
  if (this._displayState === DisplayState.FULL_SCREEN) {
    this.getMediaElement().enterFullScreen();
  } else {
    this.getMediaElement().exitFullScreen();
  }
  return value;
};

FlashPlayer.prototype.applyDisplayState = function(value) {
  var states;
  if (value === this._displayState) {
    return;
  }
  states = {
    value: value,
    previous: this._displayState
  };
  this._displayState = value;
  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, states);
  this.sendNotification(Notifications.DISPATCH_EVENT, new Event("fullscreenchange", this._displayState === DisplayState.FULL_SCREEN));
};

FlashPlayer.prototype.enterFullScreen = function() {
  this.setDisplayState(DisplayState.FULL_SCREEN);
};

FlashPlayer.prototype.exitFullScreen = function() {
  this.setDisplayState(DisplayState.NORMAL);
};

FlashPlayer.prototype.recordContentChange = function(content) {
  this.getMediaElement().recordContentChange(content);
};

FlashPlayer.prototype.setQuality = function(value) {
  return this.getMediaElement().setQuality(value);
};

FlashPlayer.prototype.getQuality = function() {
  var quality;
  try {
    quality = this.getMediaElement().getQuality();
  } catch (error) {

  }
  return quality;
};

FlashPlayer.prototype.getQualityLevels = function() {
  var levels, _base;
  try {
    levels = (typeof (_base = this.getMediaElement()).getQualityLevels === "function" ? _base.getQualityLevels() : void 0) || [];
  } catch (error) {
    levels = [];
  }
  return levels;
};

Events = {
  LOADED_METADATA: "loadedmetadata",
  READY: "ready",
  ERROR: "error",
  ENDED: "ended",
  STARTED: "started",
  DURATION_CHANGE: "durationchange",
  SEEKING: "seeking",
  SEEKED: "seeked",
  TIME_UPDATE: "timeupdate",
  LOAD_START: "loadstart",
  LOADED_DATA: "loadeddata",
  CAN_PLAY: "canplay",
  CAN_PLAY_THROUGH: "canplaythrough",
  PROGRESS: "progress",
  MEDIA_CHANGE: "mediachange",
  WAITING: "waiting",
  BUFFERING_CHANGE: "bufferingchange",
  STALLED: "stalled",
  PLAY: "play",
  PLAYING: "playing",
  PAUSE: "pause",
  PAUSED: "paused",
  PLAY_REQUEST: "playrequest",
  MEDIUM_CHANGE: "mediumchange",
  TEMPORAL_TYPE_CHANGE: "temporaltypechange",
  VOLUME_CHANGE: "volumechange",
  FAIL_OVER_ATTEMPT: "failoverattempt",
  PLAYBACK_TARGET_CHANGE: "playbacktargetchange",
  PLAYBACK_TARGET_AVAILABLE: "playbacktargetavailable",
  RECORD_CONTENT_CHANGE: "recordcontentchange",
  IS_LIVE: "islive",
  CONTENT_CHANGED: "contentchanged",
  PLAYBACK_RATE_CHANGE: "playbackratechange",
  QUALITY_CHANGE: "qualitychange",
  QUALITY_CHANGING: "qualitychanging",
  QUALITY_MODE_CHANGE: "qualitymodechange",
  QUALITY_LEVELS_LOADED: "qualitylevelsloaded",
  MEDIA_SEQUENCE_STARTED: "mediasequencestarted",
  MEDIA_SEQUENCE_ENDED: "mediasequenceended",
  MEDIA_SEQUENCE_ABORTED: "mediasequenceaborted",
  LANGUAGE_CHANGE: "languagechange",
  TIMED_METADATA: "timedmetadata",
  CUES_CHANGE: "cueschange",
  VIEW_CREATED: "viewcreated",
  MUTE_CHANGE: "mutechange",
  RESUME: "resume",
  PLAY_STATE_CHANGE: "playstatechange",
  FULL_SCREEN_CHANGE: "fullscreenchange",
  init: function() {
    var key, value;
    this.values = [];
    for (key in this) {
      value = this[key];
      if (key !== "values" && key !== "init") {
        this.values.push(value);
      }
    }
  }
};
Events.init();

/**
 * The ModuleAdapter class.
 * 
 * @param {Module} module
 * @constructor
 * @private
 * @extends {puremvc.Mediator}
*/
function ModuleAdapter(module) {
  this.module = module;
  ModuleAdapter.__super__.constructor.call(this, module.getModuleName(), this);
}


__extends(ModuleAdapter, puremvc.Mediator);


ModuleAdapter.prototype.module = null;

ModuleAdapter.prototype.mediator = null;

ModuleAdapter.prototype.initializeNotifier = function(key) {
  var publications,
    _this = this;
  ModuleAdapter.__super__.initializeNotifier.call(this, key);
  publications = this.module.listNotificationPublications();
  if (publications != null) {
    this.mediator = new puremvc.Mediator(this.facade.getModuleName());
    this.mediator.listNotificationInterests = function() {
      return publications;
    };
    this.mediator.handleNotification = function(notification) {
      _this.facade.sendNotification(notification.getName(), notification.getBody(), notification.getType());
    };
  }
};

ModuleAdapter.prototype.onRegister = function() {
  if (this.mediator != null) {
    this.module.registerMediator(this.mediator);
  }
};

ModuleAdapter.prototype.onRemove = function() {
  if (this.mediator != null) {
    this.module.removeMediator(this.mediator);
  }
};

/**
 * Overridden so this class may subscribe to all notifications
 * @return An Array
 *
*/
ModuleAdapter.prototype.listNotificationInterests = function() {
  return this.module.listNotificationInterests();
};

/**
 * Handles notifications of interest to this mediator. Note that
 * the default declaration is to allow the super to handle the
 * note. This leaves the base JunctionMediator to handle things
 * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE  
 * @param note An INotification
 *
*/
ModuleAdapter.prototype.handleNotification = function(notification) {
  this.module.sendNotification(notification.getName(), notification.getBody(), notification.getType());
};

/**
 * @constructor
*/
function DataBinding() {}

/**
 * @private
 * @type {RegExp}
 * @const
*/
DataBinding.SINGLE = /^\s*[#\$]{([^\$#{}]+)}\s*$/;

/**
 * @private
 * @type {RegExp}
 * @const
*/
DataBinding.TOKEN = /[#\$]{([^\$#}]*)}/g;

/**
 * @private
 * @type {string}
 * @const
*/
DataBinding.RETURN = "return ";

/**
 * @private
 * @type {string}
 * @const
*/
DataBinding.EVENT = "event";

/**
 * @private
 * @type {string}
 * @const
*/
DataBinding.ELEMENT = "element";

/**
 * @private
 * @type {string}
 * @const
*/
DataBinding.PATHS = "paths";

/**
 * Evaluate a data bound string.
 *
 * @param {string} binding
 *   The data bound string.
 *
 * @param {?Object} context
 *   The context object used as "global" when evaluating the binding.
 *
 * @param {?Object} event
 *   An optional event object to expose to the binding.
 *
 * @return {string}
 *   The evaluated result
*/
DataBinding["eval"] = function(binding, context, event, element, paths) {
  var result, single, _ref;
  if (!(binding != null)) {
    return binding;
  }
  single = (_ref = this.SINGLE.exec(binding)) != null ? _ref[1] : null;
  result = single != null ? this.evalBinding(single, context, event, element, paths) : this.evalString(binding, context, event, element, paths);
  return result;
};

/**
 * Evaluate a data bound string.
 *
 * @param {string} binding
 *   The data bound string.
 *
 * @param {?Object} context
 *   The context object used as "global" when evaluating the binding.
 *
 * @param {?Object} event
 *   An optional event object to expose to the binding.
 *
 * @return {string}
 *   The evaluated result
 *
 * @private
*/
DataBinding.evalString = function(binding, context, event, element, paths) {
  return binding.replace(this.TOKEN, this.replaceBinding.bind(this, context, event, element, paths));
};

/**
 * @private
*/
DataBinding.replaceBinding = function(context, event, element, paths, match, token, offset, string) {
  return this.evalBinding(token, context, event, element, paths);
};

/**
 * Evaluate a data bound string.
 *
 * @param {string} binding
 *   The data bound string.
 *
 * @param {?Object} context
 *   The context object used as "this" when evaluating the binding.
 *
 * @param {?Object} event
 *   An optional event object to expose to the binding.
 *
 * @return {string}
 *   The evaluated result
 *
 * @private
*/
DataBinding.evalBinding = function(binding, context, event, element, paths) {
  var result;
  try {
    result = this.exec(binding, context, event, element, paths);
  } catch (error) {
    result = '#{' + binding + '}';
  }
  return result;
};

/**
 * Execute a data binding.
 *
 * @param {string} binding
 *   The data bound string.
 *
 * @param {?Object} context
 *   The context object used as "this" when evaluating the binding.
 *
 * @param {?Object} event
 *   An optional event object to expose to the binding.
 *
 * @return {string}
 *   The evaluated result
 *
 * @private
*/
DataBinding.exec = function(binding, context, event, element, paths) {
  return (new Function(this.EVENT, this.ELEMENT, this.PATHS, this.RETURN + binding)).bind(context)(event, element, paths);
};

/**
 * The EndCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function DispatchEventCommand() {
  DispatchEventCommand.__super__.constructor.call(this);
}


__extends(DispatchEventCommand, puremvc.SimpleCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
DispatchEventCommand.prototype.execute = function(notification) {
  var event;
  event = notification.getBody();
  event.player = this.facade.player || this.facade;
  this.facade.dispatchEvent(event);
};

/**
 * @enum {string}
 * @const
 * @private
*/

var Notifications = {
  STARTUP: "startup",
  LOAD: "load",
  PAUSE_REQUEST: "pauserequest",
  TOGGLE_PLAY_PAUSE: "togglePlayPause",
  CHANGE_PLAY_STATE: "chageplaystate",
  MEDIA_ELEMENT_CHANGE: "mediaelementchange",
  HIDDEN_CHANGE: "hiddenchange",
  TOGGLE_FULL_SCREEN: "toggleFullScreen",
  CHANGE_DISPLAY_STATE: "chageDisplayState",
  DISPLAY_STATE_CHANGE: "displayStateChange",
  DISABLE_FULL_SCREEN: "disableFullScreen",
  ENABLE_FULL_SCREEN: "enableFullScreen",
  TOGGLE_ACTIVE: "toggleActive",
  CHANGE_ACTIVE_STATE: "changeactivestate",
  ACTIVE_STATE_CHANGE: "activestatechange",
  CHANGE_MEDIA: "changeMedia",
  SET_MEDIA: "setmedia",
  MEDIA_VALIDATED: "mediavalidated",
  SETTINGS_CHANGE: "settingschange",
  UPDATE_DATA_BINDINGS: "updatedatabindings",
  CHANGE_VOLUME: "changevolume",
  CHANGE_MUTED: "changemuted",
  TOGGLE_MUTED: "togglemuted",
  SEEK: "seek",
  CHANGE_DURATION: "changeduration",
  CHANGE_AUTOPLAY: "changeAutoplay",
  AUTOPLAY_CHANGE: "autoplaychange",
  CHANGE_LOOP: "changeLoop",
  PLAYBACK_CORE_CHANGE: "playbackCoreChange",
  START: "start",
  END: "end",
  REPLAY: "replay",
  REGISTER_PLUGIN: "registerPlugin",
  REGISTER_PLUGINS: "registerPlugins",
  PLUGIN_REGISTERED: "pluginRegistered",
  ADD_LAYER: "addLayer",
  REMOVE_LAYER: "removeLayer",
  ADD_OVERLAY: "addOverlay",
  REMOVE_OVERLAY: "removeOverlay",
  ADD_CONTROL: "addControl",
  REMOVE_CONTROL: "removeControl",
  ADD_CONTROL_STATE: "addControlState",
  REMOVE_CONTROL_STATE: "removeControlState",
  ADD_APPLICATION_STATE: "addApplicationState",
  REMOVE_APPLICATION_STATE: "removeApplicationState",
  DISPATCH_EVENT: "dispatchEvent",
  CHANGE_PARAMS: "changeParams",
  INITIALIZED: "initialized",
  REGISTER_PLAYBACK_CORE: "registerPlaybackCore",
  REMOVE_PLAYBACK_CORE: "removePlaybackCore",
  DISPLAY_TIME: "displaytime",
  IS_USER_ACTIVE: "isUserActive",
  CHANGE_PLAYBACK_TARGET: "changeplaybacktarget",
  LOCK: "lock",
  FRAGMENT_LOAD_START: "fragmentloadstart",
  FRAGMENT_LOADED: "fragmentloaded",
  CHANGE_CONTENT: "changecontent",
  ENABLE_VIDEO_EVENTS: "enablevideoevents",
  DISABLE_VIDEO_EVENTS: "disablevideoevents",
  HAS_POST_CONTENT: "haspostcontent",
  init: function() {
    var key, value;
    for (key in Events) {
      value = Events[key];
      if (key !== "values" && key !== "init") {
        this[key] = value;
      }
    }
  }
};
Notifications.init();

/**
 * The Config class
 *
 * @param Object} overrides
 *    Config overrides
 *
 * @constructor
*/
function Config(overrides) {
  var config, key, react, value;
  if (overrides == null) {
    overrides = {};
  }
  if (!(akamai.amp.AMP.plugins.controls != null)) {
    react = {
      plugins: {
        react: {
          resources: [
            {
              src: "https://unpkg.com/react@15/dist/react.min.js",
              debug: "https://unpkg.com/react@15/dist/react.js",
              type: "text/javascript"
            }, {
              src: "https://unpkg.com/react-dom@15/dist/react-dom.min.js",
              debug: "https://unpkg.com/react-dom@15/dist/react-dom.js",
              type: "text/javascript"
            }, {
              src: "https://unpkg.com/prop-types/prop-types.min.js",
              debug: "https://unpkg.com/prop-types/prop-types.min.js",
              type: "text/javascript"
            }, {
              src: '#{paths.plugins}react/React.min.css',
              debug: '#{paths.plugins}react/React.css',
              type: "text/css"
            }, {
              src: '#{paths.plugins}react/React.min.js',
              debug: '#{paths.plugins}react/React.js',
              type: "text/javascript"
            }
          ],
          autoHide: 3
        }
      }
    };
    overrides = Utils.override(react, overrides);
  }
  config = Utils.override(Config.defaults, overrides);
  if (/amp\-debug\=true/.test(location.search.toLowerCase()) === true) {
    config.debug = true;
  }
  config.mode = Utils.getPlaybackMode(config.mode);
  config.version = AMP.getVersion();
  for (key in config) {
    value = config[key];
    this[key] = value;
  }
}

Config.create = function(overrides) {
  return new Config(overrides);
};

Config.defaults = {
  paths: {
    base: "../",
    root: "../",
    player: "../amp/",
    plugins: "../akamai/amp/",
    resources: "../resources/"
  },
  resources: [
    {
      src: '#{paths.player}amp.css',
      type: "text/css",
      async: true
    }
  ],
  rules: {
    android_4_gets_m3u8: {
      regexp: "Android 4"
    }
  },
  attributes: {},
  settings: {},
  autoplay: true,
  loop: false,
  playsinline: null,
  muted: null,
  target: "_blank",
  domain: "akamai.com",
  fullscreen: {},
  contextmenu: {},
  captioning: {},
  controls: {},
  playoverlay: {},
  hls: {
    resources: [
      {
        type: "text/javascript",
        src: '#{paths.resources}js/hls.min.js',
        debug: '#{paths.resources}js/hls.js'
      }
    ],
    quality: {
      startLevel: -1
    },
    data: {
      enableWorker: true
    }
  },
  dash: {
    resources: [
      {
        type: "text/javascript",
        src: "//cdn.dashjs.org/v2.5.0/dash.all.min.js",
        debug: "//cdn.dashjs.org/v2.5.0/dash.all.debug.js"
      }
    ],
    buffer: 1
  },
  flash: {
    swf: '#{paths.player}AkamaiStandardPlayer.swf',
    debug: '#{paths.player}AkamaiStandardPlayer-debug.swf',
    expressInstallSWF: '#{paths.player}playerProductInstall.swf',
    "static": {
      enabled: false,
      swf: '#{paths.player}AkamaiStandardPlayer-static.swf',
      debug: '#{paths.player}AkamaiStandardPlayer-static-debug.swf'
    },
    vars: {
      core_player_name: "amp",
      mbr_starting_index: 2,
      use_last_known_bitrate: false,
      use_netsession_client: false,
      netsession_install_prompt_frequency_secs: -1,
      ad_server_timeout: 20,
      ad_control_enabled: true,
      dvr_enabled: 1,
      branding_preload: "none",
      hds_live_low_latency: true,
      fullscreen_enabled: true,
      show_feature_bar: false,
      suppress_events: "mediaPlayerViewInitialized",
      hds_fragment_retry_data_gap_threshold: 20
    },
    view: {
      attributes: {
        skin: '#{paths.player}standard.assets.swf'
      },
      elements: {
        adOptions: {
          attributes: {
            style: "backgroundColor: 'rgba(0, 0, 0, 0)'"
          },
          elements: {
            adChoices: null,
            adCountdown: null,
            adCount: null
          }
        },
        endSlate: {
          attributes: {
            enabled: "false",
            hideElements: "brandingLogo|viewAll"
          }
        },
        loadingView: {
          attributes: {
            enabled: "false",
            style: "backgroundColor: 'rgba(0, 0, 0, 0)'; color: 'rgba(0, 0, 0, 0)'",
            radius: 0
          }
        }
      }
    }
  },
  locales: {
    en: {
      MSG_TIME_SEPARATOR: " / ",
      MSG_EMAIL_TO: "To",
      MSG_EMAIL_FROM: "From",
      MSG_EMAIL_VIDEO: "Email this video",
      MSG_EMAIL_MESSAGE_DEFAULT: "Check out this video from xxx",
      MSG_EMAIL_MESSAGE: "Message",
      MSG_EMAIL_ADDRESS_INVALID: "Invalid Email Address",
      MSG_EMAIL_MESSAGE_INVALID: "Please limit your message to 500 characters or less.",
      MSG_EMAIL_CHARACTERS_REMAINING_TEXT: " characters left",
      MSG_EMAIL_SEND_FAILURE: "Message could not be sent.",
      MSG_EMAIL_SEND_SUCCESS_MESSAGE: "Your email has been sent!",
      MSG_SHARE_VIDEO_TEXT: "Share this video...",
      MSG_POST_TEXT: "Post",
      MSG_EMBED_TEXT: "Embed",
      MSG_LINK_TEXT: "Link",
      MSG_SHARE_CONNECT_FAILURE: "Unable to connect. Please try again.",
      MSG_SHARE_CONTENT_DISABLED: "Share and embed are disabled.",
      MSG_VERSION_TEXT: "Version",
      MSG_BUFFERING_TEXT: "buffering",
      MSG_CUSTOMIZE_CLIP_POINTS: "Customize the start and end point of the video.",
      MSG_PAUSE: "Pause",
      MSG_PLAY: "Play",
      MSG_REWIND: "Rewind",
      MSG_PLAYBACK_RATE: "Playback Rate",
      MSG_FULLSCREEN: "Fullscreen",
      MSG_ENTER_FULLSCREEN: "Enter Fullscreen",
      MSG_EXIT_FULLSCREEN: "Exit Fullscreen",
      MSG_MUTE: "Mute",
      MSG_JUMP_BACK: "Jump Back",
      MSG_JUMP_AHEAD: "Jump Ahead",
      MSG_VOLUME: "Volume",
      MSG_REPLAY: "Replay",
      MSG_SETTINGS: "Settings",
      MSG_SHARE: "Share",
      MSG_CLOSED_CAPTIONING: "Closed Captioning",
      MSG_SLIDER: "Slider",
      MSG_SEEK: "Seek",
      MSG_OF: "of",
      MSG_AD: "Ad",
      MSG_PREVIEW: "Preview",
      MSG_CURRENT: "Current",
      MSG_SEEK_TO: "Seek to",
      MSG_LIVE: "LIVE",
      MSG_ERROR: "Error",
      MSG_ERROR_ABORTED: "Media Aborted",
      MSG_ERROR_DECODE: "Decode Error",
      MSG_ERROR_NETWORK: "Network Error",
      MSG_ERROR_SRC: "Source not supported",
      MSG_ERROR_DEFAULT: "An error has occured",
      MSG_STREAM_NOT_FOUND: "Stream not found",
      MSG_CURRENT_WORKING_BANDWIDTH: "Current working bandwidth",
      MSG_CURRENT_BITRATE_PLAYING: "Current bitrate playing",
      MSG_MAX_BITRATE_AVAILABLE: "Max bitrate available",
      MSG_NOT_AVAILABLE: "Not Available",
      MSG_GO_LIVE: "GO LIVE",
      MSG_NEXT_VIDEO: "Video starts in: ",
      MSG_RECOMMENDED: "Recommended",
      MSG_VIEW_ALL: "View all ",
      MSG_VIDEO: " videos",
      MSG_CC: "CC",
      MSG_CC_TITLE: "Caption",
      MSG_CC_LANGUAGE: "Track :",
      MSG_CC_PRESETS: "Presets :",
      MSG_CC_FONT: "Font :",
      MSG_CC_EDGE: "Edge :",
      MSG_CC_SIZE: "Size :",
      MSG_CC_SCROLL: "Scroll :",
      MSG_CC_COLOR: "Color :",
      MSG_CC_BACKGROUND: "Background :",
      MSG_CC_WINDOW: "Window :",
      MSG_CC_OPACITY: "Opacity :",
      MSG_CC_SHOW_ADVANCED: "Show Advanced Settings",
      MSG_CC_HIDE_ADVANCED: "Hide Advanced Settings",
      MSG_NEXT_AD: "Next ad starts in: ",
      MSG_CC_RESET: "Default",
      MSG_CC_CANCEL: "Cancel",
      MSG_CC_APPLY: "Apply",
      MSG_CC_PREVIEW_TEXT: "Lorem ipsum dolor sit amet..",
      MSG_EN: "English",
      MSG_ES: "Spanish",
      MSG_DE: "German",
      MSG_FR: "French",
      MSG_IT: "Italian",
      MSG_RU: "Russian",
      MSG_ZH: "Chinese",
      MSG_CHROMECAST_MESSAGE: "Video playing on another screen",
      MSG_RETRY_MESSAGE: "Content not yet available, retrying in",
      MSG_SECONDS: "seconds",
      MSG_RETRY_FAILED: "Retry failed",
      MSG_RECOMMENDATIONS_TITLE: "Recommended",
      MSG_VIEWER_ID: "Viewer ID: ",
      MSG_SIGN_IN: "Sign In",
      MSG_PREVIEW_INFO: "Free Preview",
      MSG_PREVIEW_EXPIRES: "Expires in"
    },
    es: '#{paths.player}es.json',
    fr: '#{paths.player}fr.json'
  }
};

function ITokenized() {}

/**
 * The tokenized data structure
*/
ITokenized.prototype.data = null;

/**
 * The literal value after compiliation
*/
ITokenized.prototype.value = null;

/**
 * The original data structure
*/
ITokenized.prototype.source = null;

/**
 *
*/
ITokenized.prototype.parse = function(data) {};

/**
 * Compiles the tokenized values in the data property
 * and saves them to the value property. As a convenience
 * this function returns the value property.
 * 
 * @param context         An object who's properties can be called from within a token
 * @param suppressErrors  Flag indicating wether or not to suppress errors. Useful when certain context items are known not to exist.
 * @return                The compile value object.
*/
ITokenized.prototype.compile = function(context, suppressErrors) {
  if (context == null) {
    context = {};
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
};

/**
 * @constructor
 * @private
 * @extends {ITokenized}
 * @param {string} source
*/
function TokenizedBase(source) {
  if (source != null) {
    this.parse(source);
  }
}


__extends(TokenizedBase, ITokenized);


/**
 * The tokenized data structure
*/
TokenizedBase.prototype.data = null;

/**
 * The literal value after compiliation
*/
TokenizedBase.prototype.value = null;

/**
 * The original data structure
*/
TokenizedBase.prototype.source = null;

/**
 * Populates the data property with tokenized values
 * 
 * @param   {Array.<Object>|Object|string|number|boolean} source  The tokenized data structure.
 * @return  {Object} The parsed data structure.
*/
TokenizedBase.prototype.parse = function(source) {
  var value;
  if (source instanceof Array) {
    value = new TokenizedArray(source);
  } else if (source instanceof Object) {
    value = new TokenizedObject(source);
  } else {
    value = new TokenizedValue(source);
  }
  return value;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var SecurityNotifications = {
  AUTHORIZATION_FAILED: "authorizationfailed",
  AUTHORIZE: "authorize",
  AUTHORIZED: "authorized",
  AUTHENTICATION_FAILED: "authenticationfailed",
  AUTHENTICATE: "authenticate",
  AUTHENTICATED: "authenticated",
  AUTHORIZATION_EXPIRED: "authorizationexpired"
};

/** 
 * Binds an event(s) to a handler function.
 * 
 * @param {IEventDispatcher}    target  The event target
 * @param {string|Array|number} type    The event to listen for
 * @param {Function}            handler The handler function to call when the event is dispatched. 
 * @constructor
 * @private
*/
function EventHandler(target, type, handler) {
  var _ref;
  this.target = target;
  this.type = type;
  this.handler = handler;
  this.trigger = __bind(this.trigger, this);

  EventHandler.instances.push(this);
  this.types = [];
  if (_ref = this.type, __indexOf.call(EventHandler.EVENTS, _ref) >= 0) {
    if (Utils.isTouchDevice()) {
      this.types.push(EventHandler.TOUCH_EVENTS[this.type]);
      if (this.type === EventHandler.TOUCH_EVENTS[1]) {
        this.types.push(EventHandler.TOUCH_EVENTS[4]);
      }
    } else {
      this.types.push(EventHandler.MOUSE_EVENTS[this.type]);
    }
  } else if (this.type instanceof Array) {
    this.types = this.type;
  } else {
    this.types.push(this.type);
  }
  this.bind();
}

/**
 * Represents the press user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.PRESS = 0;

/**
 * Represents the release user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.RELEASE = 1;

/**
 * Represents the move user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.MOVE = 2;

/**
 * Represents the click user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.CLICK = 3;

/**
 * Represents the right click (contextMenu) user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.CONTEXTMENU = 4;

/**
 * Represents the mouse over user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.HOVER = 5;

/**
 * Represents the mouse out user interaction
 * 
 * @type {number}
 * @static
 * @const
*/
EventHandler.HOVEROUT = 6;

/**
 * The list of user interactions
 * 
 * @type {Array.<number>}
 * @static
 * @const
*/
EventHandler.EVENTS = [EventHandler.PRESS, EventHandler.RELEASE, EventHandler.MOVE, EventHandler.CLICK, EventHandler.CONTEXTMENU, EventHandler.HOVER, EventHandler.HOVEROUT];

/**
 * The list of mouse interactions
 * 
 * @type {Array.<string>}
 * @static
 * @const
*/
EventHandler.MOUSE_EVENTS = ["mousedown", "mouseup", "mousemove", "click", "contextmenu", "mouseover", "mouseout"];

/**
 * The list of touch interactions
 * 
 * @type {Array.<string>}
 * @static
 * @const
*/
EventHandler.TOUCH_EVENTS = ["touchstart", "touchend", "touchmove", "click", "touchcancel"];

/**
 * An array of EventHandler instances.
 * 
 * @type {Array.<EventHandler>}
 * @static
*/
EventHandler.instances = [];

/**
 * Creates an EventHandler with the parameters provided.
 * 
 * @param {IEventDispatcher}    target  The event target
 * @param {string|Array|number} type    The event to listen for
 * @param {Function}            handler The handler function to call when the event is dispatched. 
 * @static
 * @return {EventHandler} the new EventHandler
*/
EventHandler.create = function(target, type, handler) {
  return new EventHandler(target, type, handler);
};

/**
 * Binds all EventHandlers of the provided target.
 * 
 * @param {IEventDispatcher} target
 * @static
*/
EventHandler.bind = function(target, type) {
  var i, instance, _i, _len, _ref;
  _ref = EventHandler.instances;
  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
    instance = _ref[i];
    if (!(instance.target === target)) {
      continue;
    }
    if ((type != null) && instance.type !== type) {
      continue;
    }
    instance.bind();
  }
};

/**
 * Unbinds all EventHandlers of the provided target.
 * 
 * @param {IEventDispatcher} target
 * @static
*/
EventHandler.unbind = function(target, type) {
  var i, instance, _i, _len, _ref;
  _ref = EventHandler.instances;
  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
    instance = _ref[i];
    if (!(instance.target === target)) {
      continue;
    }
    if ((type != null) && instance.type !== type) {
      continue;
    }
    instance.unbind();
  }
};

/**
 * Clear all EventHandlers of the provided target.
 * 
 * @param {IEventDispatcher} target
 * @static
*/
EventHandler.clear = function(target, type) {
  var i, instance, _i, _len, _ref;
  _ref = EventHandler.instances;
  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
    instance = _ref[i];
    if (!((instance != null ? instance.target : void 0) === target)) {
      continue;
    }
    if ((type != null) && instance.type !== type) {
      continue;
    }
    instance.clear();
    EventHandler.instances.splice(i, 1);
  }
};

/**
 * The system event types for this EventTarget
 * 
 * @type {Array.<string>}
*/
EventHandler.prototype.types = null;

/**
 * Binds the target to the event
*/
EventHandler.prototype.bind = function() {
  var type, _i, _len, _ref;
  _ref = this.types;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    type = _ref[_i];
    if (this.target.addEventListener != null) {
      this.target.addEventListener(type, this.trigger, false);
    } else if (this.target.attachEvent != null) {
      this.target.attachEvent("on" + type, this.trigger);
    }
  }
};

/**
 * Unbinds the target from the event
*/
EventHandler.prototype.unbind = function() {
  var type, _i, _len, _ref;
  _ref = this.types;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    type = _ref[_i];
    if (this.target.removeEventListener != null) {
      this.target.removeEventListener(type, this.trigger);
    } else if (this.target.attachEvent != null) {
      this.target.removeEvent("on" + type, this.trigger);
    }
  }
};

/**
 * Clears the EventHandler
*/
EventHandler.prototype.clear = function() {
  this.unbind();
  this.target = null;
  this.handler = null;
  this.type = null;
  this.types = null;
};

/**
 * Triggers the event handler
*/
EventHandler.prototype.trigger = function(event) {
  this.handler(event);
};

/**
 * @constructor
 * @private
 * @extends {ModuleMediator}
*/
function SettingsMediator() {
  SettingsMediator.__super__.constructor.call(this, "setting");
  this.namespace = "akamai_amp";
  this.defaults = {
    volume: 1,
    captions: {
      visible: false,
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "small",
      scroll: "popout",
      fontColor: "rgba(255,255,255,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0,0,0,0)",
      backgroundColor: "rgba(0,0,0,0)",
      windowColor: "rgba(0,0,0,0.5)"
    }
  };
}


__extends(SettingsMediator, puremvc.Mediator);


/** @override
*/
SettingsMediator.prototype.onRegister = function() {
  var data, settings;
  this.config = this.facade.retrieveProxy(ModuleProxy.NAME);
  settings = this.config.getSettings() || {};
  if (settings.namespace != null) {
    this.namespace = settings.namespace;
  }
  try {
    data = localStorage.getItem(this.namespace);
    if (data != null) {
      this.settings = JSON.parse(data);
    }
  } catch (_error) {}
  if (!(this.settings != null)) {
    this.settings = Utils.clone(this.defaults);
    this.save();
  }
};

/** @override
*/
SettingsMediator.prototype.listNotificationInterests = function() {
  return [Notifications.READY, Notifications.VOLUME_CHANGE, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE, CaptioningNotifications.TRACK_SELECTED];
};

/** @override
*/
SettingsMediator.prototype.handleNotification = function(notification) {
  var body, name, value;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.READY:
      value = this.settings.volume;
      if (value != null) {
        this.sendNotification(Notifications.CHANGE_VOLUME, value);
      }
      break;
    case Notifications.VOLUME_CHANGE:
      if (this.settings.volume === body) {
        return;
      }
      this.change({
        volume: body
      });
      break;
    case CaptioningNotifications.VISIBILITY_CHANGE:
      if (this.settings.captions.visible === body) {
        return;
      }
      this.change({
        captions: {
          visible: body
        }
      });
      break;
    case CaptioningNotifications.SETTINGS_CHANGE:
      this.change({
        captions: body
      });
      break;
    case CaptioningNotifications.TRACK_SELECTED:
      this.change({
        captions: {
          track: body
        }
      });
  }
};

/**
*/
SettingsMediator.prototype.change = function(settings) {
  if (!(settings != null) || typeof settings !== "object" || settings instanceof Array) {
    return;
  }
  Utils.override(this.settings, settings, false);
  this.save();
  this.sendNotification(Notifications.SETTINGS_CHANGE, settings);
};

/**
*/
SettingsMediator.prototype.getSettings = function() {
  return Object.freeze(Object.assign({
    defaults: Object.assign({}, this.defaults),
    change: this.change.bind(this)
  }, this.settings));
};

/**
*/
SettingsMediator.prototype.save = function() {
  try {
    localStorage.setItem(this.namespace, JSON.stringify(this.settings));
  } catch (_error) {}
};

/**
 * Used to track player configuration settings
*/
/**
 * Creates a new instance of MediaProxy.
 *
 * @constructor
 * @private
*/
function ConfigurationProxy(config) {
  this.defaults = Config.defaults;
  ConfigurationProxy.__super__.constructor.call(this, config);
}


__extends(ConfigurationProxy, ModuleProxy);


/** @static
*/
ConfigurationProxy.NAME = ModuleProxy.NAME;

/**
 * @override
*/
ConfigurationProxy.prototype.getContextName = function() {
  return "paths";
};

/**
 * @override
*/
ConfigurationProxy.prototype.getContextData = function() {
  return this.getPaths();
};

/**
*/
ConfigurationProxy.prototype.onRegister = function() {
  this.facade.retrieveProxy(DataBindingProxy.NAME).registerContext(this);
};

/**
 * @override
*/
ConfigurationProxy.prototype.setData = function(value) {
  if (value.rules != null) {
    Utils.mergeRules(value.rules);
  }
  ConfigurationProxy.__super__.setData.call(this, value);
  return value;
};

/**
 * Plays iniline
*/
ConfigurationProxy.prototype.getPlaysInline = function() {
  return this.data.playsinline;
};

/**
 * Plays iniline
*/
ConfigurationProxy.prototype.getMuted = function() {
  return this.data.muted;
};

ConfigurationProxy.prototype.setMuted = function(value) {
  this.data.muted = value;
  return value;
};

/**
 * Auto play.
*/
ConfigurationProxy.prototype.getAutoplay = function() {
  return this.data.autoplay;
};

ConfigurationProxy.prototype.setAutoplay = function(value) {
  this.data.autoplay = value;
  return value;
};

/**
 * Auto play.
*/
ConfigurationProxy.prototype.getLoop = function() {
  return this.data.loop;
};

ConfigurationProxy.prototype.setLoop = function(value) {
  this.data.loop = value;
  return value;
};

/**
 * End Slate.
*/
ConfigurationProxy.prototype.getSettings = function() {
  return this.data.settings;
};

ConfigurationProxy.prototype.setSettings = function(value) {
  this.data.settings = value;
  return value;
};

/**
 * Domain
*/
ConfigurationProxy.prototype.getDomain = function() {
  return this.data.domain;
};

ConfigurationProxy.prototype.setDomain = function(value) {
  this.data.domain = value;
  return value;
};

/**
 * Target.
*/
ConfigurationProxy.prototype.getTarget = function() {
  return this.data.target;
};

ConfigurationProxy.prototype.setTarget = function(value) {
  this.data.target = value;
  return value;
};

/**
 * The player name.
*/
ConfigurationProxy.prototype.getName = function() {
  return this.data.name;
};

ConfigurationProxy.prototype.setName = function(value) {
  this.data.name = value;
  return value;
};

/**
 * The player paths.
*/
ConfigurationProxy.prototype.getPaths = function() {
  return this.data.paths;
};

ConfigurationProxy.prototype.setPaths = function(value) {
  this.data.paths = value;
  return value;
};

/**
 * The player version.
*/
ConfigurationProxy.prototype.getVersion = function() {
  return this.data.version;
};

/**
 * Controls
*/
ConfigurationProxy.prototype.getControls = function() {
  return this.data.controls;
};

ConfigurationProxy.prototype.setControls = function(value) {
  this.data.controls = value;
  return value;
};

/**
 * Fullscreen configuration
*/
ConfigurationProxy.prototype.getFullscreen = function() {
  return this.data.fullscreen || {};
};

ConfigurationProxy.prototype.setFullscreen = function(value) {
  this.data.fullscreen = value;
  return value;
};

/**
 * AudioPlaybackProxy constructor.
 * 
 * @constructor
 * @private
 * @extends {PlaybackCoreProxy}
*/
function AudioPlaybackProxy() {
  AudioPlaybackProxy.__super__.constructor.call(this);
}


__extends(AudioPlaybackProxy, PlaybackCoreProxy);


AudioPlaybackProxy.prototype.playbackCoreName = "audio";

/** @override
*/
AudioPlaybackProxy.prototype.onRegister = function() {
  var mediaElement;
  mediaElement = new MediaElementMediator("html5", "audio");
  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, mediaElement);
};

/** @override
*/
AudioPlaybackProxy.prototype.onRemove = function() {
  this.facade.createMediaElement();
};

/**
 *
*/
AudioPlaybackProxy.prototype.canPlayMedium = function(medium) {
  return medium === "audio";
};

/** @override
*/
AudioPlaybackProxy.prototype.canPlayType = function(mimeType) {
  if (/audio/.test(mimeType)) {
    return "maybe";
  }
  return "";
};

function FPS() {}

FPS.extractContentId = function(initData, keys) {
  var link;
  link = document.createElement('a');
  link.href = Utils.arrayToString(initData);
  return link.hostname;
};

FPS.extractServerUrl = function(initData, keys) {
  return keys.serverURL || keys.serverUrl;
};

FPS.requestCertificate = function(keys) {
  var request;
  request = {
    url: keys.cert,
    responseType: "arraybuffer",
    headers: {
      "Pragma": "Cache-Control: no-cache",
      "Cache-Control": "max-age=0"
    }
  };
  return Utils.request(request).then(function(xhr) {
    return new Uint8Array(xhr.response);
  });
};

FPS.concatInitDataIdAndCertificate = function(initData, id, cert) {
  var buffer, certArray, dataView, idArray, initDataArray, offset;
  if (typeof id === "string") {
    id = Utils.stringToArray(id);
  }
  offset = 0;
  buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
  dataView = new DataView(buffer);
  initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
  initDataArray.set(initData);
  offset += initData.byteLength;
  dataView.setUint32(offset, id.byteLength, true);
  offset += 4;
  idArray = new Uint16Array(buffer, offset, id.length);
  idArray.set(id);
  offset += idArray.byteLength;
  dataView.setUint32(offset, cert.byteLength, true);
  offset += 4;
  certArray = new Uint8Array(buffer, offset, cert.byteLength);
  certArray.set(cert);
  return new Uint8Array(buffer, 0, buffer.byteLength);
};

FPS.requestLicense = function(message, contentId, serverUrl) {
  var request,
    _this = this;
  request = {
    url: serverUrl,
    method: "POST",
    responseType: "text",
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    },
    data: "spc=" + (Utils.base64EncodeUint8Array(message)) + "&assetId=" + (encodeURIComponent(contentId))
  };
  return Utils.request(request).then(function(xhr) {
    var keyText;
    keyText = xhr.responseText.trim();
    if (keyText.substr(0, 5) === "<ckc>" && keyText.substr(-6) === "</ckc>") {
      keyText = keyText.slice(5, -6);
    }
    return Utils.base64DecodeUint8Array(keyText);
  })["catch"](function(error) {
    throw "The license request failed.";
  });
};

/**
 * @constructor
 * @private
 * @extends {TokenizedBase}
 * @param {Array.<Object>} data
*/
function TokenizedArray(data) {
  TokenizedArray.__super__.constructor.call(this, data);
}


__extends(TokenizedArray, TokenizedBase);


/**
 *
*/
TokenizedArray.prototype.parse = function(data) {
  var index, token, _i, _len;
  this.data = [];
  for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {
    token = data[index];
    this.data[index] = TokenizedArray.__super__.parse.call(this, token);
  }
  return this.data;
};

/**
 *
*/
TokenizedArray.prototype.compile = function(context, suppressErrors) {
  var index, token, _i, _len, _ref;
  if (context == null) {
    context = {};
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  this.value = [];
  _ref = this.data;
  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
    token = _ref[index];
    try {
      this.value[index] = token.compile(context, suppressErrors);
    } catch (error) {
      this.value[index] = null;
      if (!suppressErrors) {
        Logger.error(error);
      }
    }
  }
  return this.value;
};

/**
 * DVRPlaybackProxy constructor.
 *
 * @constructor
 * @private
 * @extends {PlaybackCoreProxy}
*/
function DVRPlaybackProxy() {
  DVRPlaybackProxy.__super__.constructor.call(this);
}


__extends(DVRPlaybackProxy, PlaybackCoreProxy);


DVRPlaybackProxy.prototype.playbackCoreName = "dvr";

DVRPlaybackProxy.prototype.interval = null;

/** @override
*/
DVRPlaybackProxy.prototype.ondurationchange = function(event) {
  this.updateDuration();
};

/** @override
*/
DVRPlaybackProxy.prototype.ontimeupdate = function(event) {
  this.updateCurrentTime();
};

/** @override
*/
DVRPlaybackProxy.prototype.onplay = function(event) {
  this.stopTimer();
  DVRPlaybackProxy.__super__.onplay.call(this, event);
};

/** @override
*/
DVRPlaybackProxy.prototype.onplaying = function(event) {
  this.stopTimer();
  DVRPlaybackProxy.__super__.onplaying.call(this, event);
};

/** @override
*/
DVRPlaybackProxy.prototype.onpause = function(event) {
  this.startTimer();
  DVRPlaybackProxy.__super__.onpause.call(this, event);
};

/** @override
*/
DVRPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {
  return temporalType === "dvr";
};

/**
*/
DVRPlaybackProxy.prototype.getDuration = function() {
  var mediaElement;
  mediaElement = this.getMediaElement();
  if (mediaElement.duration === Infinity) {
    this.updateDuration();
  }
  return this.data.duration;
};

/**
*/
DVRPlaybackProxy.prototype.getStartTime = function() {
  return this.getMediaElement().seekable.start(0);
};

/**
*/
DVRPlaybackProxy.prototype.getFragmentDuration = function() {
  return 10;
};

/**
*/
DVRPlaybackProxy.prototype.getLiveTime = function() {
  return this.getDuration() - this.getFragmentDuration();
};

/**
*/
DVRPlaybackProxy.prototype.isLive = function() {
  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();
};

/** @override
*/
DVRPlaybackProxy.prototype.seek = function(value) {
  var _this = this;
  return DVRPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {
    _this.sendNotification(Notifications.IS_LIVE, _this.isLive());
  });
};

/**
*/
DVRPlaybackProxy.prototype.updateCurrentTime = function() {
  var currentTime, seekable;
  seekable = this.getMediaElement().seekable;
  if (seekable.length === 0) {
    return;
  }
  currentTime = this.getMediaElement().currentTime;
  this.data.currentTime = currentTime - seekable.start(0);
  this.sendNotification(Notifications.TIME_UPDATE, this.data.currentTime);
  this.mediaProxy.setIsLive(this.isLive());
};

/**
*/
DVRPlaybackProxy.prototype.updateDuration = function() {
  var seekable;
  seekable = this.getMediaElement().seekable;
  if (seekable.length === 0) {
    return;
  }
  this.data.duration = seekable.end(0) - seekable.start(0);
  this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);
};

/**
*/
DVRPlaybackProxy.prototype.startTimer = function() {
  this.interval = setInterval(this.updateCurrentTime.bind(this), 1000);
};

/**
*/
DVRPlaybackProxy.prototype.stopTimer = function() {
  if (this.interval != null) {
    clearInterval(this.interval);
    this.interval = null;
    this.updateCurrentTime();
  }
};

/**
 * Creates a new instance of Context.
 * 
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
 * @implements {IDataBindingContext}
*/
function DataBindingContext() {
  DataBindingContext.__super__.constructor.call(this);
  if (this.contextName == null) {
    this.contextName = this.constructor.NAME;
  }
}


__extends(DataBindingContext, puremvc.Proxy);


DataBindingContext.prototype.contextName = null;

DataBindingContext.prototype.contextData = null;

/**
*/
DataBindingContext.prototype.onRegister = function() {
  var base, bindings;
  if (!(this.getContextName() != null)) {
    return;
  }
  base = this.facade.player || this.facade;
  bindings = base.retrieveProxy(DataBindingProxy.NAME);
  bindings.registerContext(this);
};

/**
*/
DataBindingContext.prototype.getContextName = function() {
  return this.contextName;
};

/**
*/
DataBindingContext.prototype.getContextData = function() {
  return this.contextData;
};

/**
 * Creates a new instance of PlayerProxy.
 *
 * @constructor
 * @private
 * @extends {DataBindingContext}
*/
function PlayerProxy(defaultPlaybackCore, getPlaybackOrder) {
  var _this = this;
  this.defaultPlaybackCore = defaultPlaybackCore;
  this.getPlaybackOrder = getPlaybackOrder;
  PlayerProxy.__super__.constructor.call(this);
  this.playbackCoreMap = [];
  if (this.getPlaybackOrder == null) {
    this.getPlaybackOrder = function(order) {
      if (/Edge|Android/.test(navigator.userAgent)) {
        return ["audio", "hls", "dash", "dvr", "default"];
      }
    };
  }
}


__extends(PlayerProxy, DataBindingContext);


/** @static
*/
PlayerProxy.NAME = "PlayerProxy";

PlayerProxy.prototype.contextName = "player";

PlayerProxy.prototype.getPlaybackOrder = null;

PlayerProxy.prototype.playbackCoreMap = null;

PlayerProxy.prototype.defaultPlaybackCore = null;

PlayerProxy.prototype.activePlaybackCore = null;

/**
*/
PlayerProxy.prototype.onRegister = function() {
  PlayerProxy.__super__.onRegister.call(this);
  this.registerPlaybackCore(new DVRPlaybackProxy());
  this.registerPlaybackCore(this.defaultPlaybackCore);
  this.registerPlaybackCore(new AudioPlaybackProxy());
  this.activePlaybackCore = this.defaultPlaybackCore;
};

PlayerProxy.prototype.ready = function() {
  var order,
    _this = this;
  order = typeof this.getPlaybackOrder === "function" ? this.getPlaybackOrder(this.playbackCoreMap.map(function(core) {
    return core.getPlaybackCoreName();
  })) : void 0;
  if (!(order != null)) {
    return;
  }
  this.playbackCoreMap = this.playbackCoreMap.sort(function(a, b) {
    a = order.indexOf(a.getPlaybackCoreName());
    b = order.indexOf(b.getPlaybackCoreName());
    if (a === b) {
      return 0;
    }
    if (a === -1 && b !== -1) {
      return 1;
    }
    if (a !== -1 && b === -1) {
      return -1;
    }
    return a - b;
  });
};

/**
*/
PlayerProxy.prototype.getActivePlaybackCore = function() {
  return this.activePlaybackCore;
};

/**
*/
PlayerProxy.prototype.registerPlaybackCore = function(core) {
  var name,
    _this = this;
  name = core.getPlaybackCoreName();
  if (!(core != null) || this.playbackCoreMap.some(function(item) {
    return item.getPlaybackCoreName() === name;
  })) {
    return;
  }
  this.playbackCoreMap.push(core);
};

/**
*/
PlayerProxy.prototype.retrievePlaybackCore = function(name) {
  var core, _i, _len, _ref;
  _ref = this.playbackCoreMap;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    core = _ref[_i];
    if (core.getPlaybackCoreName() === name) {
      return core;
    }
  }
};

/**
*/
PlayerProxy.prototype.removePlaybackCore = function(name) {
  var core, index;
  core = this.retrievePlaybackCore(name);
  if (!(core != null)) {
    return null;
  }
  index = this.playbackCoreMap.indexOf(core);
  this.playbackCoreMap.splice(index, 1);
  return core;
};

/**
*/
PlayerProxy.prototype.setPlaybackCore = function(media) {
  var core, error, playbackCore, playbackProxy, _i, _len, _ref;
  _ref = this.playbackCoreMap;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    core = _ref[_i];
    if (core.canPlayMedium(media.medium) === true && core.canPlayTemporalType(media.temporalType) === true && core.canPlayType(media.type) !== "") {
      playbackCore = core;
      break;
    }
  }
  if (!(playbackCore != null)) {
    error = new Error();
    error.code = MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED;
    throw error;
  }
  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);
  if (playbackProxy !== playbackCore) {
    if (typeof playbackProxy.destroy === "function") {
      playbackProxy.destroy();
    }
    this.facade.removeProxy(PlaybackProxy.NAME);
    this.facade.registerProxy(playbackCore);
    playbackCore.setData(playbackProxy.getData());
  }
  this.activePlaybackCore = playbackCore;
  return media;
};

/**
*/
PlayerProxy.prototype.canPlayType = function(type) {
  var canPlay, core, _i, _len, _ref;
  _ref = this.playbackCoreMap;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    core = _ref[_i];
    canPlay = core.canPlayType(type);
    if (canPlay !== "") {
      return canPlay;
    }
  }
  return "";
};

/**
 * Gets the context data for this proxy.
 *
 * @returns {Object} The contenxt data for this proxy
 * @override
*/
PlayerProxy.prototype.getContextData = function() {
  var configProxy, element, mediaProxy, playbackProxy;
  configProxy = this.facade.retrieveProxy(ConfigurationProxy.NAME);
  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);
  mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);
  element = this.facade.getViewComponent();
  return {
    width: element.offsetWidth,
    height: element.offsetHeight,
    mode: "html5",
    autoplay: configProxy.getAutoplay(),
    domain: configProxy.getDomain(),
    name: configProxy.getName(),
    currentTime: playbackProxy.getCurrentTime(),
    duration: playbackProxy.getDuration(),
    version: configProxy.getVersion(),
    timecode: {
      duration: Utils.formatTimecode(mediaProxy.getDuration()),
      currentTime: Utils.formatTimecode(playbackProxy.getCurrentTime())
    }
  };
};

/**
 * Creates a new instance of MediaProxy. Used to track metadata associated with the video such as src, title and duration.
 *
 * @constructor
 * @private
 * @extends {DataBindingContext}
*/
function MediaProxy(config) {
  var _ref;
  this.data = {
    metadata: {}
  };
  this.transforms = [this.defaultMediaTransform.bind(this)];
  if (((_ref = config.mediaTransforms) != null ? _ref.length : void 0) > 0) {
    this.transforms = this.transforms.concat(config.mediaTransforms);
  }
  MediaProxy.__super__.constructor.call(this);
}


__extends(MediaProxy, DataBindingContext);


/** @static
*/
MediaProxy.NAME = "MediaProxy";

MediaProxy.prototype.contextName = "media";

/** @private
*/
MediaProxy.prototype.data = null;

MediaProxy.prototype.value = null;

MediaProxy.prototype.started = false;

MediaProxy.prototype.authorized = true;

MediaProxy.prototype.transforms = null;

/**
 * Gets the context data for this proxy.
 *
 * @returns {Object} The contenxt data for this proxy
 * @override
*/
MediaProxy.prototype.getContextData = function() {
  return this.data;
};

/**
 * Sets the data for this proxy.
 *
 * @param {Object} value
 *    The new data for this proxy
 * @override
*/
MediaProxy.prototype.getData = function() {
  var data;
  data = Utils.clone(MediaProxy.__super__.getData.call(this));
  if (!(data.authorization != null)) {
    data.authorization = Utils.clone(this.facade.security.data);
  }
  return data;
};

/**
 * Sets the data for this proxy.
 *
 * @param {Object} value
 *    The new data for this proxy
 * @override
*/
MediaProxy.prototype.setData = function(value) {
  if (this.data && this.facade.getCurrentTime() < this.facade.getDuration()) {
    this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);
  }
  this.started = false;
  this.setAutoplay(value.autoplay);
  this.setType(value.type);
  this.setIsLive(value.isLive);
  this.setTemporalType(value.temporalType);
  if (value.source != null) {
    this.setSource(value.source);
  }
  if (value.src != null) {
    this.setSrc(value.src);
  }
  this.setTitle(value.title);
  this.setDuration(value.duration);
  this.setPoster(value.poster);
  this.setGUID(value.guid);
  this.setLink(value.link);
  this.setEmbed(value.embed);
  this.setWidth(value.width);
  this.setHeight(value.height);
  this.setCategory(value.category);
  this.setStartTime(value.startTime);
  this.setDescription(value.description);
  this.setStatus(value.status);
  this.setCategory(value.category);
  this.setMetadata(value.metadata);
  this.setAuthorization(value.authorization);
  this.setMedium(value.medium);
  this.setPubDate(value.pubDate);
  this.setTrack(value.track);
  this.setScenes(value.scenes);
  this.setKeys(value.keys);
  this.setCues(value.cues);
  return this.data;
};

/**
 *
*/
MediaProxy.prototype.defaultMediaTransform = function(media) {
  var index, item, playerProxy, scene, time, _i, _len, _ref, _ref1,
    _this = this;
  if (!(media.src != null) && ((_ref = media.source) != null ? _ref.length : void 0) > 0) {
    playerProxy = this.facade.retrieveProxy(PlayerProxy.NAME) || this.facade;
    if (playerProxy != null) {
      item = Utils.selectSource(media.source, function(type) {
        return playerProxy.canPlayType(type);
      });
    }
    if (((item != null ? item.src : void 0) != null) && item.src !== "") {
      media.src = item.src;
      media.type = item.type;
    } else {
      throw new Error("No valid source could be found");
    }
  }
  if (media.type == null) {
    media.type = Utils.getMimeType(media.src);
  }
  if (!(media.medium != null)) {
    media.medium = /audio/.test(media.type) ? "audio" : "video";
  }
  if (media.temporalType == null) {
    media.temporalType = "vod";
  }
  media.isLive = media.temporalType === "live" || media.temporalType === "dvr";
  if (media.scenes != null) {
    _ref1 = media.scenes;
    for (index = _i = 0, _len = _ref1.length; _i < _len; index = ++_i) {
      scene = _ref1[index];
      scene.start = isNaN(time = Utils.flattenTimecode(scene.sceneStartTime)) ? 0 : time;
      scene.end = isNaN(time = Utils.flattenTimecode(scene.sceneEndTime)) ? 0 : time;
      scene.title = scene.sceneTitle || "";
      scene.description = scene.sceneDescription || "";
      scene.position = index + 1;
    }
  }
  if (media.startTime == null) {
    media.startTime = 0;
  }
  if (media.status == null) {
    media.status = {};
  }
  if (media.metadata == null) {
    media.metadata = {};
  }
  media.originalSrc = media.src;
  return Promise.resolve(media);
};

MediaProxy.prototype.transform = function(value) {
  return Utils.chain(this.transforms, value);
};

/**
 *
*/
MediaProxy.prototype.updateData = function(data) {
  var key, value;
  for (key in data) {
    value = data[key];
    if (key in this.data) {
      this.data[key] = value;
    }
  }
};

/**
 * The global unique identifier for this to the video.
 *
 * @param {String} value
 *    The new guid of the video
 * @returns {String}
 *    The guid of the video
 * @type {String}
*/
MediaProxy.prototype.getGUID = function() {
  return this.data.guid;
};

MediaProxy.prototype.setGUID = function(value) {
  return this.data.guid = value;
};

MediaProxy.prototype.getLink = function() {
  return this.data.link;
};

MediaProxy.prototype.setLink = function(value) {
  return this.data.link = value;
};

MediaProxy.prototype.getStartTime = function() {
  return this.data.startTime;
};

MediaProxy.prototype.setStartTime = function(value) {
  return this.data.startTime = value;
};

MediaProxy.prototype.getEmbed = function() {
  return this.data.embed;
};

MediaProxy.prototype.setEmbed = function(value) {
  return this.data.embed = value;
};

MediaProxy.prototype.getAutoplay = function() {
  return this.data.autoplay;
};

MediaProxy.prototype.setAutoplay = function(value) {
  return this.data.autoplay = value;
};

MediaProxy.prototype.getPubDate = function() {
  return this.data.pubDate;
};

MediaProxy.prototype.setPubDate = function(value) {
  return this.data.pubDate = value;
};

MediaProxy.prototype.getCategory = function() {
  return this.data.category;
};

MediaProxy.prototype.setCategory = function(value) {
  return this.data.category = value;
};

MediaProxy.prototype.getStatus = function() {
  return this.data.status;
};

MediaProxy.prototype.setStatus = function(value) {
  return this.data.status = value != null ? value : {};
};

/**
 * The url to the video.
 *
 * @param {String} value
 *    The new title of the video
 * @returns {Boolean}
 *    The title of the video
 * @type {String}
*/
MediaProxy.prototype.getSrc = function() {
  return this.facade.security.createURL(this.data.src);
};

MediaProxy.prototype.setSrc = function(value) {
  return this.data.src = value;
};

/**
 * The mimeType of the video.
*/
MediaProxy.prototype.getType = function() {
  return this.data.type;
};

MediaProxy.prototype.setType = function(value) {
  return this.data.type = value;
};

/**
 * The medium the video. ie audio, video, executable
*/
MediaProxy.prototype.getMedium = function() {
  return this.data.medium;
};

MediaProxy.prototype.setMedium = function(value) {
  if (value === this.data.medium) {
    return;
  }
  this.data.medium = value;
  return this.facade.retrieveProxy(ApplicationStateProxy.NAME).setMedium(value);
};

/**
 * Additional information about the vieo
*/
MediaProxy.prototype.getMetadata = function() {
  return this.data.metadata;
};

MediaProxy.prototype.setMetadata = function(value) {
  return this.data.metadata = value;
};

/**
 * The source object of the video.
*/
MediaProxy.prototype.getSource = function() {
  return this.data.source;
};

MediaProxy.prototype.setSource = function(value) {
  return this.data.source = value;
};

/**
 * The source object of the video.
*/
MediaProxy.prototype.getTrack = function() {
  return this.data.track;
};

MediaProxy.prototype.setTrack = function(value) {
  return this.data.track = value;
};

/**
 * The title of the video.
 *
 * @param {String} value
 *    The new title of the video
 * @returns {Boolean}
 *    The title of the video
 * @type {String}
*/
MediaProxy.prototype.getTitle = function() {
  return this.data.title;
};

MediaProxy.prototype.setTitle = function(value) {
  return this.data.title = value;
};

/**
 * The native width of the video.
*/
MediaProxy.prototype.getWidth = function() {
  return this.data.width;
};

MediaProxy.prototype.setWidth = function(value) {
  return this.data.width = value;
};

/**
 * The native width of the video.
*/
MediaProxy.prototype.getHeight = function() {
  return this.data.height;
};

MediaProxy.prototype.setHeight = function(value) {
  return this.data.height = value;
};

/**
 * The description of the video.
 *
 * @param {String} value
 *    The new description of the video
 * @returns {Boolean}
 *    The description of the video
 * @type {String}
*/
MediaProxy.prototype.getDescription = function() {
  return this.data.description;
};

MediaProxy.prototype.setDescription = function(value) {
  return this.data.description = value;
};

/**
 *
*/
MediaProxy.prototype.getCategory = function() {
  return this.data.category;
};

MediaProxy.prototype.setCategory = function(value) {
  return this.data.category = value;
};

/**
 * The duration of the video. This property is used in situations where the
 * duration cannot be determined from the video (i.e. before metadata is loaded)
 *
 * @param {Number} value
 *    The new duration of the video
 * @returns {Number}
 *    The duration of the video
 * @type {Number}
*/
MediaProxy.prototype.getDuration = function(value) {
  return this.data.duration;
};

MediaProxy.prototype.setDuration = function(value) {
  var ua;
  if (value === 0 || this.data.temporalType === "live") {
    return;
  }
  ua = navigator.userAgent;
  if (value === 1 && (/Android/.test(ua) && !/Android.*Chrome/.test(ua))) {
    return;
  }
  if (value !== this.data.duration) {
    this.data.duration = value;
    this.sendNotification(Notifications.DURATION_CHANGE, value);
  }
  if (value === Infinity) {
    this.setTemporalType("live");
  }
  return value;
};

/**
 * The poster image for the video.
 *
 * @param {String} value
 *    The url of the new poster image
 * @returns {String}
 *    The url of the poster image
 * @type {String}
*/
MediaProxy.prototype.getPoster = function(value) {
  return this.data.poster;
};

MediaProxy.prototype.setPoster = function(value) {
  this.data.poster = value;
};

/**
 *
*/
MediaProxy.prototype.getIsLive = function() {
  return this.data.isLive;
};

MediaProxy.prototype.setIsLive = function(value) {
  if (value === this.data.isLive) {
    return;
  }
  this.data.isLive = value;
  this.sendNotification(Notifications.IS_LIVE, value);
  return value;
};

/**
 *
*/
MediaProxy.prototype.getTemporalType = function() {
  return this.data.temporalType || "vod";
};

MediaProxy.prototype.setTemporalType = function(value) {
  var previous;
  if (value === this.data.temporalType) {
    return;
  }
  previous = this.data.temporalType;
  this.data.temporalType = value;
  this.sendNotification(Notifications.TEMPORAL_TYPE_CHANGE, {
    previous: previous,
    value: value
  });
};

/**
 *
*/
MediaProxy.prototype.getScenes = function() {
  return this.data.scenes;
};

MediaProxy.prototype.setScenes = function(value) {
  return this.data.scenes = value;
};

/**
 *
*/
MediaProxy.prototype.getCues = function() {
  return this.data.cues;
};

MediaProxy.prototype.setCues = function(value) {
  if (value == null) {
    value = [];
  }
  if (this.data.cues === value) {
    return;
  }
  this.data.cues = value;
  this.sendNotification(Notifications.CUES_CHANGE, value);
  return value;
};

/**
 *
*/
MediaProxy.prototype.getScene = function(currentTime) {
  var index, scene, _i, _len, _ref;
  if (!(this.data.scenes != null)) {
    return;
  }
  _ref = this.data.scenes;
  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
    scene = _ref[index];
    if ((scene.start <= currentTime && currentTime < scene.end)) {
      return scene;
    }
  }
};

/**
 *
*/
MediaProxy.prototype.getKeys = function() {
  return this.data.keys;
};

MediaProxy.prototype.setKeys = function(value) {
  this.data.keys = value;
};

/**
 *
*/
MediaProxy.prototype.getAuthorization = function() {
  return this.data.authorization;
};

MediaProxy.prototype.setAuthorization = function(value) {
  this.data.authorization = value;
};

/**
 *
*/
MediaProxy.prototype.getTransforms = function() {
  return this.transforms;
};

/**
 * Creates a new instance of SecurityProxy.
 *
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
*/
function SecurityProxy() {
  SecurityProxy.__super__.constructor.call(this, this.constructor.NAME, {});
  this.setupHDN1();
}


__extends(SecurityProxy, puremvc.Proxy);


/** @static
*/
SecurityProxy.NAME = "SecurityProxy";

SecurityProxy.prototype.authorized = true;

SecurityProxy.prototype.timeout = null;

/**
*/
SecurityProxy.prototype.setupHDN1 = function() {
  var _this = this;
  return window.retrieveToken = function(guid, url) {
    var token;
    try {
      _this.facade.logger.debug("[AMP AUTH] HDN1: Token Requested", guid, url);
      token = _this.getToken();
      if (token != null) {
        _this.facade.getMediaElement().tokenRetrievalSuccess("&primaryToken=" + token);
      } else {
        _this.sendNotification(SecurityNotifications.AUTHORIZE);
      }
    } catch (error) {
      _this.facade.logger.error("[AMP AUTH ERROR]: Token Retrival Error", error);
    }
    return true;
  };
};

/**
*/
SecurityProxy.prototype.setMedia = function(media) {
  this.setSession(null);
  this.setAuthorized(media.status.state !== "blocked");
  this.setAuthorization(media.authorization);
};

/**
*/
SecurityProxy.prototype.authorize = function(authorization) {
  this.setAuthorization(authorization);
  this.sendNotification(SecurityNotifications.AUTHORIZED, authorization);
};

/**
*/
SecurityProxy.prototype.getAuthorization = function() {
  return this.data;
};

SecurityProxy.prototype.setAuthorization = function(value) {
  if ((value != null ? value.token : void 0) != null) {
    this.setAuthorized(true);
  }
  this.data = value || {};
  if (this.data.expiration != null) {
    this.setExpiration(this.data.expiration);
  }
  return value;
};

/**
*/
SecurityProxy.prototype.getKey = function() {
  return this.data.key;
};

SecurityProxy.prototype.setKey = function(value) {
  this.data.key = value;
  return value;
};

/**
*/
SecurityProxy.prototype.getToken = function() {
  return this.data.token;
};

SecurityProxy.prototype.setToken = function(value) {
  this.data.token = value;
  return value;
};

/**
*/
SecurityProxy.prototype.getExpiration = function() {
  return this.data.expiration;
};

SecurityProxy.prototype.setExpiration = function(value) {
  this.data.expiration = value;
  if (this.data.expiration > Date.now()) {
    this.startTimeout();
  }
  return value;
};

/**
*/
SecurityProxy.prototype.startTimeout = function() {
  var _this = this;
  Utils.getUTC().then(function(time) {
    var timeout;
    timeout = function() {
      _this.sendNotification(SecurityNotifications.AUTHORIZATION_EXPIRED);
      _this.sendNotification(SecurityNotifications.AUTHORIZE, {
        media: _this.facade.getMedia()
      });
    };
    return _this.timeout = setTimeout(timeout, _this.getExpiration() - time);
  });
};

/**
*/
SecurityProxy.prototype.stopTimeout = function() {
  clearTimeout(this.timeout);
};

/**
*/
SecurityProxy.prototype.getSecret = function() {
  var secret;
  if (!(this.data.token != null)) {
    return null;
  }
  secret = "";
  if (this.data.token != null) {
    secret = "" + this.data.token;
  }
  if (this.data.key != null) {
    secret = "" + this.data.key + "=" + secret;
  }
  return secret;
};

/**
*/
SecurityProxy.prototype.createURL = function(url) {
  var secret;
  secret = this.getSecret();
  if (secret != null) {
    url += !/\?/.test(url) ? "?" : "&";
    url += secret;
  }
  return url;
};

/**
*/
SecurityProxy.prototype.getAuthorized = function() {
  return this.authorized;
};

SecurityProxy.prototype.setAuthorized = function(value) {
  this.stopTimeout();
  this.authorized = value;
  return value;
};

/**
*/
SecurityProxy.prototype.getSession = function() {
  return this.session;
};

SecurityProxy.prototype.setSession = function(value) {
  this.session = value;
  return value;
};

/**
 * @constructor
 * @private
 * @extends {Error}
 * @param {string} msg
*/
function TokenizationError(msg) {
  this.message = TokenizationError.MESSAGE + msg;
}


__extends(TokenizationError, Error);


TokenizationError.MESSAGE = "Tokenization Error: Could not find token value for: ";

/**
 * @constructor
 * @private
 * @extends {TokenizedBase}
 * @param {string|number|boolean} source
*/
function Literal(source) {
  Literal.__super__.constructor.call(this, source);
}


__extends(Literal, TokenizedBase);


/**
 * Populates the data property with tokenized values
 * 
 * @param   source  The tokenized data structure.
 * @return          The parsed data structure.
*/
Literal.prototype.parse = function(data) {
  this.source = this.data = this.value = data;
  return data;
};

/**
 * Compiles the tokenized values in the data property
 * and saves them to the value property. As a convenience
 * this function returns the value property.
 * 
 * @param context     An object who's properties can be called from within a token
 * @param suppressErrors  Flag indicating wether or not to suppress errors. Useful when certain context items are known not to exist.
 * @return          The compile value object.
*/
Literal.prototype.compile = function(context, suppressErrors) {
  if (context == null) {
    context = null;
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  return this.value;
};

/**
 * @constructor
 * @private
 * @extends {TokenizedBase}
 * @param {string} source
*/
function Token(source) {
  Token.__super__.constructor.call(this, source);
}


__extends(Token, TokenizedBase);


/**
 * The function used to evaluate a token value
*/
Token.prototype.exec = null;

/**
 *
*/
Token.prototype.parse = function(source) {
  this.source = this.data = source;
  this.exec = new Function("context", 'var value; with(context){value = ' + this.data + ';}return value;');
  return this.data;
};

/**
 *
*/
Token.prototype.compile = function(context, suppressErrors) {
  if (context == null) {
    context = {};
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  if (!(this.exec != null)) {
    return this.value;
  }
  try {
    this.value = this.exec(context);
  } catch (error) {
    this.value = null;
    if (!suppressErrors) {
      throw new TokenizationError(this.data);
    }
  }
  return this.value;
};

/**
 * @constructor
 * @private
 * @extends {TokenizedBase}
 * @param {string} source
*/
function TokenizedValue(source) {
  this.token = new RegExp(this.tokenStart.source + "([^\$#]*)" + this.tokenEnd.source, "g");
  TokenizedValue.__super__.constructor.call(this, source);
}


__extends(TokenizedValue, TokenizedBase);


/**
 * The function used to evaluate a token value
*/
TokenizedValue.prototype.exec = null;

/**
 * The literal value after compiliation
*/
TokenizedValue.prototype.tokenStart = /[\$#]{/;

TokenizedValue.prototype.tokenEnd = /}/;

TokenizedValue.prototype.token = null;

/**
 *
*/
TokenizedValue.prototype.parse = function(source) {
  var piece, pieces, placeholder, spacer, temp, token, tokens, _i, _len;
  this.source = source;
  this.data = [];
  if (this.token.test(this.source)) {
    tokens = [];
    placeholder = "<<>>";
    spacer = null;
    temp = this.source.replace(this.token, function(match, token, offset, string) {
      tokens.push(token);
      spacer = placeholder;
      if ((0 < offset && offset < string.length - match.length)) {
        spacer += placeholder;
      }
      return spacer;
    });
    pieces = temp.split(placeholder);
    token = 0;
    for (_i = 0, _len = pieces.length; _i < _len; _i++) {
      piece = pieces[_i];
      if (piece === "" && tokens[token]) {
        this.data.push(new Token(tokens[token]));
        token++;
      } else {
        if (piece !== "") {
          this.data.push(new Literal(piece));
        }
      }
    }
    if (this.data.length === 1) {
      this.data = this.data[0];
    }
  } else {
    this.data = new Literal(source);
  }
  return this.data;
};

/**
 *
*/
TokenizedValue.prototype.compile = function(context, suppressErrors) {
  var token, _i, _len, _ref;
  if (context == null) {
    context = {};
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  if (!(this.data != null)) {
    return this.value;
  }
  try {
    if (this.data instanceof ITokenized) {
      this.value = this.data.compile(context, suppressErrors);
    } else {
      this.value = "";
      _ref = this.data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        token = _ref[_i];
        this.value += token.compile(context, suppressErrors);
      }
    }
  } catch (error) {
    this.value = null;
    if (!suppressErrors) {
      throw new TokenizationError(this.source);
    }
  }
  return this.value;
};

/**
 * @constructor
 * @private
 * @extends {TokenizedBase}
 * @param {Object} source
*/
function TokenizedObject(source) {
  TokenizedObject.__super__.constructor.call(this, source);
}


__extends(TokenizedObject, TokenizedBase);


/**
 *
*/
TokenizedObject.prototype.parse = function(source) {
  var key, token;
  this.source = source;
  this.data = {};
  for (key in source) {
    token = source[key];
    this.data[key] = TokenizedObject.__super__.parse.call(this, token);
  }
  return this.data;
};

/**
 *
*/
TokenizedObject.prototype.compile = function(context, suppressErrors) {
  var key, value, _ref;
  if (context == null) {
    context = {};
  }
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  this.value = {};
  _ref = this.data;
  for (key in _ref) {
    value = _ref[key];
    try {
      this.value[key] = value.compile(context, suppressErrors);
    } catch (error) {
      this.value[key] = null;
      Logger.instance.error(error);
    }
  }
  return this.value;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var DisplayState = {
  /**
   * Constant representing the normal display state
  */

  NORMAL: "normal",
  /**
   * Constant representing the full screen display state
  */

  FULL_SCREEN: "full-screen"
};

/**
 * The DataBoundConfigurationProxy class.
 *   
 * @constructor
 * @private
 * @extends {ModuleProxy}
 * @param {Object} data
*/
function DataBoundConfigurationProxy(data) {
  DataBoundConfigurationProxy.__super__.constructor.call(this, data);
}


__extends(DataBoundConfigurationProxy, ModuleProxy);


/** @static
*/
DataBoundConfigurationProxy.NAME = ModuleProxy.NAME;

DataBoundConfigurationProxy.prototype.bindings = null;

DataBoundConfigurationProxy.prototype.configurationName = null;

DataBoundConfigurationProxy.prototype.configurationData = null;

DataBoundConfigurationProxy.prototype.contextName = null;

DataBoundConfigurationProxy.prototype.contextData = null;

DataBoundConfigurationProxy.prototype.value = null;

DataBoundConfigurationProxy.prototype.getConfigurationName = function() {
  return this.configurationName;
};

DataBoundConfigurationProxy.prototype.getConfigurationData = function() {
  return this.configurationData.value || {};
};

DataBoundConfigurationProxy.prototype.getContextName = function() {
  return this.contextName;
};

DataBoundConfigurationProxy.prototype.getContextData = function() {
  return this.contextData;
};

DataBoundConfigurationProxy.prototype.onRegister = function() {
  var base;
  base = this.facade.player || this.facade;
  if (!(this.getConfigurationName() != null)) {
    this.configurationName = this.facade.moduleName;
  }
  this.bindings = base.retrieveProxy(DataBindingProxy.NAME);
  this.bindings.registerConfiguration(this);
  if (!(this.getContextName() != null)) {
    return;
  }
  this.bindings.registerContext(this);
};

DataBoundConfigurationProxy.prototype.setData = function(data) {
  var key, value, _ref;
  if (data == null) {
    data = {};
  }
  this.data = {};
  _ref = this.getDefaults();
  for (key in _ref) {
    value = _ref[key];
    this.data[key] = key in data ? data[key] : value;
  }
  this.configurationData = new TokenizedObject(this.data);
  return this.data;
};

DataBoundConfigurationProxy.prototype.getValue = function(key) {
  var _ref;
  this.bindings.update();
  this.value[key] = (_ref = this.configurationData.data[key]) != null ? _ref.compile(this.bindings.getData()) : void 0;
  return this.value[key];
};

DataBoundConfigurationProxy.prototype.compile = function(context, suppressErrors) {
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  if (!(this.configurationData != null)) {
    return null;
  }
  if (!(context != null)) {
    context = this.bindings.getData();
  }
  if ((this.contextName != null) && (this.contextData != null)) {
    context = Utils.clone(context);
    context[this.contextName] = this.contextData;
  }
  this.configurationData.compile(context, suppressErrors);
  this.value = this.configurationData.value;
  return this.configurationData.value;
};

/** 
 * @constructor 
 * @private
*/
function ParamsProxy(data) {
  ParamsProxy.__super__.constructor.call(this, data);
}


__extends(ParamsProxy, DataBoundConfigurationProxy);


/** @static
*/
ParamsProxy.NAME = "ParamsProxy";

ParamsProxy.prototype.defaults = {};

ParamsProxy.prototype.configurationName = "params";

/** @override
*/
ParamsProxy.prototype.setData = function(data) {
  var key, value, _ref;
  this.data = ((_ref = this.configurationData) != null ? _ref.source : void 0) || {};
  for (key in data) {
    value = data[key];
    this.data[key] = data[key];
  }
  this.configurationData = new TokenizedObject(this.data);
  return this.data;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var PlayState = {
  /**
   * Constant representing the playing play state
  */

  READY: "ready",
  /**
   * Constant representing the playing play state
  */

  PLAYING: "playing",
  /**
   * Constant representing the paused play state
  */

  PAUSED: "paused",
  /**
   * Constant representing the ended play state
  */

  ENDED: "ended",
  /**
   * Constant representing the waiting play state
  */

  LOADING: "loading",
  /**
   * Constant representing the waiting play state
  */

  WAITING: "waiting",
  /**
   * Constant representing the waiting play state
  */

  ERROR: "error"
};

/** 
 * @constructor 
 * @private
*/
function DataBindingProxy() {
  DataBindingProxy.__super__.constructor.call(this, this.constructor.NAME, {});
  this.data = {};
  this.contextMap = {};
  this.configurationMap = {};
}


__extends(DataBindingProxy, puremvc.Proxy);


/** @static
*/
DataBindingProxy.NAME = "DataBindingProxy";

DataBindingProxy.prototype.contextMap = null;

DataBindingProxy.prototype.configurationMap = null;

DataBindingProxy.prototype.paramsProxy = null;

/**
*/
DataBindingProxy.prototype.initialize = function() {
  this.paramsProxy = this.facade.retrieveProxy(ParamsProxy.NAME);
  this.update();
};

/**
*/
DataBindingProxy.prototype.registerContext = function(context) {
  if (!(context != null)) {
    return;
  }
  this.contextMap[context.getContextName()] = context;
};

/**
*/
DataBindingProxy.prototype.retrieveContext = function(name) {
  return this.contextMap[name];
};

/**
*/
DataBindingProxy.prototype.removeContext = function(name) {
  var context;
  context = this.contextMap[name];
  delete this.contextMap[name];
  return context;
};

/**
*/
DataBindingProxy.prototype.registerConfiguration = function(config) {
  if (!(config != null)) {
    return;
  }
  this.configurationMap[config.getConfigurationName()] = config;
  config.compile(this.context, true);
};

/**
*/
DataBindingProxy.prototype.retrieveConfiguration = function(name) {
  return this.configurationMap[name];
};

/**
*/
DataBindingProxy.prototype.removeConfiguration = function(name) {
  var config;
  config = this.configurationMap[name];
  delete this.configurationMap[name];
  return config;
};

/**
*/
DataBindingProxy.prototype.evaluateBinding = function(str) {
  var tokenizedObject;
  this.update();
  tokenizedObject = new TokenizedValue(str);
  tokenizedObject.compile(this.data);
  return tokenizedObject.value;
};

/**
*/
DataBindingProxy.prototype.update = function(contexts) {
  var context, key, name, value, _ref, _ref1;
  this.data.now = Date.now();
  _ref = this.contextMap;
  for (name in _ref) {
    context = _ref[name];
    if ((contexts != null ? typeof contexts.indexOf === "function" ? contexts.indexOf(name) : void 0 : void 0) === -1) {
      continue;
    }
    this.data[name] = context.getContextData();
  }
  this.paramsProxy.compile(this.data);
  _ref1 = this.paramsProxy.value;
  for (key in _ref1) {
    value = _ref1[key];
    this.data[key] = value;
  }
  return this.data;
};

/**
*/
DataBindingProxy.prototype.compile = function(contexts, suppressErrors) {
  var config, context, name, paramsName, _ref;
  if (suppressErrors == null) {
    suppressErrors = false;
  }
  this.update(contexts);
  context = Utils.clone(this.data);
  paramsName = this.paramsProxy.getConfigurationName();
  _ref = this.configurationMap;
  for (name in _ref) {
    config = _ref[name];
    if (name !== paramsName) {
      config.compile(context, suppressErrors);
    }
  }
};

/**
 * @enum {string}
 * @const
 * @private
*/

var RenderMode = {
  /**
   * Constant representing the flash renderer.
  */

  FLASH: "flash",
  /**
   * Constant representing the html renderer.
  */

  HTML: "html"
};

/**
 * @enum {string}
 * @const
 * @private
*/

var ActiveState = {
  /**
   * Constant representing the active state (controls on).
  */

  ACTIVE: "active",
  /**
   * Constant representing the inactive state (controls off).
  */

  INACTIVE: "inactive"
};

/**
 * @enum {string}
 * @const
 * @private
*/

var PluginNotifications = {
  REGISTER_PLUGINS: "registerPlugins",
  PLUGIN_REGISTERED: "pluginRegistered",
  PLUGINS_INITIALIZED: "pluginsinitialized"
};

/**
 * Used to track the various states of the player like full screen mode and active state (controls visible).
 *
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
*/
function ApplicationStateProxy() {
  ApplicationStateProxy.__super__.constructor.call(this);
  this.device = Utils.getDevice();
}


__extends(ApplicationStateProxy, puremvc.Proxy);


/** @static
*/
ApplicationStateProxy.NAME = "ApplicationStateProxy";

/** @private
*/
ApplicationStateProxy.prototype.displayState = DisplayState.NORMAL;

ApplicationStateProxy.prototype.playState = null;

ApplicationStateProxy.prototype.renderMode = null;

ApplicationStateProxy.prototype.activeState = null;

ApplicationStateProxy.prototype.seeking = false;

ApplicationStateProxy.prototype.seekrequested = false;

ApplicationStateProxy.prototype.waiting = false;

ApplicationStateProxy.prototype.isUserActive = false;

ApplicationStateProxy.prototype.device = null;

ApplicationStateProxy.prototype.volume = 1;

ApplicationStateProxy.prototype.playbackTarget = "amp";

ApplicationStateProxy.prototype.hasPostContent = false;

ApplicationStateProxy.prototype.locked = false;

ApplicationStateProxy.prototype.mediaElement = null;

ApplicationStateProxy.prototype.hidden = false;

ApplicationStateProxy.prototype.pausedBeforeSeek = false;

ApplicationStateProxy.prototype.ended = false;

ApplicationStateProxy.prototype.buffering = false;

/**
 * Flag indicating whether or not the media will have additional
 * content playback after the media playback is complete
 *
 * @param {Boolean} value
 *    The post content flag
 * @returns {Boolean}
 *    The post content flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getHasPostContent = function() {
  return this.hasPostContent;
};

ApplicationStateProxy.prototype.setHasPostContent = function(value) {
  this.hasPostContent = value;
};

/**
 * Flag indicating whether or not the media playback is complete
 *
 * @param {Boolean} value
 *    The ended flag
 * @returns {Boolean}
 *    The ended flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getEnded = function() {
  return this.ended;
};

ApplicationStateProxy.prototype.setEnded = function(value) {
  this.ended = value;
  if (this.ended === true && this.seeking === true) {
    this.seeking = false;
  }
};

/**
 * The player's display state. Valid options are:
 *
 * ApplicationStateProxy.FULL_SCREEN
 * ApplicationStateProxy.NORMAL
 *
 * @param {String} value
 *    The new display state of the player
 * @returns {String}
 *    The display state of the player
 * @type {String}
*/
ApplicationStateProxy.prototype.getDisplayState = function() {
  return this.displayState;
};

ApplicationStateProxy.prototype.setDisplayState = function(value) {
  var previous;
  if (value === this.displayState) {
    return;
  }
  previous = this.displayState;
  this.displayState = value;
  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, {
    previous: previous,
    value: this.displayState
  });
};

/**
 * The player's display state. Valid options are:
 *
 * ApplicationStateProxy.FULL_SCREEN
 * ApplicationStateProxy.NORMAL
 *
 * @param {String} value
 *    The new display state of the player
 * @returns {String}
 *    The display state of the player
 * @type {String}
*/
ApplicationStateProxy.prototype.getPlayState = function() {
  return this.playState;
};

ApplicationStateProxy.prototype.setPlayState = function(value) {
  var previous;
  if (this.getWaiting() === true) {
    this.setWaiting(false);
  }
  if (value === this.playState) {
    return;
  }
  previous = this.playState;
  this.playState = value;
  this.sendNotification(Notifications.PLAY_STATE_CHANGE, {
    previous: previous,
    value: this.playState
  });
  switch (value) {
    case PlayState.PLAYING:
      this.sendNotification(Notifications.DISPATCH_EVENT, new Event("playing"));
      break;
    case PlayState.ENDED:
      this.pausedBeforeSeek = false;
  }
};

/**
 * The player's device.
 *
 *
 * @returns {String}
 *    The display state of the player
 * @type {String}
*/
ApplicationStateProxy.prototype.getDevice = function() {
  return this.device;
};

/**
 * Indicates whether or not the player is seeking
 *
 * @param {Boolean} value
 *    The seeking flag
 * @returns {Boolean}
 *    The seeking flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getSeeking = function() {
  return this.seeking;
};

ApplicationStateProxy.prototype.setSeeking = function(value) {
  if (value === this.seeking) {
    return;
  }
  this.seeking = value;
  if (this.seeking === false && this.playState === PlayState.PAUSED && this.getWaiting() === true) {
    this.setWaiting(false);
  }
};

/**
 * Indicates whether or not a seek has been requested.
 * This is only set when a seek is requested while
 * a previously requested seek is in progress
 *
 * @param {Boolean} value
 *    The seekrequested flag
 * @returns {Boolean}
 *    The seekrequested flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getSeekRequested = function() {
  return this.seekrequested;
};

ApplicationStateProxy.prototype.setSeekRequested = function(value) {
  if (value === this.seekrequested) {
    return;
  }
  this.seekrequested = value;
};

/**
 * Indicates whether or not the player is waiting
 *
 * @param {Boolean} value
 *    The waiting flag
 * @returns {Boolean}
 *    The waiting flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getWaiting = function() {
  return this.waiting;
};

ApplicationStateProxy.prototype.setWaiting = function(value) {
  var handler, mediaElement, note,
    _this = this;
  if (value === this.waiting) {
    return;
  }
  this.waiting = value;
  note = this.waiting === true ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
  this.sendNotification(note, PlayState.WAITING);
  if (this.waiting === true) {
    mediaElement = this.facade.getMediaElement();
    handler = function(event) {
      _this.facade.removeEventListener("playing", handler);
      _this.facade.removeEventListener("canplaythrough", handler);
      _this.facade.removeEventListener("ended", handler);
      _this.setWaiting(false);
    };
    this.facade.addEventListener("playing", handler);
    this.facade.addEventListener("canplaythrough", handler);
    this.facade.addEventListener("ended", handler);
  }
};

/**
 * Indicates whether or not the player is locked.
 * A lock player will not autoplay even if configured
 * to do so.
 *
 * @param {Boolean} value
 *    The locked flag
 * @returns {Boolean}
 *    The locked flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getLocked = function() {
  return this.locked;
};

ApplicationStateProxy.prototype.setLocked = function(value) {
  this.locked = value;
};

/**
 * Indicates whether or not the player is buffering.
 *
 * @param {Boolean} value
 *    The buffering flag
 * @returns {Boolean}
 *    The buffering flag
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getBuffering = function() {
  return this.buffering;
};

ApplicationStateProxy.prototype.setBuffering = function(value) {
  this.buffering = value;
};

/**
 * Indicates whether or not the user is currently interacting with the player
 *
 * @param {Boolean} value
 *
 * @returns {Boolean}
 *
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getIsUserActive = function() {
  return this.isUserActive;
};

ApplicationStateProxy.prototype.setIsUserActive = function(value) {
  if (value !== this.isUserActive) {
    this.isUserActive = value;
  }
};

/**
 * The core type used for rendering the video.
 *
 * @param {String} value
 *    The new currentTime value in seconds
 * @returns {Number}
 *    The currentTime value in seconds
 * @type {Number}
*/
ApplicationStateProxy.prototype.getRenderMode = function() {
  return this.renderMode;
};

ApplicationStateProxy.prototype.setRenderMode = function(value) {
  if (value !== this.renderMode) {
    this.renderMode = value;
  }
};

/**
 * The medium the player is currently playing. Valid options are:
 *
 * "audio"
 * "video"
 *
 * @param {String} value
 *    The new medium
 *
 * @returns {String}
 *    The current medium
 *
 * @type {String}
*/
ApplicationStateProxy.prototype.getMedium = function() {
  return this.medium;
};

ApplicationStateProxy.prototype.setMedium = function(value) {
  var previous;
  if (value === this.medium) {
    return;
  }
  previous = this.medium != null ? "medium-" + this.medium : this.medium;
  this.medium = value;
  this.sendNotification(Notifications.MEDIUM_CHANGE, {
    previous: previous,
    value: "medium-" + this.medium
  });
};

/**
 * The player's volume as a value between 0 and 1.
 *
 * @param {Number} value
 *    The new volume
 *
 * @returns {Number}
 *    The current volume
 *
 * @type {Number}
*/
ApplicationStateProxy.prototype.getVolume = function() {
  return this.volume;
};

ApplicationStateProxy.prototype.setVolume = function(value) {
  if (value === this.volume) {
    return;
  }
  return this.volume = value;
};

/**
 * The playback target. i.e. "amp", "chromecast", "airplay"
 *
 * @param {Number} value
 *    The new volume
 *
 * @returns {Number}
 *    The current volume
 *
 * @type {Number}
*/
ApplicationStateProxy.prototype.getPlaybackTarget = function() {
  return this.playbackTarget;
};

ApplicationStateProxy.prototype.setPlaybackTarget = function(value) {
  var previous;
  if (value === this.playbackTarget) {
    return;
  }
  previous = this.playbackTarget;
  this.playbackTarget = value;
  this.sendNotification(Notifications.PLAYBACK_TARGET_CHANGE, {
    previous: previous,
    value: this.playbackTarget
  });
};

/**
 * The active state of the player. Used to display controls.
 *
 * @param {Boolean} value
 *    The new active state of the video
 * @returns {Boolean}
 *    The active state of the video
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getActiveState = function() {
  return this.activeState;
};

ApplicationStateProxy.prototype.setActiveState = function(value) {
  var previous;
  if (value === this.activeState) {
    return;
  }
  previous = this.activeState;
  this.activeState = value;
  this.sendNotification(Notifications.ACTIVE_STATE_CHANGE, {
    previous: previous,
    value: this.activeState
  });
};

/**
 * The player's media element
 *
 * @param {HTMLElement} value
 *    The new media element
 * @returns {HTMLElement}
 *    The media element
 * @type {HTMLElement}
*/
ApplicationStateProxy.prototype.getMediaElement = function() {
  return this.mediaElement;
};

ApplicationStateProxy.prototype.setMediaElement = function(value) {
  var previous;
  if (value === this.mediaElement) {
    return;
  }
  previous = this.mediaElement;
  this.mediaElement = value;
  this.sendNotification(Notifications.MEDIA_ELEMENT_CHANGE, {
    previous: previous,
    value: this.mediaElement
  });
};

/**
 * The player's hidden state
 *
 * @param {Boolean} value
 *    The new hidden state
 * @returns {Boolean}
 *    The hidden state
 * @type {Boolean}
*/
ApplicationStateProxy.prototype.getHidden = function() {
  return this.hidden;
};

ApplicationStateProxy.prototype.setHidden = function(value) {
  var previous;
  if (value === this.hidden) {
    return;
  }
  previous = this.hidden;
  this.hidden = value;
  this.sendNotification(Notifications.HIDDEN_CHANGE, {
    previous: previous,
    value: this.hidden
  });
};

/**
 * The ExternalMediaProxy class.
 * 
 * @constructor
 * @private
 * @extends {MediaProxy}
*/
function ExternalMediaProxy() {
  ExternalMediaProxy.__super__.constructor.call(this);
}


__extends(ExternalMediaProxy, MediaProxy);


/** @static
*/
ExternalMediaProxy.NAME = "MediaProxy";

/**
 * The source object of the video.
*/
ExternalMediaProxy.prototype.setSource = function(value) {
  if (!(value != null) || value.length < 1) {
    return;
  }
  value = value.filter(function(item) {
    return item.type === "external";
  });
  return ExternalMediaProxy.__super__.setSource.call(this, value);
};

/**
 * The ExternalPlaybackProxy class.
 * 
 * @constructor
 * @private
 * @extends {puremvc.Proxy}
*/
function ExternalPlaybackProxy() {
  ExternalPlaybackProxy.__super__.constructor.call(this);
}


__extends(ExternalPlaybackProxy, puremvc.Proxy);


/**
 * The name of the this Proxy.
 * 
 * @static
 * @type {string}
*/
ExternalPlaybackProxy.NAME = "PlaybackProxy";

/** @private
*/
ExternalPlaybackProxy.prototype.src = null;

/**
*/
ExternalPlaybackProxy.prototype.getPlaybackCoreName = function() {
  return "external";
};

/**
 * Determines if the core can play a given mimeType.
 * 
 * @return {String} "" if the core can't play the mimeType
*/
ExternalPlaybackProxy.prototype.canPlayType = function(mimeType) {
  return mimeType === "external";
};

/**
 *
*/
ExternalPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {
  return true;
};

/**     
 * The current time of the video in seconds. Value must be between currentTime and duration.
 * 
 * @param {Number} value
 *    The new currentTime value in seconds
 * @returns {Number} 
 *    The currentTime value in seconds
 * @type {Number}
*/
ExternalPlaybackProxy.prototype.getSrc = function() {
  return this.facade.mediaProxy.getSrc();
};

/**
 * Instructs the core to play.
*/
ExternalPlaybackProxy.prototype.play = function() {
  window.open(this.getSrc(), "_blank");
};

ExternalPlaybackProxy.prototype.load = function() {};

ExternalPlaybackProxy.prototype.setVolume = function() {};

ExternalPlaybackProxy.prototype.pause = function() {};

ExternalPlaybackProxy.prototype.setEnabled = function() {};

ExternalPlaybackProxy.prototype.getCurrentTime = function() {
  return 0;
};

ExternalPlaybackProxy.prototype.setCurrentTime = function(value) {};

ExternalPlaybackProxy.prototype.getDuration = function() {
  return 0;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var UserNotifications = {
  TOGGLE_PLAY_PAUSE: "usertogglePlayPause",
  PLAY: "userplay",
  PAUSE: "userpause",
  SEEK: "userseek",
  SEEKED: "userseeked",
  GO_LIVE: "usergolive"
};

/** 
 * The PluginProxy class.
 *   
 * @param {Object} config
 * @constructor
 * @private
 * @extends {DataBoundConfigurationProxy}
*/
function PluginProxy(config) {
  PluginProxy.__super__.constructor.call(this, config);
}


__extends(PluginProxy, DataBoundConfigurationProxy);


/** @static
*/
PluginProxy.NAME = ModuleProxy.NAME;

PluginProxy.prototype.enabled = true;

PluginProxy.prototype.plugin = null;

PluginProxy.prototype.appState = null;

/**
*/
PluginProxy.prototype.getDefaults = function() {
  var defaults;
  defaults = PluginProxy.__super__.getDefaults.call(this);
  if (!(defaults.debug != null)) {
    defaults.debug = null;
  }
  return defaults;
};

/** @override
*/
PluginProxy.prototype.initializeNotifier = function(key) {
  PluginProxy.__super__.initializeNotifier.call(this, key);
  this.appState = this.facade.player.appState;
};

/**
*/
PluginProxy.prototype.getMediaElement = function() {
  return this.facade.player.getMediaElement();
};

/**
*/
PluginProxy.prototype.setEnabled = function(value) {
  this.enabled = value;
  return value;
};

PluginProxy.prototype.getEnabled = function() {
  return this.enabled;
};

/**
*/
PluginProxy.prototype.getDebug = function() {
  if (this.value.debug != null) {
    return this.value.debug;
  } else {
    return this.facade.player.getConfig().debug === true;
  }
};

/**
*/
PluginProxy.prototype.createPlugin = function() {};

/**
*/
PluginProxy.prototype.initialize = function() {
  this.plugin = this.createPlugin();
};

/**
*/
PluginProxy.prototype.error = function(err) {
  this.facade.logger.error("[AMP " + (this.facade.getModuleName().toUpperCase()) + " Error]", err);
};

/**
 * @enum {string}
 * @const
 * @private
*/

var Namespace = {
  PREFIX: "akamai-"
};

/**
 * The Plugin class. Acts as a base for plugins.
 *
 * @constructor
 * @private
 * @extends {Module}
*/
function Plugin() {
  Plugin.__super__.constructor.call(this);
}


__extends(Plugin, Module);


Plugin.prototype.player = null;

Plugin.prototype.proxy = null;

/**
 * @override
*/
Plugin.prototype.initialize = function(config, player) {
  this.player = player;
  this.logger = this.player.logger;
  Plugin.__super__.initialize.call(this, config, player);
};

/**
*/
Plugin.prototype.isAvailable = function() {
  return true;
};

/**
*/
Plugin.prototype.loadModuleResources = function() {
  if (!this.isAvailable()) {
    return Promise.resolve();
  }
  return Plugin.__super__.loadModuleResources.call(this);
};

/**
 * @override
*/
Plugin.prototype.resourcesLoaded = function() {
  if (typeof this.oninitialized === "function") {
    this.oninitialized(this);
  }
};

/** @override
*/
Plugin.prototype.onRegister = function() {
  var _ref;
  if (this.isAvailable()) {
    this.createFramework();
    if ((_ref = this.retrieveProxy(PluginProxy.NAME)) != null) {
      if (typeof _ref.initialize === "function") {
        _ref.initialize();
      }
    }
  }
  this.performance.ready = Date.now();
  this.sendNotification(PluginNotifications.PLUGIN_REGISTERED, this);
};

/** @override
*/
Plugin.prototype.logEvent = function(event) {
  var prefix;
  if (/(timeupdate|timeremaining)/.test(event.type) === true) {
    return;
  }
  prefix = this.player.getModuleName().toUpperCase() + " " + this.getModuleName().toUpperCase();
  if (event.dispatcher != null) {
    prefix += " " + event.dispatcher;
  }
  this.logger.log("[" + prefix + " EVENT] " + event.type, event);
};

/** @override
*/
Plugin.prototype.listNotificationPublications = function() {
  var key, notes, value;
  notes = [Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.IS_USER_ACTIVE, Notifications.PLAYBACK_CORE_CHANGE];
  return notes.concat((function() {
    var _results;
    _results = [];
    for (key in PluginNotifications) {
      value = PluginNotifications[key];
      _results.push(value);
    }
    return _results;
  })());
};

/**
 * The ChangePlayStateCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangePlayStateCommand() {
  ChangePlayStateCommand.__super__.constructor.call(this);
}


__extends(ChangePlayStateCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangePlayStateCommand.prototype.execute = function(notification) {
  this.applicationState.setPlayState(notification.getBody());
};

/**
 * The ChangeMediaCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeMediaCommand() {
  ChangeMediaCommand.__super__.constructor.call(this);
}


__extends(ChangeMediaCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeMediaCommand.prototype.execute = function(notification) {
  var media;
  try {
    media = this.media.setData(notification.getBody());
  } catch (error) {
    this.sendNotification(Notifications.ERROR, error.message);
    return;
  }
  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);
  media = this.media.getData();
  this.security.setMedia(media);
  if (this.security.getAuthorized()) {
    this.sendNotification(SecurityNotifications.AUTHORIZED, this.security.getAuthorization());
  } else {
    this.sendNotification(SecurityNotifications.AUTHORIZE, {
      media: media
    });
  }
};

/**
 * The SetMediaCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function SetMediaCommand() {
  SetMediaCommand.__super__.constructor.call(this);
}


__extends(SetMediaCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
SetMediaCommand.prototype.execute = function(notification) {
  var media,
    _this = this;
  media = notification.getBody();
  this.applicationState.setBuffering(false);
  this.applicationState.setEnded(false);
  this.playback.setEnabled(false);
  this.playback.pause();
  this.tracks.clear();
  this.sendNotification(Notifications.HAS_POST_CONTENT, false);
  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);
  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);
  this.media.transform(media).then(function(result) {
    return _this.sendNotification(Notifications.CHANGE_MEDIA, result);
  })["catch"](function(error) {
    return _this.sendNotification(Notifications.ERROR, error);
  });
};

/**
 * The ChangeDurationCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeDurationCommand() {
  ChangeDurationCommand.__super__.constructor.call(this);
}


__extends(ChangeDurationCommand, PlayerCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ChangeDurationCommand.prototype.execute = function(notification) {
  var duration;
  duration = notification.getBody();
  if (this.media.getDuration() === duration) {
    return;
  }
  this.media.setDuration(duration);
};

/**
 * The ErrorCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function ErrorCommand() {
  ErrorCommand.__super__.constructor.call(this);
}


__extends(ErrorCommand, PlayerEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ErrorCommand.prototype.execute = function(notification) {
  var core, error;
  this.playback.destroy();
  core = this.playback.getMediaElement();
  EventHandler.clear(core);
  error = notification.getBody();
  this.logger.error("[AMP ERROR]", error);
  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ERROR);
  this.facade.error = error;
  ErrorCommand.__super__.execute.call(this, notification);
};

/**
 * The ReadyCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function ReadyCommand() {
  ReadyCommand.__super__.constructor.call(this);
}


__extends(ReadyCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ReadyCommand.prototype.execute = function(notification) {
  var volume, _ref;
  volume = (_ref = this.facade.config) != null ? _ref.volume : void 0;
  if (volume != null) {
    this.sendNotification(Notifications.CHANGE_VOLUME, volume);
  }
  this.playerCore.ready();
  if (this.facade.config.autoplay === true) {
    this.sendNotification(Notifications.ADD_APPLICATION_STATE, "autoplay");
  }
  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);
  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);
  this.dispatchEventAfterCommand(notification);
};

/**
 * The UpdateDataBindingsCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function UpdateDataBindingsCommand() {
  UpdateDataBindingsCommand.__super__.constructor.call(this);
}


__extends(UpdateDataBindingsCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
UpdateDataBindingsCommand.prototype.execute = function(notification) {
  var body;
  body = notification.getBody() || {};
  this.bindings.compile(body.contexts, body.suppressErrors);
};

/**
 * The ChangeParamsCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function ChangeParamsCommand() {
  ChangeParamsCommand.__super__.constructor.call(this);
}


__extends(ChangeParamsCommand, PlayerCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChangeParamsCommand.prototype.execute = function(notification) {
  this.params.setData(notification.getBody());
  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {
    suppressErrors: true
  });
};

/**
 * The MediaChangeCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerEventCommand}
*/
function MediaChangeCommand() {
  MediaChangeCommand.__super__.constructor.call(this);
}


__extends(MediaChangeCommand, PlayerEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
MediaChangeCommand.prototype.execute = function(notification) {
  var media, playback;
  media = notification.getBody();
  this.playerCore.setPlaybackCore(media);
  playback = this.playerCore.getActivePlaybackCore() || this.player.playback;
  playback.reset();
  playback.setCurrentTime(media.startTime || 0);
  MediaChangeCommand.__super__.execute.call(this, notification);
};

/**
 * The OverlayLayerMediator class.
 * 
 * @constructor
 * @private
 * @extends {LayerMediator}
*/
function OverlayLayerMediator() {
  OverlayLayerMediator.__super__.constructor.call(this);
}


__extends(OverlayLayerMediator, LayerMediator);


OverlayLayerMediator.prototype.componentName = "overlays";

OverlayLayerMediator.NAME = "OverlayLayerMediator";

/**
*/
OverlayLayerMediator.prototype.createMediatorName = function() {
  return OverlayLayerMediator.NAME;
};

/**
 * Overridden so this class may subscribe to all notifications
 * @return An Array
 * 
 * @override
*/
OverlayLayerMediator.prototype.listNotificationInterests = function() {
  return [Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY];
};

/**
 * Handles notifications of interest to this mediator. Note that
 * the default declaration is to allow the super to handle the
 * note. This leaves the base JunctionMediator to handle things
 * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE  
 * 
 * @param note An INotification
 * @override
*/
OverlayLayerMediator.prototype.handleNotification = function(notification) {
  var name, overlay;
  name = notification.getName();
  overlay = notification.getBody();
  switch (name) {
    case Notifications.ADD_OVERLAY:
      this.viewComponent.appendChild(overlay);
      break;
    case Notifications.REMOVE_OVERLAY:
      this.viewComponent.removeChild(overlay);
  }
};

/**
 * @constructor
 * @private
*/
function PluginAdapter() {
  this.plugins = [];
  this.registered = 0;
  PluginAdapter.__super__.constructor.call(this, this.constructor.NAME, {});
}


__extends(PluginAdapter, puremvc.Mediator);


PluginAdapter.NAME = "PluginAdapter";

PluginAdapter.prototype.plugins = null;

PluginAdapter.prototype.registered = null;

/**
 * Registers the appropriate pipes and listeners when
 * this class is registered
 *
 * @override
*/
PluginAdapter.prototype.onRegister = function() {
  return PluginAdapter.__super__.onRegister.call(this);
};

/**
 * Overridden so this class may subscribe to all notifications
 * @return An Array
 *
 * @override
*/
PluginAdapter.prototype.listNotificationInterests = function() {
  return [PluginNotifications.REGISTER_PLUGINS, PluginNotifications.PLUGIN_REGISTERED];
};

/**
 * Handles notifications of interest to this mediator. Note that
 * the default declaration is to allow the super to handle the
 * note. This leaves the base JunctionMediator to handle things
 * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE
 *
 * @param note An INotification
 * @override
*/
PluginAdapter.prototype.handleNotification = function(notification) {
  var body, config, def, init, initialize, key, name, plugin, plugins, type, value, _ref,
    _this = this;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case PluginNotifications.REGISTER_PLUGINS:
      type = this.facade.getPlayerType();
      config = body;
      _ref = AMP.plugins;
      for (key in _ref) {
        value = _ref[key];
        if (!(key in config)) {
          continue;
        }
        init = config[key];
        if (!(init != null) || init.enabled === false) {
          continue;
        }
        def = value[type];
        if (!(def != null)) {
          this.facade.logger.debug("[AMP] Plugin could not be found: " + key);
          continue;
        }
        try {
          plugin = new def();
          plugin.oninitialized = this.onplugininitialized.bind(this, key);
          plugin.onerror = this.onpluginerror.bind(this, key);
          initialize = plugin.initialize.bind(plugin, init, this.facade);
          this.plugins.push(initialize);
        } catch (error) {
          this.logger.error("[AMP] Plugin could not be created: " + key + ". " + error);
          continue;
        }
      }
      plugins = config.plugins || {};
      for (key in plugins) {
        init = plugins[key];
        if (!((init != null) && init.enabled !== false)) {
          continue;
        }
        initialize = function(player, config, key, resolve, reject) {
          return _this.facade.loadResources(config.resources).then(function() {
            def = AMP.plugins[key][type];
            if (!(def != null)) {
              reject("[AMP] Plugin could not be found: " + key);
            }
            return def(player, config, key);
          }).then(resolve)["catch"](reject);
        };
        this.plugins.push(initialize.bind(null, this.facade, init, key, this.onpluginregistered.bind(this, key), this.onpluginerror.bind(this, key)));
      }
      this.plugins.forEach(function(item) {
        return item();
      });
      break;
    case PluginNotifications.PLUGIN_REGISTERED:
      this.onpluginregistered(body.getModuleName(), body);
  }
};

PluginAdapter.prototype.initializedCheck = function() {
  if (this.registered === this.plugins.length) {
    this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, this.plugins);
  }
};

PluginAdapter.prototype.onplugininitialized = function(key, plugin) {
  plugin.oninitialized = null;
  plugin.onerror = null;
  this.facade.registerModule(plugin);
};

PluginAdapter.prototype.onpluginerror = function(key, error) {
  this.registered++;
  this.facade.logger.error("[AMP] Plugin could not be registered: " + key);
  this.facade.logger.error(error);
  this.initializedCheck();
};

PluginAdapter.prototype.onpluginregistered = function(key, plugin) {
  var feature;
  this.registered++;
  this.facade.logger.debug("[AMP] Plugin registered: " + key);
  this.facade[key] = plugin;
  feature = (typeof plugin.getFeatureName === "function" ? plugin.getFeatureName() : void 0) || plugin.feature;
  if (feature != null) {
    this.facade[feature] = plugin;
  }
  this.initializedCheck();
};

/**
 * The ClassList class.
 * 
 * @param {!DOMElement}  element
 *    The DOM Element
 *
 * @constructor
*/
function ClassList(element) {
  this.element = element;
}

ClassList.prototype.element = null;

ClassList.prototype.prefix = Namespace.PREFIX;

/**
*/
ClassList.prototype.contains = function(className) {
  return this.constructor.contains(className, this.element, this.prefix);
};

/**
*/
ClassList.prototype.add = function(className) {
  this.constructor.add(className, this.element, this.prefix);
};

/**
*/
ClassList.prototype.remove = function(className) {
  this.constructor.remove(className, this.element, this.prefix);
};

/**
*/
ClassList.prototype.toggle = function(className) {
  return this.constructor.contains(className, this.element, this.prefix);
};

/**
*/
ClassList.contains = function(className, element, prefix) {
  var css, _ref;
  if (prefix == null) {
    prefix = "";
  }
  css = prefix + className;
  if (((_ref = element.classList) != null ? _ref.contains : void 0) != null) {
    return element.classList.contains(css);
  } else {
    return element.className.indexOf(css) !== -1;
  }
};

/**
*/
ClassList.add = function(className, element, prefix) {
  var css, _ref;
  if (prefix == null) {
    prefix = "";
  }
  css = prefix + className;
  if (((_ref = element.classList) != null ? _ref.add : void 0) != null) {
    element.classList.add(css);
  } else {
    if (!this.contains(className, element)) {
      if (element.className !== "") {
        element.className += " " + css;
      } else {
        element.className = css;
      }
    }
  }
};

/**
*/
ClassList.remove = function(className, element, prefix) {
  var css, regexp, _ref;
  if (prefix == null) {
    prefix = "";
  }
  css = prefix + className;
  if (((_ref = element.classList) != null ? _ref.remove : void 0) != null) {
    element.classList.remove(css);
  } else {
    if (this.contains(className, element)) {
      regexp = new RegExp(" ?" + css);
      element.className = element.className.replace(regexp, "");
    }
  }
};

/**
*/
ClassList.toggle = function(className, element, prefix) {
  var css, _ref;
  if (prefix == null) {
    prefix = "";
  }
  css = prefix + className;
  if (((_ref = element.classList) != null ? _ref.toggle : void 0) != null) {
    element.classList.toggle(this.prefix + className);
  } else {
    if (this.contains(className, element)) {
      this.remome(className, element);
    } else {
      this.add(className, element);
    }
  }
};

/**
 * The LocalizationProxy class. Used to track player localization settings.
 *
 * @constructor
 * @private
 * @extends {DataBindingContext}
 * @param {Object}  init  The configuration object.
*/
function LocalizationProxy(init) {
  var key, lang;
  LocalizationProxy.__super__.constructor.call(this);
  this.data = {
    language: navigator.language || navigator.browserLanguage,
    locales: Config.defaults.locales
  };
  if (init != null) {
    if (init.language != null) {
      this.data.language = init.language;
    }
    if (init.locales != null) {
      for (lang in init.locales) {
        if (this.data.locales[lang] != null) {
          for (key in init.locales[lang]) {
            this.data.locales[lang][key] = init.locales[lang][key];
          }
        } else {
          this.data.locales[lang] = init.locales[lang];
        }
      }
    }
  }
}


__extends(LocalizationProxy, DataBindingContext);


/** @static
*/
LocalizationProxy.NAME = "LocalizationProxy";

LocalizationProxy.prototype.contextName = "l10n";

LocalizationProxy.prototype.locale = null;

LocalizationProxy.prototype.localeId = null;

/** @override
*/
LocalizationProxy.prototype.onRegister = function() {
  LocalizationProxy.__super__.onRegister.call(this);
  this.setLocale(this.data.language);
};

/**
 * Gets the context data for this proxy.
 *
 * @returns {Object} The contenxt data for this proxy
 * @override
*/
LocalizationProxy.prototype.getContextData = function() {
  return this.locale;
};

/**
 *
*/
LocalizationProxy.prototype.getLanguage = function() {
  return this.data.language;
};

LocalizationProxy.prototype.setLanguage = function(value) {
  var _this = this;
  this.setLocale(value).then(function() {
    _this.data.language = value;
    _this.sendNotification(Notifications.LANGUAGE_CHANGE, value);
  });
  return value;
};

/**
 *
*/
LocalizationProxy.prototype.setLocale = function(value) {
  var _this = this;
  return new Promise(function(resolve, reject) {
    var complete, locale, localeId;
    complete = function() {
      _this.localeId = localeId;
      _this.locale = _this.facade.l10n = _this.data.locales[localeId];
      resolve();
    };
    localeId = value;
    locale = _this.data.locales[localeId];
    if (!(locale != null)) {
      localeId = value.substring(0, 2);
      locale = _this.data.locales[localeId];
    }
    if (typeof locale === "string") {
      return AMP.addResource({
        src: _this.facade.evaluatePaths(locale),
        type: Utils.mimeTypes.json
      }).then(function(resource) {
        _this.data.locales[localeId] = resource.data;
        return complete();
      });
    } else {
      return complete();
    }
  });
};

LocalizationProxy.prototype.getLocaleId = function() {
  return this.localeId;
};

/**
 *
*/
LocalizationProxy.prototype.getLocales = function() {
  return this.data.locales;
};

LocalizationProxy.prototype.setLocales = function(value) {
  this.data.locales = value;
  return value;
};

/**
 *
*/
LocalizationProxy.prototype.getString = function(key) {
  var locale;
  try {
    locale = this.locale || this.data.locales.en;
    return locale[key] || "";
  } catch (error) {
    return "";
  }
};

/**
 * Retrieves the full language name in the player's current language setting.
 *
 * @param   {string}  lang  The language code.
 * @return  {string}        The full name of the language according to the player's current language setting.
*/
LocalizationProxy.prototype.getLanguageString = function(lang) {
  var key, str;
  if (typeof lang !== "string" || !(lang != null) || lang === "") {
    return "";
  }
  key = "MSG_" + (lang.toUpperCase());
  str = this.getString(key);
  if (str === "") {
    lang = lang.split("-").shift();
    key = "MSG_" + (lang.toUpperCase());
    str = this.getString(key);
  }
  return str;
};

function UI() {}

/**
 * Creates an HTML element.
 * 
 * @param   {?(string|Array.<string>)}  type
 * @param   {?DOMElement}  parent 
 * @param   {?string|DOMElement}  element
 * @param   {?string} text
 * @return  {DOMElement}
*/
UI.create = function(type, parent, element, text) {
  var classList, item, viewComponent, _i, _len;
  if (element == null) {
    element = "div";
  }
  if (typeof element === "string") {
    element = document.createElement(element);
  }
  classList = new ClassList(element);
  if (type != null) {
    if (typeof type === "string") {
      type = [type];
    }
    for (_i = 0, _len = type.length; _i < _len; _i++) {
      item = type[_i];
      classList.add(item);
    }
  }
  element._classList = classList;
  if (text != null) {
    if (element.innerText != null) {
      element.innerText = text;
    } else {
      element.textContent = text;
    }
  }
  if (parent != null) {
    if (parent.getViewComponent != null) {
      viewComponent = parent.getViewComponent();
    }
    if (viewComponent != null) {
      parent = viewComponent;
    }
    parent.appendChild(element);
  }
  return element;
};

/** 
 * Binds a mediators event handlers to an element.
 * 
 * @param {!DOMElement} element
 * @param {!mediator} mediator
*/
UI.bindEvents = function(element, handlers, exceptions) {
  var key, value;
  if (exceptions == null) {
    exceptions = ["onRemove", "onRegister"];
  }
  for (key in handlers) {
    value = handlers[key];
    if (!(__indexOf.call(exceptions, key) >= 0) && /^on/.test(key) && ((value != null ? value.bind : void 0) != null)) {
      element[key] = value.bind(handlers);
    }
  }
};

/**
 * Creates a unique id.
 *
 * @param   {number=}   base
 *    The base to use for representing a numeric value. 
 * 
 * @return  {string}
 *    The unique id.
*/
UI.createUID = function(base) {
  var date, len, max, rand;
  if (base == null) {
    base = 16;
  }
  date = Date.now();
  len = 2;
  max = base * len - 1;
  rand = Math.round(Math.random() * max + base);
  return (rand.toString(16) + date.toString(16)).toUpperCase();
};

/**
 * The ExternalPlayCommand class.
 * 
 * @constructor
 * @private
 * @extends {puremvc.MacroCommand}
*/
function ExternalPlayCommand() {
  ExternalPlayCommand.__super__.constructor.call(this);
}


__extends(ExternalPlayCommand, PlayerEventCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ExternalPlayCommand.prototype.execute = function(notification) {
  this.sendNotification(Notifications.PLAY_REQUEST);
  this.playback.play();
  ExternalPlayCommand.__super__.execute.call(this, notification);
};

/** 
 * The ExternalPlayer class.
 *   
 * @constructor
 * @private 
 * @extends {Player}
 * @param {Object} config
 * @param {Object} viewComponent
 * @param {EventDispatcher} dispatcher
*/
function ExternalPlayer(config, viewComponent, dispatcher) {
  ExternalPlayer.__super__.constructor.call(this, config, viewComponent, dispatcher);
}


__extends(ExternalPlayer, Player);


ExternalPlayer.prototype.playerType = "external";

/** @override
*/
ExternalPlayer.prototype.createModel = function() {
  var playbackProxy;
  ExternalPlayer.__super__.createModel.call(this);
  this.registerProxy(new LocalizationProxy(this.config));
  playbackProxy = new ExternalPlaybackProxy();
  this.registerProxy(playbackProxy);
  this.playerCore = new PlayerProxy(playbackProxy);
  this.registerProxy(this.playerCore);
  this.bindings.initialize();
};

/** @override
*/
ExternalPlayer.prototype.createView = function() {
  var overlay,
    _this = this;
  this.registerMediator(new PlayerMediator("external", this.getViewComponent()));
  this.registerMediator(new PluginAdapter());
  overlay = new OverlayLayerMediator();
  this.registerMediator(overlay);
  EventHandler.create(overlay.viewComponent, EventHandler.CLICK, function() {
    return _this.sendNotification(Notifications.TOGGLE_ACTIVE);
  });
};

/** @override
*/
ExternalPlayer.prototype.createController = function() {
  ExternalPlayer.__super__.createController.call(this);
  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);
  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ExternalPlayCommand);
  this.registerCommand(Notifications.PLAY, ExternalPlayCommand);
  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);
  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);
  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);
  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);
  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);
  this.registerCommand(Notifications.ERROR, ErrorCommand);
  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);
  this.registerCommand(Notifications.READY, ReadyCommand);
  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);
};

/** @override
*/
ExternalPlayer.prototype.createMediaElement = function() {
  return document.createElement("div");
};

ExternalPlayer.prototype.evaluateBinding = function(str) {
  var _ref;
  return (_ref = this.retrieveProxy(DataBindingProxy.NAME)) != null ? _ref.evaluateBinding(str) : void 0;
};

ExternalPlayer.prototype.canPlayType = function(mimeType) {
  return "maybe";
};

ExternalPlayer.prototype.play = function() {
  this.sendNotification(Notifications.PLAY);
};

ExternalPlayer.prototype.setParams = function(value) {
  this.sendNotification(Notifications.CHANGE_PARAMS, value);
  return value;
};

ExternalPlayer.prototype.getParams = function() {
  return this.retrieveProxy(ParamsProxy.NAME).getData();
};

ExternalPlayer.prototype.setAutoplay = function(value) {
  return false;
};

ExternalPlayer.prototype.getAutoplay = function() {
  return false;
};

ExternalPlayer.prototype.setLoop = function(value) {
  return false;
};

ExternalPlayer.prototype.getLoop = function() {
  return false;
};

ExternalPlayer.prototype.setMuted = function(value) {
  return false;
};

ExternalPlayer.prototype.getMuted = function() {
  return false;
};

ExternalPlayer.prototype.setMedia = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, value);
  return value;
};

ExternalPlayer.prototype.getMedia = function(value) {
  var _ref;
  return (_ref = this.retrieveProxy(MediaProxy.NAME)) != null ? _ref.getData() : void 0;
};

ExternalPlayer.prototype.setCurrentTime = function(value) {
  return 0;
};

ExternalPlayer.prototype.getCurrentTime = function(value) {
  return 0;
};

ExternalPlayer.prototype.getDuration = function(value) {
  return this.retrieveProxy(MediaProxy.NAME).getDuration();
};

ExternalPlayer.prototype.setSrc = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, {
    src: value
  });
  return value;
};

ExternalPlayer.prototype.getSrc = function(value) {
  return this.retrieveProxy(MediaProxy.NAME).getSrc();
};

ExternalPlayer.prototype.setSource = function(value) {
  this.sendNotification(Notifications.SET_MEDIA, {
    source: value
  });
  return value;
};

ExternalPlayer.prototype.getSource = function() {
  return this.retrieveProxy(MediaProxy.NAME).getSource();
};

ExternalPlayer.prototype.setVolume = function(value) {
  return value;
};

ExternalPlayer.prototype.getVolume = function(value) {
  return 1;
};

ExternalPlayer.prototype.getSeeking = function() {
  return false;
};

ExternalPlayer.prototype.getPaused = function() {
  return false;
};

ExternalPlayer.prototype.getEnded = function() {
  return false;
};

/**
 * Event constructor.
 *
 * @param {!string}  type  A string representing the event's type.
 * @param {Object=} detail  Data to pass along with the event.
 * @constructor
 * @private
*/
function Event(type, detail) {
  this.type = type;
  if (detail != null) {
    this.detail = this.data = detail;
  }
}

/**
 * The event's type.
 * 
 * @type {string}
*/
Event.prototype.type = null;

/**
 * The event's target
 * 
 * @type {Object}
*/
Event.prototype.target = null;

/**
 * Collection of event specific details.
 * 
 * @type {Object}
*/
Event.prototype.detail = null;

function LoggerConstructor(enabled) {
  this.enabled = enabled;
  if (!this.enabled) {
    this.log = this.trace = this.debug = this.info = this.warn = this.error = this.fatal = function() {};
  }
}

LoggerConstructor.prototype.log = function() {
  try {
    if (arguments.length > 1 && (arguments[1] != null)) {
      console.log.apply(console, arguments);
    } else {
      console.log(arguments[0]);
    }
  } catch (error) {

  }
};

LoggerConstructor.prototype.trace = function() {
  try {
    console.trace.apply(console, arguments);
  } catch (error) {

  }
};

LoggerConstructor.prototype.debug = function() {
  try {
    console.log.apply(console, arguments);
  } catch (error) {
    this.log.apply(this, arguments);
  }
};

LoggerConstructor.prototype.info = function() {
  try {
    console.info.apply(console, arguments);
  } catch (error) {

  }
};

LoggerConstructor.prototype.warn = function() {
  try {
    console.warn.apply(console, arguments);
  } catch (error) {

  }
};

LoggerConstructor.prototype.error = function() {
  try {
    console.error.apply(console, arguments);
  } catch (error) {
    this.log.apply(this, arguments);
  }
};

LoggerConstructor.prototype.fatal = function() {
  try {
    console.fatal.apply(console, arguments);
  } catch (error) {

  }
};

// Monkeypatch: Not sure how this worked 10 years ago, but set to true to show logs
var Logger = new LoggerConstructor(false);

function FeedVO() {
  this.item = [];
  this.metadata = {};
}

FeedVO.prototype.title = null;

FeedVO.prototype.link = null;

FeedVO.prototype.description = null;

FeedVO.prototype.category = null;

FeedVO.prototype.pubDate = null;

FeedVO.prototype.language = null;

FeedVO.prototype.ttl = null;

FeedVO.prototype.item = null;

FeedVO.prototype.metadata = null;

function Resource() {
  this.metadata = {};
}

/**
 * The resource url.
 *
 * @type {String}
*/
Resource.prototype.src = null;

/**
 * The resource url to use in debug mode.
 *
 * @type {String}
*/
Resource.prototype.debug = null;

/**
 * The mime type.
 *
 * @type {String}
*/
Resource.prototype.type = null;

/**
 * @type {Object}
*/
Resource.prototype.metadata = null;

/**
 * @enum {string}
 * @const
*/

var PlaybackMode = {
  /**
   *
  */

  AUTO: "auto",
  /**
   *
  */

  HTML: "html",
  /**
   *
  */

  FLASH: "flash",
  /**
   *
  */

  EXTERNAL: "external",
  /**
   *
  */

  NONE: "none",
  /**
   *
  */

  HTML_AUTO: "html-auto"
};

function MediaVO() {
  return MediaVO.__super__.constructor.apply(this, arguments);
}


__extends(MediaVO, Resource);


MediaVO.prototype.source = null;

MediaVO.prototype.title = null;

MediaVO.prototype.description = null;

MediaVO.prototype.link = null;

MediaVO.prototype.guid = null;

MediaVO.prototype.pubDate = null;

MediaVO.prototype.poster = null;

MediaVO.prototype.thumbnail = null;

MediaVO.prototype.embed = null;

MediaVO.prototype.category = null;

MediaVO.prototype.type = null;

MediaVO.prototype.medium = null;

MediaVO.prototype.duration = null;

MediaVO.prototype.track = null;

MediaVO.prototype.metadata = null;

MediaVO.prototype.scenes = null;

MediaVO.prototype.startTime = null;

/**
 * @constructor
 * @private
*/
function MRSSHelper() {}

/**
*/
MRSSHelper.prototype.getFeed = function(url) {
  return Utils.getFeed(url);
};

/**
*/
MRSSHelper.prototype.getMediaNode = function(item, name, checkItem) {
  var base, mediaContent, mediaName, node;
  if (checkItem == null) {
    checkItem = true;
  }
  mediaName = "media-" + name;
  base = item['media-group'] || item;
  mediaContent = base['media-content'];
  if ((mediaContent != null) && (mediaContent[mediaName] != null)) {
    node = mediaContent[mediaName];
  } else if (base[mediaName] != null) {
    node = base[mediaName];
  } else if (item[mediaName] != null) {
    node = item[mediaName];
  } else if ((item[name] != null) && checkItem) {
    node = item[name];
  }
  return node;
};

MRSSHelper.prototype.createEmbed = function(item) {
  var embed, embedVO, param, _i, _len, _ref;
  try {
    embed = this.getMediaNode(item, "embed");
    if (!(embed != null)) {
      return embedVO;
    }
    embedVO = {};
    embedVO.url = embed["@attributes"].url;
    embedVO.width = embed["@attributes"].width;
    embedVO.height = embed["@attributes"].height;
    embedVO.params = {};
    if (!(embed["media-param"] instanceof Array)) {
      embed["media-param"] = [embed["media-param"]];
    }
    _ref = embed["media-param"];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      param = _ref[_i];
      embedVO.params[param["@attributes"].name] = param["#text"];
    }
  } catch (error) {
    Logger.error("[AMP Feed Parse Error] embed parse error: " + error.message, error);
  }
  return embedVO;
};

/**
*/
MRSSHelper.prototype.createFeed = function(json) {
  var channel, feedVO, item, items, key, mediaVO, value, _i, _len;
  try {
    channel = json.channel;
    feedVO = new FeedVO();
    if (channel != null) {
      feedVO.title = channel.title;
      feedVO.description = channel.description;
      feedVO.language = channel.language;
      feedVO.category = channel.category;
      feedVO.pubDate = new Date(Date.parse(channel.pubDate));
      feedVO.ttl = channel.ttl;
      items = channel.item instanceof Array ? channel.item : [channel.item];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        mediaVO = this.createMedia(item);
        feedVO.item.push(mediaVO);
      }
      for (key in channel) {
        value = channel[key];
        if (!(key in feedVO)) {
          feedVO.metadata[key] = value;
        }
      }
    }
  } catch (error) {
    Logger.error("[AMP Feed Parse Error] feed parse error: " + error.message, error);
  }
  return feedVO;
};

/**
*/
MRSSHelper.prototype.createMedia = function(item) {
  var atts, category, content, key, label, mediaContent, mediaVO, node, source, track, value, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
  try {
    mediaVO = new MediaVO();
    mediaContent = this.getMediaNode(item, 'content');
    if (mediaContent instanceof Array) {
      mediaVO.source = [];
      for (_i = 0, _len = mediaContent.length; _i < _len; _i++) {
        content = mediaContent[_i];
        source = {
          src: content['@attributes'].url,
          type: content['@attributes'].type
        };
        category = content["media-category"];
        if (category != null) {
          atts = category["@attributes"];
          if (atts.schema === "http://mrss.akamai.com/user_agent_hint") {
            label = atts.label || category["#text"];
            if ((label != null) && label !== "") {
              if (source.rules == null) {
                source.rules = [];
              }
              source.rules.push(label);
            }
          }
        }
        mediaVO.source.push(source);
        mediaVO.medium = content['@attributes'].medium;
        mediaVO.duration = parseFloat(content['@attributes'].duration);
      }
    } else {
      mediaVO.type = mediaContent['@attributes'].type;
      mediaVO.src = mediaContent['@attributes'].url;
      mediaVO.medium = mediaContent['@attributes'].medium;
      mediaVO.duration = parseFloat(mediaContent['@attributes'].duration);
    }
    mediaVO.guid = item.guid;
    mediaVO.title = this.getMediaNode(item, "title");
    mediaVO.link = item.link;
    mediaVO.description = this.getMediaNode(item, "description");
    mediaVO.pubDate = new Date(Date.parse(item.pubDate));
    mediaVO.thumbnail = mediaVO.poster = (_ref = this.getMediaNode(item, 'thumbnail')) != null ? (_ref1 = _ref['@attributes']) != null ? _ref1.url : void 0 : void 0;
    mediaVO.embed = this.createEmbed(item);
    mediaVO.scenes = (_ref2 = this.getMediaNode(item, "scenes")) != null ? _ref2['media-scene'] : void 0;
    node = this.getMediaNode(item, "status", false);
    if (node != null) {
      mediaVO.status = {
        state: node['@attributes'].state,
        reason: node['@attributes'].reason
      };
    }
    mediaVO.category = item.category;
    if (!(mediaVO.category instanceof Array)) {
      mediaVO.category = [mediaVO.category];
    }
    node = this.getMediaNode(item, "category", false);
    if (node != null) {
      for (_j = 0, _len1 = node.length; _j < _len1; _j++) {
        category = node[_j];
        if ((category["#text"] != null) && category["#text"] !== "") {
          mediaVO.category.push(category["#text"]);
        }
      }
    }
    if (mediaVO.category != null) {
      mediaVO.category.sort(function(a, b) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    node = this.getMediaNode(item, "subTitle");
    if (node != null) {
      if (mediaVO.track == null) {
        mediaVO.track = [];
      }
      if (!(node instanceof Array)) {
        node = [node];
      }
      for (_k = 0, _len2 = node.length; _k < _len2; _k++) {
        track = node[_k];
        if (track["@attributes"] != null) {
          mediaVO.track.push({
            src: track["@attributes"].href,
            type: track["@attributes"].type,
            kind: "captions",
            srclang: track["@attributes"].lang || "en"
          });
        }
      }
    }
    category = item.category;
    if (!(category instanceof Array)) {
      category = [category];
    }
    mediaVO.isLive = item.temporalType === "live" || ((category != null) && category.join(",").indexOf("live_stream") !== -1);
    mediaVO.temporalType = mediaVO.isLive ? "live" : item.temporalType || "vod";
    for (key in item) {
      value = item[key];
      if (!(key in mediaVO)) {
        mediaVO.metadata[key] = value;
      }
    }
  } catch (error) {
    Logger.error("[AMP Feed Parse Error] media parse error: " + error.message, error);
  }
  return mediaVO;
};

/**
 * Poller class
 *
 * @constructor
 * @private
 * @extends {EventDispatcher}
 * @param {string} url
 * @param {number} interval
 * @param {string} type
 * @param {Object} headers
*/
function Poller(url, interval, type, headers) {
  this.url = url;
  this.interval = interval != null ? interval : 10000;
  this.type = type != null ? type : null;
  this.headers = headers != null ? headers : null;
  Poller.__super__.constructor.call(this);
}


__extends(Poller, EventDispatcher);


Poller.prototype.timeout = null;

Poller.prototype.interval = null;

Poller.prototype.url = null;

Poller.prototype.lastModified = null;

Poller.prototype.contentLenght = null;

Poller.prototype.data = null;

Poller.prototype.text = null;

Poller.prototype.type = null;

Poller.prototype.headers = null;

Poller.prototype.useHeadRequest = true;

Poller.prototype.xhr = null;

/**
*/
Poller.prototype.start = function() {
  if ((this.url != null) && this.url !== "") {
    this.poll();
  }
};

/**
*/
Poller.prototype.poll = function() {
  var xhr,
    _this = this;
  xhr = Utils.getXHR();
  if (!this.useHeadRequest) {
    this.updateData();
  } else {
    xhr.onload = function(event) {
      var contentLength, lastModified;
      if (xhr.status === 304) {
        _this.invoke();
        return;
      }
      lastModified = xhr.getResponseHeader("Last-Modified");
      contentLength = xhr.getResponseHeader("Content-Length");
      if ((!(lastModified != null) && !(contentLength != null)) || ((lastModified != null) && lastModified !== _this.lastModified) || ((contentLength != null) && contentLength !== _this.contentLength)) {
        _this.lastModified = lastModified;
        _this.contentLength = contentLength;
        _this.updateData();
      } else {
        _this.invoke();
      }
    };
    xhr.onerror = function(event) {
      _this.error(event);
    };
    xhr.open("HEAD", Utils.cacheBust(this.url), false);
    this.applyHeaders();
    if (this.lastModified != null) {
      xhr.setRequestHeader("If-Modified-Since", this.lastModified);
    }
    xhr.send();
  }
};

/**
*/
Poller.prototype.applyHeaders = function() {
  if (!(this.headers != null)) {
    return;
  }
  this.xhr.setRequestHeaders(this.headers);
};

/**
*/
Poller.prototype.updateData = function() {
  var xhr,
    _this = this;
  xhr = Utils.getXHR();
  xhr.open("GET", Utils.cacheBust(this.url), true);
  xhr.onload = function(event) {
    var text;
    text = xhr.responseText;
    _this.setText(text);
    _this.invoke();
  };
  xhr.onerror = function(event) {
    _this.error(event);
  };
  this.applyHeaders();
  return xhr.send();
};

/**
*/
Poller.prototype.setText = function(value) {
  var data;
  if (value !== this.text) {
    this.text = value;
    data = this.text;
    if (this.type === Utils.mimeTypes.json) {
      try {
        data = this.xhr.response;
      } catch (error) {
        data = this.text;
      }
    }
    this.setData(data);
  }
  return value;
};

/**
*/
Poller.prototype.setData = function(value) {
  if (value !== this.data) {
    this.data = value;
    this.dispatchEvent(new Event("datachange", this.data));
  }
  return value;
};

/**
*/
Poller.prototype.error = function(error) {
  Logger.error(event);
  this.stop();
};

/**
*/
Poller.prototype.invoke = function() {
  var _this = this;
  this.stop();
  this.timeout = setTimeout(function() {
    _this.poll();
  }, this.interval);
};

/**
*/
Poller.prototype.stop = function() {
  clearTimeout(this.timeout);
};

/**
 * @constructor
 * @private
 * @extends {EventDispatcher}
*/
function XHR() {
  XHR.__super__.constructor.call(this);
}


__extends(XHR, EventDispatcher);


XHR.prototype.xhr = null;

XHR.prototype.headers = null;

XHR.prototype.response = null;

XHR.prototype.responseXML = null;

XHR.prototype.responseText = null;

XHR.prototype.responseType = null;

XHR.prototype.withCredentials = false;

XHR.prototype.readyState = 0;

XHR.prototype.status = null;

XHR.prototype.open = function(method, url) {
  var xdr, xhr,
    _this = this;
  try {
    xhr = new XMLHttpRequest();
  } catch (error) {
    xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
  }
  if (XHR.isCORS(url)) {
    if (Object.prototype.hasOwnProperty.call(xhr, "withCredentials")) {
      try {
        xhr.withCredentials = this.withCredentials;
      } catch (error) {
        Logger.warn("[AMP XHR WARNING]", "withCredentials not properly supported in this browser.", error);
      }
    } else if (typeof XDomainRequest !== "undefined") {
      xdr = true;
      xhr = new XDomainRequest();
    }
  }
  if (xhr != null) {
    if (xdr) {
      xhr.onprogress = function() {};
      xhr.ontimeout = function() {};
      xhr.onerror = function() {};
      xhr.onload = function(event) {
        if (typeof xhr.onreadystatechange === 'function') {
          xhr.readyState = 4;
          xhr.status = 200;
          if (xhr.contentType.match(/\/xml/)) {
            xhr.responseXML = new ActiveXObject('Microsoft.XMLDOM');
            xhr.responseXML.async = false;
            xhr.responseXML.loadXML(xhr.responseText);
          }
          xhr.onreadystatechange.call(xhr, event, false);
        }
      };
    }
    xhr.onreadystatechange = function(event) {
      var _ref, _ref1;
      _this.readyState = xhr.readyState;
      _this.dispatchEvent(new Event("readystatechange", xhr));
      if (xhr.readyState === 4) {
        _this.status = xhr.status;
        if ((199 < (_ref = _this.status) && _ref < 400) || _this.status === 0) {
          if (xhr.responseText == null) {
            xhr.responseText = xhr.text;
          }
          _this.responseText = xhr.responseText;
          if ((xhr.responseXML != null) && ((_ref1 = xhr.responseXML.childNodes) != null ? _ref1.length : void 0) > 0) {
            _this.response = _this.responseXML = xhr.responseXML;
            _this.responseType = "document";
          } else {
            try {
              _this.response = JSON.parse(xhr.responseText);
              _this.responseType = "json";
            } catch (error) {
              _this.response = xhr.responseText;
              _this.responseType = "text";
            }
          }
          _this.dispatchEvent(new Event("load", _this));
        } else {
          if (_this.status !== 0) {
            _this.dispatchEvent(new Event("error", _this));
          }
        }
      }
    };
    try {
      if (typeof xhr.onerror !== "undefined") {
        xhr.onerror = function(event) {
          _this.dispatchEvent(new Event("error", _this));
        };
      }
    } catch (error) {

    }
    xhr.open(method, url);
  }
  this.xhr = xhr;
};

XHR.prototype.send = function(data) {
  var key, value, _ref,
    _this = this;
  if (this.headers != null) {
    _ref = this.headers;
    for (key in _ref) {
      value = _ref[key];
      if ((key != null) && (value != null)) {
        this.xhr.setRequestHeader(key, value);
      }
    }
  }
  setTimeout(function() {
    _this.xhr.send(data);
  }, 0);
};

XHR.prototype.setRequestHeader = function(key, value) {
  if (!(key != null) || !(value != null)) {
    return;
  }
  if (this.headers == null) {
    this.headers = {};
  }
  this.headers[key] = value;
};

XHR.prototype.setRequestHeaders = function(headers) {
  this.headers = headers;
  return headers;
};

XHR.prototype.getResponseHeader = function(name) {
  var _ref;
  return (_ref = this.xhr) != null ? typeof _ref.getResponseHeader === "function" ? _ref.getResponseHeader(name) : void 0 : void 0;
};

XHR.prototype.getAllResponseHeaders = function() {
  var _ref;
  return (_ref = this.xhr) != null ? typeof _ref.getAllResponseHeaders === "function" ? _ref.getAllResponseHeaders() : void 0 : void 0;
};

XHR.isCORS = function(url) {
  var hostname, parser, port, protocol;
  parser = document.createElement('a');
  parser.href = url;
  hostname = parser.hostname !== "" ? parser.hostname : location.hostname;
  port = parser.port !== "0" ? parser.port : location.port;
  protocol = parser.protocol !== ":" ? parser.protocol : location.protocol;
  return location.protocol !== protocol || location.hostname !== hostname || location.port !== port && !(location.port === "" && port === "80");
};

/**
 * Constructs a new Timer object with the specified delay and repeatCount states.
*/
function Timer(delay, repeatCount) {
  var _this = this;
  this.delay = delay;
  this.repeatCount = repeatCount != null ? repeatCount : 0;
  Timer.__super__.constructor.call(this);
  this._running = false;
  this._currentCount = 0;
  this._timeout = null;
  this._startTime = null;
  this._currentTime = 0;
  this.tick = this.tick.bind(this);
  this.next = setTimeout.bind(null, this.tick, this.delay);
  Object.defineProperties(this, {
    currentCount: {
      get: function() {
        return _this._currentCount;
      },
      enumerable: true,
      configurable: false
    },
    running: {
      get: function() {
        return _this._running;
      },
      enumerable: true,
      configurable: false
    },
    time: {
      get: function() {
        return _this._currentTime + (Date.now() - _this._startTime);
      },
      enumerable: true,
      configurable: false
    }
  });
}


__extends(Timer, EventDispatcher);


/**
 * Stops the timer, if it is running, and sets the currentCount property back to 0, like the reset button of a stopwatch.
*/
Timer.prototype.reset = function() {
  this.stop();
  this._currentCount = 0;
  this._currentTime = 0;
  this._startTime = null;
};

/**
 * Starts the timer, if it is not already running.
*/
Timer.prototype.start = function() {
  var delay;
  if (this._running === true) {
    return;
  }
  delay = this.delay - (this._currentTime - (this.delay * this._currentCount));
  this._running = true;
  this._timeout = setTimeout(this.tick, delay);
};

/**
 * Stops the timer.
*/
Timer.prototype.stop = function() {
  if (this._running === false) {
    return;
  }
  clearTimeout(this._timeout);
  this._currentTime += Date.now() - this._startTime;
  this._timeout = null;
  this._running = false;
};

/**
 *
*/
Timer.prototype.tick = function() {
  var complete;
  clearTimeout(this._timeout);
  complete = this.repeatCount !== 0 && this._currentCount >= this.repeatCount;
  this._currentCount++;
  this._currentTime += this.delay;
  this._startTime = Date.now();
  if (complete === false) {
    this._timeout = this.next();
  }
  this.dispatchEvent(new Event("timer", this));
  if (complete === true) {
    this.stop();
    this.dispatchEvent(new Event("complete", this));
  }
};

function Utils() {}

Utils.blankImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjI2QkJDQTBCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjI2QkJDQTFCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODg4NjdFQkIzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODg4NjdFQ0IzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pu0++ecAAAAGUExURf///wAAAFXC034AAAABdFJOUwBA5thmAAAADElEQVR42mJgAAgwAAACAAFPbVnhAAAAAElFTkSuQmCC";

Utils.mimeTypes = {
  mp4: "video/mp4",
  flv: "video/x-flv",
  f4m: "video/f4m",
  smil: "application/smil",
  smilxml: "application/smil+xml",
  m3u8: "application/x-mpegURL",
  mp3: "audio/mpeg",
  json: "application/json",
  txt: "text/plain",
  xml: "application/xml",
  ogv: "video/ogg",
  webm: "video/webm",
  mpd: "application/dash+xml",
  ism: "application/vnd.ms-sstr+xml",
  js: "text/javascript",
  css: "text/css",
  swf: "application/x-shockwave-flash",
  vtt: "text/vtt",
  ttml: "application/ttml+xml",
  srt: "application/x-subrip",
  cea608: "text/cea-608",
  cea708: "text/cea-708"
};

Utils.flashTypes = [Utils.mimeTypes.mp4, Utils.mimeTypes.flv, Utils.mimeTypes.f4m, Utils.mimeTypes.smil, Utils.mimeTypes.smilxml];

Utils.rules = {
  flashTablets: {
    label: "Android 2 & 3 or Kindle Fire 1",
    regexp: "Android [23]|Silk\/1"
  },
  html5Phones: {
    label: "iPhone",
    regexp: "iPhone"
  },
  html5Tablets: {
    label: "HTML5 Tablets",
    regexp: "iPad|Android [4-9]|Silk\/2"
  },
  desktop: {
    label: "Desktop",
    regexp: "^((?!iPad|iPhone|Android|BlackBerry|PlayBook|Silk).)*$"
  }
};

Utils.getPlaybackMode = function(mode) {
  var key, valid, value, _ref;
  if (mode == null) {
    mode = ((_ref = QueryString["amp-mode"]) != null ? _ref.toLowerCase() : void 0) || PlaybackMode.HTML_AUTO;
  }
  valid = false;
  for (key in PlaybackMode) {
    value = PlaybackMode[key];
    if (value === mode) {
      valid = true;
      break;
    }
  }
  if (!valid) {
    mode = PlaybackMode.AUTO;
  }
  if (mode === PlaybackMode.HTML_AUTO) {
    mode = this.isHTMLFirst() ? PlaybackMode.HTML : PlaybackMode.AUTO;
  }
  if (mode !== PlaybackMode.AUTO) {
    if (mode === PlaybackMode.FLASH && (!this.hasFlash() || typeof FlashPlayer === "undefined")) {
      if (this.supportsHTML5Video()) {
        mode = PlaybackMode.HTML;
      } else {
        mode = PlaybackMode.NONE;
      }
    }
    return mode;
  }
  if (!this.hasFlash()) {
    mode = this.supportsHTML5Video() ? PlaybackMode.HTML : PlaybackMode.NONE;
  }
  if (mode === PlaybackMode.AUTO) {
    mode = this.isHTML5() ? PlaybackMode.HTML : PlaybackMode.FLASH;
  }
  return mode;
};

Utils.getIEVersion = function() {
  var re, rv, ua;
  rv = -1;
  ua = navigator.userAgent;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
  } else if (navigator.appName === 'Netscape') {
    re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
  } else if (/Edge\/[0-9\.]+$/.test(ua)) {
    re = /Edge\/([0-9\.]+)/;
  }
  if ((re != null ? re.exec(ua) : void 0) != null) {
    rv = parseFloat(RegExp.$1);
  }
  return rv;
};

Utils.getFFVersion = function() {
  var rv, ua;
  rv = -1;
  ua = navigator.userAgent;
  if (/Firefox\/([0-9\.]+)$/.exec(ua)) {
    rv = parseFloat(RegExp.$1);
  }
  return rv;
};

Utils.getSafariVersion = function() {
  var rv, ua;
  rv = -1;
  ua = navigator.userAgent;
  if (/Safari\/[0-9\.]+$/.test(ua) && (/Version\/([0-9]+\.[0-9]+) Safari/.exec(ua) != null)) {
    rv = parseFloat(RegExp.$1);
  }
  return rv;
};

Utils.isChrome = function() {
  return /Chrom(e|ium)/.test(navigator.userAgent);
};

Utils.getChromeVersion = function() {
  var rv, ua;
  rv = -1;
  ua = navigator.userAgent;
  if (/Chrome( Mobile)?\/([0-9\.]+)/.test(ua)) {
    rv = parseFloat(ua.match(/Chrome( Mobile)?\/([0-9\.]+)/)[2].split(".").slice(0, 2).join("."));
  }
  return rv;
};

Utils.isHTMLFirst = function() {
  return window.MediaSource != null;
};

Utils.mergeRules = function(rules) {
  var id, rule, _results;
  _results = [];
  for (id in rules) {
    rule = rules[id];
    _results.push(Utils.rules[id] = rule);
  }
  return _results;
};

Utils.checkRules = function(rules) {
  var id, regExp, rule, _i, _len;
  if ((rules != null) && rules.length > 0) {
    for (_i = 0, _len = rules.length; _i < _len; _i++) {
      id = rules[_i];
      if (!(rule = Utils.rules[id])) {
        continue;
      }
      regExp = new RegExp(rule.regexp);
      if (regExp.test(navigator.userAgent)) {
        return true;
      }
    }
  }
  return false;
};

Utils.selectSource = function(sources, canPlayType) {
  var item, _i, _j, _len, _len1;
  for (_i = 0, _len = sources.length; _i < _len; _i++) {
    item = sources[_i];
    if (Utils.checkRules(item.rules)) {
      return item;
    }
  }
  for (_j = 0, _len1 = sources.length; _j < _len1; _j++) {
    item = sources[_j];
    if (canPlayType(item.type || Utils.getMimeType(item.src)) !== "") {
      return item;
    }
  }
  return null;
};

Utils.getSourceByType = function(media, type) {
  var source, sources, _i, _len;
  sources = media.source != null ? media.source.slice() : [];
  if (!(media.type != null)) {
    media.type = Utils.getMimeType(media.src);
  }
  sources.unshift(media);
  for (_i = 0, _len = sources.length; _i < _len; _i++) {
    source = sources[_i];
    if (source.type === type) {
      return source;
    }
  }
  return null;
};

Utils.getMimeType = function(file) {
  return this.mimeTypes[Utils.getFileExtension(file)];
};

Utils.selectTrack = function(tracks, kind) {
  var item, track, _i, _len;
  for (_i = 0, _len = tracks.length; _i < _len; _i++) {
    item = tracks[_i];
    if (!(item.kind === kind)) {
      continue;
    }
    track = item;
    break;
  }
  return track;
};

Utils.isIPhone = function() {
  return /iPhone/.test(navigator.platform) || /iPhone/.test(navigator.userAgent);
};

Utils.isIPad = function() {
  return /iPad/.test(navigator.platform) || /iPad/.test(navigator.userAgent);
};

Utils.isAndroid = function() {
  return /Android [4-9]/.test(navigator.userAgent);
};

Utils.isKindleFireHD = function() {
  return /Silk\/2/.test(navigator.userAgent);
};

Utils.isKindleFire = function() {
  return /Silk\/1/.test(navigator.userAgent);
};

Utils.isBlackBerry = function() {
  return /BlackBerry;|PlayBook|BB10/.test(navigator.userAgent);
};

Utils.isFirefoxOS = function() {
  return /\(Mobile;.*Firefox\//.test(navigator.userAgent);
};

Utils.supportsHTML5Video = function() {
  var video;
  video = document.createElement("video");
  return video.canPlayType != null;
};

Utils.isHTML5 = function() {
  return this.isIOS() || this.isAndroid() || this.isKindleFireHD() || this.isBlackBerry() || this.isFirefoxOS();
};

Utils.isIOS = function() {
  var iOSRegEx, isIOS;
  iOSRegEx = /iP(hone|od|ad)/i;
  return isIOS = iOSRegEx.test(navigator.platform) || iOSRegEx.test(navigator.userAgent);
};

Utils.getIOSversion = function() {
  var ver;
  if (this.isIOS()) {
    ver = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(ver[1], 10), parseInt(ver[2], 10), parseInt(ver[3] || 0, 10)];
  }
};

Utils.hasFlash = function() {
  var hasFlash;
  try {
    hasFlash = Boolean(new ActiveXObject("ShockwaveFlash.ShockwaveFlash"));
  } catch (error) {
    hasFlash = "undefined" !== typeof navigator.mimeTypes["application/x-shockwave-flash"];
  }
  return hasFlash;
};

Utils.isFullscreenDevice = function() {
  return this.isKindleFireHD() || this.isIPhone();
};

Utils.getDevice = function() {
  var device;
  device = "desktop";
  if (this.isIPhone()) {
    device = "iphone";
  } else if (this.isIPad()) {
    device = "ipad";
  } else if (/Android/.test(navigator.userAgent)) {
    device = "android";
  } else if (this.isKindleFireHD()) {
    device = "kindlefirehd";
  } else if (this.isKindleFire()) {
    device = "kindlefire";
  }
  return device;
};

Utils.xmlToJson = function(xml) {
  var attribute, child, element, index, nodeName, obj, _i, _j, _len, _len1, _ref, _ref1;
  obj = {};
  if (xml.nodeType === 9) {
    xml = xml.firstChild;
  }
  if (xml.nodeType === 1) {
    if (xml.attributes.length > 0) {
      obj["@attributes"] = {};
      _ref = xml.attributes;
      for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
        attribute = _ref[index];
        obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3 || xml.nodeType === 4) {
    obj = xml.nodeValue;
  }
  if (xml.hasChildNodes()) {
    _ref1 = xml.childNodes;
    for (index = _j = 0, _len1 = _ref1.length; _j < _len1; index = ++_j) {
      child = _ref1[index];
      if (child.nodeType === 3 && !/\S/.test(child.nodeValue)) {
        continue;
      }
      nodeName = child.nodeName.replace(/:/, "-");
      element = this.xmlToJson(child);
      if (!(element["@attributes"] != null) && (element["#text"] != null)) {
        element = element["#text"];
      }
      if (!(obj[nodeName] != null)) {
        obj[nodeName] = element;
      } else {
        if (!(obj[nodeName] instanceof Array)) {
          obj[nodeName] = [obj[nodeName]];
        }
        obj[nodeName].push(element);
      }
    }
  }
  return obj;
};

/**
 * Returns a platform specific XHR object.
 *
 * @static
*/
Utils.getXHR = function() {
  return new XHR();
};

/**
 * Retrieves a remote text file
 *
 * @static
*/
Utils.get = function(url, client, headers) {
  var xhr;
  if (client == null) {
    client = {};
  }
  if (headers == null) {
    headers = null;
  }
  xhr = Utils.getXHR();
  if (client != null) {
    if (client.withCredentials != null) {
      xhr.withCredentials = client.withCredentials;
    }
    if (client.onload != null) {
      xhr.onload = client.onload;
    }
    if (client.onerror != null) {
      xhr.onerror = client.onerror;
    }
  }
  xhr.open("GET", url);
  if (headers != null) {
    xhr.setRequestHeaders(headers);
  }
  xhr.send();
  return xhr;
};

/**
 * Retrieves a remote text file
 *
 * @static
*/
Utils.getUTC = function() {
  var _this = this;
  return this.request("//time.akamai.com").then(function(xhr) {
    return parseInt(xhr.responseText) * 1000;
  });
};

/**
 * Posts a string to NetStorage.
 *
 * @static
*/
Utils.send = function(url, data, client, headers) {
  var xhr;
  if (client == null) {
    client = {};
  }
  if (headers == null) {
    headers = {
      "Content-Type": "String"
    };
  }
  xhr = Utils.getXHR();
  if (client.onload != null) {
    xhr.onload = client.onload;
  }
  if (client.onerror != null) {
    xhr.onerror = client.onerror;
  }
  xhr.open("POST", url);
  if (headers != null) {
    xhr.setRequestHeaders(headers);
  }
  xhr.send(data);
  return xhr;
};

/**
 * Request an http resource
 *
 * @static
*/
Utils.request = function(options) {
  var _this = this;
  if (options == null) {
    options = {};
  }
  return new Promise(function(resolve, reject) {
    var key, value, xhr, _ref;
    if (typeof options === "string") {
      options = {
        url: options
      };
    }
    if (!(options.method != null)) {
      options.method = "GET";
    }
    xhr = new XMLHttpRequest();
    xhr.withCredentials = options.withCredentials;
    xhr.onload = function() {
      return resolve(xhr);
    };
    xhr.onerror = function(event) {
      return reject(event);
    };
    xhr.open(options.method, options.url);
    if (options.responseType != null) {
      try {
        xhr.responseType = options.responseType;
      } catch (error) {

      }
    }
    if (options.headers != null) {
      _ref = options.headers;
      for (key in _ref) {
        value = _ref[key];
        if ((key != null) && (value != null)) {
          xhr.setRequestHeader(key, value);
        }
      }
    }
    return xhr.send(options.data || options.body);
  });
};

/**
 * Request an http resource
 *
 * @static
*/
Utils.requestJson = function(options) {
  var _this = this;
  if (options == null) {
    options = {};
  }
  return this.request(options).then(function(xhr) {
    return JSON.parse(xhr.responseText);
  });
};

/**
 * Attaches a JavaScript file to the head of the document.
 *
 * @static
*/
Utils.loadScript = function(src, parent) {
  var _this = this;
  return new Promise(function(resolve, reject) {
    var head, script;
    head = parent || document.getElementsByTagName("head")[0];
    script = document.createElement("script");
    script.type = 'text/javascript';
    if (script.addEventListener) {
      script.onload = function() {
        resolve(script);
      };
      script.onerror = reject;
    } else if (script.readyState) {
      script.onreadystatechange = function(event) {
        if (this.readyState === 'loaded' || this.readyState === 'complete') {
          this.onreadystatechange = null;
          resolve(script);
        }
      };
    }
    script.src = src;
    head.appendChild(script);
  });
};

/**
 * Attaches a CSS file to the head of the document.
 *
 * @static
*/
Utils.loadStyleSheet = function(href) {
  var head, link;
  head = document.getElementsByTagName("head")[0];
  link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = href;
  return head.appendChild(link);
};

Utils.read = function(url, client, type, headers) {
  var text, xhr;
  if (client == null) {
    client = {};
  }
  if (type == null) {
    type = "";
  }
  if (headers == null) {
    headers = [];
  }
  try {
    xhr = this.get(url, client, headers);
    text = xhr.responseText || xhr.text;
    if (type === Utils.mimeTypes.json) {
      return JSON.parse(text);
    } else if ((type === Utils.mimeTypes.xml) && (xhr.responseXML != null)) {
      return xhr.responseXML;
    } else {
      return text;
    }
  } catch (error) {
    if (typeof console !== "undefined" && console !== null) {
      if (typeof console.error === "function") {
        console.error("Read Error: ", error);
      }
    }
    return null;
  }
};

Utils.getFileExtension = function(url) {
  if (url == null) {
    url = "";
  }
  return url.replace(/\?.*/, "").replace(/\#.*/, "").split('.').pop();
};

Utils.getResponseHeader = function(url, header, client) {
  var xhr;
  if (client == null) {
    client = {};
  }
  xhr = Utils.getXHR();
  if (client.onerror != null) {
    xhr.onerror = client.onerror;
  }
  xhr.open("HEAD", url, false);
  xhr.send();
  return xhr.getResponseHeader(header);
};

Utils.getResponseHeaders = function(url, headers, client) {
  var header, results, xhr, _i, _len;
  if (client == null) {
    client = {};
  }
  xhr = Utils.getXHR();
  if (client.onerror != null) {
    xhr.onerror = client.onerror;
  }
  xhr.open("HEAD", url, false);
  xhr.send();
  results = {};
  if (!(headers != null)) {
    return xhr.getAllResponseHeaders();
  }
  for (_i = 0, _len = headers.length; _i < _len; _i++) {
    header = headers[_i];
    results[header] = xhr.getResponseHeader(header);
  }
  return results;
};

/**
 * Determines if the device supports touch events
 *
 * @static
*/
Utils.isTouch = null;

/**
 * Determines if the device supports touch events
 *
 * @static
*/
Utils.isTouchDevice = function() {
  if (!(this.isTouch != null)) {
    try {
      document.createEvent("TouchEvent");
      this.isTouch = true;
    } catch (error) {
      this.isTouch = false;
    }
  }
  return this.isTouch;
};

/**
 * Forces a number between a min and a max
 *
 * @static
*/
Utils.clamp = function(value, min, max) {
  if (value < min) {
    value = min;
  }
  if (value > max) {
    value = max;
  }
  return value;
};

/**
 * Beacons a url via an img tag
 *
 * @static
*/
Utils.beacon = function(url, beaconId) {
  var beaconImg;
  if (beaconId == null) {
    beaconId = "beaconId";
  }
  beaconImg = document.getElementById(beaconId);
  if (!(beaconImg != null)) {
    beaconImg = document.createElement("img");
    beaconImg.setAttribute("id", beaconId);
    beaconImg.setAttribute("height", 0);
    beaconImg.setAttribute("width", 0);
    document.body.appendChild(beaconImg);
    beaconImg.style.display = "none";
  }
  beaconImg.setAttribute("src", url);
  return beaconImg;
};

/**
 * Calculates offset Left and Top
 *
 * @static
*/
Utils.getElementOffset = function(element, root) {
  var height, left, scrollLeft, scrollTop, top, width;
  if (root == null) {
    root = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
  }
  left = 0;
  top = 0;
  width = element.offsetWidth;
  height = element.offsetHeight;
  while (element && element !== root) {
    if (element.tagName === "BODY") {
      scrollLeft = element.scrollLeft || document.documentElement.scrollLeft;
      scrollTop = element.scrollTop || document.documentElement.scrollTop;
      left += element.offsetLeft - scrollLeft + element.clientLeft;
      top += element.offsetTop - scrollTop + element.clientTop;
    } else {
      left += element.offsetLeft - element.scrollLeft + element.clientLeft;
      top += element.offsetTop - element.scrollTop + element.clientTop;
    }
    element = element.offsetParent;
  }
  return {
    left: left,
    top: top,
    width: width,
    height: height
  };
};

/**
 * Override the properties of a base object with the values
 * of an override object.
 *
 * @param {Object} base     The base object.
 * @param {Object} overrides  key/value overrides
 * @return {Object}
 * @static
*/
Utils.override = function(base, overrides, clone) {
  var key, value;
  if (clone == null) {
    clone = true;
  }
  if (!(base != null)) {
    return overrides;
  }
  if (!(overrides != null)) {
    return base;
  }
  if (clone === true) {
    base = Utils.clone(base);
    overrides = Utils.clone(overrides);
  }
  for (key in overrides) {
    value = overrides[key];
    if (typeof value === "object" && value !== null) {
      if (base[key] == null) {
        base[key] = value instanceof Array ? [] : {};
      }
      base[key] = Utils.override(base[key], value, false);
    } else {
      base[key] = value;
    }
  }
  return base;
};

/**
 * Clones an object.
 *
 * @param {Object} obj The object to be cloned.
 * @return {Object}
 * @static
*/
Utils.clone = function(obj, deepCopy) {
  var clone, item, k, key, v, value, _i, _len;
  if (deepCopy == null) {
    deepCopy = true;
  }
  if (!(obj != null)) {
    return obj;
  }
  if (typeof obj !== "object") {
    clone = obj;
  } else {
    if (obj instanceof Array) {
      clone = [];
    } else {
      clone = {};
    }
    for (key in obj) {
      value = obj[key];
      if (typeof value === "object" && value !== null && deepCopy === true) {
        if (value instanceof Array) {
          clone[key] = [];
          for (_i = 0, _len = value.length; _i < _len; _i++) {
            item = value[_i];
            clone[key].push(this.clone(item));
          }
        } else {
          clone[key] = {};
          for (k in value) {
            v = value[k];
            clone[key][k] = this.clone(v);
          }
        }
      } else {
        clone[key] = value;
      }
    }
  }
  return clone;
};

/**
 * Takes a time in seconds and converts it to timecode.
 *
 * @param   {Number}  time  The time in seconds to be formatted.
 * @return  {String}  A SMTP formatted string.
*/
Utils.formatTimecode = function(time, duration) {
  var strTime;
  time = parseInt(time);
  if (isNaN(time)) {
    return "00:00";
  }
  strTime = Utils.formatZeroFill(time % 60);
  time = parseInt(time / 60);
  strTime = Utils.formatZeroFill(time % 60) + ":" + strTime;
  time = parseInt(time / 60);
  if (time > 0) {
    strTime = Utils.formatZeroFill(time) + ":" + strTime;
  }
  if (duration >= 3600 && strTime.length === 5) {
    strTime = "00:" + strTime;
  }
  return strTime;
};

/**
 * Converts a time in seconds to a string and adds a zero in front of any number lower than 10.
 *
 * @param Number time The number to be zero filled.
*/
Utils.formatZeroFill = function(time) {
  var str;
  str = time.toString();
  if (time < 10) {
    str = "0" + str;
  }
  return str;
};

/**
 * Converts timecode to seconds.
 *
 * @param   {string}  timeCode        A SMTP formatted string.
 * @param   {number}  [framerate=30]  The frame rate. Used to calculate milliseconds.
 * @return  {number}                  The number of seconds represented by the time code
*/
Utils.flattenTimecode = function(timeCode, framerate) {
  var ms, parts, pieces, time;
  if (framerate == null) {
    framerate = 30;
  }
  if (!(timeCode != null) || timeCode === "") {
    return NaN;
  }
  pieces = timeCode.split(":");
  ms = 0;
  if (pieces.length === 4) {
    ms = parseInt(pieces.pop()) / framerate;
  } else if (pieces.length === 3) {
    pieces[2] = pieces[2].replace(",", ".");
    if (pieces[2].indexOf(".") !== -1) {
      parts = pieces[2].split(".");
    }
    if ((parts != null ? parts.length : void 0) > 1) {
      pieces[2] = parts[0];
      ms = parseInt(parts[1]) / 1000;
    }
  }
  time = parseInt(pieces.pop());
  while (pieces.length > 0) {
    time += Math.pow(60, pieces.length) * parseInt(pieces.shift());
  }
  return time + ms;
};

/**
 * Adds a cache busting query string parameter to a url.
 *
 * @param String url The url.
 * @param String key The name of the query string variable
 * @param Object value The value of the query string variable
*/
Utils.cacheBust = function(url, key, value) {
  var op;
  if (key == null) {
    key = "cacheBust";
  }
  if (value == null) {
    value = Date.now();
  }
  op = url.indexOf('?') === -1 ? "?" : "&";
  return url + op + key + "=" + value;
};

/**
 * Converts a camel case string in to a CSS proptery name.
*/
Utils.formatStyleName = function(styleName) {
  return styleName.replace(/([A-Z])/, "-$1").toLowerCase();
};

/**
 * Trims whitespace from the beginning and end of a string
*/
Utils.trim = function(str) {
  var trim;
  trim = str.replace(/^\s*(.*)/, "$1");
  return trim.replace(/(.*)\s*$/, "$1");
};

/**
*/
Utils.getFeed = function(url) {
  var _this = this;
  return this.request(url).then(function(xhr) {
    if (xhr.responseType === "document" || (xhr.responseXML != null)) {
      return Utils.xmlToJson(xhr.responseXML);
    } else {
      return JSON.parse(xhr.response);
    }
  });
};

/**
*/
Utils.getSource = function(url, onload, onerror) {
  var feedloadedHandler, mode;
  mode = Utils.getPlaybackMode();
  feedloadedHandler = function(feed) {
    var canPlayType, helper, source, _ref;
    helper = new MRSSHelper();
    feed = helper.createFeed(feed);
    if ((feed != null ? (_ref = feed.item) != null ? _ref.length : void 0 : void 0) > 0) {
      canPlayType = function(type) {
        if ((mode === "flash" && Utils.flashTypes.indexOf(type) !== -1) || (mode === "html" && Utils.flashTypes.indexOf(type) === -1)) {
          return "maybe";
        } else {
          return "";
        }
      };
      source = Utils.selectSource(feed.item[0].source, canPlayType);
    }
    if (typeof onload === "function") {
      onload(source);
    }
  };
  Utils.getFeed(url).then(feedloadedHandler)["catch"](onerror);
};

/**
*/
Utils.trackMouse = function() {
  try {
    if (document.addEventListener != null) {
      document.addEventListener("mousemove", this.mouseTracker);
    } else if (document.attachEvent != null) {
      document.attachEvent("mousemove", this.mouseTracker);
    }
  } catch (error) {

  }
};

Utils.clientX = 0;

Utils.clientY = 0;

Utils.pageX = 0;

Utils.pageY = 0;

/**
*/
Utils.mouseTracker = function(event) {
  Utils.clientX = event.clientX;
  Utils.clientY = event.clientY;
  Utils.pageX = event.pageX;
  Utils.pageY = event.pageY;
};

/**
*/
Utils.isMouseOverElement = function(element) {
  var isOver;
  isOver = false;
  if (!(element != null)) {
    return isOver;
  }
  try {
    isOver = element.contains(document.elementFromPoint(Utils.clientX, Utils.clientY));
  } catch (error) {
    isOver = false;
  }
  return isOver;
};

Utils.trackMouse();

/** Function to get Outer Dimensions
*/
Utils.getActualSize = function(element, margin) {
  var height, style, width;
  if (margin == null) {
    margin = true;
  }
  width = element.offsetWidth;
  height = element.offsetHeight;
  if (margin === true) {
    style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  }
  return {
    "width": width,
    "height": height
  };
};

Utils.isVolumeSettable = function() {
  var noVolume, ua;
  ua = navigator.userAgent.toLowerCase();
  noVolume = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(ua);
  if (noVolume != null) {
    if (noVolume[0] === "android" && /Firefox/.test(ua)) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

/**
 * Creates a flash object tag.
 *
 * @param {string} swf
 *    The number to be zero filled.
 *
 * @param {Object} flashvars
 *
 * @return {HTMLObjectElement}
 *    The flash object tag.
 *
 * @static
*/
Utils.createFlashObject = function(flash, parent) {
  var atts, id, innerHTML, key, params, value, vars, _ref, _ref1;
  if (!(flash != null)) {
    return;
  }
  params = {
    allowFullScreen: true,
    allowScriptAccess: "always",
    wmode: "direct",
    bgColor: "#000000"
  };
  Utils.override(params, flash.params, false);
  if (flash.vars != null) {
    vars = [];
    _ref = flash.vars;
    for (key in _ref) {
      value = _ref[key];
      vars.push("" + key + "=" + value);
    }
    params.flashvars = vars.join("&");
  }
  id = ((_ref1 = flash.attributes) != null ? _ref1.id : void 0) || this.createUID();
  atts = {
    id: id,
    name: id,
    width: "100%",
    height: "100%",
    type: "application/x-shockwave-flash"
  };
  Utils.override(atts, flash.attributes, false);
  if (this.getIEVersion() !== -1) {
    if (params.wmode === "direct") {
      params.wmode = "transparent";
    }
  }
  innerHTML = "<object ";
  for (key in atts) {
    value = atts[key];
    innerHTML += "" + key + "=\"" + value + "\" ";
  }
  innerHTML += ">\n";
  for (key in params) {
    value = params[key];
    innerHTML += "<param name=\"" + key + "\" value=\"" + value + "\" />\n";
  }
  innerHTML += "</object>";
  parent.innerHTML = innerHTML;
};

/**
 * Creates a unique id.
 *
 * @param   {number=}   base
 *    The base to use for representing a numeric value.
 *
 * @return  {string}
 *    The unique id.
*/
Utils.createUID = function(base) {
  var date, len, max, rand;
  if (base == null) {
    base = 16;
  }
  date = Date.now();
  len = 2;
  max = base * len - 1;
  rand = Math.round(Math.random() * max + base);
  return (rand.toString(16) + date.toString(16)).toUpperCase();
};

/**
 * Chains an array of promises sequentially
 *
 * @param   {Array}   promises
 *    The list of promises
 *
 * @param   {Object}   data
 *    Data to be passes from promise to promise
 *
 * @return  {Promise}
 *    The promise chain
*/
Utils.chain = function(promises, data) {
  var chain, promise, _i, _len;
  chain = Promise.resolve(data);
  for (_i = 0, _len = promises.length; _i < _len; _i++) {
    promise = promises[_i];
    chain = chain.then(promise);
  }
  return chain;
};

/**
 * Converts an array buffer to UTF-8 string.
 *
 * @param   {ArrayBuffer}   arrayBuffer
 *    The ArrayBuffer
 *
 * @return  {String}
 *    The UTF-8 string
*/
Utils.arrayBufferToString = function(arrayBuffer) {
  return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
};

/**
 * Parses a JSON Web Token
 *
 * @param {String} jwt
 *
 * @return {Object}
 *    The parsed JSON Web Token as an object
*/
Utils.parseJWT = function(jwt) {
  var parts;
  parts = jwt.split(".");
  return {
    header: JSON.parse(atob(parts[0])),
    payload: JSON.parse(atob(parts[1])),
    signature: parts[2]
  };
};

/**
 *
*/
Utils.getFullScreenApi = function(container, video) {
  var fullscreen;
  fullscreen = {};
  if (container.webkitRequestFullScreen != null) {
    fullscreen.enter = container.webkitRequestFullScreen.bind(container);
    fullscreen.exit = document.webkitExitFullscreen != null ? document.webkitExitFullscreen.bind(document) : document.webkitCancelFullScreen.bind(document);
    fullscreen.event = "onwebkitfullscreenchange";
    fullscreen.element = "webkitFullscreenElement";
    fullscreen.error = "webkitfullscreenerror";
  } else if (container.requestFullscreen != null) {
    fullscreen.enter = container.requestFullscreen.bind(container);
    fullscreen.exit = document.exitFullscreen != null ? document.exitFullscreen.bind(document) : document.cancelFullscreen.bind(document);
    fullscreen.event = "onfullscreenchange";
    fullscreen.element = "fullscreenElement";
    fullscreen.error = "fullscreenerror";
  } else if (container.mozRequestFullScreen != null) {
    fullscreen.enter = container.mozRequestFullScreen.bind(container);
    fullscreen.exit = document.mozCancelFullScreen.bind(document);
    fullscreen.event = "onmozfullscreenchange";
    fullscreen.element = "mozFullscreenElement";
    fullscreen.error = "mozfullscreenerror";
  } else if (container.msRequestFullscreen != null) {
    fullscreen.enter = container.msRequestFullscreen.bind(container);
    fullscreen.exit = document.msExitFullscreen.bind(document);
    fullscreen.event = "MSFullscreenChange";
    fullscreen.element = "msFullscreenElement";
    fullscreen.error = "MSFullscreenError";
  } else if (video.webkitEnterFullscreen != null) {
    fullscreen.enter = video.webkitEnterFullscreen.bind(video);
    fullscreen.exit = video.webkitExitFullscreen.bind(video);
    fullscreen.event = null;
    fullscreen.error = null;
  }
  return fullscreen;
};

/**
*/
Utils.stringToArray = function(string) {
  var array, buffer, i, _i, _ref;
  buffer = new ArrayBuffer(string.length * 2);
  array = new Uint16Array(buffer);
  for (i = _i = 0, _ref = string.length - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
    array[i] = string.charCodeAt(i);
  }
  return array;
};

/**
*/
Utils.arrayToString = function(array) {
  return String.fromCharCode.apply(null, new Uint16Array(array.buffer));
};

/**
*/
Utils.base64DecodeUint8Array = function(input) {
  var array, i, raw, rawLength, _i, _ref;
  raw = window.atob(input);
  rawLength = raw.length;
  array = new Uint8Array(new ArrayBuffer(rawLength));
  for (i = _i = 0, _ref = rawLength - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
};

/**
*/
Utils.base64EncodeUint8Array = function(input) {
  var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {
      chr1 = input[i++];
      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index
      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    };
  return output;
};

/**
*/
Utils.getKeySystem = function() {
  var ua;
  ua = navigator.userAgent;
  if (/Edge/.test(ua) || /Trident/.test(ua)) {
    return "com.microsoft.playready";
  } else if (/Chrome/.test(ua) || /Firefox/.test(ua)) {
    return "com.widevine.alpha";
  } else {
    return "com.apple.fps.1_0";
  }
};

/**
*/
Utils.isAutoplaySupported = function() {
  var supported;
  supported = true;
  if (this.isIOS()) {
    if (this.getSafariVersion() !== -1) {
      supported = this.getIOSversion()[0] >= 10;
    } else if (this.isChrome()) {
      supported = this.getChromeVersion() >= 53;
    }
  }
  if (this.isChrome() && this.isAndroid()) {
    supported = this.getChromeVersion() >= 53;
  }
  return supported;
};

/**
 * The AMPConfig class
 *   
 * @constructor
 * @private
 * @extends {EventDispatcher}
*/
function AMPConfig() {
  AMPConfig.__super__.constructor.call(this, this, false);
}


__extends(AMPConfig, EventDispatcher);


AMPConfig.UNINITIALIZED = 0;

AMPConfig.LOADING = 1;

AMPConfig.LOADED = 2;

/**
 * Converst XML to a native JS object
 * 
 * @param   {Element} xml   The XML to convert
 * @return  {Object}
 * @static
*/
AMPConfig.parseModule = function(xml) {
  var child, childNodes, count, i, k, node, obj, _i, _len;
  obj = {};
  i = 0;
  childNodes = xml.childNodes;
  count = childNodes.length;
  k = 0;
  node = null;
  child = null;
  for (_i = 0, _len = childNodes.length; _i < _len; _i++) {
    node = childNodes[_i];
    if ((node != null ? node.nodeType : void 0) === 1) {
      obj[node.nodeName] = this.parseItem(node);
    }
  }
  return obj;
};

AMPConfig.parseItem = function(node) {
  var child, children, type, value, _i, _len;
  type = ("" + (node.getAttribute('type'))).toLowerCase();
  value = node.textContent || node.text || node.innerText;
  if (type !== "object" && type !== "array" && /#\{.*\}/.test(value)) {
    return value;
  }
  switch (type) {
    case "object":
      value = this.parseModule(node);
      break;
    case "array":
      value = [];
      children = node.childNodes;
      for (_i = 0, _len = children.length; _i < _len; _i++) {
        child = children[_i];
        if (child.nodeType !== 1) {
          continue;
        }
        value.push(this.parseItem(child));
      }
      break;
    case "boolean":
      value = value.toLowerCase() === "true";
      break;
    case "number":
      value = parseFloat(value);
  }
  return value;
};

AMPConfig.prototype.url = null;

AMPConfig.prototype.data = null;

AMPConfig.prototype.xml = null;

AMPConfig.prototype.readyState = AMPConfig.UNINITIALIZED;

AMPConfig.prototype.loaded = false;

AMPConfig.prototype.flash = {
  PlaybackMetricsPlugin: {
    src: '#{paths.resources}plugins/PlaybackMetricsPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "PlaybackMetricsPlugin"
  },
  SubclipMonitorPlugin: {
    src: '#{paths.resources}plugins/SubclipMonitorPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "SubclipMonitorPlugin"
  },
  NetSessionClientPlugin: {
    src: '#{paths.resources}plugins/NetSessionClientPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "NetSessionClientPlugin"
  }
};

/**
*/
AMPConfig.prototype.loadURL = function(url, withCredentials) {
  var xhr,
    _this = this;
  if (withCredentials == null) {
    withCredentials = false;
  }
  this.url = url;
  this.setReadyState(AMPConfig.LOADING);
  xhr = Utils.get(url, {
    withCredentials: withCredentials,
    onload: function(event) {
      var data, firstChild, xmlhttp;
      xmlhttp = event.detail;
      if (xmlhttp.responseType === "document") {
        _this.xml = xmlhttp.responseXML;
        firstChild = _this.xml.firstChild.nodeType !== 7 ? _this.xml.firstChild : _this.xml.childNodes[1];
        data = AMPConfig.parseModule(firstChild);
      } else {
        data = xmlhttp.response;
        if (typeof data === "string") {
          data = JSON.parse(data);
        }
      }
      _this.loadData(data);
    },
    onerror: function(event) {
      _this.dispatchEvent(new Event("error", event));
      Logger.error(event);
    }
  });
};

/**
*/
AMPConfig.prototype.loadData = function(data) {
  Config.defaults = data;
  this.setReadyState(AMPConfig.LOADED);
};

/**
*/
AMPConfig.prototype.load = function(resource, withCredentials) {
  if (withCredentials == null) {
    withCredentials = false;
  }
  switch (typeof resource) {
    case "object":
      this.loadData(resource);
      break;
    case "string":
      this.loadURL(resource, withCredentials);
      break;
    default:
      throw new Error("[AMP ERROR] Invalid default configuration resource");
  }
};

/**
*/
AMPConfig.prototype.setReadyState = function(state) {
  this.readyState = state;
  this.dispatchEvent(new Event("readystatechange", state));
  if (state === AMPConfig.LOADED && !this.loaded) {
    this.loaded = true;
    this.dispatchEvent(new Event("load", this.data));
  }
};

/**
 * The CaptionCue class.
 *   
 * @constructor
 * @private
 * @param {number} startTime  The start time of the cue in seconds
 * @param {number} endTime    The end time of the cue in seconds
 * @param {number} text       The text of the cue
*/
function CaptionCue(startTime, endTime, id) {
  this.startTime = startTime;
  this.endTime = endTime;
  this.id = id;
}

CaptionCue.prototype.id = null;

CaptionCue.prototype.startTime = null;

CaptionCue.prototype.endTime = null;

CaptionCue.prototype.text = null;

CaptionCue.prototype.html = null;

CaptionCue.prototype.align = null;

/**
 * @enum {string}
 * @const
 * @private
*/

var FeatureNotifications = {
  REGISTER_FEATURE: "registerfeature"
};

function SRTParser() {}

/**
 * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.
 *
 * @param   {CaptionTrack}  track The caption track to populate
 * @param   {String}        txt   The text of the srt file
 * @return  {CaptionTrack}        The populated caption track
*/
SRTParser.prototype.parse = function(track, txt) {
  var caption, captions, cue, end, index, parts, start, text, times, _i, _len;
  txt = txt.replace(/\r/g, '');
  captions = txt.split("\n\n");
  for (_i = 0, _len = captions.length; _i < _len; _i++) {
    caption = captions[_i];
    parts = caption.split("\n");
    try {
      index = parts[0];
      times = parts[1].match(/([0-9:\,]+)\s*-->\s*([0-9:\,]+)/).slice(1);
      start = Utils.flattenTimecode(times[0]);
      end = Utils.flattenTimecode(times[1]);
      text = parts.slice(2);
    } catch (err) {
      Logger.instance.warn("SRT Parsing Warning");
    }
    cue = new CaptionCue(start, end, "cue_" + index);
    cue.html = "<p>" + text.join("<br />") + "</p>";
    cue.text = text.join("\n");
    track.cues.push(cue);
  }
  return track;
};

function WebVTTParser() {}

/**
 * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.
 * 
 * @param   {CaptionTrack}  track The caption track to populate
 * @param   {String}        txt   The text of the srt file
 * @return  {CaptionTrack}        The populated caption track
*/
WebVTTParser.prototype.parse = function(track, txt) {
  var caption, captions, cue, end, index, parts, settings, start, text, times, _i, _len;
  txt = txt.replace(/\r/g, '');
  captions = txt.split("\n\n");
  index = 0;
  if (/^WEBVTT/.test(captions[0])) {
    captions.shift();
  }
  for (_i = 0, _len = captions.length; _i < _len; _i++) {
    caption = captions[_i];
    if (!(caption !== "")) {
      continue;
    }
    parts = caption.split("\n");
    try {
      index = /^[0-9]+$/.test(parts[0]) ? parts.shift() : ++index;
      times = parts[0].match(/([0-9:\.]+)\s*-->\s*([0-9:\.]+)([^\n]*)/).slice(1);
      settings = times[2];
      start = Utils.flattenTimecode(times[0]);
      end = Utils.flattenTimecode(times[1]);
      text = parts.slice(1);
    } catch (err) {
      Logger.error("WebVTT Parse Error");
    }
    cue = new CaptionCue(start, end, "cue_" + index);
    cue.html = "<p>" + text.join("<br />") + "</p>";
    cue.text = text.join("\n");
    if (settings != null) {
      settings.replace(/\s*([A-Za-z]+)\s*:\s*([\w\-\%]+)/g, function(match, $1, $2) {
        cue[$1] = $2;
        return "";
      });
    }
    track.cues.push(cue);
  }
  return track;
};

function SMPTETTParser() {}

/**
 * Parses a SMPTETT file into CaptionCue objects and attaches them to a given track.
 * 
 * @param   {CaptionTrack}  track The caption track to populate
 * @param   {XMLDocument}   xml   The SMPTETT xml document
 * @return  {CaptionTrack}        The populated caption track
*/
SMPTETTParser.prototype.parse = function(track, xml) {
  var captions, lang, styledElements, styles, tt,
    _this = this;
  if (typeof xml === "string") {
    xml = XMLUtils.parse(xml);
  }
  styles = Array.prototype.slice.call(xml.querySelectorAll("styling style"));
  styles.forEach(function(item, index, list) {
    var attributes, id, style;
    style = "";
    id = item.getAttribute("id") || item.getAttribute("xml:id");
    attributes = Array.prototype.slice.call(item.attributes);
    attributes.forEach(function(item, index, array) {
      if (item.prefix === "tts") {
        return style += Utils.formatStyleName(item.localName) + ":" + item.nodeValue + ";";
      }
    });
    track.styles[id] = style;
  });
  styledElements = Array.prototype.slice.call(xml.querySelectorAll("body [style]"));
  styledElements.forEach(function(item, index, array) {
    var id;
    id = item.getAttribute("style");
    item.setAttribute("style", track.styles[id]);
  });
  tt = xml.querySelector("tt");
  lang = tt.getAttribute("lang") || tt.getAttribute("xml:lang");
  if (track.language === void 0 || track.language === null) {
    track.language = lang;
  }
  captions = Array.prototype.slice.call(xml.querySelectorAll("body p[begin]"));
  captions.forEach(function(item, index, array) {
    var align, cue, end, start, text;
    start = item.getAttribute("begin");
    item.removeAttribute("begin");
    if (item.getAttribute("end") != null) {
      end = item.getAttribute("end");
      item.removeAttribute("end");
    } else if (captions[index + 1] != null) {
      end = captions[index + 1].getAttribute("begin");
    }
    cue = new CaptionCue(Utils.flattenTimecode(start), Utils.flattenTimecode(end), "cue_" + index);
    align = item.getAttributeNS("http://www.w3.org/ns/ttml#styling", "textAlign");
    if (align != null) {
      cue.align = align === "center" ? "middle" : align;
      item.removeAttributeNS("http://www.w3.org/ns/ttml#styling", "textAlign");
    }
    text = XMLUtils.serialize(item);
    text = text.replace(/\s*xmlns="[^"]*"/, "");
    cue.html = text;
    text = text.replace(/^<p[^>]*>/, "");
    text = text.replace(/<\/p>$/, "");
    text = text.replace(/<br\/>/, "\n");
    text = text.replace(/<span style="([^"]*)"/, "<c.$1");
    text = text.replace(/<\/span>/, "</c>");
    cue.text = text;
    track.cues.push(cue);
  });
  return track;
};

/**
 * @constructor
 * @private
*/
function LiveCaptionProxy() {
  var com,
    _this = this;
  this.captions = [];
  this.head = document.getElementsByTagName("head")[0];
  com = window.com || {};
  com.akamai = com.akamai || {};
  com.akamai.amp = com.akamai.amp || {};
  com.akamai.amp.plugins = com.akamai.amp.plugins || {};
  com.akamai.amp.plugins.subply = com.akamai.amp.plugins.subply || {};
  com.akamai.amp.plugins.subply.response = function(json) {
    _this.parse(json);
    _this.poll();
  };
  if (!(window.com != null)) {
    window.com = com;
  }
  LiveCaptionProxy.__super__.constructor.call(this, this.constructor.NAME);
}


__extends(LiveCaptionProxy, puremvc.Proxy);


/** @static
*/
LiveCaptionProxy.NAME = "LiveCaptionProxy";

LiveCaptionProxy.prototype.data = {
  base: "http://test.plymedia.com.s3.amazonaws.com/online/Akamai_",
  interval: 1000
};

LiveCaptionProxy.prototype.caption = null;

LiveCaptionProxy.prototype.head = null;

LiveCaptionProxy.prototype.script = null;

LiveCaptionProxy.prototype.timeout = null;

/**
 *
*/
LiveCaptionProxy.prototype.getURL = function() {
  return this.data.url;
};

LiveCaptionProxy.prototype.setURL = function(value) {
  this.data.url = value;
  return value;
};

LiveCaptionProxy.prototype.start = function() {
  this.send();
};

LiveCaptionProxy.prototype.poll = function() {
  var timeout,
    _this = this;
  timeout = setTimeout(function() {
    _this.send();
  }, this.data.interval || 1000);
};

LiveCaptionProxy.prototype.send = function() {
  var _this = this;
  if (this.script != null) {
    this.head.removeChild(this.script);
  }
  this.script = Utils.loadScript(this.data.base + this.data.url + ".js?nocache=" + Date.now()).then(function(script) {
    return _this.script = script;
  })["catch"](function(error) {
    return _this.facade.logger.error("[AMP CAPTIONING ERROR]", error);
  });
};

LiveCaptionProxy.prototype.stop = function() {
  clearTimeout(timeout);
};

/**
 *
*/
LiveCaptionProxy.prototype.parse = function(response) {
  var html, text, _i, _len, _ref;
  if (response.Stream !== this.data.url) {
    return;
  }
  if ((this.caption != null) && this.caption.id >= response.Ticks) {
    return;
  }
  this.caption = new CaptionCue(Utils.flattenTimecode(response.From), Utils.flattenTimecode(response.To), response.Ticks);
  this.caption.text = response.Text;
  html = "";
  _ref = response.Text.split("\n");
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    text = _ref[_i];
    if (html !== "") {
      html += "<br />";
    }
    html += "<span>" + text + "</span>";
  }
  this.caption.html = "<p>" + html + "</p>";
  this.sendNotification(CaptioningNotifications.CUE_CHANGE, [this.caption]);
  return this.caption;
};

/**
 * @constructor
*/
function AMP() {}

/**
 * Create a player based on the configuration object and container.
 *
 * @param {string|HTMLElement} container
 *    The id of the div the player will be attached to.
 *
 * @param {?(Object|string)} config
 *    The configuration override object.
 *
 * @param {?Function} onready
 *    Optional ready handler.
 *
 * @return {Player}
 *
*/
AMP.create = function(container, config, onready) {
  var element, initTime, player, version;
  initTime = Date.now();
  if (typeof container === "string") {
    element = document.getElementById(container);
    if (!(element != null)) {
      element = document.querySelector(container);
    }
  } else {
    element = container;
  }
  if (!(element != null)) {
    throw new Error("[AMP ERROR] Invalid container. Could not find DOM element: " + container);
  }
  config = config instanceof Config ? config : Config.create(config);
  Logger.instance = new LoggerConstructor(config.debug);
  version = this.getVersion();
  if (element.dataset == null) {
    element.dataset = {};
  }
  element.dataset["amp.version"] = version;
  Logger.instance.log("[AMP] " + version);
  player = this.createPlayer(config, element);
  player.initTime = initTime;
  element.amp = player;
  player.request = this.request.bind(this);
  player.require = this.require.bind(this);
  player.loadResources = player.loadModuleResources.bind(player);
  player.onready = onready;
  player.initialize(config);
  return player;
};

/**
 *
*/
AMP.createPlayer = function(config, container) {
  var player;
  player = this.players[config.mode];
  if (player != null) {
    player = new player(container);
  }
  return player;
};

/**
 * Returns the version string for this player library.
 *
 * @return {string} The version string.
*/
AMP.getVersion = function() {
  return this.VERSION;
};

/**
 * The player version string
 *
 * @type {string}
 * @private
 * @static
*/
AMP.VERSION = "AMP v4.84.10";

/**
 * @private
*/
AMP.defaults = new AMPConfig();

/**
 * @private
*/
AMP.plugins = [];

/**
 * @private
*/
AMP.players = {};

/**
 * Loads a default configuration object from a url.
 *
 * @param {string} url
 *    A url to a configuration json file to use at the defaults object.
 *
 * @param {?Function} loaded
 *    Callback function triggered when the file has been loaded and
 *    sucessfully parsed.
 *
 * @param {?Function} error
 *    Callback function triggered when the file has failed to load
 *    or cannot be parsed.
 *
 * @param {boolean} [withCredentials=false]
 *    Whether or not to use credntials when making XMLHttpRequest.
 *
 * @static
*/
AMP.loadDefaults = function(url, loaded, error, withCredentials) {
  if (withCredentials == null) {
    withCredentials = false;
  }
  if (loaded != null) {
    this.defaults.addEventListener("load", loaded);
  }
  if (error != null) {
    this.defaults.addEventListener("error", error);
  }
  this.defaults.load(url, withCredentials);
};

/**
 * Returns the playback mode best suited for the current environment.
 *
 * @return {PlaybackMode}
 *    The playback mode.
 *
 * @static
*/
AMP.getPlaybackMode = function() {
  return Utils.getPlaybackMode();
};

/**
 * @private
 * @static
*/
AMP.registerPlayer = function(mode, player) {
  this.players[mode] = player;
};

/**
 * Registers a plugin factory function. This function is
 * called when akamai.amp.AMP.create is called and the
 * config object contains the plugin key.
 *
 * @param {String} key
 *    The plugin key. Used to configure the plugin.
 *
 * @param {String|Array.<String>} mode
 *    The player mode(s) in which the plugin can be used.
 *
 * @param {Function} factory
 *
 * @static
*/
AMP.registerPlugin = function(id, mode, plugin) {
  var item, _base, _i, _len, _ref;
  if ((_base = this.plugins)[id] == null) {
    _base[id] = {};
  }
  if (typeof mode === "function") {
    _ref = [plugin, mode], mode = _ref[0], plugin = _ref[1];
  }
  if (typeof mode === "string") {
    mode = [mode];
  }
  if (!(mode != null)) {
    mode = ["html", "flash"];
  }
  for (_i = 0, _len = mode.length; _i < _len; _i++) {
    item = mode[_i];
    this.plugins[id][item] = plugin;
  }
};

/**
 * @type {akamai.amp.ResourceManager}
 * @private
*/
AMP.resourceManager = null;

/**
 * Short cut getter for the global renderer manager
 *
 * @return {akamai.amp.ResourceManager}
 *
 * @static
 * @private
*/
AMP.getResourceManager = function() {
  if (!(this.resourceManager != null)) {
    this.resourceManager = new ResourceManager();
  }
  return this.resourceManager;
};

/**
 * @param {akamai.amp.Resource} resource
 *    The resource definition
 *
 * @param {Function} callback
 *
 * @static
 * @private
*/
AMP.addResource = function(resource) {
  return this.getResourceManager().add(resource);
};

/**
 * @param {Array.<akamai.amp.Resource>} resources
 *    The list of resources
 *
 * @param {Function} callback
 *
 * @static
 * @private
*/
AMP.addResources = function(resources) {
  return this.getResourceManager().addResources(resources);
};

/**
 * Request a http resource.
 *
 * @param {String|Object} options
 *    A url string or an object containing the following properties:
 *
 * @return {Promise.<XHR>}
 *     Promise which resolves to a XHR object
 *
 * @static
*/
AMP.request = function(options) {
  return Utils.request(options);
};

/**
 * Request a http json resource.
 *
 * @param {String|Object} options
 *    A url string or an object containing the following properties:
 *
 * @return {Promise.<Object>}
 *     Promise which resolves to a js object
 *
 * @static
*/
AMP.requestJson = function(options) {
  return Utils.requestJson(options);
};

/**
 * Loads resource from url or cache
 *
 * @param {String} id
 *    A url or id of the resource
 *
 * @return {Promise.<Object>}
 *     Promise which resolves to an object
 *
 * @static
*/
AMP.require = function(id) {
  return this.resourceManager.require(id);
};

/**
 * @param {!string} key
 *     The resource's key
 *
 * @return {akamai.amp.Resource}
 *     The resource definition
 *
 * @static
 * @private
*/
AMP.getResource = function(key) {
  return this.getResourceManager().item(key);
};

/**
 * @param {!string} key
 *     The resource's key
 *
 * @return {Function}
 *     The resource's constructor
 *
 * @static
 * @private
*/
AMP.removeResource = function(key) {
  return this.getResourceManager().remove(key);
};

/**
 * Evaluate a data bound object.
 *
 * @param {Object} binding
 *   The data bound object.
 *
 * @param {Object} context
 *   The context object used as "global" when evaluating the binding.
 *
 * @return {string}
 *   The evaluated result
*/
AMP.evaluateBindings = function(value, context, params, clone) {
  var exec, key, regexp, _ref,
    _this = this;
  if (clone == null) {
    clone = true;
  }
  if (!(value != null)) {
    return;
  }
  if (typeof value === "object") {
    clone = clone === true ? JSON.parse(JSON.stringify(value)) : value;
    if (value instanceof Array) {
      return clone.map(function(item) {
        return _this.evaluateBindings(item, context, params, false);
      });
    } else {
      value = {};
      for (key in clone) {
        value[key] = this.evaluateBindings(clone[key], context, params, false);
      }
      return value;
    }
  } else if (typeof value === "string") {
    regexp = /(#|\$){([^#\$]*)}/g;
    exec = function(binding, context, params) {
      return (new Function("params", "with (this) { return " + binding + " }")).bind(context)(params);
    };
    if (((_ref = value.match(regexp)) != null ? _ref.length : void 0) > 1) {
      return value.replace(regexp, function(match, token, binding) {
        try {
          return exec(binding, context, params);
        } catch (error) {
          return value;
        }
      });
    } else {
      try {
        return exec(regexp.exec(value)[2], context, params);
      } catch (error) {
        return value;
      }
    }
  } else {
    return value;
  }
};


AMP.registerPlayer("html", HTMLPlayer);
AMP.registerPlayer("flash", FlashPlayer);
AMP.registerPlayer("none", InstallPlayer);
AMP.registerPlayer("external", ExternalPlayer);

/**
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function PluginCommand() {
  PluginCommand.__super__.constructor.call(this);
}


__extends(PluginCommand, PlayerCommand);


PluginCommand.prototype.plugin = null;

PluginCommand.prototype.proxy = null;

/** @override
*/
PluginCommand.prototype.initializeNotifier = function(key) {
  PluginCommand.__super__.initializeNotifier.call(this, key);
  this.proxy = this.facade.retrieveProxy(ModuleProxy.NAME);
  this.plugin = this.facade;
};

/**
 * The CaptioningChangeMediaCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.plugins.PluginCommand}
*/
function CaptioningChangeMediaCommand() {
  CaptioningChangeMediaCommand.__super__.constructor.call(this);
}


__extends(CaptioningChangeMediaCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
CaptioningChangeMediaCommand.prototype.execute = function(notification) {
  var media, track;
  media = notification.getBody();
  track = notification.getBody().track;
  this.proxy.setTracks(track);
  if (!(track != null)) {
    this.sendNotification(CaptioningNotifications.ENABLED, false);
    return;
  }
  this.proxy.selectRenderer(media);
  this.sendNotification(CaptioningNotifications.ENABLED, true);
};

/**
 * @constructor
 * @private
 * @extends {amp.player.controller.PlayerCommand}
*/
function PluginEventCommand() {
  PluginEventCommand.__super__.constructor.call(this);
}


__extends(PluginEventCommand, PluginCommand);


/**
 *
*/
PluginEventCommand.prototype.dispatchEvent = function(type, detail) {
  var event, name, _base;
  if (typeof type !== "string") {
    detail = type.getBody();
    if (!(detail != null)) {
      detail = {};
    }
    type = type.getName();
  }
  name = typeof (_base = this.plugin).getFeatureName === "function" ? _base.getFeatureName() : void 0;
  if ((name != null) && name !== "auth") {
    type = type.replace(new RegExp("^(" + name + ")"), "");
  }
  name = this.plugin.getModuleName();
  type = type.replace(new RegExp("^(" + name + ")"), "");
  event = new Event(type, detail);
  this.sendNotification(Notifications.DISPATCH_EVENT, event);
};

/**
 *
*/
PluginEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {
  setTimeout(this.dispatchEvent.bind(this, type, detail), 0);
};

/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
PluginEventCommand.prototype.execute = function(notification) {
  this.dispatchEvent(notification);
};

/**
 * The CaptioningEnabledCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.plugins.PluginEventCommand}
*/
function CaptioningEnabledCommand() {
  CaptioningEnabledCommand.__super__.constructor.call(this);
}


__extends(CaptioningEnabledCommand, PluginEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
CaptioningEnabledCommand.prototype.execute = function(notification) {
  this.proxy.setEnabled(notification.getBody());
  CaptioningEnabledCommand.__super__.execute.call(this, notification);
};

/**
 * @enum {string}
 * @const
 * @private
*/

var UserSettingsNotifications = {
  SETTING_CHANGE: "settingchange",
  UPDATE_SETTINGS: "updatesettings"
};

/**
 * The ChangeVisibilityCommand class.
 *
 * @constructor
 * @private
 * @extends {amp.plugins.PluginEventCommand}
*/
function CaptioningVisibilityChangeCommand() {
  CaptioningVisibilityChangeCommand.__super__.constructor.call(this);
}


__extends(CaptioningVisibilityChangeCommand, PluginEventCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
CaptioningVisibilityChangeCommand.prototype.execute = function(notification) {
  var hidden;
  hidden = !notification.getBody();
  if (hidden === this.proxy.getHidden()) {
    return;
  }
  this.proxy.setHidden(hidden);
  CaptioningVisibilityChangeCommand.__super__.execute.call(this, notification);
};

/**
 * The CaptioningTimeUpdateCommand class.
 *   
 * @constructor
 * @private
 * @extends {amp.plugins.PluginCommand}
*/
function CaptioningTimeUpdateCommand() {
  CaptioningTimeUpdateCommand.__super__.constructor.call(this);
}


__extends(CaptioningTimeUpdateCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
CaptioningTimeUpdateCommand.prototype.execute = function(notification) {
  var active, changed, cue, cues, index, time, track, _i, _len;
  time = notification.getBody();
  track = this.proxy.getTrack();
  if (!(track != null)) {
    return;
  }
  active = track.activeCues;
  cues = track.cues;
  changed = false;
  for (_i = 0, _len = cues.length; _i < _len; _i++) {
    cue = cues[_i];
    if (time >= cue.startTime && time < cue.endTime) {
      if (!(__indexOf.call(active, cue) >= 0)) {
        active.push(cue);
        changed = true;
      }
    } else {
      index = active.indexOf(cue);
      if (index !== -1) {
        active.splice(index, 1);
        changed = true;
      }
    }
  }
  if (changed === true) {
    this.sendNotification(CaptioningNotifications.CUE_CHANGE, active);
  }
};

/**
 * The CaptioningStartedCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function CaptioningStartedCommand() {
  CaptioningStartedCommand.__super__.constructor.call(this);
}


__extends(CaptioningStartedCommand, puremvc.SimpleCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
CaptioningStartedCommand.prototype.execute = function(notification) {
  var proxy, track, _ref;
  proxy = this.facade.retrieveProxy(CaptioningProxy.NAME);
  track = proxy.getTrack();
  if (!(track != null) && ((_ref = proxy.getTracks()) != null ? _ref.length : void 0) > 0) {
    track = proxy.autoSelectTrack();
  }
  if ((track != null ? track.isLive : void 0) === true) {
    this.facade.removeCommand(Notifications.TIME_UPDATE);
    proxy = this.facade.retrieveProxy(LiveCaptionProxy.NAME);
    if (!(proxy != null)) {
      proxy = new LiveCaptionProxy();
      this.facade.registerProxy(proxy);
    }
    proxy.setURL(track.src);
    proxy.start();
  }
};

/** 
 * @private
*/

CaptionParsers = {
  "application/ttml+xml": new SMPTETTParser(),
  "application/x-subrip": new SRTParser(),
  "text/vtt": new WebVTTParser(),
  undefined: new SMPTETTParser()
};

/** 
 * @param {FlashPlayer} player
 * @param {Object} config
 * @constructor
 * @private
 * @extends {puremvc.Mediator}
*/
function PluginWrapper(player, config) {
  this.player = player;
  this.config = config;
  PluginWrapper.__super__.constructor.call(this);
  this.dispatcher = new EventDispatcher(this);
  this.createDefaults();
}


__extends(PluginWrapper, puremvc.Mediator);


PluginWrapper.NAME = "PluginWrapper";

PluginWrapper.prototype.player = null;

PluginWrapper.prototype.config = null;

PluginWrapper.prototype.dispatcher = null;

PluginWrapper.prototype.flashPlugins = null;

PluginWrapper.prototype.createFlashVars = null;

PluginWrapper.prototype.createXML = null;

PluginWrapper.prototype.createDefaults = function() {
  this.player.createDefaults.call(this);
};

/**
*/
PluginWrapper.prototype.addEventListener = function(type, func) {
  this.dispatcher.addEventListener(type, func);
};

PluginWrapper.prototype.logEvent = function(event) {};

/**
*/
PluginWrapper.prototype.dispatchEvent = function(event) {
  if (event.type !== "timeupdate" && event.type !== "timeremaining") {
    this.player.logger.log("[AMP " + (this.constructor.NAME.replace('Wrapper', '').toUpperCase()) + " EVENT] " + event.type, event);
  }
  event.player = this.player;
  this.dispatcher.dispatchEvent(event);
};

/**
*/
PluginWrapper.prototype.removeEventListener = function(type, func) {
  this.dispatcher.removeEventListener(type, func);
};

/**
*/
PluginWrapper.prototype.createElement = function(xml, id, parent) {
  var element;
  element = xml.createElement("element");
  element.setAttribute("id", id);
  if (!(parent != null)) {
    parent = this.getControls(xml).controls;
  }
  if (parent != null) {
    parent.appendChild(element);
  }
  return element;
};

/**
*/
PluginWrapper.prototype.createProperty = function(xml, key, value, parent) {
  var property, text, val;
  property = xml.createElement("property");
  property.setAttribute("key", key);
  if (parent != null) {
    parent.appendChild(property);
  }
  if (value != null) {
    if (typeof value === "object" && !(value instanceof Array)) {
      for (key in value) {
        val = value[key];
        this.createProperty(xml, key, val, property);
      }
    } else {
      text = XMLUtils.createTextContent(xml, value.toString());
      property.appendChild(text);
    }
  }
  return property;
};

/** @override
*/
PluginWrapper.prototype.listNotificationInterests = function() {
  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];
};

/**
*/
PluginWrapper.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case FlashNotifications.CREATE_FLASH_VARS:
      if (typeof this.createFlashVars === "function") {
        this.createFlashVars(body.flashvars);
      }
      break;
    case FlashNotifications.CREATE_XML:
      if (typeof this.createXML === "function") {
        this.createXML(body.xml);
      }
  }
};

/**
*/
PluginWrapper.prototype.destroy = function() {};

/**
 * The CaptionTrack class.
 *   
 * @constructor
 * @private
 * @param {?Object} track A generic track object.
*/
function CaptionTrack(track, onload) {
  var xhr,
    _this = this;
  this.kind = track.kind;
  this.type = track.type;
  this.src = track.src;
  this.language = track.srclang;
  this.label = track.label || this.srclang || this.kind;
  this.cues = track.cues || [];
  this.styles = track.styles || {};
  this.activeCues = [];
  this.isLive = /live-subply/.test(this.type);
  if ((this.src != null) && this.src !== "" && !this.isLive) {
    xhr = Utils.get(this.src, {
      onload: function() {
        try {
          CaptionParsers[_this.type].parse(_this, xhr.response);
        } catch (error) {
          Logger.error("Could not parse caption track: " + _this.src);
          return;
        }
        if (typeof onload === "function") {
          onload();
        }
      },
      onerror: function() {
        Logger.error("Could not load caption track: " + _this.src);
      }
    });
  } else {
    setTimeout(onload, 1);
  }
}

CaptionTrack.prototype.kind = null;

CaptionTrack.prototype.src = null;

CaptionTrack.prototype.language = null;

CaptionTrack.prototype.cues = null;

CaptionTrack.prototype.label = null;

CaptionTrack.prototype.activeCues = null;

CaptionTrack.prototype.type = null;

CaptionTrack.prototype.styles = null;

CaptionTrack.prototype.isLive = false;

/** 
 * @constructor
 * @private
*/
function OverlayMediator() {
  OverlayMediator.__super__.constructor.call(this, null, null, null, null);
}


__extends(OverlayMediator, ComponentMediator);


OverlayMediator.prototype.componentType = "overlay";

/**
 * Registers the overlay.
 * 
 * @override
*/
OverlayMediator.prototype.onRegister = function() {
  OverlayMediator.__super__.onRegister.call(this);
  this.registerOverlay();
};

/**
 * Removes the overlay.
 * 
 * @override
*/
OverlayMediator.prototype.onRemove = function() {
  OverlayMediator.__super__.onRemove.call(this);
  this.removeOverlay();
};

/**
 *
*/
OverlayMediator.prototype.registerOverlay = function() {
  this.sendNotification(Notifications.ADD_OVERLAY, this.viewComponent);
};

/**
 *
*/
OverlayMediator.prototype.removeOverlay = function() {
  this.sendNotification(Notifications.REMOVE_OVERLAY, this.viewComponent);
};

/**
 * The CaptioningProxy class
 *
 * @constructor
 * @private
 * @extends {PluginProxy}
 * @param   {Object}  config  The configuration object.
*/
function CaptioningProxy(config) {
  this.activeCaptions = [];
  this.providers = {};
  this.tracks = [];
  this.rendererMap = [];
  this.track = {};
  CaptioningProxy.__super__.constructor.call(this, config);
}


__extends(CaptioningProxy, PluginProxy);


/** @static
*/
CaptioningProxy.NAME = ModuleProxy.NAME;

CaptioningProxy.TEXT_TRACK_RENDERER = "caption-text";

CaptioningProxy.prototype.defaults = {
  useNative: false,
  crossorigin: null
};

CaptioningProxy.prototype.enabled = false;

CaptioningProxy.prototype.hidden = true;

CaptioningProxy.prototype.tracks = null;

CaptioningProxy.prototype.track = null;

CaptioningProxy.prototype.activeCaptions = null;

CaptioningProxy.prototype.captions = null;

CaptioningProxy.prototype.loaded = true;

CaptioningProxy.prototype.rendererMap = null;

/**
 *
*/
CaptioningProxy.prototype.getUseNative = function() {
  return this.getValue("useNative");
};

/**
 *
*/
CaptioningProxy.prototype.getCrossOrigin = function() {
  return this.getValue("crossorigin");
};

/**
 *
*/
CaptioningProxy.prototype.getTracks = function() {
  return this.tracks;
};

CaptioningProxy.prototype.setTracks = function(value) {
  var count, item, loaded, track, trackLoaded, _i, _len,
    _this = this;
  this.tracks = [];
  this.track = null;
  if (!(value != null)) {
    return;
  }
  count = value.length;
  loaded = 0;
  trackLoaded = function() {
    loaded++;
    if (loaded === count) {
      _this.sendNotification(CaptioningNotifications.TRACKS_LOADED, _this.tracks);
      _this.autoSelectTrack();
    }
  };
  for (_i = 0, _len = value.length; _i < _len; _i++) {
    item = value[_i];
    track = new CaptionTrack(item, trackLoaded);
    this.tracks.push(track);
  }
  return value;
};

/**
*/
CaptioningProxy.prototype.registerRenderer = function(value) {
  if (!(value != null)) {
    return;
  }
  value.proxy = this;
  this.rendererMap.push(value);
};

/**
*/
CaptioningProxy.prototype.retrieveRenderer = function(name) {
  var value, _i, _len, _ref;
  _ref = this.rendererMap;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    value = _ref[_i];
    if (value.getRendererName() === name) {
      return value;
    }
  }
};

/**
*/
CaptioningProxy.prototype.removeRenderer = function(name) {
  var index, value;
  value = this.retrieveRenderer(name);
  value.proxy = null;
  if (!(value != null)) {
    return null;
  }
  index = this.rendererMap.indexOf(value);
  this.rendererMap.splice(index, 1);
  return value;
};

/**
 *
*/
CaptioningProxy.prototype.getRenderer = function() {
  return this.renderer;
};

CaptioningProxy.prototype.setRenderer = function(value) {
  if (value === this.renderer) {
    return value;
  }
  if (this.renderer != null) {
    this.facade.removeMediator(CaptioningProxy.TEXT_TRACK_RENDERER);
  }
  this.renderer = value;
  if (this.renderer != null) {
    this.facade.registerMediator(this.renderer);
  }
  return value;
};

/**
 *
*/
CaptioningProxy.prototype.selectRenderer = function(media) {
  var item, renderer, track, tracks, _i, _j, _len, _len1, _ref;
  renderer = null;
  tracks = media.track;
  if (!(tracks != null)) {
    return;
  }
  for (_i = 0, _len = tracks.length; _i < _len; _i++) {
    track = tracks[_i];
    _ref = this.rendererMap;
    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
      item = _ref[_j];
      if (!(item.canUseResource(track) === true)) {
        continue;
      }
      renderer = item;
      break;
    }
    if (renderer != null) {
      break;
    }
  }
  this.setRenderer(renderer);
  return renderer;
};

/**
 *
*/
CaptioningProxy.prototype.getTrack = function() {
  return this.track;
};

CaptioningProxy.prototype.setTrack = function(value) {
  this.track = value;
  this.captions = this.track.cues;
  this.activeCaptions = [];
  this.sendNotification(CaptioningNotifications.TRACK_SELECTED, this.track);
  return value;
};

/**
 *
*/
CaptioningProxy.prototype.selectTrackByIndex = function(index) {
  var track;
  if ((0 <= index && index < this.tracks.length)) {
    track = this.tracks[index];
    this.setTrack(track);
  }
  return track;
};

/**
 *
*/
CaptioningProxy.prototype.selectTrackByLanguage = function(lang) {
  var item, track, _i, _len, _ref;
  _ref = this.tracks;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    item = _ref[_i];
    if (!(item.language === lang)) {
      continue;
    }
    track = item;
    break;
  }
  if (track != null) {
    this.setTrack(track);
  }
  return track;
};

/**
 *
*/
CaptioningProxy.prototype.getHidden = function() {
  return this.hidden;
};

CaptioningProxy.prototype.setHidden = function(value) {
  this.hidden = value;
  return value;
};

/**
 *
*/
CaptioningProxy.prototype.getEnabled = function() {
  return this.enabled;
};

CaptioningProxy.prototype.setEnabled = function(value) {
  this.enabled = value;
  return value;
};

/**
 *
*/
CaptioningProxy.prototype.autoSelectTrack = function() {
  var lang, track, _ref;
  lang = (_ref = this.facade.player.retrieveProxy(LocalizationProxy.NAME)) != null ? _ref.getLanguage() : void 0;
  if (lang != null) {
    lang = lang.split("-").shift();
    track = this.selectTrackByLanguage(lang);
  }
  if (!(track != null)) {
    track = this.tracks[0];
    this.setTrack(track);
  }
  return track;
};

/** 
 * PluginMediator class.
 *   
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function PluginComponentMediator(componentName, componentType, parent, element) {
  PluginComponentMediator.__super__.constructor.call(this, componentName, componentType, parent, element);
}


__extends(PluginComponentMediator, ComponentMediator);


/** @override
*/
PluginComponentMediator.prototype.initializeNotifier = function(key) {
  PluginComponentMediator.__super__.initializeNotifier.call(this, key);
  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);
  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);
};

/**
 * The CaptioningMediator class.
 *
 * @constructor
 * @private
 * @extends {PluginMediator}
 * @param {Object} viewComponent
*/
function CaptioningNativeMediator(viewComponent) {
  CaptioningNativeMediator.__super__.constructor.call(this, viewComponent);
}


__extends(CaptioningNativeMediator, LocalizedMediator);


CaptioningNativeMediator.prototype.video = null;

CaptioningNativeMediator.prototype.index = -1;

CaptioningNativeMediator.prototype.plugin = null;

CaptioningNativeMediator.prototype.parallelement = null;

CaptioningNativeMediator.prototype.paralleltimer = null;

CaptioningNativeMediator.prototype.paddingvalue = 6;

CaptioningNativeMediator.prototype.cueChangeListener = null;

CaptioningNativeMediator.prototype.lineheight = 34;

CaptioningNativeMediator.prototype.playerDefaultHeight = 648;

CaptioningNativeMediator.NAME = CaptioningProxy.TEXT_TRACK_RENDERER;

/**
*/
CaptioningNativeMediator.prototype.getRendererName = function() {
  return "native";
};

/**
*/
CaptioningNativeMediator.prototype.canUseResource = function(resource) {
  var hasNative, type, types, useNative;
  if (!(resource != null)) {
    return false;
  }
  hasNative = document.createElement("video").textTracks != null;
  if (!hasNative) {
    return false;
  }
  types = [Utils.mimeTypes.vtt, Utils.mimeTypes.cea608, Utils.mimeTypes.cea708];
  type = resource.type;
  if (type === types[1] || type === types[2]) {
    return true;
  }
  useNative = /iphone|ipad/.test(Utils.getDevice()) || this.proxy.getUseNative();
  if (!useNative) {
    return false;
  }
  return types.indexOf(resource.type) !== -1;
};

/**
 * @override
*/
CaptioningNativeMediator.prototype.onRegister = function() {
  this.plugin = this.facade.retrieveProxy(CaptioningProxy.NAME);
  this.cueChangeListener = this.cueChange.bind(this);
  if (Utils.getSafariVersion() < 0) {
    this.facade.player.getMediaElement().textTracks.addEventListener("addtrack", this.updateTrack.bind(this));
  }
  this.facade.player.getMediaElement().textTracks.addEventListener("cuechange", this.cueChangeListener);
  if ((this.plugin != null) && (this.plugin.config != null) && !this.plugin.config.hasOwnProperty('useparallelrendering')) {
    this.plugin.config.useparallelrendering = false;
  }
};

/**
 * @override
*/
CaptioningNativeMediator.prototype.listNotificationInterests = function() {
  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.TRACKS_LOADED, Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, AdNotifications.BREAK_START];
};

/**
 * @override
*/
CaptioningNativeMediator.prototype.handleNotification = function(notification) {
  var body, crossorigin, element, track, video, _i, _len, _ref;
  body = notification.getBody();
  switch (notification.getName()) {
    case CaptioningNotifications.TRACKS_LOADED:
      this.tracks = body;
      break;
    case CaptioningNotifications.TRACK_SELECTED:
      if (this.facade.player.getMediaElement().textTracks.length) {
        track = this.facade.player.getMediaElement().textTracks[this.index];
      }
      if (track != null) {
        track.mode = "hidden";
      }
      this.index = this.plugin.getTracks().indexOf(body);
      this.lang = body.language;
      this.updateTrack();
      break;
    case CaptioningNotifications.VISIBILITY_CHANGE:
    case Notifications.CAN_PLAY_THROUGH:
      this.updateTrack();
      break;
    case AdNotifications.BREAK_START:
      this.clearCaption();
      break;
    case Notifications.LOADED_METADATA:
      if (!(this.tracks != null)) {
        return;
      }
      video = this.facade.player.getMediaElement();
      crossorigin = this.plugin.getCrossOrigin();
      if (crossorigin != null) {
        video.setAttribute("crossorigin", crossorigin);
      }
      _ref = this.tracks;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        track = _ref[_i];
        if (!(track.type === Utils.mimeTypes.vtt)) {
          continue;
        }
        element = document.createElement("track");
        element.src = track.src;
        if (track.kind != null) {
          element.kind = track.kind;
        }
        if (track.language != null) {
          element.srclang = track.language;
        }
        if (track.label != null) {
          element.label = track.label;
        }
        element["default"] = "default" in track;
        video.appendChild(element);
      }
      this.tracks = null;
  }
};

CaptioningNativeMediator.prototype.updateTrack = function(event) {
  var config, i, track, _i, _len, _ref, _ref1, _ref2;
  config = this.plugin.config;
  _ref = this.facade.player.getMediaElement().textTracks;
  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
    track = _ref[i];
    if (!(/subtitles|captions/.test(track.kind) && (track.language === this.lang || !track.language.length))) {
      continue;
    }
    if (!(track != null)) {
      return;
    }
    this.index = i;
    if (this.getTracksByKind(track.kind).length > 1) {
      this.suppressDupeTracks(track.kind, [1]);
      if (i === 1) {
        track.mode = this.plugin.getHidden() ? "hidden" : "showing";
      }
    }
    if (track.kind === "subtitles") {
      track.mode = "hidden";
    } else {
      if (config.useparallelrendering === false) {
        track.mode = this.plugin.getHidden() ? "hidden" : "showing";
      }
    }
  }
  if (event) {
    if (((_ref1 = event.track) != null ? _ref1.kind : void 0) === "metadata") {
      return;
    }
  }
  if (this.plugin.getHidden()) {
    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {
      if ((this.parallelement != null)) {
        this.parallelement.style.display = "none";
      }
    } else {
      this.clearCaption();
    }
  } else {
    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {
      if ((this.parallelement != null)) {
        this.parallelement.style.display = "inline";
      }
    }
  }
  if ((_ref2 = this.plugin) != null ? _ref2.config.useparallelrendering : void 0) {
    if (!this.parallelement) {
      this.createParallelement();
    }
    if (event) {
      this.useParallelRendering(this.plugin.config.useparallelrendering, event.track);
    } else {
      this.useParallelRendering(this.plugin.config.useparallelrendering);
    }
  }
};

CaptioningNativeMediator.prototype.createParallelement = function() {
  if (this.parallelement) {
    return;
  }
  this.parallelement = document.createElement("div");
  this.parallelement.className = "akamai-caption-container";
  this.viewComponent.appendChild(this.parallelement);
  return this.parallelement;
};

CaptioningNativeMediator.prototype.useParallelRendering = function(value, track) {
  var _ref, _ref1;
  if ((_ref = this.plugin) != null) {
    _ref.config.useparallelrendering = value;
  }
  if (!track && ((_ref1 = this.facade.player.getMediaElement().textTracks) != null ? _ref1.length : void 0)) {
    track = this.facade.player.getMediaElement().textTracks[this.index];
  }
  if (track) {
    if (value === true) {
      if (track.hasCueChangeListener === false || typeof track.hasCueChangeListener === 'undefined') {
        track.hasCueChangeListener = true;
        return track.addEventListener("cuechange", this.cueChangeListener);
      }
    } else {
      track.hasCueChangeListener = false;
      return track.removeEventListener("cuechange", this.cueChangeListener);
    }
  }
};

CaptioningNativeMediator.prototype.cueChange = function(event) {
  var capText, captionTextContainerArray, computedFontSize, cssLh, currentHeight, delay, diff, endtime, i, isPriority, maxCueBottom, percentChanged, shouldScaleFont, starttime, stl, temp, xPos, yPos;
  isPriority = this.proxy.track ? this.proxy.track.kind === event.target.kind : true;
  if (this.plugin.getHidden() || !isPriority) {
    return;
  }
  maxCueBottom = 0;
  shouldScaleFont = false;
  if (this.paralleltimer) {
    clearTimeout(this.paralleltimer);
    this.paralleltimer = null;
  }
  if (this.parallelement) {
    this.parallelement.innerHTML = "";
  }
  captionTextContainerArray = [];
  i = 0;
  while (i < event.target.activeCues.length) {
    if ((new RegExp("^\{\".*}$")).test(event.target.activeCues[i].text)) {
      return;
    }
    this.parallelement.style.display = "inline";
    captionTextContainerArray[i] = document.createElement('div');
    captionTextContainerArray[i].className = 'akamai-caption-text';
    this.viewComponent.getElementsByClassName('akamai-caption-container')[0].appendChild(captionTextContainerArray[i]);
    capText = document.createElement('p');
    captionTextContainerArray[i].appendChild(capText);
    cssLh = window.getComputedStyle(capText).lineHeight.replace("px", "");
    if (cssLh) {
      this.lineheight = cssLh;
    }
    xPos = void 0;
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      xPos = event.target.activeCues[i].position - 50 + '%';
    } else {
      xPos = event.target.activeCues[i].position + '%';
    }
    yPos = void 0;
    currentHeight = this.facade.player.getMediaElement().getBoundingClientRect().height;
    percentChanged = currentHeight / this.playerDefaultHeight * 100;
    stl = event.target.activeCues[i].snapToLines;
    if (stl !== null && (event.target.activeCues[i].snapToLines === true || typeof stl === 'undefined')) {
      yPos = event.target.activeCues[i].line * (this.lineheight / 100 * percentChanged);
    } else {
      yPos = currentHeight / 100 * event.target.activeCues[i].line * 10;
    }
    if (i > 0 && yPos) {
      diff = this.viewComponent.getElementsByClassName('akamai-caption-container')[0].childNodes[0].offsetHeight - (this.lineheight / 100 * percentChanged);
      yPos = yPos + diff * i;
    }
    yPos = yPos + 'px';
    captionTextContainerArray[i].style.left = xPos;
    captionTextContainerArray[i].style.top = yPos;
    captionTextContainerArray[i].style.textAlign = 'left';
    captionTextContainerArray[i].style.position = 'absolute';
    captionTextContainerArray[i].style.bottom = 'auto';
    captionTextContainerArray[i].style.display = 'inline';
    captionTextContainerArray[i].style.padding = this.paddingvalue + 'px';
    captionTextContainerArray[i].style.width = 'auto';
    captionTextContainerArray[i].style['min-height'] = '0px';
    capText.innerHTML = event.target.activeCues[i].text;
    capText.style.margin = '0px';
    capText.style.display = 'block';
    capText.style.lineHeight = "normal";
    computedFontSize = null;
    try {
      temp = document.createElement('span');
      temp.style.fontSize = JSON.parse(localStorage.getItem("akamai-captioningDefault")).size;
      captionTextContainerArray[i].appendChild(temp);
      computedFontSize = window.getComputedStyle(temp).fontSize.replace("px", "");
      temp = null;
    } catch (_error) {}
    if (computedFontSize) {
      if (shouldScaleFont) {
        computedFontSize = computedFontSize / 100 * percentChanged;
        capText.style.fontSize = computedFontSize + "px";
      }
      maxCueBottom = Math.max(maxCueBottom, (Number(yPos.replace("px", "")) || 0) + captionTextContainerArray[i].getBoundingClientRect().height);
    }
    if (i === event.target.activeCues.length - 1) {
      endtime = event.target.activeCues[i].endTime ? event.target.activeCues[i].endTime : 0;
      starttime = event.target.activeCues[i].startTime ? event.target.activeCues[i].startTime : 0;
      delay = (endtime - starttime) * 1000;
      if (delay > 500) {
        this.paralleltimer = setTimeout(this.clearCaption.bind(this), delay);
      }
    }
    i++;
  }
  if (maxCueBottom > currentHeight) {
    maxCueBottom = maxCueBottom - currentHeight;
    i = 0;
    while (i < captionTextContainerArray.length) {
      captionTextContainerArray[i].style.top = (Number(captionTextContainerArray[i].style.top.replace("px", "")) - maxCueBottom) + "px";
      i++;
    }
  }
};

CaptioningNativeMediator.prototype.clearCaption = function() {
  if (this.paralleltimer) {
    clearTimeout(this.paralleltimer);
    this.paralleltimer = null;
  }
  if (this.parallelement) {
    this.parallelement.innerHTML = "";
  }
};

CaptioningNativeMediator.prototype.getTracksByKind = function(kind) {
  var stracks, track, tracks, _i, _len;
  tracks = this.facade.player.getMediaElement().textTracks;
  stracks = [];
  for (_i = 0, _len = tracks.length; _i < _len; _i++) {
    track = tracks[_i];
    if (track.kind === kind && track.language === "en") {
      stracks.push(track);
    }
  }
  return stracks;
};

CaptioningNativeMediator.prototype.suppressDupeTracks = function(kind, exclude) {
  var i, track, _i, _len, _ref;
  _ref = this.getTracksByKind(kind);
  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
    track = _ref[i];
    if (track.kind === kind && track.language === "en") {
      if ((exclude != null) && exclude.includes(i)) {
        continue;
      }
      track.mode = "hidden";
    }
  }
  return i > 0;
};

/**
 * The CaptioningHTMLMediator class.
 *
 * @constructor
 * @private
 * @extends {LocalizedMediator}
 * @param {Object} viewComponent
*/
function CaptioningHTMLMediator(viewComponent) {
  CaptioningHTMLMediator.__super__.constructor.call(this, null, null, viewComponent, null);
}


__extends(CaptioningHTMLMediator, PluginComponentMediator);


CaptioningHTMLMediator.prototype.componentName = CaptioningProxy.TEXT_TRACK_RENDERER;

CaptioningHTMLMediator.prototype.captionText = null;

CaptioningHTMLMediator.prototype.onRegister = function() {
  CaptioningHTMLMediator.__super__.onRegister.call(this);
  this.settings = this.facade.player._settings.settings.captions || {};
};

/**
*/
CaptioningHTMLMediator.prototype.getRendererName = function() {
  return "html";
};

/**
*/
CaptioningHTMLMediator.prototype.canUseResource = function(resource) {
  var types;
  if (!(resource != null)) {
    return false;
  }
  types = [Utils.mimeTypes.srt, Utils.mimeTypes.ttml, Utils.mimeTypes.vtt];
  return types.indexOf(resource.type) !== -1;
};

/* Get Caption Container Display Height
*/
CaptioningHTMLMediator.prototype.getCaptionDisplayHeight = function() {
  var height, i, length;
  height = 0;
  i = length = this.viewComponent.childNodes.length;
  while (i) {
    --i;
    if (length === 3 && i === 0) {
      break;
    }
    height += Utils.getActualSize(this.viewComponent.childNodes[i]).height;
  }
  return height + "px";
};

/* Scroll Captions
*/
CaptioningHTMLMediator.prototype.scrollCaptions = function(scrollHeight, scrollTop, steps) {
  var scroll, stepSize,
    _this = this;
  if (scrollHeight == null) {
    scrollHeight = this.viewComponent.scrollHeight;
  }
  if (scrollTop == null) {
    scrollTop = this.viewComponent.scrollTop;
  }
  if (steps == null) {
    steps = 20;
  }
  stepSize = (scrollHeight - scrollTop) / steps;
  scroll = function() {
    var _results;
    if (scrollTop < scrollHeight) {
      _this.viewComponent.scrollTop = scrollTop += stepSize;
      return setTimeout(scroll, 20);
    } else {
      _results = [];
      while (_this.viewComponent.childNodes.length > 2) {
        _results.push(_this.viewComponent.removeChild(_this.viewComponent.firstChild));
      }
      return _results;
    }
  };
  scroll();
};

/**
 * @override
*/
CaptioningHTMLMediator.prototype.listNotificationInterests = function() {
  return [CaptioningNotifications.CUE_CHANGE, Notifications.CHANGE_MEDIA];
};

/**
 * @override
*/
CaptioningHTMLMediator.prototype.handleNotification = function(notification) {
  var body, captions, child, childNode, cue, i, name, temp, _i, _j, _k, _len, _len1, _len2, _ref, _ref1;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.CHANGE_MEDIA:
      this.viewComponent.innerHTML = "";
      break;
    case CaptioningNotifications.CUE_CHANGE:
      captions = "";
      for (_i = 0, _len = body.length; _i < _len; _i++) {
        cue = body[_i];
        _ref = this.viewComponent.children;
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          child = _ref[_j];
          if (child.outerHTML.includes(cue.html) && this.settings.scroll === "popout") {
            continue;
          }
        }
        captions += cue.html;
      }
      if (this.settings.scroll === "painton") {
        this.classList.add("captioning-typed");
      } else {
        this.classList.remove("captioning-typed");
      }
      switch (this.settings.scroll) {
        case "popout":
          this.viewComponent.innerHTML = captions;
          break;
        case "rollon":
        case "painton":
          temp = document.createElement("div");
          temp.innerHTML = captions;
          _ref1 = temp.childNodes;
          for (i = _k = 0, _len2 = _ref1.length; _k < _len2; i = ++_k) {
            childNode = _ref1[i];
            if (this.viewComponent.children.length && this.viewComponent.lastChild.innerText.includes(childNode.innerText)) {
              continue;
            }
            this.viewComponent.appendChild(childNode);
          }
          this.viewComponent.style.maxHeight = this.getCaptionDisplayHeight();
          this.scrollCaptions();
      }
  }
};

/**
 * @enum {string}
 * @const
 * @private
*/

var CaptioningNotifications = {
  VISIBILITY_CHANGE: "captioningvisibilitychange",
  ENABLED: "captioningenabled",
  TRACKS_LOADED: "captioningtracksloaded",
  TRACK_SELECTED: "captioningtrackselected",
  CUE_CHANGE: "captioningcuechange",
  SETTINGS_VISIBILITY_CHANGE: "captioningsettingsvisibility",
  TOGGLE_SETTINGS_VISIBILITY: "togglesettingsvisibility",
  SETTINGS_CHANGE: "captioningsettingschange"
};

function LocalizationConstants() {}

LocalizationConstants.MSG_LIVE = "MSG_LIVE";

LocalizationConstants.MSG_REPLAY = "MSG_REPLAY";

LocalizationConstants.MSG_BUFFERING = "MSG_BUFFERING_TEXT";

LocalizationConstants.MSG_CC = "MSG_CC";

LocalizationConstants.MSG_CC_TITLE = "MSG_CC_TITLE";

LocalizationConstants.MSG_CC_LANGUAGE = "MSG_CC_LANGUAGE";

LocalizationConstants.MSG_CC_PRESETS = "MSG_CC_PRESETS";

LocalizationConstants.MSG_CC_FONT = "MSG_CC_FONT";

LocalizationConstants.MSG_CC_EDGE = "MSG_CC_EDGE";

LocalizationConstants.MSG_CC_SIZE = "MSG_CC_SIZE";

LocalizationConstants.MSG_CC_SCROLL = "MSG_CC_SCROLL";

LocalizationConstants.MSG_CC_COLOR = "MSG_CC_COLOR";

LocalizationConstants.MSG_CC_BACKGROUND = "MSG_CC_BACKGROUND";

LocalizationConstants.MSG_CC_EDGE = "MSG_CC_EDGE";

LocalizationConstants.MSG_CC_WINDOW = "MSG_CC_WINDOW";

LocalizationConstants.MSG_CC_OPACITY = "MSG_CC_OPACITY";

LocalizationConstants.MSG_CC_SHOW_ADVANCED = "MSG_CC_SHOW_ADVANCED";

LocalizationConstants.MSG_CC_HIDE_ADVANCED = "MSG_CC_HIDE_ADVANCED";

LocalizationConstants.MSG_CC_RESET = "MSG_CC_RESET";

LocalizationConstants.MSG_CC_CANCEL = "MSG_CC_CANCEL";

LocalizationConstants.MSG_CC_APPLY = "MSG_CC_APPLY";

LocalizationConstants.MSG_CC_PREVIEW_TEXT = "MSG_CC_PREVIEW_TEXT";

LocalizationConstants.MSG_SECONDS = "MSG_SECONDS";

LocalizationConstants.MSG_RECOMMENDATIONS_TITLE = "MSG_RECOMMENDATIONS_TITLE";

LocalizationConstants.MSG_NEXT_VIDEO = "MSG_NEXT_VIDEO";

LocalizationConstants.MSG_NEXT_AD = "MSG_NEXT_AD";

LocalizationConstants.MSG_TIME_SEPARATOR = "MSG_TIME_SEPARATOR";

LocalizationConstants.MSG_VIEW_ALL = "MSG_VIEW_ALL";

LocalizationConstants.MSG_VIDEO = "MSG_VIDEO";

/** 
 * PluginMediator class.
 *   
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function PluginMediator() {
  PluginMediator.__super__.constructor.call(this);
}


__extends(PluginMediator, OverlayMediator);


/** @override
*/
PluginMediator.prototype.initializeNotifier = function(key) {
  PluginMediator.__super__.initializeNotifier.call(this, key);
  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);
  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);
};

/** @override
*/
PluginMediator.prototype.onRegister = function() {
  PluginMediator.__super__.onRegister.call(this);
  this.facade.viewComponent = this.viewComponent;
};

/**
 * The CaptioningMediator class.
 *
 * @constructor
 * @private
 * @extends {PluginMediator}
 * @param {Object} viewComponent
*/
function CaptioningMediator(viewComponent) {
  CaptioningMediator.__super__.constructor.call(this, viewComponent);
}


__extends(CaptioningMediator, PluginMediator);


CaptioningMediator.prototype.componentName = "captioning";

/**
 * @override
*/
CaptioningMediator.prototype.onRegister = function() {
  var settings;
  CaptioningMediator.__super__.onRegister.call(this);
  settings = this.facade.player.settings.captions;
  this.facade.setHidden(!settings.visible);
  this.captionningStyle = this.create(null, document.getElementsByTagName("head")[0], "style");
  this.captionningStyle.type = "text/css";
  this.applyStyles(settings);
};

/**
 * @override
*/
CaptioningMediator.prototype.listNotificationInterests = function() {
  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.ENABLED, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.SETTINGS_CHANGE];
};

/**
 * @override
*/
CaptioningMediator.prototype.handleNotification = function(notification) {
  var body, note, state;
  body = notification.getBody();
  note = body ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
  switch (notification.getName()) {
    case CaptioningNotifications.TRACK_SELECTED:
      state = "cc-embedded";
      note = body.type === "embedded" ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
      break;
    case CaptioningNotifications.VISIBILITY_CHANGE:
      state = "cc-active";
      break;
    case CaptioningNotifications.ENABLED:
      note = body ? Notifications.ADD_CONTROL_STATE : Notifications.REMOVE_CONTROL_STATE;
      state = "cc-enabled";
      if (!body) {
        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, "cc-active");
      }
      break;
    case CaptioningNotifications.SETTINGS_CHANGE:
      this.applyStyles(body);
      return;
  }
  this.sendNotification(note, state);
};

CaptioningMediator.prototype.applyStyles = function(styles) {
  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, windowColor, windowColorValue;
  if (styles.visible != null) {
    this.facade.hidden = !styles.visible;
  }
  fontFamily = "font-family: " + styles.fontFamily + " !important;";
  edgeType = "" + styles.edgeType + " " + styles.edgeColor + " !important;";
  fontSize = "font-size: " + styles.size + " !important;";
  color = "color: " + styles.fontColor + " !important;";
  backgroundColor = "background-color: " + styles.backgroundColor + " !important;";
  windowColor = "background-color: " + styles.windowColor + " !important;";
  containerStyle = "line-height:2.2em;";
  windowColorValue = windowColor.match(/rgba\([^)]+\)/g);
  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {
    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\)/, '$1')) === 0 ? "" : containerStyle;
  }
  id = this.facade.player.viewComponent.id;
  this.captionningStyle.innerHTML = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + 'video::-webkit-media-text-track-display { ' + windowColor + ' } video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-display { ' + windowColor + ' } video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-container {' + containerStyle + '} video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';
};

/**
 * The CaptioningWrapper class.
 *
 * @constructor
 * @private
 * @extends {PluginWrapper}
 * @param {FlashPlayer}     player  The FlashPlayer
 * @param {Object}          config  The plugin config
*/
function CaptioningWrapper(player, config) {
  CaptioningWrapper.__super__.constructor.call(this, player, config);
  Object.defineProperties(this, {
    enabled: {
      get: this.getEnabled,
      set: this.setEnabled,
      enumerable: true,
      configurable: false
    },
    hidden: {
      get: this.getHidden,
      set: this.setHidden,
      enumerable: true,
      configurable: false
    },
    visible: {
      get: this.getVisible,
      set: this.setVisible,
      enumerable: true,
      configurable: false
    },
    tracks: {
      get: this.getTracks,
      enumerable: true,
      configurable: false
    },
    track: {
      get: this.getTrack,
      set: this.setTrack,
      enumerable: true,
      configurable: false
    }
  });
}


__extends(CaptioningWrapper, PluginWrapper);


CaptioningWrapper.NAME = "CaptioningWrapper";

CaptioningWrapper.prototype.flashPlugins = [
  {
    id: "AdobeCaptionPlugin",
    src: '#{paths.resources}plugins/AdobeCaptionPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "AdobeCaptionPlugin",
    type: "application/x-shockwave-flash"
  }, {
    id: "AMPCaptionPlugin",
    src: '#{paths.resources}plugins/AMPCaptionPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "AMPCaptionPlugin",
    type: "application/x-shockwave-flash"
  }, {
    id: "CaptionSettingsPlugin",
    src: '#{paths.resources}plugins/CaptionSettingsPlugin.swf',
    blocking: false,
    host: "akamai",
    main: "CaptionSettingsPlugin",
    type: "application/x-shockwave-flash"
  }
];

CaptioningWrapper.prototype.flashView = {
  elements: {
    captionDisplay: {
      attributes: {
        defaultMessage: "Sorry! No captions available for this stream",
        initState: "cookie",
        position: "relative",
        settingsEnabled: "true",
        style: "bottom: 0px; windowColor :0x000000; windowOpacity: 0; font: Monospaced Serif; fontColor: 0xffffff; fontOpacity: 1; fontBGColor: 0x000000; fontBGOpacity: 0; edgeType: none; edgeColor: 0x000000; edgeOpacity: 1; scroll: Pop-Out; fontSize: 12;"
      }
    },
    controls: {
      elements: {
        captionBtn: {}
      }
    }
  }
};

CaptioningWrapper.prototype._hidden = true;

/** @override
*/
CaptioningWrapper.prototype.createXML = function(xml) {
  var application, player, subply, _ref;
  subply = (_ref = this.config.flash) != null ? _ref.subply : void 0;
  if (subply != null) {
    try {
      if (subply.timeMethod != null) {
        player = xml.getElementsByTagName("player")[0];
        player.setAttribute("subply_time_method", subply.timeMethod);
      }
      if (subply.plugin != null) {
        application = xml.firstChild;
        subply = xml.getElementsByTagName("subply")[0];
        if (!(subply != null)) {
          subply = xml.createElement("subply");
          application.appendChild(subply);
        }
        this.createProperty(xml, "SUBPLY_URL", this.config.flash.subply.plugin, subply);
      }
    } catch (error) {
      this.facade.logger.error("[AMP CAPTIONING ERROR]", error);
    }
  }
};

/** @override
*/
CaptioningWrapper.prototype.createFlashVars = function(flashvars) {
  var captionLangArr, captionUrlArr, config, track, _i, _len, _ref, _ref1;
  config = this.player.config;
  if (((_ref = config.media) != null ? _ref.track : void 0) != null) {
    track = Utils.selectTrack(config.media.track, "captions");
    if ((track.src != null) && track.src !== "") {
      flashvars.caption_url = track.src;
    }
    if (config.media.track.length > 0) {
      captionUrlArr = [];
      captionLangArr = [];
      _ref1 = config.media.track;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        track = _ref1[_i];
        captionUrlArr.push(track.src);
        captionLangArr.push(track.srclang);
      }
      flashvars.caption_url = captionUrlArr.join(",");
      flashvars.caption_language = captionLangArr.join(",");
    }
    flashvars.caption_type = track.type != null ? encodeURIComponent(track.type) : "application/ttml+xml";
  }
  if (flashvars.caption_language == null) {
    flashvars.caption_language = "en-us";
  }
};

/** @override
*/
CaptioningWrapper.prototype.listNotificationInterests = function() {
  return CaptioningWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIA_CHANGE, FlashNotifications.CAPTIONING_REQUEST, FlashNotifications.CAPTION_LANG_CHANGE, FlashNotifications.INITIALIZED]);
};

/**
*/
CaptioningWrapper.prototype.handleNotification = function(notification) {
  var body, media, name, track, type,
    _this = this;
  CaptioningWrapper.__super__.handleNotification.call(this, notification);
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case FlashNotifications.CAPTION_LANG_CHANGE:
      type = "";
      break;
    case FlashNotifications.CAPTIONING_REQUEST:
      type = "visibilitychange";
      body = body.enabled;
      this.hidden = !body;
      break;
    case Notifications.MEDIA_CHANGE:
      media = body;
      if (media.track != null) {
        this._tracks = media.track.map(function(track) {
          return Object.assign({
            language: track.srclang
          }, track);
        });
        track = Utils.selectTrack(this._tracks, "captions");
        if (!(track != null)) {
          return;
        }
        if ((track.src != null) && track.src !== "") {
          media.captioningUrl = track.src;
        }
        if (track.type != null) {
          media.captioningType = track.type || "application/ttml+xml";
        }
        this._track = track;
      }
      break;
    case FlashNotifications.INITIALIZED:
      this.hidden = !this.player.getMediaElement().getPlayerProperty("isCaptionVisible");
  }
  if ((type != null) && type !== "") {
    this.dispatchEvent(new Event(type, body));
  }
};

/**
*/
CaptioningWrapper.prototype.getHidden = function() {
  return this._hidden;
};

CaptioningWrapper.prototype.setHidden = function(value) {
  this._hidden = value;
  this.facade.getMediaElement().setPlayerProperty("captionDisplay", {
    visible: !value
  });
  return value;
};

/**
*/
CaptioningWrapper.prototype.getVisible = function() {
  return !this._hidden;
};

CaptioningWrapper.prototype.setVisible = function(value) {
  this.setHidden(!value);
  return value;
};

/**
 * Returns an array of caption tracks
 *
 * @return {Array.<CaptionTrack>} The list of text tracks.
 * @expose
*/
CaptioningWrapper.prototype.getTracks = function() {
  return this._tracks || [];
};

/**
 * Returns the currently selected track.
 *
 * @return {CaptionTrack} The currently selected caption track.
 * @expose
*/
CaptioningWrapper.prototype.getTrack = function() {
  return this._track;
};

/**
 * Selects a caption track by its index in the getTracks array.
 *
 * @param {number}        index   The index to select
 * @return {CaptionTrack}         The selected caption track.
 * @expose
*/
CaptioningWrapper.prototype.selectTrackByIndex = function(index) {};

/**
 * Selects a caption track by it's language property.
 *
 * @param {string}        lang  The language to select
 * @return {CaptionTrack}       The selected caption track.
 * @expose
*/
CaptioningWrapper.prototype.selectTrackByLanguage = function(lang) {
  this.facade.getMediaElement().setTrackByLanguage(lang);
};

/**
 * Sets a caption Settings Object (styles)
 *
 * @param {Object}  object  The caption settings object.
 * @expose
*/
CaptioningWrapper.prototype.changeSettings = function(object) {
  if (((object != null ? object.fontFamily : void 0) != null) && typeof object.fontFamily === "object") {
    return this.facade.getMediaElement().setPlayerProperty("captionSettingsUI", object);
  }
  if ((object != null ? object.visible : void 0) != null) {
    this.hidden = !object.visible;
  }
  this.facade.getMediaElement().setPlayerProperty("captionDisplay", {
    visible: !this.hidden,
    style: this.parseObject(object)
  });
};

/**
 * Parse Object
 *
*/
CaptioningWrapper.prototype.parseObject = function(object) {
  var flashObject, keyString, prop, _ref;
  flashObject = {};
  try {
    for (prop in object) {
      switch (prop) {
        case "fontFamily":
          flashObject['font'] = object[prop];
          break;
        case "fontColor":
        case "backgroundColor":
        case "edgeColor":
        case "windowColor":
          keyString = prop === "fontColor" ? "font" : prop === "backgroundColor" ? "fontBG" : prop === "edgeColor" ? "edge" : "window";
          if (((_ref = object[prop]) != null ? _ref.indexOf('rgba') : void 0) !== -1) {
            flashObject[keyString + 'Color'] = this.parseRGBA(object[prop]);
            flashObject[keyString + 'Opacity'] = object[prop].replace(/^.*,(.+)\)/, '$1');
          }
          break;
        default:
          flashObject[prop] = object[prop];
      }
    }
    delete flashObject['visible'];
  } catch (error) {
    this.facade.logger.error('Captioning Settings Parse Error', error);
  }
  return flashObject;
};

CaptioningWrapper.prototype.parseRGBA = function(rgb) {
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  if (rgb && rgb.length === 4) {
    return "0x" + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2);
  }
  return "";
};


AMP.registerPlugin("captioning", "flash", CaptioningWrapper);

/** 
 * The Feature class. Acts as a base for features.
 *   
 * @param {Module}  app     The parent module of this plugin.
 * @param {Object}  config  The plugin's configuration object.
 * @constructor
 * @private
 * @extends {Plugin}
*/
function Feature() {
  Feature.__super__.constructor.call(this);
}


__extends(Feature, Plugin);


Feature.NAME = "Feature";

Feature.prototype.featureName = null;

/**
*/
Feature.prototype.getFeatureName = function() {
  return this.featureName;
};

/**
*/
Feature.prototype.registerFeature = function() {
  if (this.getFeatureName() != null) {
    this.player.sendNotification(FeatureNotifications.REGISTER_FEATURE, this);
  }
};

/** @override
*/
Feature.prototype.onRegister = function() {
  this.registerFeature();
  Feature.__super__.onRegister.call(this);
};

/** @override
*/
Feature.prototype.listNotificationPublications = function() {
  return Feature.__super__.listNotificationPublications.call(this).concat([FeatureNotifications.REGISTER_FEATURE]);
};

/** 
 * @constructor
 * @extends {PluginWrapper}
 * @private
*/
function HLSWrapper(player, config) {
  HLSWrapper.__super__.constructor.call(this, player, config);
  Utils.flashTypes.push(Utils.mimeTypes.m3u8);
}


__extends(HLSWrapper, PluginWrapper);


HLSWrapper.NAME = "HLSWrapper";

HLSWrapper.prototype.flashPlugins = [
  {
    id: "flashlsOSMF",
    src: '#{paths.resources}plugins/flashlsOSMF.swf',
    host: "osmf",
    type: "application/x-shockwave-flash"
  }
];


AMP.registerPlugin("hls", "flash", HLSWrapper);

/**
 * HLSPlaybackProxy constructor.
 *
 * @constructor
 * @private
 * @extends {PlaybackCoreProxy}
*/
function HLSPlaybackProxy(config, plugin) {
  this.plugin = plugin;
  HLSPlaybackProxy.__super__.constructor.call(this, config.types, config);
  this.temporalTypes = ["vod", "live", "dvr"];
}


__extends(HLSPlaybackProxy, PlaybackCoreProxy);


HLSPlaybackProxy.prototype.playbackCoreName = "hls";

HLSPlaybackProxy.prototype.player = null;

HLSPlaybackProxy.prototype.hlsConfig = null;

HLSPlaybackProxy.prototype.fragErrorTime = 0;

HLSPlaybackProxy.prototype.timedMedatadata = null;

HLSPlaybackProxy.prototype.currentMedatadata = null;

HLSPlaybackProxy.prototype.id3Track = null;

HLSPlaybackProxy.prototype.manifestParsed = false;

HLSPlaybackProxy.prototype.details = null;

/**
 *
*/
HLSPlaybackProxy.prototype.canPlayMedium = function(medium) {
  return HLSPlaybackProxy.__super__.canPlayMedium.call(this, medium) || medium === "audio";
};

/**
*/
HLSPlaybackProxy.prototype.getUseMAE = function() {
  return HLSPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationHlsJsWrapper !== "undefined" && MediaAccelerationHlsJsWrapper !== null);
};

HLSPlaybackProxy.prototype.getConfig = function() {
  var config;
  config = Utils.clone(this.config.data);
  if (this.config.withCredentials === true) {
    config.xhrSetup = function(xhr, url) {
      xhr.withCredentials = true;
    };
  }
  config.debug = this.plugin.proxy.getDebug();
  if (!this.getUseMAE()) {
    config.enableSoftwareAES = config.enableSoftwareAES != null ? config.enableSoftwareAES : true;
  }
  return config;
};

/** @override
*/
HLSPlaybackProxy.prototype.load = function() {
  var config, key, player, value, _ref, _ref1,
    _this = this;
  if (this.player != null) {
    this.destroy();
  }
  this.manifestParsed = false;
  config = this.getConfig();
  if (!this.getUseMAE()) {
    player = new Hls(config);
  } else {
    this.facade.mae = new MediaAccelerationHlsJsWrapper(this.config.mae, config);
    player = this.facade.mae.getPlayer();
  }
  player.attachMedia(this.getMediaElement());
  _ref = Hls.Events;
  for (key in _ref) {
    value = _ref[key];
    player.on(value, function(event, data) {
      _this.plugin.dispatcher.dispatchEvent(new Event(event, data));
    });
  }
  player.on(Hls.Events.MANIFEST_PARSED, this.onManifestParsed.bind(this));
  player.on(Hls.Events.ERROR, this.onError.bind(this));
  player.on(Hls.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata.bind(this));
  player.on(Hls.Events.LEVEL_LOADED, this.onLevelLoaded.bind(this));
  player.on(Hls.Events.LEVEL_SWITCHING, this.onLevelSwitching.bind(this));
  player.on(Hls.Events.FRAG_LOADING, this.onFragmentLoadStart.bind(this));
  player.on(Hls.Events.FRAG_LOADED, this.onFragmentLoaded.bind(this));
  try {
    _ref1 = this.config.quality;
    for (key in _ref1) {
      value = _ref1[key];
      player[key] = value;
    }
  } catch (_error) {}
  this.player = player;
  this.details = null;
  HLSPlaybackProxy.__super__.load.call(this);
};

HLSPlaybackProxy.prototype.applySrc = function() {
  this.currentMedatadata = null;
  this.player.loadSource(this.getSrc());
  this.getMediaElement().load();
};

/**
*/
HLSPlaybackProxy.prototype.onManifestParsed = function(event, data) {
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.MANIFEST_PARSED, {
    event: event,
    data: data
  }));
  this.manifestParsed = true;
  this.sendNotification(Notifications.QUALITY_LEVELS_LOADED, data.levels);
  this.player.loadLevel = -1;
};

/**
*/
HLSPlaybackProxy.prototype.onLevelLoaded = function(event, data) {
  var duration;
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_LOADED, {
    event: event,
    data: data
  }));
  this.player.levels[data.level].level = data.level;
  this.sendNotification(Notifications.QUALITY_CHANGE, this.player.levels[data.level]);
  this.details = data.details;
  duration = this.details.totalduration;
  if (duration !== this.data.duration) {
    this.data.duration = this.details.totalduration;
    this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);
  }
  if (data.details.live === true && this.facade.mediaProxy.getTemporalType() !== "dvr") {
    this.facade.mediaProxy.setTemporalType("live");
  }
};

/**
*/
HLSPlaybackProxy.prototype.onLevelSwitching = function(event, data) {
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_SWITCHING, {
    event: event,
    data: data
  }));
  this.sendNotification(Notifications.QUALITY_CHANGING, this.player.levels[data.level]);
};

/**
*/
HLSPlaybackProxy.prototype.onFragParsingMetadata = function(event, data) {
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_PARSING_METADATA, {
    event: event,
    data: data
  }));
};

HLSPlaybackProxy.prototype.onFragmentLoadStart = function(event, data) {
  var bitrate;
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADING, {
    event: event,
    data: data
  }));
  bitrate = this.player.levels[data.frag.level].bitrate;
  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);
};

HLSPlaybackProxy.prototype.onFragmentLoaded = function(event, data) {
  var bitrate;
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADED, {
    event: event,
    data: data
  }));
  bitrate = this.player.levels[data.frag.level].bitrate;
  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);
};

HLSPlaybackProxy.prototype.ontimeupdate = function(event) {
  var ads, inProgress;
  ads = this.facade.ads || {};
  inProgress = (typeof ads.getInProgress === "function" ? ads.getInProgress() : void 0) || ads.inProgress;
  if (inProgress === true) {
    return;
  }
  this.data.currentTime = this.getCurrentTime();
  this.sendNotification(Notifications.TIME_UPDATE, this.data.currentTime);
};

/**
*/
HLSPlaybackProxy.prototype.ondurationchange = function(event) {
  var duration;
  duration = this.getDetails().totalduration;
  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {
    return;
  }
  this.data.duration = duration;
  this.sendNotification(Notifications.CHANGE_DURATION, duration);
};

HLSPlaybackProxy.prototype.getCurrentTime = function() {
  return this.getMediaElement().currentTime - this.getStartTime();
};

HLSPlaybackProxy.prototype.getDetails = function() {
  return this.details || {};
};

HLSPlaybackProxy.prototype.getFragmentDuration = function() {
  return this.getDetails().targetduration;
};

HLSPlaybackProxy.prototype.getUTCStart = function() {
  return this.getDetails().startSN * 10000;
};

HLSPlaybackProxy.prototype.getUTCTime = function() {
  return this.getUTCStart() + (this.getCurrentTime() * 1000);
};

HLSPlaybackProxy.prototype.getUTCEnd = function() {
  return this.getDetails().endSN * 10000;
};

HLSPlaybackProxy.prototype.getStartTime = function() {
  return this.getMediaElement().duration - this.getDuration();
};

/**
*/
HLSPlaybackProxy.prototype.goLive = function() {
  this.setCurrentTime(this.getLiveTime());
};

/**
*/
HLSPlaybackProxy.prototype.getLiveTime = function() {
  return this.getDuration() - this.getFragmentDuration();
};

/**
*/
HLSPlaybackProxy.prototype.isLive = function() {
  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();
};

/** @override
*/
HLSPlaybackProxy.prototype.seek = function(value) {
  var _this = this;
  return HLSPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {
    if (_this.mediaProxy.getTemporalType() === "dvr") {
      _this.sendNotification(Notifications.IS_LIVE, _this.isLive());
    }
  });
};

/** override
*/
HLSPlaybackProxy.prototype.onplaying = function(event) {
  HLSPlaybackProxy.__super__.onplaying.call(this);
  this.retried = false;
};

/**
*/
HLSPlaybackProxy.prototype.onError = function(event, data) {
  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event("error", {
    event: event,
    data: data
  }));
  if (this.config.ignoreErrors === true) {
    return;
  }
  if (this.config.retryOnError === false || this.retried === true) {
    this.retried = false;
    this.error(data);
    return;
  }
  if (data.fatal && data.type === Hls.ErrorTypes.MEDIA_ERROR && data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {
    data.fatal = false;
  }
  if (data.fatal) {
    switch (data.type) {
      case Hls.ErrorTypes.NETWORK_ERROR:
        this.retried = true;
        if (this.manifestParsed) {
          this.player.startLoad();
        } else {
          this.player.loadSource(this.getSrc());
        }
        this.facade.logger.error("[AMP HLS] Playback Error trying to recover:", event);
        break;
      case Hls.ErrorTypes.MEDIA_ERROR:
        this.retried = true;
        this.player.recoverMediaError();
        this.facade.logger.error("[AMP HLS] Playback Error trying to recover:", event);
        break;
      default:
        this.facade.logger.error("[AMP HLS] Playback Error:", event);
        this.error(data);
    }
  } else {
    if (data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {
      if (this.fragErrorTime === this.getMediaElement().currentTime) {
        this.getMediaElement().currentTime++;
        this.facade.logger.error("[AMP HLS] Frag Loop Load Error, Seeking to :", this.getMediaElement().currentTime);
      } else {
        this.fragErrorTime = this.getMediaElement().currentTime;
      }
    }
  }
};

HLSPlaybackProxy.prototype.error = function(data) {
  switch (data.type) {
    case Hls.ErrorTypes.NETWORK_ERROR:
      data.code = MediaError.MEDIA_ERR_NETWORK;
      break;
    case Hls.ErrorTypes.MEDIA_ERROR:
      data.code = MediaError.MEDIA_ERR_DECODE;
      break;
    default:
      data.toString = function() {
        return data.details;
      };
  }
  this.sendNotification(Notifications.ERROR, data);
};

HLSPlaybackProxy.prototype.createTracks = function() {
  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;
  audio = this.player.audioTracks;
  current = this.player.audioTrack;
  tracks = this.facade.tracks.getAudioTracks();
  count = audio.length;
  changeEnabled = function(track, enabled) {
    var _this = this;
    this.facade.tracks.getAudioTracks().forEach(function(track) {
      return track.data.enabled = false;
    });
    if (enabled !== true) {
      return;
    }
    this.facade.tracks.getAudioTracks()[track.id].data.enabled = true;
    this.player.audioTrack = track.id;
  };
  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {
    item = audio[index];
    track = new Track({
      kind: item.type,
      label: item.id,
      language: item.lang,
      id: item.id,
      enabled: item.id === current,
      data: item
    });
    track.changeEnabled = changeEnabled.bind(this, item);
    tracks.add(track, index + 1 === count);
  }
};

/** @override
*/
HLSPlaybackProxy.prototype.setQuality = function(value) {
  var _ref;
  return (_ref = this.player) != null ? _ref.currentLevel = value : void 0;
};

/** @override
*/
HLSPlaybackProxy.prototype.getQuality = function() {
  var level, _ref, _ref1;
  level = (_ref = this.player) != null ? _ref.currentLevel : void 0;
  if (level === -1) {
    level = (_ref1 = this.player) != null ? _ref1.nextLoadLevel : void 0;
  }
  return level;
};

/** @override
*/
HLSPlaybackProxy.prototype.getQualityLevels = function() {
  var _ref;
  return ((_ref = this.player) != null ? _ref.levels : void 0) || HLSPlaybackProxy.__super__.getQualityLevels.call(this);
};

/** @override
*/
HLSPlaybackProxy.prototype.getQualityMode = function() {
  var _ref;
  if (((_ref = this.player) != null ? _ref.autoLevelEnabled : void 0) === true) {
    return "auto";
  } else {
    return "manual";
  }
};

/** @override
*/
HLSPlaybackProxy.prototype.setQualityMode = function(value) {
  var _ref, _ref1, _ref2;
  if (value === "auto") {
    if ((_ref = this.player) != null) {
      _ref.currentLevel = -1;
    }
  } else if (value === "manual") {
    if ((_ref1 = this.player) != null) {
      _ref1.currentLevel = (_ref2 = this.player) != null ? _ref2.currentLevel : void 0;
    }
  } else {
    value += " is not a valid key";
  }
  return value;
};

/** @override
*/
HLSPlaybackProxy.prototype.destroy = function() {
  if (!(this.player != null)) {
    return;
  }
  this.player.destroy();
  this.player = null;
};

/**
 * The HLSAdBreakStartCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function HLSAdBreakStartCommand() {
  HLSAdBreakStartCommand.__super__.constructor.call(this);
}


__extends(HLSAdBreakStartCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
HLSAdBreakStartCommand.prototype.execute = function(notification) {
  var _ref;
  if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === "freewheel") {
    this.proxy.destroy();
  }
};

/**
 * @enum {string}
 * @const
 * @private
*/

var AdNotifications = {
  BREAK_START: "adsbreakstart",
  BREAK_END: "adsbreakend",
  BREAK_SKIPPED: "adsbreakskipped",
  AD_CONTAINER_CREATED: "adscontainercreated",
  AD_LOADED: "adsloaded",
  AD_MANAGER_LOADED: "adsmanagerloaded",
  AD_STARTED: "adsstarted",
  AD_TIME_UPDATE: "adstimeupdate",
  AD_TIME_REMAINING: "adstimeremaining",
  AD_DURATION_CHANGE: "adsdurationchange",
  AD_ENDED: "adsended",
  AD_ERROR: "adserror",
  AD_PLAY: "adsplay",
  AD_PAUSE: "adspause",
  AD_PAUSED: "adspaused",
  AD_RESUME: "adsresume",
  AD_CLICKED: "adclicked",
  AD_COMPANION: "adscompanion",
  FIRST_QUARTILE: "adsfirstquartile",
  MIDPOINT: "adsmidpoint",
  THIRD_QUARTILE: "adsthirdquartile",
  COMPLETE: "adscomplete",
  LOG: "adslog",
  REQUEST: "adsrequest",
  REQUEST_COMPLETE: "adsrequestcomplete",
  RESPONSE: "adsresponse",
  SKIPPED: "adsskipped",
  IMPRESSION: "adsimpression"
};

/** 
 * @param {Object}  config  The plugin configuration object.
 * @constructor
 * @private
 * @extends {PluginProxy}
*/
function PlaybackPluginProxy(config) {
  PlaybackPluginProxy.__super__.constructor.call(this, config);
}


__extends(PlaybackPluginProxy, PluginProxy);


/** @static
*/
PlaybackPluginProxy.NAME = ModuleProxy.NAME;

PlaybackPluginProxy.prototype.playbackProxy = null;

PlaybackPluginProxy.prototype.createPlaybackProxy = function() {};

PlaybackPluginProxy.prototype.initialize = function() {
  var player;
  this.playbackProxy = this.createPlaybackProxy();
  if (!(this.playbackProxy != null)) {
    return;
  }
  this.sendNotification(Notifications.INITIALIZED);
  player = this.facade.player.retrieveProxy(PlayerProxy.NAME);
  player.registerPlaybackCore(this.playbackProxy);
};

PlaybackPluginProxy.prototype.destroy = function() {
  var _ref;
  if ((_ref = this.playbackProxy) != null) {
    _ref.destroy();
  }
};

/**
 * The HLSProxy class.
 *
 * @param {Object}  config  The plugin configuration object.
 * @constructor
 * @private
 * @extends {PluginProxy}
*/
function HLSProxy(config) {
  HLSProxy.__super__.constructor.call(this, config);
}


__extends(HLSProxy, PlaybackPluginProxy);


/** @static
*/
HLSProxy.NAME = ModuleProxy.NAME;

HLSProxy.prototype.defaults = {
  types: ["application/x-mpegURL"],
  data: {
    enableWorker: true,
    enableCEA708Captions: true
  },
  mae: null,
  buffer: null,
  quality: null,
  withCredentials: null,
  retryOnError: true,
  ignoreErrors: false
};

HLSProxy.prototype.createPlaybackProxy = function() {
  var mediaSource;
  mediaSource = window.MediaSource || window.WebKitMediaSource;
  if (!(mediaSource != null) || !Hls.isSupported()) {
    return;
  }
  return new HLSPlaybackProxy(this.getConfigurationData(), this.facade);
};

/**
 * DASHPlaybackProxy constructor.
 *
 * @constructor
 * @private
 * @extends {PlaybackCoreProxy}
*/
function DASHPlaybackProxy(data) {
  DASHPlaybackProxy.__super__.constructor.call(this, data.types, data);
  this.buffer = data.buffer;
  this.temporalTypes = ["vod", "live", "dvr"];
}


__extends(DASHPlaybackProxy, PlaybackCoreProxy);


DASHPlaybackProxy.prototype.playbackCoreName = "dash";

DASHPlaybackProxy.prototype.context = null;

DASHPlaybackProxy.prototype.player = null;

DASHPlaybackProxy.prototype.buffer = null;

/** @override
*/
DASHPlaybackProxy.prototype.resumecomplete = function() {
  var track, tracks, _ref;
  try {
    tracks = (_ref = this.facade.getMediaElement()) != null ? _ref.textTracks : void 0;
    if ((tracks != null ? tracks.length : void 0) !== 0) {
      track = tracks[0];
      if (track != null) {
        track.mode = "hidden";
      }
    }
  } catch (error) {

  }
  DASHPlaybackProxy.__super__.resumecomplete.call(this);
};

DASHPlaybackProxy.prototype.onerror = function() {};

/** @override
*/
DASHPlaybackProxy.prototype.createTracks = function() {
  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;
  audio = this.player.getTracksFor("audio");
  current = this.player.getCurrentTrackFor("audio");
  tracks = this.facade.tracks.getAudioTracks();
  count = audio.length;
  changeEnabled = function(audio, track, enabled) {
    var _this = this;
    this.facade.tracks.getAudioTracks().forEach(function(item) {
      return item.data.enabled = item === track;
    });
    if (enabled !== true) {
      return;
    }
    this.player.setCurrentTrack(audio);
  };
  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {
    item = audio[index];
    track = new Track({
      kind: item.roles.join(" "),
      label: item.id,
      language: item.lang,
      id: item.id,
      enabled: item === current,
      data: item
    });
    track.changeEnabled = changeEnabled.bind(this, item, track);
    tracks.add(track, index + 1 === count);
  }
};

/**
*/
DASHPlaybackProxy.prototype.getUseMAE = function() {
  return DASHPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationDashJsWrapper !== "undefined" && MediaAccelerationDashJsWrapper !== null);
};

/** @override
*/
DASHPlaybackProxy.prototype.load = function() {
  var useMAE, _ref;
  if (!(this.player != null)) {
    useMAE = ((_ref = this.config.mae) != null ? _ref.enabled : void 0) !== false && (typeof MediaAccelerationDashJsWrapper !== "undefined" && MediaAccelerationDashJsWrapper !== null);
    if (!this.getUseMAE()) {
      this.player = dashjs.MediaPlayer().create();
    } else {
      this.facade.mae = new MediaAccelerationDashJsWrapper(this.config.mae);
      this.player = this.facade.mae.getPlayer();
    }
    this.player.enableBufferOccupancyABR(true);
    this.player.on("error", this.onError.bind(this));
    this.player.on("fragmentLoadingStarted", this.onFragmentLoadStart.bind(this));
    this.player.on("fragmentLoadingCompleted", this.onFragmentLoaded.bind(this));
    this.player.on("qualityChangeRequested", this.onLevelSwitching.bind(this));
    this.player.getDebug().setLogToBrowserConsole(this.facade.logger.enabled);
    this.player.initialize(this.getMediaElement(), null, false);
    if (this.config.initialBitrate != null) {
      this.player.setInitialBitrateFor(this.facade.getMedia().medium, this.config.initialBitrate);
    }
  }
  DASHPlaybackProxy.__super__.load.call(this);
};

/** @override
*/
DASHPlaybackProxy.prototype.applySrc = function() {
  var keys;
  keys = this.facade.getMedia().keys;
  if (keys != null) {
    this.player.setProtectionData(keys);
  }
  this.player.attachSource(this.getSrc());
  this.getMediaElement().load();
};

/** @override
*/
DASHPlaybackProxy.prototype.seek = function(value) {
  return Promise.resolve(this.player.seek(value));
};

/** @override
*/
DASHPlaybackProxy.prototype.getCurrentTime = function() {
  var _ref;
  return ((_ref = this.player) != null ? _ref.time() : void 0) || 0;
};

/** @override
*/
DASHPlaybackProxy.prototype.getDuration = function() {
  var _ref;
  return ((_ref = this.player) != null ? _ref.duration() : void 0) || 0;
};

/**
*/
DASHPlaybackProxy.prototype.getStats = function() {
  return {};
};

/**
*/
DASHPlaybackProxy.prototype.onFragmentLoadStart = function(event) {
  var bitrate;
  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;
  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);
};

/**
*/
DASHPlaybackProxy.prototype.onFragmentLoaded = function(event) {
  var bitrate;
  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;
  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);
};

/**
*/
DASHPlaybackProxy.prototype.onLevelSwitching = function(event) {
  this.sendNotification(Notifications.QUALITY_CHANGING, this.getQualityLevels()[event.newQuality]);
};

/**
*/
DASHPlaybackProxy.prototype.onError = function(event) {
  this.facade.logger.error("DASH JS Playback Error:", event);
};

/** @override
*/
DASHPlaybackProxy.prototype.setQuality = function(value) {
  var _ref, _ref1, _ref2;
  if ((_ref = this.player) != null) {
    _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value === -1);
  }
  if (value === -1) {
    return;
  }
  return (_ref2 = this.player) != null ? _ref2.setQualityFor("video", value) : void 0;
};

/** @override
*/
DASHPlaybackProxy.prototype.getQuality = function() {
  var _ref;
  return (_ref = this.player) != null ? _ref.getQualityFor("video") : void 0;
};

/** @override
*/
DASHPlaybackProxy.prototype.getQualityLevels = function() {
  var _ref;
  return ((_ref = this.player) != null ? _ref.getBitrateInfoListFor("video") : void 0) || DASHPlaybackProxy.__super__.getQualityLevels.call(this);
};

/** @override
*/
DASHPlaybackProxy.prototype.getQualityMode = function() {
  var _ref, _ref1;
  if (((_ref = this.player) != null ? _ref.getAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0) : void 0) === true) {
    return "auto";
  } else {
    return "abr";
  }
};

/** @override
*/
DASHPlaybackProxy.prototype.setQualityMode = function(value) {
  var _ref, _ref1;
  if (value !== "auto") {
    return value + " is not a valid key";
  }
  return (_ref = this.player) != null ? _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value) : void 0;
};

/** @override
*/
DASHPlaybackProxy.prototype.destroy = function() {
  var _ref;
  if ((_ref = this.player) != null) {
    _ref.reset();
  }
};

/**
 * The CaptioningPlugin class.
 *
 * @param {Module}  app     The parent module of this plugin.
 * @constructor
 * @private
 * @extends {Feature}
*/
function CaptioningPlugin() {
  CaptioningPlugin.__super__.constructor.call(this);
  Object.defineProperties(this, {
    enabled: {
      get: this.getEnabled,
      set: this.setEnabled,
      enumerable: true,
      configurable: false
    },
    hidden: {
      get: this.getHidden,
      set: this.setHidden,
      enumerable: true,
      configurable: false
    },
    visible: {
      get: this.getVisible,
      set: this.setVisible,
      enumerable: true,
      configurable: false
    },
    tracks: {
      get: this.getTracks,
      enumerable: true,
      configurable: false
    },
    track: {
      get: this.getTrack,
      set: this.setTrack,
      enumerable: true,
      configurable: false
    }
  });
}


__extends(CaptioningPlugin, Feature);


CaptioningPlugin.prototype.featureName = "captioning";

CaptioningPlugin.prototype.moduleName = "captioning";

/** @override
*/
CaptioningPlugin.prototype.createController = function() {
  CaptioningPlugin.__super__.createController.call(this);
  this.registerCommand(Notifications.CHANGE_MEDIA, CaptioningChangeMediaCommand);
  this.registerCommand(Notifications.STARTED, CaptioningStartedCommand);
  this.registerCommand(Notifications.TIME_UPDATE, CaptioningTimeUpdateCommand);
  this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, CaptioningVisibilityChangeCommand);
  this.registerCommand(CaptioningNotifications.ENABLED, CaptioningEnabledCommand);
  this.registerCommand(CaptioningNotifications.TRACK_SELECTED, PluginEventCommand);
  this.registerCommand(CaptioningNotifications.TRACKS_LOADED, PluginEventCommand);
  this.registerCommand(CaptioningNotifications.CUE_CHANGE, PluginEventCommand);
};

/** @override
*/
CaptioningPlugin.prototype.createModel = function() {
  this.proxy = new CaptioningProxy(this.config);
  this.registerProxy(this.proxy);
};

/** @override
*/
CaptioningPlugin.prototype.createView = function() {
  var mediator, viewComponent;
  mediator = new CaptioningMediator();
  this.registerMediator(mediator);
  viewComponent = mediator.viewComponent;
  this.proxy.registerRenderer(new CaptioningNativeMediator(viewComponent));
  this.proxy.registerRenderer(new CaptioningHTMLMediator(viewComponent));
};

/**
*/
CaptioningPlugin.prototype.listNotificationInterests = function() {
  return [Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, Notifications.CHANGE_MEDIA, Notifications.STARTED, Notifications.TIME_UPDATE, CaptioningNotifications.TRACK_SELECTED];
};

/**
*/
CaptioningPlugin.prototype.listNotificationPublications = function() {
  return CaptioningPlugin.__super__.listNotificationPublications.call(this).concat([CaptioningNotifications.CUE_CHANGE, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE]);
};

/**
 * @return {boolean} The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.getEnabled = function() {
  return this.proxy.getEnabled();
};

/**
 * @param {boolean} value The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.setEnabled = function(value) {
  this.sendNotification(CaptioningNotifications.ENABLED, value);
  return value;
};

/**
 * @return {boolean} The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.getHidden = function() {
  return this.proxy.getHidden();
};

/**
 * @param {boolean} value The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.setHidden = function(value) {
  this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, !value);
  return value;
};

/**
 * @return {boolean} The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.getVisible = function() {
  return !this.proxy.getHidden();
};

/**
 * @param {boolean} value The hidden flag.
 * @expose
*/
CaptioningPlugin.prototype.setVisible = function(value) {
  this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, value);
  return value;
};

/**
 * Returns an array of caption tracks
 *
 * @return {Array.<CaptionTrack>} The list of text tracks.
 * @expose
*/
CaptioningPlugin.prototype.getTracks = function() {
  return this.proxy.getTracks();
};

/**
 * Returns the currently selected track.
 *
 * @return {CaptionTrack} The currently selected caption track.
 * @expose
*/
CaptioningPlugin.prototype.getTrack = function() {
  return this.proxy.getTrack();
};

/**
 * Selects a caption track
 *
 * @param {CaptionTrack} value The caption track to select
 * @expose
*/
CaptioningPlugin.prototype.setTrack = function(value) {
  this.proxy.setTrack(value);
  return value;
};

/**
 * Selects a caption track by its index in the getTracks array.
 *
 * @param {number}        index   The index to select
 * @return {CaptionTrack}         The selected caption track.
 * @expose
*/
CaptioningPlugin.prototype.selectTrackByIndex = function(index) {
  return this.proxy.selectTrackByIndex(index);
};

/**
 * Selects a caption track by it's language property.
 *
 * @param {string}        lang  The language to select
 * @return {CaptionTrack}       The selected caption track.
 * @expose
*/
CaptioningPlugin.prototype.selectTrackByLanguage = function(lang) {
  return this.proxy.selectTrackByLanguage(lang);
};

/**
 * Sets a caption Settings Object (styles)
 *
 * @param {Object}  object  The caption settings object.
 * @expose
*/
CaptioningPlugin.prototype.changeSettings = function(object) {
  this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, object);
  return object;
};

/**
 * Allows parallel rendering to be toggled
 *
 * @param {value}  number  The value to use.
 * @expose
*/
CaptioningPlugin.prototype.useParallelRendering = function(value) {
  var renderer;
  renderer = this.proxy.getRenderer();
  if (renderer) {
    renderer.useParallelRendering(value);
  }
  return value;
};


AMP.registerPlugin("captioning", "html", CaptioningPlugin);

/**
 * The DASHChangeDisplayStateCommand class.
 *   
 * @constructor
 * @private
 * @extends {puremvc.SimpleCommand}
*/
function DASHChangeDisplayStateCommand() {
  DASHChangeDisplayStateCommand.__super__.constructor.call(this);
}


__extends(DASHChangeDisplayStateCommand, puremvc.SimpleCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
DASHChangeDisplayStateCommand.prototype.execute = function(notification) {
  var core, fullscreen, playback, proxy, state, target,
    _this = this;
  state = notification.getBody();
  playback = this.facade.retrieveProxy(PlaybackProxy.NAME);
  core = this.facade.getMediaElement();
  if (!(core != null) || !core.webkitSupportsFullscreen) {
    return;
  }
  proxy = this.facade.retrieveProxy(ApplicationStateProxy.NAME);
  proxy.setDisplayState(state);
  fullscreen = {};
  target = this.facade.viewComponent;
  if (target.requestFullscreen != null) {
    fullscreen.enter = function() {
      return target.requestFullscreen();
    };
    fullscreen.exit = function() {
      return document.cancelFullscreen();
    };
    fullscreen.event = "onfullscreenchange";
    fullscreen.element = "fullscreenElement";
  } else if (target.webkitRequestFullScreen != null) {
    fullscreen.enter = function() {
      return target.webkitRequestFullScreen();
    };
    fullscreen.exit = function() {
      return document.webkitCancelFullScreen();
    };
    fullscreen.event = "onwebkitfullscreenchange";
    fullscreen.element = "webkitFullscreenElement";
  } else if (target.mozRequestFullScreen != null) {
    fullscreen.enter = function() {
      return target.mozRequestFullscreen();
    };
    fullscreen.exit = function() {
      return document.mozCancelFullScreen();
    };
    fullscreen.event = "onmozfullscreenchange";
    fullscreen.element = "mozFullscreenElement";
  } else if (target.msRequestFullScreen != null) {
    fullscreen.enter = function() {
      return target.msRequestFullscreen();
    };
    fullscreen.exit = function() {
      return document.msCancelFullScreen();
    };
    fullscreen.event = "onmozfullscreenchange";
    fullscreen.element = "mozFullscreenElement";
  }
  if (state === DisplayState.FULL_SCREEN) {
    fullscreen.enter();
    if (fullscreen.event != null) {
      core[fullscreen.event] = function(event) {
        if (!(document[fullscreen.element] != null)) {
          return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);
        }
      };
    }
  } else if (state === DisplayState.NORMAL) {
    fullscreen.exit();
    core[fullscreen.event] = null;
  }
  this.facade.dispatchEvent(new Event("fullscreenchange", state === DisplayState.FULL_SCREEN));
};

/** 
 * The DASHProxy class.
 *   
 * @param {Object}  config  The plugin configuration object.
 * @constructor
 * @private
 * @extends {PluginProxy}
*/
function DASHProxy(config) {
  DASHProxy.__super__.constructor.call(this, config);
}


__extends(DASHProxy, PlaybackPluginProxy);


/** @static
*/
DASHProxy.NAME = ModuleProxy.NAME;

DASHProxy.prototype.defaults = {
  types: ["application/dash+xml"],
  buffer: null,
  mae: null,
  initialBitrate: null
};

DASHProxy.prototype.createPlaybackProxy = function() {
  var mediaSource;
  mediaSource = window.MediaSource || window.WebKitMediaSource;
  if (!(mediaSource != null)) {
    return;
  }
  return new DASHPlaybackProxy(this.getConfigurationData());
};

/**
 * The AMPChromeCastPlayer class.
 *
 * @param {Object} player
 *    The player instance
 *
 * @constructor
*/
function ChromeCastPlayer(shim) {
  var index, rule, sheet, style;
  this.shim = shim;
  ChromeCastPlayer.__super__.constructor.call(this);
  this.state = cast.receiver.media.PlayerState.IDLE;
  try {
    style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    sheet = style.sheet;
    rule = ".akamai-html5.akamai-video::cue {color: #FFFFFF; background: #000000; visibility: hidden;}";
    index = sheet.insertRule(rule, 0);
    this.cssRule = sheet.rules[index];
  } catch (error) {
    Logger.error(error);
  }
}


__extends(ChromeCastPlayer, EventDispatcher);


ChromeCastPlayer.prototype.player = null;

ChromeCastPlayer.prototype.callbackMap = null;

ChromeCastPlayer.prototype.state = null;

ChromeCastPlayer.prototype.activeTrackId = null;

ChromeCastPlayer.prototype.cssRule = null;

ChromeCastPlayer.prototype.textTrackStyle = null;

ChromeCastPlayer.prototype.ccHandler = null;

ChromeCastPlayer.prototype.feed = null;

ChromeCastPlayer.prototype.media = null;

ChromeCastPlayer.prototype.tracks = null;

/**
 *
*/
ChromeCastPlayer.prototype.registerPlayer = function(player) {
  var events, listener, readyHandler,
    _this = this;
  this.player = player;
  events = ["loadedmetadata", "ended", "error"];
  listener = this.dispatchEvent.bind(this);
  events.forEach(function(type) {
    return player.addEventListener(type, listener);
  });
  readyHandler = function() {
    _this.applyMedia();
    _this.applyClassName();
  };
  this.player.once("ready", readyHandler);
  this.player.addEventListener("playing", this.setState.bind(this, cast.receiver.media.PlayerState.PLAYING));
  this.player.addEventListener("pause", this.setState.bind(this, cast.receiver.media.PlayerState.PAUSED));
  this.player.addEventListener("waiting", this.setState.bind(this, cast.receiver.media.PlayerState.BUFFERING));
};

/**
 * @private
*/
ChromeCastPlayer.prototype.setState = function(state) {
  if (state === this.state) {
    return;
  }
  this.state = state;
  this.shim.mediaManager.broadcastStatus(true);
  return state;
};

/**
 * Registers an API that the player should call when there is an error.
 *
 * @param {function(Object)} errorCallback
 *    The callback method called when the player has an error.
*/
ChromeCastPlayer.prototype.registerErrorCallback = function(errorCallback) {
  this.onerror = errorCallback;
};

/**
 * Registers an API that the player should call when the media has ended.
 *
 * @param {function()} endedCallback
 *    The callback method called when the player has ended.
*/
ChromeCastPlayer.prototype.registerEndedCallback = function(endedCallback) {
  this.onended = endedCallback;
};

/**
 * Registers an API that the player should call when load is complete.
 *
 * @param {function()} loadCallback
 *    The callback method called when the player has completed load succesfully.
*/
ChromeCastPlayer.prototype.registerLoadCallback = function(loadCallback) {
  this.onloadedmetadata = loadCallback;
};

/**
 * Called to unregister for error callbacks.
*/
ChromeCastPlayer.prototype.unregisterErrorCallback = function() {
  this.onerror = null;
};

/**
 * Called to unregister for ended callbacks.
*/
ChromeCastPlayer.prototype.unregisterEndedCallback = function() {
  this.onended = null;
};

/**
 * Called to unregister for load callbacks.
*/
ChromeCastPlayer.prototype.unregisterLoadCallback = function() {
  this.onloadedmetadata = null;
};

/**
 * Loads content to be played.
 *
 * @param {string} contentId
 *    The content ID. Should be treated as an opaque string.
 *
 * @param {boolean} autoplay
 *    Whether the content should play after load.
 *
 * @param {number} opt_time
 *    The expected current time after load (in seconds). Optional.
 *
 * @param {cast.receiver.media.TracksInfo} opt_tracksInfo
 *    The tracks information. Optional.
*/
ChromeCastPlayer.prototype.load = function(contentId, autoplay, opt_time, opt_tracksInfo) {
  var customData, info, key, media, metadata, value, _ref, _ref1, _ref2;
  info = this.shim.mediaManager.getMediaInformation();
  customData = info.customData || {};
  metadata = info.metadata || {};
  if (opt_tracksInfo != null) {
    this.editTracksInfo(opt_tracksInfo);
  } else {
    this.activeTrackId = null;
  }
  this.feed = null;
  media = {
    src: contentId,
    type: info.contentType,
    title: metadata.title,
    poster: (_ref = metadata.images) != null ? _ref.url : void 0,
    description: metadata.subtitle,
    pubDate: new Date(info.releaseDate),
    metadata: customData,
    duration: info.duration,
    startTime: opt_time || ((_ref1 = customData.media) != null ? _ref1.startTime : void 0),
    autoplay: autoplay
  };
  if (customData.media != null) {
    _ref2 = customData.media;
    for (key in _ref2) {
      value = _ref2[key];
      if (!(media[key] != null)) {
        media[key] = value;
      }
    }
    if (customData.media.metadata != null) {
      media.metadata = customData.media.metadata;
    }
  }
  this.tracks = info.tracks;
  this.media = media;
  this.applyMedia();
};

/**
 *
*/
ChromeCastPlayer.prototype.applyMedia = function() {
  if (!(this.player != null) || !(this.media != null)) {
    return;
  }
  this.player.once("loadedmetadata", this.loadTracks.bind(this, this.tracks));
  this.player.setMedia(this.media);
  this.setState(cast.receiver.media.PlayerState.BUFFERING);
};

/**
 *
*/
ChromeCastPlayer.prototype.loadTracks = function(tracks, event) {
  var playbackCore, track, type;
  if ((tracks != null ? tracks.length : void 0) > 0) {
    track = this.getTrack(0);
    if (track != null) {
      type = /ttml/.test(track.trackContentType) ? "ttml" : track.trackContentType;
      playbackCore = this.player.retrieveProxy("PlayerProxy").getActivePlaybackCore();
      playbackCore.player.enableCaptions(true, type, track.trackContentId);
    }
  }
};

/**
 *
*/
ChromeCastPlayer.prototype.mediachangeHandler = function(event) {
  var media, mediaInfo;
  media = this.player.getMedia();
  mediaInfo = new cast.receiver.media.MediaInformation();
  mediaInfo.contentId = media.src;
  mediaInfo.contentType = media.type;
  mediaInfo.customData = media.metadata;
  mediaInfo.duration = media.duration;
  mediaInfo.metadata = {
    title: media.title,
    subtitle: media.description,
    images: [
      {
        url: media.poster
      }
    ],
    releaseDate: media.pubDate.toISOString()
  };
  this.media = media;
  this.shim.mediaManager.setMediaInformation(mediaInfo, true);
};

/**
 * Resets the player.
*/
ChromeCastPlayer.prototype.reset = function() {};

/**
 * Starts playback.
*/
ChromeCastPlayer.prototype.play = function() {
  this.player.play();
};

/**
 * Sets playback to start at a new time position.
 *
 * @param {number} time
 *    The expected current time after seek (in seconds).
 *
 * @param {cast.receiver.media.SeekResumeState} opt_resumeState
 *    The expected state after seek. Optional.
*/
ChromeCastPlayer.prototype.seek = function(time, opt_resumeState) {
  this.player.setCurrentTime(time);
  switch (opt_resumeState) {
    case cast.receiver.media.SeekResumeState.PLAYBACK_PAUSE:
      this.player.pause();
      break;
    case cast.receiver.media.SeekResumeState.PLAYBACK_START:
      this.player.play();
  }
};

/**
 * Pauses playback.
*/
ChromeCastPlayer.prototype.pause = function() {
  return this.player.pause();
};

/**
 * Provides the state of the player.
 *
 * @return {cast.receiver.media.PlayerState
 *    The current state of the player
*/
ChromeCastPlayer.prototype.getState = function() {
  return this.state;
};

/**
 * Provides the current time of the media in seconds.
 *
 * @return {number
 *    The current time of the video, in seconds.
*/
ChromeCastPlayer.prototype.getCurrentTimeSec = function() {
  if (this.player != null) {
    return this.player.getCurrentTime();
  } else {
    return 0;
  }
};

/**
 * Provides the duration of the media in seconds.
 *
 * @return {number
 *    Duration of the video, in seconds.
*/
ChromeCastPlayer.prototype.getDurationSec = function() {
  if (this.player != null) {
    return this.player.getDuration();
  } else {
    return 0;
  }
};

/**
 * Provides the stream volume.
 *
 * @return {cast.receiver.media.Volume
 *    The media volume
*/
ChromeCastPlayer.prototype.getVolume = function() {
  var volume;
  if (!(this.player != null)) {
    return;
  }
  volume = new cast.receiver.media.Volume();
  volume.level = this.player.getVolume();
  volume.muted = this.player.getMuted();
  return volume;
};

/**
 * Sets the stream volume.
 *
 * @param {cast.receiver.media.Volume} volume
 *    New volume
*/
ChromeCastPlayer.prototype.setVolume = function(volume) {
  if (volume.level != null) {
    this.player.setVolume(volume.level);
  }
  if (volume.muted === true) {
    this.player.setMuted(true);
  } else {
    if (this.player.getMuted() === true) {
      this.player.setMuted(false);
    }
  }
  return volume;
};

/**
 * Allows to edit the tracks information (active tracks and style).
 *
 * @param {cast.receiver.MediaManager.EditTracksInfoData} data
 *    The tracks information. The tracks definition can not change so
 *    the tracks field will be undefined (and should be ignored).
*/
ChromeCastPlayer.prototype.editTracksInfo = function(data) {
  var activeTrack, style;
  if (data.activeTrackIds != null) {
    activeTrack = data.activeTrackIds[0];
    if (this.activeTrackId !== activeTrack) {
      this.activeTrackId = activeTrack;
      this.applyClassName();
    }
  }
  style = data.textTrackStyle;
  if ((style != null) && (this.cssRule != null)) {
    this.textTrackStyle = style;
    if (style.foregroundColor != null) {
      this.cssRule.style.color = this.hexToRgba(style.foregroundColor);
    }
    if (style.backgroundColor != null) {
      this.cssRule.style.backgroundColor = this.hexToRgba(style.backgroundColor);
    }
    if (style.windowType === cast.receiver.media.TextTrackWindowType.ROUNDED_CORNERS) {
      this.cssRule.style.borderRadius = style.windowRoundedCornerRadius + "px";
    }
    if (style.fontScale != null) {
      this.cssRule.style.fontSize = style.fontScale + "em";
    }
    if (style.fontFamily != null) {
      this.cssRule.style.fontFamily = style.fontFamily;
    }
  }
};

ChromeCastPlayer.prototype.applyClassName = function(hex) {
  var classList, className;
  if (!(this.player != null)) {
    return;
  }
  className = "akamai-cc";
  classList = this.player.getMediaElement().classList;
  if (this.activeTrackId != null) {
    classList.add(className);
  } else {
    classList.remove(className);
  }
};

ChromeCastPlayer.prototype.hexToRgba = function(hex) {
  var a, b, g, r;
  if (!/^#[A-Fa-f0-9]{6}([A-Fa-f0-9]{2})?$/.test(hex)) {
    return hex;
  }
  r = parseInt(hex.substring(1, 3), 16);
  g = parseInt(hex.substring(3, 5), 16);
  b = parseInt(hex.substring(5, 7), 16);
  a = hex.length === 9 ? parseInt(hex.substring(7, 9), 16) / 256 : 1;
  return "rgba(" + r + "," + g + "," + b + "," + a + ")";
};

ChromeCastPlayer.prototype.getTrack = function(id) {
  var track;
  if (!(id != null)) {
    id = this.activeTrackId;
  }
  track = this.tracks.filter(function(item) {
    return item.trackId === id;
  })[0];
  if (track != null) {
    if (!(track.trackContentType != null)) {
      track.trackContentType = cast.player.api.CaptionsType.CEA608;
    }
  }
  return track;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var ChromeCastConstants = {
  CHANNEL_ID: "urn:x-cast:com.akamai.amp.cast",
  APPLICATION_ID: "CC1AD845",
  SUPPORTED_TYPES: [Utils.mimeTypes.m3u8, Utils.mimeTypes.mp4, Utils.mimeTypes.mpd, Utils.mimeTypes.ism, Utils.mimeTypes.webm, Utils.mimeTypes.mp3]
};

/**
 * The ChromeCastSenderProxy class.
 *
 * @param {Object}  config  The plugin configuration object.
 * @constructor
 * @private
 * @extends {PluginProxy}
*/
function ChromeCastSenderProxy(config) {
  this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;
  ChromeCastSenderProxy.__super__.constructor.call(this, config.sender);
}


__extends(ChromeCastSenderProxy, PluginProxy);


/** @static
*/
ChromeCastSenderProxy.NAME = ModuleProxy.NAME;

ChromeCastSenderProxy.prototype.defaults = {
  applicationID: ChromeCastConstants.APPLICATION_ID
};

ChromeCastSenderProxy.prototype.session = null;

ChromeCastSenderProxy.prototype.media = null;

ChromeCastSenderProxy.prototype.messageBus = null;

ChromeCastSenderProxy.prototype.feed = null;

ChromeCastSenderProxy.prototype.currentTime = null;

ChromeCastSenderProxy.prototype.duration = null;

ChromeCastSenderProxy.prototype.receiverAvailable = false;

ChromeCastSenderProxy.prototype.currentTime = 0;

ChromeCastSenderProxy.prototype.duration = 0;

ChromeCastSenderProxy.prototype.playerState = null;

ChromeCastSenderProxy.prototype.displayTimeTimeout = null;

ChromeCastSenderProxy.prototype.volume = 1;

ChromeCastSenderProxy.prototype.muted = false;

/** @override
*/
ChromeCastSenderProxy.prototype.initialize = function() {
  var _ref,
    _this = this;
  if (typeof chrome !== "undefined" && chrome !== null ? (_ref = chrome.cast) != null ? _ref.isAvailable : void 0 : void 0) {
    this.initializeCastApi();
  } else {
    window['__onGCastApiAvailable'] = function(loaded, errorInfo) {
      if (loaded === true) {
        _this.initializeCastApi();
      } else {
        _this.logError("cast load error", errorInfo);
      }
    };
  }
};

ChromeCastSenderProxy.prototype.initializeCastApi = function() {
  var apiConfig, applicationID, sessionRequest;
  applicationID = this.getConfigurationData().applicationID;
  sessionRequest = new chrome.cast.SessionRequest(applicationID);
  apiConfig = new chrome.cast.ApiConfig(sessionRequest, this.sessionListener.bind(this), this.receiverListener.bind(this), chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED);
  chrome.cast.initialize(apiConfig, this.onInitSuccess.bind(this), this.onInitError.bind(this));
};

ChromeCastSenderProxy.prototype.onInitSuccess = function(event) {
  this.logEvent("init success", event);
};

ChromeCastSenderProxy.prototype.onInitError = function(event) {
  this.logError("init error", event);
};

ChromeCastSenderProxy.prototype.receiverListener = function(event) {
  this.receiverAvailable = event === 'available';
  this.sendNotification(ChromeCastNotifications.AVAILABILITY_CHANGE, this.receiverAvailable);
  this.logEvent("receiver " + (this.receiverAvailable ? "found" : "list empty"));
};

ChromeCastSenderProxy.prototype.sessionListener = function(event) {
  var session;
  this.logEvent("session listener", event);
  session = event;
  if (session.media.length !== 0) {
    this.onMediaDiscovered(session.media[0]);
  } else {
    this.onRequestSessionSuccess(event);
  }
};

ChromeCastSenderProxy.prototype.launch = function() {
  chrome.cast.requestSession(this.onRequestSessionSuccess.bind(this), this.onLaunchError.bind(this));
};

ChromeCastSenderProxy.prototype.send = function(msg) {
  var _ref;
  if ((_ref = this.session) != null) {
    if (typeof _ref.sendMessage === "function") {
      _ref.sendMessage(this.messageBus, msg, this.onMessageSuccess.bind(this), this.onMessageError.bind(this));
    }
  }
};

ChromeCastSenderProxy.prototype.onLaunchError = function(event) {
  this.logError("launch error.", event);
};

ChromeCastSenderProxy.prototype.onRequestSessionSuccess = function(event) {
  var playbackProxy;
  this.logEvent("request session success.", event);
  this.session = event;
  this.session.addMessageListener(this.messageBus, this.onMessage.bind(this));
  this.session.addUpdateListener(this.onUpdate.bind(this));
  this.session.sendMessage(this.messageBus, {
    type: "createPlayer",
    config: {
      debug: this.facade.player.getConfig().debug
    }
  }, this.onCreateSucess.bind(this), this.onMessageError.bind(this));
  playbackProxy = this.facade.player.retrieveProxy(PlaybackProxy.NAME);
  if (this.session.media.length === 0) {
    this.loadMedia(playbackProxy.getCurrentTime());
  }
};

ChromeCastSenderProxy.prototype.onUpdate = function(isAlive) {
  var currentTime;
  if (!isAlive) {
    currentTime = this.facade.player.media.isLive === true ? Infinity : this.media.currentTime;
    this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, "amp");
    this.stopDisplayTimeUpdate();
  }
};

ChromeCastSenderProxy.prototype.onCreateSucess = function(event) {
  this.logEvent("MPL created", event);
  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, "chromecast");
};

ChromeCastSenderProxy.prototype.onMessageSuccess = function(event) {
  this.logEvent("message sent", event);
};

ChromeCastSenderProxy.prototype.onMessageError = function(event) {
  this.logError("message error", event);
};

ChromeCastSenderProxy.prototype.onMessage = function(namespace, message) {
  var detail, target, type;
  message = JSON.parse(message);
  type = message.type;
  detail = message.detail || {};
  switch (type) {
    case "dispatchevent":
      target = detail.target === "player" ? this.facade.player : this.facade.player[detail.target];
      if (target != null) {
        target.dispatchEvent(detail.event);
      }
  }
  this.sendNotification(Notifications.DISPATCH_EVENT, {
    type: "message",
    message: message
  });
};

ChromeCastSenderProxy.prototype.onStop = function(event) {
  this.logEvent("stop");
  this.session.stop(this.onStopSuccess.bind(this), this.onStopError.bind(this));
};

ChromeCastSenderProxy.prototype.onStopSuccess = function(event) {
  this.logEvent("stop success", event);
};

ChromeCastSenderProxy.prototype.onStopError = function(event) {
  this.logError("stop error", event);
};

ChromeCastSenderProxy.prototype.logEvent = function(message, data) {
  if (message == null) {
    message = data.type || "";
  }
  this.facade.logger.log("[AMP CHROMECAST] " + message, data);
};

ChromeCastSenderProxy.prototype.logError = function(message, data) {
  this.facade.logger.error("[AMP CHROMECAST ERROR] " + message, data);
};

ChromeCastSenderProxy.prototype.loadMedia = function(startTime) {
  var media, receiverCanPlay, request, source;
  if (startTime == null) {
    startTime = 0;
  }
  media = this.facade.player.retrieveProxy(MediaProxy.NAME).getData();
  if (!(media != null)) {
    return;
  }
  receiverCanPlay = function(type) {
    if (ChromeCastConstants.SUPPORTED_TYPES.indexOf(type) > -1) {
      return "maybe";
    } else {
      return "";
    }
  };
  source = Utils.selectSource(media.source, receiverCanPlay);
  if (!(source != null)) {
    return;
  }
  request = this.mediaToLoadRequest(media, source, startTime, {
    media: media
  });
  this.session.loadMedia(request, this.onMediaDiscovered.bind(this), this.onMediaError.bind(this));
};

ChromeCastSenderProxy.prototype.mediaToLoadRequest = function(media, source, startTime, customData) {
  var index, mediaInfo, metadata, request, track, value, _i, _len, _ref, _ref1, _ref2;
  metadata = new chrome.cast.media.GenericMediaMetadata();
  metadata.title = media.title;
  metadata.subtitle = media.description;
  metadata.image = [new chrome.cast.Image(media.poster)];
  metadata.releaseDate = (_ref = media.pubDate) != null ? typeof _ref.toISOString === "function" ? _ref.toISOString() : void 0 : void 0;
  mediaInfo = new chrome.cast.media.MediaInfo(source.src, source.type);
  mediaInfo.duration = media.duration;
  mediaInfo.customData = customData;
  mediaInfo.metadata = metadata;
  if (((_ref1 = media.track) != null ? _ref1.length : void 0) > 0) {
    mediaInfo.tracks = [];
    _ref2 = media.track;
    for (index = _i = 0, _len = _ref2.length; _i < _len; index = ++_i) {
      value = _ref2[index];
      track = new chrome.cast.media.Track(index, chrome.cast.media.TrackType.TEXT);
      track.subtype = chrome.cast.media.TextTrackType.CAPTIONS;
      track.name = "Closed Captions";
      track.language = value.srclang;
      track.customData = value;
      track.trackContentId = value.src;
      track.trackContentType = value.type;
      mediaInfo.tracks.push(track);
    }
  }
  request = new chrome.cast.media.LoadRequest(mediaInfo);
  request.currentTime = startTime;
  return request;
};

ChromeCastSenderProxy.prototype.onMediaDiscovered = function(media) {
  if (this.media != null) {
    this.media.removeUpdateListener(this.mediaStatusUpdate);
  }
  this.media = media;
  this.mediaStatusUpdate = this.onMediaStatusUpdate.bind(this);
  this.media.addUpdateListener(this.mediaStatusUpdate);
  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, "chromecast");
};

ChromeCastSenderProxy.prototype.onMediaStatusUpdate = function(status) {
  this.logEvent("mediastatusupdate", status);
  this.updatePlayerState(this.media.playerState);
  this.updateDisplayTime();
  if (status === false) {
    this.stopDisplayTimeUpdate();
  }
};

ChromeCastSenderProxy.prototype.updatePlayerState = function(playerState) {
  var state;
  if (playerState === this.playerState) {
    return;
  }
  this.playerState = playerState;
  switch (this.playerState) {
    case chrome.cast.media.PlayerState.BUFFERING:
      state = PlayState.WAITING;
      break;
    case chrome.cast.media.PlayerState.PLAYING:
      state = PlayState.PLAYING;
      break;
    case chrome.cast.media.PlayerState.PAUSED:
      state = PlayState.PAUSED;
  }
  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);
  if (this.playerState === chrome.cast.media.PlayerState.PLAYING) {
    this.startDisplayTimeUpdate();
  } else {
    this.stopDisplayTimeUpdate();
  }
};

ChromeCastSenderProxy.prototype.startDisplayTimeUpdate = function() {
  this.stopDisplayTimeUpdate();
  this.displayTimeTimeout = setInterval(this.updateDisplayTime.bind(this), 100);
};

ChromeCastSenderProxy.prototype.stopDisplayTimeUpdate = function() {
  clearInterval(this.displayTimeTimeout);
  this.displayTimeTimeout = null;
};

ChromeCastSenderProxy.prototype.updateDisplayTime = function() {
  var currentTime, duration, _ref;
  currentTime = this.media.getEstimatedTime() || 0;
  duration = ((_ref = this.media.media) != null ? _ref.duration : void 0) || currentTime;
  if (duration !== this.duration) {
    this.duration = duration;
    this.sendNotification(Notifications.CHANGE_DURATION, this.duration);
    return;
  }
  if (currentTime !== this.currentTime) {
    this.currentTime = currentTime;
    this.sendNotification(Notifications.DISPLAY_TIME, {
      currentTime: this.currentTime,
      duration: this.duration
    });
  }
};

ChromeCastSenderProxy.prototype.onMediaError = function(error) {
  this.logError("media error", error);
  this.stopDisplayTimeUpdate();
};

ChromeCastSenderProxy.prototype.play = function() {
  this.media.play();
};

ChromeCastSenderProxy.prototype.pause = function() {
  this.media.pause();
};

ChromeCastSenderProxy.prototype.setCurrentTime = function(time) {
  var request;
  request = new chrome.cast.media.SeekRequest();
  request.currentTime = time;
  this.media.seek(request);
};

ChromeCastSenderProxy.prototype.getCurrentTime = function() {
  return this.currentTime;
};

ChromeCastSenderProxy.prototype.isReceiverAvailable = function() {
  return this.receiverAvailable;
};

ChromeCastSenderProxy.prototype.toggleMuted = function() {
  var request;
  this.muted = !this.muted;
  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(null, this.muted));
  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));
  this.sendNotification(Notifications.VOLUME_CHANGE, this.muted ? 0 : this.volume);
};

ChromeCastSenderProxy.prototype.getVolume = function() {
  return this.volume;
};

ChromeCastSenderProxy.prototype.setVolume = function(value, muted) {
  var request;
  if (muted == null) {
    muted = false;
  }
  if (value === this.volume && muted !== true) {
    return;
  }
  if (muted === false) {
    this.volume = value;
  }
  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(value, value === 0));
  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));
};

ChromeCastSenderProxy.prototype.onVolumeSuccess = function() {
  this.facade.logger.log("[AMP Chromecast] Volume success", this.media.volume);
};

ChromeCastSenderProxy.prototype.onVolumeError = function() {
  this.facade.logger.log("[AMP Chromecast] Volume error");
};

/**
 * The ChromeCastLaunchCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastLaunchCommand() {
  ChromeCastLaunchCommand.__super__.constructor.call(this);
}


__extends(ChromeCastLaunchCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastLaunchCommand.prototype.execute = function(notification) {
  this.proxy.launch();
};

/**
 * The ChromeCastCaptioningVisibilityChangeCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastCaptioningVisibilityChangeCommand() {
  ChromeCastCaptioningVisibilityChangeCommand.__super__.constructor.call(this);
}


__extends(ChromeCastCaptioningVisibilityChangeCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {
  this.proxy.send({
    type: "captioning.visibilitychange",
    detail: {
      visibility: notification.getBody()
    }
  });
};

/**
 * The ChromeCastCaptioningSettingsChangeCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastCaptioningSettingsChangeCommand() {
  ChromeCastCaptioningSettingsChangeCommand.__super__.constructor.call(this);
}


__extends(ChromeCastCaptioningSettingsChangeCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastCaptioningSettingsChangeCommand.prototype.execute = function(notification) {
  this.proxy.send({
    type: "captioning.settingschange",
    detail: notification.getBody()
  });
};

/**
 * The ChromeCastReceiverReadyCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastReceiverReadyCommand() {
  ChromeCastReceiverReadyCommand.__super__.constructor.call(this);
}


__extends(ChromeCastReceiverReadyCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastReceiverReadyCommand.prototype.execute = function(notification) {
  this.facade.player.getViewComponent().hidden = false;
  this.proxy.ready();
};

/**
 * The ChromeCastBreakStartCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastBreakStartCommand() {
  ChromeCastBreakStartCommand.__super__.constructor.call(this);
}


__extends(ChromeCastBreakStartCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastBreakStartCommand.prototype.execute = function(notification) {
  var playbackCore;
  this.facade.logger.debug("ChromeCastBreakStartCommand");
  playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();
  if (playbackCore.getPlaybackCoreName() === "chromecast") {
    playbackCore.unload();
    playbackCore.src = null;
  }
};

/**
 * The ChromeCastSeekCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastMediaChangeCommand() {
  ChromeCastMediaChangeCommand.__super__.constructor.call(this);
}


__extends(ChromeCastMediaChangeCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastMediaChangeCommand.prototype.execute = function(notification) {
  if (this.applicationState.getPlaybackTarget() !== "chromecast") {
    return;
  }
  this.facade.logger.debug("ChromeCastMediaChangeCommand");
  this.proxy.loadMedia();
};

/**
 * The ChromeCastChangeVolumeCommand class.
 *
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastChangeVolumeCommand() {
  ChromeCastChangeVolumeCommand.__super__.constructor.call(this);
}


__extends(ChromeCastChangeVolumeCommand, PluginCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ChromeCastChangeVolumeCommand.prototype.execute = function(notification) {
  var volume;
  volume = notification.getBody();
  this.proxy.setVolume(volume);
  this.sendNotification(Notifications.VOLUME_CHANGE, volume);
};

/**
 * ChromeCastPlaybackProxy constructor.
 *
 * @constructor
 * @private
 * @extends {PlaybackCoreProxy}
*/
function ChromeCastPlaybackProxy(types, receiver) {
  this.receiver = receiver;
  ChromeCastPlaybackProxy.__super__.constructor.call(this, types);
}


__extends(ChromeCastPlaybackProxy, PlaybackCoreProxy);


ChromeCastPlaybackProxy.prototype.initialized = true;

ChromeCastPlaybackProxy.prototype.player = null;

ChromeCastPlaybackProxy.prototype.host = null;

ChromeCastPlaybackProxy.prototype.protocol = null;

ChromeCastPlaybackProxy.prototype.playbackCoreName = "chromecast";

ChromeCastPlaybackProxy.prototype.manifest = null;

ChromeCastPlaybackProxy.prototype.xhr = null;

ChromeCastPlaybackProxy.prototype.trackInfo = null;

ChromeCastPlaybackProxy.prototype.receiver = null;

/**
 * @override
 * @private
*/
ChromeCastPlaybackProxy.prototype.reset = function() {
  ChromeCastPlaybackProxy.__super__.reset.call(this);
  this.xhr = null;
  this.manifest = null;
};

ChromeCastPlaybackProxy.prototype.unload = function() {
  if (this.player != null) {
    this.trackInfo = {
      activeTrackIds: [this.receiver.chromecastPlayer.activeTrackId],
      textTrackStyle: this.receiver.chromecastPlayer.textTrackStyle
    };
    this.receiver.chromecastPlayer.activeTrackId = null;
    this.receiver.chromecastPlayer.textTrackStyle = null;
    this.player.unload();
    this.player = null;
  }
};

/** @override
*/
ChromeCastPlaybackProxy.prototype.load = function() {
  var initStart, mediaProxy, type, types, video,
    _this = this;
  this.data.loading = true;
  this.playWhenLoaded = true;
  this.unload();
  video = this.facade.getMediaElement();
  video.once(this.resume.event, this.resume.listener);
  video.addEventListener("loadedmetadata", this.handlers.loadedmetadata);
  video.addEventListener("durationchange", this.handlers.durationchange);
  video.addEventListener("canplaythrough", this.handlers.canplaythrough);
  initStart = 0;
  if (this.facade.logger.enabled === true) {
    cast.player.api.setLoggerLevel(cast.player.api.LoggerLevel.DEBUG);
  }
  this.host = new cast.player.api.Host({
    'mediaElement': video,
    'url': this.getSrc()
  });
  this.host.updateManifestRequestInfo = function(requestInfo) {
    requestInfo.withCredentials = true;
  };
  this.host.updateSegmentRequestInfo = function(requestInfo) {
    requestInfo.withCredentials = true;
  };
  this.host.onError = function(errorCode) {
    _this.facade.logger.error("Google Media Player Fatal Error - " + errorCode);
    _this.player.unload();
  };
  mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);
  type = mediaProxy.getType();
  types = Utils.mimeTypes;
  switch (type) {
    case types.m3u8:
      this.protocol = cast.player.api.CreateHlsStreamingProtocol(this.host);
      break;
    case types.mpd:
      this.protocol = cast.player.api.CreateDashStreamingProtocol(this.host);
      break;
    case types.ism:
      this.protocol = cast.player.api.CreateSmoothStreamingProtocol(this.host);
  }
  if (this.protocol != null) {
    this.player = new cast.player.api.Player(this.host);
    this.player.load(this.protocol, initStart);
  } else {
    this.facade.logger.error("Google Media Player Error: Could not create protocol");
  }
};

/**
 * @override
*/
ChromeCastPlaybackProxy.prototype.resumecomplete = function() {
  ChromeCastPlaybackProxy.__super__.resumecomplete.call(this);
};

/**
 * The ChromeCastToggleMutedCommand class.
 *
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastToggleMutedCommand() {
  ChromeCastToggleMutedCommand.__super__.constructor.call(this);
}


__extends(ChromeCastToggleMutedCommand, PluginCommand);


/**
 * Executes the command.
 *
 * @param {puremvc.Notification} notification
 *    The notification.
 *
 * @override
*/
ChromeCastToggleMutedCommand.prototype.execute = function(notification) {
  this.proxy.toggleMuted();
};

/**
 * The ChromeCastReceiverMediator class.
 * 
 * @constructor
 * @private
 * @extends {PluginMediator}
*/
function ChromeCastReceiverMediator() {
  ChromeCastReceiverMediator.__super__.constructor.call(this);
}


__extends(ChromeCastReceiverMediator, PluginMediator);


/**
 * @override
*/
ChromeCastReceiverMediator.prototype.onRegister = function() {
  ChromeCastReceiverMediator.__super__.onRegister.call(this);
  this.sendNotification(Notifications.ADD_APPLICATION_STATE, "chromecast-receiver");
};

/**
 * The ChromeCastSenderMediator class.
 * 
 * @constructor
 * @private
 * @extends {PluginMediator}
*/
function ChromeCastSenderMediator() {
  ChromeCastSenderMediator.__super__.constructor.call(this);
}


__extends(ChromeCastSenderMediator, PluginMediator);


ChromeCastSenderMediator.prototype.componentName = "chromecast";

ChromeCastSenderMediator.prototype.controls = null;

/**
 * @override
*/
ChromeCastSenderMediator.prototype.onRegister = function() {
  ChromeCastSenderMediator.__super__.onRegister.call(this);
  this.controls = new ChromeCastControlsMediator();
};

/**
 * @override
*/
ChromeCastSenderMediator.prototype.registerOverlay = function() {};

/**
 * @override
*/
ChromeCastSenderMediator.prototype.listNotificationInterests = function() {
  return [Notifications.PLAYBACK_TARGET_CHANGE, Notifications.CHANGE_PLAY_STATE];
};

/**
 * @override
*/
ChromeCastSenderMediator.prototype.handleNotification = function(notification) {
  var body, name, target;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.PLAYBACK_TARGET_CHANGE:
      target = body.value;
      if (target === "chromecast") {
        this.facade.registerMediator(this.controls);
      } else {
        this.facade.removeMediator(this.controls.getMediatorName());
      }
      break;
    case Notifications.CHANGE_PLAY_STATE:
      this.controls.setState(body);
  }
};

/**
 * The ChromeCastSenderMediator class.
 * 
 * @constructor
 * @extends {ChromeCastSenderMediator}
 * @private
*/
function ChromeCastHTMLSenderMediator() {
  ChromeCastHTMLSenderMediator.__super__.constructor.call(this);
}


__extends(ChromeCastHTMLSenderMediator, ChromeCastSenderMediator);


ChromeCastHTMLSenderMediator.prototype.chromeCastButton = null;

/**
 * @override
*/
ChromeCastHTMLSenderMediator.prototype.onRegister = function() {
  ChromeCastHTMLSenderMediator.__super__.onRegister.call(this);
  this.chromeCastButton = new ChromeCastButtonMediator();
  this.facade.registerMediator(this.chromeCastButton);
};

/**
 * @override
*/
ChromeCastHTMLSenderMediator.prototype.listNotificationInterests = function() {
  return ChromeCastHTMLSenderMediator.__super__.listNotificationInterests.call(this).concat([ChromeCastNotifications.AVAILABILITY_CHANGE]);
};

/**
 * @override
*/
ChromeCastHTMLSenderMediator.prototype.handleNotification = function(notification) {
  var body, name;
  ChromeCastHTMLSenderMediator.__super__.handleNotification.call(this, notification);
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case ChromeCastNotifications.AVAILABILITY_CHANGE:
      if (body === true) {
        this.sendNotification(Notifications.ADD_CONTROL_STATE, "chromecast");
        this.facade.player.sendNotification(Notifications.ADD_CONTROL, this.chromeCastButton.getViewComponent());
      } else {
        this.sendNotification(Notifications.REMOVE_CONTROL_STATE, "chromecast");
        this.facade.player.sendNotification(Notifications.REMOVE_CONTROL, this.chromeCastButton.getViewComponent());
      }
  }
};

/** 
 * The ChromeCastReceiverProxy class.
 *   
 * @param {Object}  config  The plugin configuration object.
 * @constructor
 * @private
 * @extends {PluginProxy}
*/
function ChromeCastReceiverProxy(config) {
  this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;
  ChromeCastReceiverProxy.__super__.constructor.call(this, config.receiver);
}


__extends(ChromeCastReceiverProxy, PluginProxy);


/** @static
*/
ChromeCastReceiverProxy.NAME = ModuleProxy.NAME;

ChromeCastReceiverProxy.prototype.defaults = {
  shim: null,
  types: ["application/x-mpegURL", "application/dash+xml", "application/vnd.ms-sstr+xml"]
};

ChromeCastReceiverProxy.prototype.messageBus = null;

ChromeCastReceiverProxy.prototype.castReceiverManager = null;

ChromeCastReceiverProxy.prototype.castMessageBus = null;

ChromeCastReceiverProxy.prototype.startTime = 0;

ChromeCastReceiverProxy.prototype.currentTime = 0;

ChromeCastReceiverProxy.prototype.boundHandler = null;

ChromeCastReceiverProxy.prototype.amp = null;

ChromeCastReceiverProxy.prototype.mediaManager = null;

ChromeCastReceiverProxy.prototype.playbackCore = null;

ChromeCastReceiverProxy.prototype.teardownTimeout = null;

ChromeCastReceiverProxy.prototype.chromecastPlayer = null;

ChromeCastReceiverProxy.prototype.initialize = function() {
  var core, player;
  ChromeCastReceiverProxy.__super__.initialize.call(this);
  this.sendNotification(Notifications.INITIALIZED);
  core = new ChromeCastPlaybackProxy(this.getConfigurationData().types, this);
  player = this.facade.player.retrieveProxy(PlayerProxy.NAME);
  player.registerPlaybackCore(core);
};

ChromeCastReceiverProxy.prototype.ready = function() {
  if (this.facade.logger.enabled === true) {
    cast.receiver.logger.setLevelValue(cast.receiver.LoggerLevel.DEBUG);
  }
  this.shim = ChromeCastShim.getInstance();
  this.castReceiverManager = this.shim.castReceiverManager;
  this.castReceiverManager.onReady = this.castReceiverManager.onSystemVolumeChanged = this.castReceiverManager.onVisibilityChanged = this.logEvent.bind(this);
  this.castReceiverManager.onSenderConnected = this.onSenderConnected.bind(this);
  this.castReceiverManager.onSenderDisconnected = this.onSenderDisconnected.bind(this);
  this.amp = this.facade.player;
  this.chromecastPlayer = this.shim.player;
  this.chromecastPlayer.registerPlayer(this.amp);
  this.mediaManager = this.shim.mediaManager;
  this.castMessageBus = this.shim.castMessageBuses[this.messageBus];
  this.castMessageBus.onMessage = this.onMessage.bind(this);
  this.amp.addEventListener("seeking", this.eventHandler.bind(this));
  this.amp.addEventListener("seeked", this.eventHandler.bind(this));
  this.amp.addEventListener("pause", this.startTeardownTimeout.bind(this, 20 * 60));
  this.amp.addEventListener("ended", this.startTeardownTimeout.bind(this, 5 * 60));
  this.amp.addEventListener("error", this.startTeardownTimeout.bind(this, 5 * 60));
  this.amp.addEventListener("playing", this.stopTeardownTimeout.bind(this));
  this.amp.addEventListener("loadedmetadata", this.stopTeardownTimeout.bind(this));
  if (this.amp.ads != null) {
    this["amp"].ads.addEventListener("breakstart", this.dispatchEvent.bind(this, "ads"));
    this["amp"].ads.addEventListener("breakend", this.onBreakEnd.bind(this));
    this["amp"].ads.addEventListener("started", this.dispatchEvent.bind(this, "ads"));
    this["amp"].ads.addEventListener("ended", this.dispatchEvent.bind(this, "ads"));
    this["amp"].ads.addEventListener("companion", this.dispatchEvent.bind(this, "ads"));
  }
  this.startTeardownTimeout(5 * 60);
};

ChromeCastReceiverProxy.prototype.onBreakEnd = function(event) {
  this.dispatchEvent("ads", event);
  if (this.amp.getEnded() === true) {
    this.startTeardownTimeout(5 * 60);
  }
};

ChromeCastReceiverProxy.prototype.logEvent = function(message, data) {
  if (!(message != null)) {
    message = data.type || "";
  } else if (!(data != null)) {
    data = message.data;
    message = data.type;
  }
  this.facade.logger.log("[CHROMECAST] ", message, data);
};

ChromeCastReceiverProxy.prototype.onSenderConnected = function(event) {
  this.logEvent("senderconnected", event);
  setTimeout(this.sendNotification.bind(this, Notifications.DISPATCH_EVENT, new Event("senderconnected", event)), 0);
};

ChromeCastReceiverProxy.prototype.onSenderDisconnected = function(event) {
  this.logEvent("sender disconnected", event);
  if (this.castReceiverManager.getSenders().length === 0 && event.reason === cast.receiver.system.DisconnectReason.REQUESTED_BY_SENDER) {
    this.teardown();
  }
  setTimeout(this.sendNotification.bind(this, Notifications.DISPATCH_EVENT, new Event("senderdisconnected", event)), 0);
};

ChromeCastReceiverProxy.prototype.onMessage = function(event) {
  var detail, ids, message, textTrackStyle, type;
  this.logEvent("message from sender", event);
  try {
    message = event.data || event.message;
    if (!(message != null)) {
      return;
    }
    type = message.type;
    detail = message.detail;
    if (typeof detail === "string") {
      detail = JSON.parse(detail);
    }
    if (!(detail != null)) {
      return;
    }
    switch (type) {
      case "captioning.visibilitychange":
        ids = [];
        if (detail.visibility === true) {
          ids.push(0);
        }
        this.chromecastPlayer.editTracksInfo({
          activeTrackIds: ids
        });
        break;
      case "captioning.settingschange":
        textTrackStyle = new cast.receiver.media.TextTrackStyle();
        textTrackStyle.foregroundColor = detail.fontColor;
        textTrackStyle.backgroundColor = detail.backgroundColor;
        textTrackStyle.fontScale = detail.size;
        textTrackStyle.windowColor = detail.windowColor;
        textTrackStyle.fontFamily = detail.fontFamily;
        textTrackStyle.edgeColor = detail.edgeColor;
        textTrackStyle.edgeType = detail.edgeType;
        this.chromecastPlayer.editTracksInfo({
          textTrackStyle: textTrackStyle
        });
        break;
      case "stats.visibilitychange":
        this["amp"].stats.setHidden(!detail.visibility);
    }
    this.sendNotification(Notifications.DISPATCH_EVENT, event);
  } catch (error) {
    this.error(error);
  }
};

ChromeCastReceiverProxy.prototype.onClose = function(event) {
  this.logEvent("message channel closed", event);
};

ChromeCastReceiverProxy.prototype.eventHandler = function(event) {
  var msg;
  msg = {
    type: event.type
  };
  if (event.detail != null) {
    msg.detail = event.detail;
  }
  this.send(msg);
};

ChromeCastReceiverProxy.prototype.dispatchEvent = function(target, event) {
  this.send({
    type: "dispatchevent",
    detail: {
      target: target,
      event: {
        type: event.type,
        detail: event.detail
      }
    }
  });
};

ChromeCastReceiverProxy.prototype.send = function(message) {
  this.castMessageBus.broadcast(message);
};

ChromeCastReceiverProxy.prototype.startTeardownTimeout = function(seconds) {
  this.stopTeardownTimeout();
  this.teardownTimeout = setTimeout(this.teardown.bind(this), seconds * 1000);
};

ChromeCastReceiverProxy.prototype.stopTeardownTimeout = function() {
  clearTimeout(this.teardownTimeout);
};

ChromeCastReceiverProxy.prototype.teardown = function() {
  window.close();
};

/**
 * The ChromeCastFeedChangedCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastFeedChangedCommand() {
  ChromeCastFeedChangedCommand.__super__.constructor.call(this);
}


__extends(ChromeCastFeedChangedCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastFeedChangedCommand.prototype.execute = function(notification) {
  var _base;
  if (typeof (_base = this.proxy).setFeed === "function") {
    _base.setFeed(notification.getBody());
  }
};

/**
 * The ChromeCastSeekCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastSeekCommand() {
  ChromeCastSeekCommand.__super__.constructor.call(this);
}


__extends(ChromeCastSeekCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastSeekCommand.prototype.execute = function(notification) {
  this.facade.logger.debug("ChromeCastSeekCommand");
  this.plugin.setCurrentTime(notification.getBody());
};

/**
 * @constructor
 * @private
 * @extends {contextMenuMediator}
*/
function contextMenuMediator() {
  contextMenuMediator.__super__.constructor.call(this);
}


__extends(contextMenuMediator, OverlayMediator);


contextMenuMediator.prototype.componentName = "context-menu";

contextMenuMediator.prototype.contextMenu = null;

/**
 * @override
*/
contextMenuMediator.prototype.onRegister = function() {
  var _this = this;
  contextMenuMediator.__super__.onRegister.call(this);
  EventHandler.create(this.facade.player.viewComponent, EventHandler.CONTEXTMENU, function(event) {
    event.preventDefault();
    _this.contextMenuHandler(event);
    return false;
  });
};

/** Context Menu Click Handler
*/
contextMenuMediator.prototype.contextMenuHandler = function(event) {
  var id, item,
    _this = this;
  if (this.contextMenu) {
    this.removeContextMenu();
  }
  this.contextMenu = UI.create("context-menu", document.body, "ul");
  UI.create("context-item", this.contextMenu, "li", this.facade.player.getVersion());
  if (typeof akamaiGetViewerId !== "undefined" && akamaiGetViewerId !== null) {
    id = akamaiGetViewerId();
    item = UI.create("context-item", this.contextMenu, "li", "" + (this.localizationManager.getString("MSG_VIEWER_ID") || "Viewer ID: "));
    UI.create("selectable", item, "span", "" + (id != null ? id : "N/A"));
  }
  this.contextMenu.style.top = event.pageY + "px";
  this.contextMenu.style.left = event.pageX + "px";
  EventHandler.create(document.body, EventHandler.CLICK, function(event) {
    if (/selectable/.test(event.target.className)) {
      return false;
    }
    _this.removeContextMenu(event);
    return false;
  });
};

/** Remove ContextMenu Handler and DOM Object
*/
contextMenuMediator.prototype.removeContextMenu = function(event) {
  try {
    EventHandler.clear(document.body, EventHandler.CLICK);
    document.body.removeChild(this.contextMenu);
    this.contextMenu = null;
  } catch (_error) {}
};

/**
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function TitleBarMediator() {
  TitleBarMediator.__super__.constructor.call(this);
}


__extends(TitleBarMediator, OverlayMediator);


TitleBarMediator.prototype.componentName = "title-bar";

TitleBarMediator.prototype.title = null;

TitleBarMediator.prototype.description = null;

/**
 * @override
*/
TitleBarMediator.prototype.onRegister = function() {
  TitleBarMediator.__super__.onRegister.call(this);
  this.title = this.create("title-text");
  this.description = this.create("description-text");
};

/**
 * @override
*/
TitleBarMediator.prototype.listNotificationInterests = function() {
  return [Notifications.CHANGE_MEDIA];
};

/**
 * @override
*/
TitleBarMediator.prototype.handleNotification = function(notification) {
  var metadata, title;
  switch (notification.getName()) {
    case Notifications.CHANGE_MEDIA:
      metadata = notification.getBody();
      title = this.facade.player.evaluateBinding(metadata.title);
      if (!(title != null) || title === "" || title === "undefined") {
        this.classList.add("hidden");
      } else {
        this.title.innerHTML = title;
        this.description.innerHTML = metadata.description ? metadata.description : "";
        this.classList.remove("hidden");
      }
  }
};

/**
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function ReplayOverlayMediator() {
  ReplayOverlayMediator.__super__.constructor.call(this);
}


__extends(ReplayOverlayMediator, OverlayMediator);


ReplayOverlayMediator.prototype.componentName = "replay";

ReplayOverlayMediator.prototype.replay = null;

ReplayOverlayMediator.prototype.icon = null;

ReplayOverlayMediator.prototype.label = null;

/**
 * @override
*/
ReplayOverlayMediator.prototype.onRegister = function() {
  ReplayOverlayMediator.__super__.onRegister.call(this);
  this.replay = this.create("replay-button");
  this.replay.onclick = this.onclick.bind(this);
  this.icon = this.create("replay-icon", this.replay);
  this.label = this.createText("replay-label", this.localizationManager.getString(LocalizationConstants.MSG_REPLAY), this.replay);
};

/**
*/
ReplayOverlayMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  this.sendNotification(Notifications.REPLAY);
  return false;
};

/**
 * @enum {string}
 * @const
 * @private
*/

var FeedNotifications = {
  LOAD_FEED: "loadfeed",
  FEED_CHANGED: "feedchanged",
  FEED_LOADED: "feedloaded",
  FEED_ERROR: "feederror"
};

/**
 * ErrorLayerMediator class.
 *
 * @constructor
 * @extends {LayerMediator}
 * @private
*/
function ErrorLayerMediator() {
  ErrorLayerMediator.__super__.constructor.call(this);
}


__extends(ErrorLayerMediator, LayerMediator);


ErrorLayerMediator.prototype.message = null;

ErrorLayerMediator.prototype.componentName = "error";

/**
 * @override
*/
ErrorLayerMediator.prototype.onRegister = function() {
  ErrorLayerMediator.__super__.onRegister.call(this);
  this.message = this.create("error-message");
};

/**
 * @override
*/
ErrorLayerMediator.prototype.listNotificationInterests = function() {
  return [Notifications.ERROR];
};

/**
 * @override
*/
ErrorLayerMediator.prototype.handleNotification = function(notification) {
  var error, msg;
  switch (notification.getName()) {
    case Notifications.ERROR:
      error = notification.getBody();
      msg = /^(Error: )/.test(error.toString()) ? "" : "Error: ";
      switch (error.code) {
        case MediaError.MEDIA_ERR_ABORTED:
          msg += "Media was aborted.";
          break;
        case MediaError.MEDIA_ERR_DECODE:
          msg += "Decode Error.";
          break;
        case MediaError.MEDIA_ERR_NETWORK:
          msg += "Network Error.";
          break;
        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
          msg += "Source not supported.";
          break;
        default:
          msg += error;
      }
      this.message.textContent = msg;
  }
};

/** 
 * @constructor
 * @extends {OverlayMediator}
 * @private
*/
function LoadingOverlayMediator() {
  LoadingOverlayMediator.__super__.constructor.call(this);
}


__extends(LoadingOverlayMediator, OverlayMediator);


LoadingOverlayMediator.prototype.componentName = "loading";

/**
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function WaitingOverlayMediator() {
  WaitingOverlayMediator.__super__.constructor.call(this);
}


__extends(WaitingOverlayMediator, OverlayMediator);


WaitingOverlayMediator.prototype.componentName = "waiting";

WaitingOverlayMediator.prototype.bar = null;

WaitingOverlayMediator.prototype.text = null;

WaitingOverlayMediator.prototype.onRegister = function() {
  WaitingOverlayMediator.__super__.onRegister.call(this);
  this.bar = this.create("waiting-bar");
  this.text = this.createText("waiting-text", this.localizationManager.getString(LocalizationConstants.MSG_BUFFERING));
};

/**
 * @constructor
 * @private
 * @extends {LayerMediator}
*/
function PosterMediator() {
  PosterMediator.__super__.constructor.call(this);
}


__extends(PosterMediator, OverlayMediator);


PosterMediator.prototype.componentName = "poster";

PosterMediator.prototype.poster = null;

PosterMediator.prototype.clickHandler = null;

/**
 * @override
*/
PosterMediator.prototype.onRegister = function() {
  PosterMediator.__super__.onRegister.call(this);
  this.poster = this.create("poster-content");
  this.poster.onclick = this.onclick.bind(this);
};

/**
*/
PosterMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  event.preventDefault();
  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);
  return false;
};

/**
 * @override
*/
PosterMediator.prototype.listNotificationInterests = function() {
  return [Notifications.SET_MEDIA];
};

/**
 * @override
*/
PosterMediator.prototype.handleNotification = function(notification) {
  var html, src;
  switch (notification.getName()) {
    case Notifications.SET_MEDIA:
      src = notification.getBody().poster;
      html = (src != null) && src !== "" ? "<img src=\"" + src + "\" class=\"" + this.cssPrefix + "poster-image\" />" : "";
      this.poster.innerHTML = html;
  }
};

/**
*/
/**
 * @constructor
 * @private
*/
function EndSlateMediator() {
  EndSlateMediator.__super__.constructor.call(this);
}


__extends(EndSlateMediator, OverlayMediator);


EndSlateMediator.prototype.componentName = "end-slate";

/**
 * @override
*/
EndSlateMediator.prototype.onRegister = function() {
  if (this.facade.config.endslate != null) {
    EndSlateMediator.__super__.onRegister.call(this);
  }
};

EndSlateMediator.prototype.listNotificationInterests = function() {
  return [Notifications.MEDIA_CHANGE];
};

EndSlateMediator.prototype.handleNotification = function(notification) {
  var endslate, html, media, src, viewComponent;
  switch (notification.getName()) {
    case Notifications.MEDIA_CHANGE:
      media = notification.getBody();
      endslate = this.facade.config.endslate;
      viewComponent = this.getViewComponent();
      html = "";
      if (endslate != null) {
        src = endslate.usePoster === true ? media.poster : endslate.url;
        if ((src != null) && src !== "") {
          html = "<img src=\"" + src + "\" class=\"end-slate-image\" />";
        }
      }
      if (viewComponent != null) {
        viewComponent.innerHTML = html;
      }
  }
};

/**
 * @constructor
 * @private
*/
function ButtonMediator(labelText, parent, element, componentName, onclick) {
  this.labelText = labelText;
  this.onclick = onclick != null ? onclick : this.onclick;
  ButtonMediator.__super__.constructor.call(this, componentName, null, parent, element);
}


__extends(ButtonMediator, ComponentMediator);


ButtonMediator.prototype.componentType = "button";

ButtonMediator.prototype.icon = null;

ButtonMediator.prototype.label = null;

ButtonMediator.prototype.onclick = null;

ButtonMediator.prototype.labelText = null;

ButtonMediator.prototype.onRegister = function() {
  ButtonMediator.__super__.onRegister.call(this);
  this.icon = this.create("icon");
  this.createLabel(this.labelText);
};

ButtonMediator.prototype.createLabel = function(label) {
  if (label != null) {
    this.label = this.createText("label", label);
  }
};

ButtonMediator.prototype.setLabel = function(value) {
  if (!(this.label != null)) {
    this.createLabel(value);
  } else {
    this.label.textContent = value;
  }
  return value;
};

ButtonMediator.prototype.getLabel = function() {
  var _ref;
  return (_ref = this.label) != null ? _ref.textContent : void 0;
};

/**
 * The LogoMediator class.
 * 
 * @constructor
 * @private
 * @extends {LocalizedMediator}
 * @param {Object} viewComponent
*/
function LogoMediator(parent) {
  LogoMediator.__super__.constructor.call(this, null, null, parent);
}


__extends(LogoMediator, ComponentMediator);


/**
 * The name of the this Mediator.
 * 
 * @static
 * @type {string}
*/
LogoMediator.prototype.componentName = "logo";

LogoMediator.prototype.url = null;

/**
 * @override
*/
LogoMediator.prototype.onRegister = function() {
  LogoMediator.__super__.onRegister.call(this);
  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + "-enabled");
};

LogoMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  this.sendNotification(Notifications.DISPATCH_EVENT, new Event("controlsLogoClicked"));
  return false;
};

/**
 * The FullScreenMediator class.
 *
 * @constructor
 * @private
 * @extends {ModuleMediator}
 * @param {Object} viewComponent
*/
function FullScreenMediator(parent) {
  FullScreenMediator.__super__.constructor.call(this, null, parent);
}


__extends(FullScreenMediator, ButtonMediator);


FullScreenMediator.prototype.componentName = "full-screen";

FullScreenMediator.prototype.onRegister = function() {
  FullScreenMediator.__super__.onRegister.call(this);
  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + "-enabled");
};

FullScreenMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  this.sendNotification(Notifications.TOGGLE_FULL_SCREEN);
  return false;
};

/**
 * @override
*/
FullScreenMediator.prototype.listNotificationInterests = function() {
  return [Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN];
};

/**
 * @override
*/
FullScreenMediator.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.DISABLE_FULL_SCREEN:
      this.setDisabled(true);
      break;
    case Notifications.ENABLE_FULL_SCREEN:
      this.setDisabled(false);
  }
};

/**
 * The VolumeMediator class.
 *
 * @constructor
 * @private
 * @extends {ModuleMediator}
 * @param {Object} viewComponent
*/
function SliderMediator(parent, direction) {
  this.direction = direction != null ? direction : this.direction;
  SliderMediator.__super__.constructor.call(this, null, null, parent);
}


__extends(SliderMediator, ComponentMediator);


SliderMediator.prototype.componentType = "slider";

SliderMediator.prototype.trackView = null;

SliderMediator.prototype.handleView = null;

SliderMediator.prototype.valueView = null;

SliderMediator.prototype.startCapView = null;

SliderMediator.prototype.endCapView = null;

SliderMediator.prototype.clickView = null;

SliderMediator.prototype.min = 0;

SliderMediator.prototype.max = 1;

SliderMediator.prototype.value = 0;

SliderMediator.prototype.draggable = false;

SliderMediator.prototype.dragging = false;

SliderMediator.prototype.draggingInterval = null;

SliderMediator.prototype.draggingDelay = 250;

SliderMediator.prototype.direction = "vertical";

SliderMediator.prototype.pressHandler = null;

SliderMediator.prototype.releaseHandler = null;

SliderMediator.prototype.moveHandler = null;

SliderMediator.prototype.clickHandler = null;

/**
 * @override
*/
SliderMediator.prototype.onRegister = function() {
  SliderMediator.__super__.onRegister.call(this);
  this.startCapView = this.create("start-cap");
  this.endCapView = this.create("end-cap");
  this.trackView = this.create("track");
  this.valueView = this.create("value", this.trackView);
  this.clickView = this.create("click", this.trackView);
  this.handleView = this.create("handle", this.trackView);
  this.pressHandler = EventHandler.create(this.handleView, EventHandler.PRESS, this.handlePressHandler.bind(this));
  this.releaseHandler = EventHandler.create(window, EventHandler.RELEASE, this.handleReleaseHandler.bind(this));
  this.releaseHandler.unbind();
  this.moveHandler = EventHandler.create(window, EventHandler.MOVE, this.updateHandler.bind(this, this.draggable));
  this.moveHandler.unbind();
  this.clickHandler = EventHandler.create(this.clickView, EventHandler.CLICK, this.updateHandler.bind(this, true));
};

/** sets the value
*/
SliderMediator.prototype.setDirection = function(value) {
  this.direction = value;
  return value;
};

SliderMediator.prototype.getDirection = function() {
  return this.direction;
};

/** sets the value
*/
SliderMediator.prototype.setValue = function(value) {
  this.updateValue(value);
  this.valueChanged();
  return value;
};

SliderMediator.prototype.getValue = function() {
  return this.value;
};

SliderMediator.prototype.setDragging = function(value) {
  if (value === this.dragging) {
    return;
  }
  this.dragging = value;
  this.sendNotification(Notifications.IS_USER_ACTIVE, this.dragging);
  if (this.dragging === true) {
    this.draggingInterval = setInterval(this.valueChanged.bind(this), this.draggingDelay);
  } else {
    clearInterval(this.draggingInterval);
    this.valueChanged();
  }
  return this.dragging;
};

SliderMediator.prototype.getDragging = function() {
  return this.dragging;
};

SliderMediator.prototype.setDraggable = function(value) {
  if (value === this.draggable) {
    return;
  }
  this.draggable = value;
  return value;
};

SliderMediator.prototype.getDraggable = function() {
  return this.draggable;
};

/** updates the view
*/
SliderMediator.prototype.updateValue = function(value, force) {
  var handle;
  if (force == null) {
    force = false;
  }
  if (value === this.value && force === false) {
    return;
  }
  this.value = Utils.clamp(value, this.min, this.max);
  if (this.direction === "vertical") {
    value = "height";
    handle = "bottom";
  } else {
    value = "width";
    handle = "left";
  }
  this.valueView.style[value] = this.handleView.style[handle] = "" + (this.value * 100) + "%";
};

/** calculates the value based on mouse/touch point
*/
SliderMediator.prototype.calculateValue = function(event) {
  var offset, pos, value;
  pos = {
    x: (event.pageX - (window.scrollX || window.pageXOffset)) || (event.targetTouches[0].pageX - window.scrollX),
    y: (event.pageY - (window.scrollY || window.pageYOffset)) || (event.targetTouches[0].pageY - window.scrollY)
  };
  offset = Utils.getElementOffset(this.viewComponent);
  if (this.getDirection() === "vertical") {
    value = 1 - ((pos.y - offset.top) / offset.height);
  } else {
    value = (pos.x - offset.left) / offset.width;
  }
  return Utils.clamp(value, 0, 1);
};

SliderMediator.prototype.blockEvent = function(event) {
  if (!(event != null)) {
    return;
  }
  event.stopImmediatePropagation();
  event.preventDefault();
};

SliderMediator.prototype.handlePressHandler = function(event) {
  this.moveHandler.bind();
  this.releaseHandler.bind();
  this.clickHandler.unbind();
  this.setDragging(true);
  this.blockEvent(event);
  return false;
};

SliderMediator.prototype.handleReleaseHandler = function(event) {
  this.moveHandler.unbind();
  this.releaseHandler.unbind();
  this.clickHandler.bind();
  this.setDragging(false);
  this.blockEvent(event);
  return false;
};

SliderMediator.prototype.updateHandler = function(setValue, event) {
  var value;
  this.blockEvent(event);
  value = /click/.test(event.type) && this.classList.contains('scrubbing') ? this.getValue() : this.calculateValue(event);
  if (setValue === true) {
    this.setValue(value);
  } else {
    this.updateValue(value);
  }
  return false;
};

SliderMediator.prototype.valueChanged = function() {};

/**
 * @enum {string}
 * @const
 * @private
*/

var PanelNotifications = {
  ADD_PANEL: "addPanel",
  REMOVE_PANEL: "removePanel",
  OPEN_PANEL: "openPanel",
  CLOSE_PANEL: "closePanel",
  TOGGLE_PANEL: "togglePanel",
  CLOSE_ALL_PANELS: "closeAllPanels"
};

/**
 * The TimeDisplayMediator class.
 *
 * @constructor
 * @private
 * @extends {LocalizedMediator}
 * @param {Object} viewComponent
*/
function TimeDisplayMediator(parent) {
  TimeDisplayMediator.__super__.constructor.call(this, null, null, parent);
}


__extends(TimeDisplayMediator, ComponentMediator);


/**
 * The name of the this Mediator.
 *
 * @static
 * @type {string}
*/
TimeDisplayMediator.prototype.componentName = "time-display";

TimeDisplayMediator.prototype.duration = null;

TimeDisplayMediator.prototype.currentTimeDisplay = null;

TimeDisplayMediator.prototype.separatorDisplay = null;

TimeDisplayMediator.prototype.durationDisplay = null;

TimeDisplayMediator.prototype.liveDisplay = null;

/**
 * @override
*/
TimeDisplayMediator.prototype.onRegister = function() {
  TimeDisplayMediator.__super__.onRegister.call(this);
  this.liveDisplay = this.createText("live-display", this.localizationManager.getString(LocalizationConstants.MSG_LIVE));
  this.currentTimeDisplay = this.createText("current-time-display", "00:00", this, "span");
  this.separatorDisplay = this.createText("separator-display", this.localizationManager.getString(LocalizationConstants.MSG_TIME_SEPARATOR), this, "span");
  this.durationDisplay = this.createText("duration-display", "00:00", this, "span");
};

/**
 * @override
*/
TimeDisplayMediator.prototype.listNotificationInterests = function() {
  return [Notifications.PLAY, Notifications.DURATION_CHANGE, Notifications.ENDED, Notifications.DISPLAY_TIME];
};

/**
 * @override
*/
TimeDisplayMediator.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.PLAY:
      this.updateDuration();
      break;
    case Notifications.DURATION_CHANGE:
      this.updateCurrentTime();
      this.updateDuration(body);
      break;
    case Notifications.ENDED:
      this.updateCurrentTime(this.duration);
      this.updateDuration();
      break;
    case Notifications.DISPLAY_TIME:
      this.updateCurrentTime(body.currentTime, body.duration);
      this.updateDuration(body.duration);
  }
};

TimeDisplayMediator.prototype.updateCurrentTime = function(currentTime, duration) {
  if (currentTime != null) {
    this.currentTime = currentTime;
  }
  if (duration != null) {
    this.duration = duration;
  }
  this.currentTimeDisplay.textContent = Utils.formatTimecode(this.currentTime, this.duration);
};

TimeDisplayMediator.prototype.updateDuration = function(duration) {
  if (duration != null) {
    this.duration = duration;
  }
  this.durationDisplay.textContent = Utils.formatTimecode(this.duration);
};

/**
 * The PlayPauseMediator class.
 *
 * @constructor
 * @private
 * @extends {ButtonMediator}
*/
function GoLiveMediator(parent) {
  GoLiveMediator.__super__.constructor.call(this, null, parent);
}


__extends(GoLiveMediator, ButtonMediator);


GoLiveMediator.prototype.componentName = "go-live";

GoLiveMediator.prototype.onRegister = function() {
  GoLiveMediator.__super__.onRegister.call(this);
  this.createLabel(this.localizationManager.getString("MSG_LIVE"));
};

/**
 * @override
*/
GoLiveMediator.prototype.listNotificationInterests = function() {
  return [Notifications.IS_LIVE];
};

/**
 * @override
*/
GoLiveMediator.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.IS_LIVE:
      this.setLabel(body === true ? this.localizationManager.getString("MSG_LIVE") : this.localizationManager.getString("MSG_GO_LIVE"));
  }
};

/**
*/
GoLiveMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  event.preventDefault();
  this.sendNotification(UserNotifications.GO_LIVE);
  return false;
};

/**
 * @constructor
 * @private
 * @extends {OverlayMediator}
*/
function AdMediator() {
  AdMediator.__super__.constructor.call(this);
}


__extends(AdMediator, OverlayMediator);


AdMediator.prototype.duration = null;

AdMediator.prototype.currentTime = null;

AdMediator.prototype.container = null;

AdMediator.prototype.banner = null;

AdMediator.prototype.text = null;

AdMediator.prototype.adText = null;

AdMediator.prototype.bg = null;

AdMediator.prototype.totalAds = null;

AdMediator.prototype.adPosition = null;

AdMediator.prototype.adContainerRequired = true;

AdMediator.prototype.componentName = "ads";

/**
 * @override
*/
AdMediator.prototype.onRegister = function() {
  AdMediator.__super__.onRegister.call(this);
  if (this.adContainerRequired) {
    this.container = this.create("ad-container");
  }
  this.banner = this.create("ad-banner");
  this.bg = this.create("ad-text-bg", this.banner);
  this.adText = this.create("ad-text-title", this.banner);
  this.text = this.create("ad-text", this.banner);
  if (this.adContainerRequired) {
    this.viewComponent.container = this.container;
  }
  this.sendNotification(AdNotifications.AD_CONTAINER_CREATED, this.viewComponent);
};

/**
 * @override
*/
AdMediator.prototype.listNotificationInterests = function() {
  return [AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED];
};

/**
 * @override
*/
AdMediator.prototype.handleNotification = function(notification) {
  var adVO, msg, time;
  switch (notification.getName()) {
    case AdNotifications.BREAK_END:
      this.text.textContent = "";
      this.adText.textContent = "";
      break;
    case AdNotifications.AD_TIME_REMAINING:
      time = Math.round(notification.getBody());
      if ((this.totalAds != null) && this.totalAds > 0 && (this.adPosition != null) && this.adPosition !== this.totalAds) {
        msg = time > 0 ? "" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_AD)) + time + " " + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : "";
      } else {
        msg = time > 0 ? "" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_VIDEO)) + time + " " + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : "";
      }
      this.text.textContent = msg;
      break;
    case AdNotifications.AD_STARTED:
      adVO = notification.getBody();
      this.totalAds = adVO.totalAds;
      this.adPosition = adVO.position;
      msg = "Ad " + adVO.position + " of " + adVO.totalAds;
      if ((adVO.position != null) && (adVO.totalAds != null) && adVO.totalAds >= 1) {
        this.adText.textContent = msg;
      }
  }
};

/**
 * The PanelControlMediator class.
 *
 * @constructor
 * @private
 * @extends {ButtonMediator}
*/
function PanelControlMediator(componentName) {
  PanelControlMediator.__super__.constructor.call(this, null, null, null, componentName, onclick);
}


__extends(PanelControlMediator, ButtonMediator);


PanelControlMediator.prototype.panel = null;

PanelControlMediator.prototype.timeout = null;

PanelControlMediator.prototype.closePanelDelayed = null;

/**
 * @override
*/
PanelControlMediator.prototype.onRegister = function() {
  this.closePanelDelayed = this.delayedClosePanel.bind(this);
  if (Utils.getDevice() === "desktop") {
    this.onmouseleave = this.closePanelDelayed;
    this.onmouseenter = this.openPanel;
    this.onclick = this.clickHandler;
  } else {
    this.onclick = this.togglePanel;
  }
  PanelControlMediator.__super__.onRegister.call(this);
  this.sendNotification(Notifications.ADD_CONTROL_STATE, "" + this.componentName + "-enabled");
  this.sendNotification(Notifications.ADD_CONTROL, this.viewComponent);
};

PanelControlMediator.prototype.openPanel = function() {
  clearTimeout(this.timeout);
  this.sendNotification(PanelNotifications.OPEN_PANEL, this.panel);
  this.panel.viewComponent.addEventListener("mouseleave", this.closePanelDelayed);
};

PanelControlMediator.prototype.closePanel = function() {
  if (Utils.isMouseOverElement(this.panel.viewComponent) || Utils.isMouseOverElement(this.viewComponent) || this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getIsUserActive()) {
    return;
  }
  this.panel.viewComponent.addEventListener("mouseleave", this.closePanelDelayed);
  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);
};

PanelControlMediator.prototype.delayedClosePanel = function() {
  this.timeout = setTimeout(this.closePanel.bind(this), 350);
};

PanelControlMediator.prototype.togglePanel = function(event) {
  event.stopImmediatePropagation();
  this.sendNotification(PanelNotifications.TOGGLE_PANEL, this.panel);
};

PanelControlMediator.prototype.clickPanel = function() {};

/**
 * The PlayPauseMediator class.
 * 
 * @constructor
 * @private
 * @extends {ButtonMediator}
*/
function PanelMediator(componentName) {
  PanelMediator.__super__.constructor.call(this, componentName, null, null, null);
}


__extends(PanelMediator, ComponentMediator);


PanelMediator.prototype.componentType = "panel";

PanelMediator.prototype.control = null;

/**
 * @override
*/
PanelMediator.prototype.onRegister = function() {
  PanelMediator.__super__.onRegister.call(this);
  this.sendNotification(PanelNotifications.ADD_PANEL, this);
};

/**
 * The CaptioningMediator class.
 *
 * @constructor
 * @private
 * @extends {PluginMediator}
 * @param {Object} viewComponent
*/
function CaptionsMediator(viewComponent) {
  CaptionsMediator.__super__.constructor.call(this, viewComponent);
}


__extends(CaptionsMediator, PluginMediator);


CaptionsMediator.prototype.componentName = "captioning";

CaptionsMediator.prototype.captionButton = null;

/**
 * @override
*/
CaptionsMediator.prototype.onRegister = function() {
  var button;
  this.captioning = this.facade.player.captioning;
  button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent, null, "caption", this.onclick.bind(this));
  this.facade.registerMediator(button);
  this.captionButton = button.getViewComponent();
  this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);
  CaptionsMediator.__super__.onRegister.call(this);
};

/**
*/
CaptionsMediator.prototype.onclick = function(event) {
  var _ref;
  event.stopImmediatePropagation();
  if (((_ref = this.captioning.getTrack()) != null ? _ref.type : void 0) === "embedded") {
    this.captioning.setHidden(!this.captioning.getHidden());
  } else if (event.currentTarget === this.captionButton) {
    this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, this.captioning.getHidden());
  }
  return false;
};

/**
 * The CaptioningSettingsMediator class.
 *
 * @constructor
 * @private
 * @extends {LocalizedMediator}
 * @param {Object} viewComponent
*/
function CaptionsSettingsMediator(viewComponent) {
  this.list = {
    font: null,
    language: null,
    edge: null,
    size: null,
    scroll: null
  };
  this.picker = {
    color: null,
    background: null,
    edge: null,
    window: null
  };
  this.toggle = {
    ON: null,
    OFF: null,
    disabled: false
  };
  this.captioningObject = {
    "default": {
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "small",
      scroll: "popout",
      fontColor: "rgba(255,255,255,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0, 0, 0, 0)",
      backgroundColor: "rgba(0,0,0,0)",
      windowColor: "rgba(0,0,0,0.5)"
    },
    appliedStyleText: "",
    selected: {
      fontFamily: null,
      size: null,
      fontColor: null,
      edgeType: null,
      edgeColor: null,
      backgroundColor: null,
      windowColor: null
    },
    preset1: {
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "medium",
      fontColor: "rgba(255,255,255,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0, 0, 0, 0)",
      backgroundColor: "rgba(0,0,0,0)",
      windowColor: "rgba(0,0,0,0)"
    },
    preset2: {
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "medium",
      fontColor: "rgba(255,255,0,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0, 0, 0, 0)",
      backgroundColor: "rgba(0,0,0,0)",
      windowColor: "rgba(0,0,0,0)"
    },
    preset3: {
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "medium",
      fontColor: "rgba(255,255,255,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0, 0, 0, 0)",
      backgroundColor: "rgba(0,0,0,1)",
      windowColor: "rgba(0,0,0,0)"
    },
    preset4: {
      fontFamily: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace",
      size: "medium",
      fontColor: "rgba(255,255,0,1)",
      edgeType: "text-shadow: 0px 0px 0px",
      edgeColor: "rgba(0, 0, 0, 1)",
      backgroundColor: "rgba(0,0,0,0)",
      windowColor: "rgba(0,0,0,0.5)"
    },
    instance: null
  };
  CaptionsSettingsMediator.__super__.constructor.call(this, null, null, viewComponent, null);
}


__extends(CaptionsSettingsMediator, PluginComponentMediator);


CaptionsSettingsMediator.prototype.componentName = "captioning-settings";

CaptionsSettingsMediator.prototype.settingsUiVisible = false;

CaptionsSettingsMediator.prototype.captionningStyle = null;

CaptionsSettingsMediator.prototype.swatchColorCurr = null;

CaptionsSettingsMediator.prototype.swatchOpacityCurr = null;

CaptionsSettingsMediator.prototype.colorPicker = null;

CaptionsSettingsMediator.prototype.colorPickerOpacity = null;

CaptionsSettingsMediator.prototype.advancedSettingContainer = null;

CaptionsSettingsMediator.prototype.scroll = {
  type: "popout",
  typeSpeed: 5,
  lines: 2,
  scrollTimer: [],
  speed: 10,
  popout: null,
  rollup: null,
  painton: null
};

/**
 * @override
*/
CaptionsSettingsMediator.prototype.onRegister = function() {
  var applyButton, cancelButton, captionContainer, captionLabel, clonedSwatch, color, colorArray, isDefault, preset1, preset2, preset3, preset4, previewContainer, previewPara, resetButton, swatch, titleBar, titleText, toggleAdvancedButton, _i, _len,
    _this = this;
  CaptionsSettingsMediator.__super__.onRegister.call(this);
  this.captioning = this.facade.player.captioning;
  titleBar = this.create("captioning-titlebar");
  titleText = this.create("captioning-title", titleBar, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_TITLE));
  this.toggle.OFF = this.create("captioning-toggle-btn", titleBar, "div", "OFF");
  this.toggle.ON = this.create("captioning-toggle-btn", titleBar, "div", "ON");
  EventHandler.create(this.toggle.ON, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    if (!_this.toggle.disabled) {
      _this.toggleButtonHandler(true);
    }
    return false;
  });
  if (!this.toggle.disabled) {
    ClassList.add("captioning-floater-btnselected", this.toggle.OFF, this.classList.prefix);
  }
  EventHandler.create(this.toggle.OFF, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    if (!_this.toggle.disabled) {
      _this.toggleButtonHandler(false);
    }
    return false;
  });
  captionContainer = this.create("captioning-row");
  captionLabel = this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_LANGUAGE));
  this.list.language = this.create("captioning-dropdown", captionContainer, "select");
  this.languageListPopulate();
  EventHandler.create(this.list.language, "change", function(event) {
    var langIsSelected;
    event.stopImmediatePropagation();
    langIsSelected = event.target.selectedValue !== "None";
    _this.captioining.setHidden(!langIsSelected);
    if (langIsSelected) {
      _this.captioning.setTrack(_this.captioning.selectTrackByIndex(event.target.selectedIndex));
    }
    return false;
  });
  captionLabel = this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_PRESETS));
  preset1 = this.create(["captioning-preset", "captioning-preset1"], captionContainer, null, "Aa");
  preset2 = this.create(["captioning-preset", "captioning-preset2"], captionContainer, null, "Aa");
  preset3 = this.create(["captioning-preset", "captioning-preset3"], captionContainer, null, "Aa");
  preset4 = this.create(["captioning-preset", "captioning-preset4"], captionContainer, null, "Aa");
  EventHandler.create(preset1, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset1);
    _this.applyCaptioningStyle();
    return false;
  });
  EventHandler.create(preset2, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset2);
    _this.applyCaptioningStyle();
    return false;
  });
  EventHandler.create(preset3, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset3);
    _this.applyCaptioningStyle();
    return false;
  });
  EventHandler.create(preset4, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset4);
    _this.applyCaptioningStyle();
    return false;
  });
  this.advancedSettingContainer = this.create("captioning-advanced-container");
  captionContainer = this.create("captioning-row", this.advancedSettingContainer);
  captionLabel = this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_FONT));
  this.list.font = this.create("captioning-dropdown", captionContainer, "select");
  this.create(null, this.list.font, "option", "Monospaced Serif").value = "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace";
  this.create(null, this.list.font, "option", "Proportional Serif").value = "'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif";
  this.create(null, this.list.font, "option", "Monospaced Sans-Serif").value = "'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace";
  this.create(null, this.list.font, "option", "Proportional Sans-Serif").value = "Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif";
  this.create(null, this.list.font, "option", "Casual").value = "'Comic Sans MS', Impact, Handlee, fantasy";
  this.create(null, this.list.font, "option", "Cursive").value = "'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive";
  this.create(null, this.list.font, "option", "Small Capitals").value = "'Arial Unicode Ms', Arial, Helvetica, Verdana, 'Marcellus SC', sans-serif; font-variant: small-caps";
  EventHandler.create(this.list.font, "change", function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected.fontFamily = event.target.value;
    _this.applyCaptioningStyle(false);
    return false;
  });
  captionContainer.appendChild(this.list.font);
  captionLabel = this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));
  this.list.edge = this.create("captioning-dropdown", captionContainer, "select");
  this.create(null, this.list.edge, "option", "None").value = "text-shadow: 0px 0px 0px";
  this.create(null, this.list.edge, "option", "Depressed").value = "text-shadow: 0px 1px 0px";
  this.create(null, this.list.edge, "option", "Left Drop Shadow").value = "text-shadow: -3px 3px 2px";
  this.create(null, this.list.edge, "option", "Raised").value = "text-shadow: 0px 1px 1px";
  this.create(null, this.list.edge, "option", "Right Drop Shadow").value = "text-shadow: 3px 3px 2px";
  this.create(null, this.list.edge, "option", "Uniform").value = "text-shadow: 0px 0px 4px";
  EventHandler.create(this.list.edge, "change", function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected.edgeType = event.target.value;
    _this.applyCaptioningStyle(false);
    return false;
  });
  captionContainer = this.create("captioning-row", this.advancedSettingContainer);
  this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_SIZE));
  this.list.size = this.create("captioning-dropdown", captionContainer, "select");
  this.create(null, this.list.size, "option", "Extra Small").value = "x-small";
  this.create(null, this.list.size, "option", "Small").value = "small";
  this.create(null, this.list.size, "option", "Medium").value = "medium";
  this.create(null, this.list.size, "option", "Large").value = "large";
  this.create(null, this.list.size, "option", "Extra Large").value = "x-large";
  this.list.size.selectedIndex = 1;
  EventHandler.create(this.list.size, "change", function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected.size = event.target.value;
    _this.applyCaptioningStyle(false);
    return false;
  });
  this.create("captioning-label", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_SCROLL));
  this.list.scroll = this.create("captioning-dropdown", captionContainer, "select");
  this.create(null, this.list.scroll, "option", "Pop-Out").value = "popout";
  this.create(null, this.list.scroll, "option", "Roll-On").value = "rollon";
  this.create(null, this.list.scroll, "option", "Paint-On").value = "painton";
  EventHandler.create(this.list.scroll, "change", function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.selected.scroll = _this.scroll.type = event.target.value;
    return false;
  });
  captionContainer = this.create("captioning-row", this.advancedSettingContainer);
  this.create("captioning-label-small", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_COLOR));
  this.picker.color = this.create("captioning-color-picker", captionContainer);
  this.picker.color.style.backgroundColor = this.captioningObject["default"].fontColor;
  EventHandler.create(this.picker.color, EventHandler.CLICK, function(event) {
    var alpha, _ref;
    event.stopImmediatePropagation();
    _this.colorPickerHandler();
    _this.colorPicker.style.display = _this.colorPicker.style.display === "block" ? "none" : "block";
    if (_this.colorPicker.style.display === "block") {
      if ((_ref = _this.swatchColorCurr) != null) {
        _ref.style.borderColor = "rgba(0,0,0,0.3)";
      }
      _this.colorPicker.style.left = "152px";
      _this.colorPicker.name = "fontColor";
      _this.captioningObject.instance = _this.picker.color;
      if (_this.picker.color.style.backgroundColor.indexOf('rgba') !== -1) {
        alpha = _this.picker.color.style.backgroundColor.replace(/^rgba?\(|\s+|\)$/g, '').split(',')[3];
      }
      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;
    }
    return false;
  });
  this.create("captioning-label-small", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_BACKGROUND));
  this.picker.background = this.create("captioning-color-picker", captionContainer);
  this.picker.background.style.backgroundColor = this.captioningObject["default"].backgroundColor;
  EventHandler.create(this.picker.background, EventHandler.CLICK, function(event) {
    var alpha, _ref;
    event.stopImmediatePropagation();
    _this.colorPickerHandler();
    _this.colorPicker.style.display = _this.colorPicker.style.display === "block" ? "none" : "block";
    if (_this.colorPicker.style.display === "block") {
      if ((_ref = _this.swatchColorCurr) != null) {
        _ref.style.borderColor = "rgba(0,0,0,0.3)";
      }
      _this.colorPicker.style.left = "264px";
      _this.colorPicker.name = "backgroundColor";
      _this.captioningObject.instance = _this.picker.background;
      if (_this.picker.background.style.backgroundColor.indexOf('rgba') !== -1) {
        alpha = _this.picker.background.style.backgroundColor.replace(/^rgba?\(|\s+|\)$/g, '').split(',')[3];
      }
      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;
    }
    return false;
  });
  this.create("captioning-label-small", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));
  this.picker.edge = this.create("captioning-color-picker", captionContainer);
  this.picker.edge.style.backgroundColor = this.captioningObject["default"].edgeColor;
  EventHandler.create(this.picker.edge, EventHandler.CLICK, function(event) {
    var alpha, _ref;
    event.stopImmediatePropagation();
    _this.colorPickerHandler();
    _this.colorPicker.style.display = _this.colorPicker.style.display === "block" ? "none" : "block";
    if (_this.colorPicker.style.display === "block") {
      if ((_ref = _this.swatchColorCurr) != null) {
        _ref.style.borderColor = "rgba(0,0,0,0.3)";
      }
      _this.colorPicker.style.left = "212px";
      _this.colorPicker.name = "edgeColor";
      _this.captioningObject.instance = _this.picker.edge;
      if (_this.picker.edge.style.backgroundColor.indexOf('rgba') !== -1) {
        alpha = _this.picker.edge.style.backgroundColor.replace(/^rgba?\(|\s+|\)$/g, '').split(',')[3];
      }
      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;
    }
    return false;
  });
  this.create("captioning-label-small", captionContainer, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_WINDOW));
  this.picker.window = this.create("captioning-color-picker", captionContainer);
  this.picker.window.style.backgroundColor = this.captioningObject["default"].windowColor;
  EventHandler.create(this.picker.window, EventHandler.CLICK, function(event) {
    var alpha, _ref;
    event.stopImmediatePropagation();
    _this.colorPickerHandler();
    _this.colorPicker.style.display = _this.colorPicker.style.display === "block" ? "none" : "block";
    if (_this.colorPicker.style.display === "block") {
      if ((_ref = _this.swatchColorCurr) != null) {
        _ref.style.borderColor = "rgba(0,0,0,0.3)";
      }
      _this.colorPicker.style.left = "300px";
      _this.colorPicker.name = "windowColor";
      _this.captioningObject.instance = _this.picker.window;
      if (_this.picker.window.style.backgroundColor.indexOf('rgba') !== -1) {
        alpha = _this.picker.window.style.backgroundColor.replace(/^rgba?\(|\s+|\)$/g, '').split(',')[3];
      }
      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;
    }
    return false;
  });
  previewContainer = this.create(["caption-text", "caption-text-preview"]);
  previewPara = this.create(null, previewContainer, "p", this.localizationManager.getString(LocalizationConstants.MSG_CC_PREVIEW_TEXT));
  captionContainer = this.create("captioning-footer-container");
  applyButton = this.create("captioning-footer-button", captionContainer, "div", this.localizationManager.getString(LocalizationConstants.MSG_CC_APPLY));
  cancelButton = this.create("captioning-footer-button", captionContainer, "div", this.localizationManager.getString(LocalizationConstants.MSG_CC_CANCEL));
  resetButton = this.create("captioning-footer-button", captionContainer, "div", this.localizationManager.getString(LocalizationConstants.MSG_CC_RESET));
  if (this.captioning.getViewComponent().clientWidth >= 0) {
    toggleAdvancedButton = this.create("captioning-advanced-button", captionContainer, "div", this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED));
    EventHandler.create(toggleAdvancedButton, EventHandler.CLICK, function(event) {
      event.stopImmediatePropagation();
      if (_this.advancedSettingContainer.style.display === "block") {
        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED);
        _this.advancedSettingContainer.style.display = "none";
        _this.colorPicker.style.display = "none";
      } else {
        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_HIDE_ADVANCED);
        _this.advancedSettingContainer.style.display = "block";
      }
      return false;
    });
  }
  EventHandler.create(applyButton, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);
    _this.applyCaptioningStyle(false, true);
    _this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, _this.captioningObject.selected);
    return false;
  });
  EventHandler.create(cancelButton, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);
    return false;
  });
  EventHandler.create(resetButton, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.colorPicker.style.display = "none";
    _this.applyCaptioningStyle(true);
    return false;
  });
  this.captionningStyle = this.create(null, document.getElementsByTagName('head')[0], "style");
  this.captionningStyle.type = 'text/css';
  colorArray = ["#000000", "#660000", "#990000", "#ff0000", "#000066", "#660066", "#990066", "#ff0066", "#006600", "#666600", "#996600", "#ff6600", "#006666", "#666666", "#996666", "#ff6666", "#009900", "#669966", "#999900", "#ff9900", "#009966", "#669966", "#999966", "#ff9966", "#00ff00", "#66ff00", "#99ff00", "#ffff00", "#00ff66", "#66ff66", "#99ff66", "#ffff66", "#000099", "#660099", "#990099", "#ff0099", "#0000ff", "#6600ff", "#9900ff", "#ff00ff", "#006699", "#666699", "#996699", "#ff6699", "#0066ff", "#6666ff", "#9966ff", "#ff66ff", "#009999", "#669999", "#999999", "#ff9999", "#0099ff", "#6699ff", "#9999ff", "#ff99ff", "#0099ff", "#66ff99", "#99ff99", "#ffff99", "#00ffff", "#66ffff", "#99ffff", "#ffffff"];
  this.colorPicker = this.create("colorpicker-palette", this.viewComponent.parentElement);
  swatch = this.create("colorpicker-swatch", false, null, "&nbsp;");
  for (_i = 0, _len = colorArray.length; _i < _len; _i++) {
    color = colorArray[_i];
    swatch.style.backgroundColor = color;
    clonedSwatch = swatch.cloneNode();
    EventHandler.create(clonedSwatch, EventHandler.CLICK, function(event) {
      event.stopImmediatePropagation();
      if (_this.swatchColorCurr !== null) {
        _this.swatchColorCurr.style.borderColor = "rgba(0,0,0,0.3)";
      }
      _this.swatchColorCurr = event.target;
      _this.swatchColorCurr.style.borderColor = "rgba(255, 50, 50, 1)";
      _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(event.target.style.backgroundColor);
      _this.applyCaptioningStyle(false);
      return false;
    });
    this.colorPicker.appendChild(clonedSwatch);
  }
  this.create("opacity-label", this.colorPicker, "span", this.localizationManager.getString(LocalizationConstants.MSG_CC_OPACITY));
  this.colorPickerOpacity = this.create("colorpicker-slider", this.colorPicker, "input");
  this.colorPickerOpacity.type = "range";
  this.colorPickerOpacity.min = 0;
  this.colorPickerOpacity.max = 1;
  this.colorPickerOpacity.step = .1;
  this.colorPickerOpacity.value = 1;
  EventHandler.create(this.colorPickerOpacity, "change", function(event) {
    event.stopImmediatePropagation();
    _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(_this.captioningObject.instance.style.backgroundColor);
    _this.applyCaptioningStyle(false);
    return false;
  });
  this.swatchOpacityCurr = this.colorPickerOpacity;
  try {
    if (localStorage.getItem(Namespace.PREFIX + "captioningDefault") != null) {
      this.captioningObject.selected = JSON.parse(localStorage.getItem(Namespace.PREFIX + "captioningDefault"));
      this.applyCaptioningStyle(false, !this.captioning.getHidden());
    } else {
      isDefault = !((this.captioning.config.style != null) || this.captioning.config.style !== "undefined");
      if (!isDefault) {
        this.captioningObject.selected = this.cloneObject(this.captioning.config.style);
      }
      this.applyCaptioningStyle(isDefault);
    }
  } catch (_error) {}
  this.setSettings(Object.keys(this.captioningObject.selected).length > 0 ? this.captioningObject.selected : this.captioningObject["default"]);
  this.toggleButtonHandler(!this.captioning.getHidden(), false);
};

CaptionsSettingsMediator.prototype.toRGBA = function(colorCode) {
  var rbga, rgb;
  rgb = colorCode.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
  rbga = 'rgba(' + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + this.swatchOpacityCurr.value + ')';
  return rbga;
};

CaptionsSettingsMediator.prototype.onScrollListChange = function(value) {
  var _ref;
  if (value != null) {
    this.captioningObject.selected.scroll = this.scroll.type = value;
  }
  this.setSettings({
    scroll: this.scroll.type
  });
  try {
    if (((_ref = this.captioning.proxy.renderer) != null ? _ref.viewComponent : void 0) != null) {
      if (this.scroll.type === "painton") {
        ClassList.add("akamai-captioning-typed", this.captioning.proxy.renderer.viewComponent);
      } else {
        ClassList.remove("akamai-captioning-typed", this.captioning.proxy.renderer.viewComponent);
      }
    }
  } catch (error) {
    this.facade.logger.error("AMP Captioning Error", error);
  }
};

CaptionsSettingsMediator.prototype.languageListPopulate = function() {
  var language, track, tracks, _i, _len, _ref;
  tracks = this.captioning.getTracks();
  if (!(tracks != null)) {
    return;
  }
  this.list.language.innerHTML = "";
  for (_i = 0, _len = tracks.length; _i < _len; _i++) {
    track = tracks[_i];
    language = track.language;
    language = this.facade.player.retrieveProxy(LocalizationProxy.NAME).getLanguageString(language);
    if ((language != null) && language !== "") {
      this.create(null, this.list.language, "option", language).value = track.language;
    }
  }
  this.toggle.disabled = this.list.language.childElementCount === 0;
  if (this.toggle.disabled) {
    this.create(null, this.list.language, "option", "None");
  }
  this.list.language.value = (_ref = this.captioning.getTrack()) != null ? _ref.language : void 0;
};

CaptionsSettingsMediator.prototype.colorPickerHandler = function(unbind) {
  var _this = this;
  if (unbind == null) {
    unbind = false;
  }
  if (unbind) {
    return EventHandler.unbind(document, EventHandler.CLICK);
  }
  EventHandler.create(document, EventHandler.CLICK, function(event) {
    event.stopImmediatePropagation();
    _this.colorPickerHandler(true);
    if (event.target.className !== "akamai-colorpicker-palette" && event.target.className !== "akamai-opacity-label" && event.target.className !== "akamai-colorpicker-slider" && _this.colorPicker.style.display !== "none") {
      _this.colorPicker.style.display = "none";
    }
    return false;
  });
};

CaptionsSettingsMediator.prototype.cloneObject = function(clone) {
  var cloned, key;
  cloned = {};
  for (key in clone) {
    cloned[key] = clone[key];
  }
  return cloned;
};

CaptionsSettingsMediator.prototype.applyCaptioningStyle = function(isDefault, isApply, settingsDefault) {
  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, windowColor, windowColorValue;
  if (isDefault == null) {
    isDefault = false;
  }
  if (isApply == null) {
    isApply = false;
  }
  if (settingsDefault == null) {
    settingsDefault = false;
  }
  if (isDefault) {
    this.captioningObject.selected = this.cloneObject(this.captioningObject["default"]);
    this.list.font.value = this.captioningObject["default"].fontFamily;
    this.list.edge.value = this.captioningObject["default"].edgeType != null ? this.captioningObject["default"].edgeType : "text-shadow: 0px 0px 0px";
    this.list.size.value = this.captioningObject["default"].size;
    this.list.scroll.value = this.captioningObject["default"].scroll;
    this.picker.color.style.backgroundColor = this.captioningObject["default"].fontColor;
    this.picker.background.style.backgroundColor = this.captioningObject["default"].backgroundColor;
    this.picker.edge.style.backgroundColor = this.captioningObject["default"].edgeColor;
    this.picker.window.style.backgroundColor = this.captioningObject["default"].windowColor;
  } else {
    if ((this.captioningObject.selected.fontFamily != null) && !settingsDefault) {
      this.list.font.value = this.captioningObject.selected.fontFamily;
    }
    this.list.edge.value = this.captioningObject.selected.edgeType != null ? this.captioningObject.selected.edgeType : "text-shadow: 0px 0px 0px";
    if (this.captioningObject.selected.size != null) {
      this.list.size.value = this.captioningObject.selected.size;
    }
    if (this.captioningObject.selected.scroll != null) {
      this.list.scroll.value = this.captioningObject.selected.scroll;
    } else {
      this.captioningObject.selected.scroll = this.list.scroll.value;
    }
    this.picker.color.style.backgroundColor = this.captioningObject.selected.fontColor;
    if (this.captioningObject.selected.backgroundColor != null) {
      this.picker.background.style.backgroundColor = this.captioningObject.selected.backgroundColor;
    }
    if (this.captioningObject.selected.edgeColor != null) {
      this.picker.edge.style.backgroundColor = this.captioningObject.selected.edgeColor;
    }
    if (this.captioningObject.selected.windowColor != null) {
      this.picker.window.style.backgroundColor = this.captioningObject.selected.windowColor;
    }
  }
  fontFamily = "font-family: " + (isDefault ? this.captioningObject["default"].fontFamily : settingsDefault ? this.captioningObject.selected.fontFamily : this.list.font.value) + " !important;";
  edgeType = (isDefault ? this.captioningObject["default"].edgeType + this.captioningObject["default"].edgeColor : this.list.edge.value + " " + this.picker.edge.style.backgroundColor) + " !important;";
  fontSize = "font-size: " + (isDefault ? this.captioningObject["default"].size : this.list.size.value) + " !important;";
  color = "color: " + (isDefault ? this.captioningObject["default"].fontColor : this.picker.color.style.backgroundColor) + " !important;";
  backgroundColor = "background-color: " + (isDefault ? this.captioningObject["default"].backgroundColor : this.picker.background.style.backgroundColor) + " !important;";
  windowColor = "background-color: " + (isDefault ? this.captioningObject["default"].windowColor : this.picker.window.style.backgroundColor) + " !important;";
  containerStyle = "line-height:2.2em;";
  windowColorValue = windowColor.match(/rgba\([^)]+\)/g);
  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {
    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\)/, '$1')) === 0 ? "" : containerStyle;
  }
  if (isApply) {
    this.onScrollListChange();
    id = this.facade.player.viewComponent.id;
    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + 'video::-webkit-media-text-track-display { ' + windowColor + ' } video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-display { ' + windowColor + ' } video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-container {' + containerStyle + '} video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';
    try {
      if (isDefault === false && !settingsDefault) {
        localStorage.setItem(Namespace.PREFIX + "captioningDefault", JSON.stringify(this.captioningObject.selected));
      }
    } catch (localStorageError) {
      this.facade.logger.error("LocalStorage Not Supported on this Browser", localStorageError);
    }
  } else {
    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText + '#' + id + ' .akamai-caption-text.akamai-caption-text-preview { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text.akamai-caption-text-preview p { ' + color + backgroundColor + ' }';
  }
};

CaptionsSettingsMediator.prototype.toggleButtonHandler = function(isON, isTargetButton) {
  if (isON == null) {
    isON = false;
  }
  if (isTargetButton == null) {
    isTargetButton = true;
  }
  if (isON) {
    ClassList.add("captioning-floater-btnselected", this.toggle.ON, this.classList.prefix);
    ClassList.remove("captioning-floater-btnselected", this.toggle.OFF, this.classList.prefix);
  } else {
    ClassList.add("captioning-floater-btnselected", this.toggle.OFF, this.classList.prefix);
    ClassList.remove("captioning-floater-btnselected", this.toggle.ON, this.classList.prefix);
  }
  if (isTargetButton) {
    this.captioning.setHidden(!isON);
  }
  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {
    captioning: {
      hidden: !isON
    }
  });
};

CaptionsSettingsMediator.prototype.setSettings = function(value) {
  this.settings = value;
  return value;
};

CaptionsSettingsMediator.prototype.getSettings = function() {
  return this.settings;
};

/**
 * @override
*/
CaptionsSettingsMediator.prototype.listNotificationInterests = function() {
  return [CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY, CaptioningNotifications.SETTINGS_CHANGE];
};

/**
 * @override
*/
CaptionsSettingsMediator.prototype.handleNotification = function(notification) {
  var body, fName, fValue, i, isDefault, k, listString, name, note, option, state, v, _i, _len, _ref;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE:
    case CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY:
      if (this.settingsUiVisible) {
        this.colorPicker.style.display = "none";
      }
      this.settingsUiVisible = !this.settingsUiVisible;
      if (this.settingsUiVisible && this.list.language.length === 1) {
        this.languageListPopulate();
      }
      note = this.settingsUiVisible ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
      state = "cc-setting-active";
      this.toggleButtonHandler(!this.captioning.getHidden(), false);
      this.list.language.value = this.captioning.getTrack().language;
      this.onScrollListChange(this.captioningObject.selected.scroll);
      this.sendNotification(note, state);
      break;
    case CaptioningNotifications.SETTINGS_CHANGE:
      isDefault = false;
      for (k in body) {
        v = body[k];
        switch (k) {
          case "fontFamily":
          case "fontSize":
          case "scroll":
          case "edgeType":
            listString = k === "fontFamily" ? "font" : k === "fontSize" ? "size" : k === "edgeType" ? "edge" : "scroll";
            _ref = this.list[listString].options;
            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
              option = _ref[i];
              if (k === "fontFamily" && typeof v === "object") {
                for (fName in v) {
                  fValue = v[fName];
                  if (fName === "default") {
                    this.captioningObject.selected.fontFamily = fValue;
                    isDefault = true;
                  }
                  if ((new RegExp(fName, "i")).test(option.label)) {
                    if (!(new RegExp("^" + fValue)).test(option.value)) {
                      option.value = fValue + "," + option.value;
                    }
                    if (option.selected) {
                      this.captioningObject.selected.fontFamily = option.value;
                    }
                  }
                }
              } else if ((new RegExp("^" + v + "$", "i")).test(option.label)) {
                this.list[listString].selectedIndex = i;
                if (k === "fontSize") {
                  k = "size";
                }
                this.captioningObject.selected[k] = option.value;
                if (k === "scroll") {
                  this.scroll.type = this.captioningObject.selected.scroll = option.value;
                  this.setSettings({
                    scroll: this.scroll.type
                  });
                  try {
                    if (option.value === "painton") {
                      ClassList.add("akamai-captioning-typed", this.captioning.proxy.renderer.viewComponent);
                    } else {
                      ClassList.remove("akamai-captioning-typed", this.captioning.proxy.renderer.viewComponent);
                    }
                  } catch (error) {
                    this.facade.logger.error("AMP Captioning Error", error);
                  }
                }
              }
            }
            break;
          case "backgroundColor":
          case "edgeColor":
          case "fontColor":
          case "windowColor":
            this.captioningObject.selected[k] = v;
        }
      }
      this.applyCaptioningStyle(false, true, isDefault);
      if ((body.visible != null) && body.visible !== !this.captioning.getHidden()) {
        this.captioning.setHidden(!body.visible);
      }
  }
};

/**
 * @constructor
 * @private
*/
function PlayOverlayMediator() {
  PlayOverlayMediator.__super__.constructor.call(this);
}


__extends(PlayOverlayMediator, OverlayMediator);


PlayOverlayMediator.prototype.componentName = "play";

PlayOverlayMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  event.preventDefault();
  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);
  return false;
};

function VolumePanelControlMediator(componentName) {
  VolumePanelControlMediator.__super__.constructor.call(this, componentName);
}


__extends(VolumePanelControlMediator, PanelControlMediator);


VolumePanelControlMediator.prototype.clickHandler = function() {
  this.sendNotification(Notifications.TOGGLE_MUTED);
};

/**
 * The VolumeMediator class.
 *
 * @constructor
 * @private
 * @extends {ModuleMediator}
 * @param {Object} viewComponent
*/
function VolumeMediator(parent, direction) {
  VolumeMediator.__super__.constructor.call(this, parent, direction);
}


__extends(VolumeMediator, SliderMediator);


VolumeMediator.prototype.componentName = "volume";

VolumeMediator.prototype.draggable = true;

/**
 * @override
*/
VolumeMediator.prototype.valueChanged = function() {
  this.sendNotification(Notifications.CHANGE_VOLUME, this.value);
  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {
    volume: this.value
  });
};

/**
 * @override
*/
VolumeMediator.prototype.listNotificationInterests = function() {
  return [Notifications.VOLUME_CHANGE, Notifications.READY];
};

/**
 * @override
*/
VolumeMediator.prototype.handleNotification = function(notification) {
  switch (notification.getName()) {
    case Notifications.READY:
      this.updateValue(this.facade.player.getVolume(), true);
      break;
    case Notifications.VOLUME_CHANGE:
      this.updateValue(notification.getBody());
  }
};

/**
 * The ControlPanelMediator class.
 *
 * @constructor
 * @private
 * @extends {PluginMediator}
*/
function ControlPanelMediator() {
  ControlPanelMediator.__super__.constructor.call(this);
  this.controls = {};
}


__extends(ControlPanelMediator, PluginMediator);


ControlPanelMediator.prototype.panel = null;

ControlPanelMediator.prototype.control = null;

ControlPanelMediator.prototype.separator = null;

ControlPanelMediator.prototype.controls = null;

ControlPanelMediator.prototype.labels = null;

ControlPanelMediator.prototype.closed = true;

ControlPanelMediator.prototype.panelClass = PanelMediator;

ControlPanelMediator.prototype.controlClass = PanelControlMediator;

/**
 * @override
*/
ControlPanelMediator.prototype.onRegister = function() {
  this.panel = this.createPanel(this.componentName);
  this.control = this.createControl(this.componentName);
  this.separator = this.createSeparator(this.componentName);
  this.panel.control = this.control;
  this.control.panel = this.panel;
  if (this.labels == null) {
    this.labels = {};
  }
  this.createPanelControls(this.componentName);
};

ControlPanelMediator.prototype.createControl = function(name) {
  var control;
  control = new this.controlClass(name);
  this.facade.registerMediator(control);
  return control;
};

ControlPanelMediator.prototype.createPanel = function(name) {
  var panel;
  panel = new this.panelClass(name);
  this.facade.registerMediator(panel);
  return panel;
};

ControlPanelMediator.prototype.createSeparator = function(name) {
  return this.create(["separator", "icon"], this.panel);
};

ControlPanelMediator.prototype.createPanelControls = function(name) {
  var data, key, value, _base, _ref;
  data = (typeof (_base = this.plugin).getConfigurationData === "function" ? _base.getConfigurationData() : void 0) || this.facade.getConfig()[this.componentName];
  for (key in data) {
    value = data[key];
    if (value === true) {
      this.controls[key] = this.addPanelControl(new ButtonMediator(this.localizationManager.getString(this.labels[key]), null, null, key, (_ref = this.panelButtonClickHandler) != null ? typeof _ref.bind === "function" ? _ref.bind(this, key) : void 0 : void 0));
    }
  }
};

ControlPanelMediator.prototype.addPanelControl = function(control) {
  this.facade.registerMediator(control);
  this.panel.getViewComponent().appendChild(control.getViewComponent());
  return control;
};

/**
*/
ControlPanelMediator.prototype.panelButtonClickHandler = function() {
  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);
};

/**
 * The VolumePanelMediator class.
 *
 * @constructor
 * @private
 * @extends {ControlPanelMediator}
*/
function VolumePanelMediator() {
  VolumePanelMediator.__super__.constructor.call(this);
}


__extends(VolumePanelMediator, ControlPanelMediator);


VolumePanelMediator.prototype.componentName = "volume";

VolumePanelMediator.prototype.slider = null;

VolumePanelMediator.prototype.level = null;

VolumePanelMediator.prototype.controlClass = VolumePanelControlMediator;

/**
*/
VolumePanelMediator.prototype.onRegister = function() {
  var _ref;
  VolumePanelMediator.__super__.onRegister.call(this);
  this.slider = new VolumeMediator(this.panel, (_ref = this.facade.getConfig().volume) != null ? _ref.direction : void 0);
  this.facade.registerMediator(this.slider);
};

VolumePanelMediator.prototype.updateVolumeButton = function(percent) {
  var level;
  level = Math.ceil(percent * 10);
  if (level === this.level) {
    return;
  }
  if (this.level != null) {
    this.sendNotification(Notifications.REMOVE_CONTROL_STATE, "volume-" + this.level);
  }
  this.level = level;
  this.sendNotification(Notifications.ADD_CONTROL_STATE, "volume-" + this.level);
};

/**
 * @override
*/
VolumePanelMediator.prototype.listNotificationInterests = function() {
  return VolumePanelMediator.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.VOLUME_CHANGE]);
};

/**
 * @override
*/
VolumePanelMediator.prototype.handleNotification = function(notification) {
  VolumePanelMediator.__super__.handleNotification.call(this, notification);
  switch (notification.getName()) {
    case Notifications.VOLUME_CHANGE:
      this.updateVolumeButton(notification.body);
  }
};

/**
 * The PanelsMediator class.
 * 
 * @constructor
 * @private
 * @extends {LayerMediator}
*/
function PanelsMediator(parent) {
  this.panels = [];
  this.closeHandler = this.mouseupHandler.bind(this);
  PanelsMediator.__super__.constructor.call(this, null, null, parent);
}


__extends(PanelsMediator, ComponentMediator);


PanelsMediator.prototype.componentName = "panels";

PanelsMediator.prototype.activePanel = null;

PanelsMediator.prototype.panels = null;

PanelsMediator.prototype.closeHandler = null;

/**
 * @override
*/
PanelsMediator.prototype.listNotificationInterests = function() {
  var key, value;
  return ((function() {
    var _results;
    _results = [];
    for (key in PanelNotifications) {
      value = PanelNotifications[key];
      _results.push(value);
    }
    return _results;
  })()).concat([]);
};

/**
 * @override
*/
PanelsMediator.prototype.handleNotification = function(notification) {
  var body, name;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case PanelNotifications.ADD_PANEL:
      this.addPanel(body);
      break;
    case PanelNotifications.REMOVE_PANEL:
      this.removePanel(body);
      break;
    case PanelNotifications.OPEN_PANEL:
      this.openPanel(body);
      break;
    case PanelNotifications.CLOSE_PANEL:
      this.closePanel(body);
      break;
    case PanelNotifications.CLOSE_ALL_PANELS:
      this.closeAllPanels(body);
      break;
    case PanelNotifications.TOGGLE_PANEL:
      this.togglePanel(body);
  }
};

PanelsMediator.prototype.addPanel = function(panel) {
  this.panels.push(panel);
  this.viewComponent.appendChild(panel.getViewComponent());
};

PanelsMediator.prototype.removePanel = function(panel) {
  this.panels.splice(this.panels.indexOf(panel), 1);
  this.viewComponent.removeChild(panel.getViewComponent());
};

PanelsMediator.prototype.openPanel = function(panel) {
  if (panel === this.activePanel || !(panel != null)) {
    return;
  }
  this.closeAllPanels();
  this.activePanel = panel;
  this.activePanel.classList.add("active");
  if (Utils.getDevice() !== "desktop") {
    this.sendNotification(Notifications.IS_USER_ACTIVE, true);
  }
  document.addEventListener("mouseup", this.closeHandler);
};

PanelsMediator.prototype.closePanel = function(panel) {
  panel.classList.remove("active");
  if (this.activePanel != null) {
    this.activePanel = null;
    if (Utils.getDevice() !== "desktop") {
      this.sendNotification(Notifications.IS_USER_ACTIVE, false);
    }
    document.removeEventListener("mouseup", this.closeHandler);
  }
};

PanelsMediator.prototype.togglePanel = function(panel) {
  if (panel === this.activePanel) {
    this.closePanel(panel);
  } else {
    this.openPanel(panel);
  }
};

PanelsMediator.prototype.closeAllPanels = function() {
  var panel, _i, _len, _ref;
  _ref = this.panels;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    panel = _ref[_i];
    this.closePanel(panel);
  }
};

PanelsMediator.prototype.mouseupHandler = function(event) {
  var button, element, panel;
  element = document.elementFromPoint(event.clientX, event.clientY);
  panel = this.activePanel.getViewComponent();
  button = this.activePanel.control.getViewComponent();
  if (element !== panel && panel.contains(element) === false && element !== button && button.contains(element) === false) {
    this.closeAllPanels();
  }
};

/**
 * The ProgressMediator class.
 *
 * @constructor
 * @private
 * @extends {ModuleMediator}
 * @param {Object} viewComponent
*/
function ProgressMediator(parent) {
  ProgressMediator.__super__.constructor.call(this, parent, "horizontal");
}


__extends(ProgressMediator, SliderMediator);


/**
 * The name of the this Mediator.
 *
 * @static
 * @type {string}
*/
ProgressMediator.prototype.componentName = "progress";

ProgressMediator.prototype.bufferValue = null;

ProgressMediator.prototype.scrubTime = null;

ProgressMediator.prototype.scrubTimeSeparator = null;

ProgressMediator.prototype.cuePoints = null;

ProgressMediator.prototype.cues = null;

ProgressMediator.prototype.duration = 0;

ProgressMediator.prototype.isLive = false;

ProgressMediator.prototype.seeking = false;

ProgressMediator.prototype.previewData = {
  src: null,
  previewWidth: null,
  previewHeight: null,
  imgWidth: null,
  imgHeight: null,
  count: null
};

ProgressMediator.prototype.hoverHandler = null;

ProgressMediator.prototype.mouseoutHandler = null;

ProgressMediator.prototype.mouseMoveHandler = null;

ProgressMediator.prototype.previewMoveHandler = null;

/**
 * @override
*/
ProgressMediator.prototype.onRegister = function() {
  ProgressMediator.__super__.onRegister.call(this);
  this.bufferValue = this.create("buffer-value", false);
  this.trackView.insertBefore(this.bufferValue, this.trackView.lastChild);
  this.cuePoints = this.create("cue-points", this.trackView);
  this.scrubTimeSeparator = this.create("scrub-time-separator");
  this.scrubTime = this.create("scrub-time");
  this.thumbPreview = this.create("thumb-preview", this.trackView);
  this.previewMoveHandler = EventHandler.create(this.clickView, EventHandler.MOVE, this.updatePreviewHandler.bind(this));
  this.previewMoveHandler.unbind();
  this.hoverHandler = EventHandler.create(this.clickView, EventHandler.HOVER, this.handlehoverHandler.bind(this));
  this.mouseoutHandler = EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.handlemouseoutHandler.bind(this));
  this.mouseoutHandler.unbind();
  EventHandler.create(this.clickView, EventHandler.HOVER, this.mouseOverHandler.bind(this));
  EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.mouseOutHandler.bind(this));
  this.mouseMoveBinding = EventHandler.create(document, EventHandler.MOVE, this.mouseMoveHandler.bind(this));
  this.mouseMoveBinding.unbind();
};

/**
 * @override
*/
ProgressMediator.prototype.listNotificationInterests = function() {
  return [Notifications.ENDED, Notifications.MEDIA_CHANGE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.CUES_CHANGE, Notifications.DISPLAY_TIME, AdNotifications.BREAK_START];
};

/**
 * @override
*/
ProgressMediator.prototype.handleNotification = function(notification) {
  var body, name, value;
  ProgressMediator.__super__.handleNotification.call(this, notification);
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.MEDIA_CHANGE:
      this.isLive = body.temporalType === "live";
      this.updateValue(0);
      this.bufferValue.style.width = "0%";
      this.updatePreview(body.metadata);
      break;
    case Notifications.PROGRESS:
      value = Utils.clamp(body / this.duration * 100, 0, 100);
      this.bufferValue.style.width = value + "%";
      break;
    case Notifications.DURATION_CHANGE:
      this.duration = body;
      this.updateCuePoints();
      break;
    case Notifications.ENDED:
      this.updateValue(1.0);
      break;
    case Notifications.CUES_CHANGE:
      this.cues = body;
      this.updateCuePoints();
      break;
    case Notifications.DISPLAY_TIME:
      if (this.dragging === false) {
        this.updateValue(body.currentTime / body.duration, body.duration);
      }
      if (body.duration !== this.duration) {
        this.duration = body.duration;
      }
      break;
    case AdNotifications.BREAK_START:
      if (this.getDragging()) {
        this.handleReleaseHandler();
      }
  }
};

ProgressMediator.prototype.updateCuePoints = function() {
  var cue, cuePoint, _i, _len, _ref;
  if (!(this.cues != null)) {
    return;
  }
  if (this.facade.config.displaySceneMarkers === false) {
    return;
  }
  this.removeCuePoints();
  _ref = this.cues;
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    cue = _ref[_i];
    if (!(cue.startTime !== 0 && cue.startTime !== -1)) {
      continue;
    }
    cuePoint = this.create("cue-point", this.cuePoints);
    cuePoint.style.left = (cue.startTime / this.duration * 100) + "%";
  }
};

ProgressMediator.prototype.preloadPreviewImages = function(metadata) {
  var i, image;
  i = 1;
  while (i < metadata.previewThumbnailCount) {
    image = new Image;
    image.src = metadata.previewThumbnailSrc + "out" + i + ".png";
    i++;
  }
};

ProgressMediator.prototype.updatePreview = function(metadata) {
  this.preloadPreviewImages(metadata);
  this.previewData.src = metadata.previewThumbnailSrc;
  this.previewData.previewHeight = metadata.previewThumbnailHeight;
  this.previewData.previewWidth = metadata.previewThumbnailWidth;
  this.previewData.count = metadata.previewThumbnailCount;
  if (this.previewData.src === void 0) {
    this.hoverHandler.unbind();
  }
};

ProgressMediator.prototype.handlehoverHandler = function(event) {
  this.previewMoveHandler.bind();
  this.mouseoutHandler.bind();
  this.hoverHandler.unbind();
  this.updatePreviewHandler(event);
  event.stopImmediatePropagation();
  return false;
};

ProgressMediator.prototype.handlemouseoutHandler = function(event) {
  this.previewMoveHandler.unbind();
  this.mouseoutHandler.unbind();
  this.hoverHandler.bind();
  event.stopImmediatePropagation();
  return false;
};

ProgressMediator.prototype.mouseOverHandler = function(event) {
  this.mouseOver = true;
  this.classList.add("active");
  this.mouseMoveBinding.bind();
};

ProgressMediator.prototype.mouseOutHandler = function(event) {
  this.mouseOver = false;
  if (this.getDragging() === true) {
    return;
  }
  this.classList.remove("active");
  this.mouseMoveBinding.unbind();
};

ProgressMediator.prototype.mouseMoveHandler = function(event) {
  var value;
  value = this.calculateValue(event);
  this.scrubTime.textContent = Utils.formatTimecode(Math.round(value * this.duration));
  this.scrubTime.style.left = this.scrubTimeSeparator.style.left = "" + ((value * 100).toFixed(2)) + "%";
};

ProgressMediator.prototype.updatePreviewHandler = function(event) {
  var thumbPreviewPos, value;
  value = this.calculateValue(event);
  this.previewInterval = this.duration / this.previewData.count;
  this.previewImgIndex = Math.floor(value * this.duration / this.previewInterval);
  if (this.previewData.src) {
    this.thumbPreview.style.backgroundImage = "url(" + this.previewData.src + "out" + (this.previewImgIndex + 1) + ".png)";
  }
  this.thumbPreview.style.width = this.previewData.previewWidth + "px";
  this.thumbPreview.style.height = this.previewData.previewHeight + "px";
  thumbPreviewPos = Utils.clamp(((value * 100) - 10).toFixed(2), 1, 80);
  this.thumbPreview.style.left = "" + thumbPreviewPos + "%";
};

ProgressMediator.prototype.removeCuePoints = function() {
  if (!(this.cuePoints != null)) {
    return;
  }
  this.cuePoints.innerHTML = "";
};

/**
 * @override
*/
ProgressMediator.prototype.valueChanged = function() {
  this.sendNotification(UserNotifications.SEEK, this.value * this.facade.player.retrieveProxy(PlaybackProxy.NAME).getDuration());
};

/** updates the view
*/
ProgressMediator.prototype.updateValue = function(value) {
  if (value === this.value) {
    return;
  }
  if (this.isLive === true) {
    value = 1;
  }
  if (isNaN(value) === true) {
    value = 0;
  }
  ProgressMediator.__super__.updateValue.call(this, value);
  if (this.getDragging() && this.value >= this.max) {
    this.handleReleaseHandler();
    this.sendNotification(Notifications.END);
  }
};

ProgressMediator.prototype.updateHandler = function(setValue, event) {
  ProgressMediator.__super__.updateHandler.call(this, setValue, event);
  this.mouseMoveHandler(event);
};

ProgressMediator.prototype.handlePressHandler = function(event) {
  ProgressMediator.__super__.handlePressHandler.call(this, event);
  this.classList.add("scrubbing");
};

ProgressMediator.prototype.handleReleaseHandler = function(event) {
  var self;
  ProgressMediator.__super__.handleReleaseHandler.call(this, event);
  self = this;
  setTimeout(function() {
    return self.classList.remove("scrubbing");
  }, 500);
  if (this.mouseOver === false) {
    this.mouseOutHandler();
  }
};

/**
 * The PlayPauseMediator class.
 *
 * @constructor
 * @private
 * @extends {ButtonMediator}
*/
function PlayPauseMediator(parent) {
  PlayPauseMediator.__super__.constructor.call(this, null, parent);
}


__extends(PlayPauseMediator, ButtonMediator);


PlayPauseMediator.prototype.componentName = "play-pause";

PlayPauseMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  event.preventDefault();
  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);
  return false;
};

/**
 * The ChromeCastTogglePlayPauseCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastTogglePlayPauseCommand() {
  ChromeCastTogglePlayPauseCommand.__super__.constructor.call(this);
}


__extends(ChromeCastTogglePlayPauseCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastTogglePlayPauseCommand.prototype.execute = function(notification) {
  switch (this.applicationState.getPlayState()) {
    case PlayState.ENDED:
      this.plugin.setCurrentTime(0);
      this.plugin.play();
      break;
    case PlayState.PAUSED:
    case PlayState.READY:
      this.plugin.play();
      break;
    case PlayState.PLAYING:
    case PlayState.WAITING:
      this.plugin.pause();
  }
};

/**
 * The ChromeCastButtonMediator class.
 *
 * @constructor
 * @extends {PluginMediator}
 * @param {Object} parent
 * @private
*/
function ChromeCastButtonMediator() {
  ChromeCastButtonMediator.__super__.constructor.call(this);
}


__extends(ChromeCastButtonMediator, ButtonMediator);


ChromeCastButtonMediator.prototype.componentName = "chromecast";

ChromeCastButtonMediator.prototype.onclick = function(event) {
  event.stopImmediatePropagation();
  this.sendNotification(ChromeCastNotifications.LAUNCH);
  return false;
};

/**
 * The ControlsMediator class.
 *
 * @constructor
 * @private
 * @extends {LayerMediator}
*/
function ControlsMediator() {
  ControlsMediator.__super__.constructor.call(this);
}


__extends(ControlsMediator, LayerMediator);


ControlsMediator.prototype.componentName = "controls";

ControlsMediator.prototype.activeControlPanel = null;

ControlsMediator.prototype.controlBar = null;

ControlsMediator.prototype.panels = null;

/**
 * @override
*/
ControlsMediator.prototype.onRegister = function() {
  var separator, titlebar;
  this.facade.registerMediator(new ErrorLayerMediator());
  if (this.facade.player.config.debug !== true) {
    if (this.facade.player.config.contextmenu && this.facade.player.config.contextmenu.enabled !== false) {
      this.facade.registerMediator(new contextMenuMediator());
    }
  }
  ControlsMediator.__super__.onRegister.call(this);
  this.facade.viewComponent = this.viewComponent;
  this.facade.registerMediator(new PosterMediator());
  this.facade.registerMediator(new LoadingOverlayMediator());
  this.facade.registerMediator(new WaitingOverlayMediator());
  this.facade.registerMediator(new ReplayOverlayMediator());
  this.facade.registerMediator(new EndSlateMediator());
  titlebar = this.facade.config.titlebar || this.facade.player.config.titlebar || {};
  if (titlebar.enabled !== false) {
    this.facade.registerMediator(new TitleBarMediator());
  }
  this.controlBar = this.create("control-bar");
  this.facade.registerMediator(new PanelsMediator(this.viewComponent));
  this.facade.registerMediator(new PlayPauseMediator(this.controlBar));
  this.facade.registerMediator(new TimeDisplayMediator(this.controlBar));
  this.facade.registerMediator(new ProgressMediator(this.controlBar));
  if (this.facade.config.logo != null) {
    this.facade.registerMediator(new LogoMediator(this.controlBar));
  }
  this.facade.registerMediator(new GoLiveMediator(this.controlBar));
  if (this.facade.player.captioning != null) {
    this.facade.registerMediator(new CaptionsMediator());
    this.facade.registerMediator(new CaptionsSettingsMediator(this.viewComponent));
  }
  this.facade.registerMediator(new VolumePanelMediator());
  this.facade.ads = new AdMediator();
  this.facade.registerMediator(this.facade.ads);
  this.facade.registerMediator(new PlayOverlayMediator());
  separator = this.create("separator", this.controlBar);
};

/**
 * @override
*/
ControlsMediator.prototype.listNotificationInterests = function() {
  return [Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.SET_MEDIA, AdNotifications.BREAK_START, AdNotifications.BREAK_END];
};

/**
 * @override
*/
ControlsMediator.prototype.handleNotification = function(notification) {
  var body, name, _ref;
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case Notifications.READY:
      if (((_ref = body.fullscreen) != null ? _ref.enabled : void 0) !== false) {
        this.facade.registerMediator(new FullScreenMediator(this.controlBar));
      }
      break;
    case Notifications.SET_MEDIA:
    case AdNotifications.BREAK_END:
      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, "ad-mode");
      break;
    case AdNotifications.BREAK_START:
      this.sendNotification(Notifications.ADD_APPLICATION_STATE, "ad-mode");
      break;
    case Notifications.ADD_CONTROL_STATE:
      this.classList.add(body);
      break;
    case Notifications.REMOVE_CONTROL_STATE:
      this.classList.remove(body);
      break;
    case Notifications.ADD_CONTROL:
      this.controlBar.appendChild(body);
      break;
    case Notifications.REMOVE_CONTROL:
      if (this.controlBar.contains(body)) {
        this.controlBar.removeChild(body);
      }
  }
};

/**
 * The ChromeCastControlsMediator class.
 * 
 * @constructor
 * @extends {PluginMediator}
 * @private
*/
function ChromeCastControlsMediator() {
  ChromeCastControlsMediator.__super__.constructor.call(this);
}


__extends(ChromeCastControlsMediator, ControlsMediator);


ChromeCastControlsMediator.prototype.componentName = "chromecast-controls";

ChromeCastControlsMediator.prototype.message = null;

ChromeCastControlsMediator.prototype.messageContainer = null;

ChromeCastControlsMediator.prototype.button = null;

ChromeCastControlsMediator.prototype.captioningActive = false;

/** @override
*/
ChromeCastControlsMediator.prototype.onRegister = function() {
  var button, fullscreen, _ref, _ref1;
  ChromeCastControlsMediator.__super__.onRegister.call(this);
  this.messageContainer = this.create("chromecast-message-container");
  this.message = this.createText("chromecast-message", this.localizationManager.getString("MSG_CHROMECAST_MESSAGE"), this.messageContainer);
  this.button = new ChromeCastButtonMediator();
  this.facade.registerMediator(this.button);
  fullscreen = new FullScreenMediator(this.controlBar);
  this.facade.registerMediator(fullscreen);
  fullscreen.setDisabled(true);
  this.sendNotification(Notifications.ADD_CONTROL, this.button.getViewComponent());
  if (!this.viewComponent.getElementsByClassName("akamai-caption akamai-button").length && ((_ref = this.facade.player.captioning) != null ? (_ref1 = _ref.config) != null ? _ref1.enabled : void 0 : void 0) === true) {
    button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent.getElementsByClassName("akamai-control-bar")[0], null, "caption", this.captionButtonClick.bind(this));
    this.facade.registerMediator(button);
    this.captionButton = button.getViewComponent();
    this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);
    this.sendNotification(Notifications.ADD_CONTROL_STATE, "cc-enabled");
  }
};

ChromeCastControlsMediator.prototype.captionButtonClick = function() {
  var note;
  this.captioningActive = !this.captioningActive;
  try {
    this.facade.player.parent.chromecast.postMessage({
      type: "captioning.visibilitychange",
      detail: {
        visibility: this.captioningActive
      }
    });
  } catch (error) {
    this.facade.logger.error("[AMP Chromecast Captioning Error]", error);
  }
  note = this.captioningActive ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;
  this.sendNotification(note, "cc-active");
};

/**
 * The ChromeCastPlaybackTargetChangeCommand class.
 *   
 * @constructor
 * @private
 * @extends {PluginCommand}
*/
function ChromeCastPlaybackTargetChangeCommand() {
  ChromeCastPlaybackTargetChangeCommand.__super__.constructor.call(this);
}


__extends(ChromeCastPlaybackTargetChangeCommand, PluginCommand);


/**
 * Executes the command.
 * 
 * @param {puremvc.Notification} notification 
 *    The notification.
 * 
 * @override
*/
ChromeCastPlaybackTargetChangeCommand.prototype.execute = function(notification) {
  var body, currentTime, duration, target,
    _this = this;
  body = notification.getBody();
  target = body.target;
  if (target === "chromecast") {
    this.player.pause();
  } else if (target === "amp") {
    currentTime = this.proxy.getCurrentTime();
    duration = this.player.getDuration();
    if (currentTime !== 0) {
      if (currentTime !== duration) {
        this.seekedHandler = this.seeked.bind(this);
        this.player.once("seeked", function(event) {
          _this.player.play();
        });
      }
      this.player.setCurrentTime(currentTime);
    }
  }
};

/**
 * The ChromeCastPlugin class.
 *
 * @param {Module}  app     The parent module of this plugin.
 * @constructor
 * @private
 * @extends {Plugin}
*/
function ChromeCastPlugin() {
  ChromeCastPlugin.__super__.constructor.call(this);
}


__extends(ChromeCastPlugin, Plugin);


ChromeCastPlugin.prototype.moduleName = "chromecast";

/** @override
*/
ChromeCastPlugin.prototype.isAvailable = function() {
  return this.isSender() || this.isReceiver();
};

/** @override
*/
ChromeCastPlugin.prototype.createModel = function() {
  this.proxy = this.isSender() ? new ChromeCastSenderProxy(this.config) : new ChromeCastReceiverProxy(this.config);
  this.registerProxy(this.proxy);
};

/** @override
*/
ChromeCastPlugin.prototype.createController = function() {
  ChromeCastPlugin.__super__.createController.call(this);
  if (this.isSender()) {
    this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);
    this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);
    this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);
    this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);
    this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, ChromeCastCaptioningVisibilityChangeCommand);
    this.registerCommand(CaptioningNotifications.SETTINGS_CHANGE, ChromeCastCaptioningSettingsChangeCommand);
    this.registerCommand(Notifications.MEDIA_CHANGE, ChromeCastMediaChangeCommand);
    this.registerCommand(Notifications.CHANGE_VOLUME, ChromeCastChangeVolumeCommand);
    this.registerCommand(Notifications.TOGGLE_MUTED, ChromeCastToggleMutedCommand);
    this.registerCommand(ChromeCastNotifications.AVAILABILITY_CHANGE, PluginEventCommand);
  } else if (this.isReceiver()) {
    this.registerCommand(Notifications.READY, ChromeCastReceiverReadyCommand);
    this.registerCommand(AdNotifications.BREAK_START, ChromeCastBreakStartCommand);
  }
};

/** @override
*/
ChromeCastPlugin.prototype.createView = function() {
  if (this.isSender()) {
    this.registerMediator(new ChromeCastHTMLSenderMediator());
  } else if (this.isReceiver()) {
    this.registerMediator(new ChromeCastReceiverMediator());
  }
};

ChromeCastPlugin.prototype.isSender = function() {
  return !ChromeCastPlugin.prototype.isReceiver() && /Chrome/.test(navigator.userAgent);
};

ChromeCastPlugin.prototype.isReceiver = function() {
  return /CrKey/.test(navigator.userAgent);
};

/** @override
*/
ChromeCastPlugin.prototype.listNotificationInterests = function() {
  return [Notifications.READY, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE, AdNotifications.BREAK_START, Notifications.PLAYBACK_TARGET_CHANGE, Notifications.MEDIA_CHANGE];
};

/** @override
*/
ChromeCastPlugin.prototype.listNotificationPublications = function() {
  return ChromeCastPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.INITIALIZED, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_PLAYBACK_TARGET, ChromeCastNotifications.AVAILABILITY_CHANGE, Notifications.CHANGE_PLAY_STATE, Notifications.CHANGE_DURATION, Notifications.DISPLAY_TIME]);
};

/**
 * @expose
*/
ChromeCastPlugin.prototype.play = function() {
  var _base;
  if (typeof (_base = this.proxy).play === "function") {
    _base.play();
  }
};

/**
 * @expose
*/
ChromeCastPlugin.prototype.pause = function() {
  var _base;
  if (typeof (_base = this.proxy).pause === "function") {
    _base.pause();
  }
};

/**
 * @param {Number}  value   The time in seconds to seek to.
 * @expose
*/
ChromeCastPlugin.prototype.setCurrentTime = function(value) {
  this.proxy.setCurrentTime(value);
  return value;
};

/**
 * Returns if The chromecast device's Availability
 * @expose
*/
ChromeCastPlugin.prototype.isReceiverAvailable = function() {
  var _ref;
  return ((_ref = this.proxy) != null ? typeof _ref.isReceiverAvailable === "function" ? _ref.isReceiverAvailable() : void 0 : void 0) || false;
};

ChromeCastPlugin.prototype.getMedia = function() {
  return this.proxy.media;
};

ChromeCastPlugin.prototype.getSession = function() {
  return this.proxy.session;
};

ChromeCastPlugin.prototype.getMediaManager = function() {
  return this.proxy.mediaManager;
};

ChromeCastPlugin.prototype.getCastReceiverManager = function() {
  return this.proxy.castReceiverManager;
};

ChromeCastPlugin.prototype.getCastMessageBus = function() {
  return this.proxy.shim.castMessageBuses[this.proxy.messageBus];
};

/**
 * sends a message across the message bus.
 *
 * @param {Object} msg
 * @expose
*/
ChromeCastPlugin.prototype.postMessage = function(msg) {
  this.proxy.send(msg);
};

ChromeCastPlugin.prototype.launch = function() {
  this.proxy.launch();
};


AMP.registerPlugin("chromecast", "html", ChromeCastPlugin);

/** 
 * The ChromeCastFlashPlugin class.
 *   
 * @param {Module}  app     The parent module of this plugin.
 * @param {Object}  config  The plugin's configuration object.
 * @constructor
 * @extends {ChromeCastPlugin}
 * @private
*/
function ChromeCastFlashPlugin() {
  ChromeCastFlashPlugin.__super__.constructor.call(this);
}


__extends(ChromeCastFlashPlugin, ChromeCastPlugin);


ChromeCastFlashPlugin.NAME = "ChromeCastFlashPlugin";

/** @override
*/
ChromeCastFlashPlugin.prototype.createModel = function() {
  this.proxy = new ChromeCastSenderProxy(this.config);
  this.registerProxy(this.proxy);
};

/** @override
*/
ChromeCastFlashPlugin.prototype.createController = function() {
  ChromeCastFlashPlugin.__super__.createController.call(this);
  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);
  this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);
  this.registerCommand(FeedNotifications.FEED_CHANGED, ChromeCastFeedChangedCommand);
  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);
  this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);
};

/** @override
*/
ChromeCastFlashPlugin.prototype.createView = function() {
  this.registerMediator(new ChromeCastSenderMediator());
};

/** @override
*/
ChromeCastFlashPlugin.prototype.listNotificationInterests = function() {
  return [FeedNotifications.FEED_CHANGED, Notifications.CHANGE_MEDIA, Notifications.PLAYBACK_TARGET_CHANGE];
};

/**
 * @enum {string}
 * @const
 * @private
*/

var ChromeCastNotifications = {
  LAUNCH: "launch",
  AVAILABILITY_CHANGE: "availabilitychange"
};

/**
 * @constructor
 * @extends {PluginWrapper}
 * @private
*/
function ChromeCastWrapper(player, init) {
  if (!ChromeCastPlugin.prototype.isSender()) {
    throw new Error("Chromecast not supported on this platform. Skipping plugin initialization.");
  }
  ChromeCastWrapper.__super__.constructor.call(this, player, init);
  this.plugin = new ChromeCastFlashPlugin();
  this.plugin.initialize(init, this.player);
  player.registerModule(this.plugin);
}


__extends(ChromeCastWrapper, PluginWrapper);


ChromeCastWrapper.NAME = "ChromeCastWrapper";

ChromeCastWrapper.prototype.buttonId = "chromecastBtn";

ChromeCastWrapper.prototype.plugin = null;

ChromeCastWrapper.prototype.flashView = {
  elements: {
    controls: {
      elements: {
        chromecastBtn: {}
      }
    }
  }
};

/**
*/
ChromeCastWrapper.prototype.listNotificationInterests = function() {
  return ChromeCastWrapper.__super__.listNotificationInterests.call(this).concat([FlashNotifications.ELEMENT_EVENT, FlashNotifications.LOAD_STATE_READY, FlashNotifications.LOAD_STATE_LOADING, FlashNotifications.APPLICATION_STATE_CHANGE, ChromeCastNotifications.AVAILABILITY_CHANGE]);
};

/**
*/
ChromeCastWrapper.prototype.handleNotification = function(notification) {
  var body, isReceiverAvailable, name, _ref;
  ChromeCastWrapper.__super__.handleNotification.call(this, notification);
  name = notification.getName();
  body = notification.getBody();
  switch (name) {
    case FlashNotifications.ELEMENT_EVENT:
      if (body.type === "click" && body.element === this.buttonId) {
        this.plugin.sendNotification(ChromeCastNotifications.LAUNCH);
      }
      break;
    case ChromeCastNotifications.AVAILABILITY_CHANGE:
      if (((_ref = this.player.mediaElement) != null ? _ref.setPlayerProperty : void 0) != null) {
        this.player.mediaElement.setPlayerProperty(this.buttonId, {
          visible: body
        });
      }
      break;
    case FlashNotifications.APPLICATION_STATE_CHANGE:
    case FlashNotifications.LOAD_STATE_READY:
    case FlashNotifications.LOAD_STATE_LOADING:
      isReceiverAvailable = this.plugin.isReceiverAvailable();
      if (isReceiverAvailable) {
        this.player.mediaElement.setPlayerProperty(this.buttonId, {
          state: 1
        });
      }
      this.player.mediaElement.setPlayerProperty(this.buttonId, {
        visible: isReceiverAvailable
      });
  }
};

/**
 * @expose
*/
ChromeCastWrapper.prototype.play = function() {
  this.plugin.play();
};

/**
 * @expose
*/
ChromeCastWrapper.prototype.pause = function() {
  this.plugin.pause();
};

/**
 * @param {Number}  value   The time in seconds to seek to.
 * @expose
*/
ChromeCastWrapper.prototype.setCurrentTime = function(value) {
  this.plugin.setCurrentTime(value);
  return value;
};

/**
 * Returns if The chromecast device's Availability
 * @expose
*/
ChromeCastWrapper.prototype.isReceiverAvailable = function() {
  return this.plugin.isReceiverAvailable();
};

ChromeCastWrapper.prototype.getMedia = function() {
  return this.plugin.getMedia();
};

ChromeCastWrapper.prototype.getSession = function() {
  return this.plugin.getSession();
};

ChromeCastWrapper.prototype.getMediaManager = function() {
  return this.plugin.getMediaManager();
};

ChromeCastWrapper.prototype.getCastReceiverManager = function() {
  return this.plugin.getCastReceiverManager();
};

ChromeCastWrapper.prototype.getCastMessageBus = function() {
  return this.plugin.getCastMessageBuses();
};

/**
 * sends a message across the message bus.
 *
 * @param {Object} msg
 * @expose
*/
ChromeCastWrapper.prototype.postMessage = function(msg) {
  this.plugin.postMessage(msg);
};

ChromeCastWrapper.prototype.launch = function() {
  this.plugin.launch();
};


AMP.registerPlugin("chromecast", "flash", ChromeCastWrapper);

/**
 * The HLSPlugin class.
 *
 * @param {Module}  app     The parent module of this plugin.
 * @constructor
 * @private
 * @extends {Plugin}
*/
function HLSPlugin() {
  HLSPlugin.__super__.constructor.call(this);
  Object.defineProperties(this, {
    instance: {
      get: this.getInstance,
      enumerable: true,
      configurable: false
    }
  });
}


__extends(HLSPlugin, Plugin);


HLSPlugin.prototype.moduleName = "hls";

/** @override
*/
HLSPlugin.prototype.createModel = function() {
  this.proxy = new HLSProxy(this.config);
  this.registerProxy(this.proxy);
};

HLSPlugin.prototype.createController = function() {
  this.registerCommand(AdNotifications.BREAK_START, HLSAdBreakStartCommand);
  HLSPlugin.__super__.createController.call(this);
};

/**
*/
HLSPlugin.prototype.logEvent = function(event) {
  if (/(hlsFragLoading|hlsFragLoaded)/.test(event.type) === true) {
    return;
  }
  HLSPlugin.__super__.logEvent.call(this, event);
};

/**
 * Returns HLS PlaybackProxy
 *
*/
HLSPlugin.prototype.getPlaybackProxy = function() {
  return this.proxy.playbackProxy;
};

/**
 * Returns instance of HLS player
 *
*/
HLSPlugin.prototype.getInstance = function() {
  return this.getPlaybackProxy().player;
};

/**
*/
HLSPlugin.prototype.listNotificationInterests = function() {
  return HLSPlugin.__super__.listNotificationInterests.call(this).concat([AdNotifications.BREAK_START]);
};

/**
*/
HLSPlugin.prototype.listNotificationPublications = function() {
  return HLSPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.TIMED_METADATA, Notifications.QUALITY_LEVELS_LOADED, Notifications.QUALITY_CHANGE, Notifications.QUALITY_CHANGING, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);
};


AMP.registerPlugin("hls", "html", HLSPlugin);

/**
 * Create a ChromeCastShim.
 * 
 * @param {?cast.receiver.CastReceiverManager.Config} config
 * @param {Object.<string, string>} messageBuses
*/
function ChromeCastShim(config, messageBuses) {
  var key, value;
  if (!/CrKey/.test(navigator.userAgent) || !(typeof cast !== "undefined" && cast !== null)) {
    return;
  }
  ChromeCastShim.__super__.constructor.call(this);
  this.castReceiverManager = cast.receiver.CastReceiverManager.getInstance();
  this.castReceiverManager.onReady = this.dispatchEvent.bind(this, {
    type: "ready"
  });
  this.castReceiverManager.onSenderConnected = this.dispatchEvent.bind(this, {
    type: "senderconnected"
  });
  this.castReceiverManager.onSenderDisconnected = this.dispatchEvent.bind(this, {
    type: "senderdisconnected"
  });
  this.castReceiverManager.onShutdown = this.dispatchEvent.bind(this, {
    type: "shutdown"
  });
  this.castReceiverManager.onStandbyChanged = this.dispatchEvent.bind(this, {
    type: "standbychange"
  });
  this.castReceiverManager.onSystemVolumeChanged = this.dispatchEvent.bind(this, {
    type: "systemvolumechanged"
  });
  this.castReceiverManager.onVisibilityChanged = this.dispatchEvent.bind(this, {
    type: "visibilitychanged"
  });
  this.player = new ChromeCastPlayer(this);
  this.mediaManager = new cast.receiver.MediaManager(this.player);
  if (!(messageBuses != null)) {
    messageBuses = {};
  }
  messageBuses[ChromeCastConstants.CHANNEL_ID] = cast.receiver.CastMessageBus.MessageType.JSON;
  this.castMessageBuses = {};
  for (key in messageBuses) {
    value = messageBuses[key];
    this.castMessageBuses[key] = this.castReceiverManager.getCastMessageBus(key, value);
    this.castMessageBuses[key].addEventListener("message", this.dispatchEvent.bind(this));
  }
  this.castReceiverManager.start(config);
  return;
}


__extends(ChromeCastShim, EventDispatcher);


/**
 * @type {cast.receiver.CastReceiverManager}
*/
ChromeCastShim.prototype.castReceiverManager = null;

/**
 * @type {cast.receiver.MediaManager}
*/
ChromeCastShim.prototype.mediaManager = null;

/**
 * @type {Object.<string, cast.receiver.CastMessageBus>}
*/
ChromeCastShim.prototype.castMessageBuses = null;

/**
 * @type {cast.receiver.media.Player}
*/
ChromeCastShim.prototype.player = null;

/**
*/
ChromeCastShim.prototype.isSender = function() {
  return !this.isReceiver() && /Chrome/.test(navigator.userAgent);
};

/**
*/
ChromeCastShim.prototype.isReceiver = function() {
  return /CrKey/.test(navigator.userAgent);
};

ChromeCastShim.getInstance = function() {
  return this.instance;
};

ChromeCastShim.instance = new ChromeCastShim();

function OctoshapeWrapper(player, config) {
  OctoshapeWrapper.__super__.constructor.call(this, player, config);
}


__extends(OctoshapeWrapper, PluginWrapper);


OctoshapeWrapper.NAME = "OctoshapeWrapper";

OctoshapeWrapper.prototype.flashPlugins = [
  {
    id: "OctoShapeStreamingPlugin",
    src: '#{paths.resources}plugins/infinitehd-osmf-plugin-1511180@v330-OSMF_1_6_MA.swf',
    host: "osmf",
    main: "com.octoshape.osmf.streamingplugin.OctoshapeStreamingPluginInfo"
  }
];


AMP.registerPlugin("octoshape", "flash", OctoshapeWrapper);

/**
 * The DASHPlugin class.
 *
 * @param {Module}  app     The parent module of this plugin.
 * @constructor
 * @private
 * @extends {Plugin}
*/
function DASHPlugin() {
  DASHPlugin.__super__.constructor.call(this);
  Object.defineProperties(this, {
    instance: {
      get: this.getInstance,
      enumerable: true,
      configurable: false
    }
  });
}


__extends(DASHPlugin, Plugin);


DASHPlugin.prototype.moduleName = "dash";

/** @override
*/
DASHPlugin.prototype.createModel = function() {
  this.proxy = new DASHProxy(this.config);
  this.registerProxy(this.proxy);
};

/**
 * Returns DASH PlaybackProxy
 *
*/
DASHPlugin.prototype.getPlaybackProxy = function() {
  return this.proxy.playbackProxy;
};

/**
 * Returns instance of DASH player
 *
*/
DASHPlugin.prototype.getInstance = function() {
  return this.getPlaybackProxy().player;
};

DASHPlugin.prototype.registered = function() {
  this.player.registerCommand(Notifications.CHANGE_DISPLAY_STATE, DASHChangeDisplayStateCommand);
  DASHPlugin.__super__.registered.call(this);
};

/**
*/
DASHPlugin.prototype.listNotificationPublications = function() {
  return DASHPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);
};


AMP.registerPlugin("dash", "html", DASHPlugin);

/** 
 * The OctoShapePlugin class.
 *   
 * @param {Module}  app     The parent module of this plugin.
 * @constructor
 * @private
 * @extends {Plugin}
*/
function OctoshapePlugin() {
  OctoshapePlugin.__super__.constructor.call(this);
}


__extends(OctoshapePlugin, Plugin);


OctoshapePlugin.prototype.moduleName = "octoshape";


AMP.registerPlugin("octoshape", "html", OctoshapePlugin);


var PromisePlugin = function (_EventDispatcher) {
  babelHelpers.inherits(PromisePlugin, _EventDispatcher);

  function PromisePlugin(player, config) {
    babelHelpers.classCallCheck(this, PromisePlugin);

    var _this = babelHelpers.possibleConstructorReturn(this, (PromisePlugin.__proto__ || Object.getPrototypeOf(PromisePlugin)).call(this));

    _this.player = player;
    _this.config = config || {};
    _this.logger = new LoggerConstructor(_this.debug)

    var events = Events.values;
    var prop = void 0,
        event = void 0;

    events.forEach(function (event) {
      prop = _this["on" + event];
      if (prop == null || typeof prop != "function") return;

      prop = _this["on" + event] = prop.bind(_this);
      _this.player.addEventListener(event, prop);
    });
    return _this;
  }

  babelHelpers.createClass(PromisePlugin, [{
    key: "bindHandlers",
    value: function bindHandlers(handlers) {
      var _this2 = this;

      if (handlers instanceof Array == false) handlers = [handlers];

      handlers.forEach(function (func) {
        _this2[func] = _this2[func].bind(_this2);
      });
    }
  }, {
    key: "debug",
    get: function get() {
      return this.config.debug != null ? this.config.debug : this.player.config.debug;
    }
  }], [{
    key: "create",
    value: function create(player, config) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          var plugin = new _this2(player, config);
          resolve(plugin);
        } catch (error) {
          reject(error);
        }
      });
    }
  }, {
    key: "factory",
    get: function get() {
      return this.create.bind(this);
    }
  }]);

  return PromisePlugin;
}(EventDispatcher);

var PromiseAdPlugin = function (_PromisePlugin) {
  babelHelpers.inherits(PromiseAdPlugin, _PromisePlugin);

  function PromiseAdPlugin(player, config) {
    babelHelpers.classCallCheck(this, PromiseAdPlugin);

    return babelHelpers.possibleConstructorReturn(this, (PromiseAdPlugin.__proto__ || Object.getPrototypeOf(PromiseAdPlugin)).call(this, player, config));
  }

  babelHelpers.createClass(PromiseAdPlugin, [{
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      this.player.sendNotification("ads" + event.type, event.detail);
      babelHelpers.get(PromiseAdPlugin.prototype.__proto__ || Object.getPrototypeOf(PromiseAdPlugin.prototype), "dispatchEvent", this).call(this, event);
    }
  }]);

  return PromiseAdPlugin;
}(PromisePlugin);

global["akamai"] = {
  "amp": {
    "AMP": AMP,
    "utils": {
      "Timer": Timer,
      "Utils": Utils,
      "QueryString": QueryString,
      "Logger": Logger.instance,
      "MRSSHelper": MRSSHelper
    },
    "Timer": Timer,
    "Utils": Utils,
    "Poller": Poller,
    "PlayState": PlayState,
    "DisplayState": DisplayState,
    "QueryString": QueryString,
    "Logger": Logger,
    "Config": Config,
    "XMLUtils": XMLUtils,
    "chromecast": {
      "ChromeCastShim": (typeof ChromeCastShim != "undefined") ? ChromeCastShim.getInstance() : null
    },
    "XHR": XHR,
    "Resource": Resource,
    "Media": MediaVO,
    "Authorization": Authorization,
    "Event": Event,
    "Events": Events,
    "EventDispatcher": EventDispatcher,
    "Plugin": PromisePlugin,
    "AdPlugin": PromiseAdPlugin
  }
};

if (typeof AdVO != "undefined")
  global["akamai"]["amp"]["AdVO"] = AdVO

if (typeof AdNotifications != "undefined") {
  global["akamai"]["amp"]["AdEvents"] = (function () {
    var key, value, events = {};
    events.values = [];
    for (key in AdNotifications) {
      value = AdNotifications[key].replace(/^ads/, "");
      events[key.replace(/^AD_/, "")] = value;
      events.values.push(value);
    }
    return events;
  }())
}

  /* End JS Lib
  */
  window["AKAMAI_MEDIA_PLAYER"].saveSDK(version, global);
}
window.AKAMAI_MEDIA_PLAYER.setVersion(version);
})();
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "0mmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoPlayer_js__ = __webpack_require__("ixIq");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Youtube Player 
    * Class that directly integrates the Youtube Player IFrame API
*/


var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


var YoutubePlayer = function (_VideoPlayer) {
    _inherits(YoutubePlayer, _VideoPlayer);

    function YoutubePlayer(config) {
        _classCallCheck(this, YoutubePlayer);

        var _this = _possibleConstructorReturn(this, _VideoPlayer.call(this, config));

        _this.config = config;
        _this.element = config.element;

        if (typeof window.hsnYouTubeQueue === 'undefined') {
            window.hsnYouTubeQueue = [];

            //youtube api calls this function on their callback
            window.onYouTubeIframeAPIReady = function () {
                var len = window.hsnYouTubeQueue.length;
                for (var x = 0; x < len; x++) {
                    var ytPlayer = window.hsnYouTubeQueue.shift();
                    if (ytPlayer) {
                        ytPlayer.init();
                    }
                }
            };
        }

        //load youtube api async
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        //if youtube YT already exists - initialize the player manually
        if (typeof YT !== 'undefined') {
            _this.init();
        } else {
            window.hsnYouTubeQueue.push(_this);
        }
        return _this;
    }

    YoutubePlayer.prototype.init = function init() {
        if (this.config !== null || this.config !== '') {
            //check events - if not available, create defaults
            if (!this.config.hasOwnProperty('events')) {
                this.config.events = {
                    'onReady': this.onYoutubePlayerReady,
                    'onStateChange': this.onPlayerStateChange.bind(this)
                };
            }
        } else {
            //add defaults if no setting object is provided
            this.config.height = 406;
            this.config.width = 720;
            this.config.playerVars = { 'autoplay': 0, 'controls': 1, 'fs': 1, 'modestbranding': 1, 'theme': 'light', 'rel': 0 };
        }

        this.videoPlayer = new YT.Player(this.config.element, {
            height: this.config.height,
            width: this.config.width,
            videoId: this.config.videoId,
            playerVars: this.config.playerVars,
            events: this.config.events
        });
    };

    YoutubePlayer.prototype.play = function play() {
        this.videoPlayer.playVideo();
    };

    YoutubePlayer.prototype.pause = function pause() {
        if (this.videoPlayer && this.videoPlayer.pauseVideo) {
            this.videoPlayer.pauseVideo();
        }
    };

    YoutubePlayer.prototype.stop = function stop() {
        try {
            this.videoPlayer.end();
        } catch (e) {}
    };

    YoutubePlayer.prototype.getVolume = function getVolume() {
        return this.videoPlayer.getVolume();
    };

    YoutubePlayer.prototype.setVolume = function setVolume(volume) {
        this.videoPlayer.setVolume(volume);
    };

    YoutubePlayer.prototype.onTimeUpdate = function onTimeUpdate() {
        return Math.round(getCurrentTime());
    };

    YoutubePlayer.prototype.getCurrentTime = function getCurrentTime() {
        return this.videoPlayer.getCurrentTime();
    };

    YoutubePlayer.prototype.setCurrentTime = function setCurrentTime(time) {
        this.videoPlayer.seekTo(time, true);
    };

    YoutubePlayer.prototype.getDuration = function getDuration() {
        return this.videoPlayer.getDuration();
    };

    YoutubePlayer.prototype.onYoutubePlayerReady = function onYoutubePlayerReady(event) {
        event.target.setPlaybackQuality('hd720');
    };

    YoutubePlayer.prototype.onPlayerStateChange = function onPlayerStateChange(event) {
        switch (event.data) {
            case 0:
                //video end
                HSN.Instance().Events.Trigger(HSN.Application.EVENT.VIDEO_COMPLETE, this);
                break;
            case 1:
                //playing
                _VideoPlayer.prototype.throwAnalyticEvent.call(this, this.config.category, this.config.name, this.config.label);
                break;
            case 2:
                //paused
                break;
        }
    };

    YoutubePlayer.prototype.getPlayer = function getPlayer() {
        return this.videoPlayer;
    };

    YoutubePlayer.prototype.destroy = function destroy() {
        this.videoPlayer.destroy();
    };

    return YoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_1__VideoPlayer_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (YoutubePlayer);

/***/ }),

/***/ "0njC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CSReportModal
*
* Encapsulates the functionality of a modal dialog for creating/updating user nickname
**/
HSN.CSReportModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CSReportModal, parent);

    /**
    * new HSN.CSReportModal()
    **/
    function CSReportModal() {
        this.name = 'HSN.CSReportModal';

        return CSReportModal.__super__.constructor.call(this);
    }

    /**
    * HSN.CSReportModal#Show() -> void
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    CSReportModal.prototype._show = function () {
        var scope = this;

        $.ajax({
            type: 'GET',
            url: "/customer-service?" + new Date().getTime(),
            dataType: 'html',
            success: function success(data) {
                scope.Root.removeClass('loading');

                scope.DisplayModal(data, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for modal form, use ajax to retrieve response, and update modal content
    **/
    CSReportModal.prototype.SubmitForm = function () {
        var scope = this;

        var form = $('form', scope.Content);

        //manually run client validation since we arent running submit operation
        if (!form.valid()) return;

        $.ajax({
            type: 'POST',
            url: '/nickname?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: form.serialize()
        }).done(function (data) {
            scope.DisplayModal(data, 0);
        }).fail(function () {
            alert('error submitting review');
        });
    };

    CSReportModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            //needed for unobtrusive client side validation for ajax loaded form
            $.validator.unobtrusive.parse($('form', scope.Content));
            scope.Center();
            scope.Content.animate({ opacity: 1 });
            //handle any tooltips loaded
            if (!Modernizr.touchevents) {
                HSN.Tooltip(scope.Content.find("[data-tooltip]"));
            }
        }, function () {
            //scope.Center();
        });
    };

    return CSReportModal;
}(HSN.Modal);

/***/ }),

/***/ "0xhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_MOBILE_Gap_js__ = __webpack_require__("IPPN");


HSN.Gap = function (config) {
    var percentFire = 1.0;
    var randNum = Math.random() * 100;
    var message = '"HSN.Gap is deprecated.  Move to new Gap es2015 module.';

    if (randNum <= percentFire) {
        HSN.DataLayer.helpers.metricEvent(null, "JS:INFO", message, null, null, true);
    }

    console.warn(message);
    return __WEBPACK_IMPORTED_MODULE_0_MOBILE_Gap_js__["default"];
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("MU8w");
module.exports = __webpack_require__("Ijvh");


/***/ }),

/***/ "14+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ContentModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.ContentModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ContentModal, _super);

    /**
    * new HSN.ContentModal()
    **/
    function ContentModal() {
        this.elementName = '#';
        this.name = 'HSN.ContentModal';

        return ContentModal.__super__.constructor.call(this);
    }

    ContentModal.prototype._hide = function () {};

    /**
    * HSN.ContentModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ContentModal.prototype._show = function (url) {
        var __scope = this;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            success: function success(data, status, xhr) {
                __scope.Root.removeClass('loading');
                data += '<div class="endOfModal" tabindex="0"></div>';
                __scope.DisplayModal(data, 0);
                $('#modalPopup').on('focus', function () {
                    $('.modal-content-container').focus();
                });
                $('.endOfModal').on('focus', function () {
                    $('#closeModal').focus();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    ContentModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time, function () {
            var elemetToFocus = __scope.Root.find('#modalPopup');
            __scope.Center();
            __scope.Content.animate({ opacity: 1 }, function () {
                __scope.SetFocus(elemetToFocus);
            });
        }, function () {
            //__scope.Center();
        });
    };

    return ContentModal;
}(HSN.Modal);

/***/ }),

/***/ "1dmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.GenericConfirmModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.GenericConfirmModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(GenericConfirmModal, parent);

    function GenericConfirmModal(config) {
        var modal = GenericConfirmModal.__super__.constructor.call(this, 'generic-confirm-modal');

        this.keys = __WEBPACK_IMPORTED_MODULE_3_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
        this.callbackok = null;
        this.callbackcancel = null;
        this.inputdata = {};

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Content).on('click', '#confirm-ok', function (e) {
            if (modal.callbackok) {
                modal.callbackok(e);
            }
            $(this).off('click');
            closeModal(modal);
            return false;
        });

        $(modal.Content).on('click', '#confirm-cancel', function (e) {
            if (modal.callbackcancel) {
                modal.callbackcancel(e);
            }
            $(this).off('click');
            closeModal(modal);
            return false;
        });

        $(modal.Close).on('click', function (e) {
            if (modal.callbackcloseclick) {
                modal.callbackcloseclick(e);
            }
            closeModal(modal);
            return false;
        });

        $(modal.Close).on('keyup', function (e) {
            var key = e.keyCode || e.which;

            if (key === modal.keys.enter) {
                if (modal.callbackcloseclick) {
                    modal.callbackcloseclick(e);
                }

                closeModal(modal);
            }

            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    callbackok: null;
    callbackcancel: null;
    callbackcloseclick: null;
    callbackerror: null;
    inputdata: {};

    /**
    * HSN.GenericConfirmModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    GenericConfirmModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    GenericConfirmModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    GenericConfirmModal.prototype.SetCloseClickCallback = function (callbackCloseClick) {
        this.callbackcloseclick = callbackCloseClick;
    };
    GenericConfirmModal.prototype.SetInputData = function (inputData) {
        this.inputdata = inputData;
    };
    GenericConfirmModal.prototype.SetErrorCallback = function (callbackError) {
        this.callbackerror = callbackError;
    };
    GenericConfirmModal.prototype._show = function (url) {
        var scope = this;
        scope.AddLoadingSpinner();
        $.ajax(url + '/Get?' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            data: this.inputdata,
            success: function success(data) {
                scope.RemoveLoadingSpinner();
                scope.Root.removeClass('loading');
                scope.Content.showHtml(data, 0, function () {
                    var elemetToFocus = scope.Root.find('#modalPopup');
                    scope.Center();
                    scope.Content.animate({ opacity: 1 }, function () {
                        scope.SetFocus(elemetToFocus);
                    });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(scope.Content.find('[data-tooltip]'));
                    }
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                if (scope.callbackerror) {
                    scope.callbackerror();
                }
                scope.RemoveLoadingSpinner();
                scope.Hide();
            }
        });
    };

    return GenericConfirmModal;
}(HSN.Modal);

/***/ }),

/***/ "2HwW":
/***/ (function(module, exports) {

/*
 * Super simple javascript class extension taken from CoffeeScript
 * https://coffeescript.org/#classes
 */
__hasProp = {}.hasOwnProperty,
__extends = function(child, parent)
{
  for (var key in parent)
  {
    if (__hasProp.call(parent, key))
      child[key] = parent[key];
  }
  function ctor()
  {
    this.constructor = child;
  }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor;
  child.__super__ = parent.prototype;
  return child;
};


/*** EXPORTS FROM exports-loader ***/
module.exports = __extends;

/***/ }),

/***/ "2VHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// define EVENTs


/**
* class HSN.SignInModal
    
**/
HSN.SignInModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(SignInModal, parent);

    var modalCallback;

    function SignInModal() {
        var modal = SignInModal.__super__.constructor.call(this, "sign-in-modal");

        this.name = 'HSN.SignInModal';
        this.Close.off(); //remove existing handler, have our own
        this.application = HSN.Instance();
        this.deviceInformation = HSN.Instance().DeviceInformation;
        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });

        modal.application.Events.On(__WEBPACK_IMPORTED_MODULE_4_HSNDIR_Events_js__["a" /* default */].Widget.Signin.FORGOT_PASSWORD_INITIATED, function (data) {
            var forgotPasswordUrl = '/account/forgot-password-verify';
            if (modal.deviceInformation.IsNativeApp) {
                forgotPasswordUrl = __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(forgotPasswordUrl);
                __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(forgotPasswordUrl));
            } else {
                window.location = forgotPasswordUrl;
            }
        });
        modal.application.Events.On(__WEBPACK_IMPORTED_MODULE_4_HSNDIR_Events_js__["a" /* default */].Widget.Signin.NEW_CUSTOMER_INITIATED, function () {
            closeModal(modal);
            var createAccountUrl = modal.isCheckout ? '/checkout/account/create' : '/account/create';
            if (modal.deviceInformation.IsNativeApp) {
                createAccountUrl = __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(createAccountUrl);
                __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(createAccountUrl));
            } else {
                window.location = createAccountUrl;
            }
        });
        modal.application.Events.On(__WEBPACK_IMPORTED_MODULE_4_HSNDIR_Events_js__["a" /* default */].Widget.Signin.COMPLETE, function (data) {
            if (modal.deviceInformation.IsNativeApp) {
                var url = __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(data.returnUrl);
                __WEBPACK_IMPORTED_MODULE_2_MOBILE_Gap_js__["default"].ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(url));
            } else {
                window.location = data.returnUrl;
            }
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    SignInModal.prototype._show = function (isCheckout, doCommunity, config) {
        var _this = this;

        var scope = this;
        scope.AddLoadingSpinner();
        scope.isCommunity = typeof doCommunity != 'undefined' ? doCommunity : false;
        scope.isCheckout = typeof isCheckout != 'undefined' ? isCheckout : false;
        if (typeof config != 'undefined' && config != null) {
            modalCallback = config.callback;
        }

        var signinWidgetPromise = __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "X5xP"));

        var ajax = $.ajax('/signin?ts=' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            data: { isCommunity: scope.isCommunity, isCheckout: scope.isCheckout }
        });

        Promise.all([ajax, signinWidgetPromise]).then(function (_ref) {
            var data = _ref[0],
                SigninWidget = _ref[1];

            scope.RemoveLoadingSpinner();
            var __scope = _this;
            __scope.Root.find('#modal-loading').remove();
            _this.Content.showHtml(data, 0, function () {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 });
            }, function () {});
        }).catch(function (x) {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
            scope.RemoveLoadingSpinner();
            scope.Hide();
        });
    };
    return SignInModal;
}(HSN.Modal);

/***/ }),

/***/ "2Xce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ShowDetailsModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.ShowDetailsModalv2 = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ShowDetailsModalv2, parent);

    function ShowDetailsModalv2(config) {
        var modal = ShowDetailsModalv2.__super__.constructor.call(this);

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#show-detail-ok', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    callbackok: null;
    callbackcancel: null;

    /**
    * HSN.ShowDetailsModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    ShowDetailsModalv2.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    ShowDetailsModalv2.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    ShowDetailsModalv2.prototype._show = function (data) {
        $.ajax('/watch/program-guide/showdetails' + "?" + new Date().getTime(), {
            context: this,
            dataType: 'html',
            data: data,
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                    }
                    var elemetToFocus = __scope.Content.find('#current-show-title');
                    __scope.SetFocus(elemetToFocus);
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return ShowDetailsModalv2;
}(HSN.Modal);

/***/ }),

/***/ "2wgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.BaseballCardModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.BaseballCardModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(BaseballCardModal, parent);

    function BaseballCardModal(config) {
        var modal = BaseballCardModal.__super__.constructor.call(this, "baseball-card");
        var baseUrl = config.baseUrl || '';

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);
        var loaderUrl = HSN.Instance().UseFullyQualifiedUrls() ? baseUrl + '/assets/img/spinner-l-d8d9d9.gif' : '/assets/img/spinner-l-d8d9d9.gif';
        var loader = $('<div id="loader" class="loader"><img alt="" src="' + loaderUrl + '"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#baseball-card-modal', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();

        cmCreateManualLinkClickTag('cm_re=cm_re=Arcade-_-Profile-_-Close&cm_sp=cm_re=Arcade-_-Profile-_-Close', 'CloseArcadeDrawer');
    }

    callbackok: null;
    callbackcancel: null;

    BaseballCardModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    BaseballCardModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    BaseballCardModal.prototype._show = function (name, baseUrl) {
        $('.video-flash').css('visibility', 'hidden');
        var host = baseUrl || '';

        this.Center();

        var scope = this;
        var successCallback = function successCallback(data) {
            scope.Root.removeClass('loading');

            if (data != null && data != "") {
                scope.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(scope.Content.find("[data-tooltip]"));
                    }
                }, function () {
                    //scope.Center();
                });
            } else {
                $('#modal-mask').remove();
            }
        };

        var failureCallback = function failureCallback(xhr, status, error) {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
            $('#modal-mask').remove();
        };

        var url = name == null || name == "" ? '/baseballcard' : "/baseballcard/" + name;
        url = HSN.Instance().UseFullyQualifiedUrls() ? host + url : url;

        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        //Arcade object existence indicates that we are on the arcade wrapper page
        if (arcadeObjectName !== null) {
            window.location = host + "/profile/" + name;
        } else {
            $.ajax(url, {
                cache: false,
                context: this,
                dataType: 'html',
                success: successCallback,
                error: failureCallback
            }).done(function () {
                $('#modalPopup').focus();
            });
        }
    };

    return BaseballCardModal;
}(HSN.Modal);

/***/ }),

/***/ "3MDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ProgramGuidePrintModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.ProgramGuidePrintModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ProgramGuidePrintModal, parent);

    function ProgramGuidePrintModal(config) {
        var modal = ProgramGuidePrintModal.__super__.constructor.call(this);

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            modal.Hide();
        });
    }

    callbackok: null;
    callbackcancel: null;

    /**
    * HSN.ProgramGuidePrintModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    ProgramGuidePrintModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    ProgramGuidePrintModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    ProgramGuidePrintModal.prototype._show = function (data) {
        $.ajax('/watch/program-guide/print', {
            context: this,
            dataType: 'html',
            data: data,
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');
                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    var elemetToFocus = __scope.Content.find('#print-view-select');
                    __scope.SetFocus(elemetToFocus);
                }, function () {});
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };
    return ProgramGuidePrintModal;
}(HSN.Modal);

/***/ }),

/***/ "4LBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* class HSN.ResponsiveCells
*
* Provides the functions to make CMS content cells responsive.
**/
HSN.ResponsiveCells = function (config) {
    /**
        * new HSN.ResponsiveCell(config)
        * - config (Object): A configuration object for the [[HSN.ResponsiveCell]
        **/
    var scope = this;

    config = config = config || {};

    // Get Mobile Info if available
    if (window.HSN) {
        var deviceInfo = HSN.Instance().DeviceInformation;
        if (deviceInfo) {
            if (deviceInfo.IsMobile && !deviceInfo.IsTablet) this.showPhone = true;
        }
    }

    scope.HandleWindowResize();
    scope.TextResize('.TextContainer', '.rText');
    scope.ButtonResize('.rButton', '.rText');

    // Setup watcher
    $(window).resize(function () {
        scope.HandleWindowResize(false);
        scope.TextResize('.TextContainer', '.rText');
        scope.ButtonResize('.rButton', '.rText');
    });
    //}
};

HSN.ResponsiveCells.prototype = {
    showPhone: null,
    isFeatureCell: null,
    isSpotlight: null,
    /**
    * HSN.ResponsiveCell#HandleWindowResize(firstRun) -> void
    *
    * Handle window resizes and adjust the cell's contents.
    **/
    HandleWindowResize: function HandleWindowResize() {
        if (this.showPhone) {
            $('.YesPhone').show();
            $('.NoPhone').hide();

            $('.ResSwapper').each(function () {
                $(this).attr('src', $(this).data('src-mobile'));
            });
        } else {
            $('.YesPhone').hide();
            $('.NoPhone').show();

            $('.ResSwapper').each(function () {
                $(this).attr('src', $(this).data('src'));
            });
        }
    },
    TextResize: function TextResize(parents, children) {
        var isPersonalizedCell = $('#content-wrapper.personalized-cell').length;
        var isSpotlight = $('#content-wrapper .ResponsiveCard').length;
        $(parents + ' ' + children).each(function () {
            var me = $(this);
            if (isPersonalizedCell && isSpotlight) {
                me.css('font-size', '75px');
                me.css('line-height', '75px');
            }
            var myParents = me.parents(parents);
            // Get stored font size, or if this is our first run, get the current base css style font-size
            var fontSize = me.data('fs');
            if (!fontSize) {
                fontSize = parseInt(me.css('font-size'));
                me.data('fs', fontSize);
            }
            // If we have a lineheight, use that, else use the font-size
            var lineHeight = me.data('lh');
            if (!lineHeight) {
                lineHeight = parseInt(me.css('line-height'));

                if (isNaN(lineHeight) || lineHeight == '') lineHeight = fontSize;

                me.data('lh', lineHeight);
            }
            // Font Sizes and Line Heights are set based on 1000px width base elements
            var factor = myParents.width() / 1000.0;
            this.style.fontSize = parseFloat(fontSize) * factor + 'px';
            this.style.lineHeight = parseFloat(lineHeight) * factor + 'px';
            this.style.visibility = 'visible';
        });
    },
    ButtonResize: function ButtonResize(parents, children) {
        $(parents + ' ' + children).each(function () {
            var me = $(this);
            var fontSize = parseInt(me.css('font-size'));
            var padX = fontSize / 2;
            var padY = fontSize;
            me.css('padding', padX + 'px ' + padY + 'px');
        });
    },
    StaticReRunDefault: function StaticReRunDefault() {
        // Get Mobile Info if available
        if (this.showPhone === null && window.HSN) {
            var deviceInfo = HSN.Instance().DeviceInformation;
            if (deviceInfo) {
                if (deviceInfo.IsMobile && !deviceInfo.IsTablet) this.showPhone = true;
            }
        }

        this.HandleWindowResize(false);
        this.TextResize('.TextContainer', '.rText');
        this.ButtonResize('.rButton', '.rText');
    }
};

/***/ }),

/***/ "4fo5":
/***/ (function(module, exports) {

﻿(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       can accounts for vertical position, horizontal, or both
     */
    var $w=$(window);
    $.fn.visible = function(partial,hidden,direction,container){

        if (this.length < 1)
            return;
	
	// Set direction default to 'both'.
	direction = direction || 'both';
	    
        var $t          = this.length > 1 ? this.eq(0) : this,
						isContained = typeof container !== 'undefined' && container !== null,
						$c				  = isContained ? $(container) : $w,
						wPosition        = isContained ? $c.position() : 0,
            t           = $t.get(0),
            vpWidth     = $c.outerWidth(),
            vpHeight    = $c.outerHeight(),
            clientSize  = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = isContained ?
												rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top :
												rec.top >= 0 && rec.top < vpHeight,
                bViz = isContained ?
												rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top :
												rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = isContained ?
												rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left :
												rec.left >= 0 && rec.left <  vpWidth,
                rViz = isContained ?
												rec.right - wPosition.left > 0  && rec.right < vpWidth + wPosition.left  :
												rec.right > 0 && rec.right <= vpWidth,
                vVisible   = partial ? tViz || bViz : tViz && bViz,
                hVisible   = partial ? lViz || rViz : lViz && rViz,
		vVisible = (rec.top < 0 && rec.bottom > vpHeight) ? true : vVisible,
                hVisible = (rec.left < 0 && rec.right > vpWidth) ? true : hVisible;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var viewTop 				= isContained ? 0 : wPosition,
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $c.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                position          = $t.position(),
                _top            = position.top,
                _bottom         = _top + $t.height(),
                _left           = position.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }
    };

})(jQuery);

/***/ }),

/***/ "4plx":
/***/ (function(module, exports) {

/*! https://mths.be/placeholder v2.0.7 by @mathias */
; (function (window, document, $) {

    var isInputSupported = 'placeholder' in document.createElement('input'),
	    isTextareaSupported = 'placeholder' in document.createElement('textarea'),
	    prototype = $.fn,
	    valHooks = $.valHooks,
	    hooks,
	    placeholder;

    if (isInputSupported && isTextareaSupported) {

        placeholder = prototype.placeholder = function () {
            return this;
        };

        placeholder.input = placeholder.textarea = true;

    } else {

        placeholder = prototype.placeholder = function () {
            var $this = this;
            $this
				.filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]')
				.not('.placeholder')
				.on({
				    'focus.placeholder': clearPlaceholder,
				    'blur.placeholder': setPlaceholder
				})
				.data('placeholder-enabled', true)
				.trigger('blur.placeholder');
            return $this;
        };

        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;

        hooks = {
            'get': function (element) {
                var $element = $(element);
                return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
            },
            'set': function (element, value) {
                var $element = $(element);
                if (!$element.data('placeholder-enabled')) {
                    return element.value = value;
                }
                if (value == '') {
                    element.value = value;
                    // Issue #56: Setting the placeholder causes problems if the element continues to have focus.
                    if (element != document.activeElement) {
                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
                        setPlaceholder.call(element);
                    }
                } else if ($element.hasClass('placeholder')) {
                    clearPlaceholder.call(element, true, value) || (element.value = value);
                } else {
                    element.value = value;
                }
                // `set` can not return `undefined`; see https://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };

        isInputSupported || (valHooks.input = hooks);
        isTextareaSupported || (valHooks.textarea = hooks);

        $(function () {
            // Look for forms
            $(document).on('submit.placeholder', 'form', function () {
                // Clear the placeholder values so they don't get submitted
                var $inputs = $('.placeholder', this).each(clearPlaceholder);
                setTimeout(function () {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });

        // Clear placeholder values upon page reload
        $(window).on('beforeunload.placeholder', function () {
            $('.placeholder').each(function () {
                this.value = '';
            });
        });

    }

    function args(elem) {
        // Return an object of element attributes
        var newAttrs = {},
		    rinlinejQuery = /^jQuery\d+$/;
        $.each(elem.attributes, function (i, attr) {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });
        return newAttrs;
    }

    function clearPlaceholder(event, value) {
        var input = this,
		    $input = $(input);
        if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
            if ($input.data('placeholder-password')) {
                $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id'));
                // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) {
                    return $input[0].value = value;
                }
                $input.focus();
            } else {
                input.value = '';
                $input.removeClass('placeholder');
                input == document.activeElement && input.select();
            }
        }
    }

    function setPlaceholder() {
        var $replacement,
		    input = this,
		    $input = $(input),
		    $origInput = $input,
		    id = this.id;
        if (input.value == '') {
            if (input.type == 'password') {
                if (!$input.data('placeholder-textinput')) {
                    try {
                        $replacement = $input.clone().attr({ 'type': 'text' });
                    } catch (e) {
                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
                    }
                    $replacement
						.removeAttr('name')
						.data({
						    'placeholder-password': true,
						    'placeholder-id': id
						})
						.on('focus.placeholder', clearPlaceholder);
                    $input
						.data({
						    'placeholder-textinput': $replacement,
						    'placeholder-id': id
						})
						.before($replacement);
                }
                $input = $input.removeAttr('id').hide().prev().attr('id', id).show();
                // Note: `$input[0] != input` now!
            }
            $input.addClass('placeholder');
            $input[0].value = $input.attr('placeholder');
        } else {
            $input.removeClass('placeholder');
        }
    }

}(this, document, jQuery));

/***/ }),

/***/ "5KJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.Service.FavoriteService
    *
    * Provides an abstracted interface for favoriting or unfavoriting an object.
    **/
HSN.Service.FavoriteService = function () {
    /**
        * new HSN.Service.FavoriteService()
        **/
    this.debug = false; //print out debugging messages during execution
    this.favoritedClass = 'favorited';
    this.favoriteQueriedClass = 'favorite-queried';
    this.favoriteTooltip = 'Add to Favorites';
    this.unfavoriteTooltip = 'Remove from Favorites';

    if (typeof window.console === "undefined") {
        window.console = {
            log: function log() {}
        };
    }
};

/**
* HSN.Service.FavoriteService.OBJECT_TYPE = Object
*
* An enumeration of object types that can be favorited:
* - PRODUCT: A product.
* - BRAND: A brand.
**/
HSN.Service.FavoriteService.OBJECT_TYPE = {
    PRODUCT: 1,
    BRAND: 2
};

HSN.Service.FavoriteService.prototype = {
    /**
        * HSN.Service.FavoriteService#Favorite(objectType, objectId, config) -> void
        * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being favorited.
        * - objectId (String): The identifier of the object to favorite.
        * - webId (String): The variant of the object to favorite if favoriting product.
        * - config (Object): A configuration object for the call
        *   consisting of the following keys:
        *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
        *   - scope (Object): The scope to execute the callback function in.
        *
        * Favorites the given object with the backend Favorite service and then
        * calls the callback, if given with the success or failure status of the call.
        **/
    Favorite: function Favorite(objectType, objectId, webId, config) {
        this._toggleFavorite(objectType, objectId, webId, config);
    },

    /**
        * HSN.Service.FavoriteService#Unfavorite(id, config) -> void
        * HSN.Service.FavoriteService#Unfavorite(objectType, objectId, config) -> void
        * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being unfavorited.
        * - objectId (String): The identifier of the object to unfavorite.
        * - webId (String): The variant of the object to favorite if favoriting product.
        * - config (Object): A configuration object for the call
        *   consisting of the following keys:
        *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
        *   - scope (Object): The scope to execute the callback function in.
        *
    * Unfavorites the given object with the backend Favorite service and then
        * calls the callback, if given with the success or failure status of the call.
        **/
    Unfavorite: function Unfavorite(objectType, objectId, webId, config) {
        this._toggleFavorite(objectType, objectId, webId, config);
    },

    CheckForFavorites: function CheckForFavorites(selector) {
        var favoriteLinks = $(selector);
        if (!favoriteLinks.length) {
            return;
        }
        var scope = this;

        if (Modernizr.sessionstorage) {
            if (sessionStorage["hasCheckedFavorites"] !== 'true') {
                sessionStorage["hasCheckedFavorites"] = 'true';
                $.ajax('/account/favorites/all-favorites', {
                    context: this,
                    dataType: 'json',
                    type: 'GET',
                    success: function success(data) {
                        if (data) {
                            if (data.FavoriteProducts) {
                                data.FavoriteProducts.forEach(function (favoriteProduct) {
                                    var objectType = HSN.Service.FavoriteService.OBJECT_TYPE.PRODUCT;
                                    var productId = 'fav-' + objectType + '-';
                                    productId += favoriteProduct.ProductId;

                                    sessionStorage[productId] = favoriteProduct.VariantId || 'true';
                                });
                            }

                            if (data.FavoriteBrands) {
                                data.FavoriteBrands.forEach(function (favoriteBrand) {
                                    var objectType = HSN.Service.FavoriteService.OBJECT_TYPE.BRAND;
                                    var brandId = 'fav-' + objectType + '-';
                                    brandId += favoriteBrand;

                                    sessionStorage[brandId] = 'true';
                                });
                            }

                            favoriteLinks.each(function () {
                                scope.UpdateFavoriteLink($(this));
                            });
                        }
                    }
                });
            } else {
                favoriteLinks.each(function () {
                    scope.UpdateFavoriteLink($(this));
                });
            }

            var favorites = scope._getAllFavoritesFromStorage();
            $.each(favorites, function () {
                var favorite = this;

                HSN.Instance().Events.Trigger(HSN.Application.EVENT.FAVORITE_INITIALIZED, favorite.objectType, favorite.objectId, favorite.webId);
            });
        } else {
            var favoritesList = [];
            favoriteLinks.each(function () {
                var $fav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                var objectType = $fav.data('object-type');
                var objectId = $fav.data('object-id');

                var favoriteObject = { objectType: objectType, objectId: objectId };
                var alreadyExist = $.grep(favoritesList, function (favorite) {
                    return favorite.objectType === objectType && favorite.objectId === objectId;
                }).length > 0;

                if (!alreadyExist) {
                    favoritesList.push(favoriteObject);
                }
            });

            $(document).ready(function () {
                var $favoritesList = $(favoritesList);
                var favoritesRequest = $favoritesList.map(function () {
                    return this.objectType + "-" + this.objectId;
                }).toArray();

                $.ajax('/account/favorites/are-items-favorites', {
                    context: this,
                    data: { ids: JSON.stringify(favoritesRequest) },
                    type: 'POST',
                    dataType: 'json',
                    success: function success(data) {
                        $favoritesList.each(function (index) {
                            var favorite = this;
                            var value = data.favorites[index];
                            var isFavorited = value > 0;
                            var isVariant = value > 1;
                            var favoriteValue = isVariant ? value : isFavorited ? "true" : null;

                            if (isFavorited) {
                                favoriteLinks.filter(function () {
                                    return $(this).data("object-type") === favorite.objectType && $(this).data("object-id") === favorite.objectId;
                                }).each(function () {
                                    scope.UpdateFavoriteLink($(this), favoriteValue);
                                });

                                var webId = isVariant ? favoriteValue : null;
                                HSN.Instance().Events.Trigger(HSN.Application.EVENT.FAVORITE_INITIALIZED, favorite.objectType, favorite.objectId, webId);
                            }
                        });
                    }
                });
            });
        }
    },

    UpdateFavoriteLink: function UpdateFavoriteLink($favoriteLink, favoriteValue) {
        var scope = this;

        if (!$favoriteLink || $favoriteLink.length == 0) {
            return;
        }

        $.each($favoriteLink, function () {
            var isFavoriteProduct;
            var favoriteIsVariant;
            var linkObjectId = $(this).data('object-id');
            var linkObjectType = $(this).data('object-type');
            var linkVariantId = $(this).data('web-id');
            var favoriteId = 'fav-' + linkObjectType + '-' + linkObjectId;
            var favoriteKeyValue;
            var favoritedVariantId;
            var isSaveChangesLink = $(this).hasClass('save-changes');
            var variantSpecificFavorLink = $(this).data('variant-specific-favorite-link');

            if (!favoriteValue) {
                if (Modernizr.sessionstorage) {
                    favoriteKeyValue = sessionStorage.getItem(favoriteId);
                } else {
                    //no browser storage, fallback to link value
                    favoriteKeyValue = scope._getFavoriteValueFromLink($(this));
                }
            } else {
                favoriteKeyValue = favoriteValue;
            }

            favoriteIsVariant = $.isNumeric(favoriteKeyValue); //product has a variant favorited
            favoritedVariantId = favoriteIsVariant ? favoriteKeyValue : null;

            if (variantSpecificFavorLink) {
                isFavoriteProduct = favoriteKeyValue == linkVariantId; //only favorite if webid matches from link to favorited webid
            } else {
                isFavoriteProduct = favoriteKeyValue != null;
            }

            if (isFavoriteProduct) {
                $(this).addClass(scope.favoritedClass).data('tooltip', scope.unfavoriteTooltip);
                $(this).attr('aria-label', scope.unfavoriteTooltip);
                if (favoriteIsVariant) {
                    $(this).data('favorite-web-id', favoritedVariantId);
                    $(this).attr('data-favorite-web-id', favoritedVariantId);
                } else {
                    $(this).removeData('favorite-web-id');
                    $(this).removeAttr('data-favorite-web-id');
                }

                if (linkVariantId && linkVariantId != favoritedVariantId) {
                    //variant favorited is different from variant of link
                    if (isSaveChangesLink) {
                        $(this).data('tooltip', "Update Favorite").show();
                    } else {
                        $(this).hide();
                    }
                } else {
                    if (isSaveChangesLink) {
                        $(this).hide();
                    } else {
                        $(this).data('tooltip', scope.unfavoriteTooltip).show();
                    }
                }
            } else {
                $(this).removeClass(scope.favoritedClass).data('tooltip', scope.favoriteTooltip);
                $(this).attr('aria-label', scope.favoriteTooltip);
            }

            $(this).addClass(scope.favoriteQueriedClass);
        });
    },

    _getFavoriteValueFromLink: function _getFavoriteValueFromLink($favoriteLink) {
        var $favLink;
        var favoriteVariantId;

        if (!$favoriteLink || $favoriteLink.length == 0) {
            return null;
        }
        $favLink = $($favoriteLink[0]);
        if ($favLink.hasClass(this.favoritedClass)) {
            favoriteVariantId = $favLink.data('favorite-web-id');
            if (favoriteVariantId) {
                return favoriteVariantId;
            } else {
                return 'true';
            }
        }
        return null;
    },

    _send: function _send(url, data, config) {
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        var promise = $.ajax(url, {
            context: this,
            data: data,
            dataType: 'json',
            type: 'POST'
        });

        return promise;
    },

    _getAllFavoritesFromStorage: function _getAllFavoritesFromStorage() {
        var scope = this;

        var allFavorites = [];
        for (var i = 0; i < sessionStorage.length; i++) {
            var key = sessionStorage.key(i);
            var favorite = scope._getFavoriteFromStorage(key);
            if (favorite) {
                allFavorites.push(favorite);
            }
        }

        return allFavorites;
    },

    _getFavoriteFromStorage: function _getFavoriteFromStorage(key) {
        var favoriteSplit = key.split('-');
        if (favoriteSplit[0] !== "fav") {
            return false;
        }
        var objectType = favoriteSplit[1];
        var objectId = favoriteSplit[2];

        var value = sessionStorage[key];
        if (!value) {
            return false;
        }
        var webId = $.isNumeric(value) ? value : null;

        return { objectType: objectType, objectId: objectId, webId: webId };
    },

    _updateStorage: function _updateStorage(key, value) {
        if (Modernizr.sessionstorage) {
            if (value) {
                sessionStorage[key] = value;
                if (this.debug) {
                    console.log("favorite - storage - add favorite " + key + "/ value " + value);
                }
            } else {
                if (this.debug) {
                    console.log("favorite - storage - remove favorite " + key);
                }
                sessionStorage.removeItem(key);
            }
        }
    },

    _toggleFavorite: function _toggleFavorite(objectType, objectId, webId, config) {

        if (!objectId) {
            return;
        }

        if (config.scope.AccountNavigation.CustomerState == 0) {
            if (HSN.Instance().DeviceInformation.HasNativeSignin) {
                var jsonData = { "returnUrl": window.location.href };
                var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
                __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);

                return;
            }

            var modal = HSN.Instance().GetGenericConfirmModal();

            modal.SetOkCallback(function () {
                var url = '/signin?favoriteType=' + objectType + '&favoriteId=' + objectId;
                if (webId) {
                    url += '&favoriteWebId=' + webId;
                }
                window.location = url;
            });

            modal.Show('/profile/requestlogin');

            return;
        }

        var favoriteId = 'fav-' + objectType + '-' + objectId;

        if (objectType == HSN.Service.FavoriteService.OBJECT_TYPE.BRAND) {
            if (HSN.Instance().DeviceInformation.IsNativeApp) {
                __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].AddRemoveFavoriteBrand(objectId);
            }

            this._send("/account/favorites/add-remove-favorite-brand", {
                brandId: objectId
            }, config).done(function (data, status, xhr) {
                var isFavorited = data.favorited;
                var value = isFavorited ? 'true' : null;

                if (data.success) {
                    this._updateStorage(favoriteId, value);
                }

                if (this.debug) {
                    console.log("favorite - ajax - " + (isFavorited ? "add" : "remove") + " brand" + objectId);
                }

                if (config.callback) {
                    config.callback.call(config.scope || config.callback, data.success, data.favorited);
                }
            }).fail(function (data, status, xhr) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, 0);
                }
                console.log("Error favoriting brand Id " + objectId);
            });
        } else if (objectType === HSN.Service.FavoriteService.OBJECT_TYPE.PRODUCT) {
            if (HSN.Instance().DeviceInformation.IsNativeApp) {
                __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].AddRemoveFavoriteProduct(objectId, webId);
            }

            this._send("/account/favorites/add-remove-favorite-product", { productId: objectId, webId: webId }, config).done(function (data, status, xhr) {
                var isFavorited = data.favorited;
                var value = isFavorited ? webId ? webId : 'true' : null;

                if (data.success) {
                    this._updateStorage(favoriteId, value);
                }

                if (this.debug) {
                    console.log("favorite - ajax - " + (isFavorited ? "add" : "remove") + " product" + objectId + " variant " + webId);
                }

                if (config.callback) {
                    config.callback.call(config.scope || config.callback, data.success, data.favorited);
                }
            }).fail(function (data, status, xhr) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, 0);
                }
                console.log("Error favoriting product Id " + objectId);
            });
        }
    }
};

/***/ }),

/***/ "5Xe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.RatingModal
* Encapsulates the functionality of a modal dialog that contains rating warning.
**/
HSN.RatingModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(RatingModal, _super);

    function RatingModal() {
        return RatingModal.__super__.constructor.call(this);
    }

    RatingModal.prototype._show = function (rating, buttonClicked) {

        $.ajax("/esrb/notice/rating?" + new Date().getTime(), {
            context: this,
            dataType: 'html',
            data: { 'rating': rating },
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });

                $('#under17').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    var exdate = new Date();
                    exdate.setDate(exdate.getDate() - 1);
                    var c_value = escape("true") + (1 == null ? "" : "; expires=" + exdate.toUTCString());
                    document.cookie = "over17=" + c_value;

                    __scope.Root.hide();
                    $('#modal-mask').remove();
                });

                $('#over17').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    var exdate = new Date();
                    var c_value = escape("true");
                    document.cookie = "over17=" + c_value;

                    __scope.Root.hide();
                    $('#modal-mask').remove();

                    buttonClicked.click();
                });

                //base modal wasn't working so this fixes that.
                $('.close').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    __scope.Root.hide();
                    $('#modal-mask').remove();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return RatingModal;
}(HSN.Modal);

/***/ }),

/***/ "6MBR":
/***/ (function(module, exports) {

/*!
 * jQuery Validation Plugin 1.11.1
 *
 * https://bassistance.de/jquery-plugins/jquery-plugin-validation/
 * https://docs.jquery.com/Plugins/Validation
 *
 * Copyright 2013 Jörn Zaefferer
 * Released under the MIT license:
 *   https://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

    $.extend($.fn, {
        // https://docs.jquery.com/Plugins/Validation/validate
        validate: function (options) {

            // if nothing is selected, return nothing; can't chain anyway
            if (!this.length) {
                if (options && options.debug && window.console) {
                    console.warn("Nothing selected, can't validate, returning nothing.");
                }
                return;
            }

            // check if a validator for this form was already created
            var validator = $.data(this[0], "validator");
            if (validator) {
                return validator;
            }

            // Add novalidate tag if HTML5.
            this.attr("novalidate", "novalidate");

            validator = new $.validator(options, this[0]);
            $.data(this[0], "validator", validator);

            if (validator.settings.onsubmit) {

                this.validateDelegate(":submit", "click", function (event) {
                    if (validator.settings.submitHandler) {
                        validator.submitButton = event.target;
                    }
                    // allow suppressing validation by adding a cancel class to the submit button
                    if ($(event.target).hasClass("cancel")) {
                        validator.cancelSubmit = true;
                    }

                    // allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
                    if ($(event.target).attr("formnovalidate") !== undefined) {
                        validator.cancelSubmit = true;
                    }
                });

                // validate the form on submit
                this.submit(function (event) {
                    if (validator.settings.debug) {
                        // prevent form submit to be able to see console output
                        event.preventDefault();
                    }
                    function handle() {
                        var hidden;
                        if (validator.settings.submitHandler) {
                            if (validator.submitButton) {
                                // insert a hidden input as a replacement for the missing submit button
                                hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val($(validator.submitButton).val()).appendTo(validator.currentForm);
                            }
                            validator.settings.submitHandler.call(validator, validator.currentForm, event);
                            if (validator.submitButton) {
                                // and clean up afterwards; thanks to no-block-scope, hidden can be referenced
                                hidden.remove();
                            }
                            return false;
                        }
                        return true;
                    }

                    // prevent submit for invalid forms or custom submit handlers
                    if (validator.cancelSubmit) {
                        validator.cancelSubmit = false;
                        return handle();
                    }
                    if (validator.form()) {
                        if (validator.pendingRequest) {
                            validator.formSubmitted = true;
                            return false;
                        }
                        return handle();
                    } else {
                        validator.focusInvalid();
                        return false;
                    }
                });
            }

            return validator;
        },
        // https://docs.jquery.com/Plugins/Validation/valid
        valid: function () {
            if ($(this[0]).is("form")) {
                return this.validate().form();
            } else {
                var valid = true;
                var validator = $(this[0].form).validate();
                this.each(function () {
                    valid = valid && validator.element(this);
                });
                return valid;
            }
        },
        // attributes: space seperated list of attributes to retrieve and remove
        removeAttrs: function (attributes) {
            var result = {},
                $element = this;
            $.each(attributes.split(/\s/), function (index, value) {
                result[value] = $element.attr(value);
                $element.removeAttr(value);
            });
            return result;
        },
        // https://docs.jquery.com/Plugins/Validation/rules
        rules: function (command, argument) {
            var element = this[0];

            if (command) {
                var settings = $.data(element.form, "validator").settings;
                var staticRules = settings.rules;
                var existingRules = $.validator.staticRules(element);
                switch (command) {
                    case "add":
                        $.extend(existingRules, $.validator.normalizeRule(argument));
                        // remove messages from rules, but allow them to be set separetely
                        delete existingRules.messages;
                        staticRules[element.name] = existingRules;
                        if (argument.messages) {
                            settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
                        }
                        break;
                    case "remove":
                        if (!argument) {
                            delete staticRules[element.name];
                            return existingRules;
                        }
                        var filtered = {};
                        $.each(argument.split(/\s/), function (index, method) {
                            filtered[method] = existingRules[method];
                            delete existingRules[method];
                        });
                        return filtered;
                }
            }

            var data = $.validator.normalizeRules(
            $.extend(
                {},
                $.validator.classRules(element),
                $.validator.attributeRules(element),
                $.validator.dataRules(element),
                $.validator.staticRules(element)
            ), element);

            // make sure required is at front
            if (data.required) {
                var param = data.required;
                delete data.required;
                data = $.extend({ required: param }, data);
            }

            return data;
        }
    });

    // Custom selectors
    $.extend($.expr.pseudos, {
        // https://docs.jquery.com/Plugins/Validation/blank
        blank: function (a) { return !$.trim("" + $(a).val()); },
        // https://docs.jquery.com/Plugins/Validation/filled
        filled: function (a) { return !!$.trim("" + $(a).val()); },
        // https://docs.jquery.com/Plugins/Validation/unchecked
        unchecked: function (a) { return !$(a).prop("checked"); }
    });

    // constructor for validator
    $.validator = function (options, form) {
        this.settings = $.extend(true, {}, $.validator.defaults, options);
        this.currentForm = form;
        this.init();
    };

    $.validator.format = function (source, params) {
        if (arguments.length === 1) {
            return function () {
                var args = $.makeArray(arguments);
                args.unshift(source);
                return $.validator.format.apply(this, args);
            };
        }
        if (arguments.length > 2 && params.constructor !== Array) {
            params = $.makeArray(arguments).slice(1);
        }
        if (params.constructor !== Array) {
            params = [params];
        }
        $.each(params, function (i, n) {
            source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function () {
                return n;
            });
        });
        return source;
    };

    $.extend($.validator, {

        defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            validClass: "valid",
            errorElement: "label",
            focusInvalid: true,
            errorContainer: $([]),
            errorLabelContainer: $([]),
            onsubmit: true,
            ignore: ":hidden",
            ignoreTitle: false,
            onfocusin: function (element, event) {
                this.lastActive = element;

                // hide error label and remove error class on focus if enabled
                if (this.settings.focusCleanup && !this.blockFocusCleanup) {
                    if (this.settings.unhighlight) {
                        this.settings.unhighlight.call(this, element, this.settings.errorClass, this.settings.validClass);
                    }
                    this.addWrapper(this.errorsFor(element)).hide();
                }
            },
            onfocusout: function (element, event) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
                    this.element(element);
                }
            },
            onkeyup: function (element, event) {
                if (event.which === 9 && this.elementValue(element) === "") {
                    return;
                } else if (element.name in this.submitted || element === this.lastElement) {
                    this.element(element);
                }
            },
            onclick: function (element, event) {
                // click on selects, radiobuttons and checkboxes
                if (element.name in this.submitted) {
                    this.element(element);
                }
                    // or option elements, check parent select in that case
                else if (element.parentNode.name in this.submitted) {
                    this.element(element.parentNode);
                }
            },
            highlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            }
        },

        // https://docs.jquery.com/Plugins/Validation/Validator/setDefaults
        setDefaults: function (settings) {
            $.extend($.validator.defaults, settings);
        },

        messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            equalTo: "Please enter the same value again.",
            maxlength: $.validator.format("Please enter no more than {0} characters."),
            minlength: $.validator.format("Please enter at least {0} characters."),
            rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
            range: $.validator.format("Please enter a value between {0} and {1}."),
            max: $.validator.format("Please enter a value less than or equal to {0}."),
            min: $.validator.format("Please enter a value greater than or equal to {0}.")
        },

        autoCreateRanges: false,

        prototype: {

            init: function () {
                this.labelContainer = $(this.settings.errorLabelContainer);
                this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
                this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
                this.submitted = {};
                this.valueCache = {};
                this.pendingRequest = 0;
                this.pending = {};
                this.invalid = {};
                this.reset();

                var groups = (this.groups = {});
                $.each(this.settings.groups, function (key, value) {
                    if (typeof value === "string") {
                        value = value.split(/\s/);
                    }
                    $.each(value, function (index, name) {
                        groups[name] = key;
                    });
                });
                var rules = this.settings.rules;
                $.each(rules, function (key, value) {
                    rules[key] = $.validator.normalizeRule(value);
                });

                function delegate(event) {
                    var validator = $.data(this[0].form, "validator"),
                        eventType = "on" + event.type.replace(/^validate/, "");
                    if (validator.settings[eventType]) {
                        validator.settings[eventType].call(validator, this[0], event);
                    }
                }
                $(this.currentForm)
                    .validateDelegate(":text, [type='password'], [type='file'], select, textarea, " +
                        "[type='number'], [type='search'] ,[type='tel'], [type='url'], " +
                        "[type='email'], [type='datetime'], [type='date'], [type='month'], " +
                        "[type='week'], [type='time'], [type='datetime-local'], " +
                        "[type='range'], [type='color'] ",
                        "focusin focusout keyup", delegate)
                    .validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", delegate);

                if (this.settings.invalidHandler) {
                    $(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
                }
            },

            // https://docs.jquery.com/Plugins/Validation/Validator/form
            form: function () {
                this.checkForm();
                $.extend(this.submitted, this.errorMap);
                this.invalid = $.extend({}, this.errorMap);
                if (!this.valid()) {
                    $(this.currentForm).triggerHandler("invalid-form", [this]);
                }
                this.showErrors();
                return this.valid();
            },

            checkForm: function () {
                this.prepareForm();
                for (var i = 0, elements = (this.currentElements = this.elements()) ; elements[i]; i++) {
                    this.check(elements[i]);
                }
                return this.valid();
            },

            // https://docs.jquery.com/Plugins/Validation/Validator/element
            element: function (element) {
                element = this.validationTargetFor(this.clean(element));
                this.lastElement = element;
                this.prepareElement(element);
                this.currentElements = $(element);
                var result = this.check(element) !== false;
                if (result) {
                    delete this.invalid[element.name];
                } else {
                    this.invalid[element.name] = true;
                }
                if (!this.numberOfInvalids()) {
                    // Hide error containers on last error
                    this.toHide = this.toHide.add(this.containers);
                }
                this.showErrors();
                return result;
            },

            // https://docs.jquery.com/Plugins/Validation/Validator/showErrors
            showErrors: function (errors) {
                if (errors) {
                    // add items to error list and map
                    $.extend(this.errorMap, errors);
                    this.errorList = [];
                    for (var name in errors) {
                        this.errorList.push({
                            message: errors[name],
                            element: this.findByName(name)[0]
                        });
                    }
                    // remove items from success list
                    this.successList = $.grep(this.successList, function (element) {
                        return !(element.name in errors);
                    });
                }
                if (this.settings.showErrors) {
                    this.settings.showErrors.call(this, this.errorMap, this.errorList);
                } else {
                    this.defaultShowErrors();
                }
            },

            // https://docs.jquery.com/Plugins/Validation/Validator/resetForm
            resetForm: function () {
                if ($.fn.resetForm) {
                    $(this.currentForm).resetForm();
                }
                this.submitted = {};
                this.lastElement = null;
                this.prepareForm();
                this.hideErrors();
                this.elements().removeClass(this.settings.errorClass).removeData("previousValue");
            },

            numberOfInvalids: function () {
                return this.objectLength(this.invalid);
            },

            objectLength: function (obj) {
                var count = 0;
                for (var i in obj) {
                    count++;
                }
                return count;
            },

            hideErrors: function () {
                this.addWrapper(this.toHide).hide();
            },

            valid: function () {
                return this.size() === 0;
            },

            size: function () {
                return this.errorList.length;
            },

            focusInvalid: function () {
                if (this.settings.focusInvalid) {
                    try {
                        $(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
                        .filter(":visible")
                        .focus()
                        // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                        .trigger("focusin");
                    } catch (e) {
                        // ignore IE throwing errors when focusing hidden elements
                    }
                }
            },

            findLastActive: function () {
                var lastActive = this.lastActive;
                return lastActive && $.grep(this.errorList, function (n) {
                    return n.element.name === lastActive.name;
                }).length === 1 && lastActive;
            },

            elements: function () {
                var validator = this,
                    rulesCache = {};

                // select all valid inputs inside the form (no submit or reset buttons)
                return $(this.currentForm)
                .find("input, select, textarea")
                .not(":submit, :reset, :image, [disabled]")
                .not(this.settings.ignore)
                .filter(function () {
                    if (!this.name && validator.settings.debug && window.console) {
                        console.error("%o has no name assigned", this);
                    }

                    // select only the first element for each name, and only those with rules specified
                    if (this.name in rulesCache || !validator.objectLength($(this).rules())) {
                        return false;
                    }

                    rulesCache[this.name] = true;
                    return true;
                });
            },

            clean: function (selector) {
                return $(selector)[0];
            },

            errors: function () {
                var errorClass = this.settings.errorClass.replace(" ", ".");
                return $(this.settings.errorElement + "." + errorClass, this.errorContext);
            },

            reset: function () {
                this.successList = [];
                this.errorList = [];
                this.errorMap = {};
                this.toShow = $([]);
                this.toHide = $([]);
                this.currentElements = $([]);
            },

            prepareForm: function () {
                this.reset();
                this.toHide = this.errors().add(this.containers);
            },

            prepareElement: function (element) {
                this.reset();
                this.toHide = this.errorsFor(element);
            },

            elementValue: function (element) {
                var type = $(element).attr("type"),
                    val = $(element).val();

                if (type === "radio" || type === "checkbox") {
                    return $("input[name='" + $(element).attr("name") + "']:checked").val();
                }

                if (typeof val === "string") {
                    return val.replace(/\r/g, "");
                }
                return val;
            },

            check: function (element) {
                element = this.validationTargetFor(this.clean(element));

                var rules = $(element).rules();
                var dependencyMismatch = false;
                var val = this.elementValue(element);
                var result;

                for (var method in rules) {
                    var rule = { method: method, parameters: rules[method] };
                    try {

                        result = $.validator.methods[method].call(this, val, element, rule.parameters);

                        // if a method indicates that the field is optional and therefore valid,
                        // don't mark it as valid when there are no other rules
                        if (result === "dependency-mismatch") {
                            dependencyMismatch = true;
                            continue;
                        }
                        dependencyMismatch = false;

                        if (result === "pending") {
                            this.toHide = this.toHide.not(this.errorsFor(element));
                            return;
                        }

                        if (!result) {
                            this.formatAndAdd(element, rule);
                            return false;
                        }
                    } catch (e) {
                        if (this.settings.debug && window.console) {
                            console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
                        }
                        throw e;
                    }
                }
                if (dependencyMismatch) {
                    return;
                }
                if (this.objectLength(rules)) {
                    this.successList.push(element);
                }
                return true;
            },

            // return the custom message for the given element and validation method
            // specified in the element's HTML5 data attribute
            customDataMessage: function (element, method) {
                return $(element).data("msg-" + method.toLowerCase()) || (element.attributes && $(element).attr("data-msg-" + method.toLowerCase()));
            },

            // return the custom message for the given element name and validation method
            customMessage: function (name, method) {
                var m = this.settings.messages[name];
                return m && (m.constructor === String ? m : m[method]);
            },

            // return the first defined argument, allowing empty strings
            findDefined: function () {
                for (var i = 0; i < arguments.length; i++) {
                    if (arguments[i] !== undefined) {
                        return arguments[i];
                    }
                }
                return undefined;
            },

            defaultMessage: function (element, method) {
                return this.findDefined(
                    this.customMessage(element.name, method),
                    this.customDataMessage(element, method),
                    // title is never undefined, so handle empty string as undefined
                    !this.settings.ignoreTitle && element.title || undefined,
                    $.validator.messages[method],
                    "<strong>Warning: No message defined for " + element.name + "</strong>"
                );
            },

            formatAndAdd: function (element, rule) {
                var message = this.defaultMessage(element, rule.method),
                    theregex = /\$?\{(\d+)\}/g;
                if (typeof message === "function") {
                    message = message.call(this, rule.parameters, element);
                } else if (theregex.test(message)) {
                    message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
                }
                this.errorList.push({
                    message: message,
                    element: element
                });

                this.errorMap[element.name] = message;
                this.submitted[element.name] = message;
            },

            addWrapper: function (toToggle) {
                if (this.settings.wrapper) {
                    toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
                }
                return toToggle;
            },

            defaultShowErrors: function () {
                var i, elements;
                for (i = 0; this.errorList[i]; i++) {
                    var error = this.errorList[i];
                    if (this.settings.highlight) {
                        this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
                    }
                    this.showLabel(error.element, error.message);
                }
                if (this.errorList.length) {
                    this.toShow = this.toShow.add(this.containers);
                }
                if (this.settings.success) {
                    for (i = 0; this.successList[i]; i++) {
                        this.showLabel(this.successList[i]);
                    }
                }
                if (this.settings.unhighlight) {
                    for (i = 0, elements = this.validElements() ; elements[i]; i++) {
                        this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
                    }
                }
                this.toHide = this.toHide.not(this.toShow);
                this.hideErrors();
                this.addWrapper(this.toShow).show();
            },

            validElements: function () {
                return this.currentElements.not(this.invalidElements());
            },

            invalidElements: function () {
                return $(this.errorList).map(function () {
                    return this.element;
                });
            },

            showLabel: function (element, message) {
                var label = this.errorsFor(element);
                if (label.length) {
                    // refresh error/success class
                    label.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
                    // replace message on existing label
                    label.html(message);
                } else {
                    // create label
                    label = $("<" + this.settings.errorElement + ">")
                        .attr("for", this.idOrName(element))
                        .addClass(this.settings.errorClass)
                        .html(message || "");
                    if (this.settings.wrapper) {
                        // make sure the element is visible, even in IE
                        // actually showing the wrapped element is handled elsewhere
                        label = label.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
                    }
                    if (!this.labelContainer.append(label).length) {
                        if (this.settings.errorPlacement) {
                            this.settings.errorPlacement(label, $(element));
                        } else {
                            label.insertAfter(element);
                        }
                    }
                }
                if (!message && this.settings.success) {
                    label.text("");
                    if (typeof this.settings.success === "string") {
                        label.addClass(this.settings.success);
                    } else {
                        this.settings.success(label, element);
                    }
                }
                this.toShow = this.toShow.add(label);
            },

            errorsFor: function (element) {
                var name = this.idOrName(element);
                return this.errors().filter(function () {
                    return $(this).attr("for") === name;
                });
            },

            idOrName: function (element) {
                return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
            },

            validationTargetFor: function (element) {
                // if radio/checkbox, validate first element in group instead
                if (this.checkable(element)) {
                    element = this.findByName(element.name).not(this.settings.ignore)[0];
                }
                return element;
            },

            checkable: function (element) {
                return (/radio|checkbox/i).test(element.type);
            },

            findByName: function (name) {
                return $(this.currentForm).find("[name='" + name + "']");
            },

            getLength: function (value, element) {
                switch (element.nodeName.toLowerCase()) {
                    case "select":
                        return $("option:selected", element).length;
                    case "input":
                        if (this.checkable(element)) {
                            return this.findByName(element.name).filter(":checked").length;
                        }
                }
                return value.length;
            },

            depend: function (param, element) {
                return this.dependTypes[typeof param] ? this.dependTypes[typeof param](param, element) : true;
            },

            dependTypes: {
                "boolean": function (param, element) {
                    return param;
                },
                "string": function (param, element) {
                    return !!$(param, element.form).length;
                },
                "function": function (param, element) {
                    return param(element);
                }
            },

            optional: function (element) {
                var val = this.elementValue(element);
                return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
            },

            startRequest: function (element) {
                if (!this.pending[element.name]) {
                    this.pendingRequest++;
                    this.pending[element.name] = true;
                }
            },

            stopRequest: function (element, valid) {
                this.pendingRequest--;
                // sometimes synchronization fails, make sure pendingRequest is never < 0
                if (this.pendingRequest < 0) {
                    this.pendingRequest = 0;
                }
                delete this.pending[element.name];
                if (valid && this.pendingRequest === 0 && this.formSubmitted && this.form()) {
                    $(this.currentForm).submit();
                    this.formSubmitted = false;
                } else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
                    $(this.currentForm).triggerHandler("invalid-form", [this]);
                    this.formSubmitted = false;
                }
            },

            previousValue: function (element) {
                return $.data(element, "previousValue") || $.data(element, "previousValue", {
                    old: null,
                    valid: true,
                    message: this.defaultMessage(element, "remote")
                });
            }

        },

        classRuleSettings: {
            required: { required: true },
            email: { email: true },
            url: { url: true },
            date: { date: true },
            dateISO: { dateISO: true },
            number: { number: true },
            digits: { digits: true },
            creditcard: { creditcard: true }
        },

        addClassRules: function (className, rules) {
            if (className.constructor === String) {
                this.classRuleSettings[className] = rules;
            } else {
                $.extend(this.classRuleSettings, className);
            }
        },

        classRules: function (element) {
            var rules = {};
            var classes = $(element).attr("class");
            if (classes) {
                $.each(classes.split(" "), function () {
                    if (this in $.validator.classRuleSettings) {
                        $.extend(rules, $.validator.classRuleSettings[this]);
                    }
                });
            }
            return rules;
        },

        attributeRules: function (element) {
            var rules = {};
            var $element = $(element);
            var type = $element[0].getAttribute("type");

            for (var method in $.validator.methods) {
                var value;

                // support for <input required> in both html5 and older browsers
                if (method === "required") {
                    value = $element.get(0).getAttribute(method);
                    // Some browsers return an empty string for the required attribute
                    // and non-HTML5 browsers might have required="" markup
                    if (value === "") {
                        value = true;
                    }
                    // force non-HTML5 browsers to return bool
                    value = !!value;
                } else {
                    value = $element.attr(method);
                }

                // convert the value to a number for number inputs, and for text for backwards compability
                // allows type="date" and others to be compared as strings
                if (/min|max/.test(method) && (type === null || /number|range|text/.test(type))) {
                    value = Number(value);
                }

                if (value) {
                    rules[method] = value;
                } else if (type === method && type !== 'range') {
                    // exception: the jquery validate 'range' method
                    // does not test for the html5 'range' type
                    rules[method] = true;
                }
            }

            // maxlength may be returned as -1, 2147483647 (IE) and 524288 (safari) for text inputs
            if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
                delete rules.maxlength;
            }

            return rules;
        },

        dataRules: function (element) {
            var method, value,
                rules = {}, $element = $(element);
            for (method in $.validator.methods) {
                value = $element.data("rule-" + method.toLowerCase());
                if (value !== undefined) {
                    rules[method] = value;
                }
            }
            return rules;
        },

        staticRules: function (element) {
            var rules = {};
            var validator = $.data(element.form, "validator");
            if (validator.settings.rules) {
                rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
            }
            return rules;
        },

        normalizeRules: function (rules, element) {
            // handle dependency check
            $.each(rules, function (prop, val) {
                // ignore rule when param is explicitly false, eg. required:false
                if (val === false) {
                    delete rules[prop];
                    return;
                }
                if (val.param || val.depends) {
                    var keepRule = true;
                    switch (typeof val.depends) {
                        case "string":
                            keepRule = !!$(val.depends, element.form).length;
                            break;
                        case "function":
                            keepRule = val.depends.call(element, element);
                            break;
                    }
                    if (keepRule) {
                        rules[prop] = val.param !== undefined ? val.param : true;
                    } else {
                        delete rules[prop];
                    }
                }
            });

            // evaluate parameters
            $.each(rules, function (rule, parameter) {
                rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
            });

            // clean number parameters
            $.each(['minlength', 'maxlength'], function () {
                if (rules[this]) {
                    rules[this] = Number(rules[this]);
                }
            });
            $.each(['rangelength', 'range'], function () {
                var parts;
                if (rules[this]) {
                    if ($.isArray(rules[this])) {
                        rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
                    } else if (typeof rules[this] === "string") {
                        parts = rules[this].split(/[\s,]+/);
                        rules[this] = [Number(parts[0]), Number(parts[1])];
                    }
                }
            });

            if ($.validator.autoCreateRanges) {
                // auto-create ranges
                if (rules.min && rules.max) {
                    rules.range = [rules.min, rules.max];
                    delete rules.min;
                    delete rules.max;
                }
                if (rules.minlength && rules.maxlength) {
                    rules.rangelength = [rules.minlength, rules.maxlength];
                    delete rules.minlength;
                    delete rules.maxlength;
                }
            }

            return rules;
        },

        // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
        normalizeRule: function (data) {
            if (typeof data === "string") {
                var transformed = {};
                $.each(data.split(/\s/), function () {
                    transformed[this] = true;
                });
                data = transformed;
            }
            return data;
        },

        // https://docs.jquery.com/Plugins/Validation/Validator/addMethod
        addMethod: function (name, method, message) {
            $.validator.methods[name] = method;
            $.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
            if (method.length < 3) {
                $.validator.addClassRules(name, $.validator.normalizeRule(name));
            }
        },

        methods: {

            // https://docs.jquery.com/Plugins/Validation/Methods/required
            required: function (value, element, param) {
                // check if dependency is met
                if (!this.depend(param, element)) {
                    return "dependency-mismatch";
                }
                if (element.nodeName.toLowerCase() === "select") {
                    // could be an array for select-multiple or a string, both are fine this way
                    var val = $(element).val();
                    return val && val.length > 0;
                }
                if (this.checkable(element)) {
                    return this.getLength(value, element) > 0;
                }
                return $.trim(value).length > 0;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/email
            email: function (value, element) {
                // contributed by Scott Gonzalez: https://projects.scottsplayground.com/email_address_validation/
                return this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(value);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/url
            url: function (value, element) {
                // contributed by Scott Gonzalez: https://projects.scottsplayground.com/iri/
                return this.optional(element) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/date
            date: function (value, element) {
                return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/dateISO
            dateISO: function (value, element) {
                return this.optional(element) || /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(value);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/number
            number: function (value, element) {
                return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/digits
            digits: function (value, element) {
                return this.optional(element) || /^\d+$/.test(value);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/creditcard
            // based on https://en.wikipedia.org/wiki/Luhn
            creditcard: function (value, element) {
                if (this.optional(element)) {
                    return "dependency-mismatch";
                }
                // accept only spaces, digits and dashes
                if (/[^0-9 \-]+/.test(value)) {
                    return false;
                }
                var nCheck = 0,
                    nDigit = 0,
                    bEven = false;

                value = value.replace(/\D/g, "");

                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n);
                    nDigit = parseInt(cDigit, 10);
                    if (bEven) {
                        if ((nDigit *= 2) > 9) {
                            nDigit -= 9;
                        }
                    }
                    nCheck += nDigit;
                    bEven = !bEven;
                }

                return (nCheck % 10) === 0;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/minlength
            minlength: function (value, element, param) {
                var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
                return this.optional(element) || length >= param;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/maxlength
            maxlength: function (value, element, param) {
                var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
                return this.optional(element) || length <= param;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/rangelength
            rangelength: function (value, element, param) {
                var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
                return this.optional(element) || (length >= param[0] && length <= param[1]);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/min
            min: function (value, element, param) {
                return this.optional(element) || value >= param;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/max
            max: function (value, element, param) {
                return this.optional(element) || value <= param;
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/range
            range: function (value, element, param) {
                return this.optional(element) || (value >= param[0] && value <= param[1]);
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/equalTo
            equalTo: function (value, element, param) {
                // bind to the blur event of the target in order to revalidate whenever the target field is updated
                // TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
                var target = $(param);
                if (this.settings.onfocusout) {
                    target.off(".validate-equalTo").on("blur.validate-equalTo", function () {
                        $(element).valid();
                    });
                }
                return value === target.val();
            },

            // https://docs.jquery.com/Plugins/Validation/Methods/remote
            remote: function (value, element, param) {
                if (this.optional(element)) {
                    return "dependency-mismatch";
                }

                var previous = this.previousValue(element);
                if (!this.settings.messages[element.name]) {
                    this.settings.messages[element.name] = {};
                }
                previous.originalMessage = this.settings.messages[element.name].remote;
                this.settings.messages[element.name].remote = previous.message;

                param = typeof param === "string" && { url: param } || param;

                if (previous.old === value) {
                    return previous.valid;
                }

                previous.old = value;
                var validator = this;
                this.startRequest(element);
                var data = {};
                data[element.name] = value;
                $.ajax($.extend(true, {
                    url: param,
                    mode: "abort",
                    port: "validate" + element.name,
                    dataType: "json",
                    data: data,
                    success: function (response) {
                        validator.settings.messages[element.name].remote = previous.originalMessage;
                        var valid = response === true || response === "true";
                        if (valid) {
                            var submitted = validator.formSubmitted;
                            validator.prepareElement(element);
                            validator.formSubmitted = submitted;
                            validator.successList.push(element);
                            delete validator.invalid[element.name];
                            validator.showErrors();
                        } else {
                            var errors = {};
                            var message = response || validator.defaultMessage(element, "remote");
                            errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
                            validator.invalid[element.name] = true;
                            validator.showErrors(errors);
                        }
                        previous.valid = valid;
                        validator.stopRequest(element, valid);
                    }
                }, param));
                return "pending";
            }

        }

    });

    // deprecated, use $.validator.format instead
    $.format = $.validator.format;

}(jQuery));

// ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
(function ($) {
    var pendingRequests = {};
    // Use a prefilter if available (1.5+)
    if ($.ajaxPrefilter) {
        $.ajaxPrefilter(function (settings, _, xhr) {
            var port = settings.port;
            if (settings.mode === "abort") {
                if (pendingRequests[port]) {
                    pendingRequests[port].abort();
                }
                pendingRequests[port] = xhr;
            }
        });
    } else {
        // Proxy ajax
        var ajax = $.ajax;
        $.ajax = function (settings) {
            var mode = ("mode" in settings ? settings : $.ajaxSettings).mode,
                port = ("port" in settings ? settings : $.ajaxSettings).port;
            if (mode === "abort") {
                if (pendingRequests[port]) {
                    pendingRequests[port].abort();
                }
                pendingRequests[port] = ajax.apply(this, arguments);
                return pendingRequests[port];
            }
            return ajax.apply(this, arguments);
        };
    }
}(jQuery));

// provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
// handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target
(function ($) {
    $.extend($.fn, {
        validateDelegate: function (delegate, type, handler) {
            return this.on(type, function (event) {
                var target = $(event.target);
                if (target.is(delegate)) {
                    return handler.apply(target, arguments);
                }
            });
        }
    });
}(jQuery));


/***/ }),

/***/ "6iF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* class HSN.ImageSwapper
*
* Provides a very lightweight functionality for swapping the anchor/image of a main image area with the values coming from a set of alternate anchors/images.
**/
HSN.ImageSwapper = function (config) {
    /**
        * new HSN.ImageSwapper(config)
        * - config (Object): A configuration object for the [[HSN.ImageSwapper]
        *   consisting of the following keys:
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the container of the alternate triggers.
        *   - destinationAnchor (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to the anchor tag surrounding the main image.
        *   - destinationImage (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to the main image tag.
        *   - triggerSelector (String): A CSS selector used find descendents of the container to trigger image swaps.
        **/
    var scope = this;

    this._container = $(config.container);
    this._destinationAnchor = $(config.destinationAnchor);
    this._destinationImage = $(config.destinationImage);
    this._triggerSelector = config.triggerSelector;
    this._useHover = config.useHover;
    this._useData = config.useData;
    this._followTriggerHref = config.followTriggerHref;

    var selectedImg = this._container.find(this._triggerSelector).filter('.selected').get(0);

    this._container.on('mouseenter', this._triggerSelector, function () {
        $(this).addClass('hover');

        if (scope._useHover) {
            scope.SynchronizeSelectedTriggerState(this);
        }
    });

    this._container.on('mouseleave', this._triggerSelector, function () {
        $(this).removeClass('hover');

        if (scope._useHover) {
            if (selectedImg) {
                scope.SynchronizeSelectedTriggerState(selectedImg);
            }
        }
    });

    this._container.on('click', this._triggerSelector, function (e) {
        e.preventDefault();

        if (!scope._useHover) {
            scope.SynchronizeSelectedTriggerState(this);
        }
    });
};

HSN.ImageSwapper.prototype = {
    /**
    * HSN.ImageSwapper#ActivateTrigger(trigger, className) -> void
    * - trigger (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve one of the triggers.
    * - className (String): The CSS class name to add to the trigger when activated.
    *
    * Modifies the trigger as necessary to support the activated state of the trigger and adds the given class.
    **/
    ActivateTrigger: function ActivateTrigger(trigger, className) {
        var $trigger = $(trigger);

        var $triggerOverlay = $trigger.find('.overlay');
        if (!$triggerOverlay.length) {
            $triggerOverlay = $('<div class="overlay"></div>');
            $trigger.append($triggerOverlay);
            if (this._followTriggerHref) {
                $triggerOverlay.click(function () {
                    window.location = $trigger.attr('href');
                });
            }
        }

        $trigger.addClass(className);
    },

    /**
    * HSN.ImageSwapper#DeactivateTrigger(trigger) -> void
    * - trigger (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve one of the triggers.
    *
    * Restores the state of the given trigger to a deactivated state by removing the given class name.
    **/
    DeactivateTrigger: function DeactivateTrigger(trigger, className) {
        $(trigger).removeClass(className);
        $(trigger).find('.overlay').remove();
    },

    /**
    * HSN.ImageSwapper#SynchronizeSelectedTriggerState(trigger) -> void
    * - trigger (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the trigger to be marked selected.
    *
    * Sets the given trigger into the selected state while removing the selected state from any other triggers.
    **/
    SynchronizeSelectedTriggerState: function SynchronizeSelectedTriggerState(trigger) {
        if (!trigger) {
            return;
        }

        var $trigger = $(trigger);

        var triggerImageUrl = this._useData ? $trigger.data('image') : $trigger.attr('href');
        var triggerZoomImageUrls = $trigger.data('zoom');

        if (triggerImageUrl) {
            this._destinationImage.attr('src', triggerImageUrl);
        }

        if (this._destinationAnchor) {
            if (triggerImageUrl) {
                this._destinationAnchor.attr('href', triggerImageUrl);
            }
            if (triggerZoomImageUrls) {
                this._destinationAnchor.data('zoom', triggerZoomImageUrls);
            }
        }

        var currentlyActiveTriggers = this._container.find(this._triggerSelector).filter('.active');
        if (currentlyActiveTriggers.length) {
            this.DeactivateTrigger(currentlyActiveTriggers, 'active');
        }

        this.ActivateTrigger(trigger, 'active');
    },

    SetPlusSizeMode: function SetPlusSizeMode(enabled) {
        this._plusSizeMode = enabled;
    }
};

/***/ }),

/***/ "7LMO":
/***/ (function(module, exports) {

/**
 * HSN.Template
 **/
HSN.Template = HSN.Template = HSN.Template || {};

HSN.Template.Checkout = HSN.Template.Checkout = HSN.Template.Checkout || {};

HSN.Template.MyAccount = HSN.Template.MyAccount = HSN.Template.MyAccount || {};

HSN.Template.AgentPortal = HSN.Template.AgentPortal = HSN.Template.AgentPortal || {};

HSN.Template.DataRegulations = HSN.Template.DataRegulations = HSN.Template.DataRegulations || {};

/***/ }),

/***/ "8648":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.OrdersRateReviewModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.OrdersRateReviewModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(OrdersRateReviewModal, _super);

    function OrdersRateReviewModal() {
        return OrdersRateReviewModal.__super__.constructor.call(this);
    }

    /**
    * HSN.OrdersRateReviewModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    OrdersRateReviewModal.prototype._show = function (url) {
        $.ajax(url, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return OrdersRateReviewModal;
}(HSN.Modal);

/***/ }),

/***/ "98Oh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
* class HSN.ClickToCallModal
*
* Encapsulates the functionality of a modal dialog that a customer can use to submit a request to have CS call them
**/
HSN.ClickToCallModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ClickToCallModal, parent);

    function ClickToCallModal() {
        var modal = ClickToCallModal.__super__.constructor.call(this);
        this.Close.off();
        this.customerPhoneNumber = null;
        eventHandlers(this);
        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Close).on('click', function () {
            closeModal(modal);
        });

        $(modal.Content).on('click', '#call-btn', function () {
            modal.putCustomerPhone();
            return false;
        });

        $(modal.Content).on('click', '.cancel-btn', function () {
            closeModal(modal);
            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.ClickToCallModal#Show() -> void
    * - data (object): customer object
    **/
    ClickToCallModal.prototype._show = function (data) {
        this.customerPhoneNumber = this.cleanPhoneNumber(data.customerPhoneNumber);
        $.ajax('/myaccount/clicktocall/modal/get?CustomerPhone=' + this.customerPhoneNumber, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    __scope.customerPhone = $('.click-to-call-phone').val();
                    HSN.FormatPhone('.click-to-call-phone');
                    $(__scope.Root).find('.click-to-call-phone').focus();
                    $(__scope.Root).find('.click-to-call-phone').blur();
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    ClickToCallModal.prototype.putCustomerPhone = function () {
        var scope = this;
        this.customerPhoneNumber = this.cleanPhoneNumber($(this.Root).find('.click-to-call-phone').val());
        $(this.Content).find('#validation-errors').html('');
        $.ajax('/api/clicktocall/callback?phoneNumber=' + this.customerPhoneNumber, {
            type: 'POST',
            context: this,
            dataType: 'json',
            success: function success(data) {
                if (data.ServiceAvailable && data.Successful) {
                    scope.renderConfirmation(data.EstimatedWaitTime);
                } else if (data.Errors) {
                    scope.renderValidationErrors(data.Errors);
                } else {
                    scope.renderError();
                }
            },
            error: function error() {
                scope.renderError();
            }
        });
    };

    ClickToCallModal.prototype.renderConfirmation = function (timeInMinutes) {
        var scope = this;
        $(this.Content).find('.wait-time-confirmation').text(timeInMinutes);
        $(this.Content).find('.minutes-text').text(this.pluralize(timeInMinutes, 'minute'));
        $(this.Content).find('.click-to-call-input').hide();
        $(this.Content).find('.click-to-call-complete').show();
        scope.Center();
    };

    ClickToCallModal.prototype.renderError = function () {
        var scope = this;
        $(this.Root).find('.click-to-call-input').hide();
        $(this.Root).find('.click-to-call-error').show();
        scope.Center();
    };

    ClickToCallModal.prototype.pluralize = function (count, noun) {
        var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';

        return count !== 1 ? noun + suffix : noun;
    };

    ClickToCallModal.prototype.cleanPhoneNumber = function (phoneNumber) {
        return phoneNumber.replace(/\D+/g, '');
    };

    ClickToCallModal.prototype.renderValidationErrors = function (errors) {
        var errorElement = $('<div class="errors" tabindex="-1"><div class="errors-top"><span><b>OOPS.</b> Please fix the following:</span></div><ul></ul></div>');
        for (var currentError = 0; currentError < errors.length; currentError++) {
            errorElement.find('ul').append('<li>' + errors[currentError].Message + '</li>');
        }
        $(this.Content).find('#validation-errors').append(errorElement);
    };

    return ClickToCallModal;
}(HSN.Modal);

/***/ }),

/***/ "9XdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_BonusBuy_js__ = __webpack_require__("DLzk");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Used by content


/**
* class HSN.BonusBuyModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.BonusBuyModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(BonusBuyModal, parent);

    function BonusBuyModal(config) {
        var modal = BonusBuyModal.__super__.constructor.call(this, "bonusbuy");

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {

        /*$(modal.Content).on('click', '#baseball-card-modal', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });*/

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();

        //cmCreateManualLinkClickTag('cm_re=cm_re=Arcade-_-Profile-_-Close&cm_sp=cm_re=Arcade-_-Profile-_-Close', 'CloseArcadeDrawer');
    }

    callbackok: null;
    callbackcancel: null;

    BonusBuyModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    BonusBuyModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    BonusBuyModal.prototype._show = function (id, useQualifiers) {
        $('.video-flash').css('visibility', 'hidden');

        this.Center();

        $.ajax("/bonusbuy/PromotionProducts/" + id + "/" + useQualifiers, {
            cache: false,
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                if (data != null && data != "") {
                    this.Content.showHtml(data, 0, function () {
                        __scope.Center();
                        __scope.Content.animate({ opacity: 1 });
                        //handle any tooltips loaded
                        if (!Modernizr.touchevents) {
                            HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                        }
                    }, function () {
                        //__scope.Center();
                    });
                } else {
                    $('#modal-mask').remove();
                }
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return BonusBuyModal;
}(HSN.Modal);

/***/ }),

/***/ "A8ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.PageIdModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.PageIdModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(PageIdModal, parent);

    PageIdModal.EVENT = {
        SHOW_COMPLETE: 'HSN.PageIdModal.SHOW_COMPLETE'
    };

    /**
    * new HSN.PageIdModal()
    **/
    function PageIdModal() {
        return PageIdModal.__super__.constructor.call(this);
    }

    /**
    * HSN.PageIdModal#Show(elementId) -> void
    * - elementId (string): The identifier for the element to show in modal
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    PageIdModal.prototype._show = function (elementId, hideCloseButton) {
        var scope = this;

        var html = $(elementId).html();

        if (html !== undefined) {
            scope.Root.removeClass('loading');

            scope.Content.showHtml(html, 0, function () {
                scope.Center();
                scope.Content.animate({
                    opacity: 1
                }, {
                    complete: function complete() {
                        HSN.Instance().Events.Trigger(HSN.PageIdModal.EVENT.SHOW_COMPLETE, scope);
                    }
                });
                if (hideCloseButton) {
                    scope.Close.hide();
                }
                scope.Content.focus();
            }, function () {
                //scope.Center();
            });
        } else {
            $('#modal-mask').remove();
        }
    };

    return PageIdModal;
}(HSN.Modal);

/***/ }),

/***/ "B7Qy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_AddToBag_js__ = __webpack_require__("Z47Q");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
* class HSN.BuyAgain
* Handles add-to-bag-handler buttons for sitewide widgets
**/
HSN.BuyAgain = function () {
    var clickHandler = function clickHandler(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var cur = $(ev.currentTarget);
        var productId = cur.data('webpid');
        var productStyleId = cur.data('webid');
        if (productId !== 0 && productStyleId !== 0) {
            HSN.SetWait();

            var options = {
                ProductId: productId,
                WebId: productStyleId,
                DeferredFinancing: null,
                ExtraFlexPromo: null,
                ExtraFlex: null,
                ExpressBuy: 0,
                Quantity: 1,
                FlexPay: 1,
                ProgramId: cur.data('autoship-program-id'),
                ProgramCode: cur.data('autoship-program-code'),
                Frequency: cur.data('autoship-program-frequency'),
                StartDate: cur.data('autoship-program-start-date'),
                WarrantyWebPId: null,
                WarrantyName: null,
                WarrantyAmount: null
            };

            var addToBagWidget = new HSN.Widget.AddToBag();
            addToBagWidget.init({
                application: HSN.Instance(),
                isInPreviewModal: false,
                refreshWhenDone: true
            });
            addToBagWidget.AddToBag(options);
        } else {
            alert('Unfortunately there was an error attempting to add the item to your bag, please try again.');
        }
    };

    $(document).ready(function () {
        $(document).on('click', '.add-to-bag-handler', clickHandler);
    });
}();

/***/ }),

/***/ "BBRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* class HSN.TabPanel
*
* Encapsulates the functionality of a tab-based card layout providing multiple, clickable tabs that swap bewtween one visible panel of content.
**/
HSN.TabPanel = function (container, tabSelector, externalTriggers, scrollTo) {
    /**
    * new HSN.TabPanel(container, tabSelector)
    * - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the tabs.
    * - tabSelector (String): A CSS selector that finds the clickable elements that trigger tab switches.
    * - externalTriggers (jQuery | HTMLElement | String): A jQuery object, HTML Element(s), or CSS selector that will ultimately resolve to anchor tags that are not tabs, but should trigger the activation of tabs.
    **/

    var scope = this;

    this._container = $(container);
    this._externalTriggers = $(externalTriggers);
    this._tabSelector = tabSelector;
    this._scrollTo = scrollTo;

    this._container.on('click', this._tabSelector, handleTabSelector);
    this._externalTriggers.on('click', handleExternalTriggers);

    function handleTabSelector(e) {
        e.preventDefault();

        scope.ActivateTab(this, false);
    }

    function handleExternalTriggers(e) {
        e.preventDefault();

        var href = $(this).attr('href'); //extract trigger href ID
        href = href.substr(href.indexOf('#'));

        var tabs = $(scope._tabSelector).parent(); //tabs parent
        var tab = $('[href=\"' + href + '\"]', tabs); //desired tab
        scope.ActivateTab(tab, true);
    }

    function destroy() {
        scope._container.off('click', scope._tabSelector, handleTabSelector);
        scope._externalTriggers.off('click', handleExternalTriggers);
    }

    return {
        destroy: destroy
    };
};

HSN.TabPanel.prototype = {
    _container: null,
    _externalTriggers: null,
    _tabSelector: null,
    _scrollTo: null,

    /**
    * HSN.TabPanel#ActivateTab(id) -> void
    * - selectedTab (jQuery | HTMLElement | String): A jQuery object, HTML Element(s), or CSS selector that will ultimately resolve to anchor element which represents tab
    * - shouldScrollToTab - scroll to
    * Activates the tab with the given id.
    **/
    ActivateTab: function ActivateTab(selectedTab, shouldScrollToTab) {
        $(selectedTab).parent().addClass('active').siblings().removeClass('active');

        var href = $(selectedTab).attr('href');

        if (href.charAt(0) == '#') {
            shouldScrollToTab = true;
        }

        href = href.substr(href.indexOf('#') + 1);

        $('#' + href, this._container).addClass('active').siblings().removeClass('active');

        if (shouldScrollToTab && this._scrollTo) {
            $('html, body').animate({ scrollTop: $(selectedTab).offset().top }, 100); // note: longer animations make the page seem stuck if user scrolls 
        }
    }
};

/***/ }),

/***/ "BG0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Widget_VideoPlayers_YoutubePlayer_js__ = __webpack_require__("0mmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.YoutubeModal
* Encapsulates the functionality of a youtube video dialog using youtube js api
**/
HSN.YoutubeModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(YoutubeModal, parent);

    var youtubePlayer = null;

    function YoutubeModal() {
        var modal = YoutubeModal.__super__.constructor.call(this);
        var scope = this;
        $(this.Close).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var player = scope.GetPlayer();
            player.destroy();
        }).on('keydown', function (e) {
            if (e.key === 'Tab' & e.shiftKey) {
                e.preventDefault();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                $(this.Close).click();
            }
        });

        var application = HSN.Instance();
        application.Events.On(HSN.Application.EVENT.VIDEO_COMPLETE, function () {
            $('#closeModal').click();
        });

        return modal;
    }

    YoutubeModal.prototype._show = function (videoData, w, h, showDisclaimer) {
        var __scope = this;
        __scope.Root.removeClass("loading");
        __scope.Root.css("overflow-y", "hidden");
        //video div must have a unique id to allow multiple videos
        var playerId = "hsn-youtube-player";
        var disclaimer = showDisclaimer ? "<div id='video-disclaimer' style='padding: 0; margin: -15px 0 10px 24px'>Prices and the availability of FlexPay shown on the previously recorded video may not represent the current price options. Consult the product page for current price options.</div>" : "";
        var ada = "<div class='endOfModal' tabindex='0'></div>";
        this.Content.showHtml("<div id=\"" + playerId + "\" style=\"width: " + w + "px; height: " + h + "px; display: block; padding: 23px;\"></div>" + disclaimer + ada, 0, function () {
            __scope.Center();
            __scope.Content.animate({ opacity: 1 }, {
                complete: function complete() {
                    __scope.Close[0].focus();

                    $('.endOfModal', __scope.Root).off('focus').on('focus', function (e) {
                        __scope.Close[0].focus();
                        e.preventDefault();
                    }).off('keydown').on('keydown', function (e) {
                        __scope.Close[0].focus();
                        e.preventDefault();
                    });
                }
            });

            //load player
            youtubePlayer = new __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Widget_VideoPlayers_YoutubePlayer_js__["a" /* default */](videoData);
        });
    };

    YoutubeModal.prototype.GetPlayer = function () {
        return youtubePlayer;
    };

    return YoutubeModal;
}(HSN.Modal);

/***/ }),

/***/ "BHfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
    * class HSN.EventCoordinator
    *
    * Coordinates the registration and triggering of arbitrary events handlers.
    * May be instantiated directly or as a public property to another class
    * allowing any class to expose an event-driven model.
    **/
HSN.EventCoordinator = function () {
    /**
        * new HSN.EventCoordinator()
        *
        * Instantiates and returns a new [[HSN.EventCoordinator]].
        **/
    this._events = {};
};

HSN.EventCoordinator.prototype = {
    _events: null,

    /**
        * HSN.EventCoordinator#On(name, handler, scope) -> void
        * - name (String): The name of the event to handle.
        * - handler (Function): The function to handle the given event.
        * - scope (Object): The optional scope to execute the handler in. If not provided it will default to the handler.
        *
        * Registers a new handler for the given event to be executed within the given scope.
        **/
    On: function On(name, handler, scope) {
        this._events[name] = this._events[name] = this._events[name] || [];
        if (this._events[name].length === 0) {
            this._events[name].push({
                handler: handler,
                scope: scope
            });
        } else {
            var hasEvent = false;
            var eventsByNameLength = this._events[name].length;
            for (var i = 0; i < eventsByNameLength; i++) {
                if (this._events[name][i].handler === handler && this._events[name][i].scope === scope) {
                    hasEvent = true;
                }
            }

            if (!hasEvent) {
                this._events[name].push({
                    handler: handler,
                    scope: scope
                });
            }
        }
    },

    /**
    * HSN.EventCoordinator#On(name, handler, scope) -> void
    * - name (String): The name of the event to handle.
    * - handler (Function): Optional - function originally passed to On() when attaching event
    * - scope (Object): Option - scope originally passed to On for given handler when attaching event
    *
    * UnRegisters handler for event.
    **/
    Off: function Off(name, handler, scope) {
        if (!(name in this._events)) {
            return; //didnt find any handler for event
        } else {
            this._events[name] = $.grep(this._events[name], function (n) {
                if ((!handler || n.handler === handler) && (!scope || n.scope === scope)) {
                    return false;
                }
                return true;
            });

            if (this._events[name].length !== 0) {
                delete this._events[name];
            }
        }
    },

    /**
        * HSN.EventCoordinator#Trigger(name[, argument1[, argument2[, argumentN]]]) -> void
        * - name (String): The name of the event to trigger handlers for.
        * - arguments (Object): Arguments to be passed to the event handlers.
        *
        * Executes the registered handlers for the given event, passing them the
        * optional arguments in the same order as they are passed.
        **/
    Trigger: function Trigger(name) {
        if (!this._events[name]) {
            return;
        }

        var argumentsCopy = [];
        var argumentsLength = arguments.length;
        for (var i = 0; i < argumentsLength; i++) {
            argumentsCopy[i] = arguments[i];
        }

        var eventsByNameLength = this._events[name].length;
        for (var i = 0; i < eventsByNameLength; i++) {
            this._events[name][i].handler.apply(this._events[name][i].scope || this._events[name][i].handler, argumentsCopy.slice(1));
        }
    },

    /**
        * HSN.EventCoordinator#IsRegistered(name) -> void
        * - name (String): The name of the event to trigger handlers for.
        *
        * Will check the registered events to see if a particular one is registered or not
        **/
    IsRegistered: function IsRegistered(name, scope) {
        var found = false;
        if (this._events[name]) {
            if (scope || scope === '') {
                var matches = $.grep(this._events[name], function (n) {
                    if (n.scope === scope) {
                        return true;
                    } else {
                        return false;
                    }
                });
                if (matches.length !== 0) {
                    found = true;
                }
            } else {
                found = true;
            }
        }
        return found;
    }
};

/***/ }),

/***/ "Bwf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";


/**
* class HSN.MultiItemBagModal
*
* Encapsulates the functionality of a modal dialog that contains information from a multi item add to bag.
**/
HSN.MultiItemBagModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(MultiItemBagModal, parent);

    function MultiItemBagModal() {
        /**
        * new HSN.MultiItemBagModal()
        **/
        var modal = MultiItemBagModal.__super__.constructor.call(this);
        this.name = 'HSN.MultiItemBagModal';

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            closeBagModal(true, modal);
        });

        $(modal.Content).on('click', '.keep-shopping', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(modal.Close).click();
        });

        $(modal.Content).on('click', '.checkout-button', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var destinationUrl = $(this).data('destination-url');

            window.location.href = destinationUrl;
        });
    }

    function closeBagModal(dumpItems, modal) {
        modal.Hide(); //not personalize, so hide modal
    }

    MultiItemBagModal.prototype._show = function (requests, callback) {
        var scope = this;

        this.Content.showHtml('<div id="modal-processing"><h3>Processing</h3><div class="processing-symbol"><img alt="Processing" src="/assets/img/spinner-l-d8d9d9.gif" /></div></div>', 0, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        });

        $.ajax("/bag/multi-item/post?" + new Date().getTime(), {
            context: this,
            contentType: 'application/json; charset=utf-8',
            dataType: 'html',
            type: 'POST',
            data: JSON.stringify({ 'input': requests }),
            success: function success(data) {
                var scope = this;

                scope.Root.removeClass('loading');

                if (data.indexOf('window.location.href') > -1) {
                    this.Redirect = $('<div></div>');
                    this.Redirect.appendTo('body');

                    this.Redirect.showHtml(data, 0);
                } else {
                    this.Content.showHtml(data, 0, function () {
                        scope.Center();
                        scope.Content.animate({ opacity: 1 });
                    });
                }

                /*var bagCount = $('div .checkout-added-overlayDiv').attr('data-bag-count');
                if (bagCount > 0) HSN.Instance().AccountNavigation.SetBagItemCount(bagCount);*/

                if (callback) {
                    callback();
                }
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
            }
        });
    };

    return MultiItemBagModal;
}(HSN.Modal);

/***/ }),

/***/ "Bwwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CardVerificationRetryModal
**/
HSN.CardVerificationRetryModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CardVerificationRetryModal, parent);

    function CardVerificationRetryModal() {
        var modal = CardVerificationRetryModal.__super__.constructor.call(this, 'card-verification-modal');

        this.commerceService = HSN.Instance()._getCommerceService();
        this.paymentService = HSN.Instance()._getPaymentService();
        this.isTokenizerOk = false;
        this.name = 'HSN.CardVerificationRetryModal';
        this.Close.off();
        eventHandlers(this);
        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Content).on('click', '#continue', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Continue-_-226&cm_re=CVV-_-Continue-_-226', '');
            HSN.Instance().ccTokenizerSocket.tokenize(function (response) {
                modal.isTokenizerOk = true;
                if (response.error) {
                    var responseError = {
                        'errorFields': [{ 'Key': 'cvv', 'Value': response.error.faultDetail }],
                        'errors': [response.error.faultDetail],
                        'success': false
                    };
                    HSN.AddErrorTreatment('#cardVerificationForm', responseError, modal.Content);
                } else {
                    $('#cardVerificationTransactionId').val(response.data.transactionID);
                    modal.commerceService.ResubmitCardVerification({ orderIdentity: modal.orderNumber, cardVerificationTransactionId: response.data.transactionID }, {
                        callback: function callback(data) {
                            if (data.success) {
                                window.location = data.NextUrl;
                            } else if (data.RequiresCardVerificationRetry) {
                                HSN.RemoveWait();
                                HSN.Instance().GetCardVerificationRetryModal().Show(true, data.CvvUrl, data.OrderNumber);
                            } else if (data.NextUrl) {
                                window.location = data.NextUrl;
                            } else {
                                HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to resubmit your order, please try again.');
                            }
                        }
                    });
                }
                return false;
            });
        });

        $(modal.Content).on('click', '#cancel', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Cancel-_-226&cm_re=CVV-_-Cancel-_-226', '');
            modal.Hide();
            return false;
        });
    }

    CardVerificationRetryModal.prototype._show = function (isError, tokenizationUrl, orderNumber) {
        var _this = this;

        var scope = this;
        scope.AddLoadingSpinner();
        scope.orderNumber = orderNumber;

        var easyXdmPromise = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "qS3Q"));

        var ajax = $.ajax('/checkout/card-verification-retry?isError=' + isError, {
            context: this,
            dataType: 'html'
        });

        Promise.all([ajax, easyXdmPromise]).then(function (_ref) {
            var content = _ref[0],
                EasyXDMLoaded = _ref[1];

            cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Error-_-226&cm_re=CVV-_-Error-_-226', '');
            scope.RemoveLoadingSpinner();
            _this.Content.showHtml(content, 0, function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
                scope.Root.find('#closeModal').remove();
            }, function () {});

            HSN.Instance().ccTokenizerSocket = new easyXDM.Rpc({
                remote: tokenizationUrl,
                props: {
                    id: 'card-verification-frame',
                    frameborder: 0,
                    scrolling: 'no',
                    style: {
                        overflow: 'hidden',
                        width: '200px',
                        height: '62px',
                        allowTransparency: 'true',
                        margin: '5px auto'
                    }
                },
                container: $('#card-verification-container')[0]
            }, {
                remote: {
                    tokenize: {},
                    clearTextBox: {},
                    status: {}
                }
            });

            window.setTimeout(function () {
                HSN.Instance().ccTokenizerSocket.status(function () {
                    scope.isTokenizerOk = true;
                });
            }, 4800);
            window.setTimeout(function () {
                if (!scope.isTokenizerOk) {
                    scope.paymentService.LogTokenizerFailure({ Type: 'CVV' }, {});
                }
            }, 5000);
        }).catch(function () {
            alert('Unfortunately there was an error attempting to load the content, please try again.');
            scope.RemoveLoadingSpinner();
            scope.Hide();
        });
    };
    return CardVerificationRetryModal;
}(HSN.Modal);

/***/ }),

/***/ "DLzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_VariantInfo_js__ = __webpack_require__("fMYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_ProductOptionSelector_js__ = __webpack_require__("ZrRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_chosen_jquery_js__ = __webpack_require__("Y/iy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_chosen_jquery_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_chosen_jquery_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_ImageSwapper_js__ = __webpack_require__("6iF5");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// define EVENTs





HSN.BonusBuy = function ($) {
    /// <signature>
    ///     <summary>Ensemble Detail Page</summary>
    ///     <returns type="BonusBuy" />
    /// </signature>
    "use strict";

    var application;
    var container;
    var buySelectorList = new Array();

    function handleMatrixOptions() {
        function insertRetailPrice(parent) {
            var retailPriceElement = $("<div/>").addClass("product-retail-price");
            $(parent).prepend(retailPriceElement);
        }

        var products = $(".bonus-buy-product", container);
        var matrixSelector = $(".matrix-options > select", products);

        if ($(".mobile").length == 0 && matrixSelector.length) {
            //matrix select when too many matrix thumbnails to display
            matrixSelector.chosen();
        }

        if (!Modernizr.touchevents) {
            $.each(products, function () {
                // ReSharper disable once WrongExpressionStatement
                var matrixOptions = $(this).find(".matrix-options");
                var productImage = $(this).find("img.main");

                new HSN.ImageSwapper({
                    container: matrixOptions,
                    destinationImage: productImage,
                    triggerSelector: "a",
                    useHover: false,
                    useData: true,
                    followTriggerHref: false
                });
            });
        }

        //Swap price range for specific matrix item price
        $(".matrix-options > a", products).on("click", function (e) {
            e.preventDefault();

            var matrixPriceAmount = $(this).data("price");
            var matrixOldPriceAmount = $(this).data("old-price");
            var matrixRetailPriceAmount = $(this).data("retail-price");
            var matrixRetailPriceLabel = $(this).data("retail-price-label");
            var product = $(this).closest(".bonus-buy-product-info").parent();
            var priceElement = $(".product-price", product);
            var oldPriceElement = $(".product-old-price > del", product);
            var retailPriceElement = $(".product-retail-price", product);

            if (priceElement && matrixPriceAmount) {
                priceElement.text(matrixPriceAmount);
            }
            if (oldPriceElement && matrixOldPriceAmount) {
                oldPriceElement.text(matrixOldPriceAmount);
            }
            if (matrixRetailPriceAmount) {
                //Only show retail price for matrix option if available
                if (!retailPriceElement.length) {
                    insertRetailPrice($(".product-pricing", product));
                    retailPriceElement = $(".product-retail-price", product);
                }
                var retailPriceString = matrixRetailPriceLabel + " value: " + matrixRetailPriceAmount;
                retailPriceElement.text(retailPriceString);
            } else {
                if (retailPriceElement.length) {
                    //Remove retail price if selected product doesnt have it
                    retailPriceElement.text("");
                }
            }

            $(this).siblings().removeClass("selected");
            $(this).addClass("selected");
        });
    }

    function handleOptionsSelect() {
        var addToBagCallback = function addToBagCallback(atbButton) {
            return function () {
                if (HSN.Instance().DeviceInformation.IsMobile) {
                    var checkoutUrl = $(atbButton).data("url");

                    HSN.Instance().GetMobileAddedToBagModal().Show(checkoutUrl);

                    getBagItems();
                }
            };
        };

        function bindBuySelector(product) {
            var imageContainer = $(".bonus-buy-product-image", product);
            var optionsContainer = $(".bonus-buy-product-options", product);
            var variantJsonString = $("#json-variants", optionsContainer).html();
            var variants = variantJsonString ? JSON.parse(variantJsonString) : null;
            var variantInfo = new __WEBPACK_IMPORTED_MODULE_1_HSNDIR_VariantInfo_js__["a" /* default */](variants);
            var productOptionsContainer = $(".product-option-selector", product);
            var matrixOptions = $(product).find(".matrix-options");
            var productImage = $(product).find(".bonus-buy-product-image img");

            if (!optionsContainer.length) {
                return;
            }
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.TabPanel(optionsContainer, ".tabs .tab-items a");

            var addToBagProxy = null;
            if ($("body.mobile").length == 0) {
                optionsContainer.find("input.add-to-bag").addClass("button add-to-bag-proxy");
            }

            //initialize after image swapper/zoomer
            var buySelector = new HSN.BuySelector({
                application: application,
                container: optionsContainer,
                windowLocation: window.location,
                imageContainer: imageContainer,
                favoriteLink: $(".favorite-link", product),
                addToBagCallback: addToBagCallback(addToBagProxy || optionsContainer.find("input.add-to-bag")),
                variants: variants,
                variantInfo: variantInfo
            });

            buySelectorList.push(buySelector);

            //Product Option Selector
            var productOptionSelector = new HSN.ProductOptionSelector({
                application: application,
                container: productOptionsContainer,
                imageContainer: imageContainer,
                favoriteLink: $(".favorite-link", product),
                preSelectedWebId: $(".pre_selected_webid", optionsContainer).val(),
                useSimpleMainImage: $(".is_edit_bag_preview", optionsContainer).val(),
                variantInfo: variantInfo
            }).init();

            if (!Modernizr.touchevents) {
                // ReSharper disable once ConstructorCallNotUsed
                new HSN.ImageSwapper({
                    container: matrixOptions,
                    destinationImage: productImage,
                    triggerSelector: "a",
                    useHover: true,
                    useData: true,
                    followTriggerHref: false
                });
            }
        }

        function updateFavorite(product) {
            HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link:not(.favorite-queried)");
        }

        var products = $(".bonus-buy-product", container);

        var anyProductHaveOptions = $(".bonus-buy-product-options", products).length > 0;
        if (!anyProductHaveOptions) {
            return;
        }

        $.each(products, function () {
            bindBuySelector(this);
        });

        application.Events.On(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, function (matrixProductId, url, editBagItemId, editBagIdentity) {
            var matrixOption = $(".matrix-options > a[data-id=\"" + matrixProductId + "\"], .matrix-options > .matrix-selector > option[value=" + matrixProductId + "]", container);
            var product = matrixOption.parents(".bonus-buy-product");

            RemoveBuySelectorFromList($(".bonus-buy-product-options", product));

            $.ajax("/bonusbuy/promotionproduct/" + matrixProductId, {
                type: "GET",
                data: {},
                dataType: "html",
                success: function success(data) {
                    if (data) {
                        product.fadeOut(function () {
                            $(this).html(data).fadeIn();

                            bindBuySelector(product);

                            bindProductCardSoldOutColorBehavior();

                            handleTooltips();

                            updateFavorite(product);
                        });
                    }
                    HSN.RemoveWait();
                },
                error: function error() {
                    HSN.RemoveWait();
                    alert("Unfortunately there was an error attempting to load the select product.");
                }
            });
        });
    }

    function handleProductThumbnailImages() {
        var products = $(".bonus-buy-product-info", container).parent();
        $.each(products, function () {
            // ReSharper disable once WrongExpressionStatement
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.ImageSwapper({
                container: $(this).find(".product-image-thumbnails"),
                destinationImage: $(this).find("img.main"),
                triggerSelector: "a:not(.video)",
                useHover: true,
                useData: false,
                followTriggerHref: false
            });
        });
    }

    function handleProductSwatches() {
        var products = $(".bonus-buy-product-info", container).parent();
        $.each(products, function () {
            // ReSharper disable once WrongExpressionStatement
            // ReSharper disable once ConstructorCallNotUsed
            new HSN.ImageSwapper({
                container: $(this).find(".product-color-swatches"),
                destinationImage: $(this).find("img.main"),
                triggerSelector: "li",
                useHover: true,
                useData: true,
                followTriggerHref: false
            });
        });
    }

    function handleProductThumbnailVideos() {

        container.find(".product-image-thumbnails .video").each(function () {
            var productVideo = new HSN.Template.ProductVideo({
                application: HSN.Instance(),
                container: $(this),
                videoUrls: { httpUrl: $(this).data("httpUrl"), rtmpUrl: $(this).data("rtmpUrl"), androidUrl: $(this).data("androidUrl") },
                videoName: $(this).data("analyticName"),
                assetId: $(this).data("assetid"),
                webpid: $(this).data("productId"),
                backgroundColor: "#000000"
            });
        });
    }

    function handleAddToBag() {
        var addToBagButton = $(".add-to-bag", container);
        addToBagButton.on("click", function () {
            var productId = $(this).data("product-id");
            application.GetProductPreviewOffCanvas().Show(productId);
            return false;
        });
    }

    function handleTooltips() {
        if (!Modernizr.touchevents) {
            HSN.Tooltip($("[data-tooltip]", container));
        }
    }

    function handlePinterestSharing() {
        $(document).ready(function () {
            $("#pin-button-container").click(function () {
                window.cmCreateManualLinkClickTag("/ensemble-pinterest?cm_sp=Social-_-Ensemble-_-Pinterest&cm_re=Social-_-Ensemble-_-Pinterest", "");
            });
        });

        $(window).on("load", function () {
            (function () {
                var po = document.createElement("script");
                po.type = "text/javascript";
                po.async = true;
                po.src = "https://apis.google.com/js/plusone.js";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(po, s);
            })();

            (function () {
                var po = document.createElement("script");
                po.type = "text/javascript";
                po.async = true;
                po.src = "https://assets.pinterest.com/js/pinit.js";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(po, s);
            })();
        });
    }

    function RemoveBuySelectorFromList(buySelectorContainer) {
        var listIndexToRemove;

        $.each(buySelectorList, function (index, obj) {
            if (obj._container.is(buySelectorContainer)) {
                listIndexToRemove = index;
            }
        });

        if ($.isNumeric(listIndexToRemove) && listIndexToRemove > -1) {
            buySelectorList.splice(listIndexToRemove, 1);
        }

        return;
    }

    function bindProductCardSoldOutColorBehavior() {
        $(".bonus-buy-product-options .small-options label").click(function () {
            var opts = $(this).closest(".bonus-buy-product-options");
            var defaultQty = opts.find(".defaultQuantity").val() || 1;

            opts.find(".quantity select").val(defaultQty).change();
            opts.find(".color-soldout").hide();
        });
    }

    function init(config) {
        /// <signature>
        ///     <summary>Initializer</summary>
        ///     <param name="config" type="PlainObject">
        ///         A set of key/value pairs that configure the Ajax request. All settings are
        ///         optional. A default can be set for any option with $.ajaxSetup(). See jQuery.ajax( settings ) below for a
        ///         complete list of all settings.
        ///     </param>
        /// </signature>
        application = config.application;
        container = $(config.container);

        handleMatrixOptions();
        handleProductThumbnailImages();
        handleProductSwatches();
        handleAddToBag();
        handleProductThumbnailVideos();
        handleTooltips();
        handleOptionsSelect();
        bindProductCardSoldOutColorBehavior();

        $(".bonus-buy-product input.add-to-bag").addClass("button add-to-bag-proxy");
    }

    return {
        init: init
    };
}(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

/***/ }),

/***/ "DY1O":
/***/ (function(module, exports) {

﻿/* Watch an element and trigger a callback when user has scrolled down to it
* Usage: $(element).onviewed(callback);
* Operates on a single element only (first in a jquery collection), use onviewed multiple times to track multiple elements
* Only checks if scrolled down enough, expand if needed
*/
(function ($) {
    var $window = $(window);

    $.fn.onviewed = function (callback) {
        var element = this.eq(0);
        var checkTimeout = null;

        if (!element.length || !callback) {
            return this;
        }

        var check = function() {
            var fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
            var inview = fold >= $(element).offset().top;
            if (inview) {
                callback.call();
                $window.off('scroll', checkDelayed);
                clearTimeout(checkTimeout);
            }
        };

        var checkDelayed = function () {
            if (checkTimeout) {
                clearTimeout(checkTimeout);
            }
            checkTimeout = setTimeout(function () {
                check();
            }, 100);
        };

        $window.on('scroll', checkDelayed);

        $(check);

        return this;
    };
})(jQuery);


/***/ }),

/***/ "E9at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddToBag_js__ = __webpack_require__("Z47Q");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// define EVENTs


/**
    * class HSN.Widget.ApplePay
    *
    * Encapsulates the common functionality of the ApplePay Widget.
    **/
HSN.Widget.ApplePay = function () {
    var application;
    var container;
    var commerceService;
    var deviceInformation;
    var eventIdentity;
    var basketIdentity;
    var applePaySupported;
    var applePayType = HSN.Widget.ApplePay.TYPE.NONE;
    var merchantIdentifier = 'merchant.com.hsn.applepay';
    var applePayError = 'Unfortunately, we cannot process your Apple Pay order at this time. Please try again or call customer service at 1.877.916.0354.';
    var proxyButtonDelay = 500;
    var applePaySession;
    /**
        * new HSN.Widget.ApplePay.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.ApplePay]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        deviceInformation = application.DeviceInformation;
        eventIdentity = config.eventIdentity || '';
        commerceService = application._getCommerceService();
        determineSupport();
        bindEvents();
    }

    function setupApplePaySession(initialProductPrice) {
        var applePayRequest = {
            countryCode: 'US',
            currencyCode: 'USD',
            supportedNetworks: ['visa', 'masterCard', 'discover', 'amex'],
            merchantCapabilities: ['supports3DS'],
            requiredShippingContactFields: ['postalAddress', 'name', 'email', 'phone'],
            requiredBillingContactFields: ['postalAddress', 'name'],
            total: { label: 'Total', amount: initialProductPrice }
        };

        var session = new window.ApplePaySession(1, applePayRequest);
        HSN.Instance().SetApplePaySession(session);
    }

    function determineSupport() {
        if (deviceInformation.IsNativeApp) {
            //Does native app support apple pay?
            HSN.OnAccountStatusLoad(function (data) {
                if (data.applePaySupported) {
                    applePayType = HSN.Widget.ApplePay.TYPE.NATIVE;
                }
                applePaySupported = data.applePaySupported;
                ToggleApplePay(data.applePaySupported);
            });
        } else {
            //TODO uncomment to force applepay button to show for testing UI
            //applePaySupported = true;
            //applePayType = HSN.Widget.ApplePay.TYPE.WEB;
            //window.setTimeout(function () {
            //    ToggleApplePay(applePaySupported);
            //}, proxyButtonDelay);
            //return;
            if (window.ApplePaySession) {
                //TODO: This seems to be a bug in apples sandbox checks, we need to bypass canMakePaymentsWithActiveCard, it will return false always in sandbox
                if (window.location.hostname === 'wwwlocal.hsn.com' || window.location.hostname === 'qa1.hsn.com') {
                    applePaySupported = true;
                    applePayType = HSN.Widget.ApplePay.TYPE.WEB;
                    ToggleApplePay(applePaySupported);
                    return;
                }
                var promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
                promise.then(function (canMakePayments) {
                    if (canMakePayments) {
                        applePaySupported = true;
                        applePayType = HSN.Widget.ApplePay.TYPE.WEB;

                        //proxy buttons, have to delay here
                        window.setTimeout(function () {
                            ToggleApplePay(applePaySupported);
                        }, proxyButtonDelay);
                    } else {
                        applePaySupported = false;
                    }
                });
            } else {
                applePaySupported = false;
                ToggleApplePay(applePaySupported);
            }
        }
    }

    function bindEvents() {
        //Allow external widgets to toggle button
        application.Events.On(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, function (toggle) {
            ToggleApplePay(toggle);
        });

        application.Events.On(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, function (addedBasketItemIdentity) {
            basketIdentity = addedBasketItemIdentity;
            OpenApplePay();
        });

        application.Events.On(HSN.Widget.ApplePay.EVENT.OPEN_PAYMENT_SHEET, function (sourceEventIdentity) {
            if (eventIdentity === sourceEventIdentity) {
                OpenApplePay();
            }
        });

        //window events for native app
        window.ApplePayComplete = HandleComplete;
        window.ApplePayError = HandleError;
        window.ApplePayCancelled = HandleCancel;
    }

    function HandleComplete(data) {
        application.Events.Trigger(HSN.Widget.ApplePay.EVENT.ADD_SUCCESS);
        HSN.SetTempWait(30000);
        commerceService.ProcessOrder({ debitAuthorized: false, debitAuthorizationRequired: false, sessionIdentity: '' }, {
            callback: function callback(data) {
                if (data.success) {
                    Navigate('/checkout/order-confirmation?orderId=' + data.orderNumber);
                } else {
                    HandleError(applePayError);
                }
            }
        });
    }

    function HandleCancel() {
        if (basketIdentity) {
            HSN.SetWait();
            commerceService.RemoveBagItem({ bagItemId: basketIdentity }, {
                callback: function callback() {
                    HSN.RemoveWait();
                }
            });
        }
    }

    function HandleError(message) {
        if (!message || message === '(null)') {
            message = applePayError;
        }
        message = encodeURIComponent(message);
        application.Events.Trigger(HSN.Widget.ApplePay.EVENT.ADD_ERROR);
        Navigate('/checkout/ordererror?errorMessage=' + message);
    }

    function ToggleApplePay(toggle) {
        if (applePaySupported) {
            $('.apple-pay-button').toggle(toggle);
            $('.buy-selector .express-buy-proxy').toggle(!toggle);
            $('.add-to-bag-buttons .express-buy').toggle(!toggle);
            $('.button-group .express-buy').toggle(!toggle);
            $('.apple-pay-container').toggle(toggle);
            if (toggle) {
                $('.paypal-container').addClass('half');
            } else {
                $('.paypal-container').removeClass('half');
            }
        } else {
            $('.apple-pay-button').toggle(false);
            $('.buy-selector .express-buy-proxy').toggle(true);
            $('.add-to-bag-buttons .express-buy').toggle(true);
            $('.button-group .express-buy').toggle(true);
            $('.paypal-container').removeClass('half');
            $('.apple-pay-container').toggle(false);
        }
    }

    function Navigate(url) {
        if (deviceInformation.IsNativeApp) {
            url = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command;
            if (deviceInformation.IsTablet) {
                if (deviceInformation.OsName === 'Android') {
                    command = 'hsn://HSNWebView.PopOverWithUrl/' + encodedUrl + '/1';
                    __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
                } else {
                    command = 'hsn://HSNWebView.PushUrl/' + encodedUrl;
                    __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
                }
            } else {
                command = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].BuildGapCommand(url);
                __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
            }
        } else {
            window.location.href = url;
        }
    }

    function Destroy() {
        application = container = commerceService = null;
    }
    function OpenApplePay() {
        if (applePayType === HSN.Widget.ApplePay.TYPE.NATIVE) {
            commerceService.ApplePayBagGet({}, {
                callback: function callback(data) {
                    OpenPaymentSheet(data);
                },
                errorCallback: function errorCallback() {
                    alert('Unfortunately there was a problem with Apple Pay. Please try again or contact customer service.');
                }
            });
        } else {
            OpenPaymentSheet();
        }
    }
    function OpenPaymentSheet(lineItems) {
        if (applePayType === HSN.Widget.ApplePay.TYPE.NATIVE) {
            var jsonString = JSON.stringify(lineItems);
            var escapedGapData = escape(jsonString);
            __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand('hsn://HSNWebView.ApplePay//' + escapedGapData);
        } else {
            applePaySession = application.GetApplePaySession();
            applePaySession.oncancel = HandleCancel;
            applePaySession.onvalidatemerchant = HandleValidateMerchant;
            applePaySession.onshippingcontactselected = HandleShippingContactSelected;
            //Future use?
            //applePaySession.onpaymentmethodselected = PaymentMethodSelected;
            applePaySession.onpaymentauthorized = HandlePaymentAuthorized;
            applePaySession.begin();
        }
    }

    function HandleValidateMerchant(event) {
        commerceService.ApplePayValidate({ validationUrl: event.validationURL }, {
            callback: function callback(data) {
                if (data && data.signature) {
                    applePaySession.completeMerchantValidation(data);
                } else {
                    HandleCancel();
                    applePaySession.abort();
                }
            },
            errorCallback: function errorCallback() {
                HandleCancel();
                applePaySession.abort();
            }
        });
    }
    function HandleShippingContactSelected(event) {
        var zipCode = event.shippingContact.postalCode;
        commerceService.ApplePayChangeShipping({ ZipCode: zipCode }, {
            callback: function callback(data) {
                var newTotal = data.LineItemData.Total;
                var newLineItems = data.LineItemData.LineItems;
                applePaySession.completeShippingContactSelection(applePaySession.STATUS_SUCCESS, [], newTotal, newLineItems);
            },
            errorCallback: function errorCallback() {
                applePaySession.completeShippingContactSelection(applePaySession.STATUS_FAILURE, [], { label: 'Total', amount: .01 }, []);
            }
        });
    }
    //function HandlePaymentMethodSelected(event) {
    //    var zipCode = event.shippingContact.postalCode;
    //    commerceService.ApplePayChangePayment({ ZipCode: zipCode }, {
    //        callback: function (data) {
    //            var newTotal = data.LineItemData.Total;
    //            var newLineItems = data.LineItemData.LineItems;
    //            applePaySession.completePaymentMethodSelection(applePaySession.STATUS_SUCCESS, [], newTotal, newLineItems);
    //        },
    //        errorCallback: function () {
    //            applePaySession.completePaymentMethodSelection(applePaySession.STATUS_FAILURE, [], { label: 'Total', amount: .01 }, []);
    //        }
    //    });
    //}
    function HandlePaymentAuthorized(event) {
        var applePayment = event.payment;
        var validationStatus = validatePaymentObject(applePayment);
        if (validationStatus) {
            applePaySession.completePayment(validationStatus);
            return;
        }
        var billingAddress = getAddressObject(applePayment.billingContact);
        var shippingAddress = getAddressObject(applePayment.shippingContact);
        var email = applePayment.shippingContact.emailAddress;
        var cardDetails = {
            Network: applePayment.token.paymentMethod.network,
            PaymentName: applePayment.token.paymentMethod.displayName
        };
        var paymentData = applePayment.token.paymentData;
        commerceService.ApplePayComplete({ BillingAddress: billingAddress, ShippingAddress: shippingAddress, EmailAddress: email, CardDetails: cardDetails, PaymentData: paymentData }, {
            callback: function callback(data) {
                if (data.success) {
                    applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
                    HandleComplete();
                } else {
                    var message = data.message;
                    applePaySession.completePayment(data.errorResponse.Code);

                    if (data.errorResponse && data.errorResponse.Code === 1) {
                        HandleError(message);
                    }
                }
            },
            errorCallback: function errorCallback() {
                applePaySession.completePayment(applePaySession.STATUS_FAILURE);
            }
        });
    }
    function getAddressObject(appleContact) {
        var address = {
            FirstName: appleContact.givenName,
            LastName: appleContact.familyName,
            AddressLine1: appleContact.addressLines[0],
            AddressLine2: appleContact.addressLines[1],
            City: appleContact.locality,
            State: appleContact.administrativeArea,
            ZipCode: appleContact.postalCode
        };
        if ("phoneNumber" in appleContact) {
            address.PhoneNumber = appleContact.phoneNumber;
        }
        return address;
    }
    function validatePaymentObject(applePayment) {
        if (!applePayment.billingContact || !applePayment.billingContact.givenName || !applePayment.billingContact.familyName || !applePayment.billingContact.addressLines || applePayment.billingContact.addressLines.length < 1 || !applePayment.billingContact.addressLines[0] || !applePayment.billingContact.locality || !applePayment.billingContact.administrativeArea || !applePayment.billingContact.postalCode) {
            return applePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS;
        }
        if (!applePayment.shippingContact || !applePayment.shippingContact.givenName || !applePayment.shippingContact.familyName || !applePayment.shippingContact.addressLines || applePayment.shippingContact.addressLines.length < 1 || !applePayment.shippingContact.addressLines[0] || !applePayment.shippingContact.locality || !applePayment.shippingContact.administrativeArea || !applePayment.shippingContact.postalCode) {
            return applePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS;
        }
        if (!applePayment.shippingContact.emailAddress || !applePayment.shippingContact.phoneNumber) {
            return applePaySession.STATUS_INVALID_SHIPPING_CONTACT;
        }
        return '';
    }
    function getApplePaySessionStatus(statusCode) {
        switch (statusCode) {
            case 1:
                return applePaySession.STATUS_FAILURE;
            case 2:
                return applePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS;
            case 3:
                return applePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS;
            case 4:
                return applePaySession.STATUS_INVALID_SHIPPING_CONTACT;
        }
    }
    return {
        init: init,
        setupApplePaySession: setupApplePaySession,
        Destroy: Destroy
    };
};

HSN.Widget.ApplePay.EVENT = {
    ADD_SUCCESS: 'HSN.Widget.ApplePay:ADD_SUCCESS',
    ADD_ERROR: 'HSN.Widget.ApplePay:ADD_ERROR',
    TOGGLE_APPLE_PAY: 'HSN.Widget.ApplePay:TOGGLE_APPLE_PAY',
    OPEN_PAYMENT_SHEET: 'HSN.Widget.ApplePay:OPEN_PAYMENT_SHEET'
};
HSN.Widget.ApplePay.TYPE = {
    NATIVE: 'HSN.Widget.ApplePay.Type:NATIVE',
    WEB: 'HSN.Widget.ApplePay.Type:WEB',
    NONE: 'HSN.Widget.ApplePay.Type:NONE'
};

/***/ }),

/***/ "FJ3w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.PastShowModal
* 
* Encapsulates the functionality of the modal dialog for past shows
**/

HSN.PastShowModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(PastShowModal, parent);

    function PastShowModal(config) {
        var modal = PastShowModal.__super__.constructor.call(this);

        this.callback = null;
        this.callbackcancel = null;

        this.Close.off();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            modal.Hide();
        });
    }

    callbackok: null;
    callbackcancel: null;

    /**
        * HSN.PastShowModal.Show() -> void
        * 
        * Display the modal and load in all the infos
        */
    PastShowModal.prototype._show = function (data) {
        $.ajax('/watch/past-shows/watch-now', {
            context: this,
            dataType: 'html',
            data: data,
            success: function success(data, status, xhr) {
                var scope = this;
                scope.Root.removeClass('loading');
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                }, function () {});
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };
    return PastShowModal;
}(HSN.Modal);

/***/ }),

/***/ "FfXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// define EVENTs


/**
* class HSN.FlyoutManager
*
* Coordinates the state of set of [[HSN.Flyout]] instances to ensure that
* their interactions are synchronized.
**/
HSN.FlyoutManager = function (config) {
    /**
    * new HSN.FlyoutManager(config)
    * - config (Object): A configuration object for the [[HSN.FlyoutManager]]
    *   consisting of the following keys:
    *   - flyouts (Array [[HSN.Flyout]]): The [[HSN.Flyout]] instances the [[HSN.FlyoutManager]] is supposed to coordinate.
    **/
    var __scope = this;

    this.Flyouts = config.flyouts;

    $.each(this.Flyouts, function (i, flyout) {
        __scope.Add(flyout);
    });

    $(window).on('keydown', function (event) {
        var keyCode = event.keyCode || event.which;
        if (keyCode != 27) {
            return;
        }
        $.each(__scope.Flyouts, function (i, flyout) {
            flyout.Close();
        });
    });
};
HSN.FlyoutManager.prototype = {
    /**
    * HSN.FlyoutManager#Flyouts -> [HSN.Flyout]
    *
    * [[HSN.FlyoutManage#Flyouts]] provides access to the [[HSN.Flyout]] instances it is coordinating.
    **/
    Flyouts: null,

    /**
    * HSN.FlyoutManager#Add(flyout) -> void
    * - flyout (HSN.Flyout): The [[HSN.Flyout]] to be managed.
    *
    * Adds the given [[HSN.Flyout]] to the collection of [[HSN.Flyout]]s that need to be managed and coordinated.
    **/
    Add: function Add(flyout) {
        var __scope = this;
        flyout.Events.On(HSN.Flyout.EVENT.BEFORE_OPEN, function (flyout) {
            $.each(__scope.Flyouts, function (j, otherFlyout) {
                if (otherFlyout != flyout) {
                    otherFlyout.Close();
                }
            });
        }, this);
        this.Flyouts.push(flyout);
    },

    Remove: function Remove(flyout) {
        var __scope = this;
        __scope.Flyouts = $.grep(__scope.Flyouts, function (element, index) {
            if (element == flyout) {
                element.Close();
                element.RemoveHandlers();
                return false;
            } else {
                return true;
            }
        });
    }
};

/***/ }),

/***/ "Flij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.EmailFriendsModal
*
* Encapsulates the functionality of a modal dialog that contains email friend form
**/
HSN.EmailFriendsModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(emailFriendsModal, parent);

    /**
    * new HSN.emailFriendsModal()
    **/
    function emailFriendsModal() {
        this.name = 'HSN.EmailFriendsModal';
        emailFriendsModal.__super__.constructor.call(this);

        eventHandlers(this);
    }
    emailFriendsModal.prototype._hide = function () {};

    function eventHandlers(modal) {
        $(modal.Content).on('click', '#emailfriend', function () {
            modal.SubmitEmailFriendForm(true);
            return false;
        });

        $(modal.Content).on('click', '#emailfriendcancel', function () {
            modal.Hide();
            return false;
        });

        $(modal.Content).on('keyup', '#Message', function () {
            var max = 500;
            var len = $(this).val().length;
            if (len >= max) {
                $('#Message-chars-remain').text(0 + '/' + max);
                $(this).val($(this).val().slice(0, max));
            } else {
                var charsRemain = max - len;
                $('#Message-chars-remain').text(charsRemain + '/' + max);
            }
        });
        $(modal.Content).on('click', '#close', function () {
            modal.Hide();
        });
    }

    /**
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    emailFriendsModal.prototype._show = function (url, webPId, title, photoUrl, imageDescription, productUrl) {

        var scope = this;
        emailFriendsModal.url = url;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: { 'WebPId': webPId, 'Title': title, 'PhotoUrl': photoUrl, 'ImageDescription': imageDescription, 'ProductUrl': productUrl },
            success: function success(htmlData) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(htmlData, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for recommend a friend, use ajax to retrieve response, and update modal content
    **/
    emailFriendsModal.prototype.SubmitEmailFriendForm = function (saveData) {

        var scope = this;
        var emailFriendForm = $('form', scope.Root);
        var formData = emailFriendForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/products/emailfriend/email-friend-post',
            dataType: 'json',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        }).done(function (data) {
            if (data.success) {
                $('div.errors').remove();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModal").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModalSucess").show();

                scope.Center();
            } else {
                HSN.AddErrorTreatment('#emailFriendForm', data);
            }
        }).fail(function () {
            alert('error submitting the request');
        });
    };

    emailFriendsModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            var elemetToFocus = scope.Root.find('#modalPopup');
            scope.Center();
            scope.Content.animate({ opacity: 1 }, function () {
                scope.SetFocus(elemetToFocus);
            });
        }, function () {
            //scope.Center();
        });
    };
    return emailFriendsModal;
}(HSN.Modal);

/***/ }),

/***/ "GCfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Template_Checkout_PayPalInContext_js__ = __webpack_require__("deWE");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Used by PaymentManagementWidget


HSN.Service.PaymentService = function () {};
HSN.Service.PaymentService.prototype = {
    RemovePaymentMethod: function RemovePaymentMethod(data, config) {
        this._send('/payment-management/remove-payment', data, config);
    },
    SelectPayment: function SelectPayment(data, config) {
        this._send('/payment-management/select-payment', data, config);
    },
    ValidatePayment: function ValidatePayment(data, config) {
        this._send('/payment-management/validate-payment', data, config);
    },
    AddEditPaymentSave: function AddEditPaymentSave(data, config) {
        this._send('/payment-management/save-payment', data, config);
    },
    LogTokenizerFailure: function LogTokenizerFailure(data, config) {
        this._send('/payment-management/log-tokenizer-failure', data, config);
    },
    GetEditPaymentForm: function GetEditPaymentForm(paymentIdentity, data, config) {
        this._get('/payment-management/add-edit-payment/' + paymentIdentity, data, config);
    },
    GetAddPaymentForm: function GetAddPaymentForm(data, config) {
        this._get('/payment-management/add-edit-payment', data, config);
    },
    GetPaymentList: function GetPaymentList(data, config) {
        this._get('/payment-management/payment-list', data, config);
    },
    GetPaymentManagementWidget: function GetPaymentManagementWidget(data, config) {
        this._get('/payment-management/get', data, config);
    },
    _send: function _send(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error() {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _get: function _get(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'html',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    }
};

/***/ }),

/***/ "GDK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.Widget.FlexPayPayNow
    *
    * Encapsulates the common functionality of the FlexPayPayNow Widget.
    **/
HSN.Widget.FlexPayPayNow = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var paymentNumbers;
    /**
        * new HSN.Widget.FlexPayPayNow.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayPayNow]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        paymentNumbers = config.paymentNumbers;

        if (deviceInformation.IsMobile) {
            SetMyEventHandlers();
        }

        bindEvents();
    }

    function bindEvents() {
        container.on('click', '#pay-now', function () {
            var isAuthorized = $('.authorization-check', container).is(':checked');
            if (!isAuthorized) {
                alert('Please confirm that you have reviewed the details before submitting.');
                return false;
            }

            container.html('');
            HSN.SetContainerWait(container);
            accountService.FlexPayGetProcessingPage({ orderIdentity: orderIdentity, flexPayNumbers: paymentNumbers }, {
                callback: function callback(content) {
                    HSN.RemoveContainerWait();
                    container.showHtml(content, 0, function () {}, function () {});
                },
                errorCallback: function errorCallback() {}
            });

            HSN.DataLayer.helpers.metricEvent(null, "RE:flexpaymanager", "authorization", "paynow");

            return false;
        });
        container.on('click', '#cancel', function () {
            HSN.Instance().Events.Trigger(HSN.Widget.FlexPayPayNow.EVENT.CANCELLED, orderIdentity);

            HSN.DataLayer.helpers.metricEvent(null, "RE:flexpaymanager", "authorization", "cancel");

            return false;
        });
    }
    function ClearChildEventHandlers() {}
    function ClearMyEventHandlers() {}
    function SetMyEventHandlers() {}
    function Destroy() {
        ClearMyEventHandlers();
        ClearChildEventHandlers();
    }
    return {
        init: init,
        Destroy: Destroy
    };
};

HSN.Widget.FlexPayPayNow.EVENT = {
    CANCELLED: 'HSN.Widget.FlexPayPayNow:CANCELLED'
};

/***/ }),

/***/ "GoIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.EmailFriendsModal
*
* Encapsulates the functionality of a modal dialog that contains email friend form
**/
HSN.EmailFriendsEnsembleModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(emailFriendsEnsembleModal, parent);

    /**
    * new HSN.emailFriendsModal()
    **/
    function emailFriendsEnsembleModal() {
        this.name = 'HSN.EmailFriendsEnsembleModal';
        emailFriendsEnsembleModal.__super__.constructor.call(this);
    }
    emailFriendsEnsembleModal.prototype._hide = function () {};

    /**
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    emailFriendsEnsembleModal.prototype._show = function (url, ensembleId, title, photoUrl, imageDescription, productUrl) {
        var scope = this;
        emailFriendsEnsembleModal.url = url;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: { 'ensembleId': ensembleId, 'Title': title, 'PhotoUrl': photoUrl, 'ImageDescription': imageDescription, 'ProductUrl': productUrl },
            success: function success(htmlData) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(htmlData, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for recommend a friend, use ajax to retrieve response, and update modal content
    **/
    emailFriendsEnsembleModal.prototype.SubmitEmailFriendForm = function (saveData) {

        var scope = this;
        var emailFriendForm = $('form', scope.Root);
        var formData = emailFriendForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/ensemble/emailfriend/email-friend-post',
            dataType: 'json',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        }).done(function (data) {

            if (data.success) {
                $('div.errors').remove();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModal").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModalSucess").show();
            } else {
                HSN.AddErrorTreatment('#emailFriendForm', data);
            }
        }).fail(function () {
            alert('error submitting the request');
        });
    };

    emailFriendsEnsembleModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {
            //scope.Center();
        });
    };
    return emailFriendsEnsembleModal;
}(HSN.Modal);

/***/ }),

/***/ "H6N7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
    * class HSN.ExchangeVariantSelector
    *
    * Progressively enhances a definition list full of option radio buttons and
    * labels to be more interactive.
    **/
HSN.ExchangeVariantSelector = function (config) {
    /**
        * new HSN.ExchangeVariantSelector(config)
        * - config (Object): A configuration object for the [[HSN.ExchangeVariantSelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the BuySelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector
        *     that will ultimately resolve to an HTML element will act as the container for the set of options.
        **/

    var __scope = this;

    var _flyouts = [];

    this._application = config.application;

    this._container = $('.new-item-details');
    this.__varSelections = [];

    this._preSelectedWebId = $('.pre_selected_webid', __scope._container).val();
    this._isPlusSizeVariantSelected = false;

    var variantJsonString = $('#json-variants').html();
    this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;

    this._preselectedVariant = $.grep(__scope._variants, function (v) {
        return v.Sku == __scope._preSelectedWebId;
    })[0];

    this._imageContainer = $('#new-prod-image');

    var tabs = new HSN.TabPanel($('.product-option-selector', __scope._container), '.variant-group-tab-items a', null, false);

    this.init = function () {
        this._container.addClass('product-option-selector'); //TODO remove?

        this.SynchronizeOptionLabels();

        var waitlistFlyout = $('<div class="flyout-container"><div class="variant-waitlist flyout"><div class="variant-flyout-header">On Waitlist</div></div></div>');
        var soldoutFlyout = $('<div class="flyout-container"><div class="variant-soldout flyout"><div class="variant-flyout-header">Sold Out</div></div></div>');

        //ignore hover events used for product option preview on touch devices
        if (!Modernizr.touchevents) {
            this._container.on('mouseenter', 'dd label', function (e) {
                var $label = $(this);
                var $input = $('input', this);
                if (!$input.length) {
                    return;
                }
                //set selected option description
                var relatedDt = $label.closest('dd').prevAll('dt:first');
                var selectedSpan = relatedDt.find("span");

                if (!selectedSpan.length) {
                    //create span for first time use
                    selectedSpan = $("<span></span>");
                    relatedDt.append(selectedSpan);
                }
                selectedSpan.text($input.data('label'));
            });

            this._container.on('mouseleave', 'dd label', function (e) {
                var $label = $(this);
                var $selectedInput = $('> input:checked', $(this).siblings());

                if ($selectedInput.length > 0) {
                    //set selected option description
                    var relatedDt = $label.closest('dd').prevAll('dt:first');
                    var selectedSpan = relatedDt.find("span");
                    if (!selectedSpan.length) {
                        //create span for first time use
                        selectedSpan = $("<span></span>");
                        relatedDt.append(selectedSpan);
                    }
                    selectedSpan.text($selectedInput.data('label'));
                }
            });
        }

        //Prevent variant flyout from triggered variant selection
        this._container.on('click', '.small-options label .flyout', function (e) {
            e.preventDefault(); //by default children on label will trigger input on it, so prevent that.
        });

        //handle group selection
        this._container.on('click keydown', '.variant-group-tab-items label', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
                return;
            }

            var relatedDt = $(this).closest('dd').siblings('dt');
            var selectedLabel = relatedDt.find("label.product-option-label");
            var selectedGroupLabel = $(this).closest('dd').siblings('dt:first').find('> label');

            if (selectedLabel.text().length == 0) {
                selectedLabel.text(selectedLabel.data('text'));
                selectedLabel.addClass(selectedLabel.data('class'));
                selectedLabel.show();
            }

            selectedGroupLabel.removeClass('inline-error');
            $('div[class*="errors"]').remove();

            $('> label', $(this).parent().siblings()).removeClass('checked-selected');
            $('> label', $(this).parent().siblings()).removeClass('waitlisted-selected');

            if ($(this).hasClass('waitlisted')) {
                $(this).addClass('waitlisted-selected');
            } else {
                $(this).addClass('checked-selected');
            }

            $('> input', this).prop('checked', true);

            __scope._isPlusSizeVariantSelected = $('> input', this).data('is-plus-size-group');

            //clear out size variant selected
            var sizeVariantLabel = __scope.GetSelectedVariant('S');
            if (sizeVariantLabel) {
                var $input = $(sizeVariantLabel).find('> input');
                var selectedInputGroup = $input.attr('name');
                var selectedInputGroupNumber = selectedInputGroup.substr(21, 1) - 1;
                delete __scope.__varSelections[selectedInputGroupNumber];
                __scope.DeactivateOptionLabel(sizeVariantLabel);
            }

            //reactivate non size variant buttons
            $.each(__scope.__varSelections, function (index, label) {
                if (!label || label === sizeVariantLabel) {
                    return;
                }
                var $input = $(label).find('> input');
                __scope.SelectVariant($input.val(), false);
            });
        });

        //handle input selection
        this._container.on('change', 'input[name^="product-modal-option"]', function (e) {
            var hasMatrix = $('.matrix-options', __scope._container).length;

            if (__scope._variants === null && hasMatrix) {
                var hasMatrixErrorMessage = $('dt:first label .matrix-selection-error', __scope._container).length;
                if (!hasMatrixErrorMessage) {
                    $('dt:first label', __scope._container).append('<span class="matrix-selection-error">Please ' + $('dt:first label', __scope._container).html().toLowerCase() + ' first.</span>');
                }
                return;
            }

            var $selectedInput = $(this);

            //input group
            var selectedInputGroup = $selectedInput.attr('name');
            var selectedInputLabel = $selectedInput.parent('label');

            var selectedInputGroupNumber = selectedInputGroup.substr(21, 1) - 1;

            //clear previously selected option
            if (__scope.__varSelections[selectedInputGroupNumber] != null && __scope.__varSelections[selectedInputGroupNumber].find('> input').val() != $selectedInput.val()) {
                __scope.DeactivateOptionLabel(__scope.__varSelections[selectedInputGroupNumber]);
            }

            //set new currently selected option in this group
            __scope.__varSelections[selectedInputGroupNumber] = selectedInputLabel;

            //activate selected item
            $("input[name^='product-modal-option']:checked", __scope._container).each(function () {
                __scope.ActivateOptionLabel($(this).parent('label'), false); //TODO FIXME Hack needed after removing mouseenter/mouseleave events
                __scope.ActivateOptionLabel($(this).parent('label'), true);
            });

            $.each(_flyouts, function () {
                //remove previous flyouts
                __scope._application.FlyoutManager.Remove(this);
            });

            _flyouts = [];
            _flyouts.push(new HSN.Flyout({
                cacheable: true,
                closer: '<div></div>',
                flyout: $('.flyout', waitlistFlyout.clone()),
                trigger: $('.small-options label.waitlisted', __scope._container),
                noajax: false,
                relocateFlyout: true,
                timeout: 0,
                disableHover: Modernizr.touchevents
            }));
            _flyouts.push(new HSN.Flyout({
                cacheable: true,
                closer: '<div></div>',
                flyout: $('.flyout', soldoutFlyout.clone()),
                trigger: $('.small-options label.disabled-overlay', __scope._container),
                noajax: false,
                relocateFlyout: true,
                timeout: 0,
                disableHover: Modernizr.touchevents
            }));

            $.each(_flyouts, function () {
                //add new flyouts
                __scope._application.FlyoutManager.Add(this);
                if (Modernizr.touchevents) {
                    //On touch devices, open bubble for item selected if matches bubble trigger
                    if (selectedInputLabel.is(this.Trigger)) {
                        this.Open(selectedInputLabel);
                    }
                }
            });
        });

        //handle mouseover thumbnails
        $('.product-option-selector .inline-image', this._container).on('mouseenter', function () {
            var $input = $(this).siblings('input');
            var images = $input.data('images');

            if (this._isPlusSizeVariantSelected) {
                if (images.detailPlusSize) {
                    $('#new-prod-image', this._imageContainer).attr('src', images.detailPlusSize);
                } else if (images.zoomPlusSize) {
                    $('a', this._imageContainer).data('zoom', images.zoomPlusSize);
                }
            } else {
                if (images.detail) {
                    $('#new-prod-image', this._imageContainer).attr('src', images.detail);
                } else if (images.zoom) {
                    $('a', this._imageContainer).data('zoom', images.zoom);
                }
            }
        });

        //If only option, select it by default
        if ($('input[class*="product-modal-option-1"]', __scope._container).length == 1) $('input[class*="product-modal-option-1"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-2"]', __scope._container).length == 1) $('input[class*="product-modal-option-2"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-3"]', __scope._container).length == 1) $('input[class*="product-modal-option-3"]', __scope._container).first().click();

        __scope.SelectCodesFromVariant(__scope._preselectedVariant, ["S", "C"]);
    };
};

HSN.ExchangeVariantSelector.prototype = {
    _container: null,

    /**
        * HSN.ExchangeVariantSelector#ActivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that
        *   will ultimately resolve one of the option labels in this product modal.
        * - sel (boolean) mark as selected?
        *
        * Modifies the label as necessary to support the activated state of the alternate image and
        * adds the active class.
        **/
    ActivateOptionLabel: function ActivateOptionLabel(label, sel) {
        var scope = this;
        var variants = scope._variants;

        if (variants === null) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label); //input for label

        //disable error messages
        $('label[class*="inline-error"]', scope._container).removeClass('inline-error');
        $('div[class*="errors"]').remove();
        $('.extended-delivery-notice', scope._container).remove();
        var errorDiv = $(scope._container).siblings('.product-modal-option-status');
        errorDiv.text('');
        var allInputs = $('input[name^="product-modal-option"]', scope._container);

        if (sel) {
            //mark as selected
            if ($label.hasClass('waitlisted')) {
                $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('waitlist-disabled-overlay');
                $(allInputs[i]).parent('label').addClass('waitlist-disabled-overlay').removeClass('regular').removeClass('checked-selected').removeClass('checked').removeClass('waitlisted').removeClass('waitlisted-selected');
                $(allInputs[i]).prop('checked', false);
            } else {
                $label.addClass('regular');
                $label.addClass('checked-selected');
            }
        } else {
            //marked as active but not selected
            $label.addClass('checked');
        }

        var selectedCode = $input.val(); //variant code

        var inputGroupName = $input.attr('name'); //radio group name of selected option
        var variantsLength = variants.length;

        if (sel && selectedCode.substr(0, 1) === "S") {
            //Handle Size Variant)
            scope._isPlusSizeVariantSelected = $input.data('is-plus-size-code');
        }

        var allInputsLength = allInputs.length;
        for (var i = 0; i < allInputsLength; i++) {

            if (allInputs[i].name == inputGroupName) {
                //if this input part of chosen input group
                if (variants[0].Codes.length > 1) continue; //continue if more than one option group
                else {
                        //only one option group exist
                        var currentCode = allInputs[i].value; //this inputs variant code
                        var foundCallout = false;
                        for (var a = 0; a < variantsLength; a++) {
                            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(selectedCode, variants[a].Codes) > -1 && selectedCode == currentCode) {
                                //if found selected variant
                                if (variants[a].Callout != null) {
                                    //if variant has callout
                                    if (variants[a].Callout["Name"] == 'SoldOut' || variants[a].Callout["Name"] == 'Waitlist' || variants[a].Callout["Name"] == 'LowInventory' || variants[a].Callout["Name"] == 'BackOrder' || variants[a].Callout["Name"] == 'ExtendedDelivery') {
                                        foundCallout = true; //found selected variant, and it has callout
                                        break;
                                    }
                                }
                            }
                        }
                        if (foundCallout) {
                            //if found selected variant with callout
                            if (variants[a].Callout["Name"] == 'Waitlist') {

                                $(allInputs[i]).parent('label').addClass('waitlisted');
                                $(allInputs[i]).parent('label').addClass('waitlist-disabled-overlay');
                            } else if (variants[a].Callout["Name"] == "BackOrder") {
                                $('.extended-delivery-notice', scope._container).remove();
                                var notice = $('<div class="extended-delivery-notice">Extended Delivery</div>');
                                $('.button-cancel', scope._container).before(notice);
                            } else {
                                $('.extended-delivery-notice', scope._container).remove();
                            }
                        }
                    }
            } else {
                //this input not in chosen input group
                var currentCode = allInputs[i].value; //this inputs variant code
                var foundVariant = false;
                for (var j = 0; j < variantsLength; j++) {
                    //if this variant group has selected variant and current input variant
                    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(selectedCode, variants[j].Codes) > -1 && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(currentCode, variants[j].Codes) > -1) {
                        foundVariant = true;
                        //if this variant group has callout
                        if (variants[j].Callout != null) {
                            if (variants[j].Callout["Name"] == 'SoldOut' || variants[j].Callout["Name"] == 'Waitlist') {
                                var webid = variants[j].WebId;
                                var soldout = true;
                                if (variants[0].Codes.length > 2) {
                                    //check soldout for case of 3 option groups
                                    for (var x = 0; x < variantsLength; x++) {
                                        if (variants[x].WebId != webid && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(selectedCode, variants[x].Codes) > -1 && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(currentCode, variants[x].Codes) > -1 && (variants[x].Callout == null || variants[x].Callout["Name"] != 'SoldOut' || variants[j].Callout["Name"] != 'Waitlist')) {
                                            soldout = false; //found a variant group where not sold out
                                        }
                                    }
                                }
                                if (soldout) {
                                    $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('disabled-overlay');
                                    $(allInputs[i]).parent('label').addClass('disabled-overlay').removeClass('checked-selected').removeClass('waitlist-disabled-overlay').removeClass('checked').removeClass('waitlisted-selected');
                                    if (sel) {
                                        $(allInputs[i]).prop('checked', false);
                                    }
                                }
                            }
                            /*                                else if (variants[j].Callout["Name"] == 'Waitlist') {
                                                            var waitwebid = variants[j].WebId;
                                                            var waitlisted = true;
                                                            //check waitlist for case of 3 option groups
                                                            if (variants[0].Codes.length > 2) {
                                                                for (var z = 0; z < variantsLength; z++) {
                                                                    if (variants[z].WebId != waitwebid
                                                                        && jQuery.inArray(selectedCode, variants[z].Codes) > -1
                                                                        && jQuery.inArray(currentCode, variants[z].Codes) > -1) {
                                                                        if (variants[z].Callout == null || variants[z].Callout["Name"] != 'Waitlist') {
                                                                            waitlisted = false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            if (waitlisted) {
                                                                if (sel && $(allInputs[i]).parent('label').hasClass('checked')) {
                                                                    $(allInputs[i]).parent('label').addClass('waitlisted-selected');
                                                                }
                                                                else {
                                                                    $(allInputs[i]).parent('label').addClass('waitlisted');
                                                                }
                                                            }
                                                        }*/
                            break;
                        }
                    }
                }
                if (!foundVariant) {
                    //If variant for selected combo doesnt exist, mark as soldout
                    $('span[class*="' + $(allInputs[i]).attr('class') + '-soldout"]', scope._container).addClass('disabled-overlay');

                    $(allInputs[i]).parent('label').addClass('disabled-overlay').removeClass('checked-selected').removeClass('checked').removeClass('waitlisted-selected').removeClass('waitlist-disabled-overlay');

                    if (sel) {
                        $(allInputs[i]).prop('checked', false);
                    }
                }
            }
        }

        var statusText = "";
        if (variants != null) {
            //get currently selected values
            //TODO: reselecting vs using varSelections array
            var var1 = $("input[name='product-modal-option-1']:checked", scope._container).val();
            var var2 = $("input[name='product-modal-option-2']:checked", scope._container).val();
            var var3 = $("input[name='product-modal-option-3']:checked", scope._container).val();
            var arr = [];
            if (var1 != null) arr.push(var1);

            if (var2 != null) arr.push(var2);

            if (var3 != null) arr.push(var3);

            var selectedVariant = $.grep(variants || [], function (variant) {
                return $(arr).not(variant.Codes).length == 0 && $(variant.Codes).not(arr).length == 0;
            });
        }

        //actually set status text
        var statusDiv = $(scope._container).siblings('.product-modal-option-status');
        statusDiv.text(statusText);

        //set selected option description
        var relatedDt = $label.closest('dd').prev('dt');
        var selectedSpan = relatedDt.find("span");
        if (!selectedSpan.length) {
            //create span for first time use
            selectedSpan = $("<span></span>");
            relatedDt.append(selectedSpan);
        }
        selectedSpan.text($input.data('label'));

        //Pop waitlist banner if selected product is waitlisted
        /*            if (statusText == 'On Waitlist') {
                    var banner = $('#modal-banner');
                    var bannerH = banner.children('h6');
                    banner.removeClass('none');
                    banner.addClass('waitlist');
                    bannerH.text('WAITLIST');
                }*/

        //if(sel) {
        //    scope.SynchronizeOptionGroupLabels();
        //}

        //Check if modal is in 'edit bag' and change Update button to waitlist.
        /*            var span = $('form>div.button-group>span.add-to-bag-proxy');
                var input = $('form>div.button-group>input.add-to-bag');
                var waitlistInfo = $('.edit-item-waitlist-off');
                if (input.data('update-bag') && statusText == 'On Waitlist') {
                    span.text("join waitlist");
                    waitlistInfo.removeClass('edit-item-waitlist-off');
                    waitlistInfo.addClass('edit-item-waitlist-on');
                    statusDiv.text('');
                }*/
    },

    /**
        * HSN.ExchangeVariantSelector#DeactivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *   ultimately resolve one of the option labels in this product modal.
        *
        * Deactivate label and set description text to currently selected option.
        * Clean all labels, spans and status text
        **/
    DeactivateOptionLabel: function DeactivateOptionLabel(label) {
        var scope = this;

        if (!scope._variants || !label) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label); //input corresponding to label
        $input.prop('checked', false);
        $label.removeClass('checked'); // deactivate label

        //clean status classes from all input labels
        var allInputLabels = $('input[name^="product-modal-option"]', scope._container).parent('label');
        allInputLabels.removeClass('regular').removeClass('waitlisted').removeClass('disabled').removeClass('waitlisted-selected').removeClass('checked-selected').removeClass('disabled-overlay').removeClass('waitlist-disabled-overlay').removeClass('variant-soldout');

        //clean all disabled-overlay spans
        var allSpans = $('span[class*="disabled-overlay"]', scope._container);
        allSpans.removeClass('disabled-overlay');
        allSpans.removeClass('waitlist-disabled-overlay');

        //clear status text
        var statusDiv = $('.product-modal-option-status', scope._container);
        statusDiv.text('');

        //populate input group description to selected or empty if no selected
        var checkedOption = $('input[name="' + $input.attr('name') + '"]:checked', scope._container);
        var checkOptionDataLabel = checkedOption.data('label') || '';
        $label.closest('dd').prev('dt').find('span').text(checkOptionDataLabel);

        //remove waitlist banner
        var banner = $('#modal-banner');
        banner.removeClass('waitlist');
        banner.addClass('none');

        //Check if modal is in 'edit bag' change back to update my bag.
        var span = $('form>div.button-group>span.add-to-bag-proxy');
        var input = $('form>div.button-group>input.add-to-bag');
        var waitlistInfo = $('.edit-item-waitlist-on');
        if (input.data('update-bag')) {
            span.text("update bag");
            waitlistInfo.removeClass('edit-item-waitlist-on');
            waitlistInfo.addClass('edit-item-waitlist-off');
        }
    },

    /**
        * HSN.ExchangeVariantSelector#SynchronizeOptionLabels() -> void
        *
        * Ensures that the selected and disabled states of the progressively enhanced option labels match
        * their associated radio buttons.
        **/
    SynchronizeOptionLabels: function SynchronizeOptionLabels() {
        var scope = this;

        if (scope._variants === null) {
            return;
        }

        var allInputs = $('input[name^="product-modal-option"]', scope.container);

        allInputs.each(function () {
            var $this = $(this);
            var $label = $this.parent('label');

            //if input disabled, add disabled class to label
            $label[$this.prop('disabled') ? 'addClass' : 'removeClass']('disabled');

            if ($this.prop('disabled')) {
                //TODO is input ever disabled?
                var inputCousins = $label.siblings('label').children('input[class*="' + $this.attr('name') + '"]');
                inputCousins.each(function () {
                    var $cousinLabel = $(this);

                    var $labelOverlay = $cousinLabel.find('.disabled-overlay');
                    if (!$labelOverlay.length) {
                        $labelOverlay = $('<div class="disabled-overlay"></div>');
                        $cousinLabel.append($labelOverlay);
                    }
                });
            }
            //if active, add checked class
            $label[$this.prop('checked') ? 'addClass' : 'removeClass']('checked');
        });
    },

    /**
    *HSN.ExchangeVariantSelector.SynchronizeOptionGroupLabels() -> void
    *
    *Adds visual overlays to option groups based on group children
    **/
    SynchronizeOptionGroupLabels: function SynchronizeOptionGroupLabels() {
        var scope = this;

        var variantTypes = $('> dl > dd.variant-group-tab-items', this._container).parent();

        $.each(variantTypes, function () {
            var variantType = this;
            var optionGroups = $('> dd.small-options', this);
            $.each(optionGroups, function () {
                var options = $('> label', this);
                var optionsGroupLabel = $('> dd.variant-group-tab-items a[href$="' + $(this).prop('id') + '"] > label', variantType);
                if (options.length === options.filter('.disabled-overlay').length) {
                    optionsGroupLabel.addClass('disabled-overlay');
                } else {
                    optionsGroupLabel.removeClass('disabled-overlay');
                }
                if (options.length === options.filter('.waitlisted').length) {
                    optionsGroupLabel.addClass('waitlisted');
                } else {
                    optionsGroupLabel.removeClass('waitlisted');
                }
            });
        });
    },

    SelectVariant: function SelectVariant(variantCode, selectOnlyGroup) {
        var scope = this;

        var $sizeVariantInput = $('input[value="' + variantCode + '"]', scope._container);
        var $sizeGroup = $sizeVariantInput.closest('dd');
        var $sizeGroupTab = $('a[href="#' + $sizeGroup.prop('id') + '"] > label', $sizeGroup.parent());

        $sizeGroupTab.click();
        if (!selectOnlyGroup && $sizeVariantInput) {
            $sizeVariantInput.click();
            $sizeVariantInput.change();
        }
    },

    IsPlusSizeGroupSelected: function IsPlusSizeGroupSelected() {
        return this._isPlusSizeVariantSelected;
    },

    GetSelectedVariant: function GetSelectedVariant(variantType) {
        if (!variantType) {
            return false;
        }

        var scope = this;

        return $.grep(scope.__varSelections, function (variantLabel) {
            if (variantLabel) {
                var $input = variantLabel.find('> input');
                return $input.val().substr(0, 1) === variantType;
            }
            return false;
        })[0]; //should only have single result
    },

    GetSelectedSku: function GetSelectedSku() {

        var id = -1;

        var allErrors = [];
        var scope = this;
        var inputLabels = $("label.required-selection", scope._container);
        var arr = [];

        /*            var selectedVariant = this.GetSelectedVariant();
                if(selectedVariant.Callout && selectedVariant.Callout["Name"] == 'Waitlist') {
                    return false;
                }*/

        $.each(inputLabels, function () {
            var inputLabel = $(this);
            var checkedInput = $('input[name="' + $(this).data('selection-name') + '"]:checked', scope._container);
            if (checkedInput.length === 0) {
                var labelText = inputLabel.text().toLowerCase();
                if (labelText.length) {
                    allErrors.push('Please select a ' + labelText);
                    inputLabel.addClass('inline-error');
                }
            } else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                arr.push(checkedInput.val());
            }
        });

        var allErrorsLength = allErrors.length;
        if (allErrorsLength > 0) {
            var $errors = $('<div class="errors-exchange"><div class="add"></div></div>');

            for (var i = 0; i < allErrorsLength; i++) {
                if (allErrors[i] != null) {
                    $errors.find('div.add').append('<div>' + allErrors[i] + '</div>');
                }
            }
            $('div.errors-exchange', scope._container).remove();
            $('.exchange-notice', scope._container).after($errors);
            $(this).focus();
            $('.product-modal-option-status', scope._container).last().text('');
            return false;
        }

        var isWaitlist = false;

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(scope._variants, function (k, v) {
            if ($(arr).not(v.Codes).length == 0 && $(v.Codes).not(arr).length == 0) {
                id = v.Sku;

                if (v.Callout != null && v.Callout["Name"] == "Waitlist") {
                    isWaitlist = true;
                }
                return;
            }
        });

        if (isWaitlist) {
            $('div.errors-exchange', scope._container).remove();
            var $waitlisterror = $('<div class="errors-exchange"><div class="add"><div style="font-size: 90%;">We are unable to complete an exchange for an item on waitlist.</div></div></div>');
            $('.exchange-notice', scope._container).after($waitlisterror);
            return false;
        }

        $('#selectedSku').val(id);

        return true;
    },

    SelectCodesFromVariant: function SelectCodesFromVariant(variant, variantTypes) {
        if (!variant) {
            return;
        }

        var scope = this;

        var codes = $.grep(variant.Codes || [], function (code) {
            var codeType = code.substr(0, 1);
            return !variantTypes || $.inArray(codeType, variantTypes) !== -1;
        });

        $.each(codes, function () {
            var codeType = this.substr(0, 1);
            if (codeType === "S") {
                //Handle Size Variant
                scope.SelectVariant(this, true);
            } else {
                scope.SelectVariant(this, false);
            }
        });
    }
};

/**
    * HSN.ExchangeVariantSelector.EVENT = Object
    *
    * An enumeration of events an [[HSN.Flyout]] can raise:
    * - OPTION_CHANGED: Fires when an option selection changes.
    **/
HSN.ExchangeVariantSelector.EVENT = {
    OPTION_CHANGED: 'HSN.ExchangeVariantSelector:OPTION_CHANGED'
};

/***/ }),

/***/ "HFir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

HSN.TodaysSpecialCountdown = new function () {
    var displays = new Array();
    var remainingHours, remainingMinutes, remainingSeconds;
    var lastTickTime;
    var timer;

    this.Register = function (element, time, endTime) {
        displays.push($(element));
        var now = new Date(time);
        var end = new Date(endTime);
        var hours = parseInt((end - now) / (3600 * 1000));
        start(hours, end.getMinutes() - now.getMinutes(), end.getSeconds() - now.getSeconds());
    };

    this.Tick = function () {
        var currentTime = new Date();
        updateRemainingTime((currentTime - lastTickTime) / 1000);
        lastTickTime = currentTime;
        displayTime();
    };

    function start(hours, minutes, seconds) {
        if (!timer) {
            remainingHours = hours;
            remainingMinutes = minutes;
            remainingSeconds = seconds;
            lastTickTime = new Date();
            timer = setInterval("HSN.TodaysSpecialCountdown.Tick()", 1000);
        }
        displayTime();
    };

    function displayTime() {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(pad(remainingHours) + ":" + pad(remainingMinutes) + ":" + pad(Math.floor(remainingSeconds)));
        }
    }

    function pad(number) {
        return number >= 10 ? number.toString() : "0" + number;
    }

    function updateRemainingTime(seconds) {
        remainingSeconds = remainingSeconds - seconds;
        if (remainingSeconds <= 0 && remainingMinutes <= 0 && remainingHours <= 0) {
            remainingSeconds = remainingMinutes = remainingHours = 0;
            clearInterval(timer);
            return;
        }
        if (remainingSeconds < 0) {
            remainingMinutes += Math.floor(remainingSeconds / 60);
            remainingSeconds = Math.floor(60 + remainingSeconds / 60);
        }
        if (remainingMinutes < 0) {
            remainingHours += Math.floor(remainingMinutes / 60);
            remainingMinutes = Math.floor(60 + remainingMinutes / 60);
        }
    }
}();

HSN.TodaysSpecialStatus = new function () {
    var displays = new Array();
    var script = null;
    var timer;
    var value = 0;
    var timeOffset;
    var prefix, suffix;
    var nonTimer = false;
    var productId;
    var scope = this;

    this.AppendScript = function () {
        var url = "/services/tsinventory";
        $.getJSON(url, function (data) {
            var productInventory = $.grep(data, function (inv) {
                return inv.ProductId === scope.productId;
            })[0];
            scope.Callback(productInventory);
        });
    };

    this.Start = function () {
        if (!script) {
            this.AppendScript();
            timer = setInterval("HSN.TodaysSpecialStatus.Tick()", 15000);
        } else {
            HSN.TodaysSpecialStatus.Tick();
        }
    };

    this.Register = function (element, startTime, nonTimr, productId) {
        displays.push($(element));
        timeOffset = new Date() - new Date(startTime);
        this.Start();
        nonTimer = nonTimr;
        this.productId = productId;
    };

    this.StopUpdates = function () {
        if (script != null) script.remove();

        clearInterval(timer);
    };

    this.Tick = function () {
        if (script != null) script.remove();

        this.AppendScript();
    };

    this.Callback = function (json) {
        if (!json) {
            return;
        }

        this.UpdateText(json);
        value = json.Value;
    };

    this.UpdateText = function (json) {
        if (!json) {
            return;
        }
        switch (json.DisplayCode) {
            case "Sold":
                prefix = " | ";
                suffix = " Sold";
                break;
            case "Remaining":
                prefix = " | Only ";
                suffix = " Remaining";
                break;
            case "LandmarkSold":
                prefix = " | Over ";
                suffix = " Sold";
                break;
            case "LandmarkRemaining":
                prefix = " | Less than ";
                suffix = " Remaining";
                break;
        }

        this.FeatherText(json.Value);
    };

    this.WriteToPage = function (text) {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(text);
        }
    };

    this.AddCommas = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };

    this.FeatherText = function (endValue) {
        if (endValue == -1) {
            HSN.TodaysSpecialStatus.WriteToPage('');
        } else if (value == 0) {
            HSN.TodaysSpecialStatus.WriteToPage(prefix + "<span class=\"ts_status\">" + this.AddCommas(endValue) + "</span>" + suffix);
        } else {
            var val = parseInt(value);
            var divided = Math.round((endValue - value) / 5);
            HSN.TodaysSpecialStatus.WriteToPage(prefix + "<span class=\"ts_status\">" + this.AddCommas(val + divided) + "</span>" + suffix);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas(val + divided * 2) + "</span>" + suffix + "')", 1000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas(val + divided * 3) + "</span>" + suffix + "')", 2000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas(val + divided * 4) + "</span>" + suffix + "')", 3000);
            setTimeout("HSN.TodaysSpecialStatus.WriteToPage('" + prefix + "<span class=\"ts_status\">" + this.AddCommas(val + divided * 5) + "</span>" + suffix + "')", 4000);
        }
    };
}();

HSN.TodaysSpecialStatusV2 = new function () {
    var displays = new Array();
    var script = null;
    var timer;
    var value = 0;
    var timeOffset;
    var prefix, suffix;
    var nonTimer = false;
    var scope = this;
    var productId;

    this.AppendScript = function () {
        var url = "/services/tsinventory";
        $.getJSON(url, function (data) {
            var productInventory = $.grep(data, function (inv) {
                return inv.ProductId === scope.productId;
            })[0];
            scope.Callback(productInventory);
        });
    };

    this.Start = function () {
        if (!script) {
            this.AppendScript();
            timer = setInterval("HSN.TodaysSpecialStatusV2.Tick()", 15000);
        } else {
            HSN.TodaysSpecialStatusV2.Tick();
        }
    };

    this.Register = function (element, startTime, nonTimr, productId) {
        displays.push($(element));
        timeOffset = new Date() - new Date(startTime);
        this.Start();
        nonTimer = nonTimr;
        scope.productId = productId;
    };

    this.StopUpdates = function () {
        if (script != null) script.remove();

        clearInterval(timer);
    };

    this.Tick = function () {
        if (script != null) script.remove();

        this.AppendScript();
    };

    this.Callback = function (json) {
        if (!json) {
            return;
        }

        this.UpdateText(json);
        value = json.Value;
    };

    this.UpdateText = function (json) {
        if (!json) {
            return;
        }

        switch (json.DisplayCode) {
            case "Sold":
                prefix = "";
                suffix = " Sold";
                break;
            case "Remaining":
                prefix = "Only ";
                suffix = " Left";
                break;
            case "LandmarkSold":
                prefix = "Over ";
                suffix = " Sold";
                break;
        }

        this.FeatherText(json.Value);
    };

    this.WriteToPage = function (text) {
        var displaysLength = displays.length;
        for (var i = 0; i < displaysLength; i++) {
            var d = $(displays[i]);
            d.html(text);
        }
    };

    this.AddCommas = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    };

    this.FeatherText = function (endValue) {
        if (endValue == -1) {
            HSN.TodaysSpecialStatusV2.WriteToPage('LIMITED TIME OFFER');
        } else if (value == 0) {
            HSN.TodaysSpecialStatusV2.WriteToPage(prefix + "<span style=\"font-weight: bold;\">" + this.AddCommas(endValue) + "</span>" + suffix);
        } else {
            var val = parseInt(value);
            var divided = Math.round((endValue - value) / 5);
            HSN.TodaysSpecialStatusV2.WriteToPage(prefix + this.AddCommas(val + divided) + suffix);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas(val + divided * 2) + suffix + "')", 1000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas(val + divided * 3) + suffix + "')", 2000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas(val + divided * 4) + suffix + "')", 3000);
            setTimeout("HSN.TodaysSpecialStatusV2.WriteToPage('" + prefix + this.AddCommas(val + divided * 5) + suffix + "')", 4000);
        }
    };
}();

/***/ }),

/***/ "HWMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.NicknameModal
*
* Encapsulates the functionality of a modal dialog for creating/updating user nickname
**/
HSN.NicknameModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(NicknameModal, parent);

    /**
    * new HSN.NicknameModal()
    **/
    function NicknameModal() {
        this.name = 'HSN.NicknameModal';

        return NicknameModal.__super__.constructor.call(this, "nickname");
    }

    /**
    * HSN.NicknameModal#Show() -> void
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    NicknameModal.prototype._show = function () {
        var scope = this;

        $.ajax({
            type: 'GET',
            url: "/nickname?" + "refurl=" + document.URL + "&" + new Date().getTime(),
            dataType: 'html',
            success: function success(data) {
                scope.Root.removeClass('loading');

                scope.DisplayModal(data, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for modal form, use ajax to retrieve response, and update modal content
    **/
    NicknameModal.prototype.SubmitForm = function () {
        var scope = this;

        var form = $('form', scope.Content);

        //manually run client validation since we arent running submit operation
        if (!form.valid()) return;

        $.ajax({
            type: 'POST',
            url: '/nickname?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: form.serialize()
        }).done(function (data) {
            scope.DisplayModal(data, 0);
        }).fail(function () {
            alert('error submitting review');
        });
    };

    NicknameModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            //needed for unobtrusive client side validation for ajax loaded form
            $.validator.unobtrusive.parse($('form', scope.Content));
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {
            //scope.Center();
        });
    };

    return NicknameModal;
}(HSN.Modal);

/***/ }),

/***/ "IEBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentManagement_js__ = __webpack_require__("O/yi");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// define EVENTs


/**
    * class HSN.Widget.FlexPayOrder
    *
    * Encapsulates the common functionality of the FlexPayOrder Widget.
    **/
HSN.Widget.FlexPayOrder = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var flexPaymentNumber;
    var flexPaymentMonth;
    /**
        * new HSN.Widget.FlexPayOrder.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayOrder]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        flexPaymentNumber = config.flexPaymentNumber;
        flexPaymentMonth = config.flexPaymentMonth;

        SetMyEventHandlers();

        bindEvents();
    }

    function bindEvents() {
        container.on('click', '.pay-now', function () {
            var paymentNumbers = [];

            $('.payment-check .pay-now-check:checked', container).each(function () {
                paymentNumbers.push($(this).closest('.payment-line').data('payment-number'));
            });

            if (deviceInformation.IsMobile) {
                var flexPayNumbers = paymentNumbers;
                var data = { flexPayNumbers: flexPayNumbers };
                var paramNumbers = $.param(data, true);
                window.location.href = '/myaccount/flexpay-manager/pay-now/' + orderIdentity + '?' + paramNumbers;
            } else {
                application.GetFlexPayManagerPayNowModal().Show({
                    orderIdentity: orderIdentity,
                    data: {
                        flexPayNumbers: paymentNumbers
                    }
                });
            }

            paymentNumbers = [];
        });
        container.on('click', '.change-card', function () {
            if (deviceInformation.IsMobile) {
                window.location.href = '/myaccount/flexpay-manager/payment/' + orderIdentity + '/' + flexPaymentNumber + '/' + flexPaymentMonth;
            } else {
                ToggleContainer(1);
            }
            return false;
        });
        container.on('click', '.payment-check .pay-now-check', function () {
            application.Events.Trigger(HSN.Widget.FlexPayOrder.EVENT.CLEAR_PAY_NOW, orderIdentity);
            var wasChecked = this.checked;
            UncheckAll('.payment-check .pay-now-check');
            CheckUpUntil('.payment-check .pay-now-check', this);
            if (!wasChecked) {
                $(this).val(wasChecked);
                this.checked = wasChecked;
            }
            TogglePayNow('.payment-check .pay-now-check');
        });
        container.on('keypress', 'label.payment-totals', function (e) {
            var keycode = e.keyCode ? e.keyCode : e.which;
            if (keycode != 32) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $('#' + $(this).attr('for')).click();
        });
        container.on('click', '.show-details-link', function () {
            if (deviceInformation.IsMobile) {
                ToggleContainer(1);
            }
            return false;
        });
        container.on('click', '.cancel-show-details-link', function () {
            if (deviceInformation.IsMobile) {
                ToggleContainer(1);
            }
            return false;
        });
    }

    function CheckUpUntil(selector, thisInput) {
        $(selector, container).each(function () {
            this.checked = true;
            $(this).val(true);
            if (this === thisInput) {
                return false;
            }
            return true;
        });
    }

    function UncheckAll(selector) {
        $(selector, container).each(function () {
            this.checked = false;
            $(this).val(false);
        });
    }

    function TogglePayNow(selector) {
        var total = parseFloat(0);
        var checkedSelector = selector + ':checked';
        if ($(checkedSelector, container).length > 0) {
            $(checkedSelector, container).each(function () {
                total += parseFloat($(this).closest('.payment-line').data('total-due'));
            });
            $('.payment-total', container).text(HSN.FormatCurrency(total, 2));
            $('.payment-action', container).toggle(true);
        } else {
            $('.payment-action', container).toggle(false);
            $('.payment-total', container).text(total);
        }
    }

    function HandlePaymentSelected(paymentIdentity, eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            return;
        }
        HSN.SetWait();
        ChangePayment(paymentIdentity);
    }
    function HandlePaymentAdded(data) {
        if (!data.isAdd) {
            return;
        }
        HSN.SetWait();
        ChangePayment(data.paymentIdentity);
    }
    function ChangePayment(paymentIdentity) {
        var requestData = {
            orderIdentity: orderIdentity,
            flexPaymentNumber: flexPaymentNumber,
            paymentIdentity: paymentIdentity
        };
        accountService.FlexPayChangePayment(requestData, {
            callback: function callback(data) {
                if (data.success) {
                    Refresh();
                } else {
                    HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to update your payment information, please try again.');
                }
            },
            errorCallback: function errorCallback() {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to update your payment information, please try again.');
            },
            scope: this
        });
    }
    function HandleRefresh(eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            return;
        }
        Refresh();
    }
    function HandleClearPayNow(eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            UncheckAll('.payment-check .pay-now-check');
            $('.payment-action', container).toggle(false);
            $('.payment-total', container).text(0);
        }
    }

    function ClearChildEventHandlers() {}
    function ClearMyEventHandlers() {
        application.Events.Off(HSN.Widget.PaymentManagement.EVENT.SELECTED, null, orderIdentity);
        application.Events.Off(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, null, orderIdentity);
    }
    function SetMyEventHandlers() {
        application.Events.On(HSN.Widget.PaymentManagement.EVENT.SELECTED, HandlePaymentSelected, orderIdentity);
        application.Events.On(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, HandlePaymentAdded, orderIdentity);
        application.Events.On(HSN.Widget.FlexPayOrder.EVENT.REFRESH, HandleRefresh, orderIdentity);
        application.Events.On(HSN.Widget.FlexPayOrder.EVENT.CLEAR_PAY_NOW, HandleClearPayNow, orderIdentity);
    }
    function ToggleContainer(index) {
        var identifier = orderIdentity + '-' + index;
        var toggleContainer = $("[toggleindex='" + identifier + "']", container);
        var isAjax = toggleContainer.hasClass('ajax');
        var ajaxUrl = toggleContainer.data('url');
        var targetContainer = $('.container-wrap', toggleContainer);
        var scrollOffset = 0;

        if (deviceInformation.IsMobile) {
            if (toggleContainer.is(':visible')) {
                scrollOffset = $('.toggleWrap', container).outerHeight();
            }
            scrollOffset = scrollOffset + HSN.GetMobileHeaderOffset() + 7; //wiggle room
        } else {
            scrollOffset = scrollOffset + HSN.GetDesktopStickyHeaderOffset();
        }

        HSN.AnimateAccordion('toggleContainer', identifier, false, true, {
            scrollOffset: scrollOffset,
            fadeOutCallback: function fadeOutCallback() {
                if (isAjax) {
                    targetContainer.html('');
                }
            },
            beforeFadeIn: function beforeFadeIn() {
                if (isAjax) {
                    LoadAjaxContainer(ajaxUrl, toggleContainer, targetContainer, scrollOffset);
                }
            }
        });
    }
    function LoadAjaxContainer(ajaxUrl, toggleContainer, targetContainer, scrollOffset) {
        ClearMyEventHandlers();
        HSN.SetContainerWait($('.container-wrap', toggleContainer));
        var topOffset = toggleContainer.parent().offset().top;
        $.ajax(ajaxUrl, {
            type: 'GET',
            data: { '_ts': new Date().getTime() },
            context: this,
            dataType: 'html',
            success: function success(responseData) {
                HSN.RemoveContainerWait();
                targetContainer.html(responseData);
                SetMyEventHandlers();
                $('html,body').animate({ scrollTop: topOffset - scrollOffset }, 'slow');
                $('.change-payment-description').focus();
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                HSN.RemoveContainerWait();
            }
        });
    }
    function CloseAllDrawers() {
        $('.toggleContainer', container).each(function () {
            if ($(this).is(':visible')) {
                ToggleContainer($(this).attr('toggleindex').split('-')[1]);
            }
        });
    }
    function Refresh() {
        HSN.SetWait();
        CloseAllDrawers();
        if (deviceInformation.IsMobile) {
            if (window.location.pathname === '/myaccount/flexpay-manager') {
                window.location.reload();
            } else {
                window.location.href = '/myaccount/flexpay-manager#flexpay-container-' + orderIdentity;
            }
        } else {
            container.parent().append('<div class="refresh-mask"></div>');
            HSN.SetContainerWait($('.refresh-mask', container.parent()), false);
            var contentWrap = container.parent();
            accountService.FlexPayGetOrder(orderIdentity, {
                callback: function callback(data) {
                    Destroy();
                    contentWrap.html(data);
                    $('html,body').animate({
                        scrollTop: contentWrap.offset().top
                    }, 500);
                    $('.refresh-mask', container.parent()).remove();
                },
                errorCallback: function errorCallback() {
                    $('.refresh-mask', container.parent()).remove();
                },
                scope: this
            });
            HSN.RemoveWait();
        }
    }
    function Destroy() {
        ClearMyEventHandlers();
        ClearChildEventHandlers();
    }
    return {
        init: init,
        Refresh: Refresh,
        Destroy: Destroy
    };
};

HSN.Widget.FlexPayOrder.EVENT = {
    CANCELLED: 'HSN.Widget.FlexPayOrder:CANCELLED',
    REFRESH: 'HSN.Widget.FlexPayOrder:REFRESH',
    CLEAR_PAY_NOW: 'HSN.Widget.FlexPayOrder:CLEAR_PAY_NOW'
};

/***/ }),

/***/ "IEwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.BrandsEditModal
*
* Encapsulates the functionality of a modal dialog that contains email friend form
**/
HSN.BrandsEditModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(brandsEditModal, parent);

    /**
    * new HSN.brandsEditModal()
    **/
    function brandsEditModal() {
        this.name = 'HSN.BrandsEditModal';
        var modal = brandsEditModal.__super__.constructor.call(this);
        this.Close.off();
        eventHandlers(this);
        return modal;
    }
    brandsEditModal.prototype._hide = function () {};

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            closeModal(e, modal);
        });
    }

    function closeModal(e, modal) {
        modal.Hide();
        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_CLOSE);
    }

    /**
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    brandsEditModal.prototype._show = function (url, webPId, title, photoUrl, imageDescription, productUrl) {

        var scope = this;
        brandsEditModal.url = url;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: { 'WebPId': webPId, 'Title': title, 'PhotoUrl': photoUrl, 'ImageDescription': imageDescription, 'ProductUrl': productUrl },
            success: function success(htmlData) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(htmlData, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for recommend a friend, use ajax to retrieve response, and update modal content
    **/
    brandsEditModal.prototype.SubmitEmailFriendForm = function (saveData) {

        var scope = this;
        var brandsEditForm = $('form', scope.Root);
        var formData = brandsEditForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/myaccount/communicationpreferences/brandsedit/brands-edit-post',
            dataType: 'json',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        }).done(function (data) {
            if (data.success) {
                $('div.errors').remove();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#BrandsEditModal").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#BrandsEditModalSucess").show();
            } else {
                HSN.AddErrorTreatment('#brandsEditForm', data);
            }
        }).fail(function () {
            alert('error submitting the request');
        });
    };

    brandsEditModal.prototype.DisplayModal = function (data, time) {
        var scope = this;
        this.Content.showHtml(data, time, function () {
            var deviceInfo = HSN.Instance().DeviceInformation;
            scope.Center(-300, -300);

            if (deviceInfo.IsMobile && !deviceInfo.IsTablet) {
                scope.Center(0, 0);
            }

            scope.Content.animate({ opacity: 1 }, function () {
                var elemetToFocus = scope.Content.find('.brands-edit-modal');
                scope.SetFocus(elemetToFocus);
            });
        });
    };
    return brandsEditModal;
}(HSN.Modal);

/***/ }),

/***/ "IPPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// ReSharper disable InconsistentNaming
function _mapSort(sort) {
    // ReSharper restore InconsistentNaming
    var rt;
    switch (sort) {
        case "hsn picks":
            rt = "default_sort";
            break;
        case "price-low-to-high":
            rt = "price(a)";
            break;
        case "price-high-to-low":
            rt = "price(d)";
            break;
        case "customer-rating":
            rt = "rating_sort";
            break;
        case "newest":
            rt = "new_arrivals";
            break;
        case "bestselling":
            rt = "best_sellers";
            break;
        default:
            rt = "default_sort";
            break;
    }
    return rt;
}

// ReSharper disable InconsistentNaming
function _getSpecialProductId(specialProductType) {
    // ReSharper restore InconsistentNaming
    var result;
    $.ajax('/special-product-id/' + specialProductType, {
        context: this,
        dataType: 'json',
        async: false,
        success: function success(data, status, xhr) {
            result = data;
        }
    });
    return result;
}

// ReSharper disable InconsistentNaming
function _sendPostMessage(message) {
    // ReSharper restore InconsistentNaming
    if (typeof window.external !== "undefined" && typeof window.external.notify !== "undefined") {
        window.external.notify(message + "::" + window.name);
    }
}

var Gap = function () {
    function Gap() {
        _classCallCheck(this, Gap);

        this.gapBusy = false;
        this.alertResponse = false;
        this.timer = null;
    }

    Gap.prototype.WaitForGap = function WaitForGap(callback) {
        var scope = this;
        if (this.gapBusy) this.timer = setTimeout(function () {
            scope.WaitForGap(callback);
        }, 500);else {
            if (this.alertResponse === true) {
                callback();
            }
        }
    };

    Gap.prototype.WaitForGapConfirm = function WaitForGapConfirm(callback, cancelCallback) {
        var scope = this;
        if (this.gapBusy) this.timer = setTimeout(function () {
            scope.WaitForGap(callback);
        }, 500);else {
            if (this.alertResponse === true) {
                callback();
            } else {
                cancelCallback();
            }
        }
    };

    Gap.prototype.ExecCommand = function ExecCommand(command) {
        if (HSN.Instance().DeviceInformation.IsWin8Metro === false) {
            document.location = command;
        } else {
            _sendPostMessage(command);
        }
        return false;
    };

    Gap.prototype.ConvertLink = function ConvertLink(href) {
        var host = document.location.host;
        return 'https://' + host + href;
    };

    Gap.prototype.FullyQualifyRelativeLink = function FullyQualifyRelativeLink(url) {
        var host = document.location.host;
        var protocol = document.location.protocol;

        var urlRegex = new RegExp('^https?:\/\/', 'i');

        if (urlRegex.test(url)) {
            return url;
        } else {
            return protocol + '//' + host + url;
        }
    };

    Gap.prototype.BuildGapCommand = function BuildGapCommand(href) {
        var encodedHref = encodeURIComponent(href);

        if (href === '/' || href === this.FullyQualifyRelativeLink('/')) {
            return 'hsn://HSNWebView.PopToRoot/';
        }

        var searchRegex = new RegExp('^.*(/search/)(.*)/(.*)$', 'i');
        var matches = searchRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Search/' + matches[3] + '/default_sort/none';
        }
        var specialProductRegex = new RegExp('^.*/(todays-special|on-air-now|hourly-deal|product-by-style)(.*)$', 'i');
        matches = specialProductRegex.exec(href);
        if (matches !== null) {
            //return 'hsn://HSNWebView.SpecialProduct/' + encodeURIComponent(matches[1] + matches[2]);
            var productInfo = _getSpecialProductId(matches[1] + matches[2]);
            if (productInfo && productInfo.WebPId !== 0) {
                return 'hsn://HSNWebView.Product/' + productInfo.Slug + '/' + productInfo.WebPId;
            } else {
                return 'hsn://HSNWebView.Product/';
            }
        }
        var newProductRegex = new RegExp('^.*(/products/)(.*)/(.*)$', 'i');
        matches = newProductRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Product/' + matches[2] + '/' + matches[3];
        }
        var ensembleRegex = new RegExp('^.*(/ensemble/)(.*)/(.*)$', 'i');
        matches = ensembleRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.Ensemble/' + matches[2] + '/' + matches[3];
        }
        var shopRegex = new RegExp('(.+?)(/shop/)(.+)/([a-z0-9|_-]+)', 'i');
        matches = shopRegex.exec(href);
        if (matches !== null) {
            var sort = _mapSort(HSN.Instance().GetQueryStringParam(href, 'sort'));
            return 'hsn://HSNWebView.Search/' + matches[4] + '/' + sort + '/none';
        }
        var videoRegex = new RegExp('^.*(.mp4|.m4v)(.*)$', 'i');
        matches = videoRegex.exec(encodedHref);
        if (matches !== null) {
            return 'hsn://HSNWebView.PDVideo/' + matches[0] + "/" + matches[0];
        }
        var manualGapRegex = new RegExp('^.*(/app-link/)(.*)#(.*)$', 'i');
        matches = manualGapRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.' + matches[2] + '/' + encodeURIComponent(matches[3]);
        }
        var contentPageRegex = new RegExp('/content/.*/(\\d+\\??.*)', 'i');
        matches = contentPageRegex.exec(href);
        if (matches !== null) {
            return 'hsn://HSNWebView.ContentPage/' + matches[1];
        }
        matches = href && href.indexOf('tel:') !== -1;
        if (matches) {
            return href;
        }
        var imagePageRegex = new RegExp('^//.*/is/image/', 'i');
        matches = imagePageRegex.exec(href);
        if (matches !== null) {
            if (HSN.Instance().DeviceInformation.IsIphone) {
                return 'hsn://HSNWebView.Image//' + window.location.protocol + encodedHref;
            } else {
                return 'hsn://HSNWebView.Goto//' + window.location.protocol + encodedHref;
            }
        }

        return 'hsn://HSNWebView.Goto//' + encodedHref;
    };

    Gap.prototype.PlayYouTubeVideo = function PlayYouTubeVideo(youtubeVideoId) {
        var command = 'hsn://HSNWebView.YouTubeVideo/' + youtubeVideoId;
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.PlayYouTubeVideoFromWebView = function PlayYouTubeVideoFromWebView(category, name, videoId) {
        var url = this.FullyQualifyRelativeLink('/youtube/' + category + '/' + name + '/' + videoId);
        var cmd = this.BuildGapCommand(url);
        this.ExecCommand(cmd);
        return;
    };

    Gap.prototype.CheckYouTubeSupport = function CheckYouTubeSupport() {
        var command = 'hsn://HSNWebView.CheckYouTubeVideoSupport/';
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.AddRemoveFavoriteProduct = function AddRemoveFavoriteProduct(pId, webId) {
        var command = 'hsn://HSNWebView.AddRemoveFavoriteProduct/' + pId + '/' + webId;
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.AddRemoveFavoriteBrand = function AddRemoveFavoriteBrand(brandId) {
        var command = 'hsn://HSNWebView.AddRemoveFavoriteBrand/' + brandId;
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.GoBack = function GoBack() {
        var command = 'hsn://HSNWebView.GoBack';
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.Share = function Share(category, name, url) {
        var command = 'hsn://HSNWebView.Share/' + category + '/' + name + '/' + encodeURIComponent(url);
        this.ExecCommand(command);
        return;
    };

    Gap.prototype.GoToExternalBrowser = function GoToExternalBrowser(url) {
        var command = 'hsn://HSNWebView.GotoExtBrowser/' + encodeURIComponent(url);
        this.ExecCommand(command);
        return;
    };

    return Gap;
}();

;

var gap = new Gap();

/* harmony default export */ __webpack_exports__["default"] = (gap);

/***/ }),

/***/ "IQJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.EmailSurveyModal
*
* Encapsulates the functionality of a modal dialog that contains thank you for signing up information.
**/
HSN.EmailSurveyModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(EmailSurveyModal, parent);

    /**
    * new HSN.EmailSurveyModal()
    **/
    function EmailSurveyModal() {
        this.name = 'HSN.EmailSurveyModal';

        var modal = EmailSurveyModal.__super__.constructor.call(this);

        eventHandlers(this);

        return modal;
    }

    /**
    * HSN.EmailSurveyModal#Show(email) -> void
    * Display the modal and load in the information
    **/
    EmailSurveyModal.prototype._show = function (url) {
        var scope = this;
        $.ajax(url, {
            dataType: 'html',
            success: function success(data) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(data, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#confirm-cancel', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(modal.Close).click();
        });
    }

    EmailSurveyModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {
            //scope.Center();
        });
    };

    return EmailSurveyModal;
}(HSN.Modal);

/***/ }),

/***/ "Ijvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_clamp_js__ = __webpack_require__("qBtQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_clamp_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_clamp_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_slimscroll_js__ = __webpack_require__("R3LS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_slimscroll_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_slimscroll_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_equalHeights_js__ = __webpack_require__("jBmH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_equalHeights_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_equalHeights_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_placeholder_js__ = __webpack_require__("4plx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_placeholder_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_placeholder_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_LIBS_jquery_onviewed_js__ = __webpack_require__("DY1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_LIBS_jquery_onviewed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_LIBS_jquery_onviewed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_LIBS_browser_deeplink_js__ = __webpack_require__("ouuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_LIBS_browser_deeplink_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_LIBS_browser_deeplink_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_unobtrusive_ajax_js__ = __webpack_require__("mqIx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_unobtrusive_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_unobtrusive_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HSN_Modal_js__ = __webpack_require__("dKm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HSN_OffCanvas_js__ = __webpack_require__("j8Sc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_HSNDIR_BuySelector_js__ = __webpack_require__("NfpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_HSNDIR_AccountNavigation_js__ = __webpack_require__("opxl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HSN_CoremetricsPatch_js__ = __webpack_require__("dHq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_HSN__ = __webpack_require__("P8Vt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HSN_Application_js__ = __webpack_require__("Pd1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HSN_EmailSignUp_js__ = __webpack_require__("TKPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HSN_Flyout_js__ = __webpack_require__("a4iX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__HSN_FlyoutManager_js__ = __webpack_require__("FfXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__HSN_HamburgerFlyout_js__ = __webpack_require__("jQJV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HSN_BagFlyout_js__ = __webpack_require__("gsQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__HSN_AccountNavigation_AccountMenu_js__ = __webpack_require__("i/Ml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__HSN_AccountNavigation_Cabinet_js__ = __webpack_require__("iWJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HSN_AccountNavigation_Cabinet_Drawer_js__ = __webpack_require__("azVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HSN_ResponsiveCells_js__ = __webpack_require__("4LBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HSN_DataLayer_js__ = __webpack_require__("qcZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__HSN_TodaysSpecial_js__ = __webpack_require__("HFir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_HSNDIR_Widget_VideoPlayers_YoutubePlayer_js__ = __webpack_require__("0mmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_HSNDIR_BuyAgain_js__ = __webpack_require__("B7Qy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_HSNDIR_DynamicCarouselHelper_js__ = __webpack_require__("Vk0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__HSN_NicknameModal_js__ = __webpack_require__("HWMV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__HSN_VideoModal_js__ = __webpack_require__("kxPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__HSN_Widget_FancyInput_js__ = __webpack_require__("cHJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_HSNDIR_Widget_WriteReview_js__ = __webpack_require__("dKps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__HSN_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;









// Global


























// Passed to HSN.Application






/*
The purpose of the Initializer is to create a new instance of the HSN.Application
and give it to the HSN singleton interface.
    
By separating the Application from the initialization it allows us to provide it
the dependencies it needs without having to be aware of the HTML layer providing
us far more flexibility to change the markup in the future.
*/

var noAjax = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input#header-noajax').length > 0 ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input#header-noajax').val() : false;
var flyouts = typeof HsnArcadeObjectName != 'undefined' && HsnArcadeObjectName.length > 0 ? [] : BuildFlyouts();

window.HSN.Instance(new HSN.Application('body', '.device-information', new HSN.FlyoutManager({
    flyouts: flyouts
}), new HSN.AccountNavigation({
    cabinet: new HSN.AccountNavigation.Cabinet({
        id: 'cabinet',
        drawers: []
    }),
    container: '#utility-nav',
    drawerParent: '#utility-nav-parent',
    welcome: '#utility-nav-welcome',
    signin: '#utility-nav-signin',
    signout: '#utility-nav-signout',
    account: '#utility-nav-account',
    alert: "#utility-nav-alerts",
    alertCount: "#account-alert-count",
    noajax: noAjax,
    noUpdateState: false
}), {
    NicknameModal: HSN.NicknameModal,
    VideoModal: HSN.VideoModal
}));

new HSN.AccountNavigation({
    cabinet: new HSN.AccountNavigation.Cabinet({
        id: 'cabinet',
        drawers: [new HSN.AccountNavigation.Cabinet.Drawer({
            identifier: 'lessman-favorites',
            trigger: '#lessman-favorites-drawer-trigger',
            url: '/account/favorites',
            noajax: noAjax,
            callback: function callback() {
                SetFavoriteDrawer();
            },
            closeCallback: function closeCallback() {
                CloseFavoriteDrawer();
            }
        })]
    }),
    container: '#utility-nav',
    drawerParent: '#primary-navigation-minified',
    welcome: '#utility-nav-welcome',
    signin: '#utility-nav-signin',
    signout: '#utility-nav-signout',
    account: '#utility-nav-account',
    alert: "#utility-nav-alerts",
    alertCount: "#account-alert-count",
    noajax: noAjax,
    noUpdateState: true
});

HSN.Instance()._getFavoriteService().CheckForFavorites('.favorite-link:not(.favorite-queried)');
HSN.Instance().Events.On(HSN.Application.EVENT.VISITOR_AUTHENTICATED, function () {
    if (Modernizr.sessionstorage) {
        sessionStorage.removeItem("hasCheckedFavorites");
    }
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
    var cells = new HSN.ResponsiveCells();
    HSN.OnHomePage();

    //check if users can use cookies- throw a banner article if cookies are disabled.
    if (typeof HsnDrdPageCache !== "undefined") {
        var cookieName = "cookieEnabled";
        HsnDrdPageCache.setCookie(cookieName, "enabled", HsnDrdPageCache.getLowerDomain(), null);
        if (!HsnDrdPageCache.getCookie(cookieName)) {
            HSN.Instance().GetArticleContent({ element: HSN.Instance().Canvas.find('#promo'), appendElement: true }).Show('/article/' + "cookieWarning" + '/' + 100);
        } else {
            HsnDrdPageCache.removeCookie(cookieName);
        }
        //Commision Junction - look for cm_mmc parameter and set cookie for 14 days
        var trackCode = HSN.Instance().GetQueryStringParam(window.location.href, 'cm_mmc');
        if (trackCode != null && trackCode.toUpperCase().indexOf('CJ') === 0) {
            HsnDrdPageCache.setCookie('Commision', 'CJ', HsnDrdPageCache.getLowerDomain(), 14);
        } else if (trackCode !== '') {
            HsnDrdPageCache.setCookie('Commision', 'OTHER', HsnDrdPageCache.getLowerDomain(), 14);
        }
    }

    HSN.OnAccountStatusLoad(function (data) {
        if (data.displayGlobalPrivacyControlBanner) {
            HSN.Instance().AccountNavigation.Cabinet.Open(new HSN.AccountNavigation.Cabinet.Drawer({ identifier: 'global-privacy-banner', url: '/global-privacy-banner' }));

            setTimeout(function () {
                HSN.Instance().AccountNavigation.Cabinet.Close();
            }, 20000);
        }
    });
});

//Handler for article modals
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', ".article-modal", function (e) {
    articleModalHandler(this, e);
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('keydown', ".article-modal", function (e) {
    var keys = __WEBPACK_IMPORTED_MODULE_27_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
    if (e.keyCode === keys.enter) {
        articleModalHandler(this, e);
    }
});

function articleModalHandler(scope, e) {
    e.stopPropagation();
    e.preventDefault();

    var articleSlug = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(scope).data("articleSlug");
    var articleId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(scope).data("articleId");
    if (isNaN(articleId)) return; //continue
    if (!articleSlug) articleId = 'default-article-slug';

    var articleModal = HSN.Instance().GetArticleModal();
    articleModal.SetElementToFocusOnClose(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(scope));
    articleModal.Show('/article/' + articleSlug + '/' + articleId);

    HSN.DataLayer.helpers.personalizationEvent($(scope).data("datalayerUdo"));
}

//Handler for content modals
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', ".content-modal", function (e) {
    e.stopPropagation();
    e.preventDefault();

    var contentId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("contentId");
    if (isNaN(contentId)) return true; //continue

    var contentModal = HSN.Instance().GetContentModal();
    contentModal.SetElementToFocusOnClose(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    contentModal.Show('/content/content/' + contentId);
    return true;
});

// Handler for HSN Cares Drive modals
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', ".hsncaresdrivedisclaimer-modal, .rules-link", function (e) {
    e.stopPropagation();
    e.preventDefault();

    cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-OfficialRules-_-NA&cm_re=ArcadeSweeps-_-OfficialRules-_-NA', 'ArcadeSweepsRules');

    var disclaimer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("disclaimer");
    if (!disclaimer.trim()) return true;

    HSN.Instance().GetHsnCaresDisclaimerModal().Show(disclaimer);
    return true;
});

//Handler for video modals
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click keydown', ".video-modal", function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
    }

    e.stopPropagation();
    e.preventDefault();
    var httpUrl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-http-url");
    var analyticCategory = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-analytic-cat") || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-category');
    var analyticName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-analytic-name") || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-name');
    var label = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-label");
    var width = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-vwidth");
    var height = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-vheight");
    var customCaptions = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-custom-captions");
    var hideBranding = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-hide-branding") ? true : false;

    var vidModal = HSN.Instance().GetVideoModal();
    vidModal.SetElementToFocusOnClose($(e.target).closest('.video-modal'));
    vidModal.Show({ httpUrl: httpUrl, analyticCategory: analyticCategory, analyticName: analyticName, customCaptions: customCaptions }, width, height, false, hideBranding);
    vidModal.Close.focus();
});

//Handler for youtube content videos
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', ".youtube-player-inline, .youtube-player-modal", function () {
    var name = $(this).attr("data-name");
    var category = $(this).attr("data-category");
    var videoId = $(this).attr("data-id");
    var element = $(this).attr("data-element");
    var showDisclaimer = $(this).attr("data-show-disclaimer");
    var label = $(this).attr("data-label");
    var playerRequestedFromPdP = $(this).attr("data-inline-video");
    var settings = {
        type: 'youtube',
        videoId: videoId,
        element: element,
        name: name,
        category: category,
        label: label,
        playerVars: {
            autoplay: $(this).attr("data-autoplay"),
            controls: 1,
            fs: 1,
            theme: "light",
            rel: 0
        }
    };

    if ($(this).hasClass("youtube-player-inline")) {
        if (playerRequestedFromPdP) {
            //Mute audio:
            var playerEventObject = {
                onReady: function onReady(e) {
                    e.target.mute();
                    e.target.playVideo();
                    $(e.target.h).attr('tabindex', 0);
                }
            };
            settings.events = playerEventObject;

            HSN.Instance().Events.Trigger(__WEBPACK_IMPORTED_MODULE_34__HSN_Events_js__["a" /* default */].Widget.Video.TOGGLE_INLINE_PLAYER, settings);
            return false;
        }

        //allow player to be initalized directly instead of the request from PDP.
        var player = new __WEBPACK_IMPORTED_MODULE_26_HSNDIR_Widget_VideoPlayers_YoutubePlayer_js__["a" /* default */](settings);
    } else {
        var modal = HSN.Instance().GetYoutubeModal();
        modal.elementToFocusOnClose = !$(this).attr('tabindex') || $(this).attr('tabindex') === '-1' ? $(this).parent() : $(this);
        //show the modal
        settings.element = "hsn-youtube-player";
        modal.Show(settings, 720, 408, showDisclaimer);
    }
    $('.modal-content-container').focus();
    $('.endOfModal').on('focus', function () {
        $('#closeModal').focus();
    });
    $('#modalPopup').on('focus', function () {
        $('.modal-content-container').focus();
    });
    return false;
});

//arcade/lessman shop hsn button
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', '#ShopAllHSN', function () {
    cmCreateManualLinkClickTag('/Lessman-ShopAllHSN?cm_re=Lessman-_-Header-_-ShopAll&amp;cm_sp=Lessman-_-Header-_-ShopAll', 'Lessman-ShopAllHSN');

    $('#navigation-wrapper').off('mouseleave');
    $("#navigation-wrapper2").slideUp(150, function () {
        $("#navigation-wrapper2").css('display', 'none');

        $("#navigation-wrapper").slideDown(500, function () {
            $("#navigation-wrapper").mouseleave(function () {

                $("#navigation-wrapper").slideUp(250, function () {
                    $("#navigation-wrapper2").slideDown(250, 'linear', function () {
                        $("#navigation-wrapper2").css('display', 'block');
                    });
                });
            });
        });
    });
    return false;
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', '.bv-write-review', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var productIdentity = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('product-id') || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('webpid');
    if (!productIdentity || productIdentity === 0) {
        return false;
    }
    var writeReviewWidget = new HSN.Widget.WriteReview();
    writeReviewWidget.init({ application: HSN.Instance() });
    writeReviewWidget.execute(productIdentity);
    return false;
});

//--------Begin Search

//Search button
HSN.ProxyButton('#search-submit', 'ir');

//search suggestion flyout
var searchSuggestTimeoutId = 0;
var searchSuggestFlyout = new HSN.Flyout({
    cacheable: true,
    closeClass: 'ir',
    flyout: '#search-form .flyout',
    url: '/search/suggest?query=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').val()),
    noajax: noAjax,
    trigger: '#search-form .flyout',
    enablehover: Modernizr.touchevents,
    triggerEvent: HSN.Flyout.TRIGGER_EVENT.HOVER,
    setMask: true
});
//HDO-1622

var searchContainer = document.querySelector('.search-container');
var searchInput = document.getElementById('search-input');

if (searchContainer !== null) {
    searchContainer.addEventListener('click', function () {
        searchInput.focus();
    });

    searchContainer.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            searchInput.focus(); // Focus the input when Enter is pressed on the icon
        }
    });

    if (searchInput !== null) {
        searchInput.addEventListener('blur', function () {
            searchContainer.blur(); // Unfocus the icon when the input loses focus
        });
    }
}
//end
searchSuggestFlyout.Events.On(HSN.Flyout.EVENT.AFTER_LOAD, function (flyoutScope) {
    var isTablet = HSN.Instance().DeviceInformation.IsTablet;

    $('#search-suggestions-v3 .product-name').each(function () {
        $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
    });

    if (!$('#search-form .slimScrollSearch').length) {
        $('#search-form #search-suggestions-v3').slimScroll({
            wrapperClass: 'slimScrollSearch',
            alwaysVisible: isTablet,
            color: '#999',
            railColor: '#f2f2f2',
            height: '200px',
            size: '11px',
            distance: '4px',
            borderRadius: '0px',
            wheelStep: isTablet ? 40 : 8,
            opacity: 1,
            railOpacity: 1,
            railVisible: true,
            disableFadeOut: true
        });

        if (!isTablet) $(".slimScrollSearch .slimScrollBar").hide();
    }

    if (isTablet) {
        $(document).off('touchstart.SearchFlyoutCapture').on('touchstart.SearchFlyoutCapture', function (e) {
            if (!$(e.target).parents('#searchbar-v3').length) {
                searchSuggestFlyout.Close(null);
            }
        });
    }
}, this);

searchSuggestFlyout.Events.On(HSN.Flyout.EVENT.BEFORE_CLOSE, function (flyoutScope) {
    var isTablet = HSN.Instance().DeviceInformation.IsTablet;

    if (isTablet) $(document).off('touchstart.SearchFlyoutCapture');
}, this);

HSN.Instance().FlyoutManager.Add(searchSuggestFlyout);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-submit').on('click', function () {
    var cmSitePromo = $(this).attr('manual_cm_sp');
    var cmRealEstateTags = $(this).attr('manual_cm_re');
    cmCreateManualLinkClickTag('/search-submit?cm_re=' + cmRealEstateTags + '&amp;cm_sp=' + cmSitePromo, 'SearchGo');
    return true;
});
//Handle flyout load/unload and selection via key
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').on('keyup focus', function (event) {
    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;
    var androidKey = 229;
    if ((keyCode == arrowKey.up || keyCode == arrowKey.down || keyCode > 111) && keyCode != androidKey) {
        return;
    }

    if (keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
        var currentSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-suggestions-v3 li.selected');
        if (currentSelection.length > 0) {
            var href = currentSelection.find('a').attr('href');
            window.location = href + '&isSuggested=true';
            var cmSitePromo = $(this).attr('manual_cm_sp');
            var cmRealEstateTags = $(this).attr('manual_cm_re');
            cmCreateManualLinkClickTag('/search-submit?cm_re=' + cmRealEstateTags + '&amp;cm_sp=' + cmSitePromo, 'SearchGo');
            return;
        }
    }

    var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').val();

    if (query != '' && query != null && query.length > 2) {
        clearTimeout(searchSuggestTimeoutId);
        searchSuggestTimeoutId = setTimeout(function () {
            searchSuggestFlyout.Url = '/search/suggest?query=' + encodeURIComponent(query);
            searchSuggestFlyout.Open(null, true);
        }, 250);
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-form .flyout').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal-mask').remove();
    }
});

//handle search suggestion flyout key navigation
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-input').on('keydown', function (event) {
    var search = $('#search-input').val().trim();

    // save last search in local storage
    window.sessionStorage && window.sessionStorage.setItem('_last_search_', search);

    var searchSuggestions = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-suggestions-v3 li:not(.disabled-header)');
    var hasResults = searchSuggestions.length;
    if (!hasResults) {
        return;
    }

    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;

    var currentSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-suggestions-v3 li.selected');

    //If has selected item, and pressed enter, ignore default behavior(form submit) to do search on keyup event
    if (currentSelection.length > 0 && keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
    }

    if (keyCode != arrowKey.up && keyCode != arrowKey.down) {
        return;
    }

    var nextSelection = [];
    if (keyCode === arrowKey.down) {
        nextSelection = currentSelection.nextAll('#search-suggestions-v3 li:not(.disabled-header)').first();
        if (nextSelection.length === 0) {
            nextSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-suggestions-v3 li:not(.disabled-header)').first();
        }
    } else if (keyCode === arrowKey.up) {
        nextSelection = currentSelection.prevAll('#search-suggestions-v3 li:not(.disabled-header)').first();
        if (nextSelection.length === 0) {
            nextSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-suggestions-v3 li:not(.disabled-header)').last();
        }
    }

    currentSelection.removeClass('selected');
    nextSelection.addClass('selected');
});

//handle suggested search selection via mouse
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-form').on('click', '#search-suggestions-v3 li a', function (event) {
    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');

    link += '&isSuggested=true';

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', link); //Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//handle lessman suggested search selection via mouse
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lessman-search-suggestions-flyout').on('click', '#lessman-search-suggestions li a', function () {

    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');

    link += '&isSuggested=true';

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', link); //Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//handle lessman suggested search (ALL HSN.com) selection via mouse
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lessman-search-suggestions-flyout').on('click', '#search-suggestions li a', function () {

    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');

    link += '&isSuggested=true';

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', link); //Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//Logging if search was done, checking querystring for parameters
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
    var query = HSN.Instance().GetQueryStringParam(window.location.search, 'query');

    //is search result, log
    if (query.length > 0) {
        var wasRedirect = HSN.Instance().GetQueryStringParam(window.location.search, 'rid').length > 0;
        var isSuggested = HSN.Instance().GetQueryStringParam(window.location.search, 'isSuggested');

        var numResults;

        var numResultField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#template-product-grid[data-total-products]');
        if (numResultField.length > 0) {
            //if search result page, get num results
            var notInitialPage = HSN.Instance().GetQueryStringParam(window.location.search, 'skip').length > 0;
            if (notInitialPage) {
                return;
            }
            numResults = parseInt(numResultField.data('total-products'));
        } else if (!wasRedirect) {
            //not search result or redirect, must be single product page
            numResults = 1;
        } else {
            numResults = null; //must be redirect, set as null
        }

        HSN.Instance().LogKeywordSearch(query, numResults, isSuggested.toLowerCase() == "true", wasRedirect);
    }
});
//------End Search


//--------Begin Arcade Search

//Search button
HSN.ProxyButton('#arcade-search-submit', 'ir');

//search suggestion flyout
var arcadeSearchSuggestTimeoutId = 0;
var arcadeSearchSuggestFlyout = new HSN.Flyout({
    cacheable: true,
    closeClass: 'ir',
    flyout: '#arcade-search-form .flyout',
    url: '/search/suggest?query=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-input').val()),
    noajax: noAjax
});

HSN.Instance().FlyoutManager.Add(arcadeSearchSuggestFlyout);

arcadeSearchSuggestFlyout.Events.On(HSN.Flyout.EVENT.AFTER_LOAD, function (flyoutScope) {
    $('#search-suggestions-v3 .product-name').each(function () {
        $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
    });
}, this);

//Handle flyout load/unload and selection via key
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-input').on('keyup', function (event) {
    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;
    if (keyCode == arrowKey.up || keyCode == arrowKey.down || keyCode > 111) {
        return;
    }

    if (keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
        var currentSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-suggestions li:not(.title).selected');
        if (currentSelection.length > 0) {
            var href = currentSelection.find('a').attr('href');
            window.location = href + '&isSuggested=true';
            cmCreateManualLinkClickTag('/search-submit?cm_re=header-_-search-_-NA&amp;cm_sp=header-_-search-_-NA', 'SearchGo');
            return;
        }
    }

    var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-input').val();
    if (query != '' && query != null && query.length > 2) {
        clearTimeout(arcadeSearchSuggestTimeoutId);
        arcadeSearchSuggestTimeoutId = setTimeout(function () {
            arcadeSearchSuggestFlyout.Url = '/search/suggest?query=' + encodeURIComponent(query);
            arcadeSearchSuggestFlyout.Open(null, true);
        }, 250);
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-form .flyout').hide();
    }
});

//handle search suggestion flyout key navigation
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-input').on('keydown', function (event) {
    var arcadeSearchSuggestions = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-suggestions li:not(.title)');
    var hasResults = arcadeSearchSuggestions.length;
    if (!hasResults) {
        return;
    }

    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;

    var currentSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-suggestions li:not(.title).selected');

    //If has selected item, and pressed enter, ignore default behavior(form submit) to do search on keyup event
    if (currentSelection.length > 0 && keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
    }

    if (keyCode != arrowKey.up && keyCode != arrowKey.down) {
        return;
    }

    var nextSelection = [];
    if (keyCode == arrowKey.down) {
        nextSelection = currentSelection.nextAll('#arcade-search-suggestions li:not(.title)').first();
        if (nextSelection.length === 0) {
            nextSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-suggestions li:not(.title)').first();
        }
    } else if (keyCode == arrowKey.up) {
        nextSelection = currentSelection.prevAll('#arcade-search-suggestions li:not(.title)').first();
        if (nextSelection.length === 0) {
            nextSelection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-suggestions li:not(.title)').last();
        }
    }

    currentSelection.removeClass('selected');
    nextSelection.addClass('selected');
});

//handle suggested search selection via mouse
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#arcade-search-form').on('click', '#arcade-search-suggestions li a', function (event) {

    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');

    link += '&isSuggested=true';

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href', link); //Modify link to include new querystring parameter for search tracking
});
//------End Arcade Search

//jquery placeholder library
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('input, textarea').placeholder();

//w3c markup validation control
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#markup-validation a').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).html('Validating...');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax('/validation', {
        context: this,
        data: { url: window.location.href },
        dataType: 'html',
        type: 'GET',
        success: function success(data) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().html(data);
        }
    });
});

function SetFavoriteDrawer() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.favorites-drawer .items-drawer-content .product .supplementary').equalHeights();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.favorites-drawer .items-drawer-content .drawer-content, .favorites-drawer .more-drawer-content .drawer-content').equalHeights();
}

function CloseFavoriteDrawer() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.favorites-drawer .favorite-wrapper').each(function () {
        var favoriteWidgetName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('id');
        var favoriteWidget = window[favoriteWidgetName];
        if (favoriteWidget && favoriteWidget.destroy) {
            favoriteWidget.destroy();
        }
    });
}

function BuildFlyouts() {
    var flyouts = [];

    flyouts.push(new HSN.Flyout({
        cacheable: true,
        closeClass: 'ir',
        flyout: '#recently-aired .flyout',
        trigger: '#recently-aired',
        url: '/headerfooter/recently-aired',
        noajax: noAjax,
        disableHover: Modernizr.touchevents,
        triggerEvent: Modernizr.touchevents ? HSN.Flyout.TRIGGER_EVENT.CLICK : HSN.Flyout.TRIGGER_EVENT.HOVER
    }));

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lessman-flyout-area > div').each(function () {

        var linkElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var flyoutElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children('div');

        if (flyoutElement.length > 0) {
            var flyout = new HSN.Flyout({
                cacheable: true,
                closeClass: 'ir',
                closeTag: 'li',
                flyout: flyoutElement,
                trigger: this,
                url: '/namedcell?name=' + linkElement.attr('data-marketing-id'),
                noajax: noAjax,
                disableHover: Modernizr.touchevents,
                triggerEvent: HSN.Flyout.TRIGGER_EVENT.CLICKHOVER

            });

            flyouts.push(flyout);
        }
    });

    if ($('#arcade.arcade').length > 0) flyouts.push(new HSN.Flyout({
        cacheable: true,
        closeClass: 'ir',
        flyout: '#arcade.arcade .flyout',
        trigger: '#arcade.arcade',
        url: '/namedcell?name=Arcade-Flyout',
        noajax: noAjax,
        disableHover: Modernizr.touchevents,
        triggerEvent: Modernizr.touchevents ? HSN.Flyout.TRIGGER_EVENT.CLICK : HSN.Flyout.TRIGGER_EVENT.HOVER
    }));

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
        var accountMenu = new HSN.AccountMenu();
        accountMenu.init({
            application: HSN.Instance(),
            container: '#account-dropdown',
            noAjax: noAjax
        });
        //email signup footer
        if ($('.email-signup-container').length > 0) {
            var emailSignup = new HSN.EmailSignUp();
            emailSignup.init({
                application: HSN.Instance(),
                container: '.email-signup-container',
                submitElement: '.email-signup-submit-btn',
                errorElement: '#signup-email-errors',
                errorConfirmElement: '#signup-confirm-email-errors'
            });
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#hamburger-open-button').one('mouseenter', function () {
            var flyout = new HSN.HamburgerFlyout({
                application: HSN.Instance(),
                flyout: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hamburger-holder"),
                trigger: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hamburger-holder").add(this)
            });

            flyout.OpenHamburgerMenu();
        });
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("load", function () {
        if ($('#shopping-bag-flyout').length > 0 && !noAjax) {
            HSN.Instance().SetBagFlyout(new HSN.BagFlyout({
                trigger: '#shopping-bag-flyout',
                flyout: '#shopping-bag-flyout .flyout',
                flyoutContent: '#shopping-bag-flyout .flyout .bag-container',
                application: HSN.Instance()
            }));
        }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
        $('#search-form form').submit(function (e) {
            var search = $('#search-input').val().trim();

            HSN.DataLayer.helpers.compassEvent({ 'search_term': search }, true, true);

            // Relies on the event above setting 'search_term'
            HSN.DataLayer.helpers.hsnEvent(null, 'SearchSubmit', 'Success');
        });
    });

    //Support for new floaty input labels
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
        var inputWidget = new HSN.Widget.FancyInput();
        inputWidget.init({
            application: HSN.Instance()
        });
    });

    return flyouts;
}

/***/ }),

/***/ "ItUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_browser_deeplink_js__ = __webpack_require__("ouuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_browser_deeplink_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_browser_deeplink_js__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



var SmartBanner = function SmartBanner(options) {
    this.options = $.extend({}, $.smartbanner.defaults, options);
    var banner = '<div id="smartbanner" class="banner"><div class="sb-container"><a href="#" class="sb-close"></a><span class="sb-icon"></span><div class="sb-info"><strong>' + this.options.title + '</strong></div><a href="#" class="sb-button"><span>' + this.options.buttonText + '</span></a></div></div>';
    if (HsnDrdPageCache.getCookie('bnrhid')) {
        return;
    }

    $('#utility-nav-parent, #utility-nav-parent-v3').append(banner);
    this.bannerHeight = $('#smartbanner').outerHeight() + 2;
    this.Show();
    this.BindEvents();

    deeplink.setup({
        iOS: {
            appName: this.options.appName,
            appId: this.options.appId
        },
        android: {
            appId: this.options.appId
        }
    });
};

SmartBanner.prototype = {
    constructor: SmartBanner,

    Show: function Show() {
        var scope = this;
        var banner = $('#smartbanner');
        banner.animate({ top: 0, display: 'block' }, this.options.speedIn).addClass('shown').show();
        if (this.options.timeout) {
            window.setTimeout(function () {
                scope.Close();
            }, this.options.timeout);
        }
    },
    Hide: function Hide() {
        var banner = $('#smartbanner');
        banner.animate({ top: -1 * this.bannerHeight, display: 'block' }, this.options.speedIn).removeClass('shown');
    },
    Close: function Close() {
        this.Hide();
        HsnDrdPageCache.setCookie('bnrhid', true, HsnDrdPageCache.getLowerDomain(), this.options.daysHidden, '/');
        return false;
    },
    BindEvents: function BindEvents() {
        $('#smartbanner .sb-close').on('click', $.proxy(this.Close, this));
        $('#smartbanner .sb-button').on('click', $.proxy(this.OpenApp, this));
    },
    OpenApp: function OpenApp() {
        var scope = this;
        scope.coremetricsLinkClick('banner-_-MobileApp-_-NA');
        this.SendDeepLinkData(function () {
            deeplink.open(scope.options.deepLinkUrl);
            scope.Hide();
            HsnDrdPageCache.setCookie('bnrinst', true, HsnDrdPageCache.getLowerDomain(), scope.options.daysReminder, '/');
        });
        return false;
    },
    SendDeepLinkData: function SendDeepLinkData(callback) {
        var data = { deepLink: this.options.deepLinkUrl };
        $.ajax('/api/save-deep-link', {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success() {
                if (callback) callback.call();
            }
        });
    },
    coremetricsLinkClick: function coremetricsLinkClick(cmData) {
        cmCreateManualLinkClickTag(window.location.href + '?cm_re=' + cmData + '&amp;cm_sp=' + cmData, 'DeepLink');
    }
};
$.smartbanner = function (option) {
    var $window = $(window),
        data = $window.data('smartbanner'),
        options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
    if (!data) $window.data('smartbanner', data = new SmartBanner(options));
    if (typeof option == 'string') data[option]();
};
// override these globally if you like (they are all optional)
$.smartbanner.defaults = {
    title: null, // What the title of the app should be in the banner (defaults to <title>)
    buttonText: 'OPEN', // Text for the install button
    speedIn: 300, // Show animation speed of the banner
    speedOut: 400, // Close animation speed of the banner
    daysHidden: 90, // Duration to hide the banner after being closed (0 = always show banner)
    daysReminder: 0, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
    appendToSelector: '#utility-nav-parent, #utility-nav-parent-v3', //Append the banner to a specific selector
    appName: 'HSN Shop App',
    appId: '324326909',
    deepLinkUrl: 'hsnapp://',
    timeout: null
};

/***/ }),

/***/ "K0L7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.AsIsModal
* Encapsulates the functionality of an "AS IS" product dialog.
**/
HSN.AsIsModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(AsIsModal, _super);

    function AsIsModal() {
        return AsIsModal.__super__.constructor.call(this);
    }

    AsIsModal.prototype._show = function (buttonClicked) {

        $.ajax("/as-is/notice", {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {

                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });

                $('#as-is-disagree').on('click', function (e) {

                    e.stopPropagation();
                    e.preventDefault();

                    var exdate = new Date();
                    exdate.setDate(exdate.getDate() - 1);
                    var c_value = escape("true") + "; expires=" + exdate.toUTCString();
                    document.cookie = "consentToAsIs=" + c_value;

                    __scope.Root.hide();
                    $('#modal-mask').remove();
                });

                $('#as-is-agree').on('click', function (e) {

                    e.stopPropagation();
                    e.preventDefault();

                    var exdate = new Date();
                    exdate.setSeconds(exdate.getSeconds() + 1);
                    var c_value = escape("true") + "; expires=" + exdate.toUTCString();
                    document.cookie = "consentToAsIs=" + c_value;

                    __scope.Root.hide();
                    $('#modal-mask').remove();

                    buttonClicked.click();
                });
            },
            error: function error(xhr, status, _error) {

                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return AsIsModal;
}(HSN.Modal);

/***/ }),

/***/ "K3P/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Template_EmailCaptureCommon_js__ = __webpack_require__("Lo8r");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





/**
* class HSN.PrivateSaleEmailCaptureModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.PrivateSaleEmailCaptureModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(PrivateSaleEmailCaptureModal, parent);

    function PrivateSaleEmailCaptureModal(config) {
        var modal = PrivateSaleEmailCaptureModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own

        this.name = 'HSN.private-sale-email-capture';

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Content).on('keyup', '#capture-email-address', function () {
            var $this = $(this);
            if (!HSN.ValidateEmail($('#capture-email-address').val())) {
                $this.addClass('invalid-email');
            } else {
                $this.removeClass('invalid-email');
            }
            return;
        });

        $(modal.Content).on('click', '#capture-signup', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var emailAddress = $('#capture-email-address').val();
            var promoId = $(this).data('promoId');

            if (emailAddress === '' || emailAddress === null || !HSN.ValidateEmail(emailAddress)) {
                $('#capture-error').html('Please enter an email address.');
                $('#capture-email-address').addClass('invalid-email');
                return;
            }

            HSN.DataLayer.helpers.metricEvent(null, 'RE:emailsignup', 'privatesale', 'SO');

            var config = {};
            config.success = function (data) {
                if (data.success) {
                    $.ajax('/stores-actions/private-sale/associate-promotion', {
                        dataType: 'json',
                        method: 'POST',
                        data: { promotionId: promoId },
                        success: function success(responseData) {
                            window.location.reload();
                        }
                    });
                }

                return;
            };
            config.error = function () {
                alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
            };

            HSN.Instance().HandleEmailSignup(emailAddress, 96, config);
        });

        $(modal.Content).on('click', '#capture-cancel', function (e) {
            e.stopPropagation();
            e.preventDefault();

            closeModal(modal);
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.PrivateSaleEmailCaptureModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    PrivateSaleEmailCaptureModal.prototype._show = function (promoId) {
        $.ajax('/stores-actions/private-sale/email-capture' + '?promoId=' + promoId + '&' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    var elemetToFocus = __scope.Root.find('#modalPopup');
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 }, function () {
                        __scope.SetFocus(elemetToFocus);
                    });

                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                    }
                });

                var inputWidget = new HSN.Widget.FancyInput();
                inputWidget.init({
                    application: HSN.Instance(),
                    containerName: '.private-sale-email-capture'
                });
            },
            error: function error(xhr, status, _error) {
                //Dont think we want to display the loading error if this modal doesnt display?
                //alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return PrivateSaleEmailCaptureModal;
}(HSN.Modal);

/***/ }),

/***/ "KjOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ProfileImageUploadModal
*
* Encapsulates the functionality of a modal dialog that uploads a customer profile image.
**/
HSN.ProfileImageUploadModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ProfileImageUploadModal, parent);

    function ProfileImageUploadModal() {
        /** new HSN.ProfileImageUploadModal() **/
        var modal = ProfileImageUploadModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        var scope = modal;
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
        $(modal.Content).on('click', '#submit', function () {
            HSN.SetWait();
            scope.accountService.UploadProfileImage(new FormData($('#image-upload')[0]), {
                callback: function callback(data) {
                    if (data.success) {
                        HSN.RemoveWait();
                        window.location.href = '/myaccount/update?tab=profile';
                    } else {
                        HSN.RemoveWait();
                        HSN.AddErrorTreatment($('#image-upload'), data);
                    }
                },
                errorCallback: function errorCallback() {
                    HSN.RemoveWait();
                    alert('Unfortunately there was an error, please try again.');
                },
                scope: this
            });
            return false;
        });
        $(modal.Content).on('click', '#cancel', function () {
            closeModal(modal);
            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.ProfileImageUploadModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ProfileImageUploadModal.prototype._show = function (config) {
        var scope = this;

        $.ajax('/myaccount/profile-image-upload', {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    $(__scope.Root).find('#browse').focus();
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };
    return ProfileImageUploadModal;
}(HSN.Modal);

/***/ }),

/***/ "Lo8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_placeholder_js__ = __webpack_require__("4plx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_placeholder_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_placeholder_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Template_js__ = __webpack_require__("7LMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Template_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Template_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





/**
    * class HSN.Template.EmailCaptureCommon
    *
    * Encapsulates the common functionality for Email Capture.
    **/
HSN.Template.EmailCaptureCommon = function (config) {
    /**
        * new HSN.Template.EmailCaptureCommon(config)
        * - config (Object): A configuration object for the [[HSN.Template.EmailCaptureCommon]]
        *   consisting of the following keys:
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the template.
        *   - context (string): A string telling the template what context its being called under. Should be either MODAL|modal or DRAWER|drawer.
        **/

    var __scope = this;

    this._container = $(config.container);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input, textarea').placeholder();

    //These events are attached from the drawer, the modal's events are attached in EmailCaptureModal.js
    $('#capture-email-address-again').on('paste', this._container, function (e) {
        return false;
    });

    $('#capture-email-address-again').on('keyup', this._container, function (e) {
        var $this = $(this);
        if ($this.val() !== $('#capture-email-address').val()) {
            $this.addClass('invalid-email');
        } else {
            $this.removeClass('invalid-email');
        }
    });

    $('#capture-signup').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        var emailAddress = $('#capture-email-address').val();
        var emailAddressAgain = $('#capture-email-address-again').val();

        if (emailAddress === '' || emailAddress === null) {
            $('#capture-error').html('Please enter an email address.');
            $('#capture-email-address').addClass('invalid-email');
            return;
        }

        if (emailAddress !== emailAddressAgain) {
            $('#capture-error').html('Your email and confirm email do not match.');
            $('#capture-email-address-again').each(function () {
                $(this).addClass('invalid-email');
            });
            return;
        }

        cmCreateManualLinkClickTag('/email-capture-drawer?cm_sp=EmailCapture-_-Drawer-_-15Off&cm_re=EmailCapture-_-Drawer-_-15Off', 'EmailCapture15Off');
        var config = {};
        config.success = function (data) {
            __scope.HandleDrawerThanks();
        };
        config.error = function () {
            alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
        };
        HSN.Instance().HandleEmailSignup(emailAddress, 56, config);
    });

    $('#capture-no-thanks').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        var callback = function callback() {
            HSN.Instance().AccountNavigation.Cabinet.Close(null);
            cmCreateManualLinkClickTag('/email-capture-drawer?cm_sp=EmailCapture-_-Drawer-_-NoThanks&cm_re=EmailCapture-_-Drawer-_-NoThanks', 'EmailCaptureNoThanks');
        };
        __scope.HandleNoThanks(callback);
    });

    $('#capture-shop-now').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        HSN.Instance().AccountNavigation.Cabinet.Close(null);
    });
};
HSN.Template.EmailCaptureCommon.prototype = {
    HandleNoThanks: function HandleNoThanks(callback) {
        HSN.Template.EmailCaptureCommon.prototype.AjaxSend('/account/emailcapture/no-thanks', 'POST', 'json', {}, {});
        if (callback) {
            callback();
        }
    },
    HandleDrawerThanks: function HandleDrawerThanks() {
        var config = {};
        config.callback = function (data) {
            //change out drawer content here
            $('#cabinet .content').html(data);
        };
        HSN.Template.EmailCaptureCommon.prototype.AjaxSend('/account/emailcapture/thanks', 'GET', 'html', {}, config);
    },
    AjaxSend: function AjaxSend(url, type, dataType, reqData, config) {
        url = url + '?_ts' + new Date().getTime();
        $.ajax(url, {
            context: this,
            dataType: dataType,
            type: type,
            data: reqData,
            success: function success(data) {
                if (config && config.callback) {
                    config.callback(data);
                }
            },
            error: function error() {
                alert('Unfortunately there was an error, please try again.');
            }
        });
    }
};

/***/ }),

/***/ "MU8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__("hKoQ").polyfill();


/***/ }),

/***/ "Mc10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.ArcadeService = function () {};

HSN.Service.ArcadeService.prototype = {
    /*Cms Widget Helpers*/
    GetGamePlayWidget: function GetGamePlayWidget(data, config) {
        this._sendHtml("/widget/arcade/gameplay", data, config);
    },

    GetGameOverWidget: function GetGameOverWidget(data, config) {
        this._sendHtml("/widget/arcade/gameover", data, config);
    },

    GetLeaderboardWidget: function GetLeaderboardWidget(data, config) {
        this._sendHtml("/widget/arcade/leaderboard", data, config);
    },

    GetGameSize: function GetGameSize(ratio, container) {
        var result = { width: 0, height: 0 };
        var maxWidth = $(container).closest('.cms-cell').width();
        var maxHeight = $(window).height();

        if ($(window).width() < maxWidth) {
            maxWidth = $(window).width();
        }

        if (maxWidth / ratio > maxHeight) {
            result.width = Math.round(maxHeight * ratio);
            result.height = maxHeight;
        } else {
            result.width = maxWidth;
            result.height = Math.round(maxWidth / ratio);
        }

        return result;
    },

    /*End Cms Widget Helpers*/

    GetTicketBalance: function GetTicketBalance(config) {
        this._send("/arcade/getticketbalance", {}, config);
    },

    RateGame: function RateGame(gameId, rating, config) {
        this._send("/arcade/rategame/", { GameId: gameId, Rating: rating }, config);
    },

    FavoriteGame: function FavoriteGame(gameId, add, config) {
        this._send("/arcade/favoritegame", { GameId: gameId, Add: add }, config);
    },

    /* Rewards Services */
    GetLiveGridPage: function GetLiveGridPage(page, config) {
        this._sendHtml("rewards/livegrid", { pageNumber: page }, config);
    },

    _send: function _send(url, data, config) {
        config = config || {};

        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        if (arcadeObjectName !== null) {
            var fullyQualifiedUrl = config.baseUrl + url;

            var successCallback = function successCallback(data) {
                if (config.callback) config.callback.call(config.scope || config.callback, data);
            };

            var failureCallback = function failureCallback(xhr, status, error) {
                if (config.callback) config.callback.call(config.scope || config.callback, true);
            };

            window[arcadeObjectName].easyXDM.rpc.ajaxRequest({
                url: fullyQualifiedUrl,
                type: 'POST',
                dataType: 'json',
                data: data
            }, successCallback, failureCallback);
        } else {
            data['_ts'] = new Date().getTime();

            $.ajax(url, {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function success(data, status, xhr) {
                    if (config.callback) config.callback.call(config.scope || config.callback, data);
                },
                error: function error(xhr, status, _error) {
                    if (config.callback) config.callback.call(config.scope || config.callback, true);
                }
            });
        }
    },

    _sendHtml: function _sendHtml(url, data, config) {
        config = config = config || {};

        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        if (arcadeObjectName !== null) {
            var fullyQualifiedUrl = config.baseUrl + url;

            var successCallback = function successCallback(data) {
                if (config.callback) config.callback.call(config.scope || config.callback, true, data);
            };

            var failureCallback = function failureCallback(xhr, status, error) {
                if (config.callback) config.callback.call(config.scope || config.callback, false, error);
            };

            window[arcadeObjectName].easyXDM.rpc.ajaxRequest({
                url: fullyQualifiedUrl,
                type: 'GET',
                dataType: 'html',
                data: data
            }, successCallback, failureCallback);
        } else {
            data['_ts'] = new Date().getTime();

            $.ajax(url, {
                cache: config.cacheable = config.cacheable || false,
                type: 'GET',
                data: data,
                context: this,
                dataType: 'html',
                success: function success(data, status, xhr) {
                    if (config.callback) config.callback.call(config.scope || config.callback, true, data);
                },
                error: function error(xhr, status, _error2) {
                    if (config.callback) config.callback.call(config.scope || config.callback, false, _error2);
                }
            });
        }
    }
};

/***/ }),

/***/ "MpGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.VIPFinancingModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.VIPFinancingModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(VIPFinancingModal, _super);

    function VIPFinancingModal() {
        var modal = VIPFinancingModal.__super__.constructor.call(this);
        this.Close.off();
        this.isCheckout = false;
        this.resubmitConfig = {};
        this.commerceService = HSN.Instance()._getCommerceService();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            cancel(modal);
        });
        $(modal.Content).on('click', '#continue', function () {
            $('.confirm-container').removeClass('input-validation-error');
            if (!$('#confirmation', modal.Content).is(':checked')) {
                $('.confirm-container').addClass('input-validation-error');
                return false;
            }
            HSN.LoaderSetWait();

            var config = modal.resubmitConfig;
            modal.commerceService.ProcessOrder({ debitAuthorized: config.debitAuthorized, debitAuthorizationRequired: config.debitAuthorizationRequired, sessionIdentity: config.sessionIdentity, isDeferredContinue: true }, {
                callback: function callback(data) {
                    if (data.success) {
                        if (data.isBagGiveawayWinner) {
                            HSN.RemoveWait();
                            var winnerModal = HSN.Instance().GetGenericConfirmModal();
                            winnerModal.SetInputData({});
                            winnerModal.SetOkCallback(function () {
                                window.location = data.NextUrl;
                            });
                            winnerModal.SetCloseClickCallback(function () {
                                window.location = data.NextUrl;
                            });
                            winnerModal.Show('/checkout/bag-giveaway-winner');
                        } else {
                            window.location = data.NextUrl;
                        }
                    } else {
                        if (data.RequiresCardVerification) {
                            HSN.RemoveWait();
                            HSN.Instance().GetCardVerificationModal().Show(config.cvvUrl);
                        } else if (data.NextUrl) {
                            window.location = data.NextUrl;
                        } else {
                            HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was a problem submitting your order, please try again.');
                        }
                    }
                }
            });

            modal.Hide();
            return false;
        });

        $(modal.Content).on('click', '#cancel', function () {
            cancel(modal);
            return false;
        });

        $(modal.Content).on('click', '#print', function () {
            HSN.PrintElement(document.getElementById('vip-financing-modal'));
            window.print();
            return false;
        });
    }

    function cancel(modal) {
        if (modal.isCheckout) {
            modal.Content.remove();
            modal.AddLoadingSpinner();
            modal.commerceService.RemoveVipFinancing({}, {
                callback: function callback() {
                    window.location.reload(true);
                }
            });
        } else {
            modal.Hide();
        }
    }

    /**
    * HSN.VIPFinancingModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    VIPFinancingModal.prototype._show = function (id, isCheckout, resubmitConfig) {
        var scope = this;
        scope.isCheckout = isCheckout;
        scope.resubmitConfig = resubmitConfig || {};
        scope.AddLoadingSpinner();
        var url = '/vipfinancing/get/' + id;
        if (isCheckout) {
            url = url + '?isCheckout=true';
        }
        $.ajax(url, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                scope.RemoveLoadingSpinner();
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                }, function () {});
            },
            error: function error(xhr, status, _error) {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                $('#modal-mask').remove();
            }
        });
    };

    return VIPFinancingModal;
}(HSN.Modal);

/***/ }),

/***/ "NfpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_AddToBag_js__ = __webpack_require__("Z47Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_ApplePay_js__ = __webpack_require__("E9at");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductOptionSelector_js__ = __webpack_require__("ZrRa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Widget_QuantitySelector_js__ = __webpack_require__("+PcD");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// define EVENTs




/**
    * class HSN.BuySelector
    *
    * Encapsulates the client functionality the Buy Selector Partial.
    * @param {object} [config] A configuration object
    **/
HSN.BuySelector = function (config) {
    var _this = this;

    /**
        * new HSN.BuySelector(config)
        * - config (Object): A configuration object for the [[HSN.BuySelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the BuySelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the BuySelector.
        *   - windowLocation (Location): The location object of the browser window.
        **/

    var scope = this;

    this._application = config.application;
    this._container = $(config.container);
    this._windowLocation = config.windowLocation;
    this._imageContainer = $(config.imageContainer);
    this._favoriteLink = $(config.favoriteLink);
    this._addToBagCallback = config.addToBagCallback;
    this._addToBagRefreshWhenDone = config.addToBagRefreshWhenDone;
    this._isPreviewModal = config.isPreviewModal;
    this._variants = config.variants;
    this._variantInfo = config.variantInfo;

    this._productImage = null;
    this._preSelectedWebId = $('.pre_selected_webid', scope._container).val();
    this._isEditBagPreview = $('.is_edit_bag_preview', scope._container).val();

    var quantitySelector = $('.quantity-selector', scope._container);
    if (quantitySelector.length) {
        this._quantitySelector = new HSN.QuantitySelector({
            application: this._application,
            container: quantitySelector
        });

        quantitySelector.on('qtyChanged', function () {
            scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
        });
    }

    // Keep display in sync with the variantInfo
    this._variantInfo.onChange(function () {
        _this.ClearErrors();
    });

    scope._application.Events.On(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, function (text, container) {
        // make sure the containers match, in case there are multiple buy selectors on page
        if (scope._container.find('.product-option-selector')[0] === container[0]) {
            if ((text === 'On Waitlist' || text === 'Extended Delivery') && !$('.product-delivery-message').hasClass('is-override')) {
                $('.product-delivery-message').toggle(false);
            } else {
                $('.product-delivery-message').toggle(true);
            }
            $('.product-modal-option-status', scope._container).last().text(text);
            scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
        }
    });

    $('input.add-to-bag, input.express-buy, .apple-pay-button', scope._container).on('click keydown', function (e) {

        var $this = $(this);

        if (e.type === 'keydown') {
            if (e.key !== 'Enter') {
                return;
            }

            if (!$this.is('input')) {
                $this = $this.siblings('input');
            }
        } else if (e.type === 'click') {
            if ($this.is('span.add-to-bag-proxy') || $this.is('span.express-buy-proxy')) {
                return;
            }
        }

        //esrb
        var rating = $this.data('rating');
        if (rating) {
            //check for cookie
            var isOver17 = false;
            var i,
                x,
                y,
                arRcookies = document.cookie.split(';');
            var arrCookiesLength = arRcookies.length;
            for (i = 0; i < arrCookiesLength; i++) {
                x = arRcookies[i].substr(0, arRcookies[i].indexOf('='));
                y = arRcookies[i].substr(arRcookies[i].indexOf('=') + 1);
                x = x.replace(/^\s+|\s+$/g, '');
                if (x === 'over17') {
                    isOver17 = true;
                }
            }

            if (!isOver17) {
                HSN.Instance().GetRatingModal().Show(rating, $this);
                return false;
            }
        }

        // As Is
        var isAsIs = $this.data('isasis');
        if (isAsIs) {
            //check for cookie
            var consentToAsIs = false;
            var index,
                name,
                cookies = document.cookie.split(';');
            var cookiesLength = cookies.length;
            for (index = 0; index < cookiesLength; index++) {
                name = cookies[index].substr(0, cookies[index].indexOf('='));
                name = name.replace(/^\s+|\s+$/g, '');
                if (name === 'consentToAsIs') {
                    consentToAsIs = true;
                }
            }

            if (!consentToAsIs) {
                HSN.Instance().GetAsIsModal().Show($this);
                return false;
            }
        }

        // Alcohol
        var isAlcohol = $this.data('isalcohol');
        if (isAlcohol) {
            var itsFunHere = sessionStorage.getItem('alcohol-verification') ? true : false;

            if (!itsFunHere) {
                HSN.Instance().GetAlcoholModal().Show($this);
                return false;
            }
        }

        var productId = $this.data('object-id');
        var productWebmId = $this.data('object-webmid');

        var request = scope.GetRequestObject($this, productId);

        if (request.Errors !== null && request.Errors.length > 0) {
            return false;
        }

        if ($this.data('personalize')) {
            var form = document.createElement('form');
            var inputId = document.createElement('input');
            inputId.setAttribute('type', 'hidden');
            inputId.setAttribute('name', 'Id');
            inputId.setAttribute('value', request.WebId);
            form.appendChild(inputId);
            var warrWebPId = document.createElement('input');
            warrWebPId.setAttribute('type', 'hidden');
            warrWebPId.setAttribute('name', 'WarrantyWebPId');
            warrWebPId.setAttribute('value', request.WarrantyWebPId);
            form.appendChild(warrWebPId);
            var inputQty = document.createElement('input');
            inputQty.setAttribute('type', 'hidden');
            inputQty.setAttribute('name', 'Qty');
            inputQty.setAttribute('value', request.Quantity);
            form.appendChild(inputQty);
            var inputFlex = document.createElement('input');
            inputFlex.setAttribute('type', 'hidden');
            inputFlex.setAttribute('name', 'flexpay');
            inputFlex.setAttribute('value', request.FlexPay);
            form.appendChild(inputFlex);
            var inputExtaFlex = document.createElement('input');
            inputExtaFlex.setAttribute('type', 'hidden');
            inputExtaFlex.setAttribute('name', 'extraFlex');
            inputExtaFlex.setAttribute('value', request.ExtraFlex);
            form.appendChild(inputExtaFlex);
            var inputExtaFlexPromo = document.createElement('input');
            inputExtaFlexPromo.setAttribute('type', 'hidden');
            inputExtaFlexPromo.setAttribute('name', 'extraFlexPromo');
            inputExtaFlexPromo.setAttribute('value', request.ExtraFlexPromo);
            form.appendChild(inputExtaFlexPromo);
            var inputDeferred = document.createElement('input');
            inputDeferred.setAttribute('type', 'hidden');
            inputDeferred.setAttribute('name', 'deferredPromo');
            inputDeferred.setAttribute('value', request.DeferredFinancing);
            form.appendChild(inputDeferred);

            form.action = '/products/personalization/get';
            form.method = 'post';
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(form);
            form.submit();
        } else {
            var commerceService = HSN.Instance()._getCommerceService();
            if ($this.data('update-bag')) {
                HSN.SetWait();
                commerceService.UpdateVariant({ bagIdentity: $this.data('bag-id'), bagItemId: $this.data('basket-id'), webId: request.WebId }, {
                    callback: function callback(data) {
                        if (!data.success) {
                            HSN.RemoveWait();
                            alert('There was a problem editing your bag item. Please try again later.');
                        } else {
                            location.reload();
                        }
                    },
                    scope: $this.get(0)
                });
            } else {
                if ($this.is(".express-buy")) {
                    HSN.LoaderSetWait();
                } else {
                    HSN.SetWait();
                }

                var addToBag = {
                    ProductId: productId,
                    WebId: request.WebId,
                    DeferredFinancing: request.DeferredFinancing,
                    ExtraFlexPromo: request.ExtraFlexPromo,
                    ExtraFlex: request.ExtraFlex,
                    ExtraFlexV2: request.ExtraFlexV2,
                    ExpressBuy: request.ExpressBuy,
                    IsApplePay: request.IsApplePay,
                    Quantity: request.Quantity,
                    FlexPay: request.FlexPay,
                    FlexPayV2: request.FlexPayV2,
                    ProgramId: request.ProgramId,
                    ProgramCode: request.ProgramCode,
                    Frequency: request.Frequency,
                    StartDate: request.StartDate,
                    WarrantyWebPId: request.WarrantyWebPId,
                    WarrantyName: request.WarrantyName,
                    WarrantyAmount: request.WarrantyAmount,
                    MatrixId: productWebmId
                };
                var addToBagWidget = new HSN.Widget.AddToBag();
                addToBagWidget.init({
                    application: scope._application,
                    isInPreviewModal: scope._isPreviewModal,
                    doFinish: !request.IsApplePay,
                    refreshWhenDone: scope._addToBagRefreshWhenDone
                });
                addToBagWidget.AddToBag(addToBag, scope._addToBagCallback);

                if (request.IsApplePay) {
                    HSN.DataLayer.helpers.metricEvent(null, 'RE:PDP', 'applepay');
                    HSN.Widget.ApplePay().setupApplePaySession(scope.getProductPrice());
                }
            }
        }
        return false;
    });

    //Fit Guide Modal trigger
    this._container.on('click', '.fit-guide-link', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var webpId = $('#webp_id', scope._container).val();
        var defaultPage = $(this).data('default-page');
        var ajaxData = { 'webpId': webpId, 'defaultPage': defaultPage };

        if (defaultPage === "sizeRec") {
            // open modal window for Edit Measurements...
            if (webpId !== undefined) {
                var fitGuideModal = scope._application.GetFitGuideModal();
                fitGuideModal.elementToFocusOnClose = $(this);
                fitGuideModal.Show('/fitguide/get-fit-guide', ajaxData);
            }
            HSN.DataLayer.helpers.realEstate(null, "ProductPage-_-SizeAdvice-_-Add-Measurements");
        } else {
            // navigate to Size & Fit section and open Size Chart tab...
            // ReSharper disable once UnexpectedValue
            var tabHeader = $('h2:contains(Size & Fit)');
            if (tabHeader.length != 0) {
                var tabContent = tabHeader.parents().eq(1).find('.info');

                tabHeader.next().removeClass('plus').addClass('minus');
                $('html, body').animate({
                    scrollTop: tabHeader.offset().top - 69
                }, 500);
                tabContent.show();
                $('[target=hsn-size-content]').click().focus();

                HSN.DataLayer.helpers.realEstate(null, "ProductPage-_-SizeAdvice-_-View-Size-Chart");
            }
        }
    });

    this._container.on('click', ".autoship-modal", function (e) {
        e.stopPropagation();
        e.preventDefault();

        var articleSlug = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("articleSlug");
        var articleId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("articleId");
        var webpId = $('#webp_id', scope._container).val();

        if (isNaN(articleId)) return; //continue

        if (!articleSlug) articleId = 'default-article-slug';

        HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId + "?webpid=" + webpId);
    });

    this._container.on('change', '.template-product-detail-quantity', function () {
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('change', '#payment-options', function () {
        cmCreateManualLinkClickTag('/product-flexpay?cm_sp=ProductPage-_-Flexpay-_-Dropdown&cm_re=ProductPage-_-FlexPay-_-Dropdown', 'ProductDetail');
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('click', '.add-hpp-button', function () {
        var storedWarrantySelection = $('#selected-warranty', scope._container);
        var currentSelection = $(this);

        //update selected warranty
        storedWarrantySelection.val(currentSelection.data('warrantyWebpid'));
        storedWarrantySelection.data('warrantyPrice', currentSelection.data('warrantyPrice'));
        storedWarrantySelection.data('warrantyName', currentSelection.data('warrantyName'));

        //update button status
        currentSelection.removeClass('add-hpp-button');
        currentSelection.addClass('remove-hpp-button');
        currentSelection.val('REMOVE');

        //hide other warranty options
        $('.add-hpp-button').parents('.warranty-row').hide();

        //send apple pay event
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('click', '.remove-hpp-button', function () {
        var storedWarrantySelection = $('#selected-warranty', scope._container);
        var currentSelection = $(this);

        //clear selected warranty
        storedWarrantySelection.val('');
        storedWarrantySelection.removeData();

        //update button status
        currentSelection.removeClass('remove-hpp-button');
        currentSelection.addClass('add-hpp-button');
        currentSelection.val('ADD');

        //make all options visible
        $('.add-hpp-button').parents('.warranty-row').show();

        //send apple pay event
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    //Validator for autoship frequency
    this._container.on('blur', '.frequency', function () {
        var txt = $('.frequency');
        var amt = txt.val();

        var freq = txt.data('frequency');
        if (freq === undefined) {
            freq = 30;
        }

        if (!scope._application.IsAutoshipFrequencyValid({ frequency: amt })) {
            txt.val(freq);
        }
    });

    scope.LoadFitGuide();

    this.HandleObjectIdResponse = function (objectIdResponse, singleRequest) {
        singleRequest.WebId = objectIdResponse.value;

        if (objectIdResponse.errorList) {
            $.each(objectIdResponse.errorList, function (index, error) {
                singleRequest.Errors.push(error);
            });
        }

        return singleRequest;
    };
    this.GetVariantId = function (productCardScope, objectId) {
        var hasMatrix = $('.product-option-selector .matrix-options', productCardScope).length;

        if (scope._variants === null && hasMatrix) {
            var hasMatrixErrorMessage = $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', productCardScope).length;
            if (!hasMatrixErrorMessage) {
                var labelTxt = $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer")', productCardScope).html().toLowerCase();
                labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer")', productCardScope).append('<span class="matrix-selection-error">Please ' + labelTxt + ' first.</span>');
            }

            return { value: objectId, errorList: ['Please select option first'] };
        }

        if (scope._variants !== null && scope._variants.length > 0) {
            var allErrors = [];
            var inputLabels = $('label.required-selection', productCardScope);
            var arr = [];

            $.each(inputLabels, function () {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', productCardScope);
                if (checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if (labelText.length) {
                        allErrors.push('Please select a ' + labelText);
                        inputLabel.addClass('inline-error');
                    }
                } else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });

            //Item Sold out
            var variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                allErrors.push('Selection Not Available');
            }
            if (variant && variant.Callout && variant.Callout.Name === 'SoldOut') {
                allErrors.push('Item Sold Out');
            }

            var allErrorsLength = allErrors.length;
            if (allErrorsLength > 0) {
                var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

                for (var i = 0; i < allErrorsLength; i++) {
                    if (allErrors[i] !== null) {
                        $errors.find('ul').append('<li>' + allErrors[i] + '</li>');
                    }
                }

                var button = $('.add-to-bag-proxy', productCardScope);
                var oldError = $('div.errors-pd', productCardScope);
                oldError.remove();
                button.after($errors);
                var errorLeft = button.position().left + (button.outerWidth() - $errors.outerWidth()) / 2;
                $errors.css({
                    "top": parseInt('-' + ($errors.height() + 6)),
                    "left": errorLeft
                });

                $errors.focus();
                $('.product-modal-option-status', productCardScope).last().text('');

                return { value: objectId, errorList: allErrors };
            }

            $.each(scope._variants, function (k, v) {
                if ($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value: objectId };
    };
    this.GetDeferredPay = function (productCardScope) {
        return $('#payment-options option:selected', productCardScope).hasClass('vip-payment');
    };
    this.GetExtraFlex = function (productCardScope) {
        var extraFlex = null;
        if ($('#payment-options option:selected', productCardScope).data('extra-flex') !== undefined) {
            extraFlex = $('#payment-options option:selected', productCardScope).data('extra-flex');
        }

        return extraFlex;
    };
    this.GetExtraFlexV2 = function (productCardScope) {
        var extraFlex = null;
        if ($('#payment-options option:selected', productCardScope).data('extra-flex') !== undefined) {
            var optionSelected = parseInt($('#payment-options option:selected', productCardScope).val());
            var totalFlexAvailable = $('#payment-options option:not(.extra-flex-payment, .vip-payment, .option-group)').length;
            var numberOfExtraFlex = optionSelected - totalFlexAvailable < 0 ? 0 : optionSelected - totalFlexAvailable;

            extraFlex = numberOfExtraFlex;
        }

        return extraFlex;
    };
    this.GetExtraFlexPromo = function (productCardScope) {
        var extraFlexPromo = null;
        if ($('#payment-options', productCardScope).data('extra-flex-promo') !== null) {
            extraFlexPromo = $('#payment-options', productCardScope).data('extra-flex-promo');
        }

        var deferredPay = scope.GetDeferredPay(productCardScope);
        if (deferredPay) {
            extraFlexPromo = $('.vip-payment', productCardScope).data('deferred-promo');
        }

        return extraFlexPromo;
    };
    this.GetExpressBuy = function (buttonObj) {
        var expressBuy = 0;
        if (buttonObj.hasClass('express-buy') || buttonObj.hasClass('apple-pay-button')) {
            expressBuy = 1;
        }

        return expressBuy;
    };
    this.GetApplePay = function (buttonObj) {
        var isApplePay = false;
        if (buttonObj.hasClass('apple-pay-button')) {
            isApplePay = true;
        }
        return isApplePay;
    };
    this.GetSelectedQuantity = function (productCardScope) {
        return $('.template-product-detail-quantity, .quantity-selector .qs-quantity', productCardScope).eq(0).val();
    };
    this.GetFlexpay = function (productCardScope) {
        var flexpay = null;
        if ($('.flex-payment', productCardScope).length > 0) {
            if ($('#payment-options option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            } else if ($('#payment-options option:selected', productCardScope).hasClass('flex-payment')) {
                flexpay = $('#payment-options', productCardScope).val();
            }
        }

        return flexpay;
    };

    this.GetFlexpayV2 = function (productCardScope) {
        var flexpay = 1;
        if ($('.flex-payment', productCardScope).length > 0) {
            if ($('#payment-options option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            } else if ($('#payment-options option:selected', productCardScope).hasClass('flex-payment')) {
                var optionSelected = parseInt($('#payment-options option:selected', productCardScope).val());
                var totalFlexAvailable = $('#payment-options option:not(.extra-flex-payment, .vip-payment, .option-group)').length;
                var numberOfFlexPayments = optionSelected > totalFlexAvailable ? totalFlexAvailable : optionSelected;

                flexpay = numberOfFlexPayments;
            }
        }

        return flexpay;
    };

    this.GetStartDate = function (productCardScope, autoshipId) {
        var theDate = new Date($('.datepicker', productCardScope).val());

        //no idea why but the month is always coming back 1 less than it should.
        var startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();

        if (autoshipId !== null && startDate === 'NaN-NaN-NaN') {
            theDate = new Date();
            startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();
        }

        return startDate;
    };
    this.GetFrequency = function (productCardScope) {
        var frequency = parseInt($('#autoship-frequency-options option:selected', productCardScope).val());

        return frequency;
    };
    this.GetAutoshipId = function (productCardScope) {
        var autoshipId = null;
        if ($('.autoship', productCardScope).length > 0) {
            autoshipId = $('.autoship', productCardScope).data('program-id');
        }

        return autoshipId;
    };
    this.GetAutoshipProgramType = function (productCardScope) {
        var autoshipPgmType = null;
        if ($('.autoship', productCardScope).length > 0) {
            autoshipPgmType = $('.autoship', productCardScope).data('program-type');
        }

        return autoshipPgmType;
    };
    this.GetSizeRecommendationTracking = function (productCardScope) {
        //Size Recommendation tracking on basket add
        var recommendedSize = $('.edit-size-measurements #FitGuideRecommendationId', productCardScope).val();
        var sizeIsAvailable = $('.edit-size-measurements #IsAvailable', productCardScope).val();

        var sizeRecommendationTracking = '';
        if (recommendedSize !== undefined && sizeIsAvailable !== undefined) {
            sizeRecommendationTracking = '1|' + $.trim(recommendedSize) + ',2|' + $.trim(sizeIsAvailable);
        }

        return sizeRecommendationTracking;
    };

    this.GetWarrantyWebPId = function (productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.val() : null;
    };
    this.GetWarrantyPrice = function (productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyPrice') : null;
    };
    this.GetWarrantyName = function (productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyName') : null;
    };
    this.getWarrantySelected = function (warrSelectedScope) {
        var selectedWarranty = $('#selected-warranty', warrSelectedScope);

        return selectedWarranty.length > 0 && typeof selectedWarranty.val() !== 'undefined' && selectedWarranty.val().length > 0;
    };
    this.getWarrantyDetails = function (warrDetailsScope) {
        return $('#selected-warranty', warrDetailsScope);
    };
    this.getProductPrice = function () {
        if ($('span[itemprop="price"]', '.product-price').length > 0) {
            return $('span[itemprop="price"]', '.product-price').attr('content');
        } else {
            return '.01';
        }
    };

    this.canDoApplePay = function () {
        if (!HSN.Widget.ApplePay) {
            return false;
        }
        var isValidQuantity, isValidPaymentOption, isValidWarranty, isValidProductStatus;
        //get quantity value
        var quantity = scope.GetSelectedQuantity(scope._container);
        if (quantity > 1) {
            isValidQuantity = false;
        } else {
            isValidQuantity = true;
        }
        //get flexpay value
        var paymentSelect = $('#payment-options');
        var flexNumber = paymentSelect.val();
        if (flexNumber > 1 || $('option:selected', paymentSelect).attr('class') === 'vip-payment') {
            isValidPaymentOption = false;
        } else {
            isValidPaymentOption = true;
        }
        //get warranty value
        var selectedWarranty = $('#selected-warranty', scope._container);
        if (selectedWarranty.val() && selectedWarranty.val().length > 0) {
            isValidWarranty = false;
        } else {
            isValidWarranty = true;
        }
        //get extended del/waitlist value
        var text = $('.product-modal-option-status', scope._container).last().text();
        if (text === 'On Waitlist' || text === 'Extended Delivery') {
            isValidProductStatus = false;
        } else {
            isValidProductStatus = true;
        }

        return isValidQuantity && isValidPaymentOption && isValidWarranty && isValidProductStatus;
    };
};

HSN.BuySelector.prototype = {
    LoadFitGuide: function LoadFitGuide() {
        var scope = this;

        var hasFitGuide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#has_fit_guide', scope._container).val();
        if (!hasFitGuide) {
            //only try to retrieve fit guide widget if product has one
            return;
        }

        var webpId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#webp_id', scope._container).val();
        if (!webpId) {
            return;
        }

        var isSoldOut = $('#is_sold_out', scope._container).val() ? true : false;

        $.ajax('/fitguide/get-fit-guide-widget', {
            dataType: 'html',
            data: { webpId: webpId, enableFitGuide: !isSoldOut },
            success: function success(data) {
                if ($('.edit-size-measurements', scope._container).length > 0) {
                    $('.edit-size-measurements', scope._container).html(data);
                    scope._application.Events.Trigger(HSN.BuySelector.EVENT.FITGUIDE_READY);
                }
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to calculate your measurement, please try again.');
            }
        });
    },
    GetRequestObject: function GetRequestObject(buttonScope, objectId) {
        var scope = this;

        var singleRequest = {
            Errors: new Array()
        };

        singleRequest.ObjectId = objectId;
        singleRequest = scope.HandleObjectIdResponse(scope.GetVariantId(scope._container, singleRequest.ObjectId), singleRequest);
        singleRequest.DeferredFinancing = scope.GetDeferredPay(scope._container);
        singleRequest.ExtraFlex = scope.GetExtraFlex(scope._container);
        singleRequest.ExtraFlexV2 = scope.GetExtraFlexV2(scope._container);
        singleRequest.ExtraFlexPromo = scope.GetExtraFlexPromo(scope._container);
        singleRequest.ExpressBuy = scope.GetExpressBuy(buttonScope);
        singleRequest.IsApplePay = scope.GetApplePay(buttonScope);
        singleRequest.Quantity = scope.GetSelectedQuantity(scope._container);
        singleRequest.FlexPay = scope.GetFlexpay(scope._container);
        singleRequest.FlexPayV2 = scope.GetFlexpayV2(scope._container);
        singleRequest.ProgramId = scope.GetAutoshipId(scope._container);
        singleRequest.ProgramCode = scope.GetAutoshipProgramType(scope._container);
        singleRequest.StartDate = scope.GetStartDate(scope._container, singleRequest.ProgramId);
        singleRequest.Frequency = scope.GetFrequency(scope._container);
        singleRequest.SizeRecommendationTracking = scope.GetSizeRecommendationTracking(scope._container);
        singleRequest.WarrantyWebPId = scope.GetWarrantyWebPId(scope._container);
        singleRequest.WarrantyName = scope.GetWarrantyName(scope._container);
        singleRequest.WarrantyAmount = scope.GetWarrantyPrice(scope._container);

        return singleRequest;
    },
    ClearErrors: function ClearErrors() {
        var scope = this;
        scope._allErrors = [];

        $('label[class*="inline-error"]').removeClass('inline-error');
        $('div[class*="errors"]').remove();
        $('input[class*="has-error"]').removeClass('has-error');
        $('input[class*="inline-error"], select[class*="inline-error"]').removeClass('inline-error');
    }
    /**
    * HSN.BuySelector.EVENT = Object
    * *
    * * An enumeration of events an [HSN.BuySelector]] can raise:
    * * * - FITGUIDE_MEASUREMENT_SUCCESS: Fires when an fitguide finds valid size variant for measurements given
    * **/
};HSN.BuySelector.EVENT = {
    FITGUIDE_MEASUREMENT_SUCCESS: 'HSN.BuySelector:FITGUIDE_MEASUREMENT_SUCCESS',
    FITGUIDE_READY: 'HSN.BuySelector:FITGUIDE_READY'
};

/***/ }),

/***/ "O/yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddEditPayment_js__ = __webpack_require__("b2Ol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentList_js__ = __webpack_require__("RlAA");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






/**
    * class HSN.Widget.PaymentManagement
    *
    * Encapsulates the common functionality of the PaymentManagement Widget.
    **/
HSN.Widget.PaymentManagement = function () {
    var application;
    var container;
    var paymentService;
    var deviceInformation;
    var eventIdentity;
    var showSelectButton;
    var showDefaultCardChecked;
    var showMakeDefault;
    var hideSaveCard;
    var showAddPaypal;
    /**
        * new HSN.Widget.PaymentManagement.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.PaymentManagement]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        paymentService = application._getPaymentService();
        deviceInformation = application.DeviceInformation;
        showSelectButton = config.showSelectButton;
        showDefaultCardChecked = config.showDefaultCardChecked;
        showMakeDefault = config.showMakeDefault;
        hideSaveCard = config.hideSaveCard || false;
        showAddPaypal = config.showAddPaypal;
        eventIdentity = config.eventIdentity;
        ClearChildEventHandlers();
        bindEvents();
    }

    function bindEvents() {
        application.Events.On(HSN.Widget.PaymentList.EVENT.ADD_SELECTED, function () {
            SetContainerWait();
            paymentService.GetAddPaymentForm({ hideSaveCard: hideSaveCard }, {
                callback: function callback(data) {
                    SetPaymentContainerContent(data, false);
                    if (deviceInformation.IsMobile) {
                        ScrollToTop();
                    }
                },
                errorCallback: function errorCallback() {
                    alert('Unfortunately there was an error attempting to add your payment method, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, function (paymentIdentity) {
            SetContainerWait();
            paymentService.GetEditPaymentForm(paymentIdentity, {}, {
                callback: function callback(data) {
                    SetPaymentContainerContent(data, true);
                    if (deviceInformation.IsMobile) {
                        ScrollToTop();
                    }
                },
                errorCallback: function errorCallback() {
                    alert('Unfortunately there was an error attempting to edit your payment method, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, function (identity, isNoMoreCards) {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.REMOVE_SUCCESS, identity, isNoMoreCards);
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.SELECTED, function (paymentIdentity, eventIdentity) {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.SELECTED, paymentIdentity, eventIdentity);
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.DEFAULT_CHANGED, function () {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.DEFAULT_CHANGED);
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.CANCELED, function (isEdit) {
            SetContainerWait();
            paymentService.GetPaymentList({ showSelect: showSelectButton, showDefaultCardChecked: showDefaultCardChecked, showMakeDefault: showMakeDefault, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
                callback: function callback(data) {
                    SetPaymentContainerContent(data, isEdit);
                },
                errorCallback: function errorCallback() {
                    alert('Unfortunately there was an error attempting get the content, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, function (respData) {
            SetContainerWait();
            paymentService.GetPaymentList({ showSelect: showSelectButton, showDefaultCardChecked: showDefaultCardChecked, showMakeDefault: showMakeDefault, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
                callback: function callback(data) {
                    SetPaymentContainerContent(data);
                    if (respData.isAdd) {
                        application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, respData);
                    } else if (respData.isMakeDefault) {
                        application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.DEFAULT_CHANGED);
                    }
                },
                errorCallback: function errorCallback() {
                    alert('Unfortunately there was an error attempting get the content, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, function () {});

        application.Events.On(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED, function () {});
    }
    function SetContainerWait() {
        $('.payment-management-widget-container').html('');
        HSN.SetContainerWait('.payment-management-widget-container');
    }
    function SetPaymentContainerContent(content) {
        $('.payment-management-widget-container').html(content).find('[tabindex=0]').first().focus();
        HSN.RemoveContainerWait();
    }
    function ScrollToTop() {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    }
    function ClearChildEventHandlers() {
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.CANCELED, null, this);
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, null, this);
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, null, this);

        application.Events.Off(HSN.Widget.PaymentList.EVENT.ADD_SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, null, this);
    }
    function Destroy() {
        application = container = paymentService = deviceInformation = null;
    }
    return {
        init: init,
        Destroy: Destroy
    };
};

HSN.Widget.PaymentManagement.EVENT = {
    CANCELLED: 'HSN.Widget.PaymentManagement:CANCELLED',
    SELECTED: 'HSN.Widget.PaymentManagement:SELECTED',
    DEFAULT_CHANGED: 'HSN.Widget.PaymentManagement:DEFAULT_CHANGED',
    ADD_NEW_PAYMENT_COMPLETE: 'HSN.Widget.PaymentManagement:ADD_NEW_PAYMENT_COMPLETE',
    REMOVE_SUCCESS: 'HSN.Widget.PaymentManagement:REMOVE_SUCCESS'
};

/***/ }),

/***/ "O2fp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.CommerceService = function () {};
HSN.Service.CommerceService.prototype = {
    AddToBag: function AddToBag(data, config) {
        this._send('/bag/add-to-bag', data, config);
    },
    RemoveBagItem: function RemoveBagItem(data, config) {
        this._send('/checkout/bag-actions/remove-bag-item', data, config);
    },
    RemoveWarrantyFromBagItem: function RemoveWarrantyFromBagItem(data, config) {
        this._send('/checkout/bag-actions/remove-warranty', data, config);
    },
    AddWarrantyToBagItem: function AddWarrantyToBagItem(data, config) {
        this._send('/checkout/bag-actions/add-warranty', data, config);
    },
    SaveItemForLater: function SaveItemForLater(data, config) {
        this._send('/checkout/bag-actions/save-item-for-later', data, config);
    },
    MoveItemToBag: function MoveItemToBag(data, config) {
        this._send('/checkout/bag-actions/move-item-to-bag', data, config);
    },
    ChangeItemSingleShipToAutoShip: function ChangeItemSingleShipToAutoShip(data, config) {
        this._send('/checkout/bag-actions/change-item-to-autoship', data, config);
    },
    ChangeItemAutoShipToSingleShip: function ChangeItemAutoShipToSingleShip(data, config) {
        this._send('/checkout/bag-actions/change-item-to-singleship', data, config);
    },
    GetBagFlyout: function GetBagFlyout(config) {
        this._ajaxGet('/bag-flyout', {}, config);
    },
    RemoveGiftOptions: function RemoveGiftOptions(data, config) {
        this._send('/checkout/bag-actions/remove-gift-options', data, config);
    },
    SaveGiftOptions: function SaveGiftOptions(data, config) {
        this._send('/checkout/bag-actions/save-gift-options', data, config);
    },
    UpdatePaymentInfo: function UpdatePaymentInfo(data, config) {
        this._send('/checkout/bag-actions/update-payment-info', data, config);
    },
    RemoveVipFinancing: function RemoveVipFinancing(data, config) {
        this._send('/checkout/bag-actions/remove-vip-financing', data, config);
    },
    UpdateShipping: function UpdateShipping(data, config) {
        this._send('/checkout/bag-actions/update-shipping', data, config);
    },
    UpdateQuantity: function UpdateQuantity(data, config) {
        this._send('/checkout/bag-actions/update-quantity', data, config);
    },
    UpdateVariant: function UpdateVariant(data, config) {
        this._send('/checkout/bag-actions/update-variant', data, config);
    },
    ApplyDiscount: function ApplyDiscount(code, config) {
        this._send('/checkout/bag-actions/apply-discount', { discountCode: code }, config);
    },
    RemoveDiscount: function RemoveDiscount(data, config) {
        this._send('/checkout/bag-actions/remove-discount', data, config);
    },
    ApplyKash: function ApplyKash(config) {
        this._send('/checkout/bag-actions/apply-kash', {}, config);
    },
    AddCharityItem: function AddCharityItem(webpid, config) {
        this._send('/checkout/bag-actions/add-charity', { 'webpid': webpid }, config);
    },
    ProcessOrder: function ProcessOrder(data, config) {
        this._send('/checkout/process-order', data, config);
    },
    SelectAddress: function SelectAddress(data, config) {
        this._send('/checkout/select-address', data, config);
    },
    RemoveAddress: function RemoveAddress(data, config) {
        this._send('/checkout/remove-address', data, config);
    },
    ValidateAddress: function ValidateAddress(data, config) {
        this._send('/checkout/validate-address', data, config);
    },
    AddEditAddressSave: function AddEditAddressSave(data, config) {
        this._send('/checkout/add-edit-address-save', data, config);
    },
    PrescreenNoThanks: function PrescreenNoThanks(data, config) {
        this._send('/checkout/order-review/prescreen/no-thanks', data, config);
    },
    PrescreenCardOfferGet: function PrescreenCardOfferGet(data, config) {
        this._ajaxGet('/checkout/order-review/prescreen/card-offer', data, config);
    },
    SubmitAvsMatch: function SubmitAvsMatch(data, config) {
        this._send('/checkout/payment-confirmation/save', data, config);
    },
    UpdateLtlShippingPhoneNumber: function UpdateLtlShippingPhoneNumber(data, config) {
        this._send('/checkout/order-review/save-shipping-phone', data, config);
    },
    EstimateTax: function EstimateTax(zipCode, config) {
        this._send('/checkout/bag-actions/estimate-tax', { zipCode: zipCode }, config);
    },
    ResubmitOrder: function ResubmitOrder(data, config) {
        this._send('/checkout/payment/resubmit', data, config);
    },
    ResubmitBillingAddress: function ResubmitBillingAddress(data, config) {
        this._send('/checkout/billing-address/resubmit', data, config);
    },
    ResubmitFlexOrder: function ResubmitFlexOrder(data, config) {
        this._send('/checkout/flex-error/resubmit', data, config);
    },
    ResubmitCardVerification: function ResubmitCardVerification(data, config) {
        this._send('/checkout/card-verification-retry/resubmit', data, config);
    },
    GetEditPaymentMethodForm: function GetEditPaymentMethodForm(paymentIdentity, config) {
        this._ajaxGet('/checkout/add-edit-payment', { paymentIdentity: paymentIdentity, partialOnly: true }, config);
    },
    GetAddPaymentMethodForm: function GetAddPaymentMethodForm(data, config) {
        this._ajaxGet('/checkout/add-edit-payment', data, config);
    },
    CreateAccount: function CreateAccount(data, config) {
        this._send('/account/create', data, config);
    },
    GetCityStateFromZip: function GetCityStateFromZip(data, config) {
        this._send('/account/city-state-from-zip', data, config);
    },
    ConvertGuest: function ConvertGuest(data, config) {
        this._send('/checkout/convert-guest-account', data, config);
    },
    SetCardVerificationTransactionId: function SetCardVerificationTransactionId(cardVerificationTransactionId, config) {
        this._send('/checkout/card-verification', { cardVerificationTransactionId: cardVerificationTransactionId }, config);
    },
    GetMoreOrderStatusOrders: function GetMoreOrderStatusOrders(data, config) {
        this._ajaxGet('/myaccount/order-status/get-more-orders', data, config);
    },
    UpdateBagPaymentProvider: function UpdateBagPaymentProvider(data, config) {
        this._send('/checkout/bag-actions/update-payment-provider', data, config);
    },
    CreateEGiftOrder: function CreateEGiftOrder(data, config) {
        this._send('/products/egiftcard/save/', data, config);
    },
    ApplePayBagGet: function ApplePayBagGet(data, config) {
        config.dataType = 'json';
        this._ajaxGet('/api/applepay-bag', data, config);
    },
    ApplePayValidate: function ApplePayValidate(data, config) {
        this._send('/api/applepay-validate', data, config);
    },
    ApplePayChangeShipping: function ApplePayChangeShipping(data, config) {
        this._send('/api/applepay-change-shipping', data, config);
    },
    ApplePayComplete: function ApplePayComplete(data, config) {
        this._send('/api/applepay-complete', data, config);
    },
    CancelOrderItem: function CancelOrderItem(data, config) {
        this._send('/checkout/order-actions/cancel-order-line', data, config);
    },
    RequestSigninCode: function RequestSigninCode(data, config) {
        this._send('/signin/request-code', data, config);
    },
    CheckProductReviewable: function CheckProductReviewable(data, config) {
        config.dataType = 'json';
        this._ajaxGet('/products/check-reviewable/' + data.productIdentity, data, config);
    },

    _send: function _send(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error() {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _ajaxGet: function _ajaxGet(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: config.dataType || 'html',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    },

    _get: function _get(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf('=') === -1 ? '' : '&';
            data += joiner + '_ts=' + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'json',
            beforeSend: function beforeSend(xhr) {
                xhr.setRequestHeader('X-Requested-With', { toString: function toString() {
                        return '';
                    } });
            },
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    }
};

/***/ }),

/***/ "Oq/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CardVerificationModal
**/
HSN.CardVerificationModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CardVerificationModal, parent);

    function CardVerificationModal() {
        var modal = CardVerificationModal.__super__.constructor.call(this, 'card-verification-modal');

        this.commerceService = HSN.Instance()._getCommerceService();
        this.paymentService = HSN.Instance()._getPaymentService();
        this.isTokenizerOk = false;
        this.name = 'HSN.CardVerificationModal';

        this.Close.off();
        eventHandlers(this);
        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Content).on('click', '#continue', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification?cm_sp=CVV-_-Continue-_-NA&cm_re=CVV-_-Continue-_-NA', '');
            HSN.Instance().ccTokenizerSocket.tokenize(function (response) {
                modal.isTokenizerOk = true;
                if (response.error) {
                    var responseError = {
                        'errorFields': [{ 'Key': 'CardNumber', 'Value': response.error.faultDetail }],
                        'errors': [response.error.faultDetail],
                        'success': false
                    };
                    HSN.AddErrorTreatment('#cardVerificationForm', responseError, modal.Content);
                } else {
                    $('#cardVerificationTransactionId').val(response.data.transactionID);
                    modal.commerceService.SetCardVerificationTransactionId(response.data.transactionID, {
                        callback: function callback(data) {
                            if (data.success) {
                                modal.Hide();
                                var sessionIdentity = '';
                                if ($('#order-session-id').length > 0) {
                                    sessionIdentity = $('#order-session-id').val();
                                }
                                HSN.SetWait();
                                modal.commerceService.ProcessOrder({ debitAuthorized: true, debitAuthorizationRequired: true, sessionIdentity: sessionIdentity, isDeferredContinue: true, isTilaProcess: modal.config.isTilaProcess }, {
                                    callback: function callback(data) {
                                        if (data.success) {
                                            if (data.isBagGiveawayWinner) {
                                                HSN.RemoveWait();
                                                var winnerModal = HSN.Instance().GetGenericConfirmModal();
                                                winnerModal.SetInputData({});
                                                winnerModal.SetOkCallback(function () {
                                                    window.location = data.NextUrl;
                                                });
                                                winnerModal.SetCloseClickCallback(function () {
                                                    window.location = data.NextUrl;
                                                });
                                                winnerModal.Show("/checkout/bag-giveaway-winner");
                                            } else {
                                                window.location = data.NextUrl;
                                            }
                                        } else {
                                            if (data.RequiresCardVerificationRetry) {
                                                HSN.RemoveWait();
                                                HSN.Instance().GetCardVerificationRetryModal().Show(true, modal.cvvUrl, data.OrderNumber);
                                            } else if (data.NextUrl) {
                                                window.location = data.NextUrl;
                                            } else {
                                                HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was a problem submitting your order, please try again.');
                                            }
                                        }
                                    },
                                    scope: this
                                });
                            } else {
                                HSN.AddErrorTreatment('#cardVerificationForm', 'Unfortunately there was an error verifying your security code, please try again.', modal.Content);
                            }
                        }
                    });
                }
                return false;
            });
        });

        $(modal.Content).on('click', '#cancel', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification?cm_sp=CVV-_-Cancel-_-NA&cm_re=CVV-_-Cancel-_-NA', '');
            modal.Hide();
            return false;
        });
    }

    CardVerificationModal.prototype._show = function (tokenizationUrl, config) {
        var scope = this;
        scope.AddLoadingSpinner();

        scope.cvvUrl = tokenizationUrl;
        scope.config = config = config || {};

        var easyXdmPromise = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "qS3Q"));

        var ajax = $.ajax('/checkout/card-verification', {
            context: this,
            dataType: 'html'
        });

        Promise.all([ajax, easyXdmPromise]).then(function (_ref) {
            var content = _ref[0],
                EasyXDMLoaded = _ref[1];

            scope.RemoveLoadingSpinner();
            cmCreateManualLinkClickTag('/checkout/card-verification?cm_sp=CVV-_-Modal-_-NA&cm_re=CVV-_-Modal-_-NA', '');
            scope.Content.showHtml(content, 0, function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
                scope.Root.find('#closeModal').remove();
            }, function () {});

            HSN.Instance().ccTokenizerSocket = new easyXDM.Rpc({
                remote: tokenizationUrl,
                props: {
                    id: 'card-verification-frame',
                    frameborder: 0,
                    scrolling: 'no',
                    style: {
                        overflow: 'hidden',
                        width: '200px',
                        height: '62px',
                        allowTransparency: 'true',
                        margin: '5px auto'
                    }
                },
                container: $('#card-verification-container')[0]
            }, {
                remote: {
                    tokenize: {},
                    clearTextBox: {},
                    status: {}
                }
            });

            window.setTimeout(function () {
                HSN.Instance().ccTokenizerSocket.status(function () {
                    scope.isTokenizerOk = true;
                });
            }, 4800);
            window.setTimeout(function () {
                if (!scope.isTokenizerOk) {
                    scope.paymentService.LogTokenizerFailure({ Type: 'CVV' }, {});
                }
            }, 5000);
        }).catch(function () {
            alert('Unfortunately there was an error attempting to load the content, please try again.');
            scope.RemoveLoadingSpinner();
            scope.Hide();
        });
    };
    return CardVerificationModal;
}(HSN.Modal);

/***/ }),

/***/ "P8Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__ = __webpack_require__("vued");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_mailcheck_js__ = __webpack_require__("cV/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_mailcheck_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_mailcheck_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Application_js__ = __webpack_require__("Pd1c");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





// defines Events and Instance functions


/**
* HSN
* The HSN namespace exists to contain all HSN-specific variables, objects,
* classes, functions and constants to prevent conflicts with other libraries
* that may be loaded.
**/
// ReSharper disable once InconsistentNaming
var HSN = window.HSN || {};

HSN.Language = HSN.Language || {};

var pageMask = '<div id="wait-mask" class="wait-mask"></div>';
var pageWait = '<div id="wait-mask" class="wait-mask"><div class="spinner-positioner"><div class="spinner-container"><div id="floatingCircles64"><div class="f_circle64" id="frotate64_01"></div><div class="f_circle64" id="frotate64_02"></div><div class="f_circle64" id="frotate64_03"></div><div class="f_circle64" id="frotate64_04"></div><div class="f_circle64" id="frotate64_05"></div><div class="f_circle64" id="frotate64_06"></div><div class="f_circle64" id="frotate64_07"></div><div class="f_circle64" id="frotate64_08"></div></div></div></div></div>';
var containerWait = '<div id="container-wait" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div>';

/**
    * HSN.Instance() -> HSN.Application | null
    * HSN.Instance(newInstance) -> HSN.Application
    * - newInstance (HSN.Application): The new HSN.Application instance to make available.
    *
    * Exposes a static singleton method that will return the current instance of
    * the [[HSN.Application]] that represents the page. Additionally if given an
    * argument it will replace the current instance with a new one. While this
    * is not an exact implementation of the Singleton Pattern, it is good enough
    * for use in Javascript.
    **/
/*
Usage:
    HSN.Instance(new HSN.Application(...));
    var hsnApplicationInstance = HSN.Instance();
*/
HSN.Instance = function (newInstance) {
    if (null != newInstance) HSN._instance = newInstance;
    return HSN._instance;
};

/**
    * HSN.ProxyButton(element[, cssClass]) -> null
    * - element (HTMLElement): The element that should be replaced with a stylized button.
    * - cssClass (String): The optional css class to add to the replacement button.
    *
    * Hides the element provided, such as an input button and replaces it with
    * another that proxies click events allowing for form submissions while providing more
    * robust styling opportunities.
    **/
HSN.ProxyButton = function (button, cssClass) {
    var isPreOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    button = $(button);
    if (button.data('HSN.ProxyButton.Processed')) return false;

    button.css({
        'position': 'absolute',
        'left': '-9999px'
    });
    var proxy = $('<span class="proxy-button">' + button.attr('value') + '</span>').on('click', function () {
        button.click();
    });
    if (isPreOrder) {
        proxy = $('<span class="proxy-button"><span class="topLine">PRE-ORDER NOW</span><span class="bottomLine">' + button.attr('value') + '</span></span>').on('click', function () {
            button.click();
        });
    }
    if (button.attr('id')) {
        proxy.attr('id', button.attr('id') + '-proxy');
    }
    if (cssClass) {
        proxy.addClass(cssClass);
    }
    if (button.attr('tabindex')) {
        proxy.attr('tabindex', button.attr('tabindex'));
    }
    if (button.data('tooltip')) {
        proxy.data('tooltip', button.data('tooltip'));
    }
    button.before(proxy);

    button.data('HSN.ProxyButton.Processed', true);

    return proxy;
};

//Import javascript dynamic module importer
//Only use for for places that don't have js es2015+ compiler, like cshtml views
HSN.DynamicImport = function (moduleName) {
    switch (moduleName) {
        case "Gap":
            var gapPromise = new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "IPPN"));
            return gapPromise.then(function (gap) {
                return gap.default;
            });
    }
    return Promise.reject();
};

HSN.AsyncLoad = function (url, callback, id) {
    var doc = document;
    if (id && doc.getElementById(id)) {
        return;
    }

    var tagName = 'script';
    var newScriptElement = doc.createElement(tagName);
    newScriptElement.async = true;
    newScriptElement.id = id;
    newScriptElement.src = url;

    if (callback) {
        if (newScriptElement.addEventListener) {
            newScriptElement.addEventListener('load', function () {
                callback();
            }, false);
        } else {
            newScriptElement.onreadystatechange = function () {
                // old IEs
                if (newScriptElement.readyState in { loaded: 1, complete: 1 }) {
                    newScriptElement.onreadystatechange = null;
                    callback();
                }
            };
        }
    }

    var firstScriptElement = doc.getElementsByTagName(tagName)[0];
    firstScriptElement.parentNode.insertBefore(newScriptElement, firstScriptElement);
};

// TODO: If calling the callback every time AsyncLoad is called is okay, then this function can be removed.
HSN.EnsureAsyncLoaded = function (url, callback, id) {
    if (id && document.getElementById(id)) {
        callback();
    } else {
        HSN.AsyncLoad(url, callback, id);
    }
};

/**
    * HSN.ValidateEmail(emailAddress) -> null
    * - emailAddress (String): The email address to validate.
    *
    * Returns true if valid, otherwise false.
    * 
    * regex's suck for this
    * https://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    **/
HSN.ValidateEmail = function (emailAddress) {
    var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return filter.test(emailAddress);
};

/**
    * HSN.Tooltip(element) -> null
    * - element (HTMLElement|jQuery|String): The element, jQuery object, or CSS Selector that should be given a tooltip.
    * - classname (String): Optional class name applied to the tooltip.
    *
    * Provides for a stylized tooltip display read from the data-tooltip
    * attribute of the provided element(s) when hovered.
    **/
HSN.Tooltip = function (element, classname) {
    if (!HSN.Tooltip.__flywheel) {
        HSN.Tooltip.__flywheel = $('<div class="tooltip" role="tooltip" id="tooltip" aria-hidden="true"><span class="text"></span><span class="arrow"></span></div>');
        if (classname) {
            HSN.Tooltip.__flywheel.addClass(classname);
        }
        HSN.Tooltip.__flywheel.on('mouseenter', function () {
            this.__dontClose = true;
        }).on('mouseleave', function () {
            this.__dontClose = false;
        });
        $('body').append(HSN.Tooltip.__flywheel);
    }

    var elements = $(element);
    elements.each(function () {
        if (Modernizr.touchevents && ($(this).hasClass('favorite') || $(this).hasClass('express-buy-proxy'))) {
            return true; //ignore touch tooltips for certain types
        }

        var configureToolTip = function configureToolTip(eventScope) {
            var trigger = $(eventScope);

            if ($(eventScope).data('tooltip') === "") return;

            var offset = trigger.offset().top;
            if ($(eventScope).parents('.lessman').length || $(eventScope).parents('.lessman-carousel-product-card').length || $(eventScope).parents('.lessman-torso').length) {
                offset = offset - 120;
            }

            /* Unfortunately since we have to use CSS3Pie for rounded-corners in IE7/8,
            * we must update the tooltip in advance of the timeout or the animation will
            * be jaring.
            */
            HSN.Tooltip.__flywheel.find('.text').html($(eventScope).data('tooltip'));
            HSN.Tooltip.__flywheel
            // Just in case we need to position the tooltip relative to the mouse position at some point in the future.
            //.css({'top': (e.pageY - HSN.Tooltip.__flywheel.outerHeight() - 20), 'left': (e.pageX - (HSN.Tooltip.__flywheel.outerWidth() / 2))})
            .css({
                'top': offset - HSN.Tooltip.__flywheel.outerHeight() - 5,
                'left': trigger.offset().left - HSN.Tooltip.__flywheel.outerWidth() / 2 + trigger.outerWidth() / 2
            })
            // We also have to do this to force CSS3Pie to re-position it's canvas element to match the new position of the actual element. :(
            .removeClass('tooltip').addClass('tooltip');
        };

        var onMouseEnter = function onMouseEnter() {
            var scope = this;

            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout) clearTimeout(timeout);

            configureToolTip(scope);

            HSN.Tooltip.__flywheel.data('timeout', setTimeout(function () {
                HSN.Tooltip.__flywheel.show();
                HSN.Tooltip.__flywheel.attr('aria-hidden', 'false');
            }, 500));
        };

        var onMouseLeave = function onMouseLeave() {
            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout) {
                clearTimeout(timeout);
            }

            HSN.Tooltip.__flywheel.data('timeout', setTimeout(function () {
                if (!HSN.Tooltip.__flywheel.__dontClose) {
                    HSN.Tooltip.__flywheel.hide();
                    HSN.Tooltip.__flywheel.attr('aria-hidden', 'true');
                }
            }, 250));
        };

        var onFocus = function onFocus() {
            var scope = this;

            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout) clearTimeout(timeout);

            configureToolTip(scope);

            HSN.Tooltip.__flywheel.data('timeout', setTimeout(function () {
                HSN.Tooltip.__flywheel.show();
                HSN.Tooltip.__flywheel.attr('aria-hidden', 'false');
            }, 500));
        };

        var offFocus = function offFocus() {
            var timeout = HSN.Tooltip.__flywheel.data('timeout');
            if (timeout) {
                clearTimeout(timeout);
            }

            HSN.Tooltip.__flywheel.data('timeout', setTimeout(function () {
                if (!HSN.Tooltip.__flywheel.__dontClose) {
                    HSN.Tooltip.__flywheel.hide();
                    HSN.Tooltip.__flywheel.attr('aria-hidden', 'true');
                }
            }, 250));
        };

        var showOnClickOrKey = function showOnClickOrKey(eventScope) {
            configureToolTip(eventScope);

            if (HSN.Tooltip.__flywheel.css('display') === 'none') {
                HSN.Tooltip.__flywheel.__dontClose = true;
                HSN.Tooltip.__flywheel.show();
            } else {
                HSN.Tooltip.__flywheel.__dontClose = false;
                HSN.Tooltip.__flywheel.fadeOut();
            }
        };

        $(this).on('mouseenter', onMouseEnter).on('mouseleave', onMouseLeave).on('focusin', onFocus).on('focusout', offFocus).on('click', function (e) {
            e.preventDefault();
            showOnClickOrKey(this);
        }).on('keyup', function (e) {
            e.preventDefault();

            if (e.keyCode === 13) {
                showOnClickOrKey(this);
            }
        });
        return true;
    });
};

/**
    * HSN.AnimateAccordion(container, toggleindex, config) -> null
    * - container (jQuery selector): The selector that should be animated.
    * - toggleindex (int): The number of the toggleContainer to be animated.
    * - showBottomDotted (bool): for tight accordions where a dotted-line class should be added at the bottom of the container.
    * - scrollToTop (bool): if you want the page to scroll to the top when animation is done.
    * - config (object): Contains two possible functions to be executed either during fadeIn or fadeOut.
    *
    * Provides for a nice animated accordion display
    **/
HSN.AnimateAccordion = function (container, toggleindex, showBottomDotted, scrollToTop, config) {
    config = config || {};
    var scrollOffset = config.scrollOffset || 0;
    $("." + container + "[toggleindex!='" + toggleindex + "']").each(function () {
        if (showBottomDotted) $(this).prev().addClass("bottom-dotted-lines");
        $(this).hide();
    });

    var toggleContainer = $("." + container + "[toggleindex='" + toggleindex + "']");
    var hasPeek = toggleContainer.hasClass('has-peek');
    var hadPeek = toggleContainer.hasClass('had-peek');

    if (toggleContainer.is(":visible") && !hasPeek) {
        if (config.beforeFadeOut) {
            config.beforeFadeOut();
        }
        toggleContainer.fadeOut({
            duration: 500,
            queue: false,
            complete: function complete() {
                var prevContainer = toggleContainer.prev();
                if (showBottomDotted) {
                    prevContainer.addClass("bottom-dotted-lines");
                }
                if (config.fadeOutCallback) {
                    config.fadeOutCallback();
                }
                if (hadPeek) {
                    toggleContainer.removeClass('had-peek');
                    toggleContainer.addClass('has-peek');
                }
            }
        }).slideUp(500);
    } else {
        if (config.beforeFadeIn) {
            config.beforeFadeIn();
        }
        toggleContainer.fadeIn({
            duration: 500,
            queue: false,
            complete: function complete() {
                var prevContainer = toggleContainer.prev();
                if (showBottomDotted) {
                    prevContainer.removeClass("bottom-dotted-lines");
                }
                if (config.fadeInCallback) {
                    config.fadeInCallback();
                }
                if (scrollToTop) $('html,body').animate({ scrollTop: toggleContainer.parent().offset().top - scrollOffset }, 'slow');
                if (hasPeek) {
                    toggleContainer.removeClass('has-peek');
                    toggleContainer.addClass('had-peek');
                }
            }
        }).css('display', 'none').slideDown(500);
    }
};

/**
    * HSN.AddErrortreatment(formSelector, data) -> null
    * - formSelector (jQuery selector): The selector of the form to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    *      - data.errorFields contains the Key matching the input page element with a value of the first error message associated to that key.
    *      - data.errors contains the flattened collection of all error messages for all keys.
    * Will add standardized error treatments to the top of a given form.
    **/
HSN.AddErrorTreatment = function (formSelector, data) {
    var $errors = $('<div class="errors" tabindex="-1"><div class="errors-top"><span tabindex="0"><b>OOPS.</b> Please fix the following:</span></div><ul></ul></div>');
    var form = $(formSelector);
    $('.errors', form.parent()).remove();
    $('.input-validation-error', formSelector).removeClass("input-validation-error");
    $('.field-validation-error', formSelector).removeClass("field-validation-error");

    var errorFieldsLength = data.errorFields.length;
    for (var i = 0; i < errorFieldsLength; i++) {
        if (data.errorFields[i].Value) {
            $errors.find('ul').append('<li>' + data.errorFields[i].Value + '</li>');
        }
        $('[name="' + data.errorFields[i].Key + '"]', formSelector).each(function (index, domEle) {
            $(domEle).addClass("input-validation-error");
        });
        $('label[for="' + data.errorFields[i].Key + '"]', formSelector).each(function (index, domEle) {
            $(domEle).addClass("field-validation-error");
        });
    }
    if (data.errorFieldIds) {
        var errorFieldIdsLength = data.errorFieldIds.length;
        for (var x = 0; x < errorFieldIdsLength; x++) {
            if (data.errorFieldIds[x].Value) {
                $errors.find('ul').append('<li>' + data.errorFieldIds[x].Value + '</li>');
            }
            $('#' + data.errorFieldIds[x].Key, formSelector).each(function (index, domEle) {
                $(domEle).addClass("input-validation-error");
            });
            $('label[for="' + data.errorFieldIds[x].Key + '"]', formSelector).each(function (index, domEle) {
                $(domEle).addClass("field-validation-error");
            });
        }
    }

    if (typeof data.errors != 'undefined') {
        $('li', $errors).remove();
        var errorsLength = data.errors.length;
        for (var j = 0; j < errorsLength; j++) {
            $errors.find('ul').append('<li><span tabindex="0">' + data.errors[j] + '</span></li>');
        }
    }

    $('div.errors', formSelector).remove();
    $(formSelector).before($errors);
    $errors.find('.errors-top *[tabindex=0]').first().focus();
};
HSN.ClearFormErrors = function (selector) {
    $('.errors', $(selector).parent()).remove();
    $('.input-validation-error', selector).removeClass("input-validation-error");
    $('.field-validation-error', selector).removeClass("field-validation-error");
};
/**
    * HSN.HandleCheckoutError(containerName, data, alertMessage) -> null
    * - containerName (jQuery selector): The selector of the container to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    * - alertMessage (string) : message to alert on.
    * This function is mainly called after an ajax functions data.success = false.
    There could be multiple scenarious why this happened.
    Data.signIn = true - customers session is not authenticated. Send to signin.
    Data.error has content - likely an API error, or some other misc error, put this into the containers error section.
    Data.alertError has content - We want to display an alert to the customer with this content.
    As a default, alert the alertMessage that was passed in.
    **/
HSN.CheckoutHandleError = function (containerName, data, alertMessage) {
    if (data.signIn) {
        if (data.signIn === 'modal') {
            HSN.Instance().GetSignInModal().Show(true, false);
        } else if (data.signIn === 'gap') {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
        } else {
            window.location = '/checkout/signin';
        }
        HSN.RemoveWait();
    } else {
        HSN.RemoveWait();
        if (data.error) {
            var errorContainer = $(containerName).find('.error-container')[0];
            $(errorContainer).html(data.error);
            $(errorContainer).toggle(true);
            HSN.ScrollToElement($(errorContainer));
        } else if (data.alertError) {
            alert(data.alertError);
        } else {
            alert(alertMessage);
        }
    }
};

/**
    * HSN.HandleAjaxError(containerName, data, alertMessage) -> null
    * - containerName (jQuery selector): The selector of the container to add error treatment to.
    * - data (object): Array of objects (ModelState error key/value pairs).
    * - alertMessage (string) : message to alert on.
    * This function is mainly called after an ajax functions data.success = false.
    There could be multiple scenarious why this happened.
    Data.signIn = true - customers session is not authenticated. Send to signin.
    Data.error has content - likely an API error, or some other misc error, put this into the containers error section.
    Data.alertError has content - We want to display an alert to the customer with this content.
    As a default, alert the alertMessage that was passed in.
    **/
HSN.HandleAjaxError = function (containerName, data, alertMessage) {
    if (data.signIn) {
        if (data.signIn === 'modal') {
            HSN.Instance().GetSignInModal().Show(true, false);
        } else if (data.signIn === 'gap') {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
        } else {
            window.location = '/signin';
        }
        HSN.RemoveWait();
    } else {
        HSN.RemoveWait();
        if (data.error) {
            var errorContainer = $(containerName).find('.error-container')[0];
            $(errorContainer).html(data.error);
            $(errorContainer).toggle(true);
            HSN.ScrollToElement($(errorContainer));
        } else if (data.alertError) {
            alert(data.alertError);
        } else {
            alert(alertMessage);
        }
    }
};

/**
    * HSN.FormatPhone(fieldSelector) -> null
    * - fieldSelector (jQuery selector): The selector of the field to add formatting to.
    *
    * Will add standardized phone formatting to a given field.
    **/
HSN.FormatPhone = function (fieldSelector) {

    function format() {
        var input = $(this);
        var digits = input.val().replace(/[^\d]/g, '');

        if (digits.length < 3) {
            return null;
        }
        var prefix;
        var rest;
        if (digits.length >= 3 && digits.length <= 6) {
            prefix = digits.substring(0, 3);
            rest = digits.substring(3, digits.length);
            return input.val(prefix + '-' + rest);
        }

        if (digits.length > 6 && digits.length <= 10) {
            var areaCode = digits.substring(0, 3);
            prefix = digits.substring(3, 6);
            rest = digits.substring(6, digits.length);
            return input.val('(' + areaCode + ')' + prefix + '-' + rest);
        }

        return null;
    }

    $.fn.formatsPhone = function () {
        this.on('keypress', format);
        this.on('blur', format);
        this.attr('maxlength', '13');
    };

    $(fieldSelector).formatsPhone();
};

/**
    * HSN.FormatCurrency =function(value, precision) -> null
    * - value (Number value): The value to convert to a currency string.
    * - precision (Number precision): How many decimal places.
    *
    * Will format a given javascript decimal to a currency string.
    **/
HSN.FormatCurrency = function (value, precision) {
    var re = '\\d(?=(\\d{' + 3 + '})+' + (precision > 0 ? '\\.' : '$') + ')';
    return '$' + value.toFixed(Math.max(0, ~~precision)).replace(new RegExp(re, 'g'), '$&,');
},

/**
* HSN.ShowProgressBar(fieldSelector) -> null
* - fieldSelector (jQuery selector): The selector of the input to check the email domain.
*
* Will show password strength progress bar.
**/
HSN.ShowProgressBar = function (fieldSelector) {
    $(document).on('keyup', fieldSelector, function () {
        // Must have capital letter, numbers and lowercase letters
        var strongRegex = new RegExp('^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$', 'g');

        // Must have either capitals and lowercase letters or lowercase and numbers
        var mediumRegex = new RegExp('^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$', 'g');

        if (strongRegex.test($(this).val())) {
            $('#strength').html('Strong');
            $('#weak-strength').removeClass().addClass('strong-strength');
            $('#medium-strength').removeClass().addClass('strong-strength');
            $('#strong-strength').removeClass().addClass('strong-strength');
        } else if (mediumRegex.test($(this).val())) {
            $('#strength').html('Medium');
            $('#weak-strength').removeClass().addClass('medium-strength');
            $('#medium-strength').removeClass().addClass('medium-strength');
            $('#strong-strength').removeClass();
        } else {
            $('#strength').html('Weak');
            $('#weak-strength').removeClass().addClass('weak-strength');
            $('#medium-strength').removeClass();
            $('#strong-strength').removeClass();
        }
        return true;
    });
};

/**
* HSN.SuggestEmail(fieldSelector) -> null
* - fieldSelector (jQuery selector): The selector of the input to check the email domain.
*
* Will add standardized email domain.
**/
HSN.SuggestEmail = function (fieldSelector) {

    function suggest() {

        var $hint = $("#hint");
        if (fieldSelector === "#template-product-detail-brand-signup-email") $hint = $("#hint-brand");

        $hint.css('display', 'none');
        $(this).mailcheck({
            suggested: function suggested(element, suggestion) {
                if (!$hint.html()) {
                    suggestion = "Did you mean " + suggestion.address + "&#64;" + suggestion.domain + "?";
                    $hint.html(suggestion).fadeIn(150);
                } else {
                    $(".address").html(suggestion.address);
                    $(".domain").html(suggestion.domain);
                }
            },
            empty: function empty() {}
        });

        $hint.on('click', '.domain', function () {
            $(fieldSelector).val($(".suggestion").text());
            $hint.fadeOut(200, function () {
                $(this).empty();
            });
            return false;
        });
    }

    $.fn.suggestEmail = function () {
        this.on('blur', suggest);
    };

    $(fieldSelector).suggestEmail();
};
/**
* HSN.ConstrainSelectElements (selector, container) -> null
* - fieldSelector (jQuery selector): The selector of the select elements to constrain.
*
**/
HSN.ConstrainSelectElements = function (selector, container) {
    var usedTypes = [];
    var notSeletedSelector = selector + ' option:not(:selected)';
    var selectedSelector = selector + ' option:selected';
    var optionsNotSelected = $(notSeletedSelector, container);
    var optionsSelected = $(selectedSelector, container);

    optionsNotSelected.prop('disabled', false);
    optionsNotSelected.show();

    //Get all the types that are currently selected
    optionsSelected.each(function () {
        if ($(this).val() !== 'Select') {
            usedTypes.push({ Type: $(this).val() });
        }
    });

    //Unique-ify!
    usedTypes = $.uniqueSort(usedTypes);

    //Hide from lists if already selected
    optionsNotSelected.each(function () {
        var thisValue = $(this).val();
        var opt = $(this);
        $.each(usedTypes, function () {
            if (thisValue === this.Type) {
                opt.prop('disabled', true);
                opt.hide();
            }
        });
    });
};
/**
    * HSN.ResetForm(fieldSelector) -> null
    * - form (jQuery selector/object): The form to reset.
    *
    * This will clear all form fields and remove error formatting.
    **/
HSN.ResetForm = function (form) {
    $(':input', form).not(':button, :submit, :reset').not('input[type="hidden"]').not('select').val('').prop('checked', false).prop('selected', false).prop('disabled', false);
    $('select', form).val('0').prop('selected', false);
    $('div.errors').remove();
};
/**
    * HSN.PlusMinus(fieldSelector) -> null
    * - selector (jQuery selector/object): The element to switch.
    *
    * This will clear all form fields and remove error formatting.
    **/
HSN.PlusMinus = function (selector) {
    var element = $(selector);
    if (element.hasClass('plus')) {
        element.removeClass('plus');
        element.addClass('minus');
    } else {
        element.removeClass('minus');
        element.addClass('plus');
    }
};

HSN.OnHomePage = function () {
    if (window.location.pathname === '/') {
        //-----do stuff to homepage-----      
    }
};

// Loader Animation
// Utilizes existing #wait-mask
HSN.LoaderGet = function (width, useWaitMask) {
    if (!width) {
        width = 400;
    }

    var fontSize = 1 * (parseFloat(width) / 400.0);
    var waitMask = $('<div id="wait-mask" class="wait-mask" />');
    var loadingContainer = $('<div class="animated-loader" />').css({ width: width, height: width, fontSize: fontSize });

    //clean, almost path free svg - don't muck it up!
    var animationElements = $('<div class="loading-animation default">\n            <svg class="logo" viewBox="0 0 380 230">\n                <title id="loading-animation-title">HSN Loading, Please Wait...</title>\n                <desc id="loading-animation-desc">Shaped as a blue circle, the HSN logo is spinning as the process is loading.</desc>\n                <circle fill="#2482c9" r="74" cy="91" cx="189"></circle>\n                <g transform="translate(-53,16)\n                              scale(1.5)">\n                    <path d="m146.568335,62.253923l0,-23.673697l-0.484883,0l-4.082684,0l0,9.07509l-13.778626,0l0,-9.07509l-4.558364,0l0,23.673697l4.558364,0l0,-10.0513l13.778626,0l0,10.0513l4.567567,0z" id="logo-h"></path>\n                    <path d="m172.295685,55.495989c0.372147,-6.744999 -7.572349,-7.54 -11.809758,-7.882284c-4.4393,-0.353266 -6.250567,-1.120811 -6.087789,-2.962187c0.177733,-2.025025 3.644391,-2.917037 6.101018,-2.784028c3.141676,0.167176 5.199699,0.439294 8.613439,2.83711c0,0 1.150951,-1.585731 2.375526,-3.16292c-4.200597,-3.323384 -8.503003,-3.693124 -11.020025,-3.740714c-1.872237,-0.025015 -10.522488,0.345334 -10.611642,7.156228c-0.088579,6.225168 7.748356,6.898142 10.579431,7.292897c2.077004,0.28127 7.242191,0.41733 7.242191,2.939612c0,2.330701 -4.158033,3.356941 -7.170868,3.142785c-4.580797,-0.3252 -6.36618,-1.882865 -8.636447,-4.313627c-1.162455,1.30202 -2.869037,3.125702 -2.869037,3.125702c2.561887,3.103737 7.094943,5.510094 11.434161,5.685812c2.480785,0.097621 11.49513,-0.489325 11.8598,-7.334386" id="logo-s"></path>\n                    <path d="m194.189293,62.168139l3.943488,0l0,-23.54618l-0.47453,0l-4.048173,0l0,15.752975c-1.476507,-1.738874 -13.430063,-15.752975 -13.430063,-15.752975l-4.979402,0l0,23.54618l4.428947,0l0,-17.222171c1.494338,1.771821 14.559732,17.222171 14.559732,17.222171" id="logo-n"></path>\n                </g>\n            </svg>\n\n            <svg class="spinner" viewBox="0 0 66 66">\n                <defs>\n                    <linearGradient id="gradient-loader">\n                        <stop offset="0%" stop-color="#7ccac6" stop-opacity="1"/>\n                        <stop offset="100%" stop-color="#2c526c" stop-opacity="0"/>\n                    </linearGradient>\n                </defs>\n                <circle class="path" fill="transparent" stroke-width="3" cx="33" cy="33" r="30" stroke="url(#gradient-loader)"></circle>\n            </svg>\n            <div class="textBlurb">Loading, please wait...</div>\n        </div>');

    loadingContainer.append(animationElements);
    if (useWaitMask) {
        waitMask.append(loadingContainer);
        return waitMask;
    } else {
        return loadingContainer;
    }
};

HSN.LoaderSetWait = function (text, autoCloseTime) {
    if ($('#wait-mask .animated-loader').length === 0) {
        var d = $(document);
        $('body').prepend(HSN.LoaderGet(300, true));
        $('#wait-mask').css({ width: d.width(), height: d.height() });
        HSN.LoaderReposition();
    }
    if (text) {
        $('.animated-loader .textBlurb').html(text);
    }

    if (autoCloseTime) {
        window.setTimeout(HSN.RemoveWait, autoCloseTime);
    }
};

HSN.LoaderReposition = function () {
    var w = $(window);
    var container = $('#wait-mask .animated-loader');

    var top = (w.height() - container.height()) / 2 + w.scrollTop();
    var left = (w.width() - container.width()) / 2;

    container.css({ top: top, left: left });
};

/**
    * HSN.GetHsnArcadeObjectName() -> null
    * 
    * Gets the HsnArcadeObjectName if present.
    **/
HSN.GetHsnArcadeObjectName = function () {
    return window.HsnArcadeObjectName || null;
};

/**
* HSN.SetPageMask() -> null
*
* Places page wait mask (with no visual spinner) over entire page.
**/
HSN.SetPageMask = function () {
    if ($('#wait-mask').length === 0) {
        $('#torso').prepend(pageMask);
        $('#wait-mask').css('height', $(document).height());
        $('#wait-mask').css('width', $(document).width());
    }
};
/**
* HSN.RemovePageMask() -> null
*
* Removes page wait mask.
**/
HSN.RemovePageMask = function () {
    $('#wait-mask').remove();
};
/**
* HSN.SetWait() -> null
*
* Places page wait mask (with visual spinner) over entire page.
**/
HSN.SetWait = function (waitText) {
    if ($('#wait-mask .spinner-container, #wait-mask .animated-loader').length === 0) {
        $('body').prepend(pageWait);
        $('#wait-mask').css('height', $(document).height());
        $('#wait-mask').css('width', $(document).width());
        HSN.PositionSpinner();
    }
    if (waitText) {
        $('.spinner-container').prepend(waitText);
    }
};
/**
* HSN.SetTempWait() -> null
*
* Places page wait mask (with visual spinner) over entire page automatically removes after 3 seconds.
**/
HSN.SetTempWait = function (howLong) {
    $('body').prepend(pageWait);
    $('#wait-mask').css('height', $(document).height());
    $('#wait-mask').css('width', $(document).width());
    HSN.PositionSpinner();
    window.setTimeout(HSN.RemoveWait, howLong);
};

/**
* HSN.PositionSpinner() -> null
*
* Positions the spinner on the page.
**/
HSN.PositionSpinner = function () {
    var spinnerWidth = $('#wait-mask .spinner-positioner').width();
    var spinnerHeight = $('#wait-mask .spinner-positioner').height();
    var top = ($(window).height() - spinnerHeight) / 2 + $(window).scrollTop();
    $('#wait-mask .spinner-positioner').css('top', top);
    $('#wait-mask .spinner-positioner').css('left', ($(window).width() - spinnerWidth) / 2);
};
/**
* HSN.RemoveWait() -> null
*
* Removes page wait mask (with visual spinner) over entire page.
**/
HSN.RemoveWait = function () {
    $('#wait-mask').remove();
};
/**
* HSN.SetContainerWait(selector) -> null
* -selector (jQuery selector): The selector of the field to append the spinner css
* Adds a spinner below a container.
**/
HSN.SetContainerWait = function (selector, doPrepend) {
    if (doPrepend) {
        $(selector).prepend(containerWait);
    } else {
        $(selector).after(containerWait);
    }
};
/**
* HSN.RemoveContainerWait() -> null
* Removes the container spinner for all loaders.
**/
HSN.RemoveContainerWait = function () {
    $('#container-wait, .animated-loader').remove();
};
/**
* HSN.AddButtonProcessing(selector) -> null
* -selector (jQuery selector): The selector of the input button to mark as "processing"
* Marks classes to make button show as processing.
**/
HSN.AddButtonProcessing = function (selector) {
    $(selector).addClass('processing');
};
/**
* HSN.IsButtonProcessing(selector) -> bool
* -selector (jQuery selector): The selector of the input button to check is "processing"
* Checks if a button is processing.
**/
HSN.IsButtonProcessing = function (selector) {
    if ($(selector).hasClass('processing')) {
        return true;
    }
    return false;
};
/**
* HSN.ClearButtonProcessing(selector) -> null
* -selector (jQuery selector): The selector of the input button to clear "processing"
* Clears classes to mark if a button is processing.
**/
HSN.ClearButtonProcessing = function (selector) {
    if ($(selector).hasClass('processing')) {
        $(selector).removeClass('processing');
    }
};
/**
* HSN.GetMobileHeaderOffset() -> null
* Returns the height of the mobile header for offset scenarios.
**/
HSN.GetMobileHeaderOffset = function () {
    var offset = 0;

    var mobileUtilityNavV3 = $('#utility-nav-parent-v3 #utility-nav-v3');

    if (mobileUtilityNavV3.length) {
        offset += mobileUtilityNavV3.outerHeight();

        if (!mobileUtilityNavV3.is('.fixed')) {
            var subNavV3 = $('#utility-nav-parent-v3 #subnav-v3');

            if (subNavV3.length) offset += subNavV3.outerHeight();
        }
    } else {
        var subNav = $('#utility-nav-parent #subnav');
        var utilityNav = $('#utility-nav-parent #utility-nav');
        var search = $('#utility-nav-parent #search');

        if (subNav.length) offset += subNav.outerHeight();
        if (utilityNav.length) offset += utilityNav.outerHeight();
        if (search.length) offset += search.outerHeight();
    }

    return offset;
};
/**
* HSN.GetDesktopStickyHeaderOffset() -> null
* Returns the height of the desktop sticky header for offset scenarios.
**/
HSN.GetDesktopStickyHeaderOffset = function () {
    var headerHeight = $('#primary-navigation').length > 0 ? $('#primary-navigation').outerHeight() : 0;
    if (headerHeight === 0) {
        return 0;
    }
    var stickyHeaderHeight = $('#primary-navigation .sticky-navigation').length > 0 && $('#primary-navigation .sticky-navigation').is(':visible') ? $('#primary-navigation .sticky-navigation').outerHeight() : 64;
    return headerHeight - stickyHeaderHeight;
};
/**
* HSN.GetDesktopStickyHeaderOffset() -> null
* Returns the height of the desktop sticky header for offset scenarios.
**/
HSN.GetDesktopStickyHeaderHeight = function () {
    var stickyHeaderHeight = $('#primary-navigation .sticky-navigation').length > 0 && $('#primary-navigation .sticky-navigation').is(':visible') ? $('#primary-navigation .sticky-navigation').outerHeight() : 64;
    return stickyHeaderHeight;
};
/**
* HSN.ScrollToElement() -> null
* Scroll the page to a specific element.
**/
HSN.ScrollToElement = function (element, speed, padding) {
    var offset = 0;
    speed = speed || 'slow';
    padding = padding || 0;
    if (HSN.Instance().DeviceInformation.IsMobile) {
        offset = HSN.GetMobileHeaderOffset();
    } else {
        offset = HSN.GetDesktopStickyHeaderOffset();
    }
    $('html,body').animate({ scrollTop: element.offset().top - offset - padding }, speed);
};
/**
* HSN.EqualHeights(firstContainer, secondContainer) -> null
* -firstContainer (jQuery selector): The selector of the first container to match heights
* -secondContainer (jQuery selector): The selector of the second container to match heights
* -heightType (string): What type of height to set (height, min-height, max-height, etc)
* Will adjust the heights of the two containers, if the first container is taller than second, will set second container to height of first.
**/
HSN.EqualHeights = function (firstContainer, secondContainer, heightType) {
    var height1 = $(firstContainer).outerHeight();
    var height2 = $(secondContainer).outerHeight();
    var property = {};
    if (height1 > height2) {
        property[heightType] = height1;
        $(secondContainer).css(property);
    } else {
        property[heightType] = height2;
        $(firstContainer).css(property);
    }
};
/**
* HSN.EqualHeights(selector, triggerContinuously) -> null
* -container (jQuery selector): The selector that marks the container of the collection
* -selector (jQuery selector): The selector of the grid cells
* -triggerContinuously (boolean): True - binds function to window resize event.  False - only runs when method called.
* Will adjust the height of all elements with the supplied selector to the talleset member of the collection.
**/
HSN.SetCollectionEqualHeight = function (container, selector, triggerContinuously) {
    var elements = $(selector, container);
    elements.css("height", "auto");
    var max = Number.NEGATIVE_INFINITY;

    $.each(elements, function (index, item) {
        if ($(item).height() > max) {
            max = $(item).outerHeight();
        }
    });

    $(selector, container).css("height", max + "px");

    if (triggerContinuously) {
        $(window).resize(function () {
            HSN.SetCollectionEqualHeight(container, selector, false);
        });
    }
};
/**
* HSN.IncreaseBagIconCount(value) -> null
* -value (integer): - value to increase bag icon count by
* Will update the bag icon count to the increased value.
**/
HSN.IncreaseBagIconCount = function (value) {
    var bagIcons = $('.bag-item-count');
    var quantity = parseInt(value) || 0;
    if (bagIcons.length) {
        var itemsCount = (parseInt(bagIcons.html().replace(/[^\d]/g, '')) || 0) + quantity;
        bagIcons.html(itemsCount);
        bagIcons.attr('aria-label', 'My Bag, ' + itemsCount + ' items');
    }
};
/**
* HSN.SetBagIconCount(value) -> null
* -value (integer): - value to set bag icon count to
* Will update the bag icon count to the value.
**/
HSN.SetBagIconCount = function (value) {
    var bagIcons = $('.bag-item-count');
    bagIcons.html(parseInt(value));
    bagIcons.attr('aria-label', 'My Bag, ' + value + ' items');
};
/**
* HSN.GetBagIconCount() -> null
* Will return the bag icon count.
**/
HSN.GetBagIconCount = function () {
    var bagIcon = $('.bag-item-count').first();
    return parseInt(bagIcon.html().replace(/[^\d]/g, '')) || 0;
};
/**
* HSN.OnCoremetricsLoad(function) -> null
* -callback (callback): Function to call when the coremetrics js is loaded
**/
HSN.OnCoremetricsLoad = function (callback) {
    if (typeof window.cG7 != 'undefined') {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.CM_LOADED, function () {
            callback();
        });
    }
};
/**
* HSN.OnGoogleAnalyticsLoad(function) -> null
* -callback (callback): Function to call when the google analytics js is loaded
**/
HSN.OnGoogleAnalyticsLoad = function (callback) {
    if (window.ga) {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.GOOGANALYTICS_LOADED, function () {
            callback();
        });
    }
};

HSN.OnGtmLoad = function (callback) {
    if (window.google_tag_manager) {
        callback();
    } else {
        HSN.Instance().Events.On(HSN.Application.EVENT.GTM_LOADED, function () {
            callback();
        });
    }
};

HSN.OnAccountStatusLoad = function (callback) {
    var accountStatusData = HSN.Instance().GetAccountStatusData();
    if (accountStatusData) {
        callback(accountStatusData);
    } else {
        HSN.Instance().Events.On(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_COMPLETE, function (data) {
            callback(data);
        });
    }
};

HSN.OnAccountStatusDetailLoad = function (callback) {
    var accountStatusDetailData = HSN.Instance().GetAccountStatusDetailData();
    if (accountStatusDetailData) {
        callback(accountStatusDetailData);
    } else {
        HSN.Instance().Events.On(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_DETAIL_COMPLETE, function (data) {
            callback(data);
        });
    }
};

HSN.OnAdobeTargetLoad = function (callback) {
    if (HSN.AdobeTarget && HSN.AdobeTarget.IsLoaded()) {
        callback();
    } else {
        HSN.Instance().Events.On(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__["a" /* default */].AdobeTarget.LOADED, function () {
            callback();
        });
    }
};

HSN.OnConfigLoaded = function (callback) {
    if (HSN.Config) {
        callback();
    } else {
        HSN.Instance().Events.On(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__["a" /* default */].Config.LOADED, function () {
            callback();
        });
    }
};

HSN.GoogleApiJsClientLoaded = function () {
    HSN.Instance().Events.Trigger(HSN.Application.EVENT.ON_GOOGLE_API_JS_CLIENT_LOADED);
};

HSN.PrintElement = function (elem) {
    var newWindow = window.open('', 'PRINT', 'height=400,width=600');

    newWindow.document.write('<html><head><title>' + document.title + '</title>');
    newWindow.document.write('</head><body >');
    newWindow.document.write('<h1>' + document.title + '</h1>');
    newWindow.document.write(document.getElementById(elem).innerHTML);
    newWindow.document.write('</body></html>');

    newWindow.document.close(); // necessary for IE >= 10
    newWindow.focus(); // necessary for IE >= 10*/

    newWindow.print();
    newWindow.close();

    return true;
};

// Expose the HSN namespace into the global scope.
window.HSN = HSN;

// Polyfills
if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) {
                // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        value: function value(_value) {

            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);

            // Steps 3-5.
            var len = O.length >>> 0;

            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;

            // Step 8.
            var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ? len : end >> 0;

            // Step 11.
            var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

            // Step 12.
            while (k < final) {
                O[k] = _value;
                k++;
            }

            // Step 13.
            return O;
        }
    });
}

/***/ }),

/***/ "Pd1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_MOBILE_OldGap_js__ = __webpack_require__("0xhX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventCoordinator_js__ = __webpack_require__("BHfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArticleContent_js__ = __webpack_require__("YNYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResponsiveCells_js__ = __webpack_require__("4LBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Config_js__ = __webpack_require__("+JEf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Arcade_ArcadePopupCoordinator_js__ = __webpack_require__("UoOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Rewards_Rewards_js__ = __webpack_require__("sSI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Service_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Service_AccountService_js__ = __webpack_require__("QfMd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Service_ArcadeService_js__ = __webpack_require__("Mc10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Service_CommerceService_js__ = __webpack_require__("O2fp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Service_FavoriteService_js__ = __webpack_require__("5KJu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Service_PaymentService_js__ = __webpack_require__("GCfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Service_AddressService_js__ = __webpack_require__("YuIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Service_ProductTabService_js__ = __webpack_require__("gXLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Service_ProductService_js__ = __webpack_require__("us/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Service_WatchService_js__ = __webpack_require__("gFf4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Service_WidgetService_js__ = __webpack_require__("rd1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Service_AgentPortal__ = __webpack_require__("cn2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ArticleModal_js__ = __webpack_require__("oxdC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__BaseballCardModal_js__ = __webpack_require__("2wgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BonusBuyModal_js__ = __webpack_require__("9XdC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BrandsEditModal_js__ = __webpack_require__("IEwP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CouponModal_js__ = __webpack_require__("wlyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ContentModal_js__ = __webpack_require__("14+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CSReportModal_js__ = __webpack_require__("0njC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__EmailCaptureModal_js__ = __webpack_require__("y8pB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PrivateSaleEmailCaptureModal_js__ = __webpack_require__("K3P/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__EmailFriendsModal_js__ = __webpack_require__("Flij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__EmailFriendsEnsembleModal_js__ = __webpack_require__("GoIT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__EmailSurveyModal_js__ = __webpack_require__("IQJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FaqEmailFriendModal_js__ = __webpack_require__("TzR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FitGuideModal_js__ = __webpack_require__("c50M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__GenericConfirmModal_js__ = __webpack_require__("1dmk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__HsnCaresDisclaimerModal_js__ = __webpack_require__("TWyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__KashReminderModal_js__ = __webpack_require__("/DXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__MultiItemBagModal_js__ = __webpack_require__("Bwf7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__OrdersRateReviewModal_js__ = __webpack_require__("8648");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__OrdersReprintLabelModal_js__ = __webpack_require__("Xrr0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__OrdersReturnLabelModal_js__ = __webpack_require__("qDDW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__OrdersTrackOrderModal_js__ = __webpack_require__("m/F2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__PageIdModal_js__ = __webpack_require__("A8ru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__RatingModal_js__ = __webpack_require__("5Xe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__AlcoholModal_js__ = __webpack_require__("w2jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__AsIsModal_js__ = __webpack_require__("K0L7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ReportReviewModal_js__ = __webpack_require__("rMvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Modals_SigninModal_js__ = __webpack_require__("2VHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__SignupMessageModal_js__ = __webpack_require__("djvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__VIPFinancingModal_js__ = __webpack_require__("MpGi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__WarrantyModal_js__ = __webpack_require__("UxLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__WriteReviewModal_js__ = __webpack_require__("U0cD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__YoutubeModal_js__ = __webpack_require__("BG0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Exchange_ExchangeModal_js__ = __webpack_require__("hYlo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Modals_MyAccount_CancelOrderModal_js__ = __webpack_require__("nsWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Modals_MyAccount_ProfileImageUploadModal_js__ = __webpack_require__("KjOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Modals_MyAccount_FlexPayManagerPayNowModal_js__ = __webpack_require__("qIg+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Modals_Checkout_CardVerificationModal_js__ = __webpack_require__("Oq/h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Modals_Checkout_CardVerificationRetryModal_js__ = __webpack_require__("Bwwu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Modals_Checkout_GiftOptionsModal_js__ = __webpack_require__("r3YC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Modals_Checkout_ShippingPhoneNumberModal_js__ = __webpack_require__("YI9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Modals_Checkout_SoldOutModal_js__ = __webpack_require__("mWkM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Modals_Checkout_WarrantyUpsellModal_js__ = __webpack_require__("neuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__OffCanvas_Checkout_EditOptionsOffCanvas_js__ = __webpack_require__("Yh3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__OffCanvas_Checkout_AddedToBag_js__ = __webpack_require__("kKtQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Modals_Watch_PastShowModal_js__ = __webpack_require__("FJ3w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Modals_Watch_ProgramGuidePrintModal_js__ = __webpack_require__("3MDU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Modals_Watch_ShowDetailsModalv2_js__ = __webpack_require__("2Xce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Modals_MyAccount_ClickToCallModal_js__ = __webpack_require__("98Oh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__OffCanvas_Product_ProductPreview_js__ = __webpack_require__("fr1J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_HSNDIR_Metrics_js__ = __webpack_require__("eiAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_HSNDIR_SmartBanner_js__ = __webpack_require__("ItUS");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


















































































// Used by content



/**
* class HSN.Application
*
* Keeps state of the current page loaded into the browser and provides a
* consistent and abstracted API for interacting with that page.
**/
HSN.Application = function (canvas, deviceInfo, flyoutManager, accountNavigation, desktopMobileInjector) {
    /**
    * new HSN.Application(canvas, flyoutManager, accountNavigation)
    * - canvas: (HtmlElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the root canvas of the application.
    * - deviceInfo: (HtmlElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the JSON string of device information.
    * - flyoutManager ([[HSN.FlyoutManager]]): The flyout manager that will coordinate interaction between all registered [[HSN.Flyout]]s.
    * - accountNavigation ([[HSN.AccountNavigation]]): The account navigation class that will manage the drawers.
    *
    * Instantiates and returns a new [[HSN.Application]] that may be passed to
    * [[HSN.Instance]] which will provide it as a singleton to anything that
    * needs to interact with the page.
    **/

    this.Events = new HSN.EventCoordinator();
    this.Canvas = $(canvas);
    this.FlyoutManager = flyoutManager;
    this.AccountNavigation = accountNavigation;
    if (typeof accountNavigation != 'undefined' && accountNavigation !== null) {
        this.AccountNavigation.SetApplicationInstance(this);
    }

    var deviceJson = $(deviceInfo).html();
    this.DeviceInformation = deviceJson ? JSON.parse(deviceJson) : null;

    var scope = this;
    $.ajax({
        url: '/api/device-information',
        beforeSend: function beforeSend(xhr) {
            xhr.setRequestHeader('X-Requested-With', { toString: function toString() {
                    return '';
                } });
        }
    }).done(function (data) {
        scope.DeviceInformation = data;
    });

    new HSN.ConfigLoader({
        application: this
    });

    this.dependencies = desktopMobileInjector;
};
HSN.Application.prototype = {
    _uniqueDartFloodlightNumber: null,
    _favoriteService: null,
    _bagService: null,
    _commerceService: null,
    _productTabService: null,
    _productService: null,
    _accountService: null,
    _paymentService: null,
    _addressService: null,
    _bagModal: null,
    _multiItemBagModal: null,
    _flexPayQuantityErrorModal: null,
    _soldoutModal: null,
    _giftModal: null,
    _warrantyModal: null,
    _ratingModal: null,
    _alcoholModal: null,
    _asIsModal: null,
    _videoModal: null,
    _youtubeModal: null,
    _CancelOrderModal: null,
    _ProfileImageUploadModal: null,
    _OrdersReprintLabelModal: null,
    _OrdersTrackOrderModal: null,
    _OrdersRateReviewModal: null,
    _VIPFinancingModal: null,
    _ExchangeModal: null,
    _GenericConfirmModal: null,
    _RewardEntryModal: null,
    _CodeCollectorEntryModal: null,
    _arcadeService: null,
    _emailCaptureModal: null,
    _privateSaleEmailCaptureModal: null,
    _kashReminderModel: null,
    _watchService: null,
    _widgetService: null,
    _showDetailsModalv2: null,
    _programGuidePrintModal: null,
    _pastShowsModal: null,
    _baseballCardModal: null,
    _signupMessageModal: null,
    _emailSurveyModal: null,
    _hsnCaresDisclaimerModal: null,
    _tsSmsAlertModal: null,
    _signInModal: null,
    _forgotPasswordModal: null,
    _multiAccountFoundModal: null,
    _shippingPhoneNumberModal: null,
    ccTokenizerSocket: null,
    _arcadePopupCoordinator: null,
    _arcadePopupCooridinator: null,
    _ordersReturnLabelModal: null,
    _bonusbuyModal: null,
    _bagFlyout: null,
    _flexPayManagerPayNowModal: null,
    _applePaySession: null,
    _accountStatusData: null,
    _accountStatusDetailData: null,
    _warrantyUpsellModal: null,
    _useFullyQualifiedUrls: false,
    _clickToCallModal: null,
    _editOptionsOffCanvas: null,
    _addedToBagOffCanvas: null,
    _productPreviewOffCanvas: null,
    /**
    * HSN.Application#Canvas -> jQuery
    *
    * Provides access to the jQuery-wrapped element that serves as the root canvas for the application.
    **/
    Canvas: null,

    /**
    * HSN.Application#Events -> HSN.EventCoordinator
    *
    * Provides access to the [[HSN.EventCoordinator]] instance that the
    * application uses to raise it's events.
    **/
    Events: null,

    /**
    * HSN.Application#FlyoutManager -> HSN.FlyoutManager
    *
    * Provides access to the [[HSN.FlyoutManager]] instance the application is holding.
    **/
    FlyoutManager: null,

    /**
    * HSN.Application#AccountNavigation -> HSN.AccountNavigation
    *
    * Provides access to the [[HSN.AccountNavigation]] instance the application is holding.
    **/
    AccountNavigation: null,

    /**
    * HSN.Application#DeviceInformation -> HSN.DeviceInformation
    *
    * Provides access to the [[HSN.DeviceInformation]] instance the application is holding.
    **/
    DeviceInformation: null,

    _getFavoriteService: function _getFavoriteService() {
        if (!this._favoriteService) {
            this._favoriteService = new HSN.Service.FavoriteService();
        }
        return this._favoriteService;
    },

    _getProductTabService: function _getProductTabService() {
        if (!this._productTabService) {
            this._productTabService = new HSN.Service.ProductTabService();
        }
        return this._productTabService;
    },

    _getProductService: function _getProductService() {
        if (!this._productService) {
            this._productService = new HSN.Service.ProductService();
        }
        return this._productService;
    },

    _getAccountService: function _getAccountService() {
        if (!this._accountService) {
            this._accountService = new HSN.Service.AccountService();
        }
        return this._accountService;
    },

    _getPaymentService: function _getPaymentService() {
        if (!this._paymentService) {
            this._paymentService = new HSN.Service.PaymentService();
        }
        return this._paymentService;
    },

    _getAddressService: function _getAddressService() {
        if (!this._addressService) {
            this._addressService = new HSN.Service.AddressService();
        }
        return this._addressService;
    },

    _getArcadeService: function _getArcadeService() {
        if (!this._arcadeService) {
            this._arcadeService = new HSN.Service.ArcadeService();
        }
        return this._arcadeService;
    },

    _getWatchService: function _getWatchService() {
        if (!this._watchService) {
            this._watchService = new HSN.Service.WatchService();
        }
        return this._watchService;
    },

    _getWidgetService: function _getWidgetService() {
        if (!this._widgetService) {
            this._widgetService = new HSN.Service.WidgetService();
        }
        return this._widgetService;
    },

    _getCommerceService: function _getCommerceService() {
        if (!this._commerceService) {
            this._commerceService = new HSN.Service.CommerceService();
        }
        return this._commerceService;
    },

    _getAgentPortalService: function _getAgentPortalService() {
        if (!this._agentPortalService) {
            this._agentPortalService = new HSN.Service.AgentPortal();
        }
        return this._agentPortalService;
    },
    /**
    * HSN.Application#Favorite(objectType, objectId, config) -> void
    * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being favorited.
    * - objectId (String): The identifier of the object to favorite.
    * - config (Object): A configuration object for the call
    * - webId (String): The variant of the object to favorite if favoriting product.
    *   consisting of the following keys:
    *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
    *   - scope (Object): The scope to execute the callback function in.
    *
    * Favorites the given object with the backend Favorite service and then
    * executes the callback, if given, with the success or failure status of
    * the call.
    *
    * If successful, raises an [[HSN.Application.EVENT]].`FAVORITE_FAVORITED`
    * event passing the type and identifier of the favorited object for
    * handling by other components.
    **/
    Favorite: function Favorite(objectType, objectId, webId, config) {
        config = config = config || {};
        this._getFavoriteService().Favorite(objectType, objectId, webId, {
            callback: function callback(success, favorited) {
                if (success && favorited) {
                    if (favorited > 1) {
                        //updated favorite, unfavorite previous
                        this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, favorited);
                    }
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                } else if (success) {
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                }
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, success, favorited);
                }
            },
            scope: this
        });
    },

    /**
    * HSN.Application#Unfavorite(objectType, objectId, config) -> void
    * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being unfavorited.
    * - objectId (String): The identifier of the object to unfavorite.
    * - webId (String): The variant of the object to favorite if favoriting product.
    * - config (Object): A configuration object for the call
    *   consisting of the following keys:
    *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
    *   - scope (Object): The scope to execute the callback function in.
    *
    * Unfavorites the given object with the backend Favorite service and then
    * executes the callback, if given, with the success or failure status of
    * the call.
    *
    * If successful, raises an [[HSN.Application.EVENT]].`FAVORITE_UNFAVORITED`
    * event passing the type and identifier of the unfavorited object for
    * handling by other components.
    **/
    Unfavorite: function Unfavorite(objectType, objectId, webId, config) {
        config = config = config || {};
        this._getFavoriteService().Unfavorite(objectType, objectId, webId, {
            callback: function callback(success, favorited) {
                if (success && favorited) {
                    if (favorited > 1) {
                        //updated favorite, unfavorite previous
                        this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, favorited);
                    }
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                } else if (success) {
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, webId);
                }
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, success);
                }
            },
            scope: this
        });
    },

    GetProductReviews: function GetProductReviews(encodedProductName, id, page, recordsPerPage, sortTerm, sortSequence, pfid, ratingFilter, percentRecommended, lessman, config) {
        this._getProductTabService().GetProductReviews(encodedProductName, id, page, recordsPerPage, sortTerm, sortSequence, pfid, ratingFilter, percentRecommended, $('cmSource').val() || 'ProductPage', lessman, {
            callback: function callback(success, data) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, success, data);
                }
            },
            scope: this
        });
    },

    GetProductTab: function GetProductTab(id, tab, config) {
        this._getProductTabService().GetProductTab(id, tab, {
            callback: function callback(success, data) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, success, data);
                }
            },
            scope: this
        });
    },

    FormatAsCurrency: function FormatAsCurrency(sSymbol, vValue) {
        aDigits = vValue.toFixed(2).split('.');
        aDigits[0] = aDigits[0].split('').reverse().join('').replace(/(\d{3})(?=\d)/g, '$1,').split('').reverse().join('');

        return sSymbol + aDigits.join('.');
    },

    SingleOrderStatus: function SingleOrderStatus(phoneNumber, orderId, config) {
        config = config = config || {};
        config.scope = config.scope = config.scope || this;
        $.ajax('/account/order-status/singleitem', {
            context: this,
            dataType: 'json',
            type: 'POST',
            data: { 'phoneNumber': phoneNumber, 'orderNumber': orderId, 'isSingleOrder': 'true' },
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error);
                }
            }
        });
    },

    GetBagFlyout: function GetBagFlyout() {
        return this._bagFlyout;
    },
    SetBagFlyout: function SetBagFlyout(flyout) {
        this._bagFlyout = flyout;
    },
    /**
    * HSN.Application#InitModal -> HSN.Modal
    *
    * @param {function} modalConstructor
    * @param {object} config
    **/
    InitModal: function InitModal(modalConstructor, config) {
        var instanceName = '__' + modalConstructor.name;
        if (null == this[instanceName]) {
            this[instanceName] = new modalConstructor(config);
            this.Canvas.append(this[instanceName].Root);
        }
        return this[instanceName];
    },

    /**
    * HSN.Application#GetProductModal -> HSN.ProductModal
    *
    * Provides access to the lazy-instantiated [[HSN.ProductModal]] that the [[HSN.Application]] is holding.
    * This function was left to provide backwards compatibility in case content had calls to the old product modal
    **/
    GetProductModal: function GetProductModal() {
        if (null == this._productPreviewOffCanvas) {
            this._productPreviewOffCanvas = new HSN.OffCanvas.ProductPreview();
            this.Canvas.append(this._productPreviewOffCanvas.Root);
        }
        return this._productPreviewOffCanvas;
    },

    /**
    * HSN.Application#GetMobileAddedToBagModal -> HSN.BagModal
    *
    * Provides access to the lazy-instantiated [[HSN.BagModal]] that the [[HSN.Application]] is holding.
    **/
    GetMobileAddedToBagModal: function GetMobileAddedToBagModal() {
        if (null == this._bagModal) {
            this._bagModal = new this.dependencies.BagModal();
            this.Canvas.append(this._bagModal.Root);
        }

        return this._bagModal;
    },

    GetMultiItemBagModal: function GetMultiItemBagModal() {
        if (null == this._multiItemBagModal) {
            this._multiItemBagModal = new HSN.MultiItemBagModal();
            this.Canvas.append(this._multiItemBagModal.Root);
        }

        return this._multiItemBagModal;
    },

    GetSoldOutModal: function GetSoldOutModal() {
        if (null == this._soldoutModal) {
            this._soldoutModal = new HSN.SoldOutModal();
            this.Canvas.append(this._soldoutModal.Root);
        }

        return this._soldoutModal;
    },
    GetExchangeModal: function GetExchangeModal() {
        if (null == this._ExchangeModal) {
            this._ExchangeModal = new HSN.ExchangeModal();
            this.Canvas.append(this._ExchangeModal.Root);
        }

        return this._ExchangeModal;
    },

    /**
    * HSN.Application#GetRatingModal -> HSN.RatingModal
    *
    * Provides access to the lazy-instantiated [[HSN.RatingModal]] that the [[HSN.Application]] is holding.
    **/
    GetRatingModal: function GetRatingModal() {
        if (null == this._ratingModal) {
            this._ratingModal = new HSN.RatingModal();
            this.Canvas.append(this._ratingModal.Root);
        }

        return this._ratingModal;
    },

    GetAlcoholModal: function GetAlcoholModal() {
        if (null === this._alcoholModal) {
            this._alcoholModal = new HSN.AlcoholModal();
            this.Canvas.append(this._alcoholModal.Root);
        }

        return this._alcoholModal;
    },

    GetAsIsModal: function GetAsIsModal() {
        if (null == this._asIsModal) {
            this._asIsModal = new HSN.AsIsModal();
            this.Canvas.append(this._asIsModal.Root);
        }

        return this._asIsModal;
    },

    GetVideoModal: function GetVideoModal() {
        if (!this._videoModal) {
            this._videoModal = new this.dependencies.VideoModal();
            this.Canvas.append(this._videoModal.Root);
        }

        return this._videoModal;
    },

    GetYoutubeModal: function GetYoutubeModal() {
        if (!this._youtubeModal) {
            this._youtubeModal = new HSN.YoutubeModal();
            this.Canvas.append(this._youtubeModal.Root);
        }

        return this._youtubeModal;
    },

    //grab specifc param from querystring
    GetQueryStringParam: function GetQueryStringParam(url, param) {
        var queryString = url.substring(url.indexOf('?') + 1);

        var params = queryString.split('&');
        var paramsLength = params.length;
        for (var i = 0; i < paramsLength; i++) {
            var sParameterName = params[i].split('=', 2);
            if (sParameterName[0] == param) {
                return decodeURIComponent(sParameterName[1].replace(/\+/g, ' '));
            }
        }
        return '';
    },

    UpdateQueryStringParameter: function UpdateQueryStringParameter(uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';

        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            return uri + separator + key + '=' + value;
        }
    },

    //call keyword search logger
    LogKeywordSearch: function LogKeywordSearch(searchTerm, numResults, wasSuggested, wasRedirect) {
        if (!searchTerm) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax('/search/log', {
            data: {
                'searchTerm': searchTerm,
                'numResults': numResults,
                'wasSuggested': wasSuggested,
                'wasRedirect': wasRedirect
            },
            type: 'GET'
        });
    },

    /**
    * HSN.Application#GetBrowser -> HSN.Browser
    *
    * Returns browser name and version.
    **/
    GetBrowser: function GetBrowser() {
        var nav = navigator.appName,
            ua = navigator.userAgent.toLowerCase(),
            tem;
        var match = ua.match(/(opera|chrome|safari|firefox|msie|iphone|ipod|ipad|android|blackBerry)/);
        var version = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/);
        if (version && (tem = ua.match(/version\/([\.\d]+)/i)) != null) {
            version[2] = tem[1];
        }
        version = version ? [version[1], version[2]] : [nav, navigator.appVersion, '-?'];
        var browserObj = [match && match[0] ? match[0] : 'unknown', version && version[1] ? version[1] : 'unknown'];
        return browserObj;
    },

    /**
    * HSN.Application#GetWriteReviewModal -> HSN.NicknameModal
    *
    * Provides access to the lazy-instantiated [[HSN.NickanmeModal]] that the [[HSN.Application]] is holding.
    **/
    GetNicknameModal: function GetNicknameModal() {
        if (null == this._nicknameModal) {
            this._nicknameModal = new this.dependencies.NicknameModal();
            this.Canvas.append(this._nicknameModal.Root);
        }

        return this._nicknameModal;
    },
    GetCSReportModal: function GetCSReportModal() {
        if (null == this._csreportModal) {
            this._csreportModal = new HSN.CSReportModal();
            this.Canvas.append(this._csreportModal.Root);
        }

        return this._csreportModal;
    },
    /**
    * HSN.Application#GetWriteReviewModal -> HSN.WriteReviewModal
    *
    * Provides access to the lazy-instantiated [[HSN.WriteReviewModal]] that the [[HSN.Application]] is holding.
    **/
    GetWriteReviewModal: function GetWriteReviewModal() {
        if (null == this._writeReviewModal) {
            this._writeReviewModal = new HSN.WriteReviewModal();
            this.Canvas.append(this._writeReviewModal.Root);
        }

        return this._writeReviewModal;
    },

    GetCouponModal: function GetCouponModal() {
        if (null == this._couponModal) {
            this._couponModal = new HSN.CouponModal();
            this.Canvas.append(this._couponModal.Root);
        }

        return this._couponModal;
    },

    /**
    * HSN.Application#GetArticleModal -> HSN.ArticleModal
    *
    * Provides access to the lazy-instantiated [[HSN.ArticleModal]] that the [[HSN.Application]] is holding.
    **/
    GetArticleModal: function GetArticleModal() {
        if (null == this._articleModal) {
            this._articleModal = new HSN.ArticleModal();
            this.Canvas.append(this._articleModal.Root);
        }

        return this._articleModal;
    },

    GetArticleContent: function GetArticleContent(config) {
        if (null == this._articleContent) {
            this._articleContent = new HSN.ArticleContent(config);
            this.Canvas.append(this._articleContent.Root);
        }

        return this._articleContent;
    },

    GetContentModal: function GetContentModal() {
        if (null == this._contentModal) {
            this._contentModal = new HSN.ContentModal();
            this.Canvas.append(this._contentModal.Root);
        }

        return this._contentModal;
    },

    GetHsnCaresDisclaimerModal: function GetHsnCaresDisclaimerModal() {
        if (null == this._hsnCaresDisclaimerModal) {
            this._hsnCaresDisclaimerModal = new HSN.HsnCaresDisclaimerModal();
            this.Canvas.append(this._hsnCaresDisclaimerModal.Root);
        }

        return this._hsnCaresDisclaimerModal;
    },

    GetReportReviewModal: function GetReportReviewModal() {
        if (null == this._reportReviewModal) {
            this._reportReviewModal = new HSN.ReportReviewModal();
            this.Canvas.append(this._reportReviewModal.Root);
        }

        return this._reportReviewModal;
    },

    GetFitGuideModal: function GetFitGuideModal() {
        if (null == this._fitGuideModal) {
            this._fitGuideModal = new HSN.FitGuideModal();
            this.Canvas.append(this._fitGuideModal.Root);
        }

        return this._fitGuideModal;
    },

    GetEmailFriendsModal: function GetEmailFriendsModal() {
        if (null == this._emailFriendsModal) {
            this._emailFriendsModal = new HSN.EmailFriendsModal();
            this.Canvas.append(this._emailFriendsModal.Root);
        }

        return this._emailFriendsModal;
    },

    GetEmailFriendsEnsembleModal: function GetEmailFriendsEnsembleModal() {
        if (null == this._emailFriendsEnsembleModal) {
            this._emailFriendsEnsembleModal = new HSN.EmailFriendsEnsembleModal();
            this.Canvas.append(this._emailFriendsEnsembleModal.Root);
        }

        return this._emailFriendsEnsembleModal;
    },

    GetBrandsEditModal: function GetBrandsEditModal() {
        if (null == this._brandsEditModal) {
            this._brandsEditModal = new HSN.BrandsEditModal();
            this.Canvas.append(this._brandsEditModal.Root);
        }

        return this._brandsEditModal;
    },

    GetSignupMessageModal: function GetSignupMessageModal() {
        if (null == this._signupMessageModal) {
            this._signupMessageModal = new HSN.SignupMessageModal();
            this.Canvas.append(this._signupMessageModal.Root);
        }

        return this._signupMessageModal;
    },

    GetEmailSurveyModal: function GetEmailSurveyModal() {
        if (null == this._emailSurveyModal) {
            this._emailSurveyModal = new HSN.EmailSurveyModal();
            this.Canvas.append(this._emailSurveyModal.Root);
        }

        return this._emailSurveyModal;
    },

    GetPageIdModal: function GetPageIdModal() {
        if (null == this._pageIdModal) {
            this._pageIdModal = new HSN.PageIdModal();
            this.Canvas.append(this._pageIdModal.Root);
        }

        return this._pageIdModal;
    },

    GetFaqEmailFriendsModal: function GetFaqEmailFriendsModal() {
        if (null == this._faqEmailFriendsModal) {
            this._faqEmailFriendsModal = new HSN.FaqEmailFriendsModal();
            this.Canvas.append(this._faqEmailFriendsModal.Root);
        }

        return this._faqEmailFriendsModal;
    },
    /**
    * HSN.Application#GetGiftOptionsModal -> HSN.GiftModal
    *
    * Provides access to the lazy-instantiated [[HSN.GiftOptionsModal]] that the [[HSN.Application]] is holding.
    **/
    GetGiftOptionsModal: function GetGiftOptionsModal() {
        if (null == this._giftModal) {
            this._giftModal = new HSN.GiftOptionsModal();
            this.Canvas.append(this._giftModal.Root);
        }

        return this._giftModal;
    },
    /**
    * HSN.Application#GetWarrantyDetailsModal -> HSN.WarrantyModal
    *
    * Provides access to the lazy-instantiated [[HSN.GiftModal]] that the [[HSN.Application]] is holding.
    **/
    GetWarrantyDetailsModal: function GetWarrantyDetailsModal() {
        if (null == this._warrantyModal) {
            this._warrantyModal = new HSN.WarrantyModal();
            this.Canvas.append(this._warrantyModal.Root);
        }

        return this._warrantyModal;
    },
    /**
    * HSN.Application#GetGenericConfirmModal -> HSN.GenericConfirmModal
    *
    * Provides access to the lazy-instantiated [[HSN.GenericConfirmModal]] that the [[HSN.Application]] is holding.
    **/
    GetGenericConfirmModal: function GetGenericConfirmModal(config) {
        if (null == this._GenericConfirmModal) {
            this._GenericConfirmModal = new HSN.GenericConfirmModal(config);
            this.Canvas.append(this._GenericConfirmModal.Root);
        }

        return this._GenericConfirmModal;
    },
    /**
    * HSN.Application#GetFlexPayManagerPayNowModal -> HSN.FlexPayManagerPayNowModal
    *
    * Provides access to the lazy-instantiated [[HSN.FlexPayManagerPayNowModal]] that the [[HSN.Application]] is holding.
    **/
    GetFlexPayManagerPayNowModal: function GetFlexPayManagerPayNowModal() {
        if (null == this._flexPayManagerPayNowModal) {
            this._flexPayManagerPayNowModal = new HSN.FlexPayManagerPayNowModal();
            this.Canvas.append(this._flexPayManagerPayNowModal.Root);
        }

        return this._flexPayManagerPayNowModal;
    },
    /**
    * HSN.Application#GetCancelOrderModal -> HSN.CancelOrderModal
    *
    * Provides access to the lazy-instantiated [[HSN.CancelOrderModal]] that the [[HSN.Application]] is holding.
    **/
    GetCancelOrderModal: function GetCancelOrderModal() {
        if (null == this._CancelOrderModal) {
            this._CancelOrderModal = new HSN.CancelOrderModal();
            this.Canvas.append(this._CancelOrderModal.Root);
        }

        return this._CancelOrderModal;
    },
    /**
    * HSN.Application#GetProfileImageUploadModal -> HSN.ProfileImageUploadModal
    *
    * Provides access to the lazy-instantiated [[HSN.ProfileImageUploadModal]] that the [[HSN.Application]] is holding.
    **/
    GetProfileImageUploadModal: function GetProfileImageUploadModal() {
        if (null == this._ProfileImageUploadModal) {
            this._ProfileImageUploadModal = new HSN.ProfileImageUploadModal();
            this.Canvas.append(this._ProfileImageUploadModal.Root);
        }

        return this._ProfileImageUploadModal;
    },
    /**
    * HSN.Application#GetOrdersReprintLabelModal -> HSN.OrdersReprintLabelModal
    *
    * Provides access to the lazy-instantiated [[HSN.OrdersReprintLabelModal]] that the [[HSN.Application]] is holding.
    **/
    GetOrdersReprintLabelModal: function GetOrdersReprintLabelModal() {
        if (null == this._OrdersReprintLabelModal) {
            this._OrdersReprintLabelModal = new HSN.OrdersReprintLabelModal();
            this.Canvas.append(this._OrdersReprintLabelModal.Root);
        }

        return this._OrdersReprintLabelModal;
    },
    /**
    * HSN.Application#GetOrdersTrackOrderModal -> HSN.OrdersTrackOrderModal
    *
    * Provides access to the lazy-instantiated [[HSN.OrdersTrackOrderModal]] that the [[HSN.Application]] is holding.
    **/
    GetOrdersTrackOrderModal: function GetOrdersTrackOrderModal() {
        if (null == this._OrdersTrackOrderModal) {
            this._OrdersTrackOrderModal = new HSN.OrdersTrackOrderModal();
            this.Canvas.append(this._OrdersTrackOrderModal.Root);
        }

        HSN.DataLayer.helpers.virtualPageview(null, 'Modal: Track Order', 'Track Order');

        return this._OrdersTrackOrderModal;
    },
    /**
    * HSN.Application#GetVIPFinancingModal -> HSN.VIPFinancingModal
    *
    * Provides access to the lazy-instantiated [[HSN.VIPFinancingModal]] that the [[HSN.Application]] is holding.
    **/
    GetVIPFinancingModal: function GetVIPFinancingModal() {
        if (null == this._VIPFinancingModal) {
            this._VIPFinancingModal = new HSN.VIPFinancingModal();
            this.Canvas.append(this._VIPFinancingModal.Root);
        }

        return this._VIPFinancingModal;
    },

    /**
    * HSN.Application#RewardEntryModal -> HSN.RewardEntryModal
    *
    * Provides access to the lazy-instantiated [[HSN.RewardEntryModal]] that the [[HSN.Application]] is holding.
    **/
    GetRewardEntryModal: function GetRewardEntryModal(config) {
        if (null == this._RewardEntryModal) {
            this._RewardEntryModal = new HSN.RewardEntryModal(config);
            this.Canvas.append(this._RewardEntryModal.Root);
        }

        return this._RewardEntryModal;
    },
    /**
    * HSN.Application#CodeCollectorEntryModal -> HSN.CodeCollectorEntryModal
    *
    * Provides access to the lazy-instantiated [[HSN.CodeCollectorEntryModal]] that the [[HSN.Application]] is holding.
    **/
    GetCodeCollectorEntryModal: function GetCodeCollectorEntryModal(config) {
        if (null == this._CodeCollectorEntryModal) {
            this._CodeCollectorEntryModal = new HSN.CodeCollectorModal(config);
            this.Canvas.append(this._CodeCollectorEntryModal.Root);
        }

        return this._CodeCollectorEntryModal;
    },
    /**
    * HSN.Application#GetBaseballCardModal -> HSN.BaseballCardModal
    *
    * Provides access to the lazy-instantiated [[HSN.BaseballCardModal]] that the [[HSN.Application]] is holding.
    **/
    GetBaseballCardModal: function GetBaseballCardModal(config) {
        if (null == this._baseballCardModal) {
            this._baseballCardModal = new HSN.BaseballCardModal(config);
            this.Canvas.append(this._baseballCardModal.Root);
        }

        return this._baseballCardModal;
    },
    /**
    * HSN.Application#GetEmailCaptureModal -> HSN.EmailCaptureModal
    *
    * Provides access to the lazy-instantiated [[HSN.EmailCaptureModal]] that the [[HSN.Application]] is holding.
    **/
    GetEmailCaptureModal: function GetEmailCaptureModal(config) {
        if (null == this._emailCaptureModal) {
            this._emailCaptureModal = new HSN.EmailCaptureModal(config);
            this.Canvas.append(this._emailCaptureModal.Root);
        }

        return this._emailCaptureModal;
    },
    /**
    * HSN.Application#GetPrivateSaleEmailCaptureModal -> HSN.PrivateSaleEmailCaptureModal
    *
    * Provides access to the lazy-instantiated [[HSN.PrivateSaleEmailCaptureModal]] that the [[HSN.Application]] is holding.
    **/
    GetPrivateSaleEmailCaptureModal: function GetPrivateSaleEmailCaptureModal(config) {
        if (null == this._privateSaleEmailCaptureModal) {
            this._privateSaleEmailCaptureModal = new HSN.PrivateSaleEmailCaptureModal(config);
            this.Canvas.append(this._privateSaleEmailCaptureModal.Root);
        }

        return this._privateSaleEmailCaptureModal;
    },
    /**
    * HSN.Application#GetKashReminderModal -> HSN.KashReminderModal
    *
    * Provides access to the lazy-instantiated [[HSN.KashReminderModal]] that the [[HSN.Application]] is holding.
    **/
    GetKashReminderModal: function GetKashReminderModal(config) {
        if (null == this._kashReminderModal) {
            this._kashReminderModal = new HSN.KashReminderModal(config);
            this.Canvas.append(this._kashReminderModal.Root);
        }

        return this._kashReminderModal;
    },
    /**
    * HSN.Application#GetShowDetailsModal -> HSN.ShowDetailsModal
    *
    * Provides access to the lazy-instantiated [[HSN.ShowDetailsModal]] that the [[HSN.Application]] is holding.
    **/
    GetShowDetailsModalv2: function GetShowDetailsModalv2(config) {
        if (null == this._showDetailsModalv2) {
            this._showDetailsModalv2 = new HSN.ShowDetailsModalv2(config);
            this.Canvas.append(this._showDetailsModalv2.Root);
        }

        return this._showDetailsModalv2;
    },
    GetProgramGuidePrintModal: function GetProgramGuidePrintModal(config) {
        if (null == this._programGuidePrintModal) {
            this._programGuidePrintModal = new HSN.ProgramGuidePrintModal(config);
            this.Canvas.append(this._programGuidePrintModal.Root);
        }

        return this._programGuidePrintModal;
    },
    GetPastShowsModal: function GetPastShowsModal(config) {
        if (null == this._pastShowsModal) {
            this._pastShowsModal = new HSN.PastShowModal(config);
            this.Canvas.append(this._pastShowsModal.Root);
        }

        return this._pastShowsModal;
    },
    GetSignInModal: function GetSignInModal(config) {
        if (null == this._signInModal) {
            this._signInModal = new HSN.SignInModal(config);
            this.Canvas.append(this._signInModal.Root);
        }

        return this._signInModal;
    },
    GetForgotPasswordModal: function GetForgotPasswordModal(config) {
        if (null == this._forgotPasswordModal) {
            this._forgotPasswordModal = new HSN.ForgotPasswordModal(config);
            this.Canvas.append(this._forgotPasswordModal.Root);
        }

        return this._forgotPasswordModal;
    },
    GetMultiAccountFoundModal: function GetMultiAccountFoundModal(config) {
        if (null == this._multiAccountFoundModal) {
            this._multiAccountFoundModal = new HSN.MultiAccountFoundModal(config);
            this.Canvas.append(this._multiAccountFoundModal.Root);
        }

        return this._multiAccountFoundModal;
    },
    GetShippingPhoneNumberModal: function GetShippingPhoneNumberModal() {
        if (null == this._shippingPhoneNumberModal) {
            this._shippingPhoneNumberModal = new HSN.ShippingPhoneNumberModal();
            this.Canvas.append(this._shippingPhoneNumberModal.Root);
        }
        return this._shippingPhoneNumberModal;
    },
    GetOrdersReturnLabelModal: function GetOrdersReturnLabelModal() {
        if (null == this._ordersReturnLabelModal) {
            this._ordersReturnLabelModal = new HSN.OrdersReturnLabelModal();
            this.Canvas.append(this._ordersReturnLabelModal.Root);
        }
        return this._ordersReturnLabelModal;
    },
    GetBonusBuyModal: function GetBonusBuyModal() {
        if (null == this._bonusbuyModal) {
            this._bonusbuyModal = new HSN.BonusBuyModal();
            this.Canvas.append(this._bonusbuyModal.Root);
        }
        return this._bonusbuyModal;
    },
    GetCardVerificationModal: function GetCardVerificationModal(config) {
        if (null == this._cardVerificationModal) {
            this._cardVerificationModal = new HSN.CardVerificationModal(config);
            this.Canvas.append(this._cardVerificationModal.Root);
        }
        return this._cardVerificationModal;
    },
    GetCardVerificationRetryModal: function GetCardVerificationRetryModal(config) {
        if (null == this._cardVerificationRetryModal) {
            this._cardVerificationRetryModal = new HSN.CardVerificationRetryModal(config);
            this.Canvas.append(this._cardVerificationRetryModal.Root);
        }
        return this._cardVerificationRetryModal;
    },
    GetWarrantyUpsellModal: function GetWarrantyUpsellModal(config) {
        if (null == this._warrantyUpsellModal) {
            this._warrantyUpsellModal = new HSN.WarrantyUpsellModal(config);
            this.Canvas.append(this._warrantyUpsellModal.Root);
        }
        return this._warrantyUpsellModal;
    },

    GetClickToCallModal: function GetClickToCallModal(config) {
        if (null == this._clickToCallModal) {
            this._clickToCallModal = new HSN.ClickToCallModal(config);
            this.Canvas.append(this._clickToCallModal.Root);
        }
        return this._clickToCallModal;
    },
    /*
    ====================================================================================================================
    BEGIN OFF CANVAS WIDGETS
    ====================================================================================================================
    */
    GetEditOptionsOffCanvas: function GetEditOptionsOffCanvas() {
        if (null == this._editOptionsOffCanvas) {
            this._editOptionsOffCanvas = new HSN.EditOptionsOffCanvas();
            this.Canvas.append(this._editOptionsOffCanvas.Root);
        }
        return this._editOptionsOffCanvas;
    },
    GetAddedToBagOffCanvas: function GetAddedToBagOffCanvas() {
        if (null == this._addedToBagOffCanvas) {
            this._addedToBagOffCanvas = new HSN.AddedToBagOffCanvas();
            this.Canvas.append(this._addedToBagOffCanvas.Root);
        }
        return this._addedToBagOffCanvas;
    },
    GetProductPreviewOffCanvas: function GetProductPreviewOffCanvas() {
        if (null == this._productPreviewOffCanvas) {
            this._productPreviewOffCanvas = new HSN.OffCanvas.ProductPreview();
            this.Canvas.append(this._productPreviewOffCanvas.Root);
        }
        return this._productPreviewOffCanvas;
    },

    /*
    ====================================================================================================================
    END OFF CANVAS WIDGETS
    ====================================================================================================================
    */
    HandleEmailSignup: function HandleEmailSignup(emailAddress, source, config) {
        config = config = config || {};
        $.ajax('/account/emailcapture/signup', {
            context: this,
            dataType: 'json',
            type: 'POST',
            data: { 'emailAddress': emailAddress, 'sourceId': source },
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error2) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error2);
                }
            }
        });
    },
    FlexPaymentMethod: function FlexPaymentMethod(action, orderNumber, flexNumber, identity, defaultFlag, month, year, name, type, debitFlag, saveFlag, ccnumber, cctoken, bankName, config) {
        config = config = config || {};
        config.scope = config.scope = config.scope || this;
        //alert(identity + ',' + password);

        $.ajax('/myaccount/flexpay/changecard', {
            context: this,
            dataType: 'json',
            type: 'POST',
            // TODO: These parameter names must be updated to match the service endpoint expectation.
            data: { 'Action': action, 'OrderNumber': orderNumber, 'FlexNumber': flexNumber, 'Identity': identity, 'DefaultFlag': defaultFlag, 'Month': month, 'Year': year, 'Name': name, 'Type': type, 'DebitFlag': debitFlag, 'SaveFlag': saveFlag, 'Number': ccnumber, 'PaymentMethodToken': cctoken, 'BankName': bankName },
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error3) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error3);
                }
            }
        });
    },
    AutoshipPaymentMethod: function AutoshipPaymentMethod(action, orderNumber, identity, defaultFlag, month, year, name, type, debitFlag, saveFlag, ccnumber, cctoken, bankName, config) {
        config = config = config || {};
        config.scope = config.scope = config.scope || this;
        //alert(identity + ',' + password);

        $.ajax('/myaccount/autoship/changecard', {
            context: this,
            dataType: 'json',
            type: 'POST',
            // TODO: These parameter names must be updated to match the service endpoint expectation.
            data: { 'Action': action, 'OrderNumber': orderNumber, 'Identity': identity, 'DefaultFlag': defaultFlag, 'Month': month, 'Year': year, 'Name': name, 'Type': type, 'DebitFlag': debitFlag, 'SaveFlag': saveFlag, 'Number': ccnumber, 'PaymentMethodToken': cctoken, 'BankName': bankName },
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error4) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error4);
                }
            }
        });
    },
    IsAutoshipFrequencyValid: function IsAutoshipFrequencyValid(data) {
        var frequency = data.frequency || 0;

        return frequency >= 7 && frequency <= 365;
    },
    SetGuest: function SetGuest(config) {
        config = config = config || {};
        config.scope = config.scope = config.scope || this;
        $.ajax('/account/guest', {
            context: this,
            dataType: 'json',
            type: 'POST',
            // TODO: These parameter names must be updated to match the service endpoint expectation.
            data: null,
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error5) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error5);
                }
            }
        });
    },
    ReportIssue: function ReportIssue(name, email, contactMe, description, url, config) {
        config = config = config || {};
        config.scope = config.scope = config.scope || this;
        var randomnumber = Math.floor(Math.random() * 10) + 100;
        $.ajax('/customer-service/report' + '?rnd=' + randomnumber, {
            context: this,
            dataType: 'json',
            type: 'POST',
            data: { 'Name': name, 'EmailAddress': email, 'ContactMe': contactMe, 'Description': description, 'URL': url },
            success: function success(data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                } else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function error(xhr, status, _error6) {
                if (config.error) {
                    config.error.call(config.error, config.scope, _error6);
                }
            }
        });
    },

    GetMenuData: function GetMenuData(query, lessman) {
        var url = '';
        var params = '?UseBullets=true';

        if (lessman) {
            url = '/lessman-menu/';
        } else {
            url = query ? '/offcanvas/' + query + params : '/offcanvas/';
            if (query === 'hf0035') {
                url = '/lessman-menu/';
            }
        }

        $.ajax(url, {
            context: this,
            dataType: 'html',

            success: function success(data, status, xhr) {
                this.Events.Trigger(HSN.Application.EVENT.ON_NAVIGATION_LOADED, data);
            }
        });
    },
    /**
    * HSN.Application#GetOrdersRateReviewModal -> HSN.OrdersRateReviewModal
    *
    * Provides access to the lazy-instantiated [[HSN.OrdersRateReviewModal]] that the [[HSN.Application]] is holding.
    **/
    GetOrdersRateReviewModal: function GetOrdersRateReviewModal() {
        if (null == this._OrdersRateReviewModal) {
            this._OrdersRateReviewModal = new HSN.OrdersRateReviewModal();
            this.Canvas.append(this._OrdersRateReviewModal.Root);
        }

        return this._OrdersRateReviewModal;
    },

    GetUniqueDartFloodlightNumber: function GetUniqueDartFloodlightNumber() {
        return this._uniqueDartFloodlightNumber = Number(this._uniqueDartFloodlightNumber) || Math.floor(Math.random() * 10e12);
    },

    DisplayCustomerOffers: function DisplayCustomerOffers(offers) {
        $.each(offers, function () {
            var offerContainer = $("[offer-location='" + this.Location + "']");
            var $offerHtml = $(this.Html);
            var cmTagValue = this.Location + '-_-' + (this.InControlGroup ? 'Control' : 'Target') + '-_-' + this.TreatmentCode;
            var event = JSON.stringify({
                'event_type': 'metric',
                'metrics_event_category': 'offer',
                'metrics_event_action': 'Accepted',
                "unica_treatment_code": this.TreatmentCode,
                "unica_session_id": this.SessionId,
                "unica_source": 'Web'
            });

            if (!this.Html && !this.InControlGroup || offerContainer.length === 0) {
                //not personalized offer or in control group
                return;
            }

            if (this.InControlGroup && !this.Html) {
                offerContainer.find('a').add(offerContainer.filter('a')).attr('manual_cm_re', cmTagValue).attr('manual_cm_sp', cmTagValue).attr('data-datalayer-udo', event);
            } else {
                $offerHtml.filter('a').add($offerHtml.find('a')).attr('data-datalayer-udo', event);

                offerContainer.html($offerHtml);

                // If this cell is the LeftNavGrid cell, activate the separator/spacer + readjust the breadbox and product grid cells
                if (offerContainer.is('#IP_xx_LeftNavGrid')) {
                    $('#IP_xx_LeftNavGrid_Separator').addClass('active');

                    if (_typeof(window.productGrid) === 'object' && productGrid.adjustProductGrid) {
                        productGrid.adjustProductGrid();
                    }
                }
            }
        });
        HSN.ResponsiveCells.prototype.TextResize('.TextContainer', '.rText');
        HSN.ResponsiveCells.prototype.ButtonResize('.rButton', '.rText');
        HSN.ResponsiveCells.prototype.HandleWindowResize();
        $('[offer-location]').removeClass('invisible');
    },

    GetArcadePopupCoordinator: function GetArcadePopupCoordinator() {
        if (!this._arcadePopupCoordinator) {
            this._arcadePopupCoordinator = new HSN.ArcadePopupCoordinator();
            this._arcadePopupCoordinator.init({
                application: HSN.Instance()
            });
        }
        return this._arcadePopupCoordinator;
    },

    //checks if Android or IOS features are enabled based on feature name and version number
    GetAppFeatures: function GetAppFeatures(feature, version) {
        var appFeature = null;
        var appFeatureAndroid = window.appFeaturesAndroid && window.appFeaturesAndroid !== 'undefined' ? JSON.parse(window.appFeaturesAndroid.toString()) : null;
        var appFeatureIOS = window.appFeaturesIOS && window.appFeaturesIOS !== 'undefined' ? JSON.parse(window.appFeaturesIOS) : null;

        if (appFeatureAndroid !== null) {
            appFeature = appFeatureAndroid;
        } else if (appFeatureIOS !== null) {
            appFeature = appFeatureIOS;
        }

        if (appFeature !== null) {
            if (feature === 'localtyics') {
                if (appFeature.featurelist.localytics === version) {
                    return true;
                }
            }
            if (feature === 'social') {
                if (appFeature.featurelist.social === version) {
                    return true;
                }
            }
            if (feature === 'branch') {
                if (appFeature.featurelist.branch === version) {
                    return true;
                }
            }
            if (feature === 'gapevents') {
                if (appFeature.featurelist.gapevents === version) {
                    return true;
                }
            }
            if (feature === 'writereview') {
                if (appFeature.featurelist.writereview === version) {
                    return true;
                }
            }
        }

        return false;
    },

    ConvertLinks: function ConvertLinks() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('a:not(.native-link):not(.not-native-link)').each(function () {
            //Convert all links back to mobile domain
            if ($(this).attr('href')) {
                if ($(this).attr('href').lastIndexOf('http', 0) === -1 && $(this).attr('href').lastIndexOf('#', 0) === -1 && $(this).attr('href').lastIndexOf('//', 0) === -1 && $(this).attr('href').lastIndexOf('tel:', 0) === -1 && $(this).attr('href').lastIndexOf('javascript:', 0) === -1) {
                    $(this).attr('href', __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ConvertLink($(this).attr('href')));
                }

                if (window.isNativeApp && $(this).attr('href').lastIndexOf('javascript:', 0) === -1) {
                    $(this).addClass('native-link');
                }
            }
        });
    },

    SetApplePaySession: function SetApplePaySession(session) {
        this._applePaySession = session;
    },

    GetApplePaySession: function GetApplePaySession() {
        return this._applePaySession;
    },

    SetAccountStatusData: function SetAccountStatusData(data) {
        this._accountStatusData = data;
    },

    GetAccountStatusData: function GetAccountStatusData() {
        return this._accountStatusData;
    },

    SetAccountStatusDetailData: function SetAccountStatusDetailData(data) {
        this._accountStatusDetailData = data;
    },

    GetAccountStatusDetailData: function GetAccountStatusDetailData() {
        return this._accountStatusDetailData;
    },

    SetUseFullyQualifiedUrls: function SetUseFullyQualifiedUrls(data) {
        this._useFullyQualifiedUrls = data;
    },

    UseFullyQualifiedUrls: function UseFullyQualifiedUrls() {
        return this._useFullyQualifiedUrls;
    }
};

/**
* HSN.Application.EVENT = Object
*
* An enumeration of events an [[HSN.Application]] can raise:
* - FAVORITE_FAVORITED: When an item is successfully favorited.
* - FAVORITE_UNFAVORITED: When an item is successfully unfavorited.
* - FAVORITE_INITIALIZED: When an item is first displayed as favorited or not.
* - VISITOR_AUTHENTICATED: When a visitor is authenticated.
* - BAGITEM_REMOVED: When item is removed from the shopping bag.
* - BAGITEM_SAVEDFORLATER: When item is saved for later.
**/
HSN.Application.EVENT = {
    FAVORITE_FAVORITED: 'favorite:favorited',
    FAVORITE_UNFAVORITED: 'favorite:unfavorited',
    FAVORITE_INITIALIZED: 'favorite:initialized',
    VISITOR_AUTHENTICATED: 'visitor:authenticated',
    BAGITEM_ADDED: 'bagitem:added',
    BAGITEM_REMOVED: 'bagitem:removed',
    BAGITEM_SAVEDFORLATER: 'bagitem:savedforlater',
    BAGITEM_MOVEDTOBAG: 'bagitem:movedtobag',
    BAGITEM_DELETEWARRANTY: 'bagitem:deletewarranty',
    BAGITEM_KEEPSHOPPING: 'bagitem:keepshopping',
    NICKNAME_ADDED: 'nickname:added',
    VIDEO_COMPLETE: 'video:complete',
    CM_LOADED: 'cm:loaded',
    DATALAYER_LOADED: 'datalayer:loaded',
    TEALIUM_LOADED: 'tealium:loaded',
    GTM_LOADED: 'gtm:loaded',
    GOOGANALYTICS_LOADED: 'googanalytics:loaded',
    ARCADE_TICKETBALANCECHANGE: 'arcade:ticketbalancechange',
    ARCADE_HEADER_MOUSELEAVE: 'arcade:headermouseleave',
    GAP_EXECUTECOMMAND: 'gap:executecommand',
    NAVIGATION_LOADED: 'navigation:loaded',
    ON_NAVIGATION_MENU_OPENED: 'navigation:menu_opened',
    ON_NAVIGATION_LOADED: 'navigation:loaded',
    ON_GOOGLE_API_JS_CLIENT_LOADED: 'googlejsclientapi:loaded',
    VIRTUAL_PAGE_VIEW: 'virtualpageview'
};

/***/ }),

/***/ "QfMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.AccountService = function () {};

HSN.Service.AccountService.prototype = {
    SaveChangesV2: function SaveChangesV2(data, config) {
        this._send('/myaccount/update/update-password/', data, config);
    },
    SaveChanges: function SaveChanges(oldPassword, newPassword, confirmPassword, config) {
        this._send('/myaccount/update/update-password/', { oldPassword: oldPassword, newPassword: newPassword, confirmPassword: confirmPassword }, config);
    },

    RemoveAddress: function RemoveAddress(addressId, config) {
        this._send('/myaccount/address-book/remove-address', { identity: addressId }, config);
    },

    GetAddressList: function GetAddressList(data, config) {
        this._get('/myaccount/address-book/address-list', data, config);
    },
    GetEditAddressForm: function GetEditAddressForm(addressIdentity, hideTitle, config) {
        this._get('/checkout/add-edit-address', { addressIdentity: addressIdentity, partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetAddAddressForm: function GetAddAddressForm(hideTitle, config) {
        this._get('/checkout/add-edit-address', { partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetEditPaymentForm: function GetEditPaymentForm(paymentIdentity, hideTitle, config) {
        this._get('/checkout/add-edit-payment', { paymentIdentity: paymentIdentity, partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetAddPaymentForm: function GetAddPaymentForm(data, config) {
        this._get('/checkout/add-edit-payment', data, config);
    },
    GetAccessAndDevicesForm: function GetAccessAndDevicesForm(config) {
        this._get('/myaccount/devices-access', {}, config);
    },
    RemoveSession: function RemoveSession(sessionIdentity, config) {
        this._send('/myaccount/devices-access/remove', { sessionIdentity: sessionIdentity }, config);
    },
    /*=====Autoship manager methods=====*/
    AutoshipEnrollmentCancel: function AutoshipEnrollmentCancel(enrollmentIdentity, config) {
        this._send('/myaccount/autoship-manager/cancel-enrollment/' + enrollmentIdentity, {}, config);
    },
    AutoshipToggleShipment: function AutoshipToggleShipment(enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/toggle-shipment/' + enrollmentIdentity, data, config);
    },
    AutoshipEditShipment: function AutoshipEditShipment(enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/edit-shipment/' + enrollmentIdentity, data, config);
    },
    AutoshipShipmentChangeAddress: function AutoshipShipmentChangeAddress(enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/shipment-change-address/' + enrollmentIdentity, data, config);
    },
    AutoshipChangeAddress: function AutoshipChangeAddress(enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/change-address/' + enrollmentIdentity, data, config);
    },
    AutoshipChangePayment: function AutoshipChangePayment(enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/change-payment/' + enrollmentIdentity, data, config);
    },
    AutoshipGetEnrollment: function AutoshipGetEnrollment(enrollmentIdentity, data, config) {
        this._get('/myaccount/autoship-manager/enrollment-get/' + enrollmentIdentity, data, config);
    },
    /*=====END Autoship manager methods=====*/
    /*=====Flexpay manager methods=====*/
    SubmitFlexPayment: function SubmitFlexPayment(data, config) {
        this._send('/myaccount/flex-manager/pay-now', data, config);
    },
    FlexPayChangePayment: function FlexPayChangePayment(data, config) {
        this._send('/myaccount/flex-manager/change-card', data, config);
    },
    FlexPayGetProcessingPage: function FlexPayGetProcessingPage(data, config) {
        this._get('/myaccount/flexpay-manager/pay-now/processing/' + data.orderIdentity, $.param(data, true), config);
    },
    FlexPayGetOrder: function FlexPayGetOrder(orderIdentity, config) {
        this._get('/myaccount/flexpay-manager/order/' + orderIdentity, {}, config);
    },
    /*=====END Flexpay manager methods=====*/
    SavePhoneBook: function SavePhoneBook(data, config) {
        this._send('/myaccount/phone-book/save', data, config);
    },
    CancelOrder: function CancelOrder(data, config) {
        this._send('/myaccount/cancel-order', data, config);
    },

    UpdateEmail: function UpdateEmail(data, config) {
        this._send('/myaccount/update/update-email/', data, config);
    },

    UpdateAlertStatus: function UpdateAlertStatus(EventId, StatusId, config) {
        this._send('/myaccount/alerts/update-alert-status', { eventid: EventId, statusid: StatusId }, config);
    },

    SaveBrandChanges: function SaveBrandChanges(data, config) {
        this._send('/myaccount/compref/brands/save-selections', data, config);
    },

    SaveEmailPreferenceChanges: function SaveEmailPreferenceChanges(data, config) {
        this._send('/myaccount/compref/email/save-selections', data, config);
    },

    SaveNickname: function SaveNickname(Nickname, GuidelinesAccepted, config) {
        this._send('/myaccount/update/nickname', { nickname: Nickname, guidelinesaccepted: GuidelinesAccepted }, config);
    },

    UpdateProfile: function UpdateProfile(BirthdayMonth, BirthdayDay, City, PhotoName, ThumbnailName, HostServer, AboutMe, ShowProfileFlag, ShowPostsFlag, ShowFavoritesFlag, ShowScoresFlag, ShowBadgesFlag, ShowReviewsFlag, config) {
        this._send('/myaccount/update/profile', {
            birthdayMonth: BirthdayMonth,
            birthdayDay: BirthdayDay,
            city: City,
            photoName: PhotoName,
            thumbnailName: ThumbnailName,
            hostServer: HostServer,
            aboutme: AboutMe,
            showProfileFlag: ShowProfileFlag,
            showPostsFlag: ShowPostsFlag,
            showFavoritesFlag: ShowFavoritesFlag,
            showScoresFlag: ShowScoresFlag,
            showBadgesFlag: ShowBadgesFlag,
            showReviewsFlag: ShowReviewsFlag
        }, config);
    },

    UploadProfileImage: function UploadProfileImage(data, config) {
        this._sendMixedData('/myaccount/profile-image-upload/save', data, config);
    },

    Register: function Register(data, config) {
        this._send('/account/register', data, config);
    },

    SaveAdsCreditCard: function SaveAdsCreditCard(data, config) {
        this._send('/myaccount/creditcard', data, config);
    },

    GetSingleOrder: function GetSingleOrder(data, config) {
        this._send('/myaccount/single-order/get-order', data, config);
    },

    ResetCookieInformation: function ResetCookieInformation(data, config) {
        this._send('/signin/reset', data, config);
    },

    Signin: function Signin(data, config) {
        this._send('/signin', data, config);
    },

    SubmitForgotPassword: function SubmitForgotPassword(data, config) {
        this._send('/account/forgot-password', data, config);
    },

    GetForgotPasswordVerify: function GetForgotPasswordVerify(data, config) {
        this._get('/account/forgot-password-verify', data, config);
    },

    SubmitForgotPasswordVerify: function SubmitForgotPasswordVerify(data, config) {
        this._send('/account/forgot-password-verify', data, config);
    },

    ValidateAccountInformation: function ValidateAccountInformation(data, config) {
        this._send('/account/validate-info', data, config);
    },
    ValidatePaymentInformation: function ValidatePaymentInformation(data, config) {
        this._send('/account/validate-payment-info', data, config);
    },

    _send: function _send(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, _error) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, xhr);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _sendMixedData: function _sendMixedData(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            contentType: false,
            processData: false,
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, _error2) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, xhr);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _get: function _get(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'html',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error() {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback);
                }
            }
        });
    }
};

/***/ }),

/***/ "QrS1":
/***/ (function(module, exports) {

/**
 * HSN.Widget
 **/
HSN.Widget = HSN.Widget = HSN.Widget || {};
HSN.Widget.AddressManagement = HSN.Widget.AddressManagement = HSN.Widget.AddressManagement || {};

/***/ }),

/***/ "R3LS":
/***/ (function(module, exports) {

/*! Copyright (c) 2011 Piotr Rochala (https://rocha.la)
 * Dual licensed under the MIT (https://www.opensource.org/licenses/mit-license.php)
 * and GPL (https://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.0
 *
 */
(function($) {

  jQuery.fn.extend({
    slimScroll: function(options) {

      var defaults = {

        // width in pixels of the visible scroll area
        width : 'auto',

        // height in pixels of the visible scroll area
        height : '250px',

        // width in pixels of the scrollbar and rail
        size : '7px',

        // scrollbar color, accepts any hex/color value
        color: '#000',

        // scrollbar position - left/right
        position : 'right',

        // distance in pixels between the side edge and the scrollbar
        distance : '1px',

        // default scroll position on load - top / bottom / $('selector')
        start : 'top',

        // sets scrollbar opacity
        opacity : .4,

        // enables always-on mode for the scrollbar
        alwaysVisible : false,

        // check if we should hide the scrollbar when user is hovering over
        disableFadeOut : false,

        // sets visibility of the rail
        railVisible : false,

        // sets rail color
        railColor : '#333',

        // sets rail opacity
        railOpacity : .2,

        // whether  we should use jQuery UI Draggable to enable bar dragging
        railDraggable : true,

        // defautlt CSS class of the slimscroll rail
        railClass : 'slimScrollRail',

        // defautlt CSS class of the slimscroll bar
        barClass : 'slimScrollBar',

        // defautlt CSS class of the slimscroll wrapper
        wrapperClass : 'slimScrollDiv',

        // check if mousewheel should scroll the window if we reach top/bottom
        allowPageScroll : false,

        // scroll amount applied to each mouse wheel step
        wheelStep : 20,

        // scroll amount applied when user is using gestures
        touchScrollStep : 200,

        // sets border radius
        borderRadius: '7px',

        // sets border radius of the rail
        railBorderRadius : '7px'
      };

      var o = $.extend(defaults, options);

      // do it for every element that matches selector
      this.each(function(){

      var isOverPanel, isOverBar, isDragg, queueHide, touchDif,
        barHeight, percentScroll, lastScroll,
        divS = '<div></div>',
        minBarHeight = 30,
        releaseScroll = false;

        // used in event handlers and for better minification
        var me = $(this);

        // ensure we are not binding it again
        if (me.parent().hasClass(o.wrapperClass))
        {
            // start from last bar position
            var offset = me.scrollTop();

            // find bar and rail
            bar = me.parent().find('.' + o.barClass);
            rail = me.parent().find('.' + o.railClass);

            getBarHeight();

            // check if we should scroll existing instance
            if ($.isPlainObject(options))
            {
              // Pass height: auto to an existing slimscroll object to force a resize after contents have changed
              if ( 'height' in options && options.height == 'auto' ) {
                me.parent().css('height', 'auto');
                me.css('height', 'auto');
                var height = me.parent().parent().height();
                me.parent().css('height', height);
                me.css('height', height);
              }

              if ('scrollTo' in options)
              {
                // jump to a static point
                offset = parseInt(o.scrollTo);
              }
              else if ('scrollBy' in options)
              {
                // jump by value pixels
                offset += parseInt(o.scrollBy);
              }
              else if ('destroy' in options)
              {
                // remove slimscroll elements
                bar.remove();
                rail.remove();
                me.unwrap();
                return;
              }

              // scroll content by the given offset
              scrollContent(offset, false, true);
            }

            return;
        }

        // optionally set height to the parent's height
        o.height = (o.height == 'auto') ? me.parent().height() : o.height;

        // wrap content
        var wrapper = $(divS)
          .addClass(o.wrapperClass)
          .addClass("fade")
          .css({
            position: 'relative',
            overflow: 'hidden',
            width: o.width,
            height: o.height
          });

        // update style for the div
        me.css({
          overflow: 'hidden',
          width: o.width,
          height: o.height
        });

        // create scrollbar rail
        var rail = $(divS)
          .addClass(o.railClass)
          .css({
            width: o.size,
            height: '100%',
            position: 'absolute',
            top: 0,
            display: (o.alwaysVisible && o.railVisible) ? 'block' : 'none',
            'border-radius': o.railBorderRadius,
            background: o.railColor,
            opacity: o.railOpacity,
            zIndex: 90
          });

        // create scrollbar
        var bar = $(divS)
          .addClass(o.barClass)
          .css({
            background: o.color,
            width: o.size,
            position: 'absolute',
            top: 0,
            opacity: o.opacity,
            display: o.alwaysVisible ? 'block' : 'none',
            'border-radius' : o.borderRadius,
            BorderRadius: o.borderRadius,
            MozBorderRadius: o.borderRadius,
            WebkitBorderRadius: o.borderRadius,
            zIndex: 99
          });

        // set position
        var posCss = (o.position == 'right') ? { right: o.distance } : { left: o.distance };
        rail.css(posCss);
        bar.css(posCss);

        // wrap it
        me.wrap(wrapper);

        // append to parent div
        me.parent().append(bar);
        me.parent().append(rail);

        // make it draggable and no longer dependent on the jqueryUI
        if (o.railDraggable){
          bar.on("mousedown", function(e) {
            var $doc = $(document);
            isDragg = true;
            t = parseFloat(bar.css('top'));
            pageY = e.pageY;

            $doc.on("mousemove.slimscroll", function(e){
              currTop = t + e.pageY - pageY;
              bar.css('top', currTop);
              scrollContent(0, bar.position().top, false);// scroll content
            });

            $doc.on("mouseup.slimscroll", function(e) {
              isDragg = false;hideBar();
              $doc.off('.slimscroll');
            });
            return false;
          }).on("selectstart.slimscroll", function(e){
            e.stopPropagation();
            e.preventDefault();
            return false;
          });
        }

        // on rail over
        rail.hover(function(){
          showBar();
        }, function(){
          hideBar();
        });

        // on bar over
        bar.hover(function(){
          isOverBar = true;
        }, function(){
          isOverBar = false;
        });

        // show on parent mouseover
        me.hover(function(){
          isOverPanel = true;
          showBar();
          hideBar();
        }, function(){
          isOverPanel = false;
          hideBar();
        });

        // support for mobile
        me.on('touchstart', function(e,b){
          if (e.originalEvent.touches.length)
          {
            // record where touch started
            touchDif = e.originalEvent.touches[0].pageY;
          }
        });

        me.on('touchmove', function(e){
          // prevent scrolling the page if necessary
          if(!releaseScroll)
          {
  		      e.originalEvent.preventDefault();
		      }
          if (e.originalEvent.touches.length)
          {
            // see how far user swiped
            var diff = (touchDif - e.originalEvent.touches[0].pageY) / o.touchScrollStep;
            // scroll content
            scrollContent(diff, true);
            touchDif = e.originalEvent.touches[0].pageY;
          }
        });

        // set up initial height
        getBarHeight();

        // check start position
        if (o.start === 'bottom')
        {
          // scroll content to bottom
          bar.css({ top: me.outerHeight() - bar.outerHeight() });
          scrollContent(0, true);
        }
        else if (o.start !== 'top')
        {
          // assume jQuery selector
          scrollContent($(o.start).position().top, null, true);

          // make sure bar stays hidden
          if (!o.alwaysVisible) { bar.hide(); }
        }

        // attach scroll events
        attachWheel();

        function _onWheel(e)
        {
          // use mouse wheel only when mouse is over
            if(!jQuery.contains(document, me[0])) {
                detachWheel();
                return;
            } else if(!isOverPanel) {
                 return;
            }

          var e = e || window.event;

          var delta = 0;
          if (e.wheelDelta) { delta = -e.wheelDelta/120; }
          if (e.detail) { delta = e.detail / 3; }

          var target = e.target || e.srcTarget || e.srcElement;
          if ($(target).closest('.' + o.wrapperClass).is(me.parent())) {
            // scroll content
            scrollContent(delta, true);
          }

          // stop window scroll
          if (e.preventDefault && !releaseScroll) { e.preventDefault(); }
          if (!releaseScroll) { e.returnValue = false; }
        }

        function scrollContent(y, isWheel, isJump)
        {
          releaseScroll = false;
          var delta = y;
          var maxTop = me.outerHeight() - bar.outerHeight();

          if (isWheel)
          {
            // move bar with mouse wheel
            delta = parseInt(bar.css('top')) + y * parseInt(o.wheelStep) / 100 * bar.outerHeight();

            // move bar, make sure it doesn't go out
            delta = Math.min(Math.max(delta, 0), maxTop);

            // if scrolling down, make sure a fractional change to the
            // scroll position isn't rounded away when the scrollbar's CSS is set
            // this flooring of delta would happened automatically when
            // bar.css is set below, but we floor here for clarity
            delta = (y > 0) ? Math.ceil(delta) : Math.floor(delta);

            // scroll the scrollbar
            bar.css({ top: delta + 'px' });
          }

          // calculate actual scroll amount
          percentScroll = parseInt(bar.css('top')) / (me.outerHeight() - bar.outerHeight());
          delta = percentScroll * (me[0].scrollHeight - me.outerHeight());
          
          if (percentScroll >= 1 || isNaN(percentScroll)) {
            $(me).closest('.' + o.wrapperClass).removeClass('fade');
          }
          else {
            $(me).closest('.' + o.wrapperClass).addClass('fade');
          }
          
          if (isJump)
          {
            delta = y;
            var offsetTop = delta / me[0].scrollHeight * me.outerHeight();
            offsetTop = Math.min(Math.max(offsetTop, 0), maxTop);
            bar.css({ top: offsetTop + 'px' });
          }

          // scroll content
          me.scrollTop(delta);

          // fire scrolling event
          me.trigger('slimscrolling', ~~delta);

          // ensure bar is visible
          showBar();

          // trigger hide when scroll is stopped
          hideBar();
        }

        function attachWheel()
        {
          if (window.addEventListener)
          {
            this.addEventListener('DOMMouseScroll', _onWheel, false );
            this.addEventListener('mousewheel', _onWheel, false );
            this.addEventListener('MozMousePixelScroll', _onWheel, false );
          }
          else
          {
            document.attachEvent("onmousewheel", _onWheel)
          }
        }

        function detachWheel() {
            if (window.removeEventListener) {
                this.removeEventListener('DOMMouseScroll', _onWheel, false);
                this.removeEventListener('mousewheel', _onWheel, false);
                this.removeEventListener('MozMousePixelScroll', _onWheel, false);
            }
        }

        function getBarHeight()
        {
          // calculate scrollbar height and make sure it is not too small
          barHeight = Math.max((me.outerHeight() / me[0].scrollHeight) * me.outerHeight(), minBarHeight);
          bar.css({ height: barHeight + 'px' });

          // hide scrollbar if content is not long enough
          var display = barHeight == me.outerHeight() ? 'none' : 'block';
          bar.css({ display: display });
        }

        function showBar()
        {
          // recalculate bar height
          getBarHeight();
          clearTimeout(queueHide);

          // when bar reached top or bottom
          if (percentScroll == ~~percentScroll)
          {
            //release wheel
            releaseScroll = o.allowPageScroll;

            // publish approporiate event
            if (lastScroll != percentScroll)
            {
                var msg = (~~percentScroll == 0) ? 'top' : 'bottom';
                me.trigger('slimscroll', msg);
            }
          }
          else
          {
            releaseScroll = false;
          }
          lastScroll = percentScroll;

          // show only when required
          if(barHeight >= me.outerHeight()) {
            //allow window scroll
            releaseScroll = true;
            return;
          }
          bar.stop(true,true).fadeIn('fast');
          if (o.railVisible) { rail.stop(true,true).fadeIn('fast'); }
        }

        function hideBar()
        {
          // only hide when options allow it
          if (!o.alwaysVisible)
          {
            queueHide = setTimeout(function(){
              if (!(o.disableFadeOut && isOverPanel) && !isOverBar && !isDragg)
              {
                bar.fadeOut('slow');
                rail.fadeOut('slow');
              }
            }, 1000);
          }
        }

      });

      // maintain chainability
      return this;
    }
  });

  jQuery.fn.extend({
    slimscroll: jQuery.fn.slimScroll
  });

})(jQuery);


/***/ }),

/***/ "RlAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Widget.PaymentList
    *
    * Encapsulates the common functionality of the PaymentList Widget.
    **/
HSN.Widget.PaymentList = function () {
    var application;
    var container;
    var paymentService;
    var deviceInformation;
    var showSelectButton;
    var showDefaultCardChecked;
    var showAddPaypal;
    var showMakeDefault;
    var eventIdentity;
    var addSelector = '.add-payment';
    var hasPaypalSelector = '.has-paypal';
    var editSelector = '.edit-item';
    var removeSelector = '.remove-payment';
    var selectSelector = '.select-payment';
    var makeDefaultSelector = '.make-payment-default';
    var paypalCardType = 'PY';
    var hasPaypalHtml = '<div><div id="paypal-edit-message-modal" class="module">' + '<div class="paypal-edit-header">To edit or remove PayPal</div>' + '<div>Manage or remove your PayPal Account Information at <a target="blank" href="https://www.paypal.com")">www.PayPal.com</a></div>' + '</div></div>';
    /**
        * new HSN.Widget.PaymentList.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.PaymentList]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        deviceInformation = application.DeviceInformation;
        showSelectButton = config.showSelectButton;
        showDefaultCardChecked = config.showDefaultCardChecked;
        showAddPaypal = config.showAddPaypal;
        showMakeDefault = config.showMakeDefault;
        eventIdentity = config.eventIdentity || '';
        paymentService = application._getPaymentService();
        bindEvents();
    }

    function bindEvents() {
        container.on('click', addSelector, HandleAdd);
        container.on('click', editSelector, HandleEdit);
        container.on('click', removeSelector, HandleRemove);
        container.on('change', selectSelector, HandleSelect);
        container.on('click', makeDefaultSelector, HandleMakeDefault);
        container.on('click', hasPaypalSelector, HandleHasPaypal);
    }
    function HandleAdd() {
        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.ADD_SELECTED);
        return false;
    }
    function HandleEdit() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        var cardType = $(this).closest('.payment-method-container').data('cardtype');
        if (cardType === paypalCardType) {
            HandleHasPaypal();
        } else {
            application.Events.Trigger(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, identity, this);
        }
        return false;
    }
    function HandleRemove() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        var cardType = $(this).closest('.payment-method-container').data('cardtype');
        if (cardType === paypalCardType) {
            HandleHasPaypal();
        } else {
            HSN.SetWait();
            var numberOfCards = CountPaymentMethods();
            paymentService.RemovePaymentMethod({ paymentIdentity: identity }, {
                callback: function callback(data) {
                    if (data.success) {
                        Refresh();
                        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, identity, numberOfCards <= 1);
                    } else {
                        HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to remove your payment method, please try again.');
                    }
                },
                errorCallback: function errorCallback() {
                    HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to remove your payment method, please try again.');
                },
                scope: this
            });
        }
        return false;
    }
    function HandleSelect() {
        if (!$(this).is(':checked')) {
            $(this).prop('checked', 'checked');
            $(this).val(true);
            return false;
        }
        $(selectSelector, container).each(function () {
            $(this).prop('checked', false);
        });
        $(this).prop('checked', 'checked');
        $(this).val(true);
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        application.Events.Trigger(HSN.Widget.PaymentList.EVENT.SELECTED, identity, eventIdentity);
        return true;
    }
    function HandleMakeDefault() {
        var identity = $(this).closest('.payment-method-container').data('payment-id');
        HSN.SetWait();
        paymentService.SelectPayment({ paymentIdentity: identity }, {
            callback: function callback(data) {
                HSN.RemoveWait();
                if (data.success) {
                    Refresh();
                    application.Events.Trigger(HSN.Widget.PaymentList.EVENT.DEFAULT_CHANGED);
                } else {
                    alert('Unfortunately there was an error attempting to select your payment method, please try again.');
                }
            },
            errorCallback: function errorCallback() {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to select your payment method, please try again.');
            },
            scope: this
        });
        return false;
    }
    function HandleHasPaypal() {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(hasPaypalHtml, false);
        if (deviceInformation.IsMobile) {
            $('#paypal-edit-message-modal', modalReference.Content).addClass('mobile');
        }
        return false;
    }
    function Refresh() {
        HSN.SetWait();
        paymentService.GetPaymentList({ showSelect: showSelectButton, showMakeDefault: showMakeDefault, showDefaultCardChecked: showDefaultCardChecked, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
            callback: function callback(data) {
                container.parent().html(data);
                if (deviceInformation.IsMobile) {
                    $('html,body').animate({
                        scrollTop: container.offset().top - HSN.GetMobileHeaderOffset()
                    }, 500);
                }
                application.Events.Trigger(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED);
            },
            errorCallback: function errorCallback() {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to load the content, please try again.');
            },
            scope: this
        });
        HSN.RemoveWait();
    }
    function CountPaymentMethods() {
        return $('.payment-method-container', container).length;
    }
    function Destroy() {
        container.off('click', addSelector, HandleAdd);
        container.off('click', editSelector, HandleEdit);
        container.off('click', removeSelector, HandleRemove);
        container.off('change', selectSelector, HandleSelect);

        application = container = paymentService = null;
    }
    return {
        init: init,
        Refresh: Refresh,
        Destroy: Destroy
    };
};

HSN.Widget.PaymentList.EVENT = {
    ADD_SELECTED: 'HSN.Widget.PaymentList:ADD_SELECTED',
    EDIT_SELECTED: 'HSN.Widget.PaymentList:EDIT_SELECTED',
    SELECTED: 'HSN.Widget.PaymentList:SELECTED',
    REMOVE_SUCCESS: 'HSN.Widget.PaymentList:REMOVE_SUCCESS',
    LIST_REFRESHED: 'HSN.Widget.PaymentList:LIST_REFRESHED',
    DEFAULT_CHANGED: 'HSN.Widget.PaymentList:DEFAULT_CHANGED'
};

/***/ }),

/***/ "SLxZ":
/***/ (function(module, exports) {

//Usage:
//To get Cookie value: Hsn.Com.Cookie('name').Value();
//To set Cooke value:
//      Hsn.Com.Cookie('name').Set('value');
//      Hsn.Com.Cookie('name').Set('value', expiresInDays);
//
//To get Crumb value: Hsn.Com.Cookie('name').Crumb('name').Value();
//To set Crumb value:
//      Hsn.Com.Cookie('name').Crumb('name').Set('value');
//      Hsn.Com.Cookie('name').Crumb('name').Set('value', expiresInDays);
window.CookieAccessor = function (CookieName) {
    if (!CookieName) {
        throw new Error(1000, "CookieName is " + CookieName);
    }
    var search = CookieName + "=";
    var cookie = null;
    if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search);
        // if cookie exists
        if (offset != -1) {
            offset += search.length;
            // set index of beginning of value
            var end = document.cookie.indexOf(";", offset);
            // set index of end of cookie value
            if (end == -1) end = document.cookie.length;
            cookie = unescape(document.cookie.substring(offset, end));
        }
    };

    function _getExpires(expire) {
        var date = new Date();
        var days = 1000 * 60 * 60 * 24;
        return new Date(date.getTime() + (expire ? expire : 7) * days);
    };

    return {
        Delete: function Delete() {
            var expires = new Date();
            expires.setTime(expires.getTime() - 1);
            document.cookie = CookieName += "=;path=/;domain=.hsn.com;expires=" + expires.toGMTString();
        },
        Value: function Value() {
            return cookie;
        },
        Set: function Set(value, expire) {
            document.cookie = CookieName + "=" + value + ";path=/;domain=.hsn.com" + (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
        },
        Crumbs: function Crumbs() {
            var crumbNames = [];
            var crumbs = cookie.split('&');
            crumbs.each(function (crumb) {
                crumbNames.push(crumb.split('=')[0]);
            });
            return crumbNames;
        },
        Crumb: function Crumb(CrumbName) {
            if (!CrumbName) {
                throw new Error(1000, "CrumbName is " + CrumbName);
            }
            return {
                Delete: function Delete() {
                    if (!cookie) {
                        return;
                    }
                    var idx = cookie.indexOf(CrumbName);
                    if (idx > -1) {
                        var replacement = cookie.substr(idx);
                        idx = replacement.indexOf('&');
                        if (idx > -1) {
                            replacement = replacement.substr(0, idx);
                        }
                        cookie = cookie.replace(replacement, '');
                    }
                    document.cookie = CookieName + "=" + cookie;
                },
                Set: function Set(value, expire) {
                    if (!cookie) {
                        document.cookie = CookieName + "=" + CrumbName + "=" + value + ";path=/;domain=.hsn.com" + (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
                    } else {
                        var idx = cookie.indexOf(CrumbName);
                        if (idx > -1) {
                            var replacement = cookie.substr(idx);
                            idx = replacement.indexOf('&');
                            if (idx > -1) {
                                replacement = replacement.substr(0, idx);
                            }
                            cookie = cookie.replace(replacement, CrumbName + "=" + value);
                        } else {
                            cookie += "&" + CrumbName + "=" + value;
                        }
                        document.cookie = CookieName + "=" + cookie + ";path=/;domain=.hsn.com" + (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
                    }
                },
                Value: function Value() {
                    var ret = null;
                    if (cookie && cookie.length > 0) {
                        var crumbs = cookie.split('&');
                        if (crumbs.length > 0) {
                            for (var i = 0; i < crumbs.length; i++) {
                                var values = crumbs[i].split('=');
                                if (values[0] === CrumbName) {
                                    ret = values[1];
                                }
                            }
                        }
                    }
                    return ret;
                }
            };
        }
    };
};

/***/ }),

/***/ "TKPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
    * class HSN.EmailSignUp
    *
    * Encapsulates Email Signup and form submissions
    **/
HSN.EmailSignUp = function () {
    var application;
    var container;
    var submitElement;
    var errorElement;
    var errorConfirmElement;

    /**
        * new HSN.Widget.Calendar.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.Calendar]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML input element that will resolve to an HTML element will act as the root container for the email form
        *   - submitElement (HTMLElement): An element that represents the submit button that will post to the email controller
        *   - errorElement  (HTMLElement): An element that respresents the error element where validation errors are returned to
        **/

    function init(config) {
        application = config.application;
        container = $(config.container);
        submitElement = config.submitElement;
        errorElement = $(config.errorElement);
        errorConfirmElement = $(config.errorConfirmElement);
        bindEvents();
    }

    function bindEvents() {
        HSN.SuggestEmail('.signup-email');
        container.on('cut copy paste', '.signup-email', function () {
            return false;
        });

        container.on('cut copy paste', '.signup-confirm-email', function () {
            return false;
        });

        container.on('keydown paste', '.signup-email', function () {
            container.find('.signup-confirm-email').show();
            return true;
        });

        container.on('click', '.email-signup-submit-btn', function (e) {
            cmCreateManualLinkClickTag('/footer-noncust-EmailSignUp?cm_re=Global-_-Footer-_-EmailSignUp&amp;cm_sp=Global-_-Footer-_-EmailSignUp', 'SaleAlerts');
            var emailAddress = container.find('.signup-email').val();
            var confirmedEmailAddress = container.find('.signup-confirm-email').val();
            errorElement.html('');
            errorConfirmElement.html('');
            container.find('#signup-email').attr('aria-invalid', false);
            container.find('#signup-confirm-email').attr('aria-invalid', false);

            $.ajax('/headerfooter/emailsignup', {
                context: this,
                dataType: 'json',
                type: 'POST',
                data: { 'EmailAddress': emailAddress, 'ConfirmEmailAddress': confirmedEmailAddress, "SourceId": 57, '_ts': new Date().getTime() },
                success: function success(data) {
                    if (data.success) {
                        dataLayer.push({ 'signup_email': emailAddress });
                        HSN.DataLayer.helpers.hsnEvent(null, "EmailPromoSignupFooter", "Success", null, null);
                        container.find('input').attr('aria-invalid', false);
                        var modal = HSN.Instance().GetSignupMessageModal();
                        modal.SetElementToFocusOnClose($(e.target));
                        modal.Show("/headerfooter/signup-message/modal/get/" + btoa(emailAddress));
                        container.find('.signup-email').val('');
                        container.find('.signup-confirm-email').val('');
                        container.find('#email-error-conatiner').hide();
                        container.find('#confirm-email-error-conatiner').hide();
                        container.find('.signup-confirm-email').hide();
                        container.find('#hint').hide();
                    } else {
                        if (data.errors != null) {
                            var errorMessage = '';
                            var errorConfirmMessage = '';
                            $(data.errors).each(function (index) {
                                if (data.errors[index].toLowerCase().includes('confirm')) {
                                    errorConfirmMessage += data.errors[index] + ' ';
                                } else {
                                    errorMessage += data.errors[index] + ' ';
                                }
                            });

                            if (errorMessage.length > 0) {
                                container.find('#hint').hide();
                                errorElement.html(errorMessage);
                                container.find('#email-error-conatiner').css('display', 'flex');
                                container.find('#signup-email').attr('aria-invalid', true);
                                container.find('#signup-email').focus();
                            } else if (errorConfirmMessage.length > 0) {
                                container.find('#signup-confirm-email').focus();
                            }
                            if (errorConfirmMessage.length > 0) {
                                errorConfirmElement.html(errorConfirmMessage);
                                container.find('#confirm-email-error-conatiner').css('display', 'flex');
                                container.find('#signup-confirm-email').attr('aria-invalid', true);
                            }
                        } else alert('Unfortunately there was an error, please try again.');
                    }
                },
                error: function error() {
                    alert('Unfortunately there was an error, please try again.');
                }
            });
            return false;
        });
    }

    return {
        init: init
    };
};

/***/ }),

/***/ "TWyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class Hsn.HsnCaresDisclaimerModal
* 
* Encapsulates the functionality of a modal dialog that contains the HSN Cares Drive disclaimer info
**/
HSN.HsnCaresDisclaimerModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(HsnCaresDisclaimerModal, _super);

    //new Hsn.HsnCaresDisclaimerModal()
    function HsnCaresDisclaimerModal() {
        this.elementName = '#';
        this.name = 'HSN.HsnCaresDisclaimerModal';

        return HsnCaresDisclaimerModal.__super__.constructor.call(this);
    }

    HsnCaresDisclaimerModal.prototype._hide = function () {};

    /**
    * HSN.HsnCaresDisclaimerModal#Show(disclaimer) -> void
    * - disclaimer (string): The disclaimer to show inside of the modal...
    *
    * Display the modal and load in the disclaimer string
    **/
    HsnCaresDisclaimerModal.prototype._show = function (disclaimer) {
        var __scope = this;

        var htmlStyle = "<style>.articletext {width: 600px;padding: 10px;color: #666; font-family: Helvetica, Arial; font-size:12px; line-height:22px;}" + "#breadbox: {display:none;}" + "@media screen and (max-width: 500px) {div.articletext {width: auto;}}</style>";

        var htmlContent = '<div align="left" class="articletext"><p>' + disclaimer + '</p></div>';

        var htmlToDisplay = htmlStyle + htmlContent;

        __scope.Root.removeClass('loading');
        __scope.DisplayModal(htmlToDisplay, 0);
    };

    HsnCaresDisclaimerModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time, function () {
            __scope.Center();
            __scope.Content.animate({ opacity: 1 });
        }, function () {});
    };

    return HsnCaresDisclaimerModal;
}(HSN.Modal);

/***/ }),

/***/ "TzR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.FaqEmailFriendsModal
*
* Encapsulates the functionality of a modal dialog that contains faq email friend form
**/
HSN.FaqEmailFriendsModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(faqEmailFriendsModal, parent);

    /**
    * new HSN.faqEmailFriendsModal()
    **/
    function faqEmailFriendsModal() {
        this.name = 'HSN.FaqEmailFriendsModal';
        faqEmailFriendsModal.__super__.constructor.call(this);
    }

    faqEmailFriendsModal.prototype._hide = function () {};

    /**
    *
    * Display the modal for customer to input information
    **/
    faqEmailFriendsModal.prototype._show = function (url, id) {

        var scope = this;
        faqEmailFriendsModal.url = url;
        faqEmailFriendsModal.id = id;

        $.ajax(url, {
            dataType: 'html',
            data: { 'AnswerId': id },
            success: function success(htmlData) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(htmlData, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for recommend a friend, use ajax to retrieve response, and update modal content
    **/
    faqEmailFriendsModal.prototype.SubmitEmailFriendForm = function (saveData) {

        var scope = this;
        var emailFriendForm = $('form', scope.Root);
        var formData = emailFriendForm.serializeArray();
        //console.log(formData);
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/faqs/emailfriend/email-friend-post',
            dataType: 'json',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        }).done(function (data) {
            if (data.success) {
                $('div.errors').remove();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModal").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#EmailFriendModalSucess").show();
            } else {
                HSN.AddErrorTreatment('#emailFriendForm', data);
            }
        }).fail(function () {
            alert('error submitting the request');
        });
    };

    faqEmailFriendsModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {
            //scope.Center();
        });
    };
    return faqEmailFriendsModal;
}(HSN.Modal);

/***/ }),

/***/ "U0cD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.WriteReviewModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.WriteReviewModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(WriteReviewModal, parent);

    /**
    * new HSN.WriteReviewModal()
    **/
    function WriteReviewModal() {
        this.name = 'HSN.WriteReviewModal';
        this.data;

        return WriteReviewModal.__super__.constructor.call(this);
    }

    /**
    * HSN.WriteReviewModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    WriteReviewModal.prototype._show = function (ajaxData, url) {
        var scope = this;
        this.ajaxData = ajaxData || this.ajaxData;

        var writeReviewPromise = __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "SWwI"));

        var ajax = $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: this.ajaxData
        });

        Promise.all([ajax, writeReviewPromise]).then(function (_ref) {
            var data = _ref[0],
                WriteReview = _ref[1];

            scope.Root.removeClass('loading');
            scope.DisplayModal(data, 0);
        }).catch(function () {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
            $('#modal-mask').remove();
        });
    };

    /**
    * Submit for review modal form, use ajax to retrieve response, and update modal content
    **/
    WriteReviewModal.prototype.SubmitReviewForm = function () {
        var scope = this;
        var reviewForm = $('form', scope.Root);

        //manually run client validation since we arent running submit operation
        if (!reviewForm.valid()) return;

        $.ajax({
            type: 'POST',
            url: '/writereview?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: reviewForm.serialize()
        }).done(function (data) {
            if (data) {
                if (!$(data).find('.validation-summary-errors').data('valmsgSummary')) {}
            }

            scope.DisplayModal(data, 0);
        }).fail(function () {
            alert('error submitting review');
        });
    };

    var onContentKeydown = {};

    WriteReviewModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            //needed for unobtrusive client side validation for ajax loaded form
            $.validator.unobtrusive.parse($('form', scope.Root));
            scope.Center();
            scope.Content.animate({ opacity: 1 }, function () {
                scope.Close.focus();

                if (typeof onContentKeydown !== 'function') {
                    onContentKeydown = function onContentKeydown(e) {
                        if (e.key === 'Tab') {
                            e.preventDefault();

                            scope.Close.focus();
                        }
                    };

                    scope.Content.on('keydown', onContentKeydown);
                }
            });
        }, function () {
            //scope.Center();
        });
    };

    return WriteReviewModal;
}(HSN.Modal);

/***/ }),

/***/ "UoOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccountNavigation_Cabinet_js__ = __webpack_require__("iWJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// define EVENTs



/**
    * class HSN.ArcadePopupCoordinator
    *
    * Encapsulates the common functionality of the ArcadePopupCoordinator.
    **/
HSN.ArcadePopupCoordinator = function () {
    var application;
    var isFlyoutOpen;
    var isCabinetDrawerOpen;
    var modalOpenCount;

    function reportPopupState() {
        if (!isFlyoutOpen && !isCabinetDrawerOpen && modalOpenCount === 0) {
            application.Events.Trigger(HSN.ArcadePopupCoordinator.EVENT.POPUP_STATE_CLOSED);
        } else {
            application.Events.Trigger(HSN.ArcadePopupCoordinator.EVENT.POPUP_STATE_OPEN);
        }
    }

    function init(config) {
        application = config.application;
        isFlyoutOpen = false;
        isCabinetDrawerOpen = false;
        modalOpenCount = 0;

        /*application.Events.On(HSN.Modal.EVENT.MODAL_OPEN, function () {
            modalOpenCount = modalOpenCount + 1;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
            modalOpenCount = (modalOpenCount - 1 < 0) ? 0 : modalOpenCount - 1;
            reportPopupState();
            return;
        });*/
        application.Events.On(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, function () {
            isCabinetDrawerOpen = true;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.AccountNavigation.Cabinet.EVENT.AFTER_CLOSE, function () {
            isCabinetDrawerOpen = false;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Flyout.EVENT.BEFORE_OPEN, function () {
            isFlyoutOpen = true;
            reportPopupState();
            return;
        });
        application.Events.On(HSN.Flyout.EVENT.BEFORE_CLOSE, function () {
            isFlyoutOpen = false;
            reportPopupState();
            return;
        });
    }

    return {
        init: init,
        checkPopupState: reportPopupState
    };
};

HSN.ArcadePopupCoordinator.EVENT = {
    POPUP_STATE_OPEN: 'HSN.PopupCoordinator.EVENT.POPUPS_OPEN',
    POPUP_STATE_CLOSED: 'HSN.PopupCoordinator.EVENT.POPUPS_CLOSED'
};

/***/ }),

/***/ "UxLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.WarrantyModal
*
* Encapsulates the functionality of a modal dialog that contains the N.E.W NISC.
**/
HSN.WarrantyModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(WarrantyModal, _super);

    function WarrantyModal() {
        /**
        * new HSN.WarrantyModal()
        **/
        return WarrantyModal.__super__.constructor.call(this);
    }

    /**
    * HSN.WarrantyModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    WarrantyModal.prototype._show = function (webPId, warrWebPId, prodPrice, sourceId, url) {

        $.ajax(url + "/Get?" + new Date().getTime(), {
            context: this,
            dataType: 'html',
            data: { 'WebPId': webPId, 'WarrWebPId': warrWebPId, 'ProdPrice': prodPrice, 'SourceLocation': sourceId },
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return WarrantyModal;
}(HSN.Modal);

/***/ }),

/***/ "Vk0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_AddToBag_js__ = __webpack_require__("Z47Q");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



window.HSN = window.HSN || {};

/**
* class HSN.DynamicCarouselHelper
* Helper class for Dynamic Carousels
**/
HSN.DynamicCarouselHelper = function () {
    var deviceInfo = HSN.Instance().DeviceInformation;
    var pageName = dataLayer[0].page_name;
    var pageType = dataLayer[0].page_type;
    var isCartPage = pageName === 'Cart' && pageType === 'Checkout';
    var isOrderReviewPage = pageName === 'Order Review' && pageType === 'Checkout';
    var isMobile = deviceInfo.IsMobile && !deviceInfo.IsTablet;

    var handlerAddToBag = function handlerAddToBag(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var cur = $(ev.currentTarget);
        var data = cur.data();

        HSN.Instance().GetProductPreviewOffCanvas().Show(data.productId);

        return false;
    };

    var attachAddToBagHandlers = function attachAddToBagHandlers(container) {
        container.on('click', '.dc-add-to-bag', handlerAddToBag);
    };

    var enable = function enable(config) {
        if (!config.container) {
            return;
        }
        if (config.addToBag) {
            attachAddToBagHandlers(config.container);
        }
    };

    return {
        Enable: enable
    };
};

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "Xrr0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.OrdersReprintLabelModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.OrdersReprintLabelModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(OrdersReprintLabelModal, _super);

    function OrdersReprintLabelModal() {
        return OrdersReprintLabelModal.__super__.constructor.call(this);
    }

    /**
    * HSN.OrdersReprintLabelModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    OrdersReprintLabelModal.prototype._show = function (orderid) {
        $.ajax('/myaccount/orders/reprintlabel?orderid=' + orderid, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return OrdersReprintLabelModal;
}(HSN.Modal);

/***/ }),

/***/ "Y/iy":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

// Chosen, a Select Box Enhancer for jQuery and Protoype
// by Patrick Filler for Harvest, https://getharvest.com
// 
// Version 0.9.11
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest https://getharvest.com

// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `cake build`, do not edit it by hand.
(function() {
  var SelectParser;

  SelectParser = (function() {

    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        children: 0,
        disabled: group.disabled
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  this.SelectParser = SelectParser;

}).call(this);

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/


(function() {
  var AbstractChosen, root;

  root = this;

  AbstractChosen = (function() {

    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.finish_setup();
    }

    AbstractChosen.prototype.set_default_values = function() {
      var _this = this;
      this.click_test_action = function(evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function(evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.result_single_selected = null;
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.search_contains = this.options.search_contains || false;
      this.choices = 0;
      this.single_backstroke_delete = this.options.single_backstroke_delete || false;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      return this.inherit_select_classes = this.options.inherit_select_classes || false;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || "Select Some Options";
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || "Select an Option";
      }
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || "No results match";
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout((function() {
            return _this.container_mousedown();
          }), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout((function() {
          return _this.blur_test();
        }), 100);
      }
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, style;
      if (!option.disabled) {
        option.dom_id = this.container_id + "_o_" + option.array_index;
        classes = option.selected && this.is_multiple ? [] : ["active-result"];
        if (option.selected) {
          classes.push("result-selected");
        }
        if (option.group_array_index != null) {
          classes.push("group-option");
        }
        if (option.classes !== "") {
          classes.push(option.classes);
        }
        style = option.style.cssText !== "" ? " style=\"" + option.style + "\"" : "";
        return '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '"' + style + '>' + option.html + '</li>';
      } else {
        return "";
      }
    };

    AbstractChosen.prototype.results_update_field = function() {
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.result_single_selected = null;
      return this.results_build();
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices > 0) {
            return this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            return this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            return this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          return true;
        case 9:
        case 38:
        case 40:
        case 16:
        case 91:
        case 17:
          break;
        default:
          return this.results_search();
      }
    };

    AbstractChosen.prototype.generate_field_id = function() {
      var new_id;
      new_id = this.generate_random_id();
      this.form_field.id = new_id;
      return new_id;
    };

    AbstractChosen.prototype.generate_random_char = function() {
      var chars, newchar, rand;
      chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      rand = Math.floor(Math.random() * chars.length);
      return newchar = chars.substring(rand, rand + 1);
    };

    return AbstractChosen;

  })();

  root.AbstractChosen = AbstractChosen;

}).call(this);

/*
Chosen source: generate output using 'cake build'
Copyright (c) 2011 by Harvest
*/


(function() {
  var $, Chosen, get_side_border_padding, root,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  root = this;

  $ = jQuery;

  $.fn.extend({
    chosen: function(options) {
      var browser, match, ua;
      ua = navigator.userAgent.toLowerCase();
      match = /(msie) ([\w.]+)/.exec(ua) || [];
      browser = {
        name: match[1] || "",
        version: match[2] || "0"
      };
      if (browser.name === "msie" && (browser.version === "6.0" || (browser.version === "7.0" && document.documentMode === 7))) {
        return this;
      }
      return this.each(function(input_field) {
        var $this;
        $this = $(this);
        if (!$this.hasClass("chzn-done")) {
          return $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function(_super) {

    __extends(Chosen, _super);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function() {
      this.form_field_jq = $(this.form_field);
      this.current_value = this.form_field_jq.val();
      return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
    };

    Chosen.prototype.finish_setup = function() {
      return this.form_field_jq.addClass("chzn-done");
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_div, container_props, dd_top, dd_width, sf_width;
      this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, '_') : this.generate_field_id();
      this.container_id += "_chzn";
      container_classes = ["chzn-container"];
      container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chzn-rtl");
      }
      this.f_width = this.form_field_jq.outerWidth();
      container_props = {
        id: this.container_id,
        "class": container_classes.join(' '),
        style: 'width: ' + this.f_width + 'px;',
        title: this.form_field.title
      };
      container_div = $("<div />", container_props);
      if (this.is_multiple) {
        container_div.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop" style="left:-9000px;"><ul class="chzn-results"></ul></div>');
      } else {
        container_div.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop" style="left:-9000px;"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>');
      }
      this.form_field_jq.hide().after(container_div);
      this.container = $('#' + this.container_id);
      this.dropdown = this.container.find('div.chzn-drop').first();
      dd_top = this.container.height();
      dd_width = this.f_width - get_side_border_padding(this.dropdown);
      this.dropdown.css({
        "width": dd_width + "px",
        "top": dd_top + "px"
      });
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chzn-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chzn-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chzn-search').first();
        this.selected_item = this.container.find('.chzn-single').first();
        sf_width = dd_width - get_side_border_padding(this.search_container) - get_side_border_padding(this.search_field);
        this.search_field.css({
          "width": sf_width + "px"
        });
      }
      this.results_build();
      this.set_tab_index();
      return this.form_field_jq.trigger("liszt:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      var _this = this;
      this.container.mousedown(function(evt) {
        return _this.container_mousedown(evt);
      });
      this.container.mouseup(function(evt) {
        return _this.container_mouseup(evt);
      });
      this.container.mouseenter(function(evt) {
        return _this.mouse_enter(evt);
      });
      this.container.mouseleave(function(evt) {
        return _this.mouse_leave(evt);
      });
      this.search_results.mouseup(function(evt) {
        return _this.search_results_mouseup(evt);
      });
      this.search_results.mouseover(function(evt) {
        return _this.search_results_mouseover(evt);
      });
      this.search_results.mouseout(function(evt) {
        return _this.search_results_mouseout(evt);
      });
      this.form_field_jq.on("liszt:updated", function(evt) {
        return _this.results_update_field(evt);
      });
      this.form_field_jq.on("liszt:activate", function(evt) {
        return _this.activate_field(evt);
      });
      this.form_field_jq.on("liszt:open", function(evt) {
        return _this.container_mousedown(evt);
      });
      this.search_field.blur(function(evt) {
        return _this.input_blur(evt);
      });
      this.search_field.keyup(function(evt) {
        return _this.keyup_checker(evt);
      });
      this.search_field.keydown(function(evt) {
        return _this.keydown_checker(evt);
      });
      this.search_field.focus(function(evt) {
        return _this.input_focus(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.click(function(evt) {
          return _this.choices_click(evt);
        });
      } else {
        return this.container.click(function(evt) {
          return evt.preventDefault();
        });
      }
    };

    Chosen.prototype.search_field_disabled = function() {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass('chzn-disabled');
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.off("focus", this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass('chzn-disabled');
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.on("focus", this.activate_action);
        }
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      var target_closelink;
      if (!this.is_disabled) {
        target_closelink = evt != null ? ($(evt.target)).hasClass("search-choice-close") : false;
        if (evt && evt.type === "mousedown" && !this.results_showing) {
          evt.preventDefault();
        }
        if (!this.pending_destroy_click && !target_closelink) {
          if (!this.active_field) {
            if (this.is_multiple) {
              this.search_field.val("");
            }
            $(document).click(this.click_test_action);
            this.results_show();
          } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chzn-single").length)) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        } else {
          return this.pending_destroy_click = false;
        }
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClass("chzn-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      $(document).off("click", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chzn-container-active");
      this.winnow_results_clear();
      this.clear_backstroke();
      this.show_search_field_default();
      return this.search_field_scale();
    };

    Chosen.prototype.activate_field = function() {
      this.container.addClass("chzn-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      if ($(evt.target).parents('#' + this.container_id).length) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      var content, data, _i, _len, _ref;
      this.parsing = true;
      this.results_data = root.SelectParser.select_to_array(this.form_field);
      if (this.is_multiple && this.choices > 0) {
        this.search_choices.find("li.search-choice").remove();
        this.choices = 0;
      } else if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default").find("span").text(this.default_text);
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.container.addClass("chzn-container-single-nosearch");
        } else {
          this.container.removeClass("chzn-container-single-nosearch");
        }
      }
      content = '';
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        if (data.group) {
          content += this.result_add_group(data);
        } else if (!data.empty) {
          content += this.result_add_option(data);
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.selected_item.removeClass("chzn-default").find("span").text(data.text);
            if (this.allow_single_deselect) {
              this.single_deselect_control_build();
            }
          }
        }
      }
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      this.search_results.html(content);
      return this.parsing = false;
    };

    Chosen.prototype.result_add_group = function(group) {
      if (!group.disabled) {
        group.dom_id = this.container_id + "_g_" + group.array_index;
        return '<li id="' + group.dom_id + '" class="group-result">' + $("<div />").text(group.label).html() + '</li>';
      } else {
        return "";
      }
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      var dd_top;
      if (!this.is_multiple) {
        this.selected_item.addClass("chzn-single-with-drop");
        if (this.result_single_selected) {
          this.result_do_highlight(this.result_single_selected);
        }
      } else if (this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger("liszt:maxselected", {
          chosen: this
        });
        return false;
      }
      dd_top = this.is_multiple ? this.container.height() : this.container.height() - 1;
      this.form_field_jq.trigger("liszt:showing_dropdown", {
        chosen: this
      });
      this.dropdown.css({
        "top": dd_top + "px",
        "left": 0
      });
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      return this.winnow_results();
    };

    Chosen.prototype.results_hide = function() {
      if (!this.is_multiple) {
        this.selected_item.removeClass("chzn-single-with-drop");
      }
      this.result_clear_highlight();
      this.form_field_jq.trigger("liszt:hiding_dropdown", {
        chosen: this
      });
      this.dropdown.css({
        "left": "-9000px"
      });
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field_jq.attr("tabindex")) {
        ti = this.form_field_jq.attr("tabindex");
        this.form_field_jq.attr("tabindex", -1);
        return this.search_field.attr("tabindex", ti);
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      if (this.active_field && !($(evt.target).hasClass("search-choice" || $(evt.target).parents('.search-choice').first)) && !this.results_showing) {
        return this.results_show();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice_id, html, link,
        _this = this;
      if (this.is_multiple && this.max_selected_options <= this.choices) {
        this.form_field_jq.trigger("liszt:maxselected", {
          chosen: this
        });
        return false;
      }
      choice_id = this.container_id + "_c_" + item.array_index;
      this.choices += 1;
      if (item.disabled) {
        html = '<li class="search-choice search-choice-disabled" id="' + choice_id + '"><span>' + item.html + '</span></li>';
      } else {
        html = '<li class="search-choice" id="' + choice_id + '"><span>' + item.html + '</span><a href="javascript:void(0)" class="search-choice-close" rel="' + item.array_index + '"></a></li>';
      }
      this.search_container.before(html);
      link = $('#' + choice_id).find("a").first();
      return link.click(function(evt) {
        return _this.choice_destroy_link_click(evt);
      });
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      if (!this.is_disabled) {
        this.pending_destroy_click = true;
        return this.choice_destroy($(evt.target));
      } else {
        return evt.stopPropagation;
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link.attr("rel"))) {
        this.choices -= 1;
        this.show_search_field_default();
        if (this.is_multiple && this.choices > 0 && this.search_field.val().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.form_field.options[0].selected = true;
      this.selected_item.find("span").text(this.default_text);
      if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default");
      }
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger("change");
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      this.current_value = this.form_field_jq.val();
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function(evt) {
      var high, high_id, item, position;
      if (this.result_highlight) {
        high = this.result_highlight;
        high_id = high.attr("id");
        this.result_clear_highlight();
        if (this.is_multiple) {
          this.result_deactivate(high);
        } else {
          this.search_results.find(".result-selected").removeClass("result-selected");
          this.result_single_selected = high;
          this.selected_item.removeClass("chzn-default");
        }
        high.addClass("result-selected");
        position = high_id.substr(high_id.lastIndexOf("_") + 1);
        item = this.results_data[position];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.selected_item.find("span").first().text(item.text);
          if (this.allow_single_deselect) {
            this.single_deselect_control_build();
          }
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.search_field.val("");
        if (this.is_multiple || this.form_field_jq.val() !== this.current_value) {
          this.form_field_jq.trigger("change", {
            'selected': this.form_field.options[item.options_index].value
          });
        }
        this.current_value = this.form_field_jq.val();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.result_activate = function(el) {
      return el.addClass("active-result");
    };

    Chosen.prototype.result_deactivate = function(el) {
      return el.removeClass("active-result");
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result, result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        result = $("#" + this.container_id + "_o_" + pos);
        result.removeClass("result-selected").addClass("active-result").show();
        this.result_clear_highlight();
        this.winnow_results();
        this.form_field_jq.trigger("change", {
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (this.allow_single_deselect && this.selected_item.find("abbr").length < 1) {
        return this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
    };

    Chosen.prototype.winnow_results = function() {
      var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.search_field.val() === this.default_text ? "" : $('<div/>').text($.trim(this.search_field.val())).html();
      regexAnchor = this.search_contains ? "" : "^";
      regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
      zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (!option.disabled && !option.empty) {
          if (option.group) {
            $('#' + option.dom_id).css('display', 'none');
          } else if (!(this.is_multiple && option.selected)) {
            found = false;
            result_id = option.dom_id;
            result = $("#" + result_id);
            if (regex.test(option.html)) {
              found = true;
              results += 1;
            } else if (this.enable_split_word_search && (option.html.indexOf(" ") >= 0 || option.html.indexOf("[") === 0)) {
              parts = option.html.replace(/\[|\]/g, "").split(" ");
              if (parts.length) {
                for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                  part = parts[_j];
                  if (regex.test(part)) {
                    found = true;
                    results += 1;
                  }
                }
              }
            }
            if (found) {
              if (searchText.length) {
                startpos = option.html.search(zregex);
                text = option.html.substr(0, startpos + searchText.length) + '</em>' + option.html.substr(startpos + searchText.length);
                text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
              } else {
                text = option.html;
              }
              result.html(text);
              this.result_activate(result);
              if (option.group_array_index != null) {
                $("#" + this.results_data[option.group_array_index].dom_id).css('display', 'list-item');
              }
            } else {
              if (this.result_highlight && result_id === this.result_highlight.attr('id')) {
                this.result_clear_highlight();
              }
              this.result_deactivate(result);
            }
          }
        }
      }
      if (results < 1 && searchText.length) {
        return this.no_results(searchText);
      } else {
        return this.winnow_results_set_highlight();
      }
    };

    Chosen.prototype.winnow_results_clear = function() {
      var li, lis, _i, _len, _results;
      this.search_field.val("");
      lis = this.search_results.find("li");
      _results = [];
      for (_i = 0, _len = lis.length; _i < _len; _i++) {
        li = lis[_i];
        li = $(li);
        if (li.hasClass("group-result")) {
          _results.push(li.css('display', ''));
        } else if (!this.is_multiple || !li.hasClass("result-selected")) {
          _results.push(this.result_activate(li));
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high, selected_results;
      if (!this.result_highlight) {
        selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
        do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
        if (do_high != null) {
          return this.result_do_highlight(do_high);
        }
      }
    };

    Chosen.prototype.no_results = function(terms) {
      var no_results_html;
      no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
      no_results_html.find("span").first().html(terms);
      return this.search_results.append(no_results_html);
    };

    Chosen.prototype.no_results_clear = function() {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function() {
      var first_active, next_sib;
      if (!this.result_highlight) {
        first_active = this.search_results.find("li.active-result").first();
        if (first_active) {
          this.result_do_highlight($(first_active));
        }
      } else if (this.results_showing) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          this.result_do_highlight(next_sib);
        }
      }
      if (!this.results_showing) {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.keydown_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.search_field.val().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          evt.preventDefault();
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          this.keydown_arrow();
          break;
      }
    };

    Chosen.prototype.search_field_scale = function() {
      var dd_top, div, h, style, style_block, styles, w, _i, _len;
      if (this.is_multiple) {
        h = 0;
        w = 0;
        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ":" + this.search_field.css(style) + ";";
        }
        div = $('<div />', {
          'style': style_block
        });
        div.text(this.search_field.val());
        $('body').append(div);
        w = div.width() + 25;
        div.remove();
        if (w > this.f_width - 10) {
          w = this.f_width - 10;
        }
        this.search_field.css({
          'width': w + 'px'
        });
        dd_top = this.container.height();
        return this.dropdown.css({
          "top": dd_top + "px"
        });
      }
    };

    Chosen.prototype.generate_random_id = function() {
      var string;
      string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();
      while ($("#" + string).length > 0) {
        string += this.generate_random_char();
      }
      return string;
    };

    return Chosen;

  })(AbstractChosen);

  root.Chosen = Chosen;

  get_side_border_padding = function(elmt) {
    var side_border_padding;
    return side_border_padding = elmt.outerWidth() - elmt.width();
  };

  root.get_side_border_padding = get_side_border_padding;

}).call(this);

}.call(window));

/***/ }),

/***/ "YI9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ShippingPhoneNumberModal
*
* Encapsulates the functionality of a modal dialog that allows the user to edit their shipping address's phone number.
**/
HSN.ShippingPhoneNumberModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ShippingPhoneNumberModal, parent);

    function ShippingPhoneNumberModal() {
        /**
        * new HSN.ShippingPhoneNumberModal()
        **/
        var modal = ShippingPhoneNumberModal.__super__.constructor.call(this, 'editing-modal shipping-phone');

        HSN.FormatPhone($(this.Content).find('#Phone'));

        AddEventHandlers(this);

        return modal;
    }

    function AddEventHandlers(modal) {
        $(modal.Content).on('click', '#cancel', function () {
            $(modal.Close).click();
            return false;
        });
        $(modal.Content).on('click', '#apply', function () {
            HSN.SetWait();
            var form = $('#phone-ltl-form');
            var commerceService = HSN.Instance()._getCommerceService();
            commerceService.UpdateLtlShippingPhoneNumber(form.serialize(), {
                callback: function callback(data) {
                    if (data.success) {
                        window.location.reload();
                    } else {
                        HSN.RemoveWait();
                        HSN.AddErrorTreatment('#phone-ltl-form', data);
                    }
                },
                scope: this
            });
            return false;
        });
    }

    ShippingPhoneNumberModal.prototype._show = function (shippingAddressId) {
        var scope = this;
        scope.AddLoadingSpinner();
        $.ajax('/checkout/order-review/shipping-phone', {
            type: 'GET',
            context: this,
            dataType: 'html',
            data: { "shippingAddressId": shippingAddressId },
            success: function success(data) {
                scope.RemoveLoadingSpinner();
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                    HSN.FormatPhone(scope.Content.find('#ltl-phone'));
                });
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                scope.RemoveLoadingSpinner();
                scope.Hide();
            }
        });
    };
    return ShippingPhoneNumberModal;
}(HSN.Modal);

/***/ }),

/***/ "YNYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
    * class HSN.ArticleContent
    *
    * Encapsulates the functionality of loading article content within an element.
    * * * Config * * *
    * element: HTMLElement - element to either append or replace
    * appendElement: bool - append element to dom or replace
    **/
HSN.ArticleContent = function () {
    function ArticleContent(config) {
        config = config || {};
        var __scope = this;
        __scope.element = config.element;
        __scope.appendElement = config.appendElement;

        this.Root = $('<div class="ArticleContent"></div>');
        this.Root.hide();

        this.Content = $('<div id="ArticleContent-content"></div>');
        this.Root.append(this.Content);
    }

    /**
        * HSN.ArticleContent#Root -> jQuery
        *
        * [[HSN.ArticleContent#Content]] provides access to the jQuery-wrapped HTML element that is the root of the ArticleContent.
        **/
    ArticleContent.prototype.Root = null;

    /**
        * HSN.ArticleContent#Show() -> void
        *
        * Shows the ArticleContent.
        **/
    ArticleContent.prototype.Show = function (url) {
        var __scope = this;
        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            success: function success(data, status, xhr) {
                __scope.Root.removeClass('loading');

                __scope.DisplayContent(data, 0);
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
            }
        });
    };

    ArticleContent.prototype.DisplayContent = function (data, time) {
        var scope = this;
        scope.appendElement ? scope.element.append(data) : scope.element.html(data);
    };
    return ArticleContent;
}();

/***/ }),

/***/ "Yh3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_VariantInfo_js__ = __webpack_require__("fMYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





HSN.EditOptionsOffCanvas = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(EditOptionsOffCanvas, parent);

    function EditOptionsOffCanvas() {
        var offCanvas = EditOptionsOffCanvas.__super__.constructor.call(this, {
            className: 'edit-options-off-canvas',
            sourceDirection: HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage: true
        });
        this._scope = this;
        this.name = 'HSN.EditOptionsOffCanvas';
        this.commerceService = HSN.Instance()._getCommerceService();
        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Edit Options', 'EditOptionsOffCanvas', 'Edit Options Off Canvas');

        this._variants = null;
        this._variantInfo = null;

        return offCanvas;
    }

    function eventHandlers(offCanvas) {
        $(offCanvas.Content).on('click', '#update-bag', function () {
            var variantResponse = GetVariantId('.product-options', 0, offCanvas);
            if (variantResponse.errorList) {
                return false;
            }
            var bagIdentity = offCanvas.Content.find('.edit-options-container').data('bag-id');
            var bagItemIdentity = offCanvas.Content.find('.edit-options-container').data('bag-item-id');
            HSN.SetWait();
            offCanvas.commerceService.UpdateVariant({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity, webId: variantResponse.value }, {
                callback: function callback(data) {
                    if (!data.success) {
                        HSN.RemoveWait();
                        alert('There was a problem editing your bag item. Please try again later.');
                    } else {
                        offCanvas.Hide();
                        window.location.reload(true);
                    }
                },
                scope: offCanvas
            });
        });
    }

    EditOptionsOffCanvas.prototype.BindWidgets = function (offCanvas) {
        var variantJsonString = $('#json-variants', offCanvas.Content.find('.product-option-selector')).html();
        this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;
        this._variantInfo = new __WEBPACK_IMPORTED_MODULE_2_HSNDIR_VariantInfo_js__["a" /* default */](this._variants);

        var productOptionSelector = new HSN.ProductOptionSelector({
            application: HSN.Instance(),
            container: offCanvas.Content.find('.product-option-selector'),
            imageContainer: $('.product-image', offCanvas.Content),
            preSelectedWebId: $('.pre_selected_webid', offCanvas.Content).val(),
            useSimpleMainImage: $('.is_edit_bag_preview', offCanvas.Content).val(),
            variantInfo: this._variantInfo
        }).init();
    };

    function GetVariantId(productCardScope, objectId, scope) {
        if (scope._variants !== null && scope._variants.length > 0) {
            var allErrors = [];
            var inputLabels = $('label.required-selection', productCardScope);
            var arr = [];

            $('.errors-pd').remove();

            $.each(inputLabels, function () {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', productCardScope);

                if (checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if (labelText.length) {
                        allErrors.push('Please select a ' + labelText);
                        inputLabel.addClass('inline-error');
                    }
                } else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });

            //Item Sold out
            var variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                allErrors.push('Selection Not Available');
            }
            if (variant && variant.Callout && variant.Callout.Name === 'SoldOut') {
                allErrors.push('Item Sold Out');
            }

            var allErrorsLength = allErrors.length;
            if (allErrorsLength > 0) {
                var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

                for (var i = 0; i < allErrorsLength; i++) {
                    if (allErrors[i] !== null) {
                        $errors.find('ul').append('<li>' + allErrors[i] + '</li>');
                    }
                }

                var button = $('#update-bag');
                button.after($errors);
                var errorLeft = button.position().left + (button.outerWidth() - $errors.outerWidth()) / 2;
                var errorTop = button.position().top + parseInt('-' + ($errors.height() + 2));
                $errors.css({
                    "top": errorTop,
                    "left": errorLeft
                });

                $errors.focus();
                $('.product-modal-option-status', productCardScope).last().text('');

                return { value: objectId, errorList: allErrors };
            }

            $.each(scope._variants, function (k, v) {
                if ($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value: objectId };
    };

    EditOptionsOffCanvas.prototype._show = function (bagIdentity, bagItemIdentity) {
        $.ajax('/checkout/bag-actions/edit-options?bagIdentity=' + bagIdentity + '&bagItemIdentity=' + bagItemIdentity, {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function error() {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return EditOptionsOffCanvas;
}(HSN.OffCanvas);

/***/ }),

/***/ "YuIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.AddressService = function () {};
HSN.Service.AddressService.prototype = {
    GetAddressManagementWidget: function GetAddressManagementWidget(data, config) {
        this._get('/address-management/get', data, config);
    },
    GetAddAddressForm: function GetAddAddressForm(data, config) {
        this._get('/address-management/add-edit-address', data, config);
    },
    GetEditAddressForm: function GetEditAddressForm(addressIdentity, data, config) {
        this._get('/address-management/add-edit-address/' + addressIdentity, data, config);
    },
    GetAddressList: function GetAddressList(data, config) {
        this._get('/address-management/address-list', data, config);
    },
    GetCityStateFromZip: function GetCityStateFromZip(data, config) {
        this._send('/address-management/city-state-from-zip', data, config);
    },
    RemoveAddress: function RemoveAddress(data, config) {
        this._send('/address-management/remove-address', data, config);
    },
    ValidateAddress: function ValidateAddress(data, config) {
        this._send('/address-management/validate-address', data, config);
    },
    AddEditAddressSave: function AddEditAddressSave(data, config) {
        this._send('/address-management/add-edit-address-save', data, config);
    },
    SelectAddress: function SelectAddress(data, config) {
        this._send('/address-management/select-address', data, config);
    },

    _send: function _send(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error() {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _get: function _get(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'html',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    }
};

/***/ }),

/***/ "Z47Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.Widget.AddToBag
    *
    * Encapsulates the common functionality of the AddToBag Widget.
    **/
HSN.Widget.AddToBag = function () {
    var application;
    var commerceService;
    var deviceInformation;
    var isInOffCanvas;
    var addedBasketItemId;
    var addedBagIdentity;
    var doFinish;
    var refreshWhenDone;
    var waitlistMessageHtml = '<div id="waitlist-message"><div class="waitlist-message-container" role="dialog" aria-labeledby="waitlist-title"><div id="waitlist-title" class="title">this item is on waitlist</div><div class="waitlist-description"><span class="title" tabindex="0">what\'s waitlist?</span><ul ><li>When your item becomes available, we will automatically send it to you.</li><li>If your item doesn\'t come back in stock within 45 days, we will cancel your order and contact you via email.</li><li>Your credit card is only charged if your item is shipped.</li></ul></div><button id="join-waitlist" class="submit-button main-button blue" tabindex="0">join waitlist</button><button id="remove-product" class="submit-button minor-button" tabindex="0">back to product</button></div></div>';
    var dataLayer;
    /**
        * new HSN.Widget.AddToBag.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.AddToBag]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - isInOffCanvas (boolean): Are you calling the widget from the add to bag offcanvas?
        **/
    function init(config) {
        application = config.application;
        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;
        isInOffCanvas = config.isInOffCanvas;
        doFinish = typeof config.doFinish === 'undefined' ? true : config.doFinish;
        refreshWhenDone = typeof config.refreshWhenDone === 'undefined' ? false : config.refreshWhenDone;
    }

    function AddToBag(addToBag, addToBagCallback) {
        //Autoship disclaimer
        var isAutoship = !(addToBag.ProgramId == null) && !(addToBag.ProgramId == '');
        if (isAutoship) {
            HSN.RemoveWait();
            var autoshipProgramType = addToBag.ProgramCode;
            var autoshipFrequency = addToBag.Frequency;
            var autoshipModal = HSN.Instance().GetGenericConfirmModal();
            autoshipModal.SetInputData({ programType: autoshipProgramType, frequency: autoshipFrequency });
            autoshipModal.SetOkCallback(function () {
                HSN.SetWait();
                DoAddToBag(addToBag, addToBagCallback);
            });
            autoshipModal.Show("/autoship/notice");
            return false;
        }

        DoAddToBag(addToBag, addToBagCallback);
    }

    function DoAddToBag(addToBag, addToBagCallback) {
        var isExpressBuy = addToBag.ExpressBuy === 1;
        commerceService.AddToBag(addToBag, {
            callback: function callback(data) {
                if (data.basketItemId) {
                    addedBasketItemId = data.basketItemId;
                    addedBagIdentity = data.bagIdentity;
                }
                dataLayer = data.dataLayerUdo;

                HSN.DataLayer.sendData({ 'cartitem_webpid': addToBag.ProductId, 'cartitem_qty': addToBag.Quantity, 'cartitem_webid': addToBag.WebId, 'cartitem_webmid': addToBag.MatrixId });

                if (data.error !== '') {
                    var errorContent = '<div><div class="add-to-bag-error-container"><p>' + data.error + '</p><div id="sold-out-okay" class="submit-button main-button blue" tabindex="0">ok</div></div></div>';
                    ShowAddToBagError(errorContent);
                } else if (data.isWaitlist) {
                    ShowWaitlistError(function () {
                        if (isInOffCanvas) {
                            HSN.DataLayer.helpers.metricEvent(null, "CP:add", "previewwaitlist", addToBag.ProductId, addToBag.Quantity);
                        } else {
                            HSN.DataLayer.helpers.metricEvent(null, "CP:add", "pdwaitlist", addToBag.ProductId, addToBag.Quantity);
                        }

                        HSN.DataLayer.helpers.hsnEvent(null, "WaitList", "Success", null, null);
                        data.isOffCanvasTestActive ? AddToBagFinishV2(isExpressBuy, addToBag.Quantity, data) : AddToBagFinish(isExpressBuy, addToBag.Quantity, data);
                    });

                    HSN.DataLayer.helpers.elementInteraction(null, "Modal", "Wait List");
                } else if (data.needsPersonalization) {
                    var form = document.createElement('form');
                    var inputId = document.createElement('input');
                    inputId.setAttribute('type', 'hidden');
                    inputId.setAttribute('name', 'Id');
                    inputId.setAttribute('value', addToBag.WebId);
                    form.appendChild(inputId);

                    form.action = '/products/personalization/get';
                    form.method = 'post';
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(form);
                    form.submit();
                } else if (data.needsEgiftPersonalization) {
                    setTimeout(function () {
                        HandleNavigation('/products/egiftcard/show');
                    }, 200);
                } else {
                    HSN.DataLayer.helpers.addToBag(data.dataLayerUdo);

                    if (isExpressBuy) {
                        HSN.DataLayer.helpers.checkout(data.dataLayerUdo);
                        HSN.DataLayer.helpers.event(null, "hsn_event", "ExpressBuy", "Success", null, null, true);
                    } else {
                        HSN.DataLayer.helpers.event(null, "hsn_event", "AddToBag", "Success", null, null, true);
                    }

                    if (isInOffCanvas) {
                        HSN.DataLayer.helpers.metricEvent(null, "CP:add", "preview", addToBag.ProductId, addToBag.Quantity);
                    } else {
                        HSN.DataLayer.helpers.metricEvent(null, "CP:add", "pd", addToBag.ProductId, addToBag.Quantity);
                    }

                    if (addToBagCallback) {
                        addToBagCallback();
                    }
                    HSN.OnCoremetricsLoad(function () {
                        window.cmCreateShopAction5Tag(data.CoremetricsData.Pfid, data.CoremetricsData.ProductName, data.CoremetricsData.Quantity, data.CoremetricsData.Price, data.CoremetricsData.ProductCategory, data.CoremetricsData.ProductCallout + '-_-' + data.CoremetricsData.Size + '-_-' + data.CoremetricsData.Color + '-_--_-' + data.CoremetricsData.ProductRatingAverage + '-_-' + data.CoremetricsData.ProductRatingCount + '-_-' + data.CoremetricsData.ProductBrandName + '-_--_--_-' + data.CoremetricsData.AbTestValue1 + '-_-' + data.CoremetricsData.FlexPayments + '-_-' + data.CoremetricsData.ExpressBuy + '-_--_--_--_--_-' + data.CoremetricsData.AbTestValue2 + '-_-' + data.CoremetricsData.AbTestValue3 + '-_-' + data.CoremetricsData.Division + '-_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_--_-');
                        window.cmDisplayShop5s();
                    });

                    data.isOffCanvasTestActive ? AddToBagFinishV2(isExpressBuy, addToBag.Quantity, data) : AddToBagFinish(isExpressBuy, addToBag.Quantity, data);
                }
            },
            errorCallback: function errorCallback() {
                alert('Unfortunately there was an error attempting to add the item to your bag, please try again.');
                HSN.RemoveWait();
            }
        });
    }
    function AddToBagFinishV2(isExpressBuy, quantityAdded, addToBagResponse) {
        HSN.RemoveWait();
        if (doFinish) {
            if (isExpressBuy) {
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }
                setTimeout(function () {
                    HandleNavigation('/checkout/order-review');
                }, 200);
            } else {
                if (deviceInformation.IsNativeApp) {
                    setTimeout(function () {
                        HandleNavigation('/checkout/bag');
                    }, 200);
                } else {
                    if (!deviceInformation.IsMobile) {
                        HSN.IncreaseBagIconCount(quantityAdded);
                    }
                    if (isInOffCanvas) {
                        application.GetProductPreviewOffCanvas().Hide();
                    }
                    if (refreshWhenDone) {
                        window.location.reload(true);
                    } else {
                        application.GetAddedToBagOffCanvas().Show(addToBagResponse.bagIdentity, addToBagResponse.bagItemIdentity);
                    }
                }
            }
        } else {
            application.Events.Trigger(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, addedBasketItemId, addedBagIdentity);
        }
    }
    function AddToBagFinish(isExpressBuy, quantityAdded, addToBagResponse) {
        if (doFinish) {
            if (isExpressBuy) {
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }

                if (isShowWarrantyUpsell(addToBagResponse)) {
                    showWarrantyUpsell(addToBagResponse.basketItemId, isExpressBuy);
                } else {
                    setTimeout(function () {
                        HandleNavigation('/checkout/order-review');
                    }, 200);
                }
            } else {
                if (!deviceInformation.IsMobile) {
                    HSN.IncreaseBagIconCount(quantityAdded);
                }
                if (isInOffCanvas) {
                    application.GetProductPreviewOffCanvas().Hide();
                }
                if (isShowWarrantyUpsell(addToBagResponse)) {
                    HSN.RemoveWait();
                    showWarrantyUpsell(addToBagResponse.basketItemId, isExpressBuy);
                } else {
                    if (refreshWhenDone) {
                        window.location.reload(true);
                    } else if (deviceInformation.IsMobile) {
                        setTimeout(function () {
                            HandleNavigation('/checkout/bag');
                        }, 200);
                    } else {
                        if (addToBagResponse.isDestinationTestActive) {
                            setTimeout(function () {
                                HandleNavigation('/checkout/bag');
                            }, 200);
                        } else {
                            HSN.RemoveWait();
                            application.GetBagFlyout().Open(7000);
                        }
                    }
                }
            }
        } else {
            HSN.RemoveWait();
            application.Events.Trigger(HSN.Widget.AddToBag.EVENT.ADD_SUCCESS, addedBasketItemId, addedBagIdentity);
        }
    }
    function isShowWarrantyUpsell(data) {
        var showWarrantyMobileAbTest = deviceInformation.IsMobile && !data.isWarrantySelected && data.isWarrantyAvailable;
        if (showWarrantyMobileAbTest) {
            return showWarrantyMobileAbTest;
        }

        return !data.isWarrantySelected && data.isWarrantyAvailable && !deviceInformation.IsMobile;
    }
    function showWarrantyUpsell(basketItemId, isExpressBuy) {
        var warrantyUpsellModal = application.GetWarrantyUpsellModal({ IsExpressBuy: isExpressBuy });
        warrantyUpsellModal.Show(basketItemId, isExpressBuy, function () {
            warrantyUpsellModal.Close.focus();
        });
    }
    function HandleNavigation(url) {
        if (application.DeviceInformation.IsNativeApp) {
            url = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command;
            var eventName = "Add to Bag";

            var appFeatureLocalytics = false;
            if (application.GetAppFeatures("localtyics", "1")) {
                appFeatureLocalytics = true;
            }
            var appGapEvent = false;
            if (application.GetAppFeatures("gapevents", "1")) {
                appGapEvent = true;
            }

            var attributes = buildAppData(dataLayer, url, appFeatureLocalytics, appGapEvent);
            if (appGapEvent) {
                command = 'hsn://HSNWebView.GapEvents/' + eventName + '/' + encodeURIComponent(JSON.stringify(attributes));
            } else if (appFeatureLocalytics) {
                command = 'hsn://HSNWebView.TagLocalytics/GoTo/' + eventName + '/' + encodeURIComponent(JSON.stringify(attributes)) + '/' + encodedUrl;
            } else {
                command = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].BuildGapCommand(url);
            }
            __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
        } else {
            window.location.href = url;
        }
    }

    //builds app data for Localytics and Branch
    function buildAppData(dataLayerUdo, nextUrl, appLocalyticsEnabled, appGapEventEnabled) {
        var prodSku = undefined;
        var prodSkuLocal = undefined;
        var prodId = undefined;
        var prodMatrixId = undefined;
        var prodCats = dataLayerUdo.categories;
        var sfName = undefined;
        var sfNameLocal = undefined;
        var department = undefined;
        var departmentLocal = undefined;
        var catName = undefined;
        var catNameLocal = undefined;
        var prodName = undefined;
        var brand = undefined;
        var brandLocal = undefined;
        var price = undefined;
        var regular_price = undefined;
        var priceLocal = undefined;
        var quantity = undefined;

        if (prodCats) {
            for (i = 0; i < prodCats.length; i++) {
                if (prodCats != "undefined") {
                    if (typeof prodCats[i][0] !== "undefined") {
                        sfName = prodCats[i][0].Name;
                        sfNameLocal = prodCats[i][0].Name;
                    } else {
                        sfName = "";
                        sfNameLocal = "None";
                    }

                    if (typeof prodCats[i][1] != "undefined") {
                        department = prodCats[i][1].Name;
                        departmentLocal = prodCats[i][1].Name;
                    } else {
                        department = "";
                        departmentLocal = "None";
                    }

                    if (typeof prodCats[i][2] != "undefined") {
                        catName = prodCats[i][2].Name;
                        catNameLocal = prodCats[i][2].Name;
                    } else {
                        catName = "";
                        catNameLocal = "None";
                    }
                }
            }
        }

        if (typeof dataLayerUdo.product_name != "undefined") {
            prodName = dataLayerUdo.product_name[0].toString();
        }
        if (typeof dataLayerUdo.product_id != "undefined") {
            prodId = dataLayerUdo.product_id[0];
        }
        if (typeof dataLayerUdo.product_sku != "undefined") {
            prodSku = Number(dataLayerUdo.product_sku[0].toString());
            prodSkuLocal = dataLayerUdo.product_sku[0].toString();
        }
        if (typeof dataLayerUdo.matrix_id != "undefined") {
            prodMatrixId = dataLayerUdo.matrix_id[0];
        }
        if (typeof dataLayerUdo.product_brand_name != "undefined") {
            brand = dataLayerUdo.product_brand_name[0].toString();
        }
        if (typeof dataLayerUdo.product_sale_price != "undefined") {
            price = parseFloat(dataLayerUdo.product_sale_price[0].toString());
            priceLocal = dataLayerUdo.product_sale_price[0].toString();
        }
        if (typeof dataLayerUdo.product_original_price != "undefined") {
            regular_price = parseFloat(dataLayerUdo.product_original_price[0].toString());
        }

        quantity = HSN.DataLayer.getValueForKey("cartitem_qty");

        var attributes = {};

        if (appGapEventEnabled) {

            var prodItemAttr = [];

            var prodAttributes = {
                "product_id": prodId,
                "product_sku": prodSku,
                "matrix_id": prodMatrixId,
                "product_name": prodName,
                "price": price,
                "regular_price": regular_price,
                "storefront": sfName,
                "department": department,
                "category": catName,
                "brand": brand,
                "quantity": quantity
            };

            prodItemAttr.push(prodAttributes);

            var attributes = {
                "Products": prodItemAttr,
                "nextUrl": nextUrl
            };
        } else if (appLocalyticsEnabled) {
            attributes = {
                "Name": prodName,
                "ID": prodSkuLocal,
                "Storefront": sfNameLocal,
                "Department": departmentLocal,
                "Category": catNameLocal,
                "Brand": brand,
                "Price": priceLocal
            };
        }

        return attributes;
    }

    function BindModalHandlers(modalScope, finishCallback) {
        var joinButton = $('.waitlist-message-container #join-waitlist', modalScope.Content);
        var removeButton = $('.waitlist-message-container #remove-product', modalScope.Content);

        var hideAndFocus = function hideAndFocus() {
            modalScope.Hide();
            $('div.buy-selector span.add-to-bag-proxy').focus();
        };

        $('.add-to-bag-error-container .submit-button', modalScope.Content).on('click keydown', function () {
            modalScope.Hide();
            return false;
        });
        joinButton.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                hideAndFocus();
                if (finishCallback) {
                    finishCallback();
                }
            } else if (e.type === 'keydown' && e.key === 'Tab') {
                e.preventDefault();
                removeButton.focus();
            }
        });
        removeButton.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                commerceService.RemoveBagItem({ bagIdentity: addedBagIdentity, bagItemId: addedBasketItemId }, {
                    callback: function callback() {
                        hideAndFocus();
                    },
                    scope: this
                });
            } else if (e.type === 'keydown' && e.key === 'Tab') {
                e.preventDefault();
                joinButton.focus();
            }
        });

        application.Events.On(HSN.PageIdModal.EVENT.SHOW_COMPLETE, function () {
            if (joinButton.is(':visible')) {
                joinButton.focus();
            }
        });
    }
    function ShowAddToBagError(content) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(content, true);
        BindModalHandlers(modalReference);
        $('.add-to-bag-error-container .submit-button', modalReference.Content).focus();

        return false;
    }
    function ShowWaitlistError(finishCallback) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(waitlistMessageHtml, true);
        BindModalHandlers(modalReference, finishCallback);
        $('.waitlist-message-container #join-waitlist', modalReference.Content).focus();
        return false;
    }
    return {
        init: init,
        AddToBag: AddToBag
    };
};
HSN.Widget.AddToBag.EVENT = {
    ADD_SUCCESS: 'HSN.Widget.AddToBag:ADD_SUCCESS'
};

/***/ }),

/***/ "ZrRa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_TabPanel_js__ = __webpack_require__("BBRS");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.ProductOptionSelector
    *
    * Progressively enhances a definition list full of option radio buttons and
    * labels to be more interactive.
    **/
HSN.ProductOptionSelector = function (config) {
    var _this = this;

    /**
        * new HSN.ProductOptionSelector(config)
        * - config (Object): A configuration object for the [[HSN.ProductOptionSelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the ProductOptionSelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector
        *     that will ultimately resolve to an HTML element will act as the container for the set of options.
        *   - favoriteLink: jQuery Selector for favorite heart,
        *   preSelectedWebId: scope._preSelectedWebId,
        *   buySelector: scope,
        *   imageContainer: scope._imageContainer,
        *   useSimpleMainImage: scope._useSimpleMainImage
        **/

    // ReSharper disable once InconsistentNaming
    var __scope = this;
    this.eventIdentity = config.eventIdentity || crypto.randomUUID();
    this._variantInfo = config.variantInfo;
    this._application = config.application;
    this._container = $(config.container);
    this._favoriteLink = $(config.favoriteLink);
    this._preSelectedWebId = config.preSelectedWebId;
    this._isPlusSizeVariantSelected = false;
    this._imageContainer = config.imageContainer;
    this._useSimpleMainImage = config.useSimpleMainImage;
    this._isMobile = HSN.Instance().DeviceInformation.IsMobile;
    this._productImage = { href: null, zoom: null };
    this._showDefaultImage = true;

    // Keep display in sync with the variantInfo
    this._variantInfo.onChange(function () {
        _this._updateDisplay();
    });

    this.init = function () {
        _this._container.addClass('product-option-selector');

        // ReSharper disable once UnusedLocals

        if (__scope._imageContainer) {
            _this.SetDefaultImage();
        }

        //ignore hover events used for product option preview on touch devices
        if (!Modernizr.touchevents) {
            //handler switching main images for variants on event(hover)
            _this._container.on('mouseleave', '.color-option, .btn-styled', function () {
                var $this = $(this);
                __scope._showDefaultImage = true;
                setTimeout(function () {
                    if (__scope._showDefaultImage) {
                        __scope._updateProductImage($this, __scope._productImage, 'mouseleave');
                    }
                }, 10);
            });

            _this._container.on('blur', '.color-option input, .btn-styled input', function () {
                var $this = $(this);
                __scope._showDefaultImage = true;
                setTimeout(function () {
                    if (__scope._showDefaultImage) {
                        __scope._updateProductImage($this, __scope._productImage, 'blur');
                    }
                }, 10);
            });
        }

        //handler switching main images for variants on event(hover or click)
        _this._container.on(Modernizr.touchevents ? 'click' : 'mouseenter focus', '.color-option, .color-option .label input', function (e) {
            var $this = $(this);
            __scope._showDefaultImage = false;
            var controlVariantEle = $('.control-variant.left');
            if (controlVariantEle.length && controlVariantEle.is(':visible')) {
                if (controlVariantEle.find('#inline-video-container').is(':visible')) {
                    return;
                }
            } else {
                if ($('.variant-a-left.left .product-image-container #new-inline-video-container').is(':visible')) {
                    return;
                }
            }

            var $input = $this.find('input');
            if ($this.is('input')) {
                $input = $this;
            }
            var images = $input.data('images');
            var imageName = $input.data('image-name');

            var isPlusSize = __scope.IsPlusSizeGroupSelected();

            __scope.SwapMainImage(images, imageName, isPlusSize);
        });

        // handler tab-navigation for Attributes -- (ADA)

        _this._container.on('focus', 'input[name^="product-modal-option"], input[name^="product-option-group"]', function (e) {
            $(this).parent().addClass('highlighted-for-tab');

            /* slide left/right when focus on hidden items of carousel */
            if ($(this).closest('.slick-slide').length) {
                var slickEle = $(this).closest('.slick-slider');
                var slickIndex = parseInt($(this).closest('.slick-slide').attr('data-slick-index'));
                slickEle.slick('slickGoTo', slickIndex, false);
            }
        });
        _this._container.on('focusout', 'input[name^="product-modal-option"], .btn-styled:has(> input[name^="product-modal-option"]), input[name^="product-option-group"], .btn-styled:has(> input[name^="product-option-group"])', function (e) {
            $(this).parent().removeClass('highlighted-for-tab');
        });

        //handler switching main images for variants on event(hover or click)
        _this._container.on(Modernizr.touchevents ? 'click' : 'mouseenter focus', '.btn-styled, .groupLabel > span, .btn-styled input', function (e) {
            if (e.type === 'mouseenter' && $(this).is('.groupLabel > span')) {
                return;
            }

            __scope._showDefaultImage = false;

            var color = $('.btn-styled-swatch.selected');
            if (color.length < 1) {
                __scope._showDefaultImage = true;
                return;
            }

            var $input = $(this).find('input');
            if ($(this).is('input')) {
                $input = $(this);
            }
            var $colorInput = $(color).find('input');
            var images = $colorInput.data('images');
            var imageName = $colorInput.data('image-name');

            var isPlusSize = $input.data('isPlusSizeCode');
            if (isPlusSize == null) {
                isPlusSize = $input.data('isPlusSizeGroup');
            }

            __scope.SwapMainImage(images, imageName, isPlusSize);
        });

        //handle variant option select box override
        _this._container.on('change', '.variant-selector-override', function () {
            var selectedValue = $(this).val();
            var nearestDd = $(this).siblings('ul');
            var matchingLabel = nearestDd.find('.label > input[data-value="' + selectedValue + '"]');
            if (matchingLabel.length > 0) {
                matchingLabel.click();
            }
        });

        //handle group selection (For example, Group: [Size Type] and [Size])
        _this._container.on('click keydown', '.variant-group-tab-items .label, .variant-group-tab-items .label > input', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
                return;
            }

            e.preventDefault();

            var $label = void 0,
                $input = void 0;
            if ($(this).is('.label')) {
                $label = $(this);
                $input = $label.find('> input');
            } else {
                $input = $(this);
                $label = $input.closest('.label');
            }

            //Tab functionality moved from <a> to button
            $label.parent().addClass('active').siblings().removeClass('active');

            var $href = $label.data('href');
            $href = $href.substr($href.indexOf('#') + 1);
            $('#' + $href, this._container).addClass('active').siblings().removeClass('active');

            var changed = $input.attr('data-checked') == 'false';

            var $groupDd = $label.closest('.variant-group-tab-items');
            var relatedDt = $groupDd.siblings('.tabs-label');
            var selectedLabel = relatedDt.find('label.product-option-label');
            var selectedGroupLabel = $groupDd.siblings('.tabs-label:first').find('> label');
            // Update "Selected, " text for aria-label
            $('input[name="' + selectedGroupLabel.data('selection-name') + '"]').attr('data-checked', 'false');
            $input.attr('data-checked', 'true');

            if (selectedLabel.text().length === 0) {
                selectedLabel.text(selectedLabel.data('text'));
                selectedLabel.addClass(selectedLabel.data('class'));
                selectedLabel.show();
                selectedLabel.next('span').css('display', 'inline');
            }

            selectedGroupLabel.removeClass('inline-error');
            $('div[class*="errors"]').remove();
            $('input[class*="has-error"]').removeClass('has-error');
            $('input[class*="inline-error"], select[class*="inline-error"]').removeClass('inline-error');

            $('.label', $groupDd).removeClass('checked-selected waitlisted-selected');
            // Remove "Selected, " text from aria-label
            $('.label ', $groupDd).each(function () {
                var inputDesc = $(this).find('> .option-description').text();
                $(this).find('input').attr('aria-label', inputDesc);
            });

            //set selected option description
            var $groupTitle = $groupDd.prevAll('.tabs-label:first');
            __scope._updateGroupTitle($groupTitle, $input.data('label'));

            if ($label.hasClass('waitlisted')) {
                $label.addClass('waitlisted-selected');
            } else {
                $label.addClass('checked-selected');
            }
            // Update "Selected, " text for aria-label
            var inputDescription = $('> .option-description', $label).text(); //span with descripcion
            $input.attr('aria-label', ($label.hasClass('checked-selected') || $label.hasClass('waitlisted-selected') ? 'Selected, ' : '') + inputDescription);

            __scope._isPlusSizeVariantSelected = $input.data('is-plus-size-group');

            var colorVariantLabel = __scope.GetSelectedVariant('C');
            if (colorVariantLabel) {
                var alternateImages = colorVariantLabel.find('> input').data('images');
                __scope.HandleOptionChanged(alternateImages);
            } else {
                //no colors selected, so switch on default image
                var mainImages = __scope._imageContainer ? __scope.GetImageData(__scope._imageContainer.find('img')) : null;
                __scope.HandleOptionChanged(mainImages);
            }

            //clear out size variant selected
            var sizeVariantLabel = __scope.GetSelectedVariant('S', $label.closest('ul').parent());
            if (sizeVariantLabel) {
                __scope.DeactivateOptionLabel(sizeVariantLabel);
            }

            if (changed) {
                __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, __scope._isPlusSizeVariantSelected, __scope.eventIdentity);
            }
        });

        //handle input selection             
        _this._container.on('keydown click', 'input[name^="product-modal-option"], .btn-styled:has(> input[name^="product-modal-option"]), .btn-styled-swatch:has(> input[name^="product-modal-option"])', function (e) {

            if (e.type === 'click' || e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                var $selectedInput = $(this);
                if (!$selectedInput.is('input')) {
                    $selectedInput = $selectedInput.find('input');
                }

                var $selectedLabel = $selectedInput.parent('.label');

                var hasMatrix = $('.matrix-options', __scope._container).length;
                var hasMatrixSelect = $('.matrix-options select').length !== 0;

                if ((!hasMatrixSelect && $('.matrix-options .selected', __scope._container).length === 0 || hasMatrixSelect && $('.matrix-options select', __scope._container).val() === 'Please select...') && hasMatrix) {
                    var matrixErrorMessage = $('div.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', __scope._container);
                    var hasMatrixErrorMessage = matrixErrorMessage.length;
                    if (!hasMatrixErrorMessage) {
                        var labelTxt = $('div.tabs-label:first label:not(".waitlist-explainer")', __scope._container).html().toLowerCase();
                        labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                        $('div.tabs-label:first label:not(".waitlist-explainer")', __scope._container).append('<span class="matrix-selection-error">Please ' + labelTxt + ' first.</span>');
                    } else {
                        matrixErrorMessage.show();
                        $(this).prop('checked', false);
                    }
                    return;
                }

                __scope.ActivateOptionLabel($selectedLabel, true);
            }
        });

        $('body').on('click', function () {
            $('.highlighted-for-tab').removeClass('highlighted-for-tab');
        });

        //Refresh modal to show modal for particular product in matrix
        $('.matrix-options', _this._container).on('click keydown', 'a', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                var url = $(this).data('url') || $(this).attr('href');
                __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, $(this).data('id'), url, $(this).data('edit-bi-id'), $(this).data('edit-bag-id'), __scope.eventIdentity);
            } else if (e.type === 'keydown' & e.key === 'Tab') {
                return true;
            }
            return false;
        });

        if (__scope._isMobile) {
            //Prevent default anchor behavior for mobile, handling via events
            // look into unifying mobile/desktop approach, moving away from anchor tags
            $('.matrix-options', _this._container).on('click', 'a', function (e) {
                e.preventDefault();
            });
        }

        //Refresh modal to show modal for particular product in matrix, drop down version(large # of variants)
        _this._container.on('change', '.matrix-selector', function () {
            e.preventDefault();
            e.stopPropagation();

            var selected = $(this).find('option:selected');
            var url = $(this).data('url') || $(this).attr('href');
            __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, selected.val(), url, selected.data("edit-bi-id"), selected.data('edit-bag-id'), __scope.eventIdentity);

            return false;
        });

        _this._variantInfo.setVariantById(_this._preSelectedWebId);

        var preselectedSizeCode = _this._variantInfo.getSelectedCodeByPrefix('S');
        if (preselectedSizeCode) {
            __scope.SelectVariant(preselectedSizeCode, false);
        }

        //If only option, select it by default
        if ($('input[class*="product-modal-option-1"]', __scope._container).length === 1) $('input[class*="product-modal-option-1"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-2"]', __scope._container).length === 1) $('input[class*="product-modal-option-2"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-3"]', __scope._container).length === 1) $('input[class*="product-modal-option-3"]', __scope._container).first().click();

        _this._application.Events.On(HSN.Application.EVENT.FAVORITE_INITIALIZED, function (objectType, objectId, webId) {
            if ($(__scope._favoriteLink).data('object-id') !== objectId) {
                return;
            }

            __scope._variantInfo.setVariantById(webId);
        }, _this);

        _this._application.Events.On(HSN.BuySelector.EVENT.FITGUIDE_MEASUREMENT_SUCCESS, function (sizeCode) {
            if (!__scope._useSimpleMainImage && __scope._preSelectedWebId === '0') {
                __scope.SelectVariant(sizeCode, false);
            }
        });

        //Keith Urban products - Used to swap Left and Right hand variants
        if (_this._variantInfo._variants.length) {
            var zLeft = $('input[data-label="Left Handed"]').parent();
            var zRight = $('input[data-label="Right Handed"]').parent();

            if (zLeft.length && zRight.length) {
                zLeft.insertAfter(zRight);
                zRight.click();
            }
        }

        // Set callouts info and aria-label attributes
        _this._updateDisplay();
        _this._updateAriaLiveElement();
    };
};

HSN.ProductOptionSelector.prototype = {
    _container: null,

    _updateDisplay: function _updateDisplay() {
        var _this2 = this;

        this._updateSelectedVariantDisplay(this._variantInfo.SelectedVariant);

        var callouts = this._variantInfo.Callouts;

        // Remove "Selected, " text from aria-label
        var groupTypeInputs = $('input[name^="product-option-group"]', this._container);
        groupTypeInputs.each(function (i, el) {
            var input = $(el);
            var label = input.parent();
            var inputDesc = $('> .option-description', label).text();
            input.attr('aria-label', (label.hasClass('checked-selected') || label.hasClass('waitlisted-selected') ? 'Selected, ' : '') + inputDesc);
        });

        var $inputs = $('input[name^="product-modal-option"]', this._container);

        $inputs.each(function (i, input) {
            var $input = $(input);
            var val = $input.attr('data-value');
            var isSelected = _this2._variantInfo.isCodeSelected(val);

            _this2._updateOptionDisplay($input, callouts[val], isSelected);

            if (isSelected) {
                $input.attr('data-checked', 'true');
                var $groupTitle = $input.closest('ul').prevAll('.tabs-label:first');
                _this2._updateGroupTitle($groupTitle, $input.data('label'));
            }
        });

        this._updateSelectedVariantCalloutDisplay(this._variantInfo.SelectedVariant);
    },

    _updateGroupTitle: function _updateGroupTitle($groupTitle, text) {
        $groupTitle.find('.group-text').text(text);

        var srOnlySpan = document.createElement('span');
        var selectedText = document.createTextNode('');
        if (text !== "") {
            selectedText = document.createTextNode(' selected');
            srOnlySpan.className = 'visuallyhidden';
        } else {
            srOnlySpan.className = 'visuallyhidden empty';
        }
        srOnlySpan.appendChild(selectedText);
        if ($groupTitle.find('.group-text').length) {
            $groupTitle.find('.group-text')[0].appendChild(srOnlySpan);
        }
        this._updateAriaLiveElement();
    },
    _updateAriaLiveElement: function _updateAriaLiveElement() {
        var ariaLiveMsg = 'Your current selection is :';
        var ariaLiveEle = $('#colorAndSizeSelectionMessage', this._container);
        if (ariaLiveEle.length == 0) {
            var srOnlyDiv = document.createElement('div');
            srOnlyDiv.className = 'visuallyhidden';
            srOnlyDiv.id = 'colorAndSizeSelectionMessage';
            srOnlyDiv.ariaAtomic = 'true';
            srOnlyDiv.ariaLive = 'polite';
            if ($('.product-option-selector').length) {
                $('.product-option-selector')[0].appendChild(srOnlyDiv);
                ariaLiveEle = $('#colorAndSizeSelectionMessage', this._container);
            }
        }
        if (ariaLiveEle.length) {
            var isMatrix = $('.matrix-options', this._container).length;
            var isMatrixSelect = $('.matrix-options select').length !== 0;
            if (isMatrix) {
                var titleText = $('.product-matrix-options .tabs-label label:not(".waitlist-explainer")', this._container).text();
                var titleValue = '';
                if (!isMatrixSelect && $('.matrix-options .selected', this._container).length === 0 || isMatrixSelect && $('.matrix-options select', this._container).val() === 'Please select...') {
                    var newTitleText = titleText.toLowerCase().includes('select') ? titleText.toLowerCase() : 'select ' + titleText.toLowerCase();
                    titleValue = 'please ' + newTitleText + ' first';
                } else {
                    if (isMatrixSelect) {
                        titleValue = $('.matrix-options select', this._container).val();
                    } else {
                        titleValue = $('.matrix-options .matrix-item a.selected', this._container).text();
                        var groupLabel = $('.matrix-options .matrix-item a.selected', this._container).closest('ul').prev('.groupLabel');
                        if (groupLabel.length) {
                            titleValue = groupLabel.text() + ' ' + titleValue;
                        }
                    }
                }
                ariaLiveMsg += ' ' + titleText + ' = ' + titleValue + ',';
            }

            $('label.required-selection', this._container).each(function () {
                var titleText = $(this).text() != '' ? $(this).text() : $(this).data('text');
                var titleValue = $(this).siblings('span.group-text').text();
                if (titleValue.toLowerCase().trim() !== '') {
                    titleValue = titleValue.replace('selected', '').trim();
                } else {
                    titleValue = 'please select';
                }
                ariaLiveMsg += ' ' + titleText + ' = ' + titleValue + ',';
            });
            if (ariaLiveMsg !== 'Your current selection is :') {
                ariaLiveEle.text(ariaLiveMsg.slice(0, -1));
            } else {
                ariaLiveEle.text('');
            }
        }
    },
    _updateProductImage: function _updateProductImage(ele, productImage, eventName) {
        var imageContainer = $('.variant-a-left.left .product-image-container');
        var isControlVariant = false;
        if ($('.control-variant.left').length && $('.control-variant.left').is(':visible')) {
            imageContainer = $('.control-variant.left .product-image-container');
            isControlVariant = true;
        }
        if (productImage.href) {
            $('img', imageContainer).attr('src', productImage.href);
            $('a', imageContainer).attr('href', productImage.href);
            $('a', imageContainer).data('zoom', productImage.zoom);
        } else {
            var focusedBtn = ele.closest('.product-option-selector').find('.highlighted-for-tab');
            if (focusedBtn.length && eventName == 'mouseleave') {
                focusedBtn.find('input').focus();
            } else {
                var activeThumbnail = void 0;
                if (!isControlVariant) {
                    var activethumnailEle = imageContainer.closest('.left').find('.media-thumbnails-wrapper .image-container.active');
                    if (!activethumnailEle.is('.video-wrapper')) {
                        activeThumbnail = activethumnailEle.find('input');
                    }
                } else {
                    activeThumbnail = imageContainer.closest('.left').find('.product-image-thumbnails label.active input');
                }
                if (activeThumbnail.length && (isControlVariant && imageContainer.siblings('#inline-video-container').is(':hidden') || !isControlVariant && imageContainer.find('.product-image').is(':visible'))) {
                    $('img', imageContainer).attr('src', activeThumbnail.attr('href'));
                    $('a', imageContainer).attr('href', activeThumbnail.attr('href'));
                    $('a', imageContainer).data('zoom', activeThumbnail.attr('data-zoom'));
                }
            }
        }
    },
    _updateOptionDisplay: function _updateOptionDisplay($input, callouts, isSelected) {
        var $label = $input.parent();
        var status = 'In Stock';

        $label.toggleClass('selected', isSelected);

        if (isSelected) {
            $input.attr('data-checked', 'true');
        } else {
            $input.attr('data-checked', 'false');
        }

        $label.removeClass('regular waitlisted disabled-overlay');
        if (callouts) {
            switch (callouts.Name) {
                case "Waitlist":
                case "BackOrder":
                case "ExtendedDelivery":
                    $label.addClass('waitlisted');
                    status = 'Wait listed';
                    break;
                case "SoldOut":
                    $label.addClass('disabled-overlay');
                    status = 'Sold Out';
                    break;
                case "LowInventory":
                    $label.addClass('regular');
                    break;
                default:
                    console.error("Missing Callout Logic", callouts);
            }
        } else {
            $label.addClass('regular');
        }
        var inputDescription = $('> .option-description', $label).text(); //span with descripcion
        $input.attr('aria-label', ($label.hasClass('checked-selected') || $label.hasClass('selected') ? 'Selected, ' : '') + inputDescription + ' ' + status);
    },


    _updateSelectedVariantDisplay: function _updateSelectedVariantDisplay(selectedVariant) {
        var statusText = '';
        if (selectedVariant) {
            var productFavoriteLink = $(this._favoriteLink);
            productFavoriteLink.data('web-id', selectedVariant.WebId);
            productFavoriteLink.attr('data-web-id', selectedVariant.WebId);

            this._application._getFavoriteService().UpdateFavoriteLink(productFavoriteLink);

            if (selectedVariant.Callout) {
                switch (selectedVariant.Callout.Name) {
                    case "Waitlist":
                        statusText = 'ON WAITLIST';
                        break;
                    case "LowInventory":
                        statusText = 'ONLY ' + selectedVariant.Callout.Remaining + ' LEFT';
                        break;
                    case "BackOrder":
                    case "ExtendedDelivery":
                        statusText = 'EXTENDED DELIVERY';
                        break;
                    case "SoldOut":
                        break;
                    default:
                        console.error("Missing Callout Logic", selectedVariant.Callout);
                }
            }

            // update banner
            var banner = $('#modal-banner');
            var bannerH = banner.children('h6');
            if (selectedVariant.Callout && selectedVariant.Callout.Name === "Waitlist") {
                banner.removeClass("none");
                banner.addClass('waitlist');
                bannerH.text('WAITLIST');
            } else {
                banner.attr('class', banner.data('originalClass'));
                bannerH.text(bannerH.data('originalText'));
            }

            if (typeof dataLayer !== 'undefined') {
                var arrPV = [];
                arrPV[0] = selectedVariant.WebId;
                dataLayer[0].product_variant_id = arrPV;
            }
        }

        //actually set status text
        this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, statusText, this._container, this.eventIdentity);

        //Check if modal is in 'edit bag' and change Update button to waitlist.
        var input = $('form > div.button-group input.add-to-bag');
        var waitlistInfo = $('.edit-item-waitlist-off');
        if (input.data('update-bag')) {
            if (statusText === 'ON WAITLIST') {
                waitlistInfo.removeClass('edit-item-waitlist-off');
                waitlistInfo.addClass('edit-item-waitlist-on');
            } else {
                waitlistInfo = $('.edit-item-waitlist-on');
                waitlistInfo.removeClass('edit-item-waitlist-on');
                waitlistInfo.addClass('edit-item-waitlist-off');
            }
        }
    },

    _updateSelectedVariantCalloutDisplay: function _updateSelectedVariantCalloutDisplay(selectedVariant) {
        var headers = this._container.find('.tabs-label');
        var lastHeader = headers.last();
        var text = this.GetCallout(selectedVariant);
        var calloutName = selectedVariant && selectedVariant.Callout ? selectedVariant.Callout.Name : '';
        var isSoldout = calloutName == 'SoldOut' ? true : false;
        var isWaitlist = calloutName == 'Waitlist' ? true : false;

        headers.toggleClass('soldout-callout', isSoldout);
        headers.find('.urgent-callout-label').text(isSoldout ? text : '');

        lastHeader.removeClass('waitlist-callout');

        var $waitlistExplainer = lastHeader.find('.waitlist-explainer');
        if (!$waitlistExplainer.length) {
            $waitlistExplainer = $('<label class="waitlist-explainer">This item is temporarily out of stock. We’ll ship it to you automatically when it’s back in stock, and we’ll only charge you if it ships. The order is canceled if it doesn’t come back in stock within 45 days.</label>');
            lastHeader.prepend($waitlistExplainer);
        }

        lastHeader.toggleClass('waitlist-callout', isWaitlist);
        lastHeader.find('.urgent-callout-label').text(text);
    },


    GetCallout: function GetCallout(selectedVariant) {
        if (selectedVariant) {
            var calloutText = '';
            if (selectedVariant.Callout) {
                switch (selectedVariant.Callout.Name) {
                    case "Waitlist":
                        calloutText = 'On waitlist in';
                        break;
                    case "LowInventory":
                        calloutText = 'Only ' + selectedVariant.Callout.Remaining + ' left in ';
                        break;
                    case "BackOrder":
                    case "ExtendedDelivery":
                        calloutText = 'On extended delivery in';
                        break;
                    case "SoldOut":
                        calloutText = 'Sold out in ';
                        break;
                    default:
                        console.error("Missing Callout Logic", selectedVariant.Callout);
                }
            }
            return calloutText;
        }
        return '';
    },

    /**
        * HSN.ProductOptionSelector#ActivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that
        *   will ultimately resolve one of the option labels in this product modal.
        * - sel (boolean) mark as selected?
        *
        * Modifies the label as necessary to support the activated state of the alternate image and
        * adds the active class.
        **/
    ActivateOptionLabel: function ActivateOptionLabel(label, sel) {
        var $label = $(label);
        var $input = $('> input', $label); //input for label

        var selectedCode = $input.attr('data-value');

        if (sel && selectedCode.substr(0, 1) === "S") {
            //Handle Size Variant)
            this._isPlusSizeVariantSelected = $input.data('is-plus-size-code');
        }

        // Updating of UI happens as a side effect of setting the code
        this._variantInfo.setCode(selectedCode);

        var selectedSwatch = $('.btn-styled-swatch.selected');
        //Event stuff
        var images = $(selectedSwatch).find('input').data('images');

        var isSwatch = $label.find('.btn-styled-swatch').length ? true : false;

        var prefixCode = selectedSwatch.find('input').attr('data-value');

        var swatchCode = this._variantInfo.getSelectedCodeByPrefix(prefixCode ? prefixCode : 'C');

        if (images) {
            isSwatch = true;
        }

        if (swatchCode) {
            swatchCode = swatchCode.substr(1);
        }

        this.HandleOptionChanged(images);

        //if in special Auto Ship matrix and the Auto Ship option is selected then redirect variant selections to the proper item page
        var autoShipMatrixButton = $('.matrix-autoship.auto.selected');
        var selectedVariant = this._variantInfo.SelectedVariant;
        if (autoShipMatrixButton && autoShipMatrixButton.length > 0 && selectedVariant && parseInt(selectedVariant.WebId) !== parseInt(this._preSelectedWebId)) {
            this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, selectedVariant.WebId, '/products/slug/' + selectedVariant.WebId, this.eventIdentity);
        } else {
            this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.OPTION_CHANGED, images, isSwatch, swatchCode, this._isPlusSizeVariantSelected, this.eventIdentity);
        }
    },

    /**
        * HSN.ProductOptionSelector#DeactivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *   ultimately resolve one of the option labels in this product modal.
        *
        * Deactivate label and set description text to currently selected option.
        * Clean all labels, spans and status text
        **/
    DeactivateOptionLabel: function DeactivateOptionLabel(label) {
        var scope = this;

        if (!label) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label); //input corresponding to label
        $input.attr('data-checked', 'false');
        $label.removeClass('checked'); // deactivate label

        // Updating of UI happens as a side effect of setting the code
        this._variantInfo.unsetCode($input.attr('data-value'));

        //populate input group description to selected or empty if no selected
        var checkedOption = $('input[name="' + $input.attr('name') + '"][data-checked="true"]', scope._container);
        var checkOptionDataLabel = checkedOption.data('label') || '';
        var $groupTitle = $label.closest('ul').prevAll('.tabs-label:first');
        this._updateGroupTitle($groupTitle, checkOptionDataLabel);
    },

    /**
        * HSN.ProductOptionSelector#HandleOptionChanged() -> void
        *
        * Code that runs when an option is changed in productoptionselector.
        **/
    HandleOptionChanged: function HandleOptionChanged(alternateImages) {
        var scope = this;
        if (scope._imageContainer && alternateImages) {
            // Change default image
            var isPlusSize = scope.IsPlusSizeGroupSelected();
            if (isPlusSize) {
                scope._productImage.href = alternateImages.detailPlusSize;
                scope._productImage.zoom = alternateImages.zoomPlusSize;
            } else {
                scope._productImage.href = alternateImages.detail;
                scope._productImage.zoom = alternateImages.zoom;
            }

            scope.SwapMainImage(alternateImages, '', isPlusSize);
        }
    },

    SelectVariant: function SelectVariant(variantCode, selectOnlyGroup) {
        var scope = this;

        var $sizeVariantInput = $('input[name^="product-modal-option"][data-value="' + variantCode + '"]', scope._container);
        var $sizeGroup = $sizeVariantInput.closest('ul');
        var $sizeGroupTab = $('div[data-href="#' + $sizeGroup.prop('id') + '"].label', $sizeGroup.parent());

        $sizeGroupTab.click();
        if (!selectOnlyGroup && $sizeVariantInput && !$sizeVariantInput.is('[data-checked="true"]')) {
            $sizeVariantInput.click();
            $sizeVariantInput.change();
        }
    },

    IsPlusSizeGroupSelected: function IsPlusSizeGroupSelected() {
        return this._isPlusSizeVariantSelected;
    },

    GetSelectedVariant: function GetSelectedVariant(variantType, grouping) {
        if (!variantType) {
            return false;
        }

        var selectedCode = this._variantInfo.getSelectedCodeByPrefix(variantType);

        if (selectedCode) {
            var input = $('input[name^="product-modal-option"]', this._container).filter(function (i, e) {
                return $(e).attr('data-value') === selectedCode;
            });

            if (input.length === 1) {
                return $(input).parent();
            }
        }

        return null;
    },

    SetDefaultImage: function SetDefaultImage() {
        var scope = this;
        var isPlusSize = scope.IsPlusSizeGroupSelected();
        var images = scope._imageContainer.find('img').data('images');
        if (scope._imageContainer && images) {
            if (isPlusSize) {
                scope._productImage.href = images.detailPlusSize;
                scope._productImage.zoom = images.zoomPlusSize;
            } else {
                scope._productImage.href = images.detail;
                scope._productImage.zoom = images.zoom;
            }
        }
    },

    GetBestZoomImage: function GetBestZoomImage(images) {
        if (typeof images === 'string') {
            return images;
        }
        return images[images.length > 1 ? 1 : 0];
    },

    SwapMainImage: function SwapMainImage(images, imageName, isPlusSize) {
        var scope = this;
        var changed = false;
        var img = $(scope._isMobile && !scope._useSimpleMainImage ? 'img.zoom-image' : 'img', scope._imageContainer);
        var curSrc = img.attr('src');

        if (scope._isMobile && !scope._useSimpleMainImage) {
            if (isPlusSize) {
                if (images.detailPlusSize) {
                    img.attr('src', images.detailPlusSize);

                    if (curSrc != images.detailPlusSize) {
                        changed = true;
                    }
                }
                if (images.zoomPlusSize) {
                    img.data('zoom-url', scope.GetBestZoomImage(images.zoomPlusSize));
                }
            } else {
                if (images.detail) {
                    img.attr('src', images.detail);

                    if (curSrc != images.detail) {
                        changed = true;
                    }
                }
                if (images.zoom) {
                    img.data('zoom-url', scope.GetBestZoomImage(images.zoom));
                }
            }

            var zoomie = scope._imageContainer.data('zoomie');
            if (zoomie) {
                zoomie.reset();
            }
        } else {
            var anchor = $('a', scope._imageContainer);
            if (isPlusSize) {
                if (images.detailPlusSize) {
                    img.attr('src', images.detailPlusSize).attr('alt', imageName);
                    anchor.attr('href', images.detailPlusSize);

                    if (curSrc != images.detailPlusSize) {
                        changed = true;
                    }
                }
                if (images.zoomPlusSize) {
                    anchor.data('zoom', images.zoomPlusSize);
                }
            } else {
                if (images.detail) {
                    img.attr('src', images.detail).attr('alt', imageName);
                    anchor.attr('href', images.detail);

                    if (curSrc != images.detail) {
                        changed = true;
                    }
                }
                if (images.zoom) {
                    anchor.data('zoom', images.zoom);
                }
            }
        }

        if (changed) {
            scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MAIN_IMAGE_CHANGED, scope.eventIdentity);
        }
    },
    GetImageData: function GetImageData(img) {
        var scope = this;
        var data = img.data('images');
        if (!data) {
            var imgData = img.data();
            data = {
                detail: imgData.imagePath,
                zoom: scope.GetBestZoomImage(imgData.zoomPath),
                detailPlusSize: imgData.plusImagePath,
                zoomPlusSize: scope.GetBestZoomImage(imgData.plusZoomPath)
            };
        }

        return data;
    }
};

/**
    * HSN.ProductOptionSelector.EVENT = Object
    *
    * An enumeration of events an [[HSN.Flyout]] can raise:
    * - OPTION_CHANGED: Fires when an option selection changes.
    **/
HSN.ProductOptionSelector.EVENT = {
    OPTION_CHANGED: 'HSN.ProductOptionSelector:OPTION_CHANGED',
    GROUP_CHANGED: 'HSN.ProductOptionSelector:GROUP_CHANGED',
    MATRIX_OPTION_SELECTED: 'HSN.ProductOptionSelector:MATRIX_OPTION_SELECTED',
    OPTION_STATUS_CHANGED: 'HSN.ProductOptionSelector:OPTION_STATUS_CHANGED',
    MAIN_IMAGE_CHANGED: 'HSN.ProductOptionSelector:MAIN_IMAGE_CHANGED'
};

/***/ }),

/***/ "a4iX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* class HSN.Flyout
*
* Encapsulates the functionality of a menu that pops up when another UI
* element is hovered.
**/
HSN.Flyout = function (config) {
    /**
    * new HSN.Flyout(config)
    * - config (Object): A configuration object for the [[HSN.Flyout]]
    *   consisting of the following keys:
    *   - closer (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as a close button for the flyout.
    *   - closeClass (string): CSS classes to be added to the Flyout's close button.
    *   - closeTag (string): The HTML tag to use for the Flyout's close button if no closer is provided. Defaults to span.
    *   - trigger (HTMLElement): The HTML element that should be the trigger for opening & closing the flyout.
    *   - flyout (HTMLElement): The HTML element that should be shown and hidden when the trigger is interacted with.
    *   - triggerEvent (HSN.Flyout.TRIGGER_EVENT): The event that should trigger opening of the flyout. Defaults to [[HSN.Flyout.TRIGGER_EVENT.HOVER]]
    *   - noajax (boolean): Turns off the flyout Open function for pages where ajax will not be available.
    *   - relocateFlyout (boolean): If true, repositions flyout inside trigger element.
    *   - timeout (integer): milliseconds to wait before closing flyout after leaving trigger area
    *   - isSetContainerHtmlOnHide (boolean): if true the flyout container html will be replaced by the value in htmlForContainerOnHide
    *   - htmlForContainerOnHide (string): html to set the flyout container too when isSetContainerHtmlOnHide is true
    **/
    var __scope = this;

    this.config = config = config || {};
    config.closeTag = config.closeTag = config.closeTag || 'span';
    config.triggerEvent = config.triggerEvent = config.triggerEvent || HSN.Flyout.TRIGGER_EVENT.HOVER;

    this.Cacheable = config.cacheable = config.cacheable || false;
    this.Events = new HSN.EventCoordinator();
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.Url = config.url;
    this.NoAjax = config.noajax;
    this.RelocateFlyout = config.relocateFlyout;
    this.Timeout = "timeout" in config ? config.timeout : 350;
    this.DisableHover = config.disableHover;
    this.IsSetContainerHtmlOnHide = config.isSetContainerHtmlOnHide;
    this.HtmlForContainerOnHide = (config.htmlForContainerOnHide = config.htmlForContainerOnHide) || '';
    this.SetInvisible = config.setInvisible;
    this.AjaxData = config.ajaxData || {};
    this.IsPost = config.isPost || false;
    this.matchWindowHeight = config.matchWindowHeight || false;
    this.disableScrolling = config.disableScrolling || false;
    this.setMask = config.setMask || false;

    if (config.closer) {
        __scope.Closer = $(config.closer);
    } else {
        __scope.Closer = $('<' + config.closeTag + '>Close</' + config.closeTag + '>');
    }

    __scope.Closer.on('click', function (e) {
        e.preventDefault();
        __scope.Close();
        return false;
    });

    __scope.Closer.addClass('close');

    if (config.closeClass) {
        __scope.Closer.addClass(config.closeClass);
    }

    if (!config.closer) {
        this.Flyout.append(__scope.Closer);
    }

    switch (config.triggerEvent) {
        case HSN.Flyout.TRIGGER_EVENT.CLICK:
            this.Trigger.on('click', function (e) {
                e.preventDefault();
                if (Modernizr.touchevents) {
                    __scope.Trigger.off('click');
                }

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }
                return false;
            });
            break;
        case HSN.Flyout.TRIGGER_EVENT.TOUCH:
            this.Trigger.on('touchend', function (e) {
                e.preventDefault();

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }
                return false;
            });
            break;
        case HSN.Flyout.TRIGGER_EVENT.HOVER:
            if (!this.DisableHover) {
                this.Trigger.on('mouseenter', function (e) {
                    var scope = this;
                    var flyout = __scope.Flyout;

                    var timeout = flyout.data('_HSN.Flyout.MouseLeaveTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseLeaveTimeout', null);
                    }

                    flyout.data('_HSN.Flyout.MouseEnterTimeout', setTimeout(function () {
                        __scope.Open(scope);

                        if (__scope.config.onOpenCallback) __scope.config.onOpenCallback();
                    }, __scope.Timeout));
                });
                this.Trigger.on('mouseleave', this.triggers, function (e) {
                    var flyout = __scope.Flyout;
                    var scope = this;

                    var timeout = flyout.data('_HSN.Flyout.MouseEnterTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseEnterTimeout', null);
                    }

                    flyout.data('_HSN.Flyout.MouseLeaveTimeout', setTimeout(function () {
                        __scope.Close(scope);

                        if (__scope.config.onCloseCallback) __scope.config.onCloseCallback();
                    }, __scope.Timeout));
                });
            }
            break;

        case HSN.Flyout.TRIGGER_EVENT.CLICKHOVER:
            this.Trigger.on('click', function (e) {
                e.preventDefault();
                if (Modernizr.touchevents) {
                    __scope.Trigger.off('click');
                }

                var scope = this;
                switch (__scope.GetState()) {
                    case HSN.Flyout.STATE.CLOSED:
                        __scope.Open(scope);
                        break;
                    case HSN.Flyout.STATE.OPEN:
                        __scope.Close(scope);
                }

                return false;
            });

            if (!this.DisableHover) {
                this.Trigger.on('mouseleave', this.triggers, function (e) {
                    var scope = this;
                    return false;
                });

                this.Flyout.on('mouseleave', this.triggers, function (e) {
                    var flyout = __scope.Flyout;
                    var scope = this;

                    var timeout = flyout.data('_HSN.Flyout.MouseEnterTimeout');
                    if (timeout) {
                        clearTimeout(timeout);
                        flyout.data('_HSN.Flyout.MouseEnterTimeout', null);
                    }

                    flyout.data('_HSN.Flyout.MouseLeaveTimeout', setTimeout(function () {
                        __scope.Close(scope);
                    }, __scope.Timeout));
                });
            }

            break;

        case HSN.Flyout.TRIGGER_EVENT.TOUCH_WITH_CLOSE:
            this.Trigger.on('touchend', {
                context: __scope
            }, __scope.OnTouchWithClose);

            break;
    }
};

/**
* HSN.Flyout.EVENT = Object
*
* An enumeration of events an [[HSN.Flyout]] can raise:
* - BEFORE_OPEN: Right before the flyout is opened.
* - BEFORE_CLOSE: Right before the flyout is opened.
**/
HSN.Flyout.EVENT = {
    BEFORE_CLOSE: 'flyout:before_close',
    BEFORE_OPEN: 'flyout:before_open',
    AFTER_LOAD: 'flyout:after_load'
};

/**
* HSN.Flyout.STATE = Object
*
* An enumeration of possible states that the flyout can have, with the following members:
* - CLOSED: The flyout is currently closed.
* - OPEN: The flyout is currently open.
**/
HSN.Flyout.STATE = {
    CLOSED: false,
    OPEN: true
};

/**
* HSN.Flyout.TRIGGER_EVENT = Object
*
* An enumeration of possible events that can trigger a flyout to open, with the following members:
* - CLICK: Opens the flyout on click.
* - HOVER: Opens the flyout on mouse enter, closes the flyout on mouse leave.
* - CLICKHOVER: Opens the flyout on [trigger] click, closes the flyout on [flyout] mouse leave.
**/
HSN.Flyout.TRIGGER_EVENT = {
    CLICK: 1,
    HOVER: 2,
    TOUCH: 3,
    CLICKHOVER: 4,
    TOUCH_WITH_CLOSE: 5
};

HSN.Flyout.prototype = {
    _state: HSN.Flyout.STATE.CLOSED,

    /**
    * HSN.Flyout#Events -> HSN.EventCoordinator
    *
    * Provides access to the [[HSN.EventCoordinator]] instance that the
    * flyout uses to raise it's events.
    **/
    Events: null,

    /**
    * HSN.Flyout#Flyout -> jQuery
    *
    * [[HSN.Flyout#Flyout]] provides access to the jQuery-wrapped HTML element that is the flyout.
    **/
    Flyout: null,

    /**
    * HSN.Flyout#Trigger -> jQuery
    *
    * [[HSN.Flyout#Trigger]] provides access to the jQuery-wrapped HTML element that is the flyout trigger.
    **/
    Trigger: null,

    /**
    * HSN.Flyout#Close -> void
    *
    * [[HSN.Flyout#Close]] closes the flyout and sets proper state on all related elements.
    **/
    Close: function Close(trigger) {
        if (this._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }

        this.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, this);
        HSN.Instance().Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE);
        this.Flyout.hide();
        if (this.IsSetContainerHtmlOnHide) {
            this.Flyout.html(this.HtmlForContainerOnHide);
        }
        if (this.RelocateFlyout) {
            $(this.Flyout, this.Trigger).remove();
            $('.arrow', this.Trigger).remove();
            this.Trigger.removeClass('flyout-container');
        }
        $(this.Trigger).removeClass('active');
        this._state = HSN.Flyout.STATE.CLOSED;

        $('.video-flash').css('visibility', 'visible');

        if (this.disableScrolling) {
            $('html, #torso').css({ 'overflow': '' });
            $('#torso').css({ 'position': '' });
        }
        if (this.setMask) {
            $('#modal-mask').remove();
        }

        $('.flyout-container.v2').hide();
    },

    /**
    * HSN.Flyout#GetState() -> HSN.Flyout.STATE
    *
    * [[HSN.Flyout#GetState]] returns the appropriate [[HSN.Flyout.STATE]] value to indicate whether the flyout is currently open or closed.
    **/
    GetState: function GetState() {
        return this._state;
    },

    /**
    * HSN.Flyout#Open -> void
    *
    * [[HSN.Flyout#Open]] opens the flyout and sets proper state on all related elements.
    **/
    Open: function Open(trigger, forceOpen, noAnimate) {
        var __scope = this;
        var $trigger = $(trigger);

        $('.video-flash').css('visibility', 'hidden');

        if (typeof noAnimate == "undefined" || noAnimate == null) {
            noAnimate = true;
        }

        if (!forceOpen && this._state === HSN.Flyout.STATE.OPEN || this.NoAjax && typeof __scope.Url !== "undefined") {
            return;
        }

        $('.flyout-container.v2').show();

        this.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, this);
        HSN.Instance().Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN);
        $trigger.addClass('active');
        if (this.RelocateFlyout) {
            $trigger.addClass('flyout-container');
            var relocatedFlyout = this.Flyout.appendTo($trigger);
            var arrow = $('<div class="arrow"></div>').appendTo($trigger);
            this.Flyout.css({
                'top': -(this.Flyout.height() + $trigger.height()) + 6,
                'left': -(this.Flyout.width() / 4 + $trigger.width() / 4)
            });
            arrow.css({
                'top': -$trigger.height() + 6,
                'left': $trigger.width() / 3
            });
            relocatedFlyout.show();
        } else {
            if (noAnimate) {
                this.Flyout.show();
            } else {
                this.Flyout.stop(true, true).fadeIn({ duration: 250, queue: false }).css('display', 'none').slideDown(250);
            }
        }

        if (this.SetInvisible) {
            this.Flyout.css('visibility', 'hidden');
        }
        if (this.matchWindowHeight) {
            this.Flyout.css('height', '100%');
        }
        if (this.disableScrolling) {
            $('html, #torso').css({ 'overflow': 'hidden' });
            $('#torso').css({ 'position': 'fixed' });
        }
        if (this.setMask) {
            if (!$('#modal-mask').is(':visible')) {
                $('<div></div>').prependTo('#torso').attr('id', 'modal-mask').addClass('lower-mask');
            }

            if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
                $('#modal-mask').css('height', $('body').height());
                $('#modal-mask').show();
            }
        }

        this._state = HSN.Flyout.STATE.OPEN;

        if (typeof __scope.Url === "undefined") {
            return;
        }

        //Call for asynchronously loaded flyouts, which have url specified
        $.ajax(__scope.Url, {
            type: __scope.IsPost ? "POST" : "GET",
            cache: __scope.Cacheable,
            context: __scope,
            data: __scope.AjaxData,
            dataType: 'html',
            success: function success(data, status, xhr) {
                __scope.Flyout.html(data); //.show();

                //TODO: wrap this in a coremetrics check
                cX("onload");

                __scope.Flyout.append(__scope.Closer);

                //TODO: check if can avoid rewiring close callback from above
                __scope.Closer.on('click', function (e) {
                    e.preventDefault();
                    __scope.Close();
                    return false;
                });

                __scope.Events.Trigger(HSN.Flyout.EVENT.AFTER_LOAD, __scope);
            },
            error: function error(xhr, status, _error) {
                if (xhr.readyState === 0 && xhr.status === 0) {
                    return;
                }
                alert("Unfortunately there was an error attempting to load the content, please try again.");
            }
        });
    },

    SetUrl: function SetUrl(url) {
        this.Url = url;
    },

    RemoveHandlers: function RemoveHandlers() {
        this.Trigger.off();
    },

    OnTouchWithClose: function OnTouchWithClose(e) {
        e.preventDefault();
        var context = e.data.context;
        var scope = this;
        //turn off so flyout can appear
        context.Trigger.off('touchend');

        switch (context.GetState()) {
            case HSN.Flyout.STATE.CLOSED:
                context.Open(scope);
                break;

            case HSN.Flyout.STATE.OPEN:
                context.Close(scope);
        }

        //close on tap outside of element
        $('html').on('touchend', function (e) {
            if ($(e.target).parents('.flyout-container').length === 0 && context.GetState() === HSN.Flyout.STATE.OPEN) {

                //turn back on touch event so flyout can be interacted with
                context.Trigger.on('touchend', {
                    context: context
                }, context.OnTouchWithClose);

                context.Close(scope);

                return false;
            }
            return true;
        });
    }
};

/***/ }),

/***/ "aGXW":
/***/ (function(module, exports) {

/**
 * HSN.Service
 **/
HSN.Service = HSN.Service = HSN.Service || {};

/***/ }),

/***/ "azVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cabinet_js__ = __webpack_require__("iWJj");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
* class HSN.AccountNavigation.Cabinet.Drawer
*
* Encapsulates a single drawer for the HSN cabinet pairing a trigger for the
* drawer and the URL it's data should be loaded from.
**/
HSN.AccountNavigation.Cabinet.Drawer = function (config) {
    /**
     * new HSN.AccountNavigation.Cabinet.Drawer(config)
     * - config (Object): A configuration object for the [[HSN.AccountNavigation.Cabinet.Drawer]]
     *   consisting of the following keys:
     *   - identifier (String): The unique identifier of this drawer so it may be referenced directly within the context of a [[HSN.AccountNavigation.Cabinet]].
     *   - trigger (HTMLElement): The HTML element that should be the trigger for opening & closing the drawer.
     *   - url (String): The URL that the data for the drawer should be loaded from.
     *   - callback (Function): An optional callback function to execute once the drawer content has fully loaded.
     **/
    config = config = config || {};

    this.Identifier = config.identifier;
    this.Callback = config.callback;
    this.CloseCallback = config.closeCallback;
    this.Trigger = $(config.trigger);
    this.Url = config.url;
    this.NoAjax = config.noajax;

    if (this.NoAjax) {
        this.Trigger.addClass('drawer-trigger-noajax');
    }

    this.Trigger.append('<span class="ir active-indicator"></span>');
};
HSN.AccountNavigation.Cabinet.Drawer.prototype = {
    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Identifier -> String
     *
     * The unique identifier for this [[HSN.AccountNavigation.Cabinet.Drawer]] so it may be referenced directly within the context of a [[HSN.AccountNavigation.Cabinet]].
     **/
    Identifier: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Callback -> Function | null
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Function]] provides access to the optional callback that will be executed once a drawer has loaded.
     **/
    Callback: null,

    /**
         * HSN.AccountNavigation.Cabinet.Drawer#CloseCallback -> Function | null
         *
         * [[HSN.AccountNavigation.Cabinet.Drawer#Function]] provides access to the optional callback that will be executed once a drawer has closed.
    **/
    CloseCallback: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Trigger -> jQuery
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Trigger]] provides access to the jQuery-wrapped HTML element that is the drawer trigger.
     **/
    Trigger: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Url -> String
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Url]] provides access URL that the data for the drawer should be loaded from.
     **/
    Url: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#NoAjax -> Boolean
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#NoAjax]] provides access to a value to turn off the ajax Open functionality of the drawer.
    **/
    NoAjax: null
};

/***/ }),

/***/ "b2Ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Widget.AddEditPayment
    *
    * Encapsulates the common functionality of the AddEditPayment Widget.
    **/
HSN.Widget.AddEditPayment = function () {
    var application;
    var container;
    var scope = this;
    var isEdit;
    var tokenizationUrl;
    var paymentService;
    var deviceInformation;
    var isTokenizerOk = false;
    /**
        * new HSN.Widget.AddEditPayment.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.AddEditPayment]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        isEdit = config.isEdit || false;
        tokenizationUrl = config.tokenizationUrl;
        paymentService = application._getPaymentService();
        deviceInformation = application.DeviceInformation;
        bindEvents();
    }

    function bindEvents() {
        if (!isEdit) {
            var easyXdmPromise = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "qS3Q"));

            easyXdmPromise.then(function (EasyXDMLoaded) {
                $('#card-number').hide();
                application.ccTokenizerSocket = new easyXDM.Rpc({
                    remote: tokenizationUrl,
                    props: {
                        id: 'card-number_Tokenizer',
                        frameborder: 0,
                        scrolling: 'no',
                        style: {
                            overflow: 'hidden',
                            width: '100%',
                            height: '34px',
                            allowTransparency: 'true',
                            margin: '5px auto'
                        }
                    },
                    container: $('#card-number-container')[0]
                }, {
                    remote: {
                        tokenize: {},
                        clearTextBox: {},
                        status: {}
                    }
                });

                window.setTimeout(function () {
                    application.ccTokenizerSocket.status(function () {
                        isTokenizerOk = true;
                    });
                }, 4800);
                window.setTimeout(function () {
                    if (!isTokenizerOk) {
                        paymentService.LogTokenizerFailure({ Type: 'CreditCard' }, {});
                    }
                }, 5000);
            });
        }

        container.on('click', '#make-default, #is-debit, #save-flag', function () {
            $(this).val(this.checked);
        });
        container.on('click', '#cancel', function () {
            application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.CANCELED, isEdit);
            return false;
        });
        container.on('click', '#save-add, #save-edit', function () {
            var form = $('#payment-form');
            if (!isEdit && $('#card-number').length && (!$('#credit-card').length || $('#credit-card').hasClass('active')) && application.ccTokenizerSocket) {
                application.ccTokenizerSocket.tokenize(function (response) {
                    isTokenizerOk = true;
                    if (response.error) {
                        var respError = { "errorFields": [{ "Key": 'CardNumber', "Value": response.error.faultDetail }], "errors": [response.error.faultDetail], "success": false };
                        HSN.AddErrorTreatment('#payment-form', respError, scope._container);
                        HSN.RemoveWait();
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respError);
                    } else {
                        $('#CCTokenizationToken').val(response.data.token);
                        $('#CCTokenizationCardType').val(response.data.cardType);
                        $('#CCTokenizationBankName').val(response.data.bankName);
                        SavePaymentInformation(form);
                        return false;
                    }
                    return false;
                });
            } else {
                SavePaymentInformation(form);
                return false;
            }
            return false;
        });
        application.Events.On(HSN.Widget.AddEditPayment.EVENT.TOKENIZE_CARD, TokenizeCard);
    }
    function TokenizeCard(callback) {
        if (!isEdit && $('#card-number').length && (!$('#credit-card').length || $('#credit-card').hasClass('active')) && application.ccTokenizerSocket) {
            application.ccTokenizerSocket.tokenize(function (response) {
                isTokenizerOk = true;
                if (response.error) {
                    var respError = { "errorFields": [{ "Key": 'CardNumber', "Value": response.error.faultDetail }], "errors": [response.error.faultDetail], "success": false };
                    application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respError);
                } else {
                    $('#CCTokenizationToken').val(response.data.token);
                    $('#CCTokenizationCardType').val(response.data.cardType);
                    $('#CCTokenizationBankName').val(response.data.bankName);
                    callback();
                    return false;
                }
                return false;
            });
        } else {
            callback();
        }
    }
    function SavePaymentInformation(form) {
        var isSaved = $('#save-flag', container).val() === 'true';
        var isAdd = form.find('input[name=Type]').val() === 'add';
        var isMakeDefault = $('#make-default', container).val() === 'true';

        paymentService.ValidatePayment(form.serialize(), {
            callback: function callback(data) {
                if (data.success) {
                    HSN.SetWait();
                    paymentService.AddEditPaymentSave(form.serialize(), {
                        callback: function callback(respData) {
                            if (respData.success) {
                                respData.isSaved = isSaved;
                                respData.isAdd = isAdd;
                                respData.isMakeDefault = isMakeDefault;
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, respData);
                            } else if (respData.mergeErrorDestination) {
                                window.location.href = respData.mergeErrorDestination;
                            } else if (respData.errorFields) {
                                HSN.AddErrorTreatment('#payment-form', respData, container);
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respData);
                            } else {
                                HSN.CheckoutHandleError(container, respData, 'Unfortunately there was an error attempting to save your payment method, please try again.');
                                application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, respData);
                            }
                        },
                        scope: this
                    });
                } else {
                    if (data.errorFields) {
                        HSN.AddErrorTreatment('#payment-form', data, container);
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, data);
                    } else {
                        HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to save your payment method, please try again.');
                        application.Events.Trigger(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, data);
                    }
                }
                HSN.RemoveWait();
            },
            scope: this
        });
    }
    function Destroy() {
        if (application) {
            application.Events.Off(HSN.Widget.AddEditPayment.EVENT.TOKENIZE_CARD, null, this);
        }
        application = container = paymentService = deviceInformation = null;
    }
    return {
        init: init,
        Destroy: Destroy
    };
};

HSN.Widget.AddEditPayment.EVENT = {
    CANCELED: 'HSN.Widget.AddEditPayment:CANCELED',
    SAVE_COMPLETE: 'HSN.Widget.AddEditPayment:SAVE_COMPLETE',
    SAVE_FAILED: 'HSN.Widget.AddEditPayment:SAVE_FAILED',
    TOKENIZE_CARD: 'HSN.Widget.AddEditPayment:TOKENIZE_CARD'
};

/***/ }),

/***/ "c50M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.FitGuideModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.FitGuideModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(fitGuideModal, parent);

    /**
    * new HSN.FitGuideModal()
    **/
    function fitGuideModal() {
        this.name = 'HSN.FitGuideModal';
        fitGuideModal.__super__.constructor.call(this);

        this.internalTabsSelector = '.tab-items a[data-page-type]';
        this.externalTabsSelector = 'a[data-page-type].external-trigger';
        this.tabsSelector = this.internalTabsSelector + ',' + this.externalTabsSelector;

        setupCallbacks(this);
    }

    function setupCallbacks(scope) {
        //callback for switching tabs via external triggers
        scope.Root.on('click', scope.externalTabsSelector, function (e) {
            e.preventDefault();

            var href = $(this).attr('href'); //extract trigger href ID
            href = href.substr(href.indexOf('#'));

            var tabs = $(scope.internalTabsSelector).parent(); //tabs parent
            var tab = $('a[href=\"' + href + '\"]', tabs); //desired tab

            scope._tabPanel.ActivateTab(tab, false);
        });

        //Callback for tab, loading tab data
        scope.Root.on('click', scope.tabsSelector, function (e) {
            e.preventDefault();

            var selector = this;

            var data = fitGuideModal.data; //carry over data from first call

            var href = $(selector).attr('href');
            href = href.substr(href.indexOf('#'));

            data.pageType = $(selector).data("page-type");

            //retrieve tab specific data
            $.ajax(fitGuideModal.url + "?" + new Date().getTime(), {
                dataType: 'html',
                data: data,
                success: function success(htmlData) {
                    $(href).html(htmlData); //fill tab content

                    if (data.pageType == 'sizeRec') {
                        //needed for unobtrusive client side validation for ajax loaded form
                        $.validator.unobtrusive.parse($('form', href));
                    }
                },
                error: function error() {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                }
            });
        });

        scope.Root.on('keydown', '.exit-block .button-group .proxy-button', function (e) {
            var button = $(this);
            if (e.key === 'Enter') {
                e.preventDefault();
                button.trigger('click');
            } else if (e.key === 'Tab' && !e.shiftKey && button.text() === 'Save & Continue') {
                e.preventDefault();

                var elemetToFocus = scope.Close;
                scope.Center();
                scope.Content.animate({ opacity: 1 }, function () {
                    scope.SetFocus(elemetToFocus);
                });
            }
        });

        scope.Root.on('keyup', 'figure li div', function (e) {
            if (e.key === 'Tab') {
                var parentItem = $(e.target).closest('li');
                parentItem.find('.line').show();
            }
        });

        scope.Root.on('keydown', 'figure li div', function (e) {
            if (e.key === 'Tab') {
                var figureItems = scope.Root.find('figure li');
                figureItems.find('.line').hide();
            }
        });
    }

    fitGuideModal.prototype._hide = function () {};

    /**
    * HSN.FitGuideModal#Show(url, data) -> void
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    fitGuideModal.prototype._show = function (url, data) {
        var scope = this;

        fitGuideModal.url = url;
        fitGuideModal.data = data;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: data,
            success: function success(htmlData) {
                scope.Root.removeClass('loading');

                scope.DisplayModal(htmlData, 0);

                if (data.defaultPage.length > 0) {
                    var tabToSelect = $('.tab-items a[data-page-type="' + data.defaultPage + '"]', scope.Root);
                    if (tabToSelect.length) {
                        tabToSelect.trigger('click'); //set default tab based on requested tab
                    } else {
                        $('.tab-items a[data-page-type]', scope.Root).last().trigger('click'); //set default tab based on fallback tab
                    }
                } else {
                    $('.tab-items a[data-page-type]', scope.Root).last().trigger('click'); //set default tab with no request tab.
                }
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for review modal form, use ajax to retrieve response, and update modal content
    **/
    fitGuideModal.prototype.SubmitMyMeasurementForm = function (saveData) {
        var scope = this;

        var myMeasurementForm = $('form', scope.Root);

        //manually run client validation since we arent running submit operation
        if (!myMeasurementForm.valid()) return;

        var formData = myMeasurementForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/fitguide/submit-my-measurement?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        }).done(function (data) {
            var href = $('.tab-items a[data-page-type="sizeRec"]', scope.Root).attr('href'); //get my measure tab
            href = href.substr(href.indexOf('#'));

            $(href).html(data); //fill tab content
        }).fail(function () {
            alert('error submitting my measurement values');
        });
    };

    fitGuideModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            var elemetToFocus = scope.Root.find('#modalPopup');
            scope.Center();
            scope.Content.animate({ opacity: 1 }, function () {
                scope.SetFocus(elemetToFocus);
            });
        }, function () {
            //scope.Center();
        });

        this._tabPanel = new HSN.TabPanel(scope.Root, scope.internalTabsSelector, null, false);
    };

    return fitGuideModal;
}(HSN.Modal);

/***/ }),

/***/ "cHJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.Widget.FancyInput
    *
    * Encapsulates the common functionality of the AddToBag Widget.
    **/
HSN.Widget.FancyInput = function () {
    var application;
    var deviceInformation;
    var fancyInputContainer;
    var inputSelector = '.float-label-input input, .float-label-input textarea';
    var showHideSelector = '.float-label-input .show-hide';
    /**
        * new HSN.Widget.FancyInput.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FancyInput]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        **/
    function init(config) {
        application = config.application;
        deviceInformation = application.DeviceInformation;
        fancyInputContainer = typeof config.containerName !== 'undefined' ? $(config.containerName) : $('body');

        bindEvents();
    }

    function bindEvents() {
        fancyInputContainer.find(inputSelector).each(function () {
            if ($(this).val().length > 0) {
                $(this).addClass('filled');
            }
        });
        fancyInputContainer.on('focus', inputSelector, function () {
            $(this).addClass('focus');
        });
        fancyInputContainer.on('click', showHideSelector, function () {
            var showHide = $(this).children(':visible:first');
            if (showHide.hasClass('show')) {
                $(showHide).toggle(false).siblings('.hide').toggle(true);
                $(showHide).parent().siblings('input').attr('type', 'text');
            } else {
                $(showHide).toggle(false).siblings('.show').toggle(true);
                $(showHide).parent().siblings('input').attr('type', 'password');
            }
        });
        fancyInputContainer.on('keyup', showHideSelector, function (e) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
            var key = e.keyCode || e.which;
            if (key === keys.enter) {
                var showHide = $(this).children(':visible:first');
                if (showHide.hasClass('show')) {
                    $(showHide).toggle(false).siblings('.hide').toggle(true);
                    $(showHide).parent().siblings('input').attr('type', 'text');
                } else {
                    $(showHide).toggle(false).siblings('.show').toggle(true);
                    $(showHide).parent().siblings('input').attr('type', 'password');
                }
            }
        });
        fancyInputContainer.on('focusout', inputSelector, function () {
            $(this).removeClass('focus');
        });
        fancyInputContainer.on('keyup', inputSelector, function () {
            if ($(this).val().length > 0) {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });
        fancyInputContainer.on('blur input', inputSelector, function () {
            if ($(this).val().length > 0) {
                $(this).addClass('filled');
            } else {
                $(this).removeClass('filled');
            }
        });
    }

    return {
        init: init
    };
};
HSN.Widget.FancyInput.EVENT = {};

/***/ }),

/***/ "cV/x":
/***/ (function(module, exports) {

﻿/*
* Mailcheck https://github.com/Kicksend/mailcheck
* Author
* Derrick Ko (@derrickko)
*
* License
* Copyright (c) 2012 Receivd, Inc.
*
* Licensed under the MIT License.
*
* v 1.1
*/

var Kicksend = {
    mailcheck: {
        threshold: 3,

        defaultDomains: ["yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com",
          "live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk",
          "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "mail.com"],

        defaultTopLevelDomains: ["co.uk", "com", "net", "org", "info", "edu", "gov", "mil"],

        run: function (opts) {
            opts.domains = opts.domains || Kicksend.mailcheck.defaultDomains;
            opts.topLevelDomains = opts.topLevelDomains || Kicksend.mailcheck.defaultTopLevelDomains;
            opts.distanceFunction = opts.distanceFunction || Kicksend.sift3Distance;

            var result = Kicksend.mailcheck.suggest(encodeURI(opts.email), opts.domains, opts.topLevelDomains, opts.distanceFunction);

            if (result) {
                if (opts.suggested) {
                    opts.suggested(result);
                }
            } else {
                if (opts.empty) {
                    opts.empty();
                }
            }
        },

        suggest: function (email, domains, topLevelDomains, distanceFunction) {
            email = email.toLowerCase();

            var emailParts = this.splitEmail(email);

            var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction);

            if (closestDomain) {
                if (closestDomain != emailParts.domain) {
                    // The email address closely matches one of the supplied domains; return a suggestion
                    return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
                }
            } else {
                // The email address does not closely match one of the supplied domains
                var closestTopLevelDomain = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains);
                if (emailParts.domain && closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
                    // The email address may have a mispelled top-level domain; return a suggestion
                    var domain = emailParts.domain;
                    closestDomain = domain.substring(0, domain.lastIndexOf(emailParts.topLevelDomain)) + closestTopLevelDomain;
                    return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
                }
            }
            /* The email address exactly matches one of the supplied domains, does not closely
      * match any domain and does not appear to simply have a mispelled top-level domain,
      * or is an invalid email address; do not return a suggestion.
      */
            return false;
        },

        findClosestDomain: function (domain, domains, distanceFunction) {
            var dist;
            var minDist = 99;
            var closestDomain = null;

            if (!domain || !domains) {
                return false;
            }
            if (!distanceFunction) {
                distanceFunction = this.sift3Distance;
            }

            for (var i = 0; i < domains.length; i++) {
                if (domain === domains[i]) {
                    return domain;
                }
                dist = distanceFunction(domain, domains[i]);
                if (dist < minDist) {
                    minDist = dist;
                    closestDomain = domains[i];
                }
            }

            if (minDist <= this.threshold && closestDomain !== null) {
                return closestDomain;
            } else {
                return false;
            }
        },

        sift3Distance: function (s1, s2) {
            // sift3: https://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
            if (s1 == null || s1.length === 0) {
                if (s2 == null || s2.length === 0) {
                    return 0;
                } else {
                    return s2.length;
                }
            }

            if (s2 == null || s2.length === 0) {
                return s1.length;
            }

            var c = 0;
            var offset1 = 0;
            var offset2 = 0;
            var lcs = 0;
            var maxOffset = 5;

            while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
                if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
                    lcs++;
                } else {
                    offset1 = 0;
                    offset2 = 0;
                    for (var i = 0; i < maxOffset; i++) {
                        if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
                            offset1 = i;
                            break;
                        }
                        if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
                            offset2 = i;
                            break;
                        }
                    }
                }
                c++;
            }
            return (s1.length + s2.length) / 2 - lcs;
        },

        splitEmail: function (email) {
            var parts = email.split('@');

            if (parts.length < 2) {
                return false;
            }

            for (var i = 0; i < parts.length; i++) {
                if (parts[i] === '') {
                    return false;
                }
            }

            var domain = parts.pop();
            var domainParts = domain.split('.');
            var tld = '';

            if (domainParts.length == 0) {
                // The address does not have a top-level domain
                return false;
            } else if (domainParts.length == 1) {
                // The address has only a top-level domain (valid under RFC)
                tld = domainParts[0];
            } else {
                // The address has a domain and a top-level domain
                for (var i = 1; i < domainParts.length; i++) {
                    tld += domainParts[i] + '.';
                }
                if (domainParts.length >= 2) {
                    tld = tld.substring(0, tld.length - 1);
                }
            }

            return {
                topLevelDomain: tld,
                domain: domain,
                address: parts.join('@')
            }
        }
    }
};

if (window.jQuery) {
    (function ($) {
        $.fn.mailcheck = function (opts) {
            var self = this;
            if (opts.suggested) {
                var oldSuggested = opts.suggested;
                opts.suggested = function (result) {
                    oldSuggested(self, result);
                };
            }

            if (opts.empty) {
                var oldEmpty = opts.empty;
                opts.empty = function () {
                    oldEmpty.call(null, self);
                };
            }

            opts.email = this.val();
            Kicksend.mailcheck.run(opts);
        }
    })(jQuery);
}

/***/ }),

/***/ "cn2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.AgentPortal = function () {};
HSN.Service.AgentPortal.prototype = {
    GetMain: function GetMain(config) {
        this._ajaxGet('/agent-portal/main', {}, config);
    },
    GetStatus: function GetStatus(config) {
        this._send('/agent-portal/status', {}, config);
    },
    Authenticate: function Authenticate(data, config) {
        this._send('/agent-portal/authenticate', data, config);
    },
    Signout: function Signout(config) {
        this._send('/agent-portal/signout', {}, config);
    },
    Search: function Search(data, config) {
        this._send('/agent-portal/search', data, config);
    },
    SetState: function SetState(data, config) {
        this._send('/agent-portal/set-state', data, config);
    },
    SelectCustomer: function SelectCustomer(data, config) {
        this._send('/agent-portal/select-customer', data, config);
    },
    NewCustomer: function NewCustomer(config) {
        this._send('/agent-portal/new-customer', {}, config);
    },
    ClearCustomer: function ClearCustomer(config) {
        this._send('/agent-portal/reset-session', {}, config);
    },
    ApplyCard: function ApplyCard(data, config) {
        this._send('/agent-portal/apply-card', data, config);
    },
    TogglePortal: function TogglePortal(data, config) {
        this._send('/portal-admin/toggle-portal', data, config);
    },

    _send: function _send(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error() {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback);
                } else if (config.callback) {
                    config.callback.call(config.scope || config.callback, true);
                }
            }
        });
    },

    _ajaxGet: function _ajaxGet(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: config.dataType || 'html',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    },

    _get: function _get(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'json',
            beforeSend: function beforeSend(xhr) {
                xhr.setRequestHeader('X-Requested-With', { toString: function toString() {
                        return '';
                    } });
            },
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    }
};

/***/ }),

/***/ "dHq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_js__ = __webpack_require__("Pd1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataLayer_js__ = __webpack_require__("qcZe");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




function cmCreateManualLinkClickTag() {}
function cmCreateManualImpressionTag() {}
function cmCreateManualPageviewTag() {}
function cmCreateElementTag() {}
function cmCreatePageElementTag() {}
function cmCreateProductElementTag() {}
function cmCreateConversionEventTag() {}
function cmCreatePageviewTag() {}
function cmCreateProductviewTag() {}
function cmCreateShopAction5Tag() {}
function cmCreateShopAction9Tag() {}
function cmCreateOrderTag() {}
function cmCreateRegistrationTag() {}
function cX() {}

window.cmCreateManualLinkClickTag = cmCreateManualLinkClickTag;
window.cmCreateManualImpressionTag = cmCreateManualImpressionTag;
window.cmCreateManualPageviewTag = cmCreateManualPageviewTag;
window.cmCreateElementTag = cmCreateElementTag;
window.cmCreatePageElementTag = cmCreatePageElementTag;
window.cmCreateProductElementTag = cmCreateProductElementTag;
window.cmCreateConversionEventTag = cmCreateConversionEventTag;
window.cmCreatePageviewTag = cmCreatePageviewTag;
window.cmCreateProductviewTag = cmCreateProductviewTag;
window.cmCreateShopAction5Tag = cmCreateShopAction5Tag;
window.cmCreateShopAction9Tag = cmCreateShopAction9Tag;
window.cmCreateOrderTag = cmCreateOrderTag;
window.cmCreateRegistrationTag = cmCreateRegistrationTag;
window.cX = cX;

//if (HSN.Application.prototype.GetQueryStringParam(window.location.search, 'cm_re').length > 0) {
//    var realEstateTag = HSN.Application.prototype.GetQueryStringParam(window.location.search, 'cm_re');
//    HSN.DataLayer.helpers.realEstate(null, realEstateTag);
//}

(function interceptCmCreateManualLinkClickTag() {
    window.cmCreateManualLinkClickTag = function (href) {
        var realEstateTag = HSN.Application.prototype.GetQueryStringParam(href, 'cm_re');
        HSN.DataLayer.helpers.realEstate(null, realEstateTag);
    };
})();

window.manualCmReClickHandler = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click.coremetricsRealEstate', 'a[manual_cm_re]', function (e) {
    var re = $(this).attr('manual_cm_re');
    HSN.DataLayer.helpers.realEstate(null, re);
});

/***/ }),

/***/ "dKm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






/**
    * class HSN.Modal
    *
    * Encapsulates the functionality of a modal dialog that contains product information.
    **/
HSN.Modal = function () {
    Modal.prototype.disabled = false;
    Modal.prototype.elementToFocusOnClose = null;

    Modal.EVENT = {
        MODAL_OPEN: 'HSN.Modal.EVENT.MODAL_OPEN',
        MODAL_CLOSE: 'HSN.Modal.EVENT.MODAL_CLOSE'
    };

    function Modal(className) {
        /**
            * new HSN.Modal()
            **/
        var __scope = this;

        if (!Modernizr.touchevents) $(window).resize(function () {
            __scope.Center();
        });

        $(window).on('keydown', function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode != 27) {
                return;
            }
            __scope.Hide();
        });

        $(window).scroll(function () {
            $('#modal-mask').css('height', $('body').height());
        });

        this.Root = className ? $('<div class="modal ' + className + '"></div>') : $('<div class="modal"></div>');
        this.Root.hide();

        var ariaFirst = "<div id=\"modalPopup\" role=\"presentation\" aria-modal=\"true\" aria-label=\"Dialog opened\" tabindex=\"0\" class=\"visuallyhidden\">Dialog opened</div>";
        this.Root.append(ariaFirst);

        this.Close = $('<a href="#" id="closeModal" tabindex="0" class="close" aria-label="close dialog"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" viewBox="0 0 512 512"><defs><path id="a" d="M0 511.756h511.756V.001H0v511.755z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path class="bg-color" fill="#0077c8" d="M366.86 335.774l-31.112 31.112-79.87-79.87-79.871 79.87-31.113-31.112 79.87-79.87-79.915-79.916 31.114-31.113 79.915 79.916 79.916-79.916 31.112 31.113-79.916 79.915 79.87 79.871zM74.858 74.86c-99.81 99.811-99.81 262.227 0 362.038 99.811 99.812 262.228 99.812 362.04 0 99.81-99.81 99.81-262.227 0-362.038-99.813-99.81-262.228-99.81-362.04 0z" mask="url(#b)"/></g></svg></a>');
        this.Close.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (__scope.elementToFocusOnClose) {
                __scope.elementToFocusOnClose.focus();
            }
            __scope.Hide();
        });
        this.Close.on('keyup', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var keys = __WEBPACK_IMPORTED_MODULE_4_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
            var key = e.keyCode || e.which;
            if (key === keys.enter) {
                if (__scope.elementToFocusOnClose) {
                    __scope.elementToFocusOnClose.focus();
                }
                __scope.Hide();
            }
        });

        this.Root.append(this.Close);

        this.Content = $('<div class="modal-content-container" tabindex="0"></div>');
        this.Root.append(this.Content);

        this._initialize();

        //TODO ugh, specifics in here, needed by potentially multiple modals, create another object to inherit from
        this.Content.on('click', '#login-nickname-wrapper .nickname-continue', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var form = $('#login-nickname-wrapper form', __scope.Content);

            //manually run client validation since we arent running submit operation
            if (!form.valid()) return;

            $.ajax({
                type: 'POST',
                url: '/nickname?' + new Date().getTime(),
                dataType: 'html',
                contentType: 'application/x-www-form-urlencoded',
                data: form.serialize()
            }).done(function (data) {
                //TODO: fix this event so that we actually no it was added and not just submitted and maybe added
                HSN.Instance().Events.Trigger(HSN.Application.EVENT.NICKNAME_ADDED);

                if (data.length == 0) {
                    __scope.Hide();
                    return;
                }
                __scope.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    //needed for unobtrusive client side validation for ajax loaded form
                    $.validator.unobtrusive.parse(form);
                }, function () {
                    //__scope.Center();
                });
            }).fail(function () {
                alert('error submitting review');
            });
        });
        this.Content.on('click', '#login-nickname-wrapper .nickname-cancel', function (e) {
            e.preventDefault();
            e.stopPropagation();

            __scope.Hide();
        });
    }

    Modal.prototype._initialize = function () {};

    // This private method must be implemented by all HSN.Modal subclasses.
    Modal.prototype._show = function () {
        throw "_show() is not implemented in " + this.constructor.name;
    };
    Modal.prototype.Root = null;
    Modal.prototype.Banner = null;

    /**
        * HSN.Modal#Content -> jQuery
        *
        * [[HSN.Modal#Content]] provides access to the jQuery-wrapped HTML element that contains the content for the modal.
        **/
    Modal.prototype.Content = null;

    /**
        * HSN.Modal#Root -> jQuery
        *
        * [[HSN.Modal#Content]] provides access to the jQuery-wrapped HTML element that is the root of the modal.
        **/
    Modal.prototype.Root = null;

    Modal.prototype.SetBanner = null;

    Modal.prototype.Disable = function () {
        this.disabled = true;

        if (this.Root != null) this.Hide();
    };

    Modal.prototype.Enable = function () {
        this.disabled = false;
    };

    /**
        * HSN.Modal#Center() -> void
        *
        * Centers the modal on the screen.
        **/
    Modal.prototype.Center = function (topoffset, leftoffset) {
        // TODO: Make window an injected dependency.

        // Move dialog to the left edge of the window, so content resizes root correctly, ensuring width is calculated correctly.
        this.Root.css("left", "0");

        if (!topoffset) topoffset = 0;

        if (!leftoffset) leftoffset = 0;

        var top = ($(window).height() - this.Root.outerHeight()) / 2;

        var newtop = 0;
        if (top < 0) newtop = 61 + $(window).scrollTop() + topoffset;else newtop = top + $(window).scrollTop() + topoffset;

        this.Root.css({
            top: newtop + "px",
            left: ($('body').width() - this.Root.outerWidth()) / 2 + $(window).scrollLeft() + leftoffset + "px"
        });
        if (!this.Banner) {
            return;
        }
        this.Banner.css({
            top: this.Root.offset().top - (this.Banner.outerHeight() - parseInt(this.Banner.css("padding-bottom"))) - 14,
            left: this.Root.offset().left
        });
    };

    /**
        * HSN.Modal#Hide() -> void
        *
        * Hides the modal.
        **/
    Modal.prototype.Hide = function () {
        var __scope = this;

        if (!__scope.Root.is(':visible')) {
            return;
        }

        if (__scope.Banner) {
            __scope.Banner.hide();
        }

        if ("_hide" in __scope) {
            __scope._hide();
        }

        this.Content.showHtml('', 0, function () {
            __scope.Root.hide();
        }, function () {
            //__scope.Center();
        });

        var areAnyModalsOpen = false;
        $('.modal-content-container').each(function () {
            var childrenArray = $(this).children();

            if (typeof childrenArray !== 'undefined' && childrenArray != null && childrenArray.length > 0) {
                areAnyModalsOpen = true;
            }
        });
        if (!areAnyModalsOpen) {
            $('#modal-mask').remove();
        }

        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_CLOSE);
    };

    /**
        * HSN.Modal#Show() -> void
        *
        * Shows the modal.
        **/
    Modal.prototype.Show = function () {
        if (this.disabled) return;

        this.Content.css('opacity', 0);
        this.Root.addClass('loading');
        this.Content.empty();
        this.Center();
        this.Root.show();
        if (!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('body').attr('id', 'modal-mask');
        }

        if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            //$('#modal-mask').css('width', $('body').outerWidth());
            $('#modal-mask').show();
        }
        this._show.apply(this, arguments);

        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_OPEN);
    };

    Modal.prototype.Refresh = function () {
        this.Root.addClass('loading');
        if (!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('body').attr('id', 'modal-mask');
        }

        if (!$('.modal').hasClass('no-mask') && !$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            $('#modal-mask').show();
        }
        this._show.apply(this, arguments);
    };
    Modal.prototype.AddLoadingSpinner = function () {
        if (!this.Root.find('#modal-loading').length > 0) {
            this.Root.append('<div id="modal-loading" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div></div>');
            this.Center();
        }
    };
    Modal.prototype.RemoveLoadingSpinner = function () {
        this.Root.find('#modal-loading, .animated-loader').remove();
        this.Root.removeClass('loading');
    };
    Modal.prototype.SetBanner = function (id) {
        var banner = this.Content.find(id);
        if (this.Banner) this.Banner.remove();
        if (banner) {
            this.Banner = banner;
            this.Root.before(banner);

            // Keep originals in data
            var bannerH = banner.children('h6');
            banner.data("originalClass", banner.attr("class"));
            bannerH.data("originalText", bannerH.text());

            banner.css({
                "top": this.Root.offset().top - (banner.outerHeight() - parseInt(banner.css("padding-bottom"))) - 14,
                "left": this.Root.offset().left,
                "position": "absolute",
                "width": this.Content.outerWidth() - parseInt(banner.css("paddingLeft")) - parseInt(banner.css("paddingRight")) + 2
            });
        }
    };

    Modal.prototype.SetElementToFocusOnClose = function (element) {
        this.elementToFocusOnClose = element;
    };

    //Use to set focus inside modal for ADA
    Modal.prototype.SetFocus = function (element) {
        element.focus();
    };

    return Modal;
}();

/***/ }),

/***/ "dKps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Widget_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.Widget.WriteReview
    *
    * Encapsulates the common functionality of the WriteReview Widget.
    **/
HSN.Widget.WriteReview = function () {
    var application;
    var commerceService;
    var deviceInformation;
    var scope = this;
    /**
        * new HSN.Widget.WriteReview.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.WriteReview]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with
        **/
    HSN.OnAccountStatusDetailLoad(function (data) {
        scope.bazaarVoiceUasToken = data.BazaarVoiceUasToken;
    });
    function init(config) {
        application = config.application;
        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;
    }
    function execute(productIdentity) {
        commerceService.CheckProductReviewable({ productIdentity: productIdentity }, {
            callback: function callback(data) {
                if (data.success) {
                    if (application.GetAppFeatures('writereview', '1')) {
                        var command = 'hsn://HSNWebView.WriteReview/' + productIdentity;
                        __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
                        return false;
                    }
                    BV.ui('rr', 'submit_review', { productId: productIdentity, userToken: scope.bazaarVoiceUasToken });
                } else {
                    if (data.status === 8 || data.status === 9) {
                        HsnDrdPageCache.setCookie('signin', 'ref=' + encodeURIComponent(window.location.pathname), HsnDrdPageCache.getLowerDomain(), null, '/');
                        Navigate('/nickname');
                        return;
                    }
                    if (data.status === 1) {
                        HsnDrdPageCache.setCookie('signin', 'ref=' + encodeURIComponent(window.location.pathname), HsnDrdPageCache.getLowerDomain(), null, '/');
                        Navigate('/signin');
                        return;
                    }
                    var errorContent = '<div><div class="write-review-error-container"><p>' + data.error + '</p><div id="ok-button" class="submit-button main-button blue" tabindex="0">ok</div></div></div>';
                    ShowError(errorContent);
                }
            },
            errorCallback: function errorCallback() {
                alert('Unfortunately there was an error attempting to write your review, please try again.');
                HSN.RemoveWait();
            }
        });
    }
    function BindModalHandler(modalScope) {
        $('.submit-button', modalScope.Content).on('click keydown', function () {
            modalScope.Hide();
            return false;
        });
    }
    function Navigate(url) {
        if (application.DeviceInformation.IsNativeApp) {
            if (url === '/signin' && application.DeviceInformation.HasNativeSignin) {
                var jsonData = { "returnUrl": window.location.href };
                var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
                __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
            }
            url = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].FullyQualifyRelativeLink(url);
            var encodedUrl = encodeURIComponent(url);
            var command = __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].BuildGapCommand(url);
            __WEBPACK_IMPORTED_MODULE_1_MOBILE_Gap_js__["default"].ExecCommand(command);
        } else {
            window.location.href = url;
        }
    }
    function ShowError(content) {
        HSN.RemoveWait();
        var modalReference = application.GetPageIdModal();
        modalReference.Show(content, true);
        BindModalHandler(modalReference);
        $('.write-review-container .submit-button', modalReference.Content).focus();

        return false;
    }
    return {
        init: init,
        execute: execute
    };
};

/***/ }),

/***/ "deWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Template_js__ = __webpack_require__("7LMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Template_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Template_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Template.Checkout.PayPalInContext
    *
    * Encapsulates the common functionality of the PayPalInContext Template.
    **/
HSN.Template.Checkout.PayPalInContext = function () {
    var application;
    var container;
    var payPalMerchantId;
    var payPalEnvironment;
    var payPalButtonIdList;
    var payPalButtonClassList;
    var returnUrl;
    var cancelUrlOverride;
    var express;
    var commerceService;
    var deviceInformation;
    var paypalAttempts = 0;
    var maxPaypalAttempts = 5;
    /**
        * new HSN.Template.Checkout.PayPalInContext.init(config)
        * - config (Object): A configuration object for the [[HSN.Template.Checkout.PayPalInContext]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        payPalMerchantId = config.payPalMerchantId;
        payPalEnvironment = config.payPalEnvironment;
        payPalButtonIdList = config.payPalButtonIdList || [];
        payPalButtonClassList = config.payPalButtonClassList || [];
        returnUrl = config.returnUrl || '';
        cancelUrlOverride = config.cancelUrlOverride || '';
        express = config.express || false;

        commerceService = application._getCommerceService();
        deviceInformation = application.DeviceInformation;

        configurePayPalInContext();
    }

    function configurePayPalInContext() {
        if (typeof window.paypal !== 'undefined' && window.paypal !== null) {
            window.paypal.checkout.setup(payPalMerchantId, {
                environment: payPalEnvironment,
                click: function click(event) {
                    event.preventDefault();
                    commerceService.UpdateBagPaymentProvider({ provider: "Hsn" });

                    window.paypal.checkout.initXO();
                    $.support.cors = true;
                    $.ajax({
                        url: "/payment-management/paypal-incontext/initiate",
                        type: "GET",
                        data: { "returnUrl": returnUrl, 'express': express, "cancelUrlOverride": cancelUrlOverride },
                        async: true,
                        crossDomain: true,

                        //Load the minibrowser with the redirection url in the success handler
                        success: function success(data) {
                            HSN.DataLayer.helpers.checkout(data.dataLayerUdo);
                            if (data.success) {
                                //Loading Mini browser with redirect url, true for async AJAX calls
                                window.paypal.checkout.startFlow(data.PostUrl);
                            } else {
                                window.paypal.checkout.closeFlow();
                                window.location.href = data.RedirectUrl;
                            }
                        },
                        error: function error(responseData, textStatus, errorThrown) {
                            alert("Error in ajax post " + responseData.statusText);
                            //Gracefully Close the minibrowser in case of AJAX errors
                            window.paypal.checkout.closeFlow();
                        }
                    });

                    HSN.DataLayer.helpers.elementInteraction(null, "Modal", "PayPal");
                },
                button: buildButtonIds()
            });
        } else if (paypalAttempts < maxPaypalAttempts) {
            paypalAttempts++;
            setTimeout(configurePaypalInContext, 500);
        }
    }

    function buildButtonIds() {
        var result = [];

        if (payPalButtonIdList.length > 0) {
            for (var i = 0; i < payPalButtonIdList.length; i++) {
                result.push(payPalButtonIdList[i]);
            }
        }
        if (payPalButtonClassList.length > 0) {
            for (var j = 0; j < payPalButtonClassList.length; j++) {
                var buttons = $('.' + payPalButtonClassList[j]);

                for (var k = 0; k < buttons.length; k++) {
                    result.push(buttons[k].id);
                }
            }
        }
        if (result.length === 0) {
            console.log('Error: No paypal button bindings defined');
        }

        return result;
    }

    function removePaypalIncontextScripts(clientUrl) {
        var scriptList = document.getElementsByTagName('script');

        for (var i = 0; i < scriptList.length; i++) {
            var singleScript = scriptList[i];

            if (singleScript.src.indexOf(clientUrl) > -1) {
                var parentOfScript = singleScript.parentElement;
                parentOfScript.removeChild(singleScript);
            }
        }
    }

    function removePaypalIncontextFrames() {
        var frameList = document.getElementsByTagName('iframe');

        for (var j = 0; j < frameList.length; j++) {
            var singleFrame = frameList[j];

            if (singleFrame.src.indexOf('paypal.com') > -1 && singleFrame.name.indexOf('prefetch') > -1) {
                var parentOfFrame = singleFrame.parentElement;
                parentOfFrame.removeChild(singleFrame);
            }
        }
    }

    function removePaypalPostRobotWindowEntry() {
        //paypal's js library puts this property in the window object. if you reload their js library due to an ajax refresh of the button component it will error if
        //the postRobot property is still present in the window object
        delete window["__postRobot__"];
    }

    function removePaypalInContextPiecesBeforeReload(clientUrl) {
        removePaypalIncontextScripts(clientUrl);
        removePaypalIncontextFrames();
        removePaypalPostRobotWindowEntry();
    }

    return {
        init: init,
        removePaypalInContextPiecesBeforeReload: removePaypalInContextPiecesBeforeReload
    };
};

/***/ }),

/***/ "djvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.SignupMessageModal
*
* Encapsulates the functionality of a modal dialog that contains thank you for signing up information.
**/
HSN.SignupMessageModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(SignupMessageModal, parent);

    /**
    * new HSN.SignupMessageModal()
    **/
    function SignupMessageModal() {
        this.name = 'HSN.SignupMessageModal';

        var modal = SignupMessageModal.__super__.constructor.call(this);

        eventHandlers(this);

        return modal;
    }

    /**
    * HSN.SignupMessageModal#Show(email) -> void
    * Display the modal and load in the information
    **/
    SignupMessageModal.prototype._show = function (url) {
        var scope = this;
        $.ajax(url, {
            dataType: 'html',
            success: function success(data) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(data, 0);
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#confirm-ok', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(modal.Close).click();
        });

        $(modal.Content).on('keydown', "#confirm-ok", function (e) {
            if (e.key === 'Enter' || e.key === 'Tab') {
                e.stopPropagation();
                e.preventDefault();

                if (e.key === 'Enter') {
                    modal.Close.click();
                } else if (e.key === 'Tab') {
                    modal.Close.focus();
                }
            }
        });
    }

    SignupMessageModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 }, {
                complete: function complete() {
                    scope.Content.find('#confirm-ok').focus();
                }
            });
        }, function () {
            //scope.Center();
        });
    };

    return SignupMessageModal;
}(HSN.Modal);

/***/ }),

/***/ "eiAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

var HSN = window.HSN || {};

HSN.Metrics = function ($) {
  "use strict";

  window.console = window.console || {};

  var metricsUrl = "/api/metrics/";

  function publicSend(hitType, fieldObject) {
    if (!hitType || !fieldObject || fieldObject.length === 0) {
      return;
    }

    $.ajax({
      type: "POST",
      url: metricsUrl + hitType,
      data: fieldObject
    });
  }

  function publicSendEvent(category, action, label, value, fieldObject) {
    if (!category || !action) {
      return;
    }

    var data = {
      "category": category,
      "action": action,
      "label": label,
      "value": value,
      "optFieldsJson": JSON.stringify(fieldObject)
    };

    publicSend('event', data);
  }

  function publicSendPageview(type, name, fieldObject) {
    var data = {
      "url": window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search,
      "pageType": type || "other",
      "pageName": name || window.location.pathname + window.location.search,
      "optFieldsJson": JSON.stringify(fieldObject)
    };

    publicSend('pageview', data);
  }

  return {
    send: publicSend,
    sendEvent: publicSendEvent,
    sendPageview: publicSendPageview
  };
}(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

/***/ }),

/***/ "ejzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VideoPlayer_js__ = __webpack_require__("ixIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_video_amp_amp_amp_js__ = __webpack_require__("0Pp3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_video_amp_amp_amp_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_video_amp_amp_amp_js__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Akamai Player 
    * Class that directly integrates the Akamai player
*/


var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



var AkamaiPlayer = function (_VideoPlayer) {
    _inherits(AkamaiPlayer, _VideoPlayer);

    function AkamaiPlayer(config) {
        _classCallCheck(this, AkamaiPlayer);

        var _this = _possibleConstructorReturn(this, _VideoPlayer.call(this, config));

        _this.config = config;
        _this.element = config.element;

        //configuration object for akamai player
        _this.config.paths = {
            "player": '/assets/js/libs/video-amp/amp/',
            "resources": '/assets/js/libs/video-amp/resources/',
            "plugins": '/assets/js/libs/video-amp/akamai/amp/'
        };

        _this.config.resources = [{ "src": "#{paths.player}amp.css", "type": "text/css" }];

        _this.config.fullscreen = {
            'native': true,
            'enabled': true
        };

        _this.config.share = {
            'enabled': false
        };

        _this.config.hls = {
            'resources': [{ 'type': 'text/javascript', 'src': '#{paths.resources}js/hls.js' }],
            'quality': {
                'startLevel': -1
            },
            'data': {
                'enableWorker': true,
                'enableSoftwareAES': true
            }
        };

        _this.videoPlayer = akamai.amp.AMP.create(_this.config.element, _this.config);
        _this.videoPlayer.addEventListener('ready', function (event) {
            return _this.assignEvents(event);
        });

        return _this;
    }

    AkamaiPlayer.prototype.assignEvents = function assignEvents(event) {
        _VideoPlayer.prototype.assignEvents.call(this);
        if (this.config.category == null || this.config.category === '' && this.config.name == null || this.config.name === '') {
            this.config.category = 'CategoryNotSet';
            this.config.name = 'NameNotSet';
        }

        //play
        this.videoPlayer.addEventListener('play', function () {
            this.throwAnalyticEvent(this.config.category, this.config.name, this.config.label);
        }.bind(this), false);
    };

    AkamaiPlayer.prototype.play = function play() {
        this.videoPlayer.play();
    };

    AkamaiPlayer.prototype.pause = function pause() {
        this.videoPlayer.pause();
    };

    AkamaiPlayer.prototype.stop = function stop() {
        try {
            this.videoPlayer.end();
        } catch (e) {}
    };

    AkamaiPlayer.prototype.getVolume = function getVolume() {
        return this.videoPlayer.getVolume();
    };

    AkamaiPlayer.prototype.setVolume = function setVolume(volume) {
        this.videoPlayer.setVolume(volume);
    };

    AkamaiPlayer.prototype.onTimeUpdate = function onTimeUpdate() {
        return Math.round(getCurrentTime());
    };

    AkamaiPlayer.prototype.getCurrentTime = function getCurrentTime() {
        return this.videoPlayer.getCurrentTime();
    };

    AkamaiPlayer.prototype.setCurrentTime = function setCurrentTime(time) {
        this.videoPlayer.setCurrentTime(time);
    };

    return AkamaiPlayer;
}(__WEBPACK_IMPORTED_MODULE_1__VideoPlayer_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AkamaiPlayer);

/***/ }),

/***/ "f7Ep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccessibilityUtility = function () {
    /* Helper class for Accessibility */
    function AccessibilityUtility() {
        _classCallCheck(this, AccessibilityUtility);

        //common keyboard keys for navigation and activation
        this.keys = {
            tab: 9,
            end: 35,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            enter: 13,
            esc: 27,
            spacebar: 32,
            backspace: 8
        };
    }

    AccessibilityUtility.prototype.GetKeys = function GetKeys() {
        return this.keys;
    };

    AccessibilityUtility.prototype.SetTabIndexSequential = function SetTabIndexSequential(element) {
        //Element is included in the tab sequence based on its position in the DOM.
        return element.attr('tabindex', 0);
    };

    AccessibilityUtility.prototype.SetTabIndexProgrammatic = function SetTabIndexProgrammatic(element) {
        //Element is not included in the tab sequence but is focusable with focus().
        return element.attr('tabindex', -1);
    };

    return AccessibilityUtility;
}();

;

var accessibilityUtility = new AccessibilityUtility();

/* harmony default export */ __webpack_exports__["a"] = (accessibilityUtility);

/***/ }),

/***/ "fMYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * VariantInfo wraps the variant selector logic providing Callouts etc. for the currently selected variant codes.
 */
var VariantInfo = function () {
    function VariantInfo(variants) {
        var _this = this;

        _classCallCheck(this, VariantInfo);

        this._variants = variants || [];
        this._onChangeHandlers = [];
        this._codePrefixes = this._variants.length > 0 ? variants[0].Codes.map(function (c) {
            return codePrefix(c);
        }) : [];

        // Array of maps - inner map lists codes, outer array index gives the position the code belongs.
        this._codePositionMap = this._variants.length > 0 ? variants[0].Codes.map(function (c) {
            return {};
        }) : [];
        this._variants.forEach(function (v) {
            v.Codes.forEach(function (c, i) {
                _this._codePositionMap[i][c] = true;
            });
        });

        this._selectedCodes = new Array(this._codePositionMap.length).fill(null);

        // public API
        this.SelectedVariant = null;
        this.Callouts = {};
    }

    // set a variant code, then notify changes


    VariantInfo.prototype.setCode = function setCode(code) {
        var index = this._findCodeIndex(code);

        this._setCode(index, code);
    };

    VariantInfo.prototype.unsetCode = function unsetCode(code) {
        var index = this._findCodeIndex(code);

        this._setCode(index, null);
    };

    VariantInfo.prototype.isCodeSelected = function isCodeSelected(code) {
        return this._selectedCodes.indexOf(code) >= 0;
    };

    VariantInfo.prototype.setVariantById = function setVariantById(variantId) {
        var _this2 = this;

        var variant = this._variants.filter(function (v) {
            return parseInt(v.WebId) === parseInt(variantId);
        });

        if (variant.length === 1) {
            variant = variant[0];

            variant.Codes.forEach(function (x) {
                return _this2.setCode(x);
            });
            this._onCodesChange();
        }
    };

    VariantInfo.prototype.getSelectedCodeByPrefix = function getSelectedCodeByPrefix(prefix) {
        prefix = codePrefix(prefix);
        var index = this._codePrefixes.indexOf(prefix);

        return this._selectedCodes[index];
    };

    // subscribe to changes


    VariantInfo.prototype.onChange = function onChange(f) {
        this._onChangeHandlers.push(f);
    };

    VariantInfo.prototype._findCodeIndex = function _findCodeIndex(code) {
        return this._codePositionMap.reduce(function (prev, current, i) {
            if (current[code]) {
                return i;
            } else {
                return prev;
            }
        }, -1);
    };

    VariantInfo.prototype._setCode = function _setCode(index, code) {
        this._selectedCodes[index] = code || null;
        this._onCodesChange();
    };

    VariantInfo.prototype._onCodesChange = function _onCodesChange() {
        this._updateSelectedVariant();
        this._updateCallouts();
        this._handleChange();
    };

    VariantInfo.prototype._handleChange = function _handleChange() {
        this._onChangeHandlers.forEach(function (f) {
            return f();
        });
    };

    VariantInfo.prototype._updateSelectedVariant = function _updateSelectedVariant() {
        var setVariants = this._getVariantsForCodeSet(this._selectedCodes);
        var variant = null;

        if (setVariants.length === 1) {
            variant = setVariants[0];
        }

        this.SelectedVariant = variant;
    };

    VariantInfo.prototype._updateCallouts = function _updateCallouts() {
        var _this3 = this;

        var codeSubsets = this._getCodeSubsets();
        var calloutSubsets = codeSubsets.map(function (cs, i) {
            return _this3._getCalloutsForCodeSet(cs, i);
        });

        // flatten calloutSubsets
        var callouts = this._initCallouts();

        calloutSubsets.forEach(function (cs) {
            cs.forEach(function (c) {
                if ((c.callouts == null || c.callouts.Name == "LowInventory") && callouts[c.code] != null) callouts[c.code] = c.callouts;else if (callouts[c.code] != null && callouts[c.code].Name == "SoldOut") callouts[c.code] = c.callouts;
            });
        });

        this.Callouts = callouts;
    };

    VariantInfo.prototype._getVariantsForCodeSet = function _getVariantsForCodeSet(codeSet) {
        return this._variants.filter(function (v) {
            return arrayDiff(codeSet, v.Codes).length === 0;
        });
    };

    VariantInfo.prototype._getCalloutsForCodeSet = function _getCalloutsForCodeSet(codeSet, i) {
        var setVariants = this._getVariantsForCodeSet(codeSet);

        return setVariants.map(function (v) {
            return { code: v.Codes[i], callouts: v.Callout };
        });
    };

    // All Subsets of _selectedCodes excluding one code index
    // ex: ["C001", "S123"] has subsets ["C001"] and ["S123"]
    // ex: ["C001", "S123", "W456"] 1st subset == ["C001", "S123"]


    VariantInfo.prototype._getCodeSubsets = function _getCodeSubsets() {
        var _this4 = this;

        return new Array(this._selectedCodes.length).fill().map(function (x, i) {
            return _this4._selectedCodes.filter(function (y, j) {
                return i !== j;
            });
        });
    };

    VariantInfo.prototype._initCallouts = function _initCallouts() {
        var ret = {};
        this._codePositionMap.forEach(function (map) {
            for (var name in map) {
                if (map.hasOwnProperty(name)) {
                    ret[name] = { Name: 'SoldOut' };
                }
            }
        });
        return ret;
    };

    return VariantInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (VariantInfo);


function arrayDiff(a, b) {
    var ret = a.filter(function (x) {
        return x == null ? false : b.indexOf(x) < 0;
    });
    return ret;
}

function codePrefix(code) {
    return code.substr(0, 1);
}

/***/ }),

/***/ "fr1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_VariantInfo_js__ = __webpack_require__("fMYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_MOBILE_Gap_js__ = __webpack_require__("IPPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_MatrixOptions_js__ = __webpack_require__("gkEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_MatrixOptions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_MatrixOptions_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_HSNDIR_Widget_ApplePay_js__ = __webpack_require__("E9at");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_visible_js__ = __webpack_require__("4fo5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_visible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_LIBS_jquery_visible_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;









HSN.OffCanvas.ProductPreview = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ProductPreview, parent);

    function ProductPreview() {
        var offCanvas = ProductPreview.__super__.constructor.call(this, {
            className: 'product-preview-off-canvas',
            sourceDirection: HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage: true
        });
        this.name = 'HSN.OffCanvas.ProductPreview';
        this.application = HSN.Instance();
        this.commerceService = HSN.Instance()._getCommerceService();
        this._allErrors = [];
        this.eventIdentity = crypto.randomUUID();
        this.heightCalc = HSN.Instance().DeviceInformation.IsMobile ? 'calc(100% - 100px)' : 'calc(100% - 130px)';

        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Product Preview', 'OffCanvas.ProductPreview', 'Product Preview Off Canvas');

        this._variants = null;
        this._variantInfo = null;
        this._productOptionSelectorContainer = null;

        return offCanvas;
    }

    function HandleEsrb(control, offCanvas) {
        var rating = control.data('rating');
        if (rating) {
            //check for cookie
            var isOver17 = false;
            var i,
                x,
                y,
                arRcookies = document.cookie.split(';');
            var arrCookiesLength = arRcookies.length;
            for (i = 0; i < arrCookiesLength; i++) {
                x = arRcookies[i].substr(0, arRcookies[i].indexOf('='));
                y = arRcookies[i].substr(arRcookies[i].indexOf('=') + 1);
                x = x.replace(/^\s+|\s+$/g, '');
                if (x === 'over17') {
                    isOver17 = true;
                }
            }

            if (!isOver17) {
                offCanvas.application.GetRatingModal().Show(rating, control);
                return false;
            }
        }
        return true;
    }
    function HandleAsIs(control, offCanvas) {
        var isAsIs = control.data('isasis');
        if (isAsIs) {
            //check for cookie
            var consentToAsIs = false;
            var i,
                name,
                cookies = document.cookie.split(';');
            var cookiesLength = cookies.length;
            for (i = 0; i < cookiesLength; i++) {
                name = cookies[i].substr(0, cookies[i].indexOf('='));
                name = name.replace(/^\s+|\s+$/g, '');
                if (name === 'consentToAsIs') {
                    consentToAsIs = true;
                }
            }

            if (!consentToAsIs) {
                offCanvas.application.GetAsIsModal().Show(control);
                return false;
            }
        }
        return true;
    }
    function HandleAlcohol(control, offCanvas) {
        var isAlcohol = control.data('isalcohol');
        if (isAlcohol) {
            var alcoholFlag = sessionStorage.getItem('alcohol-verification') ? true : false;

            if (!alcoholFlag) {
                offCanvas.application.GetAlcoholModal().Show(control);
                return false;
            }
        }
        return true;
    }

    function eventHandlers(offCanvas) {
        $(offCanvas.Content).on('click', 'input.add-to-bag, .express-buy, input.paypal-express, .apple-pay-button, .pre-order', function () {
            ClearErrors(offCanvas);
            var control = $(this);
            var esrbValue = HandleEsrb(control, offCanvas);
            if (!esrbValue) {
                return esrbValue;
            }
            var asIsValue = HandleAsIs(control, offCanvas);
            if (!asIsValue) {
                return asIsValue;
            }
            var alcoholValue = HandleAlcohol(control, offCanvas);
            if (!alcoholValue) {
                return alcoholValue;
            }

            var productId = control.data('object-id');
            var productWebmId = control.data('object-webmid');

            var singleRequest = GetRequestObject(control, productId, offCanvas);
            if (offCanvas._allErrors.length > 0) {
                DisplayErrors(control, offCanvas);
                return false;
            }

            if (control.data('personalize')) {
                DoPersonalization(offCanvas, singleRequest);
            } else {
                var addToBag = {
                    ProductId: productId,
                    WebId: singleRequest.WebId,
                    DeferredFinancing: singleRequest.DeferredFinancing,
                    ExtraFlexPromo: singleRequest.ExtraFlexPromo,
                    ExtraFlexV2: singleRequest.ExtraFlex,
                    ExpressBuy: singleRequest.ExpressBuy,
                    IsApplePay: singleRequest.IsApplePay,
                    Quantity: 1,
                    FlexPayV2: singleRequest.FlexPay,
                    ProgramId: singleRequest.ProgramId,
                    ProgramCode: singleRequest.ProgramCode,
                    Frequency: singleRequest.Frequency,
                    WarrantyWebPId: singleRequest.WarrantyWebPId,
                    WarrantyName: singleRequest.WarrantyName,
                    WarrantyAmount: singleRequest.WarrantyAmount,
                    MatrixId: productWebmId
                };

                HSN.LoaderSetWait('', 5000);
                var currentPage = window.location.href;
                var isOnBagPage = false;
                if (currentPage.indexOf('bag') !== -1) {
                    isOnBagPage = true;
                }

                var addToBagWidget = new HSN.Widget.AddToBag();
                addToBagWidget.init({
                    application: offCanvas.application,
                    doFinish: !singleRequest.IsApplePay,
                    isInOffCanvas: true,
                    refreshWhenDone: isOnBagPage
                });
                addToBagWidget.AddToBag(addToBag);

                if (singleRequest.IsApplePay) {
                    HSN.Widget.ApplePay().setupApplePaySession(GetProductPrice(offCanvas.Content));
                }
            }
            return false;
        });
        $(offCanvas.Content).on('click', '.add-hpp-button', function () {
            var storedWarrantySelection = $('#selected-warranty', offCanvas.Content);
            var currentSelection = $(this);

            //update selected warranty
            storedWarrantySelection.val(currentSelection.data('warrantyWebpid'));
            storedWarrantySelection.data('warrantyPrice', currentSelection.data('warrantyPrice'));
            storedWarrantySelection.data('warrantyName', currentSelection.data('warrantyName'));

            //update button status
            currentSelection.removeClass('add-hpp-button');
            currentSelection.addClass('remove-hpp-button');
            currentSelection.val('Remove');

            //hide other warranty options
            $('.add-hpp-button', offCanvas.Content).parents('.warranty-row').hide();

            //send apple pay event
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', '.remove-hpp-button', function () {
            var storedWarrantySelection = $('#selected-warranty', offCanvas.Content);
            var currentSelection = $(this);

            //clear selected warranty
            storedWarrantySelection.val('');
            storedWarrantySelection.removeData();

            //update button status
            currentSelection.removeClass('remove-hpp-button');
            currentSelection.addClass('add-hpp-button');
            currentSelection.val('Add');

            //make all options visible
            $('.add-hpp-button', offCanvas.Content).parents('.warranty-row').show();

            //send apple pay event
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', ".autoship-modal", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var articleSlug = $(this).data("articleSlug");
            var articleId = $(this).data("articleId");
            var webpId = $('#webp_id', offCanvas.Content).val();

            if (isNaN(articleId)) {
                return false;
            }
            if (!articleSlug) {
                articleId = 'default-article-slug';
            }
            HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId + "?webpid=" + webpId);
        });
        $(offCanvas.Content).on('click', '.warranty-details', function () {
            var warrWebPId = $(this).data('warr-webpid');
            var warrName = $(this).data('name');
            var contentId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("content-page-id");
            if (offCanvas.application.DeviceInformation.IsMobile) {
                var link = __WEBPACK_IMPORTED_MODULE_3_MOBILE_Gap_js__["default"].ConvertLink('/content/squaretrade/' + contentId);
                if (scope._application.DeviceInformation.IsNativeApp) {
                    var gapCommand = __WEBPACK_IMPORTED_MODULE_3_MOBILE_Gap_js__["default"].BuildGapCommand(link);
                    __WEBPACK_IMPORTED_MODULE_3_MOBILE_Gap_js__["default"].ExecCommand(gapCommand);
                } else {
                    window.location.href = link;
                }
            } else {
                HSN.Instance().GetContentModal().Show('/content/content/' + contentId);
            }

            return false;
        });
        $(offCanvas.Content).on('change', '#flex-payment-options', function () {
            cmCreateManualLinkClickTag('/product-flexpay?cm_sp=ProductPreview-_-Flexpay-_-Dropdown&cm_re=ProductPreview-_-FlexPay-_-Dropdown', 'ProductPreview');
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', '.add-to-bag-buttons .add-to-favorites', function () {
            HSN.Instance()._getFavoriteService().Favorite($(this).data("objectType"), $(this).data("objectId"), $(this).data("objectId"), {
                scope: HSN.Instance(),
                callback: function callback(success, favorited) {
                    if (success && favorited) {
                        $('input.add-to-favorites', offCanvas.Content).hide();
                        $('.add-to-fav-success', offCanvas.Content).show();
                    }
                }
            });
        });
    }
    function DoPersonalization(offCanvas, singleRequest) {
        var form = document.createElement('form');
        var inputId = document.createElement('input');
        inputId.setAttribute('type', 'hidden');
        inputId.setAttribute('name', 'Id');
        inputId.setAttribute('value', singleRequest.WebId);
        form.appendChild(inputId);
        var inputQty = document.createElement('input');
        inputQty.setAttribute('type', 'hidden');
        inputQty.setAttribute('name', 'Qty');
        inputQty.setAttribute('value', 1);
        form.appendChild(inputQty);
        var inputFlex = document.createElement('input');
        inputFlex.setAttribute('type', 'hidden');
        inputFlex.setAttribute('name', 'flexpay');
        inputFlex.setAttribute('value', singleRequest.FlexPay);
        form.appendChild(inputFlex);
        var inputExtaFlex = document.createElement('input');
        inputExtaFlex.setAttribute('type', 'hidden');
        inputExtaFlex.setAttribute('name', 'extraFlex');
        inputExtaFlex.setAttribute('value', singleRequest.ExtraFlex);
        form.appendChild(inputExtaFlex);
        var inputExtaFlexPromo = document.createElement('input');
        inputExtaFlexPromo.setAttribute('type', 'hidden');
        inputExtaFlexPromo.setAttribute('name', 'extraFlexPromo');
        inputExtaFlexPromo.setAttribute('value', singleRequest.ExtraFlexPromo);
        form.appendChild(inputExtaFlexPromo);
        var inputDeferred = document.createElement('input');
        inputDeferred.setAttribute('type', 'hidden');
        inputDeferred.setAttribute('name', 'deferredPromo');
        inputDeferred.setAttribute('value', singleRequest.DeferredFinancing);
        form.appendChild(inputDeferred);

        form.action = '/products/personalization/get';
        form.method = 'post';
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(form);
        form.submit();
    }
    function GetRequestObject(buttonScope, objectId, offCanvas) {
        var singleRequest = {
            Errors: new Array()
        };

        singleRequest.ObjectId = objectId;
        singleRequest = HandleObjectIdResponse(GetVariantId(offCanvas.Content, singleRequest.ObjectId, offCanvas), singleRequest);
        singleRequest.DeferredFinancing = GetDeferredPay(offCanvas.Content);
        singleRequest.ExtraFlex = GetExtraFlex(offCanvas.Content);
        singleRequest.ExtraFlexPromo = GetExtraFlexPromo(offCanvas.Content);
        singleRequest.ExpressBuy = GetExpressBuy(buttonScope);
        singleRequest.IsApplePay = GetApplePay(buttonScope);
        singleRequest.FlexPay = GetFlexpay(offCanvas.Content);
        singleRequest.ProgramId = GetAutoshipId(offCanvas.Content);
        singleRequest.ProgramCode = GetAutoshipProgramType(offCanvas.Content);
        singleRequest.Frequency = GetFrequency(offCanvas.Content);
        singleRequest.StartDate = GetStartDate(offCanvas.Content, singleRequest.ProgramId);
        singleRequest.WarrantyWebPId = GetWarrantyWebPId(offCanvas.Content);
        singleRequest.WarrantyName = GetWarrantyName(offCanvas.Content);
        singleRequest.WarrantyAmount = GetWarrantyPrice(offCanvas.Content);

        return singleRequest;
    }
    function HandleObjectIdResponse(objectIdResponse, singleRequest) {
        singleRequest.WebId = objectIdResponse.value;

        if (objectIdResponse.errorList) {
            $.each(objectIdResponse.errorList, function (index, error) {
                singleRequest.Errors.push(error);
            });
        }

        return singleRequest;
    }
    function DisplayErrors(control, offCanvas) {
        var allErrorsLength = offCanvas._allErrors.length;
        if (allErrorsLength > 0) {
            var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

            for (var i = 0; i < allErrorsLength; i++) {
                if (offCanvas._allErrors[i] != null) {
                    $errors.find('ul').append('<li>' + offCanvas._allErrors[i] + '</li>');
                }
            }
            $errors.focus();
            $(control).before($errors);
            $errors.css({
                "top": control.position().top - $errors.height()
            });
            $(control).addClass('has-error');
            $errors.focus();
        }
    }
    ProductPreview.prototype.BindWidgets = function (offCanvas) {
        var variantJsonString = $('#json-variants', offCanvas.Content.find('.product-option-selector')).html();
        this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;
        this._variantInfo = new __WEBPACK_IMPORTED_MODULE_2_HSNDIR_VariantInfo_js__["a" /* default */](this._variants);

        var productOptionSelector = new HSN.ProductOptionSelector({
            application: HSN.Instance(),
            container: offCanvas.Content.find('.product-option-selector'),
            imageContainer: $('.product-image', offCanvas.Content),
            preSelectedWebId: $('.pre_selected_webid', offCanvas.Content).val(),
            useSimpleMainImage: true,
            variantInfo: this._variantInfo,
            eventIdentity: this.eventIdentity
        }).init();
        offCanvas._productOptionSelectorContainer = offCanvas.Content.find('.product-option-selector');
        var warrantyButtons = $('.hpp-button-container input', offCanvas.Content);
        $.each(warrantyButtons, function () {
            $(this).val($(this).val().toLowerCase());
        });

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, function (matrixProductId, url, editBagItemId, editBagIdentity, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            Refresh(offCanvas, matrixProductId);
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, function (text, container, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            if ((text === 'On Waitlist' || text === 'Extended Delivery') && !$('.product-delivery-message', offCanvas.Content).hasClass('is-override')) {
                $('.product-delivery-message', offCanvas.Content).toggle(false);
            } else {
                $('.product-delivery-message', offCanvas.Content).toggle(true);
            }
            $('.product-modal-option-status', offCanvas.Content).last().text(text);
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            }
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, function (isPlusSizeSelected, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            }
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.Application.EVENT.FAVORITE_INITIALIZED, function (objectType, objectId) {
            var addToFavoritesButton = $('input.add-to-favorites', offCanvas.Content);

            if ($(addToFavoritesButton).data('object-id') == objectId) {
                addToFavoritesButton.hide();
                $('.add-to-fav-success', offCanvas.Content).show();
            }
        }, "ProductPreviewOffCanvas");

        // Keep display in sync with the variantInfo
        this._variantInfo.onChange(function () {
            ClearErrors(offCanvas);
        });

        var isLessman = $('.add-to-bag-buttons', offCanvas.Content).closest('.buy-selector').hasClass('lessman');
        $('.fixed-container', offCanvas.Content).html($('.add-to-bag-buttons', offCanvas.Content));
        if (isLessman) {
            $('.fixed-container', offCanvas.Content).addClass('lessman');
            $('.product-preview-offcanvas', offCanvas.Content).addClass('lessman-page');
        }

        if (AreButtonsOffScreen(offCanvas)) {
            MakeButtonsFixed(offCanvas);
        }

        var handleResize = function handleResize() {
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            } else if (IsScrollableContainerNecessary(offCanvas)) {
                MakeButtonsRelative(offCanvas);
            }
        };

        if (window.addEventListener) {
            window.addEventListener('resize', handleResize);
        } else {
            window.attachEvent('resize', handleResize);
        }

        HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link");
    };

    function GetVariantId(productCardScope, objectId, scope) {
        var hasMatrix = $('.matrix-options', scope._productOptionSelectorContainer).length;

        if (hasMatrix) {
            if ($('.group-options input[name="groupSelect"]', scope._productOptionSelectorContainer).length && !$('.group-options input[name="groupSelect"]:checked', scope._productOptionSelectorContainer).length) {
                scope._allErrors.push('Please select an option');
                return {
                    value: objectId,
                    errorList: ['Please select option first']
                };
            }

            if (!$('.matrix-options a.selected', scope._productOptionSelectorContainer).length && !$('select.matrix-selector option:selected').length) {
                scope._allErrors.push('Please select an option');
                return {
                    value: objectId,
                    errorList: ['Please select option first']
                };
            }
        }

        if (scope._variants === null && hasMatrix) {
            var hasMatrixErrorMessage = $('.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', scope._productOptionSelectorContainer).length;
            if (!hasMatrixErrorMessage) {
                var labelTxt = $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).html().toLowerCase();
                labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                var errorMsg = 'Please ' + labelTxt + ' first.';
                scope._allErrors.push(errorMsg);
                $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).addClass('inline-error');
            } else {
                scope._allErrors.push($('.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', scope._productOptionSelectorContainer).text());
                $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).addClass('inline-error');
            }

            return {
                value: objectId,
                errorList: ['Please select option first']
            };
        }

        if (scope._variants != null && scope._variants.length > 0) {
            var inputLabels = $('label.required-selection', scope._productOptionSelectorContainer);
            var arr = [];
            var isVariantSelectionError = false;

            $.each(inputLabels, function () {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', scope._productOptionSelectorContainer);
                if (checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if (labelText.length) {
                        scope._allErrors.push('Please select a ' + labelText);
                        inputLabel.addClass('inline-error');
                        isVariantSelectionError = true;
                    }
                } else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });

            //Item Sold out
            var variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                ///scope._allErrors.push('Selection Not Available');
                isVariantSelectionError = true;
            }
            if (variant && variant.Callout && variant.Callout.Name === "SoldOut") {
                scope._allErrors.push("Item Sold Out");
                isVariantSelectionError = true;
            }

            if (isVariantSelectionError) {
                return { value: objectId, errorList: scope._allErrors };
            }

            $.each(scope._variants, function (k, v) {
                if ($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value: objectId };
    };
    function GetDeferredPay(productCardScope) {
        return $('.template-product-detail-flexpay option:selected', productCardScope).data('deferred-promo') !== undefined;
    };
    function GetExtraFlex(productCardScope) {
        var extraFlex = null;
        if ($('.template-product-detail-flexpay option:selected', productCardScope).data('extra-flex') !== undefined) {
            var optionSelected = parseInt($('.template-product-detail-flexpay option:selected', productCardScope).val());
            var totalFlexAvailable = $('.template-product-detail-flexpay option:not(.extra-flex-payment, .vip-payment)').length;
            var numberOfExtraFlex = optionSelected - totalFlexAvailable < 0 ? 0 : optionSelected - totalFlexAvailable;

            extraFlex = numberOfExtraFlex;
        }

        return extraFlex;
    };
    function GetExtraFlexPromo(productCardScope) {
        //NOTE - extraFlexPromo is multi-purposed into the call for both deferred promo id and extra flex
        var extraFlexPromo = null;
        if ($('.template-product-detail-flexpay', productCardScope).length > 0) {
            extraFlexPromo = $('.template-product-detail-flexpay', productCardScope).data('extra-flex-promo');
        }

        var deferredPay = GetDeferredPay(productCardScope);
        if (deferredPay) {
            extraFlexPromo = $('.template-product-detail-flexpay option:selected', productCardScope.Content).data('deferred-promo');
        }

        return extraFlexPromo;
    };
    function GetExpressBuy(buttonObj) {
        var expressBuy = 0;
        if (buttonObj.hasClass('express-buy') || buttonObj.hasClass('apple-pay-button')) {
            expressBuy = 1;
        }

        return expressBuy;
    };
    function GetApplePay(buttonObj) {
        var isApplePay = false;
        if (buttonObj.hasClass('apple-pay-button')) {
            isApplePay = true;
        }
        return isApplePay;
    };
    function GetFlexpay(productCardScope) {
        var flexpay = 1;
        if ($('.template-product-detail-flexpay', productCardScope).length > 0) {
            if ($('.template-product-detail-flexpay option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            } else if ($('.template-product-detail-flexpay option:selected', productCardScope).hasClass('flex-payment')) {
                var optionSelected = parseInt($('.template-product-detail-flexpay option:selected', productCardScope).val());
                var totalFlexAvailable = $('.template-product-detail-flexpay option:not(.extra-flex-payment, .vip-payment)').length;
                var numberOfFlexPayments = optionSelected > totalFlexAvailable ? totalFlexAvailable : optionSelected;

                flexpay = numberOfFlexPayments;
            }
        }

        return flexpay;
    };
    function GetStartDate(productCardScope, autoshipId) {
        var startDate = null;

        if (autoshipId != null) {
            var theDate = new Date();
            startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();
        }

        return startDate;
    }
    function GetAutoshipId(productCardScope) {
        var autoshipId = null;
        if ($('#autoship-program-id', productCardScope).length > 0) {
            autoshipId = $('#autoship-program-id', productCardScope).val();
        }

        return autoshipId;
    };
    function GetAutoshipProgramType(productCardScope) {
        var autoshipPgmType = null;
        if ($('#autoship-program-type', productCardScope).length > 0) {
            autoshipPgmType = $('#autoship-program-type', productCardScope).val();
        }

        return autoshipPgmType;
    };
    function GetFrequency(productCardScope) {
        var frequency = parseInt($('#autoship-frequency-options option:selected', productCardScope).val());

        return frequency;
    };
    function GetWarrantyWebPId(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.val() : null;
    };
    function GetWarrantyPrice(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyPrice') : null;
    };
    function GetWarrantyName(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyName') : null;
    };
    function getWarrantySelected(warrSelectedScope) {
        var selectedWarranty = $('#selected-warranty', warrSelectedScope);

        return selectedWarranty.length > 0 && typeof selectedWarranty.val() !== 'undefined' && selectedWarranty.val().length > 0;
    };
    function getWarrantyDetails(warrDetailsScope) {
        return $('#selected-warranty', warrDetailsScope);
    };
    function GetProductPrice(scope) {
        if ($('span.product-price', scope).length > 0) {
            return $('span.product-price', scope).attr('content');
        } else {
            return '.01';
        }
    };
    function ClearErrors(offCanvas) {
        offCanvas._allErrors = [];
        $('.errors-pd', offCanvas.Content).remove();
        $('label[class*="inline-error"]', offCanvas.Content).removeClass('inline-error');
        $('div[class*="errors"]', offCanvas.Content).remove();
        $('input[class*="has-error"]', offCanvas.Content).removeClass('has-error');
        $('input[class*="inline-error"], select[class*="inline-error"]', offCanvas.Content).removeClass('inline-error');
    };
    function CanDoApplePay(offCanvas) {
        if (!HSN.Widget.ApplePay) {
            return false;
        }
        var isValidPaymentOption, isValidWarranty, isValidProductStatus;
        //get flexpay value
        var paymentSelect = $('#flex-payment-options', offCanvas.Content);
        var flexNumber = paymentSelect.val();
        if (flexNumber > 1 || $('option:selected', paymentSelect).attr('class') === 'vip-payment') {
            isValidPaymentOption = false;
        } else {
            isValidPaymentOption = true;
        }
        //get warranty value
        var selectedWarranty = $('#selected-warranty', offCanvas.Content);
        if (selectedWarranty.val() && selectedWarranty.val().length > 0) {
            isValidWarranty = false;
        } else {
            isValidWarranty = true;
        }
        //get extended del/waitlist value
        var text = HSN.ProductOptionSelector.prototype.GetCallout(offCanvas._variantInfo.SelectedVariant);
        if (text === 'On Waitlist in' || text === 'On Extended Delivery in') {
            isValidProductStatus = false;
        } else {
            isValidProductStatus = true;
        }

        return isValidPaymentOption && isValidWarranty && isValidProductStatus;
    };

    function AreButtonsOffScreen(offCanvas) {
        return !$('.fixed-container .add-to-bag-buttons', offCanvas.Content).last().visible();
    }
    function MakeButtonsFixed(offCanvas) {
        $('.scrollable', offCanvas.Content).css('height', offCanvas.heightCalc);
        $('.fixed-container', offCanvas.Content).css('position', 'fixed');
    }
    function MakeButtonsRelative(offCanvas) {
        $('.scrollable', offCanvas.Content).css('height', 'auto');
        $('.fixed-container', offCanvas.Content).css('position', 'relative');
    }
    function IsScrollableContainerNecessary(offCanvas) {
        var childrenHeight = 0;
        $('.scrollable', offCanvas.Content).children().each(function () {
            var child = $(this);
            childrenHeight = childrenHeight + child.height();
        });
        return $('.scrollable', offCanvas.Content).height() > childrenHeight;
    }

    function TurnOffEvents() {
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, null, "ProductPreviewOffCanvas");
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, null, "ProductPreviewOffCanvas");
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, null, "ProductPreviewOffCanvas");
        HSN.Instance().Events.Off(HSN.Application.EVENT.FAVORITE_INITIALIZED, null, "ProductPreviewOffCanvas");
    }

    function Refresh(offCanvas, productIdentity) {
        TurnOffEvents();
        offCanvas.Refresh(productIdentity);
    };

    ProductPreview.prototype._show = function (productIdentity) {
        $.ajax('/products/' + productIdentity + '/preview', {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function error() {
                var scope = this;
                scope.HandleError();
            }
        });
    };

    ProductPreview.prototype._hide = function () {
        TurnOffEvents();
    };

    ProductPreview.prototype._refresh = function (productIdentity) {
        $.ajax('/products/' + productIdentity + '/preview', {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function error() {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return ProductPreview;
}(HSN.OffCanvas);

/***/ }),

/***/ "gFf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.WatchService = function () {};

HSN.Service.WatchService.prototype = {
    GetChannelListing: function GetChannelListing(zipCode, config) {
        this._send("/watch/getlistings", { zipCode: zipCode }, 'GET', 'html', config);
    },

    GetSearchForm: function GetSearchForm(config) {
        this._send("/watch/getsearch", {}, 'GET', 'html', config);
    },

    GetDailyProgramGuide: function GetDailyProgramGuide(date, network, timeOffset, config) {
        this._send("/watch/getdailyprogramguide", { date: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },

    GetWeeklyProgramGuide: function GetWeeklyProgramGuide(date, network, timeOffset, config) {
        this._send("/watch/getweeklyprogramguide", { date: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },

    GetShowProducts: function GetShowProducts(date, network, timeOffset, config) {
        config.isCacheable = true;
        this._send("/watch/getshowproducts", { showDate: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },

    GetRecentlyAiredView: function GetRecentlyAiredView(date, network, timeOffset, config) {
        this._send("/watch/getrecentlyairedview", { date: date, network: network, timeOffset: timeOffset }, 'GET', 'html', config);
    },

    GetShowDetails: function GetShowDetails(network, startDate, endDate, timeOffset, config) {
        this._send("/watch/program-guide/showdetails", { Network: network, StartDate: startDate, EndDate: endDate, TimeOffSet: timeOffset }, 'GET', 'html', config);
    },

    GetSearchResults: function GetSearchResults(timeOffset, network, query, config) {
        this._send("/watch/search", { Network: network, TimeOffSet: timeOffset, Query: query }, 'GET', 'html', config);
    },

    GetVideoTitle: function GetVideoTitle(date, network, title, config) {
        this._send("/watch/getvideotitle", { date: date, network: network, title: title }, 'GET', 'html', config);
    },

    GetShowProduct: function GetShowProduct(network, productId, config) {
        config.isCacheable = true;
        this._send("/watch/getshowproduct", { network: network, productId: productId }, 'GET', 'html', config);
    },

    GetShowProductFeed: function GetShowProductFeed(date, network, config) {
        this._send("/watch/getshowproductfeed", { date: date, network: network }, 'GET', 'html', config);
    },

    ContactUs: function ContactUs(data, config) {
        this._send("/watch/contactus", data, "POST", "json", config);
    },

    //=====PRINT LAYOUTS=====
    GetDailyPrintLayout: function GetDailyPrintLayout(data, config) {
        this._send('/watch/program-guide/print/daily', data, 'GET', 'html', config);
    },
    GetWeeklyPrintLayout: function GetWeeklyPrintLayout(data, config) {
        this._send('/watch/program-guide/print/weekly', data, 'GET', 'html', config);
    },
    GetFullPrintLayout: function GetFullPrintLayout(data, config) {
        this._send('/watch/program-guide/print/monthly', data, 'GET', 'html', config);
    },
    GetSearchPrintLayout: function GetSearchPrintLayout(data, config) {
        this._send('/watch/program-guide/print/search', data, 'GET', 'html', config);
    },
    //=====END PRINT LAYOUTS=====

    //Past Show - item update
    GetPastShowProduct: function GetPastShowProduct(productId, config) {
        this._send('/watch/past-shows/product', { productId: productId }, 'GET', 'html', config);
    },

    _send: function _send(url, data, type, dataType, config) {
        config = config = config || {};

        if (!config.isCacheable) {
            if (typeof data === 'string') {
                var joiner = data.indexOf("=") === -1 ? "" : "&";
                data += joiner + "_ts=" + new Date().getTime();
            } else {
                data['_ts'] = new Date().getTime();
            }
        }

        $.ajax(url, {
            type: type,
            data: data,
            context: this,
            dataType: dataType,
            success: function success(data, status, xhr) {
                if (config.callback) config.callback.call(config.scope || config.callback, data);
            },
            error: function error(xhr, status, _error) {
                if (config.callback) config.callback.call(config.scope || config.callback, false);
            }
        });
    }
};

/***/ }),

/***/ "gXLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.ProductTabService = function () {};

HSN.Service.ProductTabService.prototype = {

    GetProductReviews: function GetProductReviews(encodedProductName, id, page, recordsPerPage, sortTerm, sortSequence, pfid, ratingFilter, percentRecommended, source, lessman, config) {
        if (!id) {
            return;
        }

        config.isCacheable = true;
        this._sendHtml("/products/productreviews/get-product-reviews", {
            encodedProductName: encodedProductName,
            id: id,
            page: page,
            recordsPerPage: recordsPerPage,
            sortTerm: sortTerm,
            sortSequence: sortSequence,
            sku: pfid,
            ratingFilter: ratingFilter,
            percentRecommended: percentRecommended,
            source: source,
            lessman: lessman
        }, config);
    },

    GetProductTab: function GetProductTab(id, tab, config) {
        if (!id || !tab) {
            return;
        }
        config.isCacheable = true;
        this._sendHtml("/products/producttab/get-product-tab", { id: id, tab: tab }, config);
    },

    _sendHtml: function _sendHtml(url, data, config) {
        config = config = config || {};

        if (!config.isCacheable) {
            if (typeof data === 'string') {
                var joiner = data.indexOf("=") === -1 ? "" : "&";
                data += joiner + "_ts=" + new Date().getTime();
            } else {
                data['_ts'] = new Date().getTime();
            }
        }

        $.ajax(url, {
            type: 'GET',
            data: data,
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                if (config.callback) config.callback.call(config.scope || config.callback, true, data);
            },
            error: function error(xhr, status, _error) {
                if (config.callback) config.callback.call(config.scope || config.callback, false, _error);
            }
        });
    },

    _sendJson: function _sendJson(url, data, config) {
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            type: 'POST',
            data: data,
            context: this,
            dataType: 'json',
            success: function success(data, status, xhr) {
                if (config.callback) config.callback.call(config.scope || config.callback, data.success);
            },
            error: function error(xhr, status, _error2) {
                if (config.callback) config.callback.call(config.scope || config.callback, _error2);
            }
        });
    }
};

/***/ }),

/***/ "gkEF":
/***/ (function(module, exports) {

var HSN = window.HSN || {};
HSN.Template = HSN.Template || {};

(function ($) {
    "use strict";

    HSN.Template.MatrixOptions = function () {
        var application;
        var container;
        var events;
        var matrixGroupOptions;

        function init(config) {
            application = config.application;
            container = $(config.container);

            var eventScope = 'HSN.MatrixOptions';
            events = {};

            matrixGroupOptions = $('.group-options', container);

            matrixGroupOptions.on('click', 'input', handleGroupOptionClickEvent);

            if (!hasMatrixOptionSelected(container)) {
                $('select.variant-selector', container).hide(0);
                $('.tabs', container).hide(0);
            }
        }

        function hasMatrixOptionSelected(container) {
            return $('.matrix-options a', container).hasClass("selected") || $('select.matrix-selector option:selected', container).length;
        }

        function destroy() {
            matrixGroupOptions.off();

            application = container = events = matrixGroupOptions = null;
        }

        function handleGroupOptionClickEvent(e) {
            var groupKey = $(this).val();
            var matrixGroup = $('.' + groupKey, container);
            matrixGroup.addClass('active').siblings().removeClass('active');
            $('.matrix-selection-error, .errors-pd').remove();
        }

        return {
            init: init,
            destroy: destroy,
            EVENT: events
        };
    }();
})(jQuery);

/***/ }),

/***/ "gsQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// define EVENTs



HSN.BagFlyout = function (config) {
    var scope = this;

    config = config || {};
    config.closeTag = config.closeTag = config.closeTag || 'span';
    config.triggerEvent = config.triggerEvent = config.triggerEvent || HSN.Flyout.TRIGGER_EVENT.HOVER;

    this._application = config.application;
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.FlyoutContent = $(config.flyoutContent);
    this.NoAjax = config.noajax;
    this.CommerceService = HSN.Instance()._getCommerceService();
    this.delayMouseLeave = 750;
    this.waitTimeout;
    this.mouseLeaveFunction = null;
    this.autoLeaveFunction = null;
    this.cmPage = 'Bag';
    this.cmCategory = 'Flyout';
    this.keys = __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
    this.isModalOpen = false;
    this.arrowBtn = this.Trigger.find('#shopping-bag-arrow button');

    /* Removed event this.Trigger.on('click',  because on click it must redirect to checkout/bag also with keyboard navigation*/
    this.Trigger.on('mouseenter', function () {
        if (Modernizr.touchevents) {
            return true;
        } else {
            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            scope.Flyout.css('top', '65px');
            scope.Open();
            return false;
        }
    });
    this.Trigger.on('mouseleave', function () {
        scope.closeFlyout();
        return false;
    });
    /* ADA events  */
    this.closeFlyout = function () {
        if (scope.GetState() === HSN.Flyout.STATE.OPEN) {
            scope.mouseLeaveFunction = window.setTimeout(function () {
                if (!scope.isModalOpen) {
                    scope.Close();
                    scope.arrowBtn.find('.topnav-arrow').css('display', 'none').removeClass('arrow-up');
                }
            }, scope.delayMouseLeave);
        }
    };
    this.arrowBtn.on('click', function () {
        if (scope.GetState() === HSN.Flyout.STATE.OPEN) {
            scope.arrowBtn.find('.topnav-arrow').css('display', 'none');
            scope.closeFlyout();
        } else {
            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            scope.Flyout.css('top', 'auto');
            scope.arrowBtn.find('.topnav-arrow').addClass('arrow-up').css('display', 'inline-block');
            scope.Open();
        }
        return false;
    }).on('keydown', function (e) {
        if (e.keyCode === scope.keys.enter || e.keyCode === scope.keys.spacebar) {
            var isFlyoutOpen = scope.GetState() === HSN.Flyout.STATE.OPEN;
            scope.arrowBtn.find('.topnav-arrow').css('display', isFlyoutOpen ? 'none' : 'inline-block');
        } else if (e.keyCode === scope.keys.esc) {
            scope.closeFlyout();
        }
    }).on('focusout', function (e) {
        if (!$(e.relatedTarget).parents('.flyout').length > 0) {
            scope.closeFlyout();
        }
    });
    this.Flyout.on('keydown', function (e) {
        if (e.keyCode === scope.keys.esc) {
            scope.arrowBtn.attr('aria-expanded', false);
            scope.closeFlyout();
            scope.arrowBtn.focus();
        }
    });
    this.Flyout.on('focusout', function (e) {
        if (!$(e.relatedTarget).parents('.flyout').length && !$(e.relatedTarget).parents('#shopping-bag-arrow').length) {
            scope.closeFlyout();
        }
    });
    //

    this.Flyout.on('click', function (e) {
        window.clearTimeout(scope.autoLeaveFunction);
        e.stopPropagation();
    });

    this.Flyout.on('click', '.checkout-button', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'checkout');
        window.location.href = '/checkout/bag';
        return false;
    });

    this.Flyout.on('click', '.full-bag-link', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'fullbag');
        window.location.href = '/checkout/bag';
        return false;
    });

    this.Flyout.on('keyup', '.full-bag-link', function (event) {
        event.preventDefault();
        if (event.keyCode === scope.keys.enter || event.keyCode === scope.keys.spacebar) {
            scope.DispatchAnalytics('RE:header', 'bagflyout', 'fullbag');
            window.location.href = '/checkout/bag';
        }
    });

    this.Flyout.on('click', '.view-save-for-later', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'saveditems');
        window.location.href = '/checkout/bag?viewSaved=true';
        return false;
    });

    this.Flyout.on('keyup', '.view-save-for-later', function (event) {
        event.preventDefault();
        if (event.keyCode === scope.keys.enter || event.keyCode === scope.keys.spacebar) {
            scope.DispatchAnalytics('RE:header', 'bagflyout', 'saveditems');
            window.location.href = '/checkout/bag?viewSaved=true';
        }
    });

    this.Flyout.on('click', '.bag-link', function () {
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'yourbag');
        window.location.href = $(this).attr('href');
        return false;
    });

    this.Flyout.on('click', '.remove', function () {
        var parent = $(this).closest('.flyout-bag-item');
        scope.AddMask(parent, 'Removing Item');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');

        scope.DispatchAnalytics('RE:header', 'bagflyout', 'removeitem');
        scope.CommerceService.RemoveBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId }, {
            callback: function callback() {
                var quantity = parent.data('bi-quantity');
                var productId = parent.data('product-id');
                var webId = parent.data('web-id');
                var productPrice = parent.data('product-price');
                var webMId = parent.data('product-webmid');

                HSN.DataLayer.helpers.metricEvent(null, "CP:remove", "flyout", productId, quantity);
                HSN.DataLayer.sendData({ 'cartitem_webpid': productId, 'cartitem_qty': quantity, 'cartitem_webid': webId, 'cartitem_webmid': webMId, 'cartitem_price': productPrice });
                HSN.DataLayer.helpers.hsnEvent(null, "RemoveFromBagFlyout", "Success", null, null);
                if (quantity) {
                    HSN.IncreaseBagIconCount(-quantity);
                }
                scope.GetContent();
                HsnDrdPageCache.setCookie('BagTrack', '-1', HsnDrdPageCache.getLowerDomain(), null, '/');
            },
            errorCallBack: function errorCallBack() {
                alert('Unfortunately there was an error attempting to remove your bag item, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.remove-warranty', function () {
        var parent = $(this).closest('.flyout-bag-item');
        scope.AddMask(parent, 'Removing Warranty');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'removehpp');
        scope.CommerceService.RemoveWarrantyFromBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId }, {
            callback: function callback() {
                scope.GetContent();
            },
            errorCallBack: function errorCallBack() {
                scope.RemoveMask(parent);
                alert('Unfortunately there was an error attempting to remove your warranty, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.add-warranty', function () {
        var parent = $(this).closest('.warranty-offer');
        var flyoutBagItem = parent.prev();
        scope.AddMask(flyoutBagItem, 'Adding Warranty');
        var bagIdentity = parent.data('bag-id');
        var bagItemId = parent.data('bi-id');
        var warrantyItemId = $(this).data('warranty-id');
        scope.DispatchAnalytics('RE:header', 'bagflyout', 'addhpp');
        scope.CommerceService.AddWarrantyToBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId, warrantyItemId: warrantyItemId }, {
            callback: function callback() {
                scope.GetContent();
            },
            errorCallBack: function errorCallBack() {
                scope.RemoveMask(flyoutBagItem);
                alert('Unfortunately there was an error attempting to add your warranty, please try again.');
            }
        });
        return false;
    });
    this.Flyout.on('click', '.switch-to-auto-ship', function () {
        var parent = $(this).closest('.auto-ship-option-container');
        var flyoutBagItem = parent.prev();
        scope.AddMask(flyoutBagItem, 'Updating to AutoShip');

        var bagIdentity = $(this).data('bag-id');
        var basketId = $(this).data('basketId');
        var singleShipWebId = $(this).data('singleShipWebId');
        var autoShipWebId = $(this).data('autoShipId');

        scope.DispatchAnalytics('RE:header', 'bagflyout', 'autoship');

        var autoshipModal = HSN.Instance().GetGenericConfirmModal();
        autoshipModal.SetInputData({ productIdentity: autoShipWebId });
        autoshipModal.SetOkCallback(function () {
            scope.ChangeToAutoship({ bagIdentity: bagIdentity, basketId: basketId, singleShipWebId: singleShipWebId, autoShipWebId: autoShipWebId });
            scope.isModalOpen = false;
        });
        autoshipModal.SetCancelCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        autoshipModal.SetCloseClickCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        autoshipModal.SetErrorCallback(function () {
            scope.isModalOpen = false;
            scope.RemoveMask(flyoutBagItem);
        });
        scope.isModalOpen = true;
        autoshipModal.Show("/autoship/notice");
        return false;
        //scope.CommerceService.ChangeItemSingleShipToAutoShip({BagIdentity: bagIdentity, BasketId: basketId, SingleShipWebId: singleShipWebId, AutoShipId: autoShipWebId}, {
        //    callback: function() {
        //        scope.GetContent();
        //    },
        //    errorCallBack: function() {
        //        scope.RemoveMask(flyoutBagItem);
        //        alert('Unfortunately there was an error attempting to update your item to AutoShip, please try again.');
        //    }
        //});
    });
    this.Flyout.on('click', '.article-modal', function () {
        var articleSlug = $(this).data('articleSlug');
        var articleId = $(this).data('articleId');
        if (isNaN(articleId)) {
            return false;
        }
        if (!articleSlug) {
            articleId = 'default-article-slug';
        }
        HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId);
        return false;
    });
};
HSN.BagFlyout.prototype = {
    _state: HSN.Flyout.STATE.CLOSED,
    GetState: function GetState() {
        return this._state;
    },
    Close: function Close() {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, scope);
        HSN.RemoveContainerWait();
        scope.Flyout.stop(true, true).slideUp(750).animate({ queue: false, duration: 750, complete: function complete() {
                scope.Flyout.css('display', 'none');
            } });
        scope.FlyoutContent.hide();
        scope.FlyoutContent.empty();

        scope.arrowBtn.attr('aria-expanded', false);
        scope._state = HSN.Flyout.STATE.CLOSED;
    },
    Open: function Open(closeAfter) {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.OPEN) {
            return;
        }
        //THIS IS SOO GHETTO... Used to undo the lessman/arcade menus so we can show the flyout
        if ($('#ShopAllHSN').length > 0) {
            $('#ShopAllHSN').click();
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, scope);
        scope._state = HSN.Flyout.STATE.OPEN;

        scope.waitTimeout = setTimeout(function () {
            HSN.SetContainerWait('#shopping-bag-flyout .flyout', true);
        }, 250);

        scope.Flyout.show();
        scope.GetContent();

        if (closeAfter && closeAfter > 0) {
            scope.autoLeaveFunction = window.setTimeout(function () {
                scope.Close();
            }, closeAfter);
        }

        scope.arrowBtn.attr('aria-expanded', true);
        scope._state = HSN.Flyout.STATE.OPEN;
    },
    GetContent: function GetContent() {
        var scope = this;
        scope.CommerceService.GetBagFlyout({
            callback: function callback(data) {
                clearTimeout(scope.waitTimeout);
                HSN.RemoveContainerWait();
                scope.FlyoutContent.html(data);
                scope._application.Events.Trigger(HSN.Flyout.EVENT.AFTER_LOAD, scope);
                scope.FlyoutContent.stop(true, true).slideDown(750).animate({ queue: false, duration: 350 });
            },
            errorCallback: function errorCallback(status) {
                if (status !== 'abort') {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                }
            }
        });
    },
    AddMask: function AddMask(toElement, text) {
        toElement.prepend('<div class="mask"><div>' + text + '</div></div>');
    },
    RemoveMask: function RemoveMask(fromElement) {
        fromElement.find('.mask').remove();
    },
    DispatchAnalytics: function DispatchAnalytics(category, action, label) {
        HSN.DataLayer.helpers.metricEvent(null, category, action, label);
    },
    ChangeToAutoship: function ChangeToAutoship(data) {
        var scope = this;
        scope.CommerceService.ChangeItemSingleShipToAutoShip({ BagIdentity: data.bagIdentity, BasketId: data.basketId, SingleShipWebId: data.singleShipWebId, AutoShipId: data.autoShipWebId }, {
            callback: function callback() {
                scope.GetContent();
            },
            errorCallBack: function errorCallBack() {
                scope.RemoveMask(flyoutBagItem);
                alert('Unfortunately there was an error attempting to update your item to AutoShip, please try again.');
            }
        });
    }
};
HSN.BagFlyout.EVENT = {
    BAGITEM_REMOVED: 'bagflyout:bagitem_removed',
    WARRANTY_ADDED: 'bagflyout:warranty_added',
    WARRANTY_REMOVED: 'bagflyout:warranty_removed'
};

/***/ }),

/***/ "hKoQ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU"), __webpack_require__("DuR2")))

/***/ }),

/***/ "hYlo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExchangeVariantSelector_js__ = __webpack_require__("H6N7");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Used by content


/**
* class HSN.BagModal
*
* Encapsulates the functionality of a modal dialog that allows the user to edit their shipping address.
**/
HSN.ExchangeModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ExchangeModal, parent);

    function ExchangeModal() {
        /**
        * new HSN.ExchangeModal()
        **/
        var modal = ExchangeModal.__super__.constructor.call(this);

        return modal;
    }

    ExchangeModal.prototype.ShowComplete = function (ordernum, sku) {
        $.ajax("/myaccount/orders/exchangecomplete/" + ordernum + '/' + sku, {
            type: 'GET',
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;

                scope.Root.removeClass('loading');
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                }, function () {
                    //scope.Center();
                });
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    ExchangeModal.prototype._show = function (ordernum) {
        $.ajax("/myaccount/orders/exchange/" + ordernum, {
            type: 'GET',
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;

                scope.Root.removeClass('loading');
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                }, function () {
                    //scope.Center();
                });
            },
            error: function error() {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return ExchangeModal;
}(HSN.Modal);

/***/ }),

/***/ "i/Ml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_EventCoordinator_js__ = __webpack_require__("BHfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
    * class HSN.AccountMenu
    *
    * Encapsulates the common functionality of the Account Menu 
    **/
HSN.AccountMenu = function () {
    var application;
    var container;
    var events = new HSN.EventCoordinator();
    var customerStateEnum = {
        COLD: 0,
        WARM: 1,
        HOT: 2
    };
    var noAjax;
    var accountMenuContainer;
    var accountBtn;
    var message;
    var subMessage;
    var subMenu;
    var ownershipArrow;

    /**
        * new HSN.AccountMenu.init(config)
        * - config (Object): A configuration object for the [[HSN.AccountMenu]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        noAjax = config.noAjax;
        accountMenuContainer = container.find('#account-menu-container');
        accountBtn = container.find('.account-btn');
        message = container.find('.message');
        subMessage = container.find('.sub-message');
        ownershipArrow = container.find('.account-btn .sub-text .arrow');
        bindEvents();
    }

    function bindEvents() {
        if (noAjax) {
            accountBtn.remove();
            container.find('.community').show();
            return;
        }

        //avoid binding open/close events for community sites
        var domainsToDisableDropDown = ['community.hsn.com', 'communityqa.hsn.com', 'blogs.hsn.com'];

        for (var i = 0; i < domainsToDisableDropDown.length; i++) {
            if (document.location.host === domainsToDisableDropDown[i]) {
                return;
            }
        }

        // To manage outside click on iPad & desktop when Keyboard nav
        var outsideHandler = function outsideHandler(e) {
            if (!$(e.target).parents('#account-menu-container').length) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
            }
        };

        var openOrClose = function openOrClose() {
            if (accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
            } else {
                events.Trigger(HSN.AccountMenu.EVENT.BEFORE_OPEN, false);
                events.Trigger(HSN.AccountMenu.EVENT.OPEN, accountBtn);
            }
        };

        if (!Modernizr.touchevents) {
            accountMenuContainer.on('mouseleave', function () {
                if (accountBtn.hasClass('open')) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            });
            accountMenuContainer.on('mouseenter', function (event) {
                openOrClose();
            });
        } else {
            accountBtn.on('touchstart', function (e) {
                e.preventDefault();
                e.stopPropagation();
                openOrClose();
            });
        }

        // For keyboard or misc pointer devices
        accountBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openOrClose();
        }).on('focusout', function (e) {
            setTimeout(function () {
                if (accountBtn.hasClass('open') && !container.find('.sub-menu ul').find(':focus').length) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            }, 100);
        }).on('keydown', function (e) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
            var key = e.keyCode || e.which;
            if (key === keys.esc && accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                container.find('#account-menu-container .account-btn').focus();
            } else if (key === keys.spacebar) {
                e.preventDefault();
                e.stopPropagation();
                openOrClose();
            }
        });

        //listen for events within component
        //menu open
        events.On(HSN.AccountMenu.EVENT.OPEN, function (element) {
            ownershipArrow.addClass('active');
            var customerState = application.AccountNavigation.GetCustomerState();
            if (customerState === customerStateEnum.HOT || customerState === customerStateEnum.WARM) {
                subMenu = container.find('.hot-state');
                subMenu.show();
            } else {
                subMenu = container.find('.cold-state');
                subMenu.show();
            }

            element.addClass('open');
            element.attr('aria-expanded', true);
            if (Modernizr.touchevents) $(document).on('touchstart.accountMenuRollovers', outsideHandler);else $(document).on('click.accountMenuRollovers', outsideHandler);
        }, this);

        //menu close
        events.On(HSN.AccountMenu.EVENT.CLOSE, function (element) {
            element.removeClass('open');
            element.attr('aria-expanded', false);
            ownershipArrow.removeClass('active');
            if (subMenu) {
                subMenu.hide();
            }
            $(document).off('.accountMenuRollovers');
        }, this);

        //on account status
        HSN.OnAccountStatusLoad(function (data) {
            setCustomerName(data.name);
            container.addClass('show');
        });

        HSN.OnAccountStatusDetailLoad(function (data) {
            setTotalAlerts(data.NumberOfAlerts);
            setMainAlerts(data);
        });

        // close subMenu when it lost focus
        container.find('.sub-menu ul').on('focusout', function (event) {
            setTimeout(function () {
                if (!container.find(':focus').length) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            }, 100);
        });

        // close subMenu when Escape keyboard navigation
        container.find('.sub-menu ul a').on('keydown', function (event) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
            var key = event.keyCode || event.which;
            if (key === keys.esc && accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                container.find('#account-menu-container .account-btn').focus();
            }
        });
    }

    function setCustomerName(name) {
        if (name) {
            message.text('Hi, ' + name);
            subMessage.text('My Account');
            message.parent().attr('aria-label', 'Hi ' + name + '. My Account Menu');
        } else {
            message.text('Hello, Guest');
            subMessage.text('Sign In');
            message.parent().attr('aria-label', 'Hello Guest. Sign In Menu');
        }
    }

    function setTotalAlerts(total) {
        if (total > 0) {
            container.find('.alerts .alerts-indicator').show();
            container.find('.alerts .alert-count').text(clampAlertCount(total));
        }
    }

    function setMainAlerts(data) {
        var el = container.find('.main-alerts');
        var total = data.NumberOfAlerts;
        if (total < 1) {
            return;
        }
        if (data.IsKashCouponMenuTestActive) {
            el.addClass('has-count').html('<div class=\'alert-count\'>' + clampAlertCount(total) + '</div>');
        }
        el.show();
    }

    function clampAlertCount(amount) {
        return amount > 9 ? '9+' : amount;
    }

    function destroy() {
        application = container = null;
    }

    return {
        init: init,
        destroy: destroy
    };
};

HSN.AccountMenu.EVENT = {
    OPEN: 'HSN.AccountMenu:OPEN',
    CLOSE: 'HSN.AccountMenu:CLOSE',
    BEFORE_OPEN: 'HSN.AccountMenu:BEFORE_OPEN'
};

/***/ }),

/***/ "iWJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.AccountNavigation
//import "../AccountNavigation.js";

/**
* class HSN.AccountNavigation.Cabinet
*
* Encapsulates and manages the interactions between multiple
* [[HSN.AccountNavigation.Cabinet]] instances.
**/
HSN.AccountNavigation.Cabinet = function (config) {
  /**
   * new HSN.AccountNavigation.Cabinet(config)
   * - config (Object): A configuration object for the [[HSN.AccountNavigation.Cabinet]]
   *   consisting of the following keys:
   *   - drawers ([HSN.AccountNavigation.Cabinet.Drawer]): The collection of [[HSN.AccountNavigation.Cabinet.Drawer]] instances for the [[HSN.AccountNavigation.Cabinet]] to manage and coordinate.
   *   - id (String): The value of the cabinet's `id` attribute to be used as a styling hook.
   **/
  var __scope = this;

  config = config = config || {};

  this.Drawers = config.drawers;
  this.Root = $('<div id="' + config.id + '" class="clearfix"></div>');
  this.Wrap = $('<div class="wrap"></div>');
  this.Content = $('<div class="content"></div>');
  this.Closer = $('<span class="ir close">&times;</span><span class="close-alt">CLOSE</span>');

  this.Wrap.append(this.Closer);
  this.Wrap.append(this.Content);
  this.Root.append(this.Wrap);
  //this.Root.append('<hr>');

  this.Closer.on('click', function (e) {
    __scope.Close();
  });

  $(window).on('keydown', function (event) {
    var keyCode = event.keyCode || event.which;
    if (keyCode != 27) {
      return;
    }

    $.each(__scope.Drawers, function (i, drawer) {
      if (__scope.State == HSN.AccountNavigation.Cabinet.State.Open && drawer == __scope.GetActiveDrawer()) {
        __scope.Close();
      }
    });
  });

  $.each(this.Drawers, function (i, drawer) {
    drawer.Trigger.on('click', function (e) {

      if (drawer.NoAjax) {
        var cookie = "signin=";
        var crumb = "ref=" + window.location.href;
        var domain = "; domain=.hsn.com";
        var path = "; path=/";
        document.cookie = cookie + crumb + domain + path;
        return;
      }

      e.preventDefault();

      if (__scope.State == HSN.AccountNavigation.Cabinet.State.Open && drawer == __scope.GetActiveDrawer()) {
        __scope.Close();
        return false;
      }

      __scope.Open(drawer);
      return false;
    });
  });
};

/**
* HSN.AccountNavigation.Cabinet.EVENT = Object
*
* An enumeration of events an [[HSN.AccountNavigation.Cabinet]] can raise:
* - BEFORE_OPEN: Right before the flyout is opened.
* - BEFORE_CLOSE: Right before the flyout is opened.
**/
HSN.AccountNavigation.Cabinet.EVENT = {
  BEFORE_CLOSE: 'cabinet:before_close',
  AFTER_CLOSE: 'cabinet:after_close',
  BEFORE_OPEN: 'cabinet:before_open',
  AFTER_OPEN: 'cabinet:after_open',
  OPEN_SAVEFORLATER: 'cabinet:open_saveforlater',
  OPEN_PREVIEW: 'cabinet:open_preview'
};

/**
 * HSN.AccountNavigation.Cabinet.State = Object
 *
 * An enumeration of potential states for an [[HSN.AccountNavigation.Cabinet]] with the following members:
 * - Closed
 * - Open
 **/
HSN.AccountNavigation.Cabinet.State = {
  Closed: 0,
  Open: 1
};

HSN.AccountNavigation.Cabinet.prototype = {
  _activeDrawer: null,

  /**
   * HSN.AccountNavigation.Cabinet#State -> HSN.AccountNavigation.Cabinet.State
   *
   * Holds the current state of the [[HSN.AccountNavigation.Cabinet]]
   **/
  State: HSN.AccountNavigation.Cabinet.State.Closed,

  /**
   * HSN.AccountNavigation.Cabinet#Close([callback]) -> void
   * - callback (Function): The optional function to call once the drawer has opened
   *
   * Closes the cabinet, if open, and then fires the given
   * `callback`, if provided.
   **/
  Close: function Close(callback) {
    var __scope = this;

    HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_CLOSE, this);
    __scope.Root.filter(":not(:animated)").slideUp(250, function () {
      __scope.State = HSN.AccountNavigation.Cabinet.State.Closed;
      $.each(__scope.Drawers, function (i, drawer) {
        drawer.Trigger.removeClass('open');
        if (drawer.CloseCallback) {
          drawer.CloseCallback();
        }
      });
      __scope._activeDrawer = null;

      if (callback) {
        callback();
      }
      HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.AFTER_CLOSE, this);
    });
  },

  /**
   * HSN.AccountNavigation.Cabinet#FindDrawerByIdentifier(identifier) -> HSN.AccountNavigation.Cabinet.Drawer | null
   * - identifier (String): The identifier of the [[HSN.AccountNavigation.Cabinet.Drawer]] being looked for.
   *
   * Returns the [[HSN.AccountNavigation.Cabinet.Drawer]] in the [[HSN.AccountNavigation.Cabinet]]'s collection with the identifier provided.
   **/
  FindDrawerByIdentifier: function FindDrawerByIdentifier(identifier) {
    var drawersLength = this.Drawers.length;
    for (var i = 0; i < drawersLength; i++) {
      if (this.Drawers[i].Identifier == identifier) {
        return this.Drawers[i];
      }
    }
    return null;
  },

  /**
   * HSN.AccountNavigation.Cabinet#GetActiveDrawer() -> HSN.AccountNavigation.Cabinet.Drawer | null
   *
   * Returns the currently active [[HSN.AccountNavigation.Cabinet.Drawer]],
   * of null if no drawer is active.
   **/
  GetActiveDrawer: function GetActiveDrawer() {
    return this._activeDrawer;
  },

  /**
   * HSN.AccountNavigation.Cabinet#Open(drawer) -> void
   * - callback (HSN.AccountNavigation.Cabinet.Drawer | String): The drawer to load into the cabinet as it opens, or the identifier of a drawer.
   *
   * Opens the cabinet, if it is currently closed, and loads the contents of the provided
   * [[HSN.AccountNavigation.Cabinet.Drawer]] into it.
   **/
  Open: function Open(drawer) {
    if (typeof drawer == "string") {
      drawer = this.FindDrawerByIdentifier(drawer);
    }

    if (null == drawer) {
      return;
    }
    var __scope = this;
    HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
    var supportsFading = !$("html").hasClass("lt-ie9");
    __scope.Root.addClass('loading');
    __scope.Root.filter(":not(:animated)").slideDown(250, function () {
      __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

      $.each(__scope.Drawers, function (i, drawer) {
        drawer.Trigger.removeClass('open');
      });
      drawer.Trigger.addClass('open');
      __scope._activeDrawer = drawer;

      $.ajax(drawer.Url, {
        cache: false,
        context: drawer,
        dataType: 'html',
        success: function success(data, status, xhr) {
          __scope.Root.removeClass('loading');
          __scope.Content.showHtml(data, 250, function () {
            if (drawer.Callback) drawer.Callback(drawer);
            if (supportsFading) {
              __scope.Content.animate({ opacity: 1 });
            } else {
              __scope.Content.css("opacity", "1");
            }
            HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.AFTER_OPEN, this);
            //TODO: wrap this in a coremetrics check?
            cX('onload');
          });
        },
        error: function error(xhr, status, _error) {
          alert("Unfortunately there was an error attempting to load the content, please try again.");
        }
      });
    });

    HSN.Instance().Events.On(HSN.Application.EVENT.ARCADE_HEADER_MOUSELEAVE, function () {
      if (__scope.State === HSN.AccountNavigation.Cabinet.State.Open) {
        __scope.Close();
      }

      return false;
    });
  },

  OpenSaveForLater: function OpenSaveForLater(drawer) {
    if (typeof drawer == "string") {
      drawer = this.FindDrawerByIdentifier(drawer);
    }

    if (null == drawer) {
      return;
    }

    var __scope = this;
    var supportsFading = !$("html").hasClass("lt-ie9");

    HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
    this.Content.animate({ opacity: supportsFading ? 0 : 1 }, 250, function () {
      __scope.Root.addClass('loading');
      __scope.Root.slideDown(250, function () {
        __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

        $.each(__scope.Drawers, function (i, drawer) {
          drawer.Trigger.removeClass('open');
        });
        drawer.Trigger.addClass('open');
        __scope._activeDrawer = drawer;

        $.ajax(drawer.Url, {
          cache: false,
          context: drawer,
          dataType: 'html',
          success: function success(data, status, xhr) {
            __scope.Root.removeClass('loading');
            __scope.Content.showHtml(data, 250, function () {
              if (drawer.Callback) drawer.Callback(drawer);
              if (supportsFading) {
                __scope.Content.animate({ opacity: 1 });
              } else {
                __scope.Content.css("opacity", "1");
              }
            });
            HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.OPEN_SAVEFORLATER, this);
          },
          error: function error(xhr, status, _error2) {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
          }
        });
      });
    });
  },

  OpenPreview: function OpenPreview(drawer) {
    if (typeof drawer == "string") {
      drawer = this.FindDrawerByIdentifier(drawer);
    }

    if (null == drawer) {
      return;
    }

    var __scope = this;
    var supportsFading = !$("html").hasClass("lt-ie9");

    HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
    this.Content.animate({ opacity: supportsFading ? 0 : 1 }, 250, function () {
      __scope.Root.addClass('loading');
      __scope.Root.slideDown(250, function () {
        __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

        $.each(__scope.Drawers, function (i, drawer) {
          drawer.Trigger.removeClass('open');
        });
        drawer.Trigger.addClass('open');
        __scope._activeDrawer = drawer;

        $.ajax(drawer.Url, {
          cache: false,
          context: drawer,
          dataType: 'html',
          success: function success(data, status, xhr) {
            __scope.Root.removeClass('loading');
            __scope.Content.showHtml(data, 250, function () {
              if (drawer.Callback) drawer.Callback(drawer);
              if (supportsFading) {
                __scope.Content.animate({ opacity: 1 });
              } else {
                __scope.Content.css("opacity", "1");
              }
            });
            HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.OPEN_PREVIEW, this);
          },
          error: function error(xhr, status, _error3) {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
          }
        });
      });
    });
  },

  Reload: function Reload() {
    if (this.State != HSN.AccountNavigation.Cabinet.State.Open || !this._activeDrawer) {
      return false;
    }
    return this.Open(this._activeDrawer);
  }
};

/***/ }),

/***/ "ixIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* Video Player 
    * A base class to extend when adding new video players
    * Do not call these methods directly, this class is meant to be extended
*/

var VideoPlayer = function () {
    function VideoPlayer(config) {
        _classCallCheck(this, VideoPlayer);

        this.config = config;
        this.videoPlayer = null;

        this.status = {
            STOPPED: 0,
            PAUSED: 1,
            PLAYING: 2
        };
    }

    VideoPlayer.prototype.assignEvents = function assignEvents() {};

    VideoPlayer.prototype.play = function play() {};

    VideoPlayer.prototype.pause = function pause() {};

    VideoPlayer.prototype.stop = function stop() {};

    VideoPlayer.prototype.getCurrentTime = function getCurrentTime() {};

    VideoPlayer.prototype.setCurrentTime = function setCurrentTime(time) {};

    VideoPlayer.prototype.getDuration = function getDuration() {};

    VideoPlayer.prototype.getVolume = function getVolume() {};

    VideoPlayer.prototype.setVolume = function setVolume() {};

    VideoPlayer.prototype.onTimeUpdate = function onTimeUpdate() {};

    VideoPlayer.prototype.throwAnalyticEvent = function throwAnalyticEvent(category, action, label, value) {
        if (value) {
            HSN.DataLayer.helpers.metricEvent(null, category, action, label, value);
        } else {
            HSN.DataLayer.helpers.metricEvent(null, category, action, label);
        }
    };

    VideoPlayer.prototype.getVideoPlayer = function getVideoPlayer() {
        return this.videoPlayer;
    };

    return VideoPlayer;
}();

/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);

/***/ }),

/***/ "j8Sc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_unobtrusive_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






//**
//  *class HSN.OffCanvas
//  *Encapsulates the functionality of a Off Canvas dialog that contains product information.
//**

HSN.OffCanvas = function () {
    OffCanvas.prototype.settings = {};
    OffCanvas.prototype.elementToFocusOnClose = null;

    OffCanvas.EVENT = {
        OPEN: 'HSN.OffCanvas.EVENT.OPEN',
        CLOSE: 'HSN.OffCanvas.EVENT.CLOSE'
    };

    OffCanvas.SOURCE_DIRECTION = {
        LEFT: 'left',
        RIGHT: 'right',
        TOP: 'top',
        BOTTOM: 'bottom'
    };

    function OffCanvas(settings) {
        var __scope = this;
        __scope.settings = settings;
        var className = settings.className;
        var sourceDirection = settings.sourceDirection;

        $(window).on('keydown', function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode != 27) {
                return;
            }
            __scope.Hide();
        });

        $(document).on('click', '#modal-mask-oc', function () {
            __scope.Hide();
        });

        this.Root = className ? $('<div class="off-canvas ' + className + ' ' + sourceDirection + '"></div>') : $('<div class="off-canvas"></div>');
        this.Root.hide();

        var ariaFirst = '<div role="presentation" aria-modal="true" aria-label="Dialog opened" tabindex="0" class="visuallyhidden">Dialog opened</div>';
        this.Root.append(ariaFirst);

        this.Close = $('<a href="#" id="close" tabindex="0" class="close" aria-label="close dialog" style="display:none"></a>');
        this.Close.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (__scope.elementToFocusOnClose) {
                __scope.elementToFocusOnClose.focus();
            }
            __scope.Hide();
        });
        this.Close.on('keyup', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var keys = __WEBPACK_IMPORTED_MODULE_4_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
            var key = e.keyCode || e.which;
            if (key === keys.enter) {
                if (__scope.elementToFocusOnClose) {
                    __scope.elementToFocusOnClose.focus();
                }
                __scope.Hide();
            }
        });

        this.Root.append(this.Close);

        this.Content = $('<div class="off-canvas-content" tabindex="0"></div>');
        this.Root.append(this.Content);

        this._initialize();
    }

    OffCanvas.prototype._initialize = function () {};

    // This private method must be implemented by all HSN.OffCanvas subclasses.
    OffCanvas.prototype._show = function () {
        throw "_show() is not implemented in " + this.constructor.name;
    };
    OffCanvas.prototype.Root = null;
    OffCanvas.prototype.Banner = null;

    //**
    //    * HSN.OffCanvas#Content -> jQuery
    //    *
    //    * [[HSN.OffCanvas#Content]] provides access to the jQuery-wrapped HTML element that contains the content for the Off Canvas.
    //**
    OffCanvas.prototype.Content = null;

    //**
    //    * HSN.OffCanvas#Root -> jQuery
    //    *
    //    * [[HSN.OffCanvas#Content]] provides access to the jQuery-wrapped HTML element that is the root of the Off Canvas.
    //**
    OffCanvas.prototype.Root = null;

    //**
    //    * HSN.OffCanvas#Hide() -> void
    //    *
    //    * Hides the Off Canvas.
    //**
    OffCanvas.prototype.Hide = function () {
        var __scope = this;

        if (!__scope.Root.is(':visible')) {
            return;
        }

        if ('_hide' in __scope) {
            __scope._hide();
        }

        $('#modal-mask-oc').remove();

        this.Content.showHtml('', 0, function () {
            __scope.Root.hide("slide");
        }, function () {});

        HSN.Instance().Events.Trigger(HSN.OffCanvas.EVENT.CLOSE);
    };

    //**
    //    * HSN.OffCanvas#Show() -> void
    //    *
    //    * Shows the Off Canvas.
    //**
    OffCanvas.prototype.Show = function () {
        var classToAttach = 'body';
        if (this.settings.maskPage && !$('#modal-mask-oc').is(':visible')) {
            $('<div></div>').prependTo(classToAttach).attr('id', 'modal-mask-oc');
            this.PositionMask();
            $('#modal-mask-oc').show();
        }
        this.Root.addClass('loading');
        this.AddLoadingSpinner();
        this.Content.empty();
        this.Root.show();
        this._show.apply(this, arguments);

        HSN.Instance().Events.Trigger(HSN.OffCanvas.EVENT.OPEN);
    };

    OffCanvas.prototype.DisplayContent = function (htmlData) {
        var scope = this;

        this.Content.showHtml(htmlData, 0, function () {
            scope.RemoveLoadingSpinner();
            scope.Root.removeClass('loading');
            scope.Content.show("slide", { direction: scope.sourceDirection }, 2000);
            scope.Root.find('#close').show();
        }, function () {});
    };

    OffCanvas.prototype.PositionMask = function () {
        $('#modal-mask-oc').css('height', $(document).height());
        $('#modal-mask-oc').css('width', $(document).width());
    };

    OffCanvas.prototype.HandleError = function (errorMessage) {
        var scope = this;
        var error = errorMessage || 'Unfortunately there was an error attempting to load the content, please try again.';
        alert(error);
        scope.Hide();
    };

    OffCanvas.prototype.Refresh = function () {
        this.Show.apply(this, arguments);
    };
    OffCanvas.prototype.AddLoadingSpinner = function () {
        if (!this.Root.find('#loading').length > 0) {
            this.Root.append('<div id="loading" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div></div>');
        }
    };
    OffCanvas.prototype.RemoveLoadingSpinner = function () {
        this.Root.find('#loading').remove();
        this.Root.removeClass('loading');
    };

    OffCanvas.prototype.SetElementToFocusOnClose = function (element) {
        this.elementToFocusOnClose = element;
    };

    //Use to set focus inside modal for ADA
    OffCanvas.prototype.SetFocus = function (element) {
        element.focus();
    };

    return OffCanvas;
}();

/***/ }),

/***/ "jBmH":
/***/ (function(module, exports) {

(function($) {
    $.fn.equalHeights = function () {
        var tallest = null;
        $(this).each(function () {
            var outerHeight = $(this).outerHeight();
            if (outerHeight > tallest) {
                tallest = outerHeight;
            }
        });
        $(this).each(function (i) {
            var outerHeight = $(this).outerHeight();
            if (outerHeight < tallest) {
                $(this).height($(this).height() + (tallest - outerHeight));
            }
        });
        return this;
    };

    $.fn.equalColumnHeights = function (columns, padding) {
        var index = 0;
        var maxHeight = 0;
        var items = [columns];
        jQuery(this).each(function () {
            items[index] = jQuery(this);
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
            if (((index + 1) % columns) === 0) {
                for (var i = 0; i < columns; i++) {
                    items[i].height(maxHeight + padding);
                }
                index = 0;
                maxHeight = 0;
                for (var i = 0; i < columns; i++) {
                    items[i] = undefined;
                }
            }
            else {
                index++;
            }
        });
        if (maxHeight !== 0 || index !== 0) {
            for (var i = 0; i < columns; i++) {
                if (items[i] !== undefined) {
                    items[i].height(maxHeight + padding);
                }
            }
        }
        return jQuery(this);
    };
})(jQuery);


/***/ }),

/***/ "jQJV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_menu_aim_js__ = __webpack_require__("sSHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_menu_aim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_menu_aim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// define EVENTs


HSN.HamburgerFlyout = function (config) {
    var scope = this;

    config = config || {};
    config.closeTag = config.closeTag = config.closeTag || 'span';

    this._application = config.application;
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.FlyoutContent = $(config.flyoutContent);
    this.delayMouseLeave = 500;
    this.mouseLeaveFunction = null;
    this.autoLeaveFunction = null;
    this.isMouseOverFlyout = false;
    this.storefrontFlyout = null;
    this.cmPage = 'Bag';
    this.cmCategory = 'Flyout';
    this.touchTimeOut = null;

    this.Trigger.on('click mouseenter', function (e) {
        scope.OpenHamburgerMenu();

        window.clearTimeout(scope.mouseLeaveFunction);
        window.clearTimeout(scope.autoLeaveFunction);
        window.clearTimeout(scope.touchTimeOut);

        return true;
    });

    $('#hamburger-open-button').on('touchstart', function (e) {
        if (scope.GetState() === HSN.Flyout.STATE.CLOSED) {
            e.stopPropagation();
            scope.OpenHamburgerMenu();

            scope.isMouseOverFlyout = true;

            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            window.clearTimeout(scope.touchTimeOut);

            return false;
        } else {
            e.stopPropagation();
            scope.Close();

            return false;
        }
    });

    this.Trigger.on('mouseleave', function () {
        scope.mouseLeaveFunction = window.setTimeout(function () {
            if (!scope.isMouseOverFlyout) {
                scope.Close();
            }
        }, scope.delayMouseLeave);
        return false;
    });

    this.Flyout.on('click touchstart', function (e) {
        window.clearTimeout(scope.autoLeaveFunction);
    });

    this.Flyout.on('mouseenter', function (e) {
        scope.isMouseOverFlyout = true;
    });

    this.Flyout.on('mouseleave', function (e) {
        scope.isMouseOverFlyout = false;

        scope.mouseLeaveFunction = window.setTimeout(function () {
            scope.Close();
        }, scope.delayMouseLeave);
        return false;
    });
};
HSN.HamburgerFlyout.prototype = {
    _state: HSN.Flyout.STATE.CLOSED,
    GetState: function GetState() {
        return this._state;
    },
    Close: function Close() {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, scope);

        //$(document).off('touchstart', '#modal-mask', scope.TouchOut);
        //$(document).off('touchstart', scope.TouchOut);

        if ($('.modal:visible').length < 1) {
            $('#modal-mask').remove();
        }

        if (scope.storefrontFlyout) {
            scope.storefrontFlyout.hide();
        }

        scope.Flyout.hide();
        scope._state = HSN.Flyout.STATE.CLOSED;

        var hamburger = scope.Flyout.find('#hamburger');

        hamburger.removeClass('open');
        hamburger.find("li").removeClass("active");
    },
    OpenHamburgerMenu: function OpenHamburgerMenu() {
        var scope = this;
        if (scope._state === HSN.Flyout.STATE.OPEN) {
            return;
        }

        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, scope);
        scope._state = HSN.Flyout.STATE.OPEN;

        var pos = scope.Trigger.position();
        scope.Flyout.css({
            'top': this.Trigger.height() + pos.top,
            'left': pos.left
        });

        if (!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('#torso').attr('id', 'modal-mask').addClass('lower-mask');
        }

        if (!$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            $('#modal-mask').show();
        }

        scope.Flyout.css('display', 'table');

        scope.Flyout.find('#hamburger').menuAim({
            rowSelector: 'li',
            activate: function activate(row) {
                var $row = $(row);
                var id = $row.data('marketingId');
                scope.OpenStorefrontFlyout(id);

                if (Modernizr.touchevents) {
                    if ($row.find('a').hasClass('current')) {
                        return true;
                    }
                }

                $row.addClass("active");
            },

            deactivate: function deactivate(row) {
                scope.RemoveActiveFlyout();
                $(row).removeClass("active");
            }
        });

        $(document).one('touchstart', '#modal-mask', function (event) {
            event.stopPropagation();

            scope.isMouseOverFlyout = false;
            scope.Close();

            return false;
        });
    },
    OpenStorefrontFlyout: function OpenStorefrontFlyout(id) {
        this.storefrontFlyout = $('#hamburger-storefront-flyout');
        this.storefrontFlyout.find('> div:visible').hide();
        this.storefrontFlyout.find('#storefront-' + id).show();
        this.storefrontFlyout.show();
    },

    RemoveActiveFlyout: function RemoveActiveFlyout() {
        this.Flyout.find('a').each(function () {
            $(this).removeClass('current');
        });
    }
};

/***/ }),

/***/ "kKtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.AddedToBagOffCanvas = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(AddedToBagOffCanvas, parent);

    function AddedToBagOffCanvas() {
        this.deviceInformation = HSN.Instance().DeviceInformation;
        var offCanvas = AddedToBagOffCanvas.__super__.constructor.call(this, {
            className: 'added-to-bag-off-canvas',
            sourceDirection: this.deviceInformation.IsMobile ? HSN.OffCanvas.SOURCE_DIRECTION.BOTTOM : HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage: true
        });
        this._scope = this;
        this.name = 'HSN.AddedToBagOffCanvas';
        this.commerceService = HSN.Instance()._getCommerceService();
        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Added To Bag', 'AddedToBagOffCanvas', 'Added To Bag Off Canvas');

        return offCanvas;
    }

    function eventHandlers(offCanvas) {
        $(offCanvas.Content).on('click', '.warranty-option-input', function () {
            $('.warranty-option-input', offCanvas.Content).not(this).prop('checked', false);
        });
        $(offCanvas.Content).on('change', '.warranty-option-input', function () {
            var checkbox = $(this);
            var isChecked = checkbox.is(':checked');
            var bagIdentity = offCanvas.Content.find('.added-to-bag-container').data('bag-id');
            var bagItemIdentity = offCanvas.Content.find('.added-to-bag-container').data('bag-item-id');
            var warrantyItemId = checkbox.val();
            HSN.SetWait();
            if (isChecked) {
                HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Add', 'AddToBagButton');
                offCanvas.commerceService.AddWarrantyToBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity, warrantyItemId: warrantyItemId }, {
                    callback: function callback(data) {
                        HSN.RemoveWait();
                        if (!data.success) {
                            checkbox.prop('checked', !isChecked);
                            alert('There was a problem adding your warranty. Please try again later.');
                        }
                    },
                    scope: offCanvas
                });
            } else {
                HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Remove', 'AddToBagButton');
                offCanvas.commerceService.RemoveWarrantyFromBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity }, {
                    callback: function callback(data) {
                        HSN.RemoveWait();
                        if (!data.success) {
                            checkbox.prop('checked', !isChecked);
                            alert('There was a problem removing your warranty. Please try again later.');
                        }
                    },
                    scope: offCanvas
                });
            }
        });
        $(offCanvas.Content).on('click', '#continue-shopping', function () {
            HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'ContinueShopping', 'ContinueShoppingButton');
            offCanvas.Hide();
        });

        $(offCanvas.Content).on('click', '#view-bag', function () {
            handleNavigation(offCanvas);
        });

        $(offCanvas.Content).on('keydown', '#view-bag', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                handleNavigation(offCanvas);
            }
        });
        $(offCanvas.Close).on('click', function (e) {
            HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'Close', 'CloseButton');
            offCanvas.Hide();
        });
    }

    function handleNavigation(offCanvas) {
        HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'ViewBag', 'ViewBagButton');
        var path = isExpressBuy(offCanvas) ? '/checkout/order-review' : '/checkout/bag';
        window.location = window.location.protocol + '//' + window.location.hostname + path;
    }

    function isExpressBuy(offCanvas) {
        return $('.button-container.express', offCanvas.Content).length > 0 ? true : false;
    }

    AddedToBagOffCanvas.prototype._show = function (bagIdentity, bagItemIdentity) {
        $.ajax('/checkout/off-canvas/bag-item-added?bagIdentity=' + bagIdentity + '&bagItemIdentity=' + bagItemIdentity, {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function success(data) {
                var scope = this;
                scope.DisplayContent(data);
                scope.SetFocus($('#view-bag'));
            },
            error: function error() {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return AddedToBagOffCanvas;
}(HSN.OffCanvas);

/***/ }),

/***/ "kxPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Widget_VideoPlayers_AkamaiPlayer_js__ = __webpack_require__("ejzF");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";


/**
* class HSN.VideoModal
* Encapsulates the functionality of a video dialog
**/
HSN.VideoModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(videoModal, parent);

    var currentModal = null;
    var videoModalScope;

    function videoModal() {
        var modal = videoModal.__super__.constructor.call(this);
        videoModalScope = this;
        this.Close.off();
        eventHandlers(this);
        return modal;
    }

    function eventHandlers(modal) {
        currentModal = modal;

        $(modal.Close).on('click', function (e) {
            closeModal(e, modal);
            e.preventDefault();
            e.stopPropagation();
        }).on('keyup', function (e) {
            if (e.key === 'Tab') {
                modal.Close.focus();
                e.preventDefault();
            }
        }).on('keydown', function (e) {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    e.preventDefault();
                }
            } else if (e.key === 'Enter') {
                closeModal(e, modal);
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    function closeModal(e, modal) {
        var mdl;
        if (modal) {
            mdl = modal;

            var playerInstance = getModal();
            playerInstance.videoPlayer.stop();
            modal.Hide();
        } else {
            mdl = getModal();
            mdl.Hide();
        }

        if (mdl.elementToFocusOnClose) {
            mdl.elementToFocusOnClose.focus();
        }
    }

    function getModal() {
        return currentModal;
    }

    videoModal.prototype._show = function (videoData, w, h, showDisclaimer, hideLogo) {
        var scope = this;
        scope.Root.removeClass('loading');
        scope.Root.css("overflow-y", "hidden");

        //video div must have a unique id to allow multiple videos
        var playerId = 'akamai-player' + Math.floor(Math.random() * (99999 - 0) + 0);
        var disclaimer = showDisclaimer ? "<div id='video-disclaimer'>Prices and the availability of FlexPay shown on the previously recorded video may not represent the current price options. Consult the product page for current price options.</div>" : "";
        var videoPlayerElement = $('<div/>').attr('id', playerId);
        var ada = $("<div class='endOfModal' tabindex='0'></div>");
        var videoContainer = $('<div/>').css({ 'width': w, 'height': h, 'margin': '23px 23px 50px 23px' });
        videoContainer.attr('class', 'akamai-player-container');
        videoContainer.append(videoPlayerElement, disclaimer, ada);

        this.Content.showHtml(videoContainer, 0, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 }, {
                complete: function complete() {
                    scope.Close[0].focus();

                    $('.endOfModal', scope.Root).off('focus').on('focus', function (e) {
                        scope.Close[0].focus();
                        e.preventDefault();
                    }).off('keydown').on('keydown', function (e) {
                        scope.Close[0].focus();
                        e.preventDefault();
                    });
                }
            });

            //check for media property - if one doesn't exist, create it (may come from CMS)
            if (!videoData.hasOwnProperty("media")) {
                videoData.media = {
                    title: videoData.analyticName,
                    source: [{ src: videoData.httpUrl, type: "video/mp4" }]
                };
            }

            //check for custom captions
            if (videoData.hasOwnProperty('customCaptions') && videoData.customCaptions) {
                var parsedAsset = videoData.httpUrl.substring(videoData.httpUrl.lastIndexOf('/') + 1);
                var assetId = parsedAsset.split('.')[0];
                videoData.captioning = { enabled: true };
                videoData.media.track = [{
                    kind: "captions",
                    type: "application/x-subrip",
                    srclang: "en",
                    src: "https://" + location.host + "/services/getcaptions/asset/" + assetId
                }];
            }

            videoData.branding = { logo: "../../assets/img/logo_video_bug.png" };
            if (hideLogo) {
                videoData.branding = { logo: "" };
            }

            //init video by passing in video obj and dom id
            videoData.element = playerId;
            videoModalScope.videoPlayer = new __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Widget_VideoPlayers_AkamaiPlayer_js__["a" /* default */](videoData);

            var playerInstance = videoModalScope.videoPlayer.getVideoPlayer();
            playerInstance.addEventListener("ended", function () {
                closeModal();
            });
        });
    };

    videoModal.prototype.getVideoPlayer = function () {
        return videoModalScope.videoPlayer;
    };

    return videoModal;
}(HSN.Modal);

/***/ }),

/***/ "m/F2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.OrdersTrackOrderModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.OrdersTrackOrderModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(OrdersTrackOrderModal, _super);

    function OrdersTrackOrderModal() {
        return OrdersTrackOrderModal.__super__.constructor.call(this);
    }

    /**
    * HSN.OrdersTrackOrderModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    OrdersTrackOrderModal.prototype._show = function (url) {
        var scope = this;
        scope.AddLoadingSpinner();

        $.ajax(url, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                scope.RemoveLoadingSpinner();
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                scope.RemoveLoadingSpinner();
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return OrdersTrackOrderModal;
}(HSN.Modal);

/***/ }),

/***/ "mWkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.SoldOutModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.SoldOutModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(SoldOutModal, parent);

    var scope = this;

    function SoldOutModal() {
        /** new HSN.SoldOutModal() **/
        var modal = SoldOutModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeSoldOutModal(modal);
        });
        $(modal.Content).on('click', '#confirm', function () {
            closeSoldOutModal(modal);
            return false;
        });
    }

    function closeSoldOutModal(modal) {
        modal.Hide();
        $('html,body').animate({
            scrollTop: $('.soldout-items-container').offset().top
        }, 500);
    }

    /**
    * HSN.SoldOutModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    SoldOutModal.prototype._show = function () {
        var scope = this;
        var soldOutMessage = '<div class="sold-out-modal">';
        soldOutMessage += '<div class="module">';
        soldOutMessage += '<div class="title">you have great taste!</div>';
        soldOutMessage += '<div class="message">An item in your bag has just sold out! Save it for later to receive an alert when the item comes back.</div>';
        soldOutMessage += '<div class="message">If you continue through checkout, the sold out item will be removed from your bag.</div>';
        soldOutMessage += '<div id="confirm" class="submit-button main-button blue">OK</div>';
        soldOutMessage += '</div>';
        soldOutMessage += '</div>';
        scope.Root.removeClass('loading');
        scope.Content.showHtml(soldOutMessage, 0, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {});
    };
    return SoldOutModal;
}(HSN.Modal);

/***/ }),

/***/ "mqIx":
/***/ (function(module, exports) {

﻿/*!
** Unobtrusive Ajax support library for jQuery
** Copyright (C) Microsoft Corporation. All rights reserved.
*/

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global window: false, jQuery: false */

(function ($) {
    var data_click = "unobtrusiveAjaxClick",
        data_validation = "unobtrusiveValidation";

    function getFunction(code, argNames) {
        var fn = window, parts = (code || "").split(".");
        while (fn && parts.length) {
            fn = fn[parts.shift()];
        }
        if (typeof (fn) === "function") {
            return fn;
        }
        argNames.push(code);
        return Function.constructor.apply(null, argNames);
    }

    function isMethodProxySafe(method) {
        return method === "GET" || method === "POST";
    }

    function asyncOnBeforeSend(xhr, method) {
        if (!isMethodProxySafe(method)) {
            xhr.setRequestHeader("X-HTTP-Method-Override", method);
        }
    }

    function asyncOnSuccess(element, data, contentType) {
        var mode;

        if (contentType.indexOf("application/x-javascript") !== -1) {  // jQuery already executes JavaScript for us
            return;
        }

        mode = (element.getAttribute("data-ajax-mode") || "").toUpperCase();
        $(element.getAttribute("data-ajax-update")).each(function (i, update) {
            var top;

            switch (mode) {
                case "BEFORE":
                    top = update.firstChild;
                    $("<div />").html(data).contents().each(function () {
                        update.insertBefore(this, top);
                    });
                    break;
                case "AFTER":
                    $("<div />").html(data).contents().each(function () {
                        update.appendChild(this);
                    });
                    break;
                default:
                    $(update).html(data);
                    break;
            }
        });
    }

    function asyncRequest(element, options) {
        var confirm, loading, method, duration;

        confirm = element.getAttribute("data-ajax-confirm");
        if (confirm && !window.confirm(confirm)) {
            return;
        }

        loading = $(element.getAttribute("data-ajax-loading"));
        duration = element.getAttribute("data-ajax-loading-duration") || 0;

        $.extend(options, {
            type: element.getAttribute("data-ajax-method") || undefined,
            url: element.getAttribute("data-ajax-url") || undefined,
            beforeSend: function (xhr) {
                var result;
                asyncOnBeforeSend(xhr, method);
                result = getFunction(element.getAttribute("data-ajax-begin"), ["xhr"]).apply(this, arguments);
                if (result !== false) {
                    loading.show(duration);
                }
                return result;
            },
            complete: function () {
                loading.hide(duration);
                getFunction(element.getAttribute("data-ajax-complete"), ["xhr", "status"]).apply(this, arguments);
            },
            success: function (data, status, xhr) {
                asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
                getFunction(element.getAttribute("data-ajax-success"), ["data", "status", "xhr"]).apply(this, arguments);
            },
            error: getFunction(element.getAttribute("data-ajax-failure"), ["xhr", "status", "error"])
        });

        options.data.push({ name: "X-Requested-With", value: "XMLHttpRequest" });

        method = options.type.toUpperCase();
        if (!isMethodProxySafe(method)) {
            options.type = "POST";
            options.data.push({ name: "X-HTTP-Method-Override", value: method });
        }

        $.ajax(options);
    }

    function validate(form) {
        var validationInfo = $(form).data(data_validation);
        return !validationInfo || !validationInfo.validate || validationInfo.validate();
    }

    $(document).on("click", "a[data-ajax=true]", function (evt) {
        evt.preventDefault();
        asyncRequest(this, {
            url: this.href,
            type: "GET",
            data: []
        });
    });

    $(document).on("click", "form[data-ajax=true] input[type=image]", function (evt) {
        var name = evt.target.name,
            $target = $(evt.target),
            form = $target.parents("form")[0],
            offset = $target.offset();

        $(form).data(data_click, [
            { name: name + ".x", value: Math.round(evt.pageX - offset.left) },
            { name: name + ".y", value: Math.round(evt.pageY - offset.top) }
        ]);

        setTimeout(function () {
            $(form).removeData(data_click);
        }, 0);
    });

    $(document).on("click", "form[data-ajax=true] :submit", function (evt) {
        var name = evt.target.name,
            form = $(evt.target).parents("form")[0];

        $(form).data(data_click, name ? [{ name: name, value: evt.target.value }] : []);

        setTimeout(function () {
            $(form).removeData(data_click);
        }, 0);
    });

    $(document).on("submit", "form[data-ajax=true]", function (evt) {
        var clickInfo = $(this).data(data_click) || [];
        evt.preventDefault();
        if (!validate(this)) {
            return;
        }
        asyncRequest(this, {
            url: this.action,
            type: this.method || "GET",
            data: clickInfo.concat($(this).serializeArray())
        });
    });
}(jQuery));


/***/ }),

/***/ "neuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_cookies_js__ = __webpack_require__("rJIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_cookies_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Stuff used by Content


/**
* class HSN.WarrantyUpsellModal
*
* Encapsulates the functionality of a modal dialog that contains product warranty upsell.
**/
HSN.WarrantyUpsellModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(WarrantyUpsellModal, parent);

    function WarrantyUpsellModal(config) {
        /**
        * new HSN.WarrantyUpsellModal()
        **/
        var modal = WarrantyUpsellModal.__super__.constructor.call(this, 'warranty-upsell-modal');
        this.commerceService = HSN.Instance()._getCommerceService();
        this.name = 'HSN.WarrantyUpsellModal';

        this.Close.off();
        this.Close.removeClass('ir');
        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'Modal: HPP Upsell', 'HPPUpsellModal', 'HPP Upsell');

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Close', 'CloseButton');
            if (isExpressBuy(modal)) {
                window.location = window.location.protocol + '//' + window.location.hostname + '/checkout/order-review';
            } else {
                closeModal(modal);
            }
        });

        $(modal.Content).on('click', '.add-hpp-button', function () {
            var bagIdentity = $(this).data('bag-id');
            var bagItemId = $(this).data('bi-id');
            var warrantyItemId = $(this).data('warranty-id');
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Add', 'AddButton');

            HSN.SetWait();
            modal.commerceService.AddWarrantyToBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId, warrantyItemId: warrantyItemId }, {
                callback: function callback(data) {
                    HSN.RemoveWait();
                    if (data.success) {
                        modal.Refresh(bagItemId, isExpressBuy(modal));
                    } else {
                        HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to add the warranty, please try again.');
                    }
                }
            });
        });

        $(modal.Content).on('click', '.remove-hpp-button', function () {
            var bagIdentity = $(this).parent().data('bag-id');
            var bagItemId = $(this).parent().data('bi-id');
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Remove', 'RemoveButton');

            HSN.SetWait();
            modal.commerceService.RemoveWarrantyFromBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId }, {
                callback: function callback(data) {
                    HSN.RemoveWait();
                    if (data.success) {
                        modal.Refresh(bagItemId, isExpressBuy(modal));
                    } else {
                        HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to remove the warranty, please try again.');
                    }
                }
            });
        });

        $(modal.Content).on('click', '.continue-shopping', function () {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'ContinueShopping', 'ContinueShoppingButton');
            closeModal(modal);
        });

        $(modal.Content).on('click', '.proceed-to-checkout', function () {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Checkout', 'CheckoutButton');
            var path = isExpressBuy(modal) ? '/checkout/order-review' : '/checkout/bag';
            window.location = window.location.protocol + '//' + window.location.hostname + path;
        });

        $(modal.Content).on('keydown', '.proceed-to-checkout', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                $(modal.Close).focus();
            }
        });
    }

    function isExpressBuy(modal) {
        return $('.action-container.express', modal.Content).length > 0 ? true : false;
    }

    function isBagPage() {
        return $('#bag-template').length > 0;
    }

    function closeModal(modal) {
        if (isBagPage()) {
            window.location.reload();
        } else {
            modal.Hide();
        }
    }

    /**
        * HSN.WarrantyUpsellModal#Show() -> void
        * - productId (string): The identifier for the product to load the information into the modal for.
        *
        **/
    WarrantyUpsellModal.prototype._show = function (bagItemId, isExpressBuy, onAnimateCallback) {
        HSN.SetWait();
        $.ajax('/checkout/warranty-options/' + bagItemId, {
            context: this,
            cache: false,
            dataType: 'html',
            data: { isExpressBuy: isExpressBuy },
            success: function success(data) {
                HSN.RemoveWait();
                var scope = this;
                scope.Root.removeClass('loading');
                scope.DisplayContent(data, onAnimateCallback);
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                $('#modal-mask').remove();
                HSN.RemoveWait();
            }
        });
    };

    WarrantyUpsellModal.prototype.DisplayContent = function (htmlData, onAnimateCallback) {
        var scope = this;

        this.Content.showHtml(htmlData, 0, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
            if (typeof onAnimateCallback === 'function') {
                onAnimateCallback();
            }
        }, function () {});
    };
    return WarrantyUpsellModal;
}(HSN.Modal);

/***/ }),

/***/ "nsWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CancelOrderModal
*
* Encapsulates the functionality of a modal dialog that cancels an order.
**/
HSN.CancelOrderModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CancelOrderModal, parent);

    function CancelOrderModal() {
        /** new HSN.CancelOrderModal() **/
        var modal = CancelOrderModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        var scope = modal;
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
        $(modal.Content).on('click', '#yes-cancel', function () {
            HSN.SetWait();
            var cancelReason = $('.cancel-reason', modal.Content).val();
            scope.accountService.CancelOrder({ orderIdentity: scope.orderIdentity, cancelReason: cancelReason }, {
                callback: function callback(data) {
                    if (data.success) {
                        if (scope.cancelCallback) {
                            HSN.RemoveWait();
                            closeModal(modal);
                            scope.cancelCallback();
                        } else {
                            window.location.reload();
                        }
                    } else {
                        HSN.HandleAjaxError(modal.Content, data, 'Unfortunately there was an error cancelling your order, please try again.');
                    }
                },
                errorCallback: function errorCallback() {
                    HSN.RemoveWait();
                    alert('Unfortunately there was an error cancelling your order, please try again.');
                },
                scope: this
            });
            return false;
        });
        $(modal.Content).on('click', '#no-cancel', function () {
            closeModal(modal);
            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.CancelOrderModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    CancelOrderModal.prototype._show = function (config) {
        var scope = this;

        scope.productTopLine = config.productTopLine;
        scope.showPromoCancelMessage = config.showPromoCancelMessage;
        scope.isAutoshipOrder = config.isAutoshipOrder;
        scope.orderIdentity = config.orderIdentity;
        scope.cancelCallback = config.cancelCallback;

        var modalContent = '<div class="account-container cancel-modal">';
        modalContent += '<div class="module">';
        modalContent += '<div class="header">ARE YOU SURE?</div>';
        modalContent += '<div class="description">Do you want to remove the <strong>' + scope.productTopLine + '</strong> from your order?</div>';
        if (scope.showPromoCancelMessage) {
            modalContent += '<div class="promo-description">Cancellation may disqualify your savings on a previous order. </div>';
        }
        if (scope.isAutoshipOrder) {
            modalContent += '<label for="cancel-reason">Please select your reason for canceling</label>';
            modalContent += '<select id="cancel-reason" class="cancel-reason" name="cancelReason">';
            modalContent += '<option>Choose a reason</option>';
            modalContent += '<option value="OrderedWrongItem">I ordered the wrong item</option>';
            modalContent += '<option value="ChangedMind">I\'ve changed my mind</option>';
            modalContent += '<option value="CoordinatingItemSoldOut">The coordinating item sold out</option>';
            modalContent += '<option value="UnsatisfiedExperience">I\'m not satisfied with my HSN experience</option>';
            modalContent += '<option value="Other">other</option>';
            modalContent += '</select>';
        }
        modalContent += '<div id="yes-cancel" class="submit-button main-button blue">YES, CANCEL ITEM</div>';
        modalContent += '<div id="no-cancel" class="submit-button main-button white">NO, DO NOT CANCEL</div>';
        modalContent += '</div>';
        modalContent += '</div>';

        scope.Root.removeClass('loading');
        scope.Content.showHtml(modalContent, 0, function () {
            scope.Center();
            scope.Content.animate({ opacity: 1 });
        }, function () {});

        HSN.DataLayer.helpers.elementInteraction(null, "Modal", "Cancel Item");
    };
    return CancelOrderModal;
}(HSN.Modal);

/***/ }),

/***/ "opxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_CookieAccessor_js__ = __webpack_require__("SLxZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_CookieAccessor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_CookieAccessor_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.AccountNavigation
    *
    * Encapsulates the functionality of the HSN account bar across the top of the
    * page and exposes methods to manipulate and update its contents.
    **/
HSN.AccountNavigation = function (config) {
    /**
        * new HSN.AccountNavigation(config)
        * - config (Object): A configuration object for the [[HSN.AccountNavigation]]
        *   consisting of the following keys:
        *   - cabinet (HSN.AccountNavigation.Cabinet): The [[HSN.AccountNavigation.Cabinet]] instance that will exist within this [[HSN.AccountNavigation]].
        *   - container (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element to act as the root container for the [[HSN.AccountNavigation]].
        *   - drawerParent (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element to act as the root container provided [[HSN.AccountNavigation.Cabinet]].
        *   - account (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the account link.
        *   - signin (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the signin link.
        *   - noajax (boolean | value | jQuery): A boolean value to indicate whether the loaded account navigation can make use of ajax functionality.
        **/
    config = config = config || {};
    this.noAjax = config.noajax;
    this.noUpdateState = config.noUpdateState;
    this.Container = $(config.container);
    this.DrawerParent = $(config.drawerParent);

    this.Cabinet = config.cabinet;

    this.AccountListItem = $(config.account);
    this.WelcomeListItem = $(config.welcome);
    this.SignInListItem = $(config.signin);
    this.SignOutListItem = $(config.signout);
    this.AlertListItem = $(config.alert);
    this.AlertCount = $(config.alertCount);
    this.CustomerStateEnum = {
        COLD: 0,
        WARM: 1,
        HOT: 2
    };
    this.CustomerState = 0;

    if (!this.noUpdateState) {
        this.UpdateState();
    }

    this.Cabinet.Root.hide();
    this.DrawerParent.append(this.Cabinet.Root);
};
HSN.AccountNavigation.prototype = {
    _application: null,
    noAjax: null,
    Cabinet: null,
    AccountListItem: null,
    WelcomeListItem: null,
    SignInListItem: null,
    SignOutListItem: null,
    AlertListItem: null,
    AlertCount: null,

    /**
        * HSN.AccountNavigation#UpdateState -> void
        *
        * Updates the state of the [[HSN.AccountNavigation]]'s information and
        * display with data retrieved from the payload service such as
        *  - The visitor's name
        *  - Whether the visitor is signed in or not
        *  - The number of alerts the visitor has
        *  - The number of items in the visitors bag
        **/
    UpdateState: function UpdateState() {
        if (this.noAjax || HSN.GetHsnArcadeObjectName() !== null) {
            this.SetAuthenticatedState(false);
            this.Container.animate({ opacity: 1 });
        } else {
            var offerLocations = [];
            $("[offer-location]").each(function () {
                offerLocations.push($(this).attr('offer-location'));
            });
            var ifFromIframe = this.FromIframe();
            $.ajax("/account/status", {
                context: this,
                dataType: 'json',
                cache: false,
                data: {
                    offerLocations: offerLocations,
                    ifFromIframe: ifFromIframe
                },
                traditional: true,
                success: function success(data, status, xhr) {
                    this._application.Events.Trigger(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_COMPLETE, data);
                    HSN.SetBagIconCount(data.bagItems);
                    this.SetServerTime(data.serverTime);
                    this.SetCustomerState(data.custState);
                    this.SetAuthenticatedState(data.isAuthenticated, data.name);
                    this.SetNewSession(data.session);
                    this.Container.animate({ opacity: 1 });
                    if (data.displayEmailCapture) {
                        this.ShowEmailCapture(data.emailCaptureMethod);
                    }

                    if (data.customerOffers) {
                        this.DisplayCustomerOffers(data.customerOffers);
                    }

                    if (data.showKashModal) {
                        this.ShowKashModal();
                    }

                    if (data.showMarketingDrawer) {
                        var refToken = HSN.Instance().GetQueryStringParam(window.location.search, 'cm_mmc');
                        if (refToken.toUpperCase().indexOf('AFFILIATEPARTNER-_-UNIVISION') == 0) {
                            HSN.Instance().AccountNavigation.Cabinet.Open(new HSN.AccountNavigation.Cabinet.Drawer({ identifier: 'first-time-visit', url: '/firsttimevisit' }));
                        }
                    }

                    if (data.isCountryCa) {
                        this.SetServerCountry(data.isCountryCa);
                    }

                    if (sessionStorage["customerState"] != data.custState || location.pathname.toLowerCase() == "/profile") {
                        this.ClearSessionFavoriteData();
                    }

                    sessionStorage["customerState"] = data.custState;

                    HSN.Instance().SetAccountStatusData(data);
                }
            });
            $.ajax("/account/status-detail", {
                context: this,
                dataType: 'json',
                cache: false,
                data: {},
                traditional: true,
                success: function success(data, status, xhr) {
                    this._application.Events.Trigger(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_DETAIL_COMPLETE, data);
                    HSN.Instance().SetAccountStatusDetailData(data);

                    HSN.Bazaarvoice.SetPageMetaTag(data.BazaarVoiceUasToken);
                    HSN.OnAdobeTargetLoad(function () {
                        setTimeout(HSN.Bazaarvoice.Load, 250);
                    });
                },
                error: function error() {
                    HSN.OnAdobeTargetLoad(function () {
                        setTimeout(HSN.Bazaarvoice.Load, 250);
                    });
                }
            });
        }
    },
    FromIframe: function FromIframe() {
        try {
            return window.self != window.top;
        } catch (e) {
            return true;
        }
    },
    ShowKashModal: function ShowKashModal() {
        $.ajax("/account/kashreminder/check", {
            context: this,
            dataType: 'json',
            timeout: 5000,
            success: function success(data, status, xhr) {
                if (data.HasKash) {
                    HSN.Instance().GetKashReminderModal().Show(data.KashAmt);
                }
            }
        });
    },

    ShowEmailCapture: function ShowEmailCapture() {
        HSN.Instance().GetEmailCaptureModal().Show();
    },

    SetServerTime: function SetServerTime(time) {
        if (!this.noAjax) {
            if (time) {
                $('#server-name').data('time', time);
            }
        }
    },

    SetServerCountry: function SetServerCountry(country) {
        if (country) {
            $('#server-name').attr('is-country-ca', 'true');
        }
    },

    /**
        * HSN.AccountNavigation#SetNewSession(session) -> void
        * - session (String): The cust_ID of the new session - or null;
        *
        * Throws core metrics registration call
        **/
    SetNewSession: function SetNewSession(session) {
        if (session != "") {
            if (typeof cG7 != 'undefined') {
                cmCreateRegistrationTag(session, '', '', '', '', '', '');
            } else {
                HSN.Instance().Events.On(HSN.Application.EVENT.CM_LOADED, function () {
                    cmCreateRegistrationTag(session, '', '', '', '', '', '');
                });
            }
        }
    },

    /**
        * HSN.AccountNavigation#SetApplicationInstance(application) -> void
        * - application (HSN.Application): The [[HSN.Application]] instance this [[HSN.AccountNavigation]] should coordinate with.
        *
        * Sets the [[HSN.Application]] instance this [[HSN.AccountNavigation]] should coordinate with for events
        * and other interactions.
        **/
    SetApplicationInstance: function SetApplicationInstance(application) {
        this._application = application;
        this._application.Events.On(HSN.Application.EVENT.VISITOR_AUTHENTICATED, function () {
            this.UpdateState();
        }, this);
    },

    /**
        * HSN.AccountNavigation#SetAuthenticatedState(isAuthenticated) -> void
        * - isAuthenticated (Boolean): Whether or not the visitor is authenticated.
        *
        * Set's the state of the account navigation to display information
        * conditionally based on the new value of whether the visitor is
        * authenticated.
        **/
    SetAuthenticatedState: function SetAuthenticatedState(isAuthenticated, name) {
        var custState = this.GetCustomerState();
        this.AccountListItem[isAuthenticated || custState == this.CustomerStateEnum.WARM ? 'show' : 'hide']();
        this.SignOutListItem[isAuthenticated || custState == this.CustomerStateEnum.WARM ? 'show' : 'hide']();
        this.SignInListItem[isAuthenticated || custState == this.CustomerStateEnum.WARM ? 'hide' : 'show']();
        this.WelcomeListItem[isAuthenticated || custState == this.CustomerStateEnum.WARM ? 'hide' : 'show']();

        if (this.SignOutListItem && (isAuthenticated || this.GetCustomerState() == this.CustomerStateEnum.WARM)) {
            var displayName = name && name.length > 15 ? name.substring(0, 15) : name;
            $('#utility-nav-signout span').html("Hello, " + displayName);
        }
    },

    /**
        * HSN.AccountNavigation#DisplayCustomerPromotions(promotions) -> void
        * Overrides content areas with possible customer specific promotions
    **/
    DisplayCustomerOffers: function DisplayCustomerOffers(offers) {
        this._application.DisplayCustomerOffers(offers);
    },
    /**
    * HSN.AccountNavigation#SetCustomerState(state) -> void
    * - state (number): the state the customer is in : cold: 0, warm: 1, hot: 2
    *
    * Sets the state the customer is in : cold: 0, warm: 1, hot: 2
    **/
    SetCustomerState: function SetCustomerState(state) {
        this.CustomerState = state;
    },

    /**
    * HSN.AccountNavigation#GetCustomerState(state) -> void
    * returns the state the customer
    **/
    GetCustomerState: function GetCustomerState() {
        return this.CustomerState;
    },

    ClearSessionFavoriteData: function ClearSessionFavoriteData() {
        if (Modernizr.sessionstorage) {
            sessionStorage.removeItem("hasCheckedFavorites");
            //remove favorited products...
            for (var key in sessionStorage) {
                if (key.indexOf('fav-') == 0) {
                    sessionStorage.removeItem(key);
                }
            }
        }
    }

};
/**
    * HSN.AccountNavigation.EVENT = Object
    *
    * An enumeration of events an [[HSN.AccountNavigation]] can raise:
    * - ACCOUNT_STATUS_COMPLETE: Fires when account status is complete.
    **/
HSN.AccountNavigation.EVENT = {
    ACCOUNT_STATUS_COMPLETE: 'HSN.AccountNavigation:ACCOUNT_STATUS_COMPLETE',
    ACCOUNT_STATUS_DETAIL_COMPLETE: 'HSN.AccountNavigation:ACCOUNT_STATUS_DETAIL_COMPLETE'
};

/***/ }),

/***/ "ouuF":
/***/ (function(module, exports) {

﻿/**
 * browser-deeplink v0.1
 *
 * Author: Hampus Ohlsson, Nov 2014
 * GitHub: https://github.com/hampusohlsson/browser-deeplink
 *
 * MIT License
 */

(function (root, factory) {
    root["deeplink"] = factory(root);
})(window || this, function (root) {
    "use strict";   

    /**
     * Cannot run without DOM or user-agent
     */
    if (!root.document || !root.navigator) {
        return;
    }

    /**
     * Set up scope variables and settings
     */
    var timeout;
    var settings = {};
    var defaults = {
        iOS: {},
        android: {},
        amazon: {},
        fallback: true,
        delay: 1000,
        delta: 500
    }

    /**
     * Merge defaults with user options
     * @private
     * @param {Object} defaults Default settings
     * @param {Object} options User options
     * @returns {Object} Merged values of defaults and options
     */
    var extend = function (defaults, options) {
        var extended = {};
        for (var key in defaults) {
            extended[key] = defaults[key];
        };
        for (var key in options) {
            extended[key] = options[key];
        };
        return extended;
    };

    /**
     * Generate the app store link for iOS / Apple app store
     *
     * @private
     * @returns {String} App store itms-apps:// link 
     */
    var getStoreURLiOS = function () {
        var baseurl = "itms-apps://itunes.apple.com/app/";
        var name = settings.iOS.appName;
        var id = settings.iOS.appId;
        return (id && name) ? (baseurl + name + "/id" + id + "?mt=8") : null;
    }

    /**
     * Generate the app store link for Google Play
     *
     * @private
     * @returns {String} Play store https:// link
     */
    var getStoreURLAndroid = function () {
        var baseurl = "market://details?id=";
        var id = settings.android.appId;
        return id ? (baseurl + id) : null;
    }

    /**
     * Generate the app store link for Amazon
     *
     * @private
     * @returns {String} Amazon store link
     */
    var getStoreURLAmazon = function () {
        var baseurl = "amzn://apps/android?";
        var id = settings.amazon.appId;
        return id ? (baseurl + "?p=" + id) : null;
    }

    /**
     * Get app store link, depending on the current platform
     *
     * @private
     * @returns {String} url
     */
    var getStoreLink = function () {
        var linkmap = {
            "ios": settings.iOS.storeUrl || getStoreURLiOS(),
            "android": settings.android.storeUrl || getStoreURLAndroid(),
            "amazon": settings.amazon.storeUrl || getStoreURLAmazon(),
        }

        return linkmap[settings.platform];
    }

    /**
     * Check if the user-agent is Android
     *
     * @private
     * @returns {Boolean} true/false
     */
    var isAndroid = function () {
        return navigator.userAgent.match('Android');
    }

    /**
     * Check if the user-agent is iPad/iPhone/iPod
     *
     * @private
     * @returns {Boolean} true/false
     */
    var isIOS = function () {
        return navigator.userAgent.match('iPad') ||
               navigator.userAgent.match('iPhone') ||
               navigator.userAgent.match('iPod');
    }

    /**
     * Check if the user-agent is Kindle
     *
     * @private
     * @returns {Boolean} true/false
     */
    var isKindle = function () {
        return (navigator.userAgent.match(/\bSilk\/(.*\bMobile Safari\b)?/) ||
                navigator.userAgent.match(/\bKF\w/) ||
                navigator.userAgent.match('Kindle Fire'));
    }

    /**
     * Check if the user is on mobile
     *
     * @private
     * @returns {Boolean} true/false
     */
    var isMobile = function () {
        return isAndroid() || isIOS() || isKindle();
    }

    /**
     * Timeout function that tries to open the app store link.
     * The time delta comparision is to prevent the app store
     * link from opening at a later point in time. E.g. if the 
     * user has your app installed, opens it, and then returns 
     * to their browser later on.
     *
     * @private
     * @param {Integer} Timestamp when trying to open deeplink
     * @returns {Function} Function to be executed by setTimeout
     */
    var openAppStore = function (ts) {
        return function () {
            var link = getStoreLink();
            var wait = settings.delay + settings.delta;
            if (typeof link === "string" && (Date.now() - ts) < wait) {
                window.location.href = link;
            }
        }
    }

    /**
     * The setup() function needs to be run before deeplinking can work,
     * as you have to provide the iOS and/or Android settings for your app.
     *
     * @public
     * @param {object} setup options
     */
    var setup = function (options) {
        settings = extend(defaults, options);

        if (isAndroid()) settings.platform = "android";
        if (isIOS()) settings.platform = "ios";
        if (isKindle()) settings.platform = "amazon";
    }

    /**
     * Tries to open your app URI through a hidden iframe.
     *
     * @public
     * @param {String} Deeplink URI
     */
    var open = function (uri) {
        if (!isMobile()) {
            return;
        }

        if (isAndroid() && !navigator.userAgent.match(/Firefox/) && !isKindle()) {
            var matches = uri.match(/([^:]+):\/\/(.+)$/i);
            uri = "intent://" + matches[2] + "#Intent;scheme=" + matches[1];
            uri += ";package=" + settings.android.appId + ";end";
        }

        if (settings.fallback) {
            timeout = setTimeout(openAppStore(Date.now()), settings.delay);
        }

        var iframe = document.createElement("iframe");
        iframe.onload = function () {
            clearTimeout(timeout);
            iframe.parentNode.removeChild(iframe);
            window.location.href = uri;
        };

        iframe.src = uri;
        iframe.setAttribute("style", "display:none;");
        document.body.appendChild(iframe);
    }

    // Public API
    return {
        setup: setup,
        open: open
    };

});

/***/ }),

/***/ "oxdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ArticleModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.ArticleModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ArticleModal, _super);

    EVENT: {
        ARTICLE_MODAL_READY: 'HSN.ArticleModal.ARTICLE_MODAL_READY';
    }

    /**
    * new HSN.ArticleModal()
    **/
    function ArticleModal() {
        this.elementName = '#';
        this.name = 'HSN.ArticleModal';

        return ArticleModal.__super__.constructor.call(this);
    }

    ArticleModal.prototype._hide = function () {};

    /**
    * HSN.ArticleModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ArticleModal.prototype._show = function (url, callback) {
        var __scope = this;

        $.ajax(url, {
            dataType: 'html',
            success: function success(data, status, xhr) {
                __scope.Root.removeClass('loading');
                data += '<div class="endOfModal" tabindex="0"></div>';
                __scope.DisplayModal(data, 0);

                if (callback) callback();

                $('#modalPopup').on('focus', function () {
                    $('.modal-content-container').focus();
                });
                $('.endOfModal').on('focus', function () {
                    $('#closeModal').focus();
                });
                $('.endOfModal', __scope.Content).on('keydown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    __scope.Close.focus();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    ArticleModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time, function () {
            var elemetToFocus = __scope.Root.find('#modalPopup');
            __scope.Center();
            __scope.Content.animate({ opacity: 1 }, function () {
                __scope.SetFocus(elemetToFocus);
            });
        }, function () {
            //__scope.Center();
        });
    };

    return ArticleModal;
}(HSN.Modal);

/***/ }),

/***/ "q/Az":
/***/ (function(module, exports) {

﻿/*!
** Unobtrusive validation support library for jQuery and jQuery Validate
** Copyright (C) Microsoft Corporation. All rights reserved.
*/

/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
/*global document: false, jQuery: false */

(function ($) {
    var $jQval = $.validator,
        adapters,
        data_validation = "unobtrusiveValidation";

    function setValidationValues(options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) {
            options.messages[ruleName] = options.message;
        }
    }

    function splitAndTrim(value) {
        return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
    }

    function escapeAttributeValue(value) {
        // As mentioned on https://api.jquery.com/category/selectors/
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
    }

    function getModelPrefix(fieldName) {
        return fieldName.substr(0, fieldName.lastIndexOf(".") + 1);
    }

    function appendModelPrefix(value, prefix) {
        if (value.indexOf("*.") === 0) {
            value = value.replace("*.", prefix);
        }
        return value;
    }

    function onError(error, inputElement) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
            replaceAttrValue = container.attr("data-valmsg-replace"),
            replace = replaceAttrValue ? JSON.parse(replaceAttrValue) !== false : null;

        container.removeClass("field-validation-valid").addClass("field-validation-error");
        error.data("unobtrusiveContainer", container);

        if (replace) {
            container.empty();
            error.removeClass("input-validation-error").appendTo(container);
        }
        else {
            error.hide();
        }
    }

    function onErrors(event, validator) {  // 'this' is the form element
        var container = $(this).find("[data-valmsg-summary=true]"),
            list = container.find("ul");

        if (list && list.length && validator.errorList.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");

            $.each(validator.errorList, function () {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }

    function onSuccess(error) {  // 'this' is the form element
        var container = error.data("unobtrusiveContainer"),
            replaceAttrValue = container.attr("data-valmsg-replace"),
            replace = replaceAttrValue ? JSON.parse(replaceAttrValue) : null;

        if (container) {
            container.addClass("field-validation-valid").removeClass("field-validation-error");
            error.removeData("unobtrusiveContainer");

            if (replace) {
                container.empty();
            }
        }
    }

    function onReset() {  // 'this' is the form element
        var $form = $(this);
        $form.data("validator").resetForm();
        $form.find(".validation-summary-errors")
            .addClass("validation-summary-valid")
            .removeClass("validation-summary-errors");
        $form.find(".field-validation-error")
            .addClass("field-validation-valid")
            .removeClass("field-validation-error")
            .removeData("unobtrusiveContainer")
            .find("*")  // If we were using valmsg-replace, get the underlying error
                .removeData("unobtrusiveContainer");
    }

    function validationInfo(form) {
        var $form = $(form),
            result = $form.data(data_validation),
            onResetProxy = $.proxy(onReset, form);

        if (!result) {
            result = {
                options: {  // options structure passed to jQuery Validate's validate() method
                    errorClass: "input-validation-error",
                    errorElement: "span",
                    errorPlacement: $.proxy(onError, form),
                    invalidHandler: $.proxy(onErrors, form),
                    messages: {},
                    rules: {},
                    success: $.proxy(onSuccess, form)
                },
                attachValidation: function () {
                    $form
                        .off("reset." + data_validation, onResetProxy)
                        .on("reset." + data_validation, onResetProxy)
                        .validate(this.options);
                },
                validate: function () {  // a validation function that is called by unobtrusive Ajax
                    $form.validate();
                    return $form.valid();
                }
            };
            $form.data(data_validation, result);
        }

        return result;
    }

    $jQval.unobtrusive = {
        adapters: [],

        parseElement: function (element, skipAttach) {
            /// <summary>
            /// Parses a single HTML element for unobtrusive validation attributes.
            /// </summary>
            /// <param name="element" domElement="true">The HTML element to be parsed.</param>
            /// <param name="skipAttach" type="Boolean">[Optional] true to skip attaching the
            /// validation to the form. If parsing just this single element, you should specify true.
            /// If parsing several elements, you should specify false, and manually attach the validation
            /// to the form when you are finished. The default is false.</param>
            var $element = $(element),
                form = $element.parents("form")[0],
                valInfo, rules, messages;

            if (!form) {  // Cannot do client-side validation without a form
                return;
            }

            valInfo = validationInfo(form);
            valInfo.options.rules[element.name] = rules = {};
            valInfo.options.messages[element.name] = messages = {};

            $.each(this.adapters, function () {
                var prefix = "data-val-" + this.name,
                    message = $element.attr(prefix),
                    paramValues = {};

                if (message !== undefined) {  // Compare against undefined, because an empty message is legal (and falsy)
                    prefix += "-";

                    $.each(this.params, function () {
                        paramValues[this] = $element.attr(prefix + this);
                    });

                    this.adapt({
                        element: element,
                        form: form,
                        message: message,
                        params: paramValues,
                        rules: rules,
                        messages: messages
                    });
                }
            });

            $.extend(rules, { "__dummy__": true });

            if (!skipAttach) {
                valInfo.attachValidation();
            }
        },

        parse: function (selector) {
            /// <summary>
            /// Parses all the HTML elements in the specified selector. It looks for input elements decorated
            /// with the [data-val=true] attribute value and enables validation according to the data-val-*
            /// attribute values.
            /// </summary>
            /// <param name="selector" type="String">Any valid jQuery selector.</param>
            var $forms = $(selector)
                .parents("form")
                .addBack()
                .add($(selector).find("form"))
                .filter("form");

            $(selector).find(":input[data-val=true]").each(function () {
                $jQval.unobtrusive.parseElement(this, true);
            });

            $forms.each(function () {
                var info = validationInfo(this);
                if (info) {
                    info.attachValidation();
                }
            });
        }
    };

    adapters = $jQval.unobtrusive.adapters;

    adapters.add = function (adapterName, params, fn) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="params" type="Array" optional="true">[Optional] An array of parameter names (strings) that will
        /// be extracted from the data-val-nnnn-mmmm HTML attributes (where nnnn is the adapter name, and
        /// mmmm is the parameter name).</param>
        /// <param name="fn" type="Function">The function to call, which adapts the values from the HTML
        /// attributes into jQuery Validate rules and/or messages.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        if (!fn) {  // Called with no params, just a function
            fn = params;
            params = [];
        }
        this.push({ name: adapterName, params: params, adapt: fn });
        return this;
    };

    adapters.addBool = function (adapterName, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has no parameter values.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, function (options) {
            setValidationValues(options, ruleName || adapterName, true);
        });
    };

    adapters.addMinMax = function (adapterName, minRuleName, maxRuleName, minMaxRuleName, minAttribute, maxAttribute) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation has three potential rules (one for min-only, one for max-only, and
        /// one for min-and-max). The HTML parameters are expected to be named -min and -max.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="minRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a minimum value.</param>
        /// <param name="maxRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a maximum value.</param>
        /// <param name="minMaxRuleName" type="String">The name of the jQuery Validate rule to be used when you
        /// have both a minimum and maximum value.</param>
        /// <param name="minAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the minimum value. The default is "min".</param>
        /// <param name="maxAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the maximum value. The default is "max".</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [minAttribute || "min", maxAttribute || "max"], function (options) {
            var min = options.params.min,
                max = options.params.max;

            if (min && max) {
                setValidationValues(options, minMaxRuleName, [min, max]);
            }
            else if (min) {
                setValidationValues(options, minRuleName, min);
            }
            else if (max) {
                setValidationValues(options, maxRuleName, max);
            }
        });
    };

    adapters.addSingleVal = function (adapterName, attribute, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has a single value.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute(where nnnn is the adapter name).</param>
        /// <param name="attribute" type="String">[Optional] The name of the HTML attribute that contains the value.
        /// The default is "val".</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [attribute || "val"], function (options) {
            setValidationValues(options, ruleName || adapterName, options.params[attribute]);
        });
    };

    $jQval.addMethod("__dummy__", function (value, element, params) {
        return true;
    });

    $jQval.addMethod("regex", function (value, element, params) {
        var match;
        if (this.optional(element)) {
            return true;
        }

        match = new RegExp(params).exec(value);
        return (match && (match.index === 0) && (match[0].length === value.length));
    });

    $jQval.addMethod("nonalphamin", function (value, element, nonalphamin) {
        var match;
        if (nonalphamin) {
            match = value.match(/\W/g);
            match = match && match.length >= nonalphamin;
        }
        return match;
    });

    adapters.addSingleVal("accept", "exts").addSingleVal("regex", "pattern");
    adapters.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");
    adapters.addMinMax("length", "minlength", "maxlength", "rangelength").addMinMax("range", "min", "max", "range");
    adapters.add("equalto", ["other"], function (options) {
        var prefix = getModelPrefix(options.element.name),
            other = options.params.other,
            fullOtherName = appendModelPrefix(other, prefix),
            element = $(options.form).find(":input[name='" + escapeAttributeValue(fullOtherName) + "']")[0];

        setValidationValues(options, "equalTo", element);
    });
    adapters.add("required", function (options) {
        // jQuery Validate equates "required" with "mandatory" for checkbox elements
        if (options.element.tagName.toUpperCase() !== "INPUT" || options.element.type.toUpperCase() !== "CHECKBOX") {
            setValidationValues(options, "required", true);
        }
    });
    adapters.add("remote", ["url", "type", "additionalfields"], function (options) {
        var value = {
            url: options.params.url,
            type: options.params.type || "GET",
            data: {}
        },
            prefix = getModelPrefix(options.element.name);

        $.each(splitAndTrim(options.params.additionalfields || options.element.name), function (i, fieldName) {
            var paramName = appendModelPrefix(fieldName, prefix);
            value.data[paramName] = function () {
                return $(options.form).find(":input[name='" + escapeAttributeValue(paramName) + "']").val();
            };
        });

        setValidationValues(options, "remote", value);
    });
    adapters.add("password", ["min", "nonalphamin", "regex"], function (options) {
        if (options.params.min) {
            setValidationValues(options, "minlength", options.params.min);
        }
        if (options.params.nonalphamin) {
            setValidationValues(options, "nonalphamin", options.params.nonalphamin);
        }
        if (options.params.regex) {
            setValidationValues(options, "regex", options.params.regex);
        }
    });

    $(function () {
        $jQval.unobtrusive.parse(document);
    });
}(jQuery));


/***/ }),

/***/ "qBtQ":
/***/ (function(module, exports) {

﻿/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt https://joe.sh
* Released under the WTFPL license
* https://sam.zoy.org/wtfpl/
*/

(function () {
    /**
     * Clamps a text node.
     * @param {HTMLElement} element. Element containing the text node to clamp.
     * @param {Object} options. Options to pass to the clamper.
     */
    function clamp(element, options) {
        options = options || {};

        var self = this,
            win = window,
            opt = {
                clamp: options.clamp || 2,
                useNativeClamp: typeof (options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
                splitOnChars: options.splitOnChars || ['', '.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
                animate: options.animate || false,
                truncationChar: options.truncationChar || '…',
                truncationHTML: options.truncationHTML
            },

            sty = element.style,
            originalText = element.innerHTML,

            supportsNativeClamp = typeof (element.style.webkitLineClamp) != 'undefined',
            clampValue = opt.clamp,
            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
            truncationHTMLContainer;

        if (opt.truncationHTML) {
            truncationHTMLContainer = document.createElement('span');
            truncationHTMLContainer.innerHTML = opt.truncationHTML;
        }


        // UTILITY FUNCTIONS __________________________________________________________

        /**
         * Return the current style for an element.
         * @param {HTMLElement} elem The element to compute.
         * @param {string} prop The style property.
         * @returns {number}
         */
        function computeStyle(elem, prop) {
            if (!win.getComputedStyle) {
                win.getComputedStyle = function (el, pseudo) {
                    this.el = el;
                    this.getPropertyValue = function (prop) {
                        var re = /(\-([a-z]){1})/g;
                        if (prop == 'float') prop = 'styleFloat';
                        if (re.test(prop)) {
                            prop = prop.replace(re, function () {
                                return arguments[2].toUpperCase();
                            });
                        }
                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                    }
                    return this;
                }
            }

            return win.getComputedStyle(elem, null).getPropertyValue(prop);
        }

        /**
         * Returns the maximum number of lines of text that should be rendered based
         * on the current height of the element and the line-height of the text.
         */
        function getMaxLines(height) {
            var availHeight = height || element.clientHeight,
                lineHeight = getLineHeight(element);

            return Math.max(Math.floor(availHeight / lineHeight), 0);
        }

        /**
         * Returns the maximum height a given element should have based on the line-
         * height of the text and the given clamp value.
         */
        function getMaxHeight(clmp) {
            var lineHeight = getLineHeight(element);
            return lineHeight * clmp;
        }

        /**
         * Returns the line-height of an element as an integer.
         */
        function getLineHeight(elem) {
            var lh = computeStyle(elem, 'line-height');
            if (lh == 'normal') {
                // Normal line heights vary from browser to browser. The spec recommends
                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                lh = parseInt(computeStyle(elem, 'font-size')) * 1.1;
            }
            return parseInt(lh);
        }


        // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
        var splitOnChars = opt.splitOnChars.slice(0),
            splitChar = splitOnChars[0],
            chunks,
            lastChunk;

        /**
         * Gets an element's last child. That may be another node or a node's contents.
         */
        function getLastChild(elem) {
            //Current element has children, need to go deeper and get last child as a text node
            if (elem.lastChild && elem.lastChild.children && elem.lastChild.children.length > 0) {
                return getLastChild(Array.prototype.slice.call(elem.children).pop());
            }
                //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
                elem.lastChild.parentNode.removeChild(elem.lastChild);
                return getLastChild(elem);
            }
                //This is the last child we want, return it
            else {
                return elem.lastChild;
            }
        }

        /**
         * Removes one character at a time from the text until its width or
         * height is beneath the passed-in max param.
         */
        function truncate(target, maxHeight) {
            if (!maxHeight) { return; }

            /**
             * Resets global variables.
             */
            function reset() {
                splitOnChars = opt.splitOnChars.slice(0);
                splitChar = splitOnChars[0];
                chunks = null;
                lastChunk = null;
            }

            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

            //Grab the next chunks
            if (!chunks) {
                //If there are more characters to try, grab the next one
                if (splitOnChars.length > 0) {
                    splitChar = splitOnChars.shift();
                }
                    //No characters to chunk by. Go character-by-character
                else {
                    splitChar = '';
                }

                chunks = nodeValue.split(splitChar);
            }

            //If there are chunks left to remove, remove the last one and see if
            // the nodeValue fits.
            if (chunks.length > 1) {
                // console.log('chunks', chunks);
                lastChunk = chunks.pop();
                // console.log('lastChunk', lastChunk);
                applyEllipsis(target, chunks.join(splitChar));
            }
                //No more chunks can be removed using this character
            else {
                chunks = null;
            }

            //Insert the custom HTML before the truncation character
            if (truncationHTMLContainer) {
                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
            }

            //Search produced valid chunks
            if (chunks) {
                //It fits
                if (element.clientHeight <= maxHeight) {
                    //There's still more characters to try splitting on, not quite done yet
                    if (splitOnChars.length >= 0 && splitChar != '') {
                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                        chunks = null;
                    }
                        //Finished!
                    else {
                        return element.innerHTML;
                    }
                }
            }
                //No valid chunks produced
            else {
                //No valid chunks even when splitting by letter, time to move
                //on to the next node
                if (splitChar == '') {
                    applyEllipsis(target, '');
                    target = getLastChild(element);

                    reset();
                }
            }

            //If you get here it means still too big, let's keep truncating
            if (opt.animate) {
                setTimeout(function () {
                    truncate(target, maxHeight);
                }, opt.animate === true ? 10 : opt.animate);
            }
            else {
                return truncate(target, maxHeight);
            }
        }

        function applyEllipsis(elem, str) {
            elem.nodeValue = str + opt.truncationChar;
        }


        // CONSTRUCTOR ________________________________________________________________

        if (clampValue == 'auto') {
            clampValue = getMaxLines();
        }
        else if (isCSSValue) {
            clampValue = getMaxLines(parseInt(clampValue));
        }

        var clampedText;
        if (supportsNativeClamp && opt.useNativeClamp) {
            sty.overflow = 'hidden';
            sty.textOverflow = 'ellipsis';
            sty.webkitBoxOrient = 'vertical';
            sty.display = '-webkit-box';
            sty.webkitLineClamp = clampValue;

            if (isCSSValue) {
                sty.height = opt.clamp + 'px';
            }
        }
        else {
            var height = getMaxHeight(clampValue);
            if (height < element.clientHeight) {
                clampedText = truncate(getLastChild(element), height);
            }
        }

        return {
            'original': originalText,
            'clamped': clampedText
        }
    }

    window.$clamp = clamp;
})();

/***/ }),

/***/ "qDDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.OrdersReturnLabelModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.OrdersReturnLabelModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(OrdersReturnLabelModal, _super);

    function OrdersReturnLabelModal() {
        return OrdersReturnLabelModal.__super__.constructor.call(this);
    }

    /**
    * HSN.OrdersReturnLabelModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    OrdersReturnLabelModal.prototype._show = function (orderid, type) {
        $.ajax("/myaccount/orders/returnlabel/" + orderid + "?type=" + type, {
            context: this,
            dataType: 'html',
            data: {},
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert(_error);
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return OrdersReturnLabelModal;
}(HSN.Modal);

/***/ }),

/***/ "qIg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Widget_FlexPayProcessPayments_js__ = __webpack_require__("03Jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Widget_FlexPayPayNow_js__ = __webpack_require__("GDK4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_HSNDIR_Widget_FlexPayOrder_js__ = __webpack_require__("IEBK");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// define EVENTs




/**
* class HSN.FlexPayManagerPayNowModal
*
* Encapsulates the functionality of a modal dialog.
**/
HSN.FlexPayManagerPayNowModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(FlexPayManagerPayNowModal, parent);

    function FlexPayManagerPayNowModal() {
        /** new HSN.FlexPayManagerPayNowModal() **/
        var modal = FlexPayManagerPayNowModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();

        this.isProcessingFinished = false;
        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal, modal.isProcessingFinished);
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.FINISHED, function () {
            modal.isProcessingFinished = true;
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR, function () {
            modal.isProcessingFinished = true;
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.RETURN_TO_MANAGER, function () {
            closeModal(modal, true);
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayPayNow.EVENT.CANCELLED, function () {
            closeModal(modal, false);
        });
    }

    function closeModal(modal, doRefresh) {
        modal.Hide();
        if (doRefresh) {
            HSN.Instance().Events.Trigger(HSN.Widget.FlexPayOrder.EVENT.REFRESH, modal.orderIdentity);
        }
    }

    /**
    * HSN.FlexPayManagerPayNowModal#Show() -> void
    * Display the modal and load in the information.
    **/
    FlexPayManagerPayNowModal.prototype._show = function (config) {
        var scope = this;
        scope.orderIdentity = config.orderIdentity;
        scope.paymentNumbers = config.data.flexPayNumbers;
        scope.AddLoadingSpinner();
        $.ajax('/myaccount/flexpay-manager/pay-now/' + config.orderIdentity, {
            context: this,
            dataType: 'html',
            data: $.param(config.data, true),
            success: function success(content) {
                scope.RemoveLoadingSpinner();
                scope.Content.showHtml(content, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                    scope.Content.focus();
                }, function () {});
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                scope.RemoveLoadingSpinner();
                scope.Hide();
            }
        });
    };
    return FlexPayManagerPayNowModal;
}(HSN.Modal);

/***/ }),

/***/ "qcZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

var HSN = window.HSN || {};

HSN.DataLayer = function ($) {
    "use strict";

    window.console = window.console || {};

    var wellKnownEventNames = {
        METRIC: "metric",
        PERSONALIZATION: "personalization",
        VIRTUALPAGEVIEW: "virtualPageView",
        COMPASS: "compass_event",
        HSNEVENT: "hsn_event"
    };

    var wellKnownEventCategories = {
        PRODUCT: "product"
    };

    var wellKnownActions = {
        ADDTOBAG: "addtobag",
        SAVEFORLATER: "saveforlater",
        CHECKOUT: "checkout",
        ORDERREVIEW: "orderreview",
        PURCHASE: "purchase",
        TOGGLEFAVORITE: "togglefavorite",
        SEARCH: "search",
        SUGGESTSEARCH: "suggestsearch",
        ADDTOFAVORITES: "addtofavorites",
        REMOVEFROMFAVORITES: "removefromfavorites"
    };

    function publicGetValueForKey(key) {
        return Object.assign.apply(Object, window.dataLayer)[key];
    }

    function publicSendData(udo) {
        HSN.OnGtmLoad(function () {
            window.dataLayer.push(udo);
        });
    }

    function publicSendEvent(udo, eventName, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        if (!(udo && udo.metrics_event_category || metricsEventCategoryOverride) || !(udo && udo.metrics_event_action || metricsEventActionOverride)) {
            return;
        }

        var data = {
            "event": eventName,
            "metrics_event_category": metricsEventCategoryOverride,
            "metrics_event_action": metricsEventActionOverride,
            "metrics_event_label": metricsEventLabelOverride,
            "metrics_event_value": metricsEventValueOverride,
            "metrics_event_is_non_interaction": metricsEventIsNonInteractionOverride
        };

        var defaultUdo = getObjectWithKeysFromArray(["metrics_event_label", "metrics_event_value", "metrics_event_is_non_interaction"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        publicSendData(compositeUdo);
    }

    function publicSendCompassEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.COMPASS, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendPersonalizationEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.PERSONALIZATION, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendMetricEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.METRIC, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendHsnEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride) {
        publicSendEvent(udo, wellKnownEventNames.HSNEVENT, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride);
    }

    function publicAddToBag(udo, skuOverride, qtyOverride) {
        if (!(udo && udo.product_sku || skuOverride) || !(udo && udo.product_quantity || qtyOverride)) {
            return;
        }

        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.ADDTOBAG);
    }

    function publicCheckout(udo) {
        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.CHECKOUT);
    }

    function publicSaveForLater(udo, basketId) {
        if (!basketId) {
            return;
        }

        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.SAVEFORLATER, basketId);
    }

    function publicToggleFavorite(udo, cmPrefix, objectType, objectId, isFavorite) {
        if (!cmPrefix) {
            return;
        }

        var category = "RE:" + cmPrefix.toLowerCase();
        var action = isFavorite ? wellKnownActions.ADDTOFAVORITES : wellKnownActions.REMOVEFROMFAVORITES;
        var label = "na";
        var value = null;

        publicSendPersonalizationEvent(udo, category, action, label, value);
    }

    function publicSendVirtualPageview(udo, pageTypeOverride, pageNameOverride, pageNameSetter) {
        var virtualPageviewUdo = udo || {};
        var virtualPageType = pageTypeOverride || virtualPageviewUdo.virtual_page_type;
        var virtualPageName = pageNameOverride || virtualPageviewUdo.virtual_page_name;
        var pageNameSet = pageNameSetter || virtualPageviewUdo.page_name;

        if (!virtualPageType) {
            return;
        }

        var data = {
            "event": wellKnownEventNames.VIRTUALPAGEVIEW,
            "virtual_page_type": "virtual-" + virtualPageType,
            "virtual_page_name": virtualPageName,
            "page_name": pageNameSet
        };

        var defaultUdo = getObjectWithKeysFromArray(["virtual_page_type", "virtual_page_name"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        publicSendData(compositeUdo);
    }

    function getObjectWithKeysFromArray(keys) {
        return keys.reduce(function (result, currentItem) {
            result[currentItem] = undefined;
            return result;
        }, {});
    }

    function publicPageCategorization(udo, pageType, categories, brandName) {
        var data = {
            "page_type": pageType || undefined,
            "categories": categories || undefined,
            "product_brand_name": brandName || undefined
        };
        var defaultUdo = getObjectWithKeysFromArray(["page_type", "categories", "product_brand_name"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        if ($.inArray(compositeUdo.page_type, ["Home Page", "Storefront", "Department", "Category", "SubCategory", "Grid", "Brand", "Feature", "Product", "todspc", "Arcade", "Account"]) < 0) {
            return;
        }

        var pageCategoryStorefront = "None";
        var pageCategoryDepartment = "None";
        var pageCategoryCategory = "None";
        var pageCategorySubCategory = "None";
        var pageCategoryBrand = "None";

        if (compositeUdo.categories && compositeUdo.categories.length > 0 && compositeUdo.categories[0].length > 0) {
            var catCount = compositeUdo.categories[0].length;

            switch (catCount) {
                case 4:
                    pageCategorySubCategory = compositeUdo.categories[0][3].Name;
                case 3:
                    pageCategoryCategory = compositeUdo.categories[0][2].Name;
                case 2:
                    pageCategoryDepartment = compositeUdo.categories[0][1].Name;
                default:
                    pageCategoryStorefront = compositeUdo.categories[0][0].Name;
            }
        }

        if (compositeUdo.product_brand_name && compositeUdo.product_brand_name !== "") {
            pageCategoryBrand = compositeUdo.product_brand_name;
        }

        var metricsEventCategoryOverride = "PT:" + compositeUdo.page_type + "|SF:" + pageCategoryStorefront;
        var metricsEventActionOverride = "D:" + pageCategoryDepartment + "|C:" + pageCategoryCategory;
        var metricsEventLabelOverride = "SC:" + pageCategorySubCategory + "|B:" + pageCategoryBrand;

        publicSendMetricEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, undefined, true);
    }

    function publicRealEstate(udo, cmRealEstateTag) {
        var realEstateFields = (cmRealEstateTag || "").split("-_-");
        var realEstateUdo = udo || {};

        var realEstateCategory = realEstateFields[0] || realEstateUdo.metrics_event_category;
        var realEstateAction = realEstateFields[1] || realEstateUdo.metrics_event_action;
        var realEstateLabel = realEstateFields[2] || realEstateUdo.metrics_event_label;

        if (realEstateCategory !== null && realEstateCategory !== undefined) {
            realEstateCategory = "RE:" + realEstateCategory.toLowerCase();
        }
        if (realEstateAction !== null && realEstateAction !== undefined) {
            realEstateAction = realEstateAction.toLowerCase();
        }
        if (realEstateLabel !== null && realEstateLabel !== undefined) {
            realEstateLabel = realEstateLabel.toLowerCase();
        }

        publicSendMetricEvent(udo, realEstateCategory, realEstateAction, realEstateLabel);
    }

    function publicElementInteraction(udo, element, action) {
        var elementUdo = udo || {};
        var elementCategory = "EL:" + (element || elementUdo.metrics_event_category);
        var elementAction = action || elementUdo.metrics_event_action;

        publicSendMetricEvent(udo, elementCategory, elementAction);
    }

    return {
        sendData: publicSendData,
        wellKnownEventCategories: wellKnownEventCategories,
        wellKnownActions: wellKnownActions,
        helpers: {
            event: publicSendEvent,
            metricEvent: publicSendMetricEvent,
            hsnEvent: publicSendHsnEvent,
            personalizationEvent: publicSendPersonalizationEvent,
            compassEvent: publicSendCompassEvent,
            virtualPageview: publicSendVirtualPageview,
            addToBag: publicAddToBag,
            saveForLater: publicSaveForLater,
            favorite: publicToggleFavorite,
            pageCategorization: publicPageCategorization,
            realEstate: publicRealEstate,
            elementInteraction: publicElementInteraction,
            checkout: publicCheckout
        },
        getValueForKey: publicGetValueForKey
    };
}(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

/***/ }),

/***/ "r3YC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js__ = __webpack_require__("4plx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.GiftOptionsModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.GiftOptionsModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(GiftOptionsModal, parent);

    function GiftOptionsModal() {
        var modal = GiftOptionsModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }
    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }
    function closeModal(modal) {
        modal.Hide();
        window.location.reload();
    }

    /**
    * HSN.GiftOptionsModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    GiftOptionsModal.prototype._show = function (bagItemId, bagIdentity) {
        var scope = this;
        scope.AddLoadingSpinner();
        $.ajax('/checkout/gift-options/' + bagItemId + '?bagIdentity=' + bagIdentity + '&t=' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data) {
                scope.RemoveLoadingSpinner();
                this.Content.showHtml(data, 0, function () {
                    scope.Center();
                    scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(scope.Content.find('[data-tooltip]'));
                    }
                    var template = new HSN.Template.GiftOptions({
                        application: HSN.Instance(),
                        container: '.gift-options-container',
                        isInModal: true
                    });
                    $('input, textarea', scope.Content).placeholder();
                }, function () {});
            },
            error: function error() {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                scope.RemoveLoadingSpinner();
                scope.Hide();
            }
        });
    };

    return GiftOptionsModal;
}(HSN.Modal);

/***/ }),

/***/ "rJIu":
/***/ (function(module, exports) {

/**
 * JQuery Cookies 2.2.0
 * Copyright (c) 2005 - 2010, James Auldridge
 * All rights reserved.
 *
 * Licensed under the BSD, MIT, and GPL (your choice!) Licenses:
 *  https://code.google.com/p/cookies/wiki/License
 *
 */
var jaaulde = window.jaaulde || {};
jaaulde.utils = jaaulde.utils || {};
jaaulde.utils.cookies = ( function()
{
	var resolveOptions, assembleOptionsString, parseCookies, constructor, defaultOptions = {
		expiresAt: null,
		path: '/',
		domain:  null,
		secure: false
	};
	/**
	* resolveOptions - receive an options object and ensure all options are present and valid, replacing with defaults where necessary
	*
	* @access private
	* @static
	* @parameter Object options - optional options to start with
	* @return Object complete and valid options object
	*/
	resolveOptions = function( options )
	{
		var returnValue, expireDate;

		if( typeof options !== 'object' || options === null )
		{
			returnValue = defaultOptions;
		}
		else
		{
			returnValue = {
				expiresAt: defaultOptions.expiresAt,
				path: defaultOptions.path,
				domain: defaultOptions.domain,
				secure: defaultOptions.secure
			};

			if( typeof options.expiresAt === 'object' && options.expiresAt instanceof Date )
			{
				returnValue.expiresAt = options.expiresAt;
			}
			else if( typeof options.hoursToLive === 'number' && options.hoursToLive !== 0 )
			{
				expireDate = new Date();
				expireDate.setTime( expireDate.getTime() + ( options.hoursToLive * 60 * 60 * 1000 ) );
				returnValue.expiresAt = expireDate;
			}

			if( typeof options.path === 'string' && options.path !== '' )
			{
				returnValue.path = options.path;
			}

			if( typeof options.domain === 'string' && options.domain !== '' )
			{
				returnValue.domain = options.domain;
			}

			if( options.secure === true )
			{
				returnValue.secure = options.secure;
			}
		}

		return returnValue;
		};
	/**
	* assembleOptionsString - analyze options and assemble appropriate string for setting a cookie with those options
	*
	* @access private
	* @static
	* @parameter options OBJECT - optional options to start with
	* @return STRING - complete and valid cookie setting options
	*/
	assembleOptionsString = function( options )
	{
		options = resolveOptions( options );

		return (
			( typeof options.expiresAt === 'object' && options.expiresAt instanceof Date ? '; expires=' + options.expiresAt.toGMTString() : '' ) +
			'; path=' + options.path +
			( typeof options.domain === 'string' ? '; domain=' + options.domain : '' ) +
			( options.secure === true ? '; secure' : '' )
		);
	};
	/**
	* parseCookies - retrieve document.cookie string and break it into a hash with values decoded and unserialized
	*
	* @access private
	* @static
	* @return OBJECT - hash of cookies from document.cookie
	*/
	parseCookies = function()
	{
		var cookies = {}, i, pair, name, value, separated = document.cookie.split( ';' ), unparsedValue;
		for( i = 0; i < separated.length; i = i + 1 )
		{
			pair = separated[i].split( '=' );
			name = pair[0].replace( /^\s*/, '' ).replace( /\s*$/, '' );

			try
			{
				value = decodeURIComponent( pair[1] );
			}
			catch( e1 )
			{
				value = pair[1];
			}

			if( typeof JSON === 'object' && JSON !== null && typeof JSON.parse === 'function' )
			{
				try
				{
					unparsedValue = value;
					value = JSON.parse( value );
				}
				catch( e2 )
				{
					value = unparsedValue;
				}
			}

			cookies[name] = value;
		}
		return cookies;
	};

	constructor = function(){};

	/**
	 * get - get one, several, or all cookies
	 *
	 * @access public
	 * @paramater Mixed cookieName - String:name of single cookie; Array:list of multiple cookie names; Void (no param):if you want all cookies
	 * @return Mixed - Value of cookie as set; Null:if only one cookie is requested and is not found; Object:hash of multiple or all cookies (if multiple or all requested);
	 */
	constructor.prototype.get = function( cookieName )
	{
		var returnValue, item, cookies = parseCookies();

		if( typeof cookieName === 'string' )
		{
			returnValue = ( typeof cookies[cookieName] !== 'undefined' ) ? cookies[cookieName] : null;
		}
		else if( typeof cookieName === 'object' && cookieName !== null )
		{
			returnValue = {};
			for( item in cookieName )
			{
				if( typeof cookies[cookieName[item]] !== 'undefined' )
				{
					returnValue[cookieName[item]] = cookies[cookieName[item]];
				}
				else
				{
					returnValue[cookieName[item]] = null;
				}
			}
		}
		else
		{
			returnValue = cookies;
		}

		return returnValue;
	};
	/**
	 * filter - get array of cookies whose names match the provided RegExp
	 *
	 * @access public
	 * @paramater Object RegExp - The regular expression to match against cookie names
	 * @return Mixed - Object:hash of cookies whose names match the RegExp
	 */
	constructor.prototype.filter = function( cookieNameRegExp )
	{
		var cookieName, returnValue = {}, cookies = parseCookies();

		if( typeof cookieNameRegExp === 'string' )
		{
			cookieNameRegExp = new RegExp( cookieNameRegExp );
		}

		for( cookieName in cookies )
		{
			if( cookieName.match( cookieNameRegExp ) )
			{
				returnValue[cookieName] = cookies[cookieName];
			}
		}

		return returnValue;
	};
	/**
	 * set - set or delete a cookie with desired options
	 *
	 * @access public
	 * @paramater String cookieName - name of cookie to set
	 * @paramater Mixed value - Any JS value. If not a string, will be JSON encoded; NULL to delete
	 * @paramater Object options - optional list of cookie options to specify
	 * @return void
	 */
	constructor.prototype.set = function( cookieName, value, options )
	{
		if( typeof options !== 'object' || options === null )
		{
			options = {};
		}

		if( typeof value === 'undefined' || value === null )
		{
			value = '';
			options.hoursToLive = -8760;
		}

		else if( typeof value !== 'string' )
		{
			if( typeof JSON === 'object' && JSON !== null && typeof JSON.stringify === 'function' )
			{
				value = JSON.stringify( value );
			}
			else
			{
				throw new Error( 'cookies.set() received non-string value and could not serialize.' );
			}
		}


		var optionsString = assembleOptionsString( options );

		document.cookie = cookieName + '=' + encodeURIComponent( value ) + optionsString;
	};
	/**
	 * del - delete a cookie (domain and path options must match those with which the cookie was set; this is really an alias for set() with parameters simplified for this use)
	 *
	 * @access public
	 * @paramater MIxed cookieName - String name of cookie to delete, or Bool true to delete all
	 * @paramater Object options - optional list of cookie options to specify ( path, domain )
	 * @return void
	 */
	constructor.prototype.del = function( cookieName, options )
	{
		var allCookies = {}, name;

		if( typeof options !== 'object' || options === null )
		{
			options = {};
		}

		if( typeof cookieName === 'boolean' && cookieName === true )
		{
			allCookies = this.get();
		}
		else if( typeof cookieName === 'string' )
		{
			allCookies[cookieName] = true;
		}

		for( name in allCookies )
		{
			if( typeof name === 'string' && name !== '' )
			{
				this.set( name, null, options );
			}
		}
	};
	/**
	 * test - test whether the browser is accepting cookies
	 *
	 * @access public
	 * @return Boolean
	 */
	constructor.prototype.test = function()
	{
		var returnValue = false, testName = 'cT', testValue = 'data';

		this.set( testName, testValue );

		if( this.get( testName ) === testValue )
		{
			this.del( testName );
			returnValue = true;
		}

		return returnValue;
	};
	/**
	 * setOptions - set default options for calls to cookie methods
	 *
	 * @access public
	 * @param Object options - list of cookie options to specify
	 * @return void
	 */
	constructor.prototype.setOptions = function( options )
	{
		if( typeof options !== 'object' )
		{
			options = null;
		}

		defaultOptions = resolveOptions( options );
	};

	return new constructor();
} )();

( function()
{
	if( window.jQuery )
	{
		( function( $ )
		{
			$.cookies = jaaulde.utils.cookies;

			var extensions = {
				/**
				* $( 'selector' ).cookify - set the value of an input field, or the innerHTML of an element, to a cookie by the name or id of the field or element
				*                           (field or element MUST have name or id attribute)
				*
				* @access public
				* @param options OBJECT - list of cookie options to specify
				* @return jQuery
				*/
				cookify: function( options )
				{
					return this.each( function()
					{
						var i, nameAttrs = ['name', 'id'], name, $this = $( this ), value;

						for( i in nameAttrs )
						{
							if( ! isNaN( i ) )
							{
								name = $this.attr( nameAttrs[ i ] );
								if( typeof name === 'string' && name !== '' )
								{
									if( $this.is( ':checkbox, :radio' ) )
									{
										if( $this.attr( 'checked' ) )
										{
											value = $this.val();
										}
									}
									else if( $this.is( ':input' ) )
									{
										value = $this.val();
									}
									else
									{
										value = $this.html();
									}

									if( typeof value !== 'string' || value === '' )
									{
										value = null;
									}

									$.cookies.set( name, value, options );

									break;
								}
							}
						}
					} );
				},
				/**
				* $( 'selector' ).cookieFill - set the value of an input field or the innerHTML of an element from a cookie by the name or id of the field or element
				*
				* @access public
				* @return jQuery
				*/
				cookieFill: function()
				{
					return this.each( function()
					{
						var n, getN, nameAttrs = ['name', 'id'], name, $this = $( this ), value;

						getN = function()
						{
							n = nameAttrs.pop();
							return !! n;
						};

						while( getN() )
						{
							name = $this.attr( n );
							if( typeof name === 'string' && name !== '' )
							{
								value = $.cookies.get( name );
								if( value !== null )
								{
									if( $this.is( ':checkbox, :radio' ) )
									{
										if( $this.val() === value )
										{
											$this.attr( 'checked', 'checked' );
										}
										else
										{
											$this.removeAttr( 'checked' );
										}
									}
									else if( $this.is( ':input' ) )
									{
										$this.val( value );
									}
									else
									{
										$this.html( value );
									}
								}
								
								break;
							}
						}
					} );
				},
				/**
				* $( 'selector' ).cookieBind - call cookie fill on matching elements, and bind their change events to cookify()
				*
				* @access public
				* @param options OBJECT - list of cookie options to specify
				* @return jQuery
				*/
				cookieBind: function( options )
				{
					return this.each( function()
					{
						var $this = $( this );
						$this.cookieFill().change( function()
						{
							$this.cookify( options );
						} );
					} );
				}
			};

			$.each( extensions, function( i )
			{
				$.fn[i] = this;
			} );

		} )( window.jQuery );
	}
} )();

/***/ }),

/***/ "rMvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__ = __webpack_require__("6MBR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__ = __webpack_require__("q/Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_LIBS_jquery_validate_unobtrusive_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ReportReviewModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.ReportReviewModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(ReportReviewModal, _super);

    /**
    * new HSN.ReportReviewModal()
    **/
    function ReportReviewModal() {
        this.elementName = '#';
        this.name = 'HSN.ReportReviewModal';

        return ReportReviewModal.__super__.constructor.call(this);
    }

    ReportReviewModal.prototype._hide = function () {};

    /**
    * HSN.ReportReviewModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ReportReviewModal.prototype._show = function (url, data) {
        var __scope = this;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: data,
            success: function success(data, status, xhr) {
                __scope.Root.removeClass('loading');
                __scope.DisplayModal(data, 0);
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for review modal form, use ajax to retrieve response, and update modal content
    **/
    ReportReviewModal.prototype.SubmitReportReviewForm = function () {
        var __scope = this;

        var reviewForm = $('#report-review-form');

        //manually run client validation since we arent running submit operation
        if (!reviewForm.valid()) return false;

        $.ajax({
            type: 'POST',
            url: '/products/productreviews/submit-report-review?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: reviewForm.serialize()
        }).done(function (data, status, xhr) {
            __scope.DisplayModal(data, 0);
        }).fail(function (data, status, xhr) {
            alert('error reporting review');
        });

        return true;
    };

    ReportReviewModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time, function () {
            $.validator.unobtrusive.parse($('#report-review-form'));
            var elemetToFocus = __scope.Root.find('#modalPopup');
            __scope.Center();
            __scope.Content.animate({ opacity: 1 }, function () {
                __scope.SetFocus(elemetToFocus);
            });
        }, function () {
            //__scope.Center();
        });
    };

    return ReportReviewModal;
}(HSN.Modal);

/***/ }),

/***/ "rd1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.WidgetService = function () {};

HSN.Service.WidgetService.prototype = {
    RefreshWidget: function RefreshWidget(url, data, config) {
        this._sendHtml(url, data, config);
    },

    ShowGlobalMessaging: function ShowGlobalMessaging(data, config) {
        this._sendHtml('/global-messaging/show', data, config);
    },

    GetNamedCell: function GetNamedCell(url, data, config) {
        this._sendHtml(url, data, config);
    },

    _sendHtml: function _sendHtml(url, data, config) {
        config = config = config || {};

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax(url, {
            cache: config.cacheable = config.cacheable || false,
            type: 'GET',
            data: data,
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                if (config.callback) config.callback.call(config.scope || config.callback, true, data);
            },
            error: function error(xhr, status, _error) {
                if (config.callback) config.callback.call(config.scope || config.callback, false, _error);
            }
        });
    }
};

/***/ }),

/***/ "sSHv":
/***/ (function(module, exports) {

﻿/**
 * menu-aim is a jQuery plugin for dropdown menus that can differentiate
 * between a user trying hover over a dropdown item vs trying to navigate into
 * a submenu's contents.
 *
 * menu-aim assumes that you have are using a menu with submenus that expand
 * to the menu's right. It will fire events when the user's mouse enters a new
 * dropdown item *and* when that item is being intentionally hovered over.
 *
 * __________________________
 * | Monkeys  >|   Gorilla  |
 * | Gorillas >|   Content  |
 * | Chimps   >|   Here     |
 * |___________|____________|
 *
 * In the above example, "Gorillas" is selected and its submenu content is
 * being shown on the right. Imagine that the user's cursor is hovering over
 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
 * area.
 *
 * This problem is normally solved using timeouts and delays. menu-aim tries to
 * solve this by detecting the direction of the user's mouse movement. This can
 * make for quicker transitions when navigating up and down the menu. The
 * experience is hopefully similar to amazon.com/'s "Shop by Department"
 * dropdown.
 *
 * Use like so:
 *
 *      $("#menu").menuAim({
 *          activate: $.noop,  // fired on row activation
 *          deactivate: $.noop  // fired on row deactivation
 *      });
 *
 *  ...to receive events when a menu's row has been purposefully (de)activated.
 *
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. Defaults to "> li".
 *          rowSelector: "> li",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
 *
 * https://github.com/kamens/jQuery-menu-aim
*/
(function($) {

    $.fn.menuAim = function(opts) {
        // Initialize menu-aim for all elements in jQuery collection
        this.each(function() {
            init.call(this, opts);
        });

        return this;
    };

    function init(opts) {
        var $menu = $(this),
            activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = $.extend({
                rowSelector: "li",
                submenuSelector: "*",
                submenuDirection: "right",
                tolerance: 75,  // bigger = more forgivey when entering submenu
                enter: $.noop,
                exit: $.noop,
                activate: $.noop,
                deactivate: $.noop,
                exitMenu: $.noop
            }, opts);

        var MOUSE_LOCS_TRACKED = 3,  // number of past mouse locations to track
            DELAY = 300;  // ms delay when user appears to be entering submenu

        /**
         * Keep track of the last few locations of the mouse.
         */
        var mousemoveDocument = function(e) {
                mouseLocs.push({x: e.pageX, y: e.pageY});

                if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                    mouseLocs.shift();
                }
            };

        /**
         * Cancel possible row activations when leaving the menu entirely
         */
        var mouseleaveMenu = function() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                // If exitMenu is supplied and returns true, deactivate the
                // currently active row on menu exit.
                if (options.exitMenu(this)) {
                    if (activeRow) {
                        options.deactivate(activeRow);
                    }

                    activeRow = null;
                }
            };

        /**
         * Trigger a possible row activation whenever entering a new row.
         */
        var mouseenterRow = function() {
                if (timeoutId) {
                    // Cancel any previous activation delays
                    clearTimeout(timeoutId);
                }

                options.enter(this);
                possiblyActivate(this);
            },
            mouseleaveRow = function() {
                options.exit(this);
            };

        /*
         * Immediately activate a row if the user clicks on it.
         */
        var clickRow = function() {
                activate(this);
            };

        /**
         * Activate a menu row.
         */
        var activate = function(row) {
                if (row == activeRow) {
                    return;
                }

                if (activeRow) {
                    options.deactivate(activeRow);
                }

                options.activate(row);
                activeRow = row;
            };

        /**
         * Possibly activate a menu row. If mouse movement indicates that we
         * shouldn't activate yet because user may be trying to enter
         * a submenu's content, then delay and check again later.
         */
        var possiblyActivate = function(row) {
                var delay = activationDelay();

                if (delay) {
                    timeoutId = setTimeout(function() {
                        possiblyActivate(row);
                    }, delay);
                } else {
                    activate(row);
                }
            };

        /**
         * Return the amount of time that should be used as a delay before the
         * currently hovered row is activated.
         *
         * Returns 0 if the activation should happen immediately. Otherwise,
         * returns the number of milliseconds that should be delayed before
         * checking again to see if the row should be activated.
         */
        var activationDelay = function() {
                if (!activeRow || !$(activeRow).is(options.submenuSelector)) {
                    // If there is no other submenu row already active, then
                    // go ahead and activate immediately.
                    return 0;
                }

                var offset = $menu.offset(),
                    upperLeft = {
                        x: offset.left,
                        y: offset.top - options.tolerance
                    },
                    upperRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: upperLeft.y
                    },
                    lowerLeft = {
                        x: offset.left,
                        y: offset.top + $menu.outerHeight() + options.tolerance
                    },
                    lowerRight = {
                        x: offset.left + $menu.outerWidth(),
                        y: lowerLeft.y
                    },
                    loc = mouseLocs[mouseLocs.length - 1],
                    prevLoc = mouseLocs[0];

                if (!loc) {
                    return 0;
                }

                if (!prevLoc) {
                    prevLoc = loc;
                }

                if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
                    prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
                    // If the previous mouse location was outside of the entire
                    // menu's bounds, immediately activate.
                    return 0;
                }

                if (lastDelayLoc &&
                        loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                    // If the mouse hasn't moved since the last time we checked
                    // for activation status, immediately activate.
                    return 0;
                }

                // Detect if the user is moving towards the currently activated
                // submenu.
                //
                // If the mouse is heading relatively clearly towards
                // the submenu's content, we should wait and give the user more
                // time before activating a new row. If the mouse is heading
                // elsewhere, we can immediately activate a new row.
                //
                // We detect this by calculating the slope formed between the
                // current mouse location and the upper/lower right points of
                // the menu. We do the same for the previous mouse location.
                // If the current mouse location's slopes are
                // increasing/decreasing appropriately compared to the
                // previous's, we know the user is moving toward the submenu.
                //
                // Note that since the y-axis increases as the cursor moves
                // down the screen, we are looking for the slope between the
                // cursor and the upper right corner to decrease over time, not
                // increase (somewhat counterintuitively).
                function slope(a, b) {
                    return (b.y - a.y) / (b.x - a.x);
                };

                var decreasingCorner = upperRight,
                    increasingCorner = lowerRight;

                // Our expectations for decreasing or increasing slope values
                // depends on which direction the submenu opens relative to the
                // main menu. By default, if the menu opens on the right, we
                // expect the slope between the cursor and the upper right
                // corner to decrease over time, as explained above. If the
                // submenu opens in a different direction, we change our slope
                // expectations.
                if (options.submenuDirection == "left") {
                    decreasingCorner = lowerLeft;
                    increasingCorner = upperLeft;
                } else if (options.submenuDirection == "below") {
                    decreasingCorner = lowerRight;
                    increasingCorner = lowerLeft;
                } else if (options.submenuDirection == "above") {
                    decreasingCorner = upperLeft;
                    increasingCorner = upperRight;
                }

                var decreasingSlope = slope(loc, decreasingCorner),
                    increasingSlope = slope(loc, increasingCorner),
                    prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                    prevIncreasingSlope = slope(prevLoc, increasingCorner);

                if (decreasingSlope < prevDecreasingSlope &&
                        increasingSlope > prevIncreasingSlope) {
                    // Mouse is moving from previous location towards the
                    // currently activated submenu. Delay before activating a
                    // new menu row, because user may be moving into submenu.
                    lastDelayLoc = loc;
                    return DELAY;
                }

                lastDelayLoc = null;
                return 0;
            };

        /**
         * Hook up initial menu events
         */
        $menu
            .mouseleave(mouseleaveMenu)
            .find(options.rowSelector)
                .mouseenter(mouseenterRow)
                .mouseleave(mouseleaveRow)
                .click(clickRow);

        $(document).mousemove(mousemoveDocument);

    };
})(jQuery);

/***/ }),

/***/ "sSI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

HSN.RewardGridControls = function (config) {
    //Touch interaction variables
    var touchStartLocation;
    var swipeDeviation = 50;

    //Grid container name variables
    var gridContainerName = config.gridContainerName;
    var gridCellsContainerName = config.gridCellsContainerName;
    var pageLeftControlName = config.pageLeftControlName;
    var pageRightControlName = config.pageRightControlName;
    var pageNumberControlName = config.pageNumberControlName;
    var deviceInformation = config.deviceInformation;

    //Function variables
    var ChangeGridPage = config.ChangeGridPageFunction;

    $(gridContainerName).on('touchstart', gridCellsContainerName, function (e) {
        touchStartLocation = e.originalEvent.touches[0].pageX;
    });

    $(gridContainerName).on('touchend', gridCellsContainerName, function (e) {
        var currentPage = $(this).data('page');
        var totalPages = $(this).data('totalpages');

        var currentLocation = e.originalEvent.changedTouches[0].pageX;

        if (Math.abs(currentLocation - touchStartLocation) < swipeDeviation) {
            return;
        } else if (currentLocation - touchStartLocation >= -1 * swipeDeviation && currentPage > 1) {
            ChangeGridPage(currentPage - 1);
        } else if (currentLocation - touchStartLocation <= swipeDeviation && currentPage < totalPages) {
            ChangeGridPage(currentPage + 1);
        }
    });

    $(gridContainerName).on('click', pageLeftControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var currentPage = $(this).data('page');
        var newPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

        ChangeGridPage(newPage);
    });

    $(gridContainerName).on('click', pageRightControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var currentPage = $(this).data('page');
        var newPage = currentPage + 1;

        ChangeGridPage(newPage);
    });

    $(gridContainerName).on('keyup', pageNumberControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        var newPage = $(this).val();
        var totalPages = $(this).data('totalpages');

        if (e.keyCode === 13) {
            if (newPage > 0 && newPage <= totalPages) {
                ChangeGridPage(newPage);
            } else {
                alert(newPage + ' is not a valid page number.');
            }
        }

        return;
    });

    $(gridContainerName).on('keydown', pageNumberControlName, function (e) {
        if (deviceInformation.IsAndroidPhone || deviceInformation.IsAndroidTablet) {
            var newPage = $(this).val();
            var totalPages = $(this).data('totalpages');

            if (e.which === 9) {
                if (newPage > 0 && newPage <= totalPages) {
                    ChangeGridPage(newPage);
                } else {
                    alert(newPage + ' is not a valid page number.');
                }
            }
        }

        return;
    });

    $(gridContainerName).on('mouseup', pageNumberControlName, function (e) {
        e.stopPropagation();
        e.preventDefault();

        $(this).select();
    });
};

HSN.RewardEntryModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(RewardEntryModal, parent);

    function RewardEntryModal(config) {
        var modal = RewardEntryModal.__super__.constructor.call(this, "reward-entry");

        this.callbackok = null;
        this.callbackcancel = null;
        this.name = 'HSN.RewardEntryModal';

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();
        $('#modal-mask').remove();

        if (modal.hideCallback) {
            modal.hideCallback();
        }
    }

    RewardEntryModal.prototype.hideCallback = null;

    RewardEntryModal.prototype.SetHideCallback = function (hideCallback) {
        this.hideCallback = hideCallback;
    };

    /**
    * HSN.RewardEntryModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    RewardEntryModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    RewardEntryModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    RewardEntryModal.prototype._show = function (rewardId, url) {
        $('.video-flash').css('visibility', 'hidden');

        $.ajax(url + rewardId, {
            cache: false,
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;

                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                    }
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };
    RewardEntryModal.prototype.ChangeContent = function (html) {
        var __scope = this;
        this.Content.showHtml(html, 0, function () {
            __scope.Center();
            __scope.Content.animate({ opacity: 1 });
            //handle any tooltips loaded
            if (!Modernizr.touchevents) {
                HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
            }
        }, function () {
            //__scope.Center();
        });
    };

    return RewardEntryModal;
}(HSN.Modal);

HSN.RewardEntryControls = function (config) {
    var application = config.application;
    var containerName = config.containerName;
    var possibleEntries = config.possibleEntries;
    var rewardId = config.rewardId;
    var deviceInformation = application.DeviceInformation;

    if (possibleEntries > 0) {
        buildEntryDropDown(".entry-selection", possibleEntries);
    }

    $(containerName).on('click', '.enter-more-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = '/rewards';
    });

    $(containerName).on('click', '.earn-more-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = '/arcade';
    });

    $(containerName).on('click', '.play-on-button', function (e) {
        e.stopPropagation();
        e.preventDefault();
        window.location.href = '/arcade';
    });

    $(containerName).on('click', '.entry-submit-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var entrySelection = $('.entry-selection').find('option:selected').val();

        if (parseInt(entrySelection) === 0) {
            $('.entry-submit-error').removeClass('error-off');
            $('.entry-submit-error').addClass('error-on');

            return false;
        }

        cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');

        var data = {};

        data.optin = $('#EmailOptIn').length > 0 ? $('#EmailOptIn').is(":checked") : false;
        data.rewardId = rewardId;
        data.quantity = entrySelection;

        $.ajax({
            type: "POST",
            url: "/rewards/submit/sweepstakes",
            data: data,
            dataType: "json",
            success: function success(result) {
                if (deviceInformation.IsMobile) {
                    var url = "/rewards/submit/confirmation?";
                    url += __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(result);
                    window.location.href = url;
                } else {
                    $.ajax({
                        type: "GET",
                        url: "/rewards/submit/sweepstakes",
                        data: result,
                        dataType: "html",
                        success: function success(html) {
                            HSN.Instance().GetRewardEntryModal().ChangeContent(html);
                        }
                    });
                }
            }
        });
    });

    $(containerName).on('click', '.cancel-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        window.location.href = "/rewards";
    });

    $(containerName).on('click', '.create-nickname-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (deviceInformation.IsMobile) {
            var nicknameUrl = $(this).data('nicknameUrl');
            window.location.href = nicknameUrl;
        } else {
            var rewardId = $(this).data('rewardid');

            $('.modal.reward-entry #closeModal').click();

            HSN.Instance().Events.On(HSN.Application.EVENT.NICKNAME_ADDED, function () {
                HSN.Instance().GetRewardEntryModal().Show(rewardId, '/rewards/showentry/sweepstakes/');
            }, this);

            HSN.Instance().GetNicknameModal().Show();
        }
    });

    $(containerName).on("change", '.entry-selection', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var ticketCost = $(this).data('ticket-cost');
        var entrySelection = $(this).find('option:selected').val();

        if (entrySelection > 0) {
            $('.entry-submit-error').removeClass('error-on');
            $('.entry-submit-error').addClass('error-off');
        } else {
            $('.entry-submit-error').removeClass('error-off');
            $('.entry-submit-error').addClass('error-on');
        }

        $('.redeemed-ticket-amount').html(parseInt(entrySelection * ticketCost).toLocaleString());
    });

    function buildEntryDropDown(id, entries) {
        if ($(id).length > 0) {
            var dropdown = $(id)[0];

            var optionLabel = document.createElement("OPTION");
            optionLabel.text = 'Select';
            optionLabel.value = '0';
            dropdown.options.add(optionLabel);

            for (var i = entries; i >= 1; i--) {
                var option = document.createElement("OPTION");
                if (i === 1) option.text = i.toString() + ' Entry';else option.text = i.toString() + ' Entries';
                option.value = i.toString();
                dropdown.options.add(option);
            }
        }
    }
};

HSN.CodeCollectorModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CodeCollectorModal, parent);

    function CodeCollectorModal(config) {
        var modal = CodeCollectorModal.__super__.constructor.call(this, "code-collector-entry");

        this.callbackok = null;
        this.callbackcancel = null;
        this.name = 'HSN.CodeCollectorModal';

        this.Close.off(); //remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();
        $('#modal-mask').remove();

        if (modal.hideCallback) {
            modal.hideCallback();
        }
    }

    CodeCollectorModal.prototype.hideCallback = null;

    CodeCollectorModal.prototype.SetHideCallback = function (hideCallback) {
        this.hideCallback = hideCallback;
    };

    /**
    * HSN.CodeCollectorModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    CodeCollectorModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    CodeCollectorModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    CodeCollectorModal.prototype._show = function () {
        $('.video-flash').css('visibility', 'hidden');

        $.ajax('/codecollector/showentry', {
            cache: false,
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;

                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                    }
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error2) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };
    CodeCollectorModal.prototype.ChangeContent = function (html) {
        var __scope = this;
        this.Content.showHtml(html, 0, function () {
            __scope.Center();
            __scope.Content.animate({ opacity: 1 });
            //handle any tooltips loaded
            if (!Modernizr.touchevents) {
                HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
            }
        }, function () {
            //__scope.Center();
        });
    };

    return CodeCollectorModal;
}(HSN.Modal);

HSN.CodeCollectorControls = function (config) {
    var containerName = config.containerName;
    var isNativeSignInCapable = config.isNativeSignInCapable;

    $(containerName).on('click', '.entry-submit-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var code = $(containerName).find('#code').val().trim();
        $('.error-off').hide();
        if (code !== "") {
            $.ajax({
                type: "POST",
                url: "/codecollector/submit",
                data: { code: code },
                success: function success(data, status, xhr) {
                    var ct = xhr.getResponseHeader("content-type") || "";
                    if (ct.indexOf('html') > -1) {
                        cmCreateElementTag("Finish", "Code Collector");
                        HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Finish");
                        HSN.Instance().GetCodeCollectorEntryModal().ChangeContent(data);
                    }
                    if (ct.indexOf('json') > -1) {
                        if (data.isError) {
                            cmCreateElementTag("Invalid or Expired Entry", "Code Collector");
                            HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Invalid or Expired Entry");
                            $(containerName).find('.entry-submit-error').show();
                        }
                        if (data.isAlreadyEntered) {
                            cmCreateElementTag("Already Used", "Code Collector");
                            HSN.DataLayer.helpers.elementInteraction(null, "Code Collector", "Already Used");
                            $(containerName).find('.entry-already-submitted-error').show();
                        }
                    }
                }
            });
        } else {
            $(containerName).find('.entry-empty-error').show();
        }
    });

    $(containerName).on('click', '.sign-in-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        $('.modal.code-collector-entry #closeModal').click();

        HSN.Instance().Events.On(HSN.Application.EVENT.VISITOR_AUTHENTICATED, function () {
            cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');
            HSN.Instance().GetCodeCollectorEntryModal().Show();
        }, this);

        if (HSN.Instance().DeviceInformation.IsNativeApp && isNativeSignInCapable) {
            var jsonData = { "returnUrl": window.location.href };
            var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
            gap.ExecCommand(command);
        } else {
            window.location = "/signin?isCommunity=true";
        }
    });

    $(containerName).on('click', '.create-nickname-button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        $('.modal.code-collector-entry #closeModal').click();

        HSN.Instance().Events.On(HSN.Application.EVENT.NICKNAME_ADDED, function () {
            cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-EnterSweeps-_-Submit&cm_re=ArcadeSweeps-_-EnterSweeps-_-Submit', 'ArcadeSweepsSubmit');
            HSN.Instance().GetCodeCollectorEntryModal().Show();
        }, this);

        HSN.Instance().GetNicknameModal().Show();
    });

    $(containerName).on("click", ".rules-link", function () {
        HSN.Instance().GetPageIdModal().Show("#code-collector-rules");
        return false;
    });

    $(containerName).on("click", ".whats-this", function () {
        HSN.Instance().GetHsnCaresDisclaimerModal().Show($(this).data('desc'));
        return false;
    });
};

/***/ }),

/***/ "tVjZ":
/***/ (function(module, exports) {

// Animates the dimensional changes resulting from altering element contents
// Usage examples: 
//   $("#myElement").showHtml("new HTML contents");
//   $("div").showHtml("new HTML contents", 400);
//   $(".className").showHtml("new HTML contents", 400, 
//              function() {/* on completion */});
(function($)
{
  $.fn.showHtml = function(html, speed, callback, step)
  {
    return this.each(function()
    {
      // The element to be modified
      var el = $(this);

      // Preserve the original values of width and height - they'll need 
      // to be modified during the animation, but can be restored once
      // the animation has completed.
      var finish = {width: this.style.width, height: this.style.height};

      // The original width and height represented as pixel values.
      // These will only be the same as `finish` if this element had its
      // dimensions specified explicitly and in pixels. Of course, if that 
      // was done then this entire routine is pointless, as the dimensions 
      // won't change when the content is changed.
      var cur = {width: el.width()+'px', height: el.height()+'px'};

      // Modify the element's contents. Element will resize.
      el.html(html);

      // Capture the final dimensions of the element 
      // (with initial style settings still in effect)
      var next = {width: el.width()+'px', height: el.height()+'px'};

      el.css(cur) // restore initial dimensions
        .animate(next, {
            duration: speed,
            step: step,
            complete: function ()  // animate to final dimensions
            {
                el.css(finish); // restore initial style settings
                if ($.isFunction(callback)) callback();
            }
        });
    });
  };
})(jQuery);

/***/ }),

/***/ "us/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__ = __webpack_require__("aGXW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Service_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



HSN.Service.ProductService = function () {};
HSN.Service.ProductService.prototype = {
    GetByIds: function GetByIds(ids, config) {
        var url = '/api/products?' + $.param({ ids: ids }, true);
        this._get(url, {}, config);
    },

    GetCarousel: function GetCarousel(ids, data, config) {
        var url = '/dynamic-carousel?' + $.param({ ids: ids }, true);
        this._get(url, data, config);
    },

    _get: function _get(url, data, config) {
        config = config = config || {};

        $.ajax({
            url: url,
            type: 'GET',
            data: data,
            context: this,
            dataType: config.dataType || 'json',
            success: function success(responseData) {
                if (config.callback) {
                    config.callback.call(config.scope || config.callback, responseData);
                }
            },
            error: function error(xhr, status) {
                if (config.errorCallback) {
                    config.errorCallback.call(config.scope || config.errorCallback, status);
                }
            }
        });
    }
};

/***/ }),

/***/ "vued":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    Carousel: {
        BEFORE_SLIDE: 'carousel:before_slide',
        PAGE_CHANGED: 'carousel:page_changed'
    },
    Template: {
        AgentPortal: {
            Signin: {
                SIGNIN_SUCCESS: 'HSN.Template.AgentPortal.'
            }
        }
    },
    Widget: {
        Signin: {
            COMPLETE: 'HSN.Widget.Signin:COMPLETE',
            FAILED: 'HSN.Widget.Signin:FAILED',
            FORGOT_PASSWORD_INITIATED: 'HSN.Widget.Signin.FORGOT_PASSWORD_INITIATED',
            NEW_CUSTOMER_INITIATED: 'HSN.Widget.Signin.NEW_CUSTOMER_INITIATED'
        },
        Tabs: {
            SHOW: 'HSN.Widget.Tabs:SHOW'
        },
        Video: {
            TOGGLE_INLINE_PLAYER: 'videoplayer:toggle_inline_player'
        }
    },
    AdobeTarget: {
        LOADED: 'HSN.AdobeTarget:LOADED'
    },
    Bazaarvoice: {
        LOADED: 'HSN.Bazaarvoice:LOADED',
        REVIEWS_LOADED: 'HSN.Bazaarvoice:REVIEWS_LOADED'
    },
    Config: {
        LOADED: 'HSN.Config:LOADED'
    }
});

/***/ }),

/***/ "w2jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
* class HSN.AlcoholModal
* Encapsulates the functionality of a modal dialog that contains rating warning.
**/
HSN.AlcoholModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(AlcoholModal, _super);

    function AlcoholModal() {
        return AlcoholModal.__super__.constructor.call(this);
    }

    AlcoholModal.prototype._show = function (buttonClicked) {

        $.ajax("/alcohol/notice?" + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                }, function () {
                    //__scope.Center();
                });

                $('#alcohol-verification .yes').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    __scope.Root.hide();
                    $('#modal-mask').remove();

                    HSN.DataLayer.helpers.realEstate(null, 'productpage-_-age_verification-_-21');

                    sessionStorage.setItem('alcohol-verification', 'true');
                    buttonClicked.click();
                });

                $('#alcohol-verification .no').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    HSN.DataLayer.helpers.realEstate(null, 'productpage-_-age_verification-_-back');

                    __scope.Root.hide();
                    $('#modal-mask').remove();
                });
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    return AlcoholModal;
}(HSN.Modal);

/***/ }),

/***/ "wlyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
* class HSN.CouponModal
*
* Encapsulates the functionality of a modal dialog that contains coupon information.
**/
HSN.CouponModal = function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(CouponModal, _super);

    /**
    * new HSN.CouponModal()
    **/
    function CouponModal() {
        this.elementName = '#';
        this.name = 'HSN.CouponModal';

        return CouponModal.__super__.constructor.call(this);
    }

    CouponModal.prototype._hide = function () {};

    /**
    * HSN.CouponModal#Show(parentcouponcode) -> void
    * Display the modal and load in the information for the given coupon identifier.
    **/
    CouponModal.prototype._show = function (url) {
        var __scope = this;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            success: function success(data, status, xhr) {
                __scope.Root.removeClass('loading');

                __scope.DisplayModal(data, 0);
            },
            error: function error(xhr, status, _error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    CouponModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time, function () {
            __scope.Center();
            __scope.Content.animate({ opacity: 1 });
        }, function () {
            //__scope.Center();
        });
    };

    return CouponModal;
}(HSN.Modal);

/***/ }),

/***/ "y8pB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__ = __webpack_require__("2HwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__ = __webpack_require__("tVjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_showhtml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js__ = __webpack_require__("4plx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_jquery_placeholder_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_EmailCaptureCommon_js__ = __webpack_require__("Lo8r");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";


/**
* class HSN.EmailCaptureModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.EmailCaptureModal = function (parent) {
    __WEBPACK_IMPORTED_MODULE_1_LIBS_extend_js___default()(EmailCaptureModal, parent);

    function EmailCaptureModal(config) {
        var modal = EmailCaptureModal.__super__.constructor.call(this);

        this.Close.off(); //remove existing handler, have our own

        this.template = HSN.Template.EmailCaptureCommon.prototype;

        eventHandlers(this);

        return modal;
    }

    template: null;

    function eventHandlers(modal) {

        $(modal.Content).on('paste', '#capture-email-address-again', function () {
            return false;
        });

        $(modal.Content).on('keyup', '#capture-email-address-again', function () {
            var $this = $(this);
            if ($this.val() !== $('#capture-email-address').val()) {
                $this.addClass('invalid-email');
            } else {
                $this.removeClass('invalid-email');
            }
        });

        $(modal.Content).on('keyup', '#capture-email-address', function () {
            var $this = $(this);
            if (!HSN.ValidateEmail($('#capture-email-address').val())) {
                $this.addClass('invalid-email');
            } else {
                $this.removeClass('invalid-email');
            }
        });

        $(modal.Content).on('click', '#capture-signup', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var emailAddress = $('#capture-email-address').val();
            var emailAddressAgain = $('#capture-email-address-again').val();

            if (emailAddress === '' || emailAddress === null || !HSN.ValidateEmail(emailAddress)) {
                $('#capture-error').html('Please enter an email address.');
                $('#capture-email-address').addClass('invalid-email');
                return;
            }

            if (emailAddress !== emailAddressAgain) {
                $('#capture-error').html('Your email and confirm email do not match.');
                $('#capture-email-address-again').each(function () {
                    $(this).addClass('invalid-email');
                });
                return;
            }

            HSN.DataLayer.helpers.metricEvent(null, 'RE:emailsignup', 'welcomemodal', 'SO');
            dataLayer.push({ 'signup_email': emailAddress });
            HSN.DataLayer.helpers.hsnEvent(null, 'EmailPromoSignupModal', 'Success', null, null);

            var config = {};
            config.success = function (data) {
                HSN.Instance().GetEmailCaptureModal()._ShowThanks();
            };
            config.error = function () {
                alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
            };

            HSN.Instance().HandleEmailSignup(emailAddress, 55, config);
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });

        $(modal.Content).on('click', '#capture-shop-now', function (e) {
            e.stopPropagation();
            e.preventDefault();
            closeModal(modal);
        });

        $(modal.Content).on('click', '#capture-no-thanks', function (e) {
            e.stopPropagation();
            e.preventDefault();
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        var isThanksView = $('#email-capt-container > .capture-is-thanks-form').val();
        if (!isThanksView) {
            modal.template.HandleNoThanks(null);

            HSN.OnCoremetricsLoad(function () {
                cmCreateManualLinkClickTag('/email-capture-modal?cm_sp=EmailCapture-_-Modal-_-NoThanks&cm_re=EmailCapture-_-Modal-_-NoThanks', 'EmailCaptureNoThanks');
            });
        }
        modal.Hide();
    }

    /**
    * HSN.EmailCaptureModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    EmailCaptureModal.prototype._show = function () {
        $.ajax('/account/emailcapture' + '?' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;
                __scope.Root.removeClass('loading');

                this.Content.showHtml(data, 0, function () {
                    var elemetToFocus = __scope.Root.find('#modalPopup');
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 }, function () {
                        __scope.SetFocus(elemetToFocus);
                    });

                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                    }
                }, function () {
                    //__scope.Center();
                });
                $('input, textarea').placeholder();
            },
            error: function error(xhr, status, _error) {
                //Dont think we want to display the loading error if this modal doesnt display?
                //alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    EmailCaptureModal.prototype._ShowThanks = function () {
        $.ajax('/account/emailcapture/thanks' + '?' + new Date().getTime(), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                var __scope = this;

                this.Content.showHtml(data, 0, function () {
                    __scope.Center();
                    //handle any tooltips loaded
                    if (!Modernizr.touchevents) {
                        HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                    }
                }, function () {
                    //__scope.Center();
                });
            },
            error: function error(xhr, status, _error2) {
                //Dont think we want to display the loading error if this modal doesnt display?
                //alert("Unfortunately there was an error attempting to load the content, please try again.");
                HSN.Instance().GetEmailCaptureModal().Hide();
                $('#modal-mask').remove();
            }
        });
    };

    return EmailCaptureModal;
}(HSN.Modal);

/***/ })

},[1]);


// WEBPACK FOOTER //
// common.4aedddaa410cc540440b.js